(function () {
        'use strict';

        angular
            .module('app.pages.events', ['datatables', 'ui.sortable'])
            .config(config).run(run);


        function run($rootScope, msNavigationService) {

            /**
             * Set the pages by the admin level
             */
            $rootScope.$watch('User', function () {
                    if ($rootScope.AdminLevel) {
                        if ($rootScope.User.Categories && !angular.isArray($rootScope.User.Categories)) {
                            $rootScope.User.Categories = Object.values($rootScope.User.Categories);
                        }
                        switch ($rootScope.brandName) {
                            case 'megido':
                                setMegido($rootScope, msNavigationService);
                                break;
                            case 'levhasharon':
                                setLevHasharon($rootScope, msNavigationService);
                                break;
                            case 'izrael':
                                setEmekIzrael($rootScope, msNavigationService);
                                break;

                        }
                        // $rootScope.brandName === 'megido' ? setMegido($rootScope, msNavigationService) : setLevHasharon($rootScope, msNavigationService);

                    }
                }
            );
        }

        function setLevHasharon($rootScope, msNavigationService) {

            switch ($rootScope.AdminLevel) {
                //guide-student
                case 1:

                    break;
                //coordinator
                case 2:
                    if ($rootScope.User.Categories.length > 0) {
                        msNavigationService.saveItem('pages.events', {
                            title: 'קטגוריות',
                            icon: 'icon-apps',
                            weight: 3
                        });
                        if ($rootScope.User.Categories.includes(1)) {
                            msNavigationService.saveItem('pages.events.events', {
                                title: 'מפעלי נוער',
                                generalEventType: 'Events',
                                icon: 'icon-brightness-5',
                                state: 'app.pages_events',
                                weight: 1
                            });
                        }
                        if ($rootScope.User.Categories.includes(2)) {
                            msNavigationService.saveItem('pages.events.products', {
                                title: 'מוצרים',
                                generalEventType: 'Products',
                                icon: 'icon-shopping',
                                state: 'app.pages_products',
                                weight: 2
                            });
                        }

                        if ($rootScope.eventModules) {
                            if ($rootScope.eventModules.indexOf('summerCamp') != -1 && $rootScope.User.Categories.includes(3)) {
                                msNavigationService.saveItem('pages.events.summerCamp', {
                                    title: 'קייטנות',
                                    generalEventType: 'SummerCamps',
                                    icon: 'icon-tshirt-crew',
                                    state: 'app.pages_summer_camp',
                                    weight: 3
                                });
                            }
                            if ($rootScope.eventModules.indexOf('leisureAndAfterSchool') != -1 && $rootScope.User.Categories.includes(4)) {
                                msNavigationService.saveItem('pages.events.leisureAndAfterSchool', {
                                    title: 'אירועי פנאי וחוגים',
                                    generalEventType: 'LeisureAndAfterSchool',
                                    icon: 'icon-palette',
                                    state: 'app.pages_leisure_and_afterSchool',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('Kindergarten') != -1 && $rootScope.User.Categories.includes(5)) {
                                msNavigationService.saveItem('pages.events.Kindergarten', {
                                    title: 'מעונות וצהרונים',
                                    generalEventType: 'Kindergarten',
                                    icon: 'icon-baby',
                                    state: 'app.pages_Kindergarten',
                                    weight: 3
                                });
                            }
                            if ($rootScope.eventModules.indexOf('InternalEvents') != -1 && $rootScope.User.Categories.includes(6)) {
                                msNavigationService.saveItem('pages.events.InternalEvents', {
                                    title: 'מועצה פנימי',
                                    generalEventType: 'InternalEvents',
                                    icon: 'icon-crown',
                                    state: 'app.pages_internal_events',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('ReligiousServices') != -1 && $rootScope.User.Categories.includes(7)) {
                                msNavigationService.saveItem('pages.events.ReligiousServices', {
                                    title: 'שירותי דת ותרבות יהודית',
                                    generalEventType: 'ReligiousServices',
                                    icon: 'icon-star',
                                    state: 'app.pages_religious_services',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('GoldenAge') != -1 && $rootScope.User.Categories.includes(8)) {
                                msNavigationService.saveItem('pages.events.GoldenAge', {
                                    title: 'הגיל השלישי',
                                    generalEventType: 'GoldenAge',
                                    icon: 'icon-human-male-female',
                                    state: 'app.pages_religious_services',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('Tourism') != -1 && $rootScope.User.Categories.includes(133)) {
                                msNavigationService.saveItem('pages.events.Tourism', {
                                    title: 'תיירות',
                                    generalEventType: 'Tourism',
                                    icon: 'icon-star',
                                    state: 'app.pages_tourism',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('CommunitySecurity') != -1 && $rootScope.User.Categories.includes(134)) {
                                msNavigationService.saveItem('pages.events.CommunitySecurity', {
                                    title: 'ביטחון קהילתי',
                                    generalEventType: 'CommunitySecurity',
                                    icon: 'icon-human-male-female',
                                    state: 'app.pages_community_security',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('psychology') != -1 && $rootScope.User.Categories.includes(11)) {
                                msNavigationService.saveItem('pages.events.psychology', {
                                    title: 'שירות פסיכולוגי',
                                    generalEventType: 'Psychology',
                                    icon: 'icon-human-male-female',
                                    state: 'app.pages_products',
                                    weight: 4
                                });
                            }
                        }
                    }

                    break;
                //admin
                default:
                    msNavigationService.saveItem('pages.events', {
                        title: 'קטגוריות',
                        icon: 'icon-apps',
                        weight: 3
                    });
                    msNavigationService.saveItem('pages.events.events', {
                        title: 'מפעלי נוער',
                        generalEventType: 'Events',
                        icon: 'icon-brightness-5',
                        state: 'app.pages_events',
                        weight: 1
                    });
                    msNavigationService.saveItem('pages.events.products', {
                        title: 'מוצרים',
                        generalEventType: 'Products',
                        icon: 'icon-shopping',
                        state: 'app.pages_products',
                        weight: 2
                    });
                    if ($rootScope.eventModules) {
                        if ($rootScope.eventModules.indexOf('summerCamp') != -1) {
                            msNavigationService.saveItem('pages.events.summerCamp', {
                                title: 'קייטנות',
                                generalEventType: 'SummerCamps',
                                icon: 'icon-tshirt-crew',
                                state: 'app.pages_summer_camp',
                                weight: 3
                            });
                        }
                        if ($rootScope.eventModules.indexOf('Kindergarten') != -1) {
                            msNavigationService.saveItem('pages.events.Kindergarten', {
                                title: 'מעונות וצהרונים',
                                generalEventType: 'Kindergarten',
                                icon: 'icon-baby',
                                state: 'app.pages_Kindergarten',
                                weight: 3
                            });
                        }
                        if ($rootScope.eventModules.indexOf('leisureAndAfterSchool') != -1) {
                            msNavigationService.saveItem('pages.events.leisureAndAfterSchool', {
                                title: 'אירועי פנאי וחוגים',
                                generalEventType: 'LeisureAndAfterSchool',
                                icon: 'icon-palette',
                                state: 'app.pages_leisure_and_afterSchool',
                                weight: 4
                            });
                        }
                        if ($rootScope.eventModules.indexOf('InternalEvents') != -1) {
                            msNavigationService.saveItem('pages.events.InternalEvents', {
                                title: 'מועצה פנימי',
                                generalEventType: 'InternalEvents',
                                icon: 'icon-crown',
                                state: 'app.pages_internal_events',
                                weight: 4
                            });
                        }
                        if ($rootScope.eventModules.indexOf('ReligiousServices') != -1) {
                            msNavigationService.saveItem('pages.events.ReligiousServices', {
                                title: 'שירותי דת ותרבות יהודית',
                                generalEventType: 'ReligiousServices',
                                icon: 'icon-star',
                                state: 'app.pages_religious_services',
                                weight: 4
                            });
                        }
                        if ($rootScope.eventModules.indexOf('GoldenAge') != -1) {
                            msNavigationService.saveItem('pages.events.GoldenAge', {
                                title: 'הגיל השלישי',
                                generalEventType: 'GoldenAge',
                                icon: 'icon-human-male-female',
                                state: 'app.pages_golden_age',
                                weight: 4
                            });
                        }
                        if ($rootScope.eventModules.indexOf('Tourism') != -1) {
                            msNavigationService.saveItem('pages.events.Tourism', {
                                title: 'תיירות',
                                generalEventType: 'Tourism',
                                icon: 'icon-star',
                                state: 'app.pages_tourism',
                                weight: 4
                            });
                        }
                        if ($rootScope.eventModules.indexOf('CommunitySecurity') != -1) {
                            msNavigationService.saveItem('pages.events.CommunitySecurity', {
                                title: 'ביטחון קהילתי',
                                generalEventType: 'CommunitySecurity',
                                icon: 'icon-human-male-female',
                                state: 'app.pages_community_security',
                                weight: 4
                            });
                        }
                        if ($rootScope.eventModules.indexOf('psychology') != -1) {
                            msNavigationService.saveItem('pages.events.psychology', {
                                title: 'שירות פסיכולוגי',
                                generalEventType: 'Psychology',
                                icon: 'icon-shopping',
                                state: 'app.pages_psychology',
                                weight: 11
                            });
                        }
                    }
                    break;
            }
        }

        function setMegido($rootScope, msNavigationService) {
            switch ($rootScope.AdminLevel) {
                //guide-student
                case 1:

                    break;
                //coordinator
                case 2:
                    if ($rootScope.User.Categories.length > 0) {
                        msNavigationService.saveItem('pages.events', {
                            title: 'קטגוריות',
                            icon: 'icon-apps',
                            weight: 3
                        });
                        if ($rootScope.User.Categories.includes(1)) {
                            msNavigationService.saveItem('pages.events.sports', {
                                title: 'ספורט',
                                generalEventType: 'Sports',
                                icon: 'icon-brightness-5',
                                state: 'app.pages_sports',
                                weight: 1
                            });
                        }
                        if ($rootScope.User.Categories.includes(2)) {
                            msNavigationService.saveItem('pages.events.gilor', {
                                title: 'גילאור',
                                generalEventType: 'Gilor',
                                icon: 'icon-human-male-female',
                                state: 'app.pages_gilor',
                                weight: 2
                            });
                        }

                        if ($rootScope.eventModules) {
                            if ($rootScope.eventModules.indexOf('education') != -1 && $rootScope.User.Categories.includes(3)) {
                                msNavigationService.saveItem('pages.events.education', {
                                    title: 'חינוך',
                                    generalEventType: 'Education',
                                    icon: 'icon-tshirt-crew',
                                    state: 'app.pages_education',
                                    weight: 3
                                });
                            }
                            if ($rootScope.eventModules.indexOf('library') != -1 && $rootScope.User.Categories.includes(4)) {
                                msNavigationService.saveItem('pages.events.library', {
                                    title: 'ספרייה',
                                    generalEventType: 'Library',
                                    icon: 'icon-palette',
                                    state: 'app.pages_library',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('reut') != -1 && $rootScope.User.Categories.includes(5)) {
                                msNavigationService.saveItem('pages.events.reut', {
                                    title: 'רעות',
                                    generalEventType: 'Reut',
                                    icon: 'icon-baby',
                                    state: 'app.pages_reut',
                                    weight: 3
                                });
                            }
                            if ($rootScope.eventModules.indexOf('musicAndDance') != -1 && $rootScope.User.Categories.includes(6)) {
                                msNavigationService.saveItem('pages.events.musicAndDance', {
                                    title: 'מוזיקה ומחול',
                                    generalEventType: 'MusicAndDance',
                                    icon: 'icon-crown',
                                    state: 'app.pages_music_and_dance',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('megidoTech') != -1 && $rootScope.User.Categories.includes(7)) {
                                msNavigationService.saveItem('pages.events.megidoTech', {
                                    title: 'מגידוטק',
                                    generalEventType: 'MegidoTech',
                                    icon: 'icon-star',
                                    state: 'app.pages_megido_tech',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('youthCenter') != -1 && $rootScope.User.Categories.includes(8)) {
                                msNavigationService.saveItem('pages.events.youthCenter', {
                                    title: 'מרכז צעירים',
                                    generalEventType: 'YouthCenter',
                                    icon: 'icon-human-male-female',
                                    state: 'app.pages_youth_center',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('internalCouncil') != -1 && $rootScope.User.Categories.includes(9)) {
                                msNavigationService.saveItem('pages.events.internalCouncil', {
                                    title: 'מועצה פנימי',
                                    generalEventType: 'InternalCouncil',
                                    icon: 'icon-human-male-female',
                                    state: 'app.pages_internal_council',
                                    weight: 4
                                });
                            }
                            if ($rootScope.eventModules.indexOf('products') != -1 && $rootScope.User.Categories.includes(10)) {
                                msNavigationService.saveItem('pages.events.products', {
                                    title: 'מוצרים',
                                    generalEventType: ' Products',
                                    icon: 'icon-human-male-female',
                                    state: 'app.pages_products',
                                    weight: 4
                                });
                            }
                        }
                    }

                    break;
                //admin
                default:
                    msNavigationService.saveItem('pages.events', {
                        title: 'קטגוריות',
                        icon: 'icon-apps',
                        weight: 3
                    });

                    if ($rootScope.eventModules) {
                        if ($rootScope.eventModules.indexOf('gilor') != -1) {
                            msNavigationService.saveItem('pages.events.gilor', {
                                title: 'גילאור',
                                generalEventType: 'Gilor',
                                icon: 'icon-human-male-female',
                                state: 'app.pages_gilor',
                                weight: 2
                            });


                        }
                        if ($rootScope.eventModules.indexOf('sports') != -1) {
                            msNavigationService.saveItem('pages.events.sports', {
                                title: 'ספורט',
                                generalEventType: 'Sports',
                                icon: 'icon-baby',
                                state: 'app.pages_sports',
                                weight: 1
                            });
                        }
                        if ($rootScope.eventModules.indexOf('education') != -1) {
                            msNavigationService.saveItem('pages.events.education', {
                                title: 'חינוך',
                                generalEventType: 'Education',
                                icon: 'icon-tile-four',
                                state: 'app.pages_education',
                                weight: 4
                            });
                        }
                        if ($rootScope.eventModules.indexOf('library') != -1) {
                            msNavigationService.saveItem('pages.events.library', {
                                title: 'ספרייה',
                                generalEventType: 'Library',
                                icon: 'icon-clipboard-text',
                                state: 'app.pages_library',
                                weight: 5
                            });
                        }
                        if ($rootScope.eventModules.indexOf('reut') != -1) {
                            msNavigationService.saveItem('pages.events.reut', {
                                title: 'רעות',
                                generalEventType: 'Reut',
                                icon: 'icon-weather-sunny',
                                state: 'app.pages_reut',
                                weight: 6
                            });
                        }
                        if ($rootScope.eventModules.indexOf('musicAndDance') != -1) {
                            msNavigationService.saveItem('pages.events.musicAndDance', {
                                title: 'מוזיקה ומחול',
                                generalEventType: 'MusicAndDance',
                                icon: 'icon-star',
                                state: 'app.pages_music_and_dance',
                                weight: 7
                            });
                        }
                        if ($rootScope.eventModules.indexOf('megidoTech') != -1) {
                            msNavigationService.saveItem('pages.events.megidoTech', {
                                title: 'מגידוטק',
                                generalEventType: 'MegidoTech',
                                icon: 'icon-brightness-5',
                                state: 'app.pages_megido_tech',
                                weight: 8
                            });
                        }
                        if ($rootScope.eventModules.indexOf('youthCenter') != -1) {
                            msNavigationService.saveItem('pages.events.youthCenter', {
                                title: 'מרכז צעירים',
                                generalEventType: 'YouthCenter',
                                icon: 'icon-account-multiple',
                                state: 'app.pages_youth_center',
                                weight: 9
                            });
                        }
                        if ($rootScope.eventModules.indexOf('internalCouncil') != -1) {
                            msNavigationService.saveItem('pages.events.internalCouncil', {
                                title: 'מועצה פנימי',
                                generalEventType: 'InternalCouncil',
                                icon: 'icon-domain',
                                state: 'app.pages_internal_council',
                                weight: 10
                            });
                        }
                        if ($rootScope.eventModules.indexOf('products') != -1) {
                            msNavigationService.saveItem('pages.events.products', {
                                title: 'מוצרים',
                                generalEventType: 'Products',
                                icon: 'icon-shopping',
                                state: 'app.pages_products',
                                weight: 11
                            });
                        }
                    }
                    break;
            }
        }

        function setEmekIzrael($rootScope, msNavigationService) {
            switch ($rootScope.AdminLevel) {
                //guide-student
                case 1:

                    break;
                //coordinator
                case 2:
                    if ($rootScope.User.Categories.length > 0) {
                        msNavigationService.saveItem('pages.events', {
                            title: 'קטגוריות',
                            icon: 'icon-apps',
                            weight: 3
                        });
                        if ($rootScope.User.Categories.includes(1)) {
                            msNavigationService.saveItem('pages.events.sports', {
                                title: 'ספורט',
                                generalEventType: 'Sports',
                                icon: 'icon-brightness-5',
                                state: 'app.pages_sports',
                                weight: 1
                            });
                        }
                        if ($rootScope.User.Categories.includes(34)) {
                            msNavigationService.saveItem('pages.events.catedra', {
                                title: 'קתדרה',
                                generalEventType: 'Catedra',
                                icon: 'icon-school',
                                state: 'app.pages_sports',
                                weight: 1
                            });
                        }
                        if ($rootScope.User.Categories.includes(35)) {
                            msNavigationService.saveItem('pages.events.youthAndScholarship', {
                                title: 'צעירים ומלגות',
                                generalEventType: 'YouthAndScholarship',
                                icon: 'icon-human-male-female',
                                state: 'app.pages_youthAndScholarship',
                                weight: 1
                            });
                        }
                        if ($rootScope.User.Categories.includes(42)) {
                            msNavigationService.saveItem('pages.events.yeshuvim', {
                                title: 'יישובים',
                                generalEventType: 'Yeshuvim',
                                icon: 'icon-city',
                                state: 'app.pages_yeshuvim',
                                weight: 1
                            });
                        }
                        if ($rootScope.User.Categories.includes(43)) {
                            msNavigationService.saveItem('pages.events.kidsAndYouth', {
                                title: 'יישובים',
                                generalEventType: 'KidsAndYouth',
                                icon: 'icon-account-multiple',
                                state: 'app.pages_kidsAndYouth',
                                weight: 1
                            });
                        }
                        if ($rootScope.User.Categories.includes(51)) {
                            msNavigationService.saveItem('pages.events.omanut', {
                                title: 'בית האומנויות',
                                generalEventType: 'Omanut',
                                icon: 'icon-palette',
                                state: 'app.pages_omanut',
                                weight: 1
                            });
                        }
                        if ($rootScope.User.Categories.includes(50)) {
                            msNavigationService.saveItem('pages.events.education', {
                                title: 'אגף החינוך',
                                generalEventType: 'Education',
                                icon: 'icon-crown',
                                state: 'app.pages_education',
                                weight: 1
                            });
                        }
                        if ($rootScope.User.Categories.includes(56)) {
                            msNavigationService.saveItem('pages.events.revaha', {
                                title: 'אגף החינוך',
                                generalEventType: 'Revaha',
                                icon: 'icon-shopping',
                                state: 'app.pages_revaha',
                                weight: 1
                            });
                        }

                        if ($rootScope.User.Categories.includes(57)) {
                            msNavigationService.saveItem('pages.events.revachapnimi', {
                                title: 'אגף החינוך',
                                generalEventType: 'RevachaPnimi',
                                icon: 'icon-shopping',
                                state: 'app.pages_revachapnimi',
                                weight: 1
                            });
                        }


                    }

                    break;
                //admin
                default:
                    msNavigationService.saveItem('pages.events', {
                        title: 'קטגוריות',
                        icon: 'icon-apps',
                        weight: 3
                    });

                    if ($rootScope.eventModules) {
                        if ($rootScope.eventModules.indexOf('sports') != -1) {
                            msNavigationService.saveItem('pages.events.sports', {
                                title: 'ספורט',
                                generalEventType: 'Sports',
                                icon: 'icon-baby',
                                state: 'app.pages_sports',
                                weight: 1
                            });
                        }
                        if ($rootScope.eventModules.indexOf('catedra') != -1) {
                            msNavigationService.saveItem('pages.events.catedra', {
                                title: 'קתדרה',
                                generalEventType: 'Catedra',
                                icon: 'icon-school',
                                state: 'app.pages_catedra',
                                weight: 1
                            });
                        }
                        if ($rootScope.eventModules.indexOf('youthAndScholarship') != -1) {
                            msNavigationService.saveItem('pages.events.youthAndScholarship', {
                                title: 'צעירים ומלגות',
                                generalEventType: 'YouthAndScholarship',
                                icon: 'icon-human-male-female',
                                state: 'app.pages_youthAndScholarship',
                                weight: 1
                            });
                        }
                        if ($rootScope.eventModules.indexOf('yeshuvim') != -1) {
                            msNavigationService.saveItem('pages.events.yeshuvim', {
                                title: 'יישובים',
                                generalEventType: 'Yeshuvim',
                                icon: 'icon-city',
                                state: 'app.pages_yeshuvim',
                                weight: 1
                            });
                        }
                        if ($rootScope.eventModules.indexOf('kidsAndYouth') !== -1) {
                            msNavigationService.saveItem('pages.events.kidsAndYouth', {
                                title: 'ילדים ונוער',
                                generalEventType: 'KidsAndYouth',
                                icon: 'icon-account-multiple',
                                state: 'app.pages_kidsAndYouth',
                                weight: 1
                            });
                        }
                        if ($rootScope.eventModules.indexOf('omanut') !== -1) {
                            msNavigationService.saveItem('pages.events.omanut', {
                                title: 'בית האומנויות',
                                generalEventType: 'Omanut',
                                icon: 'icon-palette',
                                state: 'app.pages_omanut',
                                weight: 1
                            });
                        }
                        if ($rootScope.eventModules.indexOf('Education') !== -1) {
                            msNavigationService.saveItem('pages.events.education', {
                                title: 'אגף החינוך',
                                generalEventType: 'Education',
                                icon: 'icon-crown',
                                state: 'app.pages_education',
                                weight: 1
                            });
                        }

                        if ($rootScope.eventModules.indexOf('Revaha') !== -1) {
                            msNavigationService.saveItem('pages.events.revaha', {
                                title: 'רווחה',
                                generalEventType: 'Revaha',
                                icon: 'icon-shopping',
                                state: 'app.pages_revaha',
                                weight: 1
                            });
                        }

                        if ($rootScope.eventModules.indexOf('RevachaPnimi') !== -1) {
                            msNavigationService.saveItem('pages.events.revachapnimi', {
                                title: 'רווחה פנימי',
                                generalEventType: 'RevachaPnimi',
                                icon: 'icon-shopping',
                                state: 'app.pages_revachapnimi',
                                weight: 1
                            });
                        }

                    }
                    break;
            }
        }

        /** @ngInject */
        function config($stateProvider) {
            $stateProvider
                .state('app.pages_gilordummy', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_kidsAndYouth', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_gilor', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_sports', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_catedra', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_youthAndScholarship', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_yeshuvim', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_education', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_revaha', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_revachapnimi', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_omanut', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_library', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_reut', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_music_and_dance', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_megido_tech', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_youth_center', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_internal_council', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_products', {
                    url: '/products',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/products');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_psychology', {
                    url: '/psychology',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/psychology');
                        }
                    },
                    bodyClass: 'events'
                })
                //
                .state('app.pages_events', {
                    url: '/events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/events');
                        }
                    },
                    bodyClass: 'events'
                })

                .state('app.pages_summer_camp', {
                    url: '/summer-camp',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/summer-camp');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_Kindergarten', {
                    url: '/kindergarten',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/kindergarten');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_tourism', {
                    url: '/tourism',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/tourism');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_community_security', {
                    url: '/community-security',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/community-security');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_leisure_and_afterSchool', {
                    url: '/leisure-and-afterSchool',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/leisure-and-afterSchool');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_internal_events', {
                    url: '/internal-events',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/internal-events');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_religious_services', {
                    url: '/religious-services',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/religious-services');
                        }
                    },
                    bodyClass: 'events'
                })
                .state('app.pages_golden_age', {
                    url: '/golden-age',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/events/views/events/events.html',
                            controller: 'EventsController'
                        }
                    },
                    resolve: {
                        DashboardData: function (ValidToken) {
                            ValidToken.validUserToken();
                            localStorage.setItem("path", '/golden-age');
                        }
                    },
                    bodyClass: 'events'
                });
        }
    }

)
();

angular.module('app.pages.events').controller('MonthlyPaymentPreviewDialog', MonthlyPaymentPreviewDialog);

function MonthlyPaymentPreviewDialog($scope, $rootScope, privateIDCheck, $timeout, $mdDialog, PreviewData, registrations, dtOptions, DTOptionsBuilder, pelecardEndpoint, appConfig, tranzilaEndpoint) {

    $scope.params = PreviewData;
    $scope.load = true;
    $scope.registrations = registrations;
    $scope.finishedCount = 0;

    $scope.registrations.forEach(function (registration) {
        $scope.params.Registrations = [registration.ID];
        delete registration.Price
        delete registration.CreditCardNumber
        delete registration.CreditCardExpDate
        delete registration.Finished
        var callback = function (data) {
            if (data && Array.isArray(data) && data.length > 0) {
                data.forEach(function (charge) {
                    var tempReg = Object.assign({}, registration);
                    tempReg.Price = charge.Price;
                    tempReg.CreditCardNumber = charge.CreditCardNumber;
                    tempReg.CreditCardExpDate = charge.CreditCardExpDate;
                    tempReg.ChargeID = charge.ChargeID;
                    tempReg.Finished = true;
                    $scope.registrations.push(tempReg);
                    $scope.finishedCount++
                })
            }

            $scope.registrations = $scope.registrations.filter(function (reg) {
                return reg.ChargeID;
            })
        }
        if (appConfig.paymentCompany == 1)
            tranzilaEndpoint.monthlyPayment.post(params, callback);
        else
            pelecardEndpoint.monthlyPayment.post($scope.params, callback);
    })

    $scope.addMonthlyPayment = function () {
        var newRegs = [];
        $scope.registrations.forEach(function (reg) {
            // debugger
            var idx = newRegs.find(function (nReg) {
                return nReg['ID'] === reg['ID'];
            });
            if (!idx) {
                newRegs.push(reg);
            }
        });

        $scope.startedCharging = true;
        $scope.finishedCount = 0;
        $scope.params.PreviewDataOnly = 0;
        newRegs.forEach(function (registration) {
            $scope.params.Registrations = [registration.ID]
            registration.process = 0;
            var callback = function (data) {
                if (data.results.length === 1) {
                    registration.proccess = data.successCount == 1 ? 1 : -1
                    if (data.results[0].StatusCode == '000')
                        registration.ChargeResult = data.results[0].Status;
                    else
                        registration.ChargeResult = data.results[0].StatusCode + '(' + data.results[0].Status + ')';
                } else {
                    var allRelatedRegs = $scope.registrations.filter(function (reg) {
                        return reg.ID == registration.ID;
                    });
                    allRelatedRegs.forEach(function (reg, index) {
                        if (data.results[index].StatusCode == '000')
                            reg.ChargeResult = data.results[index].Status;
                        else
                            reg.ChargeResult = data.results[index].StatusCode + '(' + data.results[0].Status + ')';
                    });


                }
                $scope.finishedCount += data.results.length;
            }
            if (appConfig.paymentCompany == 1)
                tranzilaEndpoint.monthlyPayment.post($scope.params, callback);
            else
                pelecardEndpoint.monthlyPayment.post($scope.params, callback);
        })

    }

    // $timeout(function () {
    //     $scope.dtOptions = DTOptionsBuilder
    //         .newOptions()
    //         .withLanguage(dtOptions.language)
    //         .withDOM('lfrtp')
    //         .withOption('bFilter', false)
    //         .withOption('responsive', false)
    //         .withDOM('lrtip')
    //     $scope.load = false;
    // }, 300);
    $scope.closeDialog = function () {
        $mdDialog.hide();
    };
}

angular.module('app.pages.events').controller('NewStudentDiscountDialogController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','citiesEndpoint','groupsEndpoint','event','Notification', function ($scope, $rootScope, $mdDialog,eventsEndpoint,citiesEndpoint,groupsEndpoint,event,Notification) {

    $scope.newStudentDiscount = {};
    $scope.userType = 0;

     /**
     * Save new Student
     */
    $scope.saveNewStudentDiscount = function () {

            eventsEndpoint.discounts.student.post(event.selectedEvent,  $scope.newStudentDiscount.UserPrivateID, $scope.newStudentDiscount,function (data) {
               if(!data.success) {
                   Notification.error('תעודות זהות לא קיימת');
                   $scope.isClicked = false;
               }
               else
                   $mdDialog.hide();
            });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.events').controller('NewGeneralDiscountDialogController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','areasEndpoint','gradesEndpoint','event','Notification','$element','settlementsEndpoint', function ($scope, $rootScope, $mdDialog,eventsEndpoint,areasEndpoint,gradesEndpoint,event,Notification,$element,settlementsEndpoint) {

    $scope.endpointData = [];
    $scope.endpointsReady = 0;
    $scope.newGeneralDiscount = {};
    $scope.activeModule = undefined;
    var params = {};
    params.Limit=1000;
    params.WithOutEventID = event.selectedEvent.ID;

    /**
     * Get all relevant Information
     */
    $scope.getAllInformation = function () {
        $scope.activeModule = event.getActiveModule();

        var params = {};
        params.Status =1;
        settlementsEndpoint.get({},function(data){
            $scope.endpointData.Settlements = data;
            $scope.endpointsReady +=2;
        })
        eventsEndpoint.get(params,function (data) {
            if(data.length>0) {
                $scope.endpointsReady++;
                $scope.endpointData.Events = data;
            }
        });
        params.Status =1;
        gradesEndpoint.get(params,function (data) {
            if(data.length>0) {
                $scope.endpointsReady++;
                $scope.endpointData.Grades = data;
            }
        });
    };

    /**
     * Save new Student
     */
    $scope.saveNewGeneralDiscount = function () {
            $scope.isClicked = true;
            var params = {};
            params.newDiscount = JSON.stringify($scope.newGeneralDiscount);
            eventsEndpoint.discounts.general.post(event.selectedEvent,params,function (data) {
               if(!data.success) {
                   Notification.error('נשכל בשמירת הנחה כללית');
                   $scope.isClicked = false;
               }
               else
                   $mdDialog.hide();
            });

    };


    $element.find('input').on('keydown', function(ev) {
        ev.stopPropagation();
    });

    $scope.clearSearchTerm = function() {
        $scope.searchTerm = '';
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.events').controller('NewDateDiscountDialogController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','event','Notification',
    function ($scope, $rootScope, $mdDialog,eventsEndpoint,event,Notification) {

    $scope.newDateDiscount = {};

    /**
     * Save new Date Discount
     */
    $scope.saveDateDiscount = function () {
        if(moment($scope.newDateDiscount.FromDate,'DD/MM/YYYY') >= moment($scope.newDateDiscount.ToDate,'DD/MM/YYYY')){
            Notification.error('תאריכים לא תקינים');
            return;
        }
        $scope.isClicked = true;
        eventsEndpoint.discounts.date.post(event.selectedEvent, $scope.newDateDiscount,function (data) {
            $mdDialog.hide();
        });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.events').controller('NewRegistrationDiscountDialogController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','event','Notification','registrationCount',
    function ($scope, $rootScope, $mdDialog,eventsEndpoint,event,Notification,registrationCount) {

    $scope.newRegistrationDiscount = undefined;

    /**
     * Save new Brother Discount
     */
    $scope.saveNewRegistrationDiscount = function () {
        $scope.isClicked = true;
        $scope.newRegistrationDiscount.RegistrationNumber = registrationCount;
        $scope.newRegistrationDiscount.EventID = event.selectedEvent.ID;
        $scope.newRegistrationDiscount.IsNew = true;
        var temp = [];
        temp.push($scope.newRegistrationDiscount);

        var params = {};
        params.discount = JSON.stringify(temp);
        eventsEndpoint.discounts.registration.post(params,event.selectedEvent,function (data) {
           if(!data.success) {
               Notification.error('נשכל בשמירת נתונים');
               $scope.isClicked = false;
           }
           else
               $mdDialog.hide();
        });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.events').controller('NewBrotherDiscountDialogController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','event','Notification','brotherCount', function ($scope, $rootScope, $mdDialog,eventsEndpoint,event,Notification,brotherCount) {

    $scope.newBrotherDiscount = undefined;

    /**
     * Save new Brother Discount
     */
    $scope.saveNewBrotherDiscount = function () {
        $scope.isClicked = true;
        $scope.newBrotherDiscount.brotherNumber = brotherCount;
        $scope.newBrotherDiscount.eventID = event.selectedEvent.ID;
        $scope.newBrotherDiscount.IsNew = true;
        var temp = [];
        temp.push($scope.newBrotherDiscount);

        var params = {};
        params.discount = JSON.stringify(temp);
        eventsEndpoint.discounts.brother.post(params,event.selectedEvent,function (data) {
           if(!data.success) {
               Notification.error('נשכל בשמירת נתונים');
               $scope.isClicked = false;
           }
           else
               $mdDialog.hide();
        });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

/* eslint-disable angular/di */
// eslint-disable-next-line angular/di
angular.module('app.pages.events').controller('GeneralDiscountPanelController', ['$scope','generalDiscount','$rootScope','eventsEndpoint','event','$mdSidenav','$mdDialog', function($scope,generalDiscount,$rootScope,eventsEndpoint,event,$mdSidenav,$mdDialog) {

    $scope.edit = true;
    $scope.activeModule = undefined;


    /**
     * Set the selected GeneralDiscount
     */
    $scope.$on('selectedGeneralDiscount:updated', function() {
        $scope.generalDiscount= generalDiscount.selectedGeneralDiscount;
        $scope.activeModule = event.getActiveModule();
    });

    /**
     * Update GeneralDiscount
     */
    $scope.updateGeneralDiscountPanel = function() {
        $scope.disable = angular.element(document.querySelector('#vertical-navigation') );
        $scope.edit =!$scope.edit;
        if ($scope.edit) {
            $scope.isClick = true;
            var params = {};
            params.discount = JSON.stringify($scope.editedGeneralDiscount);
            eventsEndpoint.discounts.general.update.post(event.selectedEvent.ID,$scope.generalDiscount.ID,params, function (data) {
                $scope.disable.removeClass('active');
                $scope.isClick = false;
                $scope.closePanel();
            })
        }
        else
            $scope.disable.addClass('active');
    };

    /**
     * Close the panel
     */
    $scope.closePanel = function () {
        if (!$scope.edit) {
            confirmCloseWithOutSavingPopUp();
            $scope.edit = !$scope.edit;
        }
        else {
            closeSideNav();
        }

    };


    /**
     * Alert the user that the changes will be overwrite
     * @param ev
     */
    function confirmCloseWithOutSavingPopUp(ev) {
        var confirm = $mdDialog.confirm()
            .title('ביטול שינויים')
            .textContent('האם אתה בטוח/ה שברצונך לצאת ללא שמירה?')
            .targetEvent(ev)
            .ok('צא ללא שמירה')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function() {
            closeSideNav();
        });
    }

    /**
     * Close the side nav
     */
    function closeSideNav() {
        $scope.disable.removeClass('active');
        generalDiscount.isSave(true);
        $mdSidenav("general-discount-panel").close();
    }
}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.users', []).config(config).run(run);

    function run($rootScope,msNavigationService) {


        /**
         * Set the pages by the admin level
         */
        $rootScope.$watch('User',function () {
            if ($rootScope.AdminLevel && $rootScope.User) {
                msNavigationService.deleteItem('pages.users.parents');
                msNavigationService.saveItem('pages.users', {
                    title : 'תושבים',
                    icon  : 'icon-account-multiple',
                    weight: 3

                });
                switch ($rootScope.AdminLevel) {
                    case 1:
                        msNavigationService.saveItem('pages.users.students', {
                            title: 'חניכים',
                            icon  : 'icon-school',
                            state: 'app.pages_users_students'
                        });
                        break;
                    case 2:
                    case 3:
                        msNavigationService.saveItem('pages.users.students', {
                            title: 'חניכים ומדריכים',
                            icon  : 'icon-school',
                            state: 'app.pages_users_students'
                        });

                        msNavigationService.saveItem('pages.users.parents', {
                            title: 'הורים',
                            icon  : 'icon-account-box',
                            state: 'app.pages_users_parents'
                        });
                }
            }
        })
    };

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pages.users', {
                abstract: true,
                url     : '/users'
            })
            .state('app.pages_users_students', {
                url      : '/students',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/views/students/students.html',
                        controller : 'StudentsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/students');
                    }
                },
                bodyClass: 'users'
            })
            .state('app.pages_users_parents', {
            url      : '/parents',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/parents/parents.html',
                    controller : 'ParentsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/parents');
                }
            },
            bodyClass: 'parents'

        });




    }
})();

angular.module('app.pages.users').controller('SubsidyDialogController', ['$scope', '$rootScope', '$mdDialog','coordinatorsEndpoint','coordinate','$location','Notification','subsidy','parentsEndpoint','moreKids',
    function ($scope, $rootScope, $mdDialog,coordinatorsEndpoint,coordinate,$location,Notification,subsidy,parentsEndpoint,moreKids) {

    $scope.subsidy = subsidy;
    $scope.moreKids = moreKids;

    /**
     * Get subsidy files
     */
    $scope.getFiles  =function () {
        subsidy.Files.forEach(function (s){
            window.open(s.Path,s.ID);
        });
    };

    /**
     * Update Subsidy
     */
    $scope.updateSubsidy = function () {
        $scope.isClicked = true;
        parentsEndpoint.subsidy.update.post(subsidy,function (data) {
            $scope.isClicked = false;
            if (data.success)
                Notification.success("בקשה עודכנה");
            else
                Notification.error("נכשל בעידכון בקשה");

        })
    };

    /**
     * CLose dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };



}]);

angular.module('app.pages.users').controller('NewFamilyMemberDialogController', ['$scope', '$rootScope', '$mdDialog', 'parentsEndpoint', 'student', '$location', 'Notification', 'ParentID',
    function ($scope, $rootScope, $mdDialog, parentsEndpoint, student, $location, Notification, ParentID) {

        $scope.newFamilyMember = {
            ParentID: ParentID
        }
        /**
         * Save new Student
         */
        $scope.savenewFamilyMember = function () {
            $scope.isClicked = true;
            parentsEndpoint.family.addFamilyMember.post($scope.newFamilyMember, function (data) {
                $scope.isClicked = false;
                if (data.success) {
                    Notification.success(data.message);
                    $mdDialog.hide();
                } else {
                    if (data.message)
                        Notification.error(data.message);
                    $mdDialog.cancel();
                }

            })
        };

        $scope.ChangeToPassport = function () {
            $scope.tz = !$scope.tz
        };

        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

        $scope.pattern = function () {
            if (!$scope.tz)
                return "/^[0-9]{9,9}$/";
            return "";
        };

        $scope.changeShowMore = function () {
            $scope.more = !$scope.more;

        };


    }]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.student-profile', ['datatables'])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_student-profile', {
            url      : '/student-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/students/student-profile/student-profile.html',
                    controller: 'StudentProfileController'
                }
            },
            resolve  : {
                DashboardData: function ()
                {
                    localStorage.setItem("path",'/student-profile');
                }
            },
            bodyClass: 'student-profile'
        });

    }

})();
angular.module('app.pages.student-profile').controller('NewEducatorGroupsController', NewEducatorGroupsController);
function NewEducatorGroupsController($rootScope, groupsEndpoint, student, educatorsEndpoint, Notification, $mdDialog, settlementsEndpoint) {

    var vm = this;
    vm.newGroup = {};
    vm.getSettlements = getSettlements;
    vm.getGroupsBySettlement = getGroupsBySettlement;
    vm.addGroup = addGroup;
    vm.closeDialog = closeDialog;
    vm.clearSearchTerm = clearSearchTerm;
    vm.clearSearchTerm2 = clearSearchTerm2;
    vm.searchTerm2 = '';
    vm.searchTerm = '';
    vm.settlements = [];
    vm.branches = [];
    vm.groups = [];

    vm.getGroupsBySettlement();


    function getSettlements() {
        settlementsEndpoint.get({}, function (data) {
            vm.settlements = data;
        });
    }

    function getGroupsBySettlement() {
        vm.groups = false;
        var params = {};
        params.SettlementID = vm.newGroup.SettlementID;
        params.Status = 1;
        groupsEndpoint.get(params, function (data) {
            vm.groups = data;
        })
    }

    function addGroup() {
        vm.newGroup.EducatorID = student.selectedStudent.EducatorID;
        vm.newGroup.StudentID = student.selectedStudent.ID;
        vm.newGroup.FirstName = student.selectedStudent.FirstName;
        vm.newGroup.LastName = student.selectedStudent.LastName;
        vm.newGroup.Email = student.selectedStudent.Email;
        vm.isClicked = true;
        educatorsEndpoint.groups.post(vm.newGroup, function (data) {
            if (data.success == 1)
                Notification.success("שיוך בוצע בהצלחה");
            else if (data.success == 2)
                Notification.success("קבוצה שויכה בהצלחה - דואר אלקטרוני נשלח למשתמש");
            else
                Notification.error("נכשל בשליחת הזמנה - יש לוודא שלמדריך יש מייל ושהוא לא קיים עבור משתמש אחר");
            vm.isClicked = false;
            $mdDialog.hide();

        })
    }

    function clearSearchTerm() {
        vm.searchTerm = '';
    }

    function clearSearchTerm2() {
        vm.searchTerm2 = '';
    }


    function closeDialog() {
        $mdDialog.cancel();
    }


}

(function ()
{
    'use strict';

    angular
        .module('app.pages.activities-profile', ['datatables'])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_utils_activities-profile', {
            url      : '/activities-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/utils/views/activities/activities-profile/activities-profile.html',
                    controller: 'ActivitiesProfileController'
                }
            },
            resolve  : {
                DashboardData: function ()
                {
                    localStorage.setItem("path",'/activities-profile');
                }
            },
            bodyClass: 'activities-profile'
        });


    }

})();

angular.module('app.pages.activities-profile').controller('NewActivityMeetingDialogController', NewActivityMeetingDialogController)

function NewActivityMeetingDialogController($scope, $rootScope, $mdDialog, activitiesEndpoint, Notification,activity) {

    $scope.newMeeting = {
        ActivityID: activity.ID,
        Date: moment().format('DD/MM/YYYY HH:mm'),
        GroupName: activity.GroupName,
        Name: activity.Name
    }

    /**
     * Save new meeting
     */
    $scope.saveNewMeeting = function () {
        $scope.isClicked = true;
        activitiesEndpoint.meetings.post({ID: $scope.newMeeting.ActivityID},$scope.newMeeting, function (data) {
            $scope.isClicked = false;
            if (!data.success) {
                Notification.info("שגיאה");
            } else {
                Notification.success("מפגש נוצר בהצלחה");
            }
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewRowDialogController', NewRowDialogController);
function NewRowDialogController($scope, $mdDialog,Notification,currentSection,successCallback) {

    $scope.newRow = {};

    /**
     * Save new Question
     */
    $scope.saveNewRow = function () {
        var lastRowID = 0;
        if(currentSection.Rows.length > 0){
            lastRowID = Number(currentSection.Rows[currentSection.Rows.length-1]['ID']);
        }
        var length = currentSection.Rows.push({
            ID: lastRowID + 1,
            Name: $scope.newRow.Name,
            Seats: []
        });
        for(var i = 0; i < $scope.newRow.amountOfSeats; i++){
            currentSection.Rows[length-1].Seats.push({
                ID: i,
                Name: Number($scope.newRow.FirstSeatNumber) + i
            });
        }
        successCallback(currentSection.Rows[length-1]);
        $mdDialog.cancel();
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('SwapEventDialogController', SwapEventDialogController);

function SwapEventDialogController($scope, $rootScope, $mdDialog,oldRegistrationID,eventID, eventsEndpoint,Notification) {
    $scope.isClicked = false;
    $scope.newEventID;


    $scope.getEvents = function (){
        $scope.isClicked = true;
        var params = {
            Status: 1,
            FreeSearch: $scope.searchTerm,
            ParentEventID: eventID
        }
        eventsEndpoint.get(params, function (data) {
            $scope.isClicked = false;
            $scope.events = data;
        })
    }
    $scope.swapRegistration = function (){
        $scope.isClicked = true;
        var params = {
            newEventID: $scope.newEventID,
            oldRegistrationID: oldRegistrationID
        }
        eventsEndpoint.registrations.swap.post(params, function (data) {
            $scope.isClicked = false;
            if(data.success){
                Notification.success('ההרשמה הועברה בהצלחה');
            } else
                Notification.error('התרחשה שגיאה');

            $scope.closeDialog(data.success);

        })
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog = function (isSuccess) {
        $mdDialog.hide(isSuccess);
    };
}

angular.module('app.pages.events').controller('NewRegistrationDialogController', NewRegistrationDialogController);

function NewRegistrationDialogController($scope, $document, $rootScope, privateIDCheck, $timeout, $mdDialog, studentsEndpoint, student, $location, Notification, event, eventsEndpoint, tranzilaEndpoint, $sce, appConfig, pelecardEndpoint, settingsEndpoint, $interval, settlementsEndpoint, gradesEndpoint, groupsEndpoint, Upload, parentsEndpoint) {


    $scope.quesitons = true;
    $scope.newRegistration = {};
    $scope.selectedTransportation = {};
    $scope.payments = [];
    $scope.numOfPayments = 1;
    $scope.checks = [];
    $scope.parents = [];
    $scope.restrictDialogClose = false;
    $scope.dataFetched = 0;
    $scope.showErr = true;
    $scope.errMsg = '';
    $scope.paid = false;

    $scope.init = function () {
        $scope.activeModule = event.getActiveModule();
        $scope.eventType = event.selectedEvent.EventType;
        if ($scope.eventType == 1) {//externalEvent => need to fetch all the data now
            $scope.dataFetched = 1;
            $scope.getQuestions();
            $scope.getTransportation();
            $scope.getEventLocation();
        }
    }

    function getEmptyPayment() {
        return {
            Type: '',
            Amount: '',
            AccountName: '',
            BankNumber: '',
            BranchNumber: '',
            AccountNumber: '',
            fileReceipt: '',
            fileName: '',
            BrandAccountNumber: '',
            CheckOwner: '',
            NumberOfCheck: '',
            checks: [],
            PaymentStatus: 1,
            iframe: '',
            Name: '',
            Email: '',
            parent: '',
            DealID: '',
            ReceiptID: '',
            RegistrationID: '',
            interval: false,
            paymentStatusDisabled: false,
            TransactionType: ''
        }
    }


    $scope.moveToNextStep = function () {
        $scope.selectedTab++;
    }

    $scope.addPayment = function (amount, clearExisting) {
        if (clearExisting) {
            $scope.payments = [];
        }
        var payment = getEmptyPayment();
        payment.Amount = amount;
        if ($scope.parent) {
            payment.Email = $scope.parent.Email;
            payment.Name = $scope.parent.FullName;
        }
        if ($scope.event.EventType == 1) {
            payment.Email = $scope.newRegistration.UserEmail;
            payment.Name = $scope.newRegistration.FirstName + ' ' + $scope.newRegistration.LastName;

        }

        $scope.payments.push(payment);
    };

    $scope.removePayment = function (index) {
        var amount = $scope.payments[index].Amount;
        $scope.payments.splice(index, 1);
        $scope.payments[$scope.payments.length - 1].Amount += amount;
    };

    $scope.getParents = function () {
        studentsEndpoint.parent.get($scope.newRegistration.StudentID, function (data) {
            $scope.parents = data;
            $scope.dataFetched++;
        });
    };

    $scope.addPaymentMissingPrice = function () {
        if ($scope.event.MonthlyPayment != 1) {
            var sum = 0;
            for (var i = 0; i < $scope.payments.length; i++)
                sum += $scope.payments[i].Amount;
            var newAmount = $scope.event.NewPrice != undefined ? $scope.event.NewPrice : $scope.event.Price;
            newAmount -= sum;
            $scope.addPayment(newAmount);
        } else {
            $scope.addPayment($scope.event.ExtraPrice);
        }

    };

    $scope.setParent = function (index) {
        $scope.payments[index].Name = $scope.payments[index].parent.Name;
        $scope.payments[index].Email = $scope.payments[index].parent.Email;
    };

    $scope.savePayment = function (index) {
        $scope.payments[index].ReceiptID = 'saved';
    };

    /**
     * Save new Student
     */
    $scope.getStudent = function () {
        if (!$scope.newRegistration.PrivateID)
            return;
        $scope.isClicked = true;
        $scope.questionsDisable = true;
        $scope.transportationDisable = true;
        $scope.locationDisabled = true;
        if ($scope.newRegistration.userType == 1) {//1 == student, 0 == parent
            studentsEndpoint.studentPrivateID.get($scope.newRegistration, $scope.handleMember);
        } else {
            parentsEndpoint.parentByPrivateID.get($scope.newRegistration, $scope.handleMember);
        }

    };

    $scope.handleMember = function (data) {
        $scope.isClicked = false;
        $scope.new = false;
        $scope.hide = false;
        $scope.notExist = false;
        if (data.ID) {
            $scope.student = data;
            $scope.newRegistration.FirstName = data.FirstName;
            $scope.newRegistration.LastName = data.LastName;
            $scope.notExist = false;
            $scope.studentSettlementID = data.SettlementID;
            if ($scope.newRegistration.userType == 1) {
                $scope.newRegistration.StudentID = data.ID;
                studentsEndpoint.registrations.isRegistered(data.ID, event.selectedEvent.ID, function (data) {
                    if (data.success) {
                        if (data.result) {
                            Notification.error("תושב זה כבר רשום לאירוע זה");
                            $mdDialog.hide();
                        }
                    } else {
                        Notification.error("אירעה תקלה");
                    }
                })
            } else {
                $scope.newRegistration.ParentID = data.ID;
                parentsEndpoint.registration.isRegistered(data.ID, event.selectedEvent.ID, function (data) {
                    if (data.success) {
                        if (data.result) {
                            Notification.error("תושב זה כבר רשום לאירוע זה");
                            $mdDialog.hide();
                        }
                    } else {
                        Notification.error("אירעה תקלה");
                    }
                })
            }
            $scope.getQuestions();
            $scope.getParents();
            $scope.getPriceForStudent();
            $scope.getTransportation();
            $scope.getEventLocation();
        } else {
            Notification.info("תעודת זהות לא קיימת במערכת");
            $scope.notExist = true;
        }
    }

    $scope.getQuestions = function () {
        eventsEndpoint.questions.get({SettlementID: $scope.studentSettlementID}, event.selectedEvent, function (data) {
            $scope.quesitons = data;
            if ($scope.quesitons.length == 0)
                $scope.questionsDisable = false;
            else {
                $scope.quesitons.forEach(function (question) {
                    if (question['AnswerType'] == 2) {
                        question['Options'] = question['Options'].split(",");
                    }
                })
            }
            $scope.dataFetched++;
        })
    };

    $scope.getEventLocation = function () {
        if (!event.selectedEvent.LocationID) {
            $scope.locationDisabled = false;
            $scope.location = false;
            $scope.dataFetched++;
        } else {
            eventsEndpoint.locations.get(event.selectedEvent.ID, function (data) {
                if (data.location && data.layout.length) {
                    $scope.location = data;
                    $scope.location.layout = JSON.parse($scope.location.layout);
                    if ($scope.location.layout.length == 0) {
                        $scope.locationDisabled = false;
                        $scope.location = false;
                    }

                } else {
                    $scope.locationDisabled = false;
                    $scope.location = false;
                }
                $scope.dataFetched++;
            })
        }
    }

    $scope.saveSeat = function (sectionID, rowID, seatID) {
        if ($scope.newRegistration.SectionID != undefined &&
            $scope.newRegistration.RowID != undefined &&
            $scope.newRegistration.SeatID != undefined) {
            var section = $scope.location.layout.find(function (section) {
                return section.ID == $scope.newRegistration.SectionID
            });
            var row = section.Rows.find(function (row) {
                return row.ID == $scope.newRegistration.RowID
            });
            var seat = row.Seats.find(function (seat) {
                return seat.ID == $scope.newRegistration.SeatID
            });
            seat.reserved = false;
        }

        $scope.newRegistration.SectionID = sectionID;
        $scope.newRegistration.RowID = rowID;
        $scope.newRegistration.SeatID = seatID;
    }

    $scope.updateQuestions = function () {
        $scope.questionsDisable = false;
        $scope.moveToNextStep()
    };

    $scope.updateTransportations = function () {
        $scope.transportationDisable = false;
        $scope.moveToNextStep()
    };

    $scope.goToPayments = function () {
        if ($scope.newRegistration.SectionID != undefined && $scope.newRegistration.RowID != undefined && $scope.newRegistration.SeatID != undefined) {
            $scope.locationDisabled = false;
            $scope.moveToNextStep();
        }
    }

    $scope.getTransportation = function () {
        eventsEndpoint.transportation.get(event.selectedEvent, function (data) {
            $scope.transportation = data.filter(function (transport) {
                return transport.Status == 1;
            });
            if ($scope.transportation.length == 0)
                $scope.transportationDisable = false;
            $scope.dataFetched++;
        })
    };

    $scope.newStudent = function () {
        $scope.new = true;
        $scope.hide = true;
        var params = {
            status: 1
        };
        settlementsEndpoint.get(params, function (data) {
            $scope.settlements = data;
        });
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        })
    };

    /**
     * Update Questions
     * @param question
     */
    $scope.updateOptionFile = function (question) {
        var file = document.getElementById(question.ID);
        file = file.files[0];
        var params = new FormData();
        question.filename = new Date().getTime() + "_" + file.name;
        params.append("files", file, question.filename);
        params.append("brand", $rootScope.brandName);
        params.append("upload_file", 'true');

        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files';
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files';
        else
            uploadURL = appConfig.serverUrl + '/upload/files';

        $http.post(uploadURL, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + $rootScope.User.AccessToken

            },
            withCredentials: true
        }).then(function (data) {
            question.Answer = data.Path;
        });

    };


    /**
     * Get all settlements groups
     */
    $scope.getGroupsBySettlements = function () {
        var params = {};
        params.status = 1;
        params.SettlementID = $scope.newRegistration.SettlementID;
        params.GradeID = $scope.newRegistration.GradeID;
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        })
    };

    $scope.userValidation = function () {
        if ($scope.newRegistration.FirstName && $scope.newRegistration.LastName && $scope.newRegistration.UserEmail && $scope.newRegistration.UserPhoneNumber)
            if ($scope.newRegistration.FirstName.length > 0 && $scope.newRegistration.LastName.length > 0 && $scope.newRegistration.UserEmail.length > 0 && $scope.newRegistration.UserPhoneNumber.length > 0)
                $scope.getPriceForStudent();
    }

    /**
     * Get Price for event by student
     */
    $scope.getPriceForStudent = function () {
        var params = {};

        if ($scope.eventType == 1) {
            params.EventType = $scope.eventType;
            params.EventID = event.selectedEvent.ID;
            params.FirstName = $scope.newRegistration.FirstName;
            params.LastName = $scope.newRegistration.LastName;
            params.UserEmail = $scope.newRegistration.UserEmail;
            params.UserPhoneNumber = $scope.newRegistration.UserPhoneNumber;
        } else {
            $scope.student.SelectedEvents = [];
            $scope.student.SelectedEvents.push(event.selectedEvent);
            params.Students = [];
            params.Students.push(angular.copy($scope.student));
            params.Students = JSON.stringify(params.Students);
        }

        eventsEndpoint.price.post(params, function (data) {
            if (data.success === false) {
                Notification.error("לא ניתן לרשום תושב זה");
                $mdDialog.hide();
            } else {
                $scope.items = data.Items;
                $scope.parent = {}
                $scope.parent.FullName = $scope.items[0]['FirstName'] + ' ' + $scope.items[0]['LastName'];
                $scope.parent.Email = $scope.items[0]['Email'];
                $scope.parent.ParentID = $scope.items[0]['ParentID'];
                $scope.DealID = data.DealID;
                $scope.event = data.Items[0].SelectedEvents[0];
                $scope.newRegistration.Price = $scope.event.Price;
                $scope.newRegistration.NewPrice = $scope.event.NewPrice;
                $scope.newRegistration.EventID = event.selectedEvent.ID;

                if ($scope.eventType == 1)
                    $scope.newRegistration.UserID = data.Items[0].ID;

                // if ($scope.event.NewPrice > 0)
                $scope.addPayment($scope.event.NewPrice, true);
            }
            $scope.dataFetched++;
        })
    };

    /**
     * Save the new Registration
     */
    $scope.saveNewRegistration = function (newReg) {
        $scope.isClicked = true;
        $scope.items[0]['SelectedEvents'][0]['Questions'] = $scope.quesitons;
        $scope.items[0]['SelectedEvents'][0]['Transportation'] = $scope.selectedTransportation;
        $scope.newRegistration.Items = JSON.stringify(angular.copy($scope.items));
        $scope.newRegistration.EventType = $scope.eventType;

        if ($scope.event.MonthlyPayment == 1 && $scope.payments[0].Type != 11) {
            $scope.newRegistration.PaymentType = $scope.payments[0].Type;
        } else {
            if ($scope.payments.length > 0)
                $scope.newRegistration.payments = $scope.payments;
            else {
                $scope.newRegistration.PaymentType = 0;

            }
        }

        /*if ($scope.eventType == 0) {
            if($scope.parents.length)
                $scope.newRegistration.ParentID = $scope.parents[0].ID;
            else if($scope.parent.ParentID)
                $scope.newRegistration.ParentID = $scope.parent.ParentID;

        }*/

        studentsEndpoint.events.post($scope.newRegistration, function (data) {
            if (data.success) {
                Notification.success("הרשמה בוצעה בהצלחה!");
                $scope.paid = false;
            } else
                Notification.error("נכשל בהספת הזמנה.יש לוודא שהחניך משויך לסניף ושכבה ושאינו רשום כבר ל" + $rootScope.User.Event + " זה");
            $scope.isClicked = false;
            clearAllIntervals();
            if (newReg) {
                /*$scope.isClicked = false;
                $scope.new = false;
                $scope.hide = false;
                $scope.notExist = false;
                $scope.newRegistration = {};
                $scope.newRegistration.PaymentStatus = ($rootScope.AdminLevel < 3 && !$rootScope.User.Payments) ? 2 : 1;
                $scope.newRegistration.Status = 1;*/
                $mdDialog.hide();

                $mdDialog.show({
                    controller: 'NewRegistrationDialogController',
                    templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/new-registration-dialog/new-registration-dialog.html',
                    clickOutsideToClose: false,
                    locals: {
                        includePayment: true,
                    }
                });
            } else
                $mdDialog.hide();
        })
    };

    /**
     * Set pattern
     * @returns {*}
     */
    $scope.pattern = function () {
        if (!$scope.tz)
            return "/^[0-9]{9,9}$/";
        return "";
    };

    /**
     * Looking for changes in the private id
     */
    $scope.$watch('newRegistration.PrivateID', function () {
        $scope.getStudent();
    });

    /**
     * change password to tz
     * @constructor
     */
    $scope.ChangeToPassport = function () {
        $scope.tz = !$scope.tz
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        if (!$scope.paid) {
            $mdDialog.cancel();
            clearAllIntervals();
        } else {
            var saveBtn = $document.find('#saveNewRegBtn');
            if (saveBtn && saveBtn[0]) {
                saveBtn[0].focus();
                var tmpBrd = saveBtn[0].style.border;
                saveBtn[0].style.border = '3px solid red';
                $scope.showErr = true;
                $scope.errMsg = 'נא לשמור תחילה את ההרשמה';
                $timeout(function () {
                    saveBtn[0].style.border = tmpBrd;
                    $scope.showErr = false;
                    $scope.errMsg = '';
                }, 3500);
            }

        }
    };

    function clearAllIntervals() {
        $scope.payments.forEach(function (payment) {
            if (payment.interval)
                $interval.cancel(payment.interval);
        })
    }

    /**
     * Move to payment tab
     */
    $scope.moveToPayments = function () {
        if ($scope.new) {
            createNewStudent()
        } else
            $scope.moveToNextStep()
    };

    function createNewStudent() {
        if (!$scope.tz)
            if (privateIDCheck.privateIDCheck($scope.newRegistration.PrivateID) === false) {
                Notification.error("תעודות זהות לא תקינה");
                return false;
            }
        if ($scope.newRegistration.Parent1) {
            if (privateIDCheck.privateIDCheck($scope.newRegistration.Parent1) === false) {
                Notification.error("תעודות זהות הורה לא תקינה");
                return false;
            }
        }


        studentsEndpoint.post($scope.newRegistration, function (data) {
            $scope.newRegistration.StudentID = data.ID;
            $scope.student = data;
            $scope.new = false;
            $scope.hide = false;
            $scope.getStudent();
        });
        return true;
    }

    $scope.uploadFile = function (file, payment) {
        if (!file)
            return;
        $scope.isClicked = true;
        $scope.fileName = file.name;
        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else
            uploadURL = appConfig.serverUrl + '/upload/files?brand=' + $rootScope.brandName;

        Upload.upload({
            url: uploadURL,
            data: {file: file},
            headers: {
                Authorization: 'Bearer ' + $rootScope.User.AccessToken
            }
        }).then(function (resp) {
            payment.FileReceipt = resp.data.Path;
            payment.FileName = resp.data.OriginalName;
            $scope.isClicked = false;

        }, function (resp) {
            console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage);
        });

    };

    /**************************Credit Card payment****************************/
    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    };

    $scope.changePaymentStatusByType = function (payment) {
        payment.paymentStatusDisabled = false;

        if ($rootScope.AdminLevel < 3) {
            payment.paymentStatusDisabled = true;
        }
        switch (payment.Type) {
            case 0://free
                break;
            case 1://credit card
                payment.PaymentStatus = 1;
                payment.paymentStatusDisabled = true;
                break;
            case 2://cash
                if ($rootScope.AdminLevel < 3) {
                    payment.PaymentStatus = 2;//payed to coordinator
                } else {
                    payment.PaymentStatus = $rootScope.advancedCashierOptions ? 5 : 1;
                }
                break;
            case 3://bank transfer
                payment.PaymentStatus = 1;
                payment.paymentStatusDisabled = true;
                break;
            case 4://checks
                if ($rootScope.AdminLevel < 3) {
                    payment.PaymentStatus = 2;//payed to coordinator
                } else {
                    payment.PaymentStatus = $rootScope.advancedCashierOptions ? 5 : 1;
                }
                break;
            case 11://credit card monthly
                payment.PaymentStatus = 1;
                payment.paymentStatusDisabled = true;
                break;
        }
    }

    $scope.checkForMaxPaymentAmount = function (index) {
        var payment = $scope.payments[index];
        if (payment.Amount > $scope.event.NewPrice)
            payment.Amount = $scope.event.NewPrice;
    }

    /**
     * Check the payment type
     */
    $scope.checkIfNoCharge = function (index) {
        var payment = $scope.payments[index];
        $scope.changePaymentStatusByType(payment);
        if (payment.Type == 3) {
            var params = {CategoryID: $scope.event.CategoryID}
            settingsEndpoint.accountancy.banks.get(params, function (data) {
                $scope.banks = data;
            })
        } else {
            if (!$scope.copy)
                $scope.copy = angular.copy($scope.event.Price);
            if (payment.Type == 0)
                $scope.event.Price = 0;
            else
                $scope.event.Price = $scope.copy;
            if (payment.Type == 1 || payment.Type == 11) {
                if (payment.Type == 11)
                    payment.Amount = $scope.event.ExtraPrice;
                $scope.getIframe(payment);
                if (payment.interval)
                    $interval.cancel(payment.interval);
                payment.interval = $interval(function () {
                    if (!params)
                        var params = {
                            DealID: payment.DealID
                        };
                    if ($scope.success) {
                        $interval.cancel(payment.interval);
                        return;
                    }
                    params.Type = payment.Type;
                    if (appConfig.paymentCompany == 1) {
                        tranzilaEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    $scope.paid = true;
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                    $scope.success = true;
                                    payment.ReceiptID = data['receiptID'];
                                    payment.RegistrationID = data['registrationID'];
                                    $interval.cancel(payment.interval);
                                    $scope.restrictDialogClose = true;
                                    payment.iframe = false;
                                } else {
                                    Notification.error("שגיאה")
                                }
                                $scope.success = true;
                                $interval.cancel(payment.interval);
                            }

                        })
                    } else {
                        pelecardEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    $scope.paid = true;
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                    $scope.success = true;
                                    payment.ReceiptID = data['receiptID'];
                                    payment.RegistrationID = data['registrationID'];
                                    payment.TransactionType = data['transactionType'];
                                    $interval.cancel(payment.interval);
                                    $scope.restrictDialogClose = true;
                                    payment.iframe = false;
                                } else {
                                    Notification.error("שגיאה")
                                }
                                $scope.success = true;
                                //$mdDialog.hide();
                                $interval.cancel(payment.interval);
                            }

                        })
                    }

                }, 4000);
            } else if (payment.interval)
                $interval.cancel(payment.interval);
        }

        if (payment.Type === 4) {
            payment.checks = [];
        }
    };

    /**
     * Get pelecrd iframe
     */
    $scope.getIframe = function (payment) {


        var items = JSON.stringify(angular.copy($scope.items));
        var params = {};
        params.Total = $scope.event.NewPrice != undefined ? $scope.event.NewPrice : $scope.event.Price;
        params.Payments = $scope.event.MaxPayments;
        params.DealID = $scope.DealID;
        params.Amount = payment.Amount;
        params.Items = items;
        params.Name = payment.Name;
        params.Email = payment.Email;
        if (appConfig.paymentCompany == 1) {
            if (payment.Type == 1) {
                tranzilaEndpoint.get(params, function (data) {
                    payment.iframe = data.Iframe;
                    payment.DealID = data.DealID;
                });
            } else if (payment.Type == 11) {
                tranzilaEndpoint.getJ5(params, function (data) {
                    payment.iframe = data.Iframe;
                    payment.DealID = data.DealID;
                });
            }
        } else {
            if (payment.Type == 1) {
                pelecardEndpoint.get(params, function (data) {
                    payment.iframe = data.Iframe;
                    payment.DealID = data.DealID;
                });
            } else if (payment.Type == 11) {
                pelecardEndpoint.getJ2(params, function (data) {
                    payment.iframe = data.Iframe;
                    payment.DealID = data.DealID;
                });
            }
        }
    };

    $scope.generateChecks = function (index) {
        $scope.payments[index].checks = [];
        for (var i = 0; i < $scope.payments[index].NumberOfCheck; i++) {
            $scope.payments[index].checks.push({
                CheckBank: undefined,
                CheckBranch: '',
                CheckAccountNumber: '',
                CheckNumber: '',
                CheckMaturityDate: '',
                CheckAmount: '',
            });
        }
    };

    $scope.paymentsValidity = function () {
        if (!$scope.event)
            return false;
        var totalSum = 0;
        for (var i = 0; i < $scope.payments.length; i++) {
            var priceToCharge = $scope.payments[i].Amount;
            totalSum += priceToCharge;
            if ($scope.payments[i].ReceiptID == '')
                return false;
            if ($scope.payments[i].checks.length === 0)
                continue;

            for (var j = 0, sum = 0; j < $scope.payments[i].checks.length; j++) {
                sum += $scope.payments[i].checks[j].CheckAmount;
            }
            if (sum !== priceToCharge) {
                return false;
            }
        }

        return $scope.getTotalAmountsValidity();
    };


    $scope.checkForMonthlyPayment = function () {
        return $scope.payments.find(function (payment) {
            return payment.TransactionType == 3;
        })
    }

    $scope.getTotalAmountsValidity = function () {
        if (!$scope.event) {
            return false;
        }
        var totalPrice = $scope.event.NewPrice != undefined ? $scope.event.NewPrice : $scope.event.Price;
        var sum = 0;
        for (var i = 0; i < $scope.payments.length; i++) {
            if ($scope.payments[i].Type != 1 || ($scope.payments[i].Type == 1 && $scope.payments[i].ReceiptID != ''))
                sum += $scope.payments[i].Amount;
        }
        //console.log($scope.payments)
        return sum === totalPrice;
    }

    $scope.checkChecksValidity = function (payment) {
        if (payment.Type != 4)
            return true;
        var tmp = 0;
        payment.checks.forEach(function (check) {
            tmp += check.CheckAmount;
        });
        return tmp == payment.Amount;
    }
}

angular.module('app.pages.events').controller('NewMonthlyPaymentDialog', NewMonthlyPaymentDialog);

function NewMonthlyPaymentDialog($scope, $rootScope, privateIDCheck, $timeout, $mdDialog,tranzilaEndpoint,pelecardEndpoint,appConfig,registrations,Notification,RegistrationsMonthlyTransactionID) {

    $scope.percentDiscount = 0;
    $scope.chargeType;
    $scope.MonthYear;
    $scope.newPrice = 0;
    $scope.registrationsCount = registrations.length;
    $scope.showPercentageWarning = !!RegistrationsMonthlyTransactionID;
    $scope.isClicked = false;


    $scope.addMonthlyPayment = function (PreviewDataOnly){
        var params = {
            PreviewDataOnly: PreviewDataOnly? 1 : 0,
            Registrations: registrations.map(function(reg){
                return reg.ID;
            }),
            ChargeType: $scope.chargeType,
            PercentDiscount: $scope.percentDiscount,
            Amount: $scope.newPrice,
            MonthYear: $scope.MonthYear
        }

        if(RegistrationsMonthlyTransactionID)
            params.RegistrationsMonthlyTransactionID = RegistrationsMonthlyTransactionID;
        if (appConfig.paymentCompany == 1) {
            tranzilaEndpoint.monthlyPayment.post(params, function (data) {
                if(params.PreviewDataOnly)
                    $scope.showPreview(data);
                else {
                    if (data.successCount == $scope.registrationsCount)
                        Notification.success('כל העסקאות עברו בהצלחה');
                    else if (data.successCount > 0 && data.successCount != $scope.registrationsCount)
                        Notification.error(data.failCount + ' מתוך ' + $scope.registrationsCount + ' עסקאות נכשלו');
                    else
                        Notification.error('כלל העסקאות נכשלו');
                    $scope.closeDialog();
                }
                $scope.isClicked = true;
            });
        }
        else {
            if(PreviewDataOnly){
                $scope.showPreview(params);
                return;
            }
            pelecardEndpoint.monthlyPayment.post(params, function (data) {
                if(params.PreviewDataOnly)
                    $scope.showPreview(data);
                else {
                    if (data.successCount == $scope.registrationsCount)
                        Notification.success('כל העסקאות עברו בהצלחה');
                    else if (data.successCount > 0 && data.successCount != $scope.registrationsCount)
                        Notification.error(data.failCount + ' מתוך ' + $scope.registrationsCount + ' עסקאות נכשלו');
                    else
                        Notification.error('כלל העסקאות נכשלו');
                    $scope.closeDialog();
                }
            });
        }
    }

    $scope.showPreview = function(params){
        $mdDialog.show({
            controller: 'MonthlyPaymentPreviewDialog',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/new-monthly-payment-dialog/monthly-payment-preview-dialog/monthly-payment-preview-dialog.html',
            clickOutsideToClose: false,
            multiple: true,
            locals: {
                'PreviewData': params,
                'registrations': registrations
            },
        }).then(function(){
            $mdDialog.hide();
        });
    }

    $scope.validateNumberInput = function(){
        if($scope.percentDiscount > 100)
            $scope.percentDiscount = 100;
        if($scope.percentDiscount < 0)
            $scope.percentDiscount = 0;
    }
    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.hide();
    };
}

angular.module('app.pages.events').controller('MissingMonthReceiptDialog', MissingMonthReceiptDialog);

function MissingMonthReceiptDialog($scope, $rootScope, $mdDialog, eventID, eventsEndpoint, Notification) {
    $scope.isClicked = false;
    $scope.newEventID;
    $scope.months = getMonthList();
    $scope.search = {
        eventID: eventID,
        month:''
    }

    function getMonthList() {
        var months = moment();
        var res = [];
        for (var i = 0; i < 12; i++) {
            res.push({
                month: months.format('MMMM YYYY'),
                val: months.format('M/YYYY')
            });
            months.subtract(1, 'month');
        }
        return res;
    }
    $scope.getMonthUnpaidReport = function () {
            $scope.isClicked = true;
            var params = {};
            params.MissingReceipts = $scope.search.month;
            params.event = {ID:$scope.search.eventID};
            params.Status = 1;
            params.excelReport = 1;

        $scope.groups = [];
        $scope.selectedStudentsCount = 0;
        eventsEndpoint.subscribers.unpaidReport(params, params.event, function (data) {
            $scope.closeDialog(data);
        });
    }


    /**
     * Close the dialog
     */
    $scope.closeDialog = function (data) {
        $mdDialog.hide(data);
    };
}

angular.module('app.pages.events').controller('NewEventSuggestionController', NewEventSuggestionController);

function NewEventSuggestionController($scope, $rootScope, $mdDialog, event, eventsEndpoint, Notification) {


    $scope.suggestedEvent = {
        Required: 0,
        MasterEventID: event.ID,
    };
    $scope.events = false;


    $scope.init = function () {
        var objectsSearch = {
            Status: 1,
            DateStatus: 1,
            ExcludedEvent: event.ID,
        }

        eventsEndpoint.get(objectsSearch, function (data) {
            $scope.events = data;
            if ($scope.events.length === 0) {
                Notification.error('אין הצעות שניתן להוסיף');
                $mdDialog.hide();
            }
            objectsSearch.DateStatus = 0;
            objectsSearch.IsProduct = 1;
            eventsEndpoint.get(objectsSearch, function (data) {
                $scope.events = $scope.events.concat(data)
                if ($scope.events.length === 0) {
                    Notification.error('אין הצעות שניתן להוסיף');
                    $mdDialog.hide();
                }
            });
        });

    }

    $scope.saveNewEventSuggestion = function () {
        eventsEndpoint.suggestions.create($scope.suggestedEvent, function (data) {
            if (data.success)
                Notification.success('הצעה נוצרה בהצלחה');
            else
                Notification.success('הצעה כבר קיימת');

            $mdDialog.hide();
        })
    };

    $scope.log = function () {
        console.log($scope.suggestedEvent);
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

(function ()
{
    'use strict';

    angular.module('app.pages.event-management', ['datatables']).config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_event-management', {
            url      : '/event-management',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/events/views/events/event-management/event-management.html',
                    controller: 'EventManagementController'
                }
            },
            resolve  : {
                DashboardData: function () {
                    localStorage.setItem("path", '/event-management');
                }
            },
            bodyClass: 'event-management'
        });


    }

})();

angular.module('app.pages.event-management').controller('AddQuestionsToEventController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','questionsEndpoint','event','settlementsEndpoint' ,function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,questionsEndpoint,event,settlementsEndpoint) {

    $scope.event = event.selectedEvent;

    $scope.init = function(){
        $scope.getAllQuestions();
        $scope.getSettlements();
    }

    /**
     * Get all the questions that are not in the event
     */
    $scope.getAllQuestions = function () {
        $scope.newQuestions = false;
        var params = {};
        params.Status = 1;
        questionsEndpoint.get(params,function (data) {
            $scope.newQuestions = data;
        })
    };

    $scope.addQuestionsToEvent = function () {
        var params = {};
        params.QuestionID = [];
        for (var i =0 ; i<$scope.newQuestions.length;i++) {
            if($scope.newQuestions[i].Add)
                params.QuestionID.push($scope.newQuestions[i].ID);
        }
        $scope.isClicked = true;
        params.SettlementID = $scope.newQuestions.SettlementID;
        eventsEndpoint.questions.add.post($scope.event, params, function (data) {
            $scope.isClicked = false;
            if(!data.success) {
                Notification.error("אחת מהשאלות שנבחרו קיימות עבור ה" + $rootScope.User.Event);
            } else {
                $mdDialog.hide();
            }
        })
    };

    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })
    };
    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


}]);

angular.module('app.pages.event-management').controller('AddTransportationToEventController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event','transportationEndpoint', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,transportationEndpoint) {


    $scope.event = event.selectedEvent;


    /**
     * Get all the questions that are not in the event
     */
    $scope.getAllTransportation = function () {
        $scope.newTransportation = false;
        transportationEndpoint.get(function (data) {
            $scope.transportation = data;
        })
    };

    /**
     * Save new Transportation
     */
    $scope.saveNewTransportation = function () {
        $scope.isClicked = true;
        eventsEndpoint.transportation.post($scope.event, $scope.newTransportation, function (data) {
            $scope.isClicked=false;
            if(!data.success) {
                Notification.error("לא ניתן לשייך הסעה פעמיים")
            } else {
                $mdDialog.hide();
            }
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


}]);

angular.module('app.pages.events').controller('EditEventQuestionPanelController',EditEventQuestionPanelController)


function EditEventQuestionPanelController($scope,branch,eventQuestion,$rootScope,settlementsEndpoint) {


    var vm = this;
    vm.getSettlements = getSettlements;
    vm.init = init;

    function init(){
        getSettlements();
    }
    /**
     * Set the selected branch
     */
    $scope.$on('selectedEventQuestion:updated', function () {
        vm.question = eventQuestion.selectedEventQuestion;
    });

    /**
     * Look for changes in the branch
     */
    $scope.$watchCollection('vm.question',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'edit-event-question-panel')
    });

    function getSettlements() {
        settlementsEndpoint.get({}, function (data) {
            vm.settlements = data;
        })
    };










}

angular.module('app.pages.events').controller('NewSettlementPriceController', NewSettlementPriceController);

function NewSettlementPriceController($scope, $rootScope, $mdDialog, gradesEndpoint, eventID, eventsEndpoint, Notification, settlementsEndpoint) {


    $scope.newBranchPrice = {};

    $scope.init = function () {
        $scope.getSettlements();
        $scope.getGrades();
    }

    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })
    };

    /**
     * Get Grades
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        })
    };

    /**
     * Save new Event Price
     */
    $scope.saveNewBranchPrice = function () {
        $scope.newBranchPrice.EventID = eventID;
        eventsEndpoint.branches.price.post($scope.newBranchPrice, function (data) {
            Notification.success("מחיר נוסף בהצלחה");
            $mdDialog.hide();
        });
    };
    $scope.selectAllTest = function () {
        var flag = false;
        if (!$scope.newBranchPrice.SettlementID || $scope.newBranchPrice.SettlementID.length != $scope.settlements.length) flag = true;
        $scope.newBranchPrice.SettlementID = [];
        if (flag) {
            $scope.settlements.forEach(function (e) {
                $scope.newBranchPrice.SettlementID.push(e.ID);
            });
        }
    };
    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.event-management').controller('AddNewTransportationToEventController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event) {

    $scope.event = event.selectedEvent;


    /**
     * Add new Transportation
     */
    $scope.addNewTransportation = function () {
        $scope.isClicked = true;
        eventsEndpoint.transportation.post($scope.event, $scope.newTransportation, function (data) {
            $scope.isClicked = false;
            if(!data.success) {
                Notification.error("נכשל בהוספה")
            } else {
                $mdDialog.hide();
            }
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


}]);

angular.module('app.pages.events').controller('NewGroupPriceController',NewGroupPriceController );

function NewGroupPriceController($scope, $rootScope, $mdDialog,groupsEndpoint,eventID,eventsEndpoint,Notification) {


    $scope.newGroupPrice = {};

    $scope.getGroups= function () {
        var params = {};
        params.status = 1;
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        })
    };

    /**
     * Save new Event Price
     */
    $scope.saveNewGroupPrice = function () {
        $scope.newGroupPrice.EventID = eventID;
        eventsEndpoint.groups.price.post($scope.newGroupPrice,function (data) {
            Notification.success("מחיר נוסף בהצלחה");
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewEventFeeController',NewEventFeeController );

function NewEventFeeController($scope, $rootScope, $mdDialog,event,fees,eventsEndpoint,Notification) {


    $scope.newEventFee = {};

    $scope.init = function(){
        $scope.payments = [];
        var maxPayments = event.MaxPaymemnts? event.MaxPaymemnts : 12;
        var existingFees = fees.map(function (fee) {
            return fee.NumOfPayments;
        })
        for(var i = 1; i< maxPayments+1; i++){
            if(existingFees.indexOf(i) === -1)
                $scope.payments.push(i);
        }
    }

    $scope.saveNewEventFee = function () {
        $scope.newEventFee.EventID = event.ID;
        eventsEndpoint.fees.create($scope.newEventFee,function (data) {
            Notification.success("עמלה נוספה בהצלחה");
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewStudentAssociation', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','citiesEndpoint','groupsEndpoint','event','Notification', function ($scope, $rootScope, $mdDialog,eventsEndpoint,citiesEndpoint,groupsEndpoint,event,Notification) {

    $scope.newStudentAssociation = {};

     /**
     * Save new Student
     */
    $scope.saveNewStudentAssociation = function () {
            $scope.isClicked = true;
            eventsEndpoint.association.members.post( $scope.newStudentAssociation,event.selectedEvent,function (data) {
               if(!data.success) {
                   Notification.error('תעודות זהות לא קיימת');
                   $scope.isClicked = false;
               }
               else
                   $mdDialog.hide();
            });

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.student-profile').controller('EducatorGroupsController',EducatorGroupsController);

function EducatorGroupsController($timeout,$location,student,educatorsEndpoint,Notification,$mdDialog) {

    var vm =this;
    vm.updateStatus =updateStatus;
    vm.addNewGroup =addNewGroup;
    vm.openNewEducatorDialog= openNewEducatorDialog;



    /**
     * Reset all params
     */
    var interval = setInterval(function () {
        vm.student= student.selectedStudent;
        if (!vm.student) {
            vm.student = JSON.parse(localStorage.getItem('selectedStudent'));
            if (!vm.student) {
                //$location.path('/students');
                return
            }
        }
        else
            localStorage.setItem("selectedStudent",JSON.stringify(student.selectedStudent));
        clearInterval(interval);
        getGroups();
    },200);


    /**
     * Get educator Groups
     */
    function getGroups(newGroup) {
        vm.educatorGroups = false;
        var educator = {};
        educator.ID =  vm.student.EducatorID;
        if (!educator.ID && !newGroup){
            vm.educatorGroups = [];
            return;
        }
        else if (!educator.ID && newGroup) {
            educator.ID =  vm.student.ID;
            educator.IsStudent =1;
        }
        educatorsEndpoint.groups.get(educator,function (data) {
            vm.educatorGroups =data;
            if (vm.educatorGroups.length>0){
                if (!vm.educatorGroups[0]['Password'] || vm.educatorGroups[0]['Password']==="")
                    vm.showResend = true;
            }
        })
    }

    function updateStatus(group) {
        educatorsEndpoint.groups.update.post(group,function (data) {
            Notification.success("סטטוס עודכן בהצלחה")
        })
    }

    function addNewGroup() {
        $mdDialog.show({
            controller         : 'NewEducatorGroupsController as vm',
            templateUrl        : 'app/main/pages/users/views/students/student-profile/tabs/educator-groups/new-educator-group-dialog/new-educator-group-dialog.html',
            clickOutsideToClose: true
        }).then(function () {
            getGroups(true)
        });
    }

    /**
     * open create new Educator dialog
     */
    function openNewEducatorDialog() {
        $mdDialog.show({
            controller         : 'NewEducatorDialogController',
            templateUrl        : 'app/main/pages/users/views/students/student-profile/new-educator-dialog/new-educator-dialog.html',
            clickOutsideToClose: true
        })
    };




}

angular.module('app.pages.event-management').controller('EventManagementSubscribersController', ['$scope', '$rootScope', '$mdDialog', 'eventsEndpoint', 'student', '$location', 'Notification', 'dtOptions', 'DTOptionsBuilder', 'event', '$timeout', '$mdSidenav', 'groupsEndpoint', 'receiptsService', 'DTColumnDefBuilder', 'settlementsEndpoint', 'coordinatorsEndpoint', 'tranzilaEndpoint', 'pelecardEndpoint', 'appConfig', 'filesService',
    function ($scope, $rootScope, $mdDialog, eventsEndpoint, student, $location, Notification, dtOptions, DTOptionsBuilder, event, $timeout, $mdSidenav, groupsEndpoint, receiptsService, DTColumnDefBuilder, settlementsEndpoint, coordinatorsEndpoint, tranzilaEndpoint, pelecardEndpoint, appConfig, filesService) {

        $scope.search = {
            settlements: [],
            groups: [],
            grades: [],
            coordinators: []
        };

        $scope.groups = [];
        $scope.disableForUser = false;
        $scope.selectedStudentsCount = 0;

        $scope.showbtns = false;
        $scope.months = getMonthList();

        /**
         * Get event subscribers after 250 mils
         */
        $timeout(function () {
            $scope.event = event.selectedEvent;
            if ($scope.event.IsProduct)
                $scope.title = "מוצר";
            else
                $scope.title = $rootScope.User.Event;
            $scope.subscribers = [];
            checkUser();
        }, 250);

        function getMonthList() {
            var months = moment();
            var res = [];
            for (var i = 0; i < 12; i++) {
                res.push({
                    month: months.format('MMMM YYYY'),
                    val: months.format('M/YYYY')
                });
                months.subtract(1, 'month');
            }
            return res;
        }

        function checkUser() {
            if ($rootScope.User.RegistrationClose) {
                var datum = moment(event.selectedEvent.RegistrationEndDate, "DD-MM-YYYY HH:mm").unix() * 1000;
                if (Date.now() > datum)
                    $scope.disableForUser = true;
            }
        }

        $scope.getRegistrationsAmount = function () {
            eventsEndpoint.registrations.amount.get($scope.event, function (data) {
                $scope.registrationAmount = data.RegsAmount;
            });
        }

        /**
         * Get subscribers
         * @param noFilter
         */
        $scope.getSubscribers = function (noFilter) {
            $scope.subscribers = false;
            if (!noFilter) {
                $scope.isClicked = true;
                var params = {};
                if (typeof $scope.event.EventType == "string") {
                    $scope.event.EventType = parseInt($scope.event.EventType);
                }
                if (!$scope.event.EventType) {

                    params.GroupsIdes = $scope.search.groups
                    params.SettlementIdes = $scope.search.Settlements
                    params.GradesIdes = $scope.search.grades
                    params.CoordinatorIdes = $scope.search.coordinators
                    params.Type = $scope.search.educator;
                    params.Refund = $scope.search.Refund;
                    params.Canceled = $scope.search.Canceled;
                    params.PaymentType = $scope.search.PaymentType;
                    params.PaymentStatus = $scope.search.PaymentStatus;
                    params.EventGroup = $scope.search.EventGroup;
                    params.MissingReceipts = $scope.search.MissingReceipts;
                }
                params.FreeSearch = $scope.search.freeSearchFromDB;
                params.RegApproved = $scope.search.RegApproved;
                params.Status = $scope.search.Status;


            } else {
                $scope.subscribers = [];
                $scope.search = {};
                $scope.search.groups = [];
                $scope.search.Canceled = null;
                $scope.search.Status = 1;
                $scope.search.grades = [];
                $scope.search.coordinators = [];
                $scope.search.MissingReceipts = [];
                return;
            }

            $scope.groups = [];
            $scope.selectedStudentsCount = 0;
            eventsEndpoint.subscribers.get(params, $scope.event, function (data) {
                $scope.isClicked = false;
                $scope.subscribers = data;
                $scope.refreshTable = false;
            });
        };

        /**
         * Get all settlements groups
         */
        $scope.getGroups = function () {
            var params = {};
            params.status = 1;
            params.SettlementIdes = $scope.search.Settlements;
            params.GradeIdes = $scope.search.Grade;
            groupsEndpoint.get(params, function (data) {
                $scope.groups = data;
            })
        };

        /**
         * Get Final price of event
         * @param registrationKey
         * @param registrationValue
         */
        $scope.getFinalPrice = function (registrationKey, registrationValue) {
            if (registrationValue.Discount)
                $scope.subscribers[registrationKey].EventPrice = parseInt(registrationValue.Discount) + parseInt(registrationValue.FinalPrice);
            else
                $scope.subscribers[registrationKey].EventPrice = parseInt(registrationValue.FinalPrice);

        };

        $scope.changeBtns = function () {
            $scope.showbtns = !$scope.showbtns;
        }

        $scope.getSettlements = function () {
            settlementsEndpoint.get({}, function (data) {
                $scope.settlements = data;
            })
        }

        /**
         * download Receipt
         * @param receiptID
         * @param type
         */
        $scope.downloadReceipt = function (receiptID, type) {
            Notification.info("מייצר קבלה..אנא המתן");
            receiptsService.getReceiptByID(receiptID, type);

        };


        /**
         * Open the student panel
         * @param selectedStudent
         */
        $scope.openStudentPanel = function (selectedStudent) {
            $mdSidenav("student-panel").open();
            student.updateSelectedStudent(selectedStudent);
        };

        /**
         * Open Cancel Registration Dialog
         * @param registration
         */
        $scope.refundRegistration = function (registration) {

            $mdDialog.show({
                controller: 'RefundRegistrationDialogController',
                templateUrl: 'app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html',
                locals: {'registration': registration, external: false},
                clickOutsideToClose: true
            }).then(function () {
                $scope.getSubscribers();
            });
        };


        /**
         * Open Cancel Registration Dialog
         * @param registration
         */
        $scope.cancelRegistration = function (registration) {

            $mdDialog.show({
                controller: 'CancelRegistrationDialogController',
                templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
                locals: {'registration': registration, external: false},
                clickOutsideToClose: true
            }).then(function () {
                $scope.getSubscribers();
            });
        };

        /**
         * Open create Registration Dialog
         */
        $scope.openNewRegistrationDialog = function () {
            $mdDialog.show({
                controller: 'NewRegistrationDialogController',
                templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/new-registration-dialog/new-registration-dialog.html',
                clickOutsideToClose: false,
                locals: {
                    includePayment: true,
                }
            }).then(function () {
                $scope.getSubscribers();
            });
        };
        /**
         * Open send sms dialog
         */
        $scope.openSendSMS = function () {
            $mdDialog.show({
                controller: 'SMSDialogController',
                templateUrl: 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
                locals: {'students': $scope.subscribers, "type": 1, external: $scope.event.EventType}
            });
        };

        /**
         * Open the send email box
         */
        $scope.openSendEmail = function () {
            $mdDialog.show({
                controller: 'EmailDialogController',
                templateUrl: 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
                locals: {'students': $scope.subscribers, "type": 1, 'external': false}
            });
        };

        /**
         * Set all params
         * @param selectAll
         */
        $scope.setAll = function (selectAll) {
            if (selectAll) {
                for (var i = 0; i < $scope.subscribers.length; i++) {
                    $scope.subscribers[i].Selected = true;
                    $scope.selectedStudentsCount++;
                }
            } else {
                for (var i = 0; i < $scope.subscribers.length; i++) {
                    $scope.subscribers[i].Selected = false;
                }
                $scope.selectedStudentsCountselectedStudentsCount = 0;
            }

        };


        /**
         * Get Payment type by ID
         * @param registrationValue
         */
        $scope.getPaymentType = function (registrationValue) {
            switch (registrationValue.PaymentType) {
                case 0 :
                    registrationValue.PaymentType = "ללא עלות";
                    break;
                case 1 :
                    registrationValue.PaymentType = "אשראי";
                    break;
                case 2 :
                    registrationValue.PaymentType = "מזומן";
                    break;
                case 3 :
                    registrationValue.PaymentType = "העברה בנקאית";
                    break;
                case 4 :
                    registrationValue.PaymentType = "צ'ק";
                    break;
            }
        };

        /**
         * Show full Registration
         * @param registration
         */
        $scope.showFullRegistration = function (registration) {
            $mdDialog.show({
                controller: 'FullRegistrationDialogController',
                templateUrl: 'app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html',
                clickOutsideToClose: true,
                locals: {'registration': registration},
            }).then(function () {
                $scope.getSubscribers();
            });
        };
        $scope.showMonthforReport = function () {
            $mdDialog.show({
                controller: 'MissingMonthReceiptDialog',
                templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/missing-month-receipt-dialog/missing-month-receipt-dialog.html',
                clickOutsideToClose: true,
                locals: {'eventID': event.selectedEvent.ID}
            }).then(function (isSuccess) {
                if (isSuccess) {
                    Notification.success("הפעולה הסתיימה בהצלחה");
                }
            });
        };

        /**
         * Update subscribers
         */
        $rootScope.$on("Registration-Update", function () {
            $scope.getSubscribers();
        });


        /**
         * Update payments status
         */
        $scope.changePaymentsStatus = function () {

            var confirm = $mdDialog.confirm()
                .title('שינוי סטטוס תשלום')
                .textContent('האם אתה בטוח/ה שברצונך לאשר הזמנות אלו?')
                .ok('אישור')
                .cancel('ביטול');
            $mdDialog.show(confirm).then(function () {
                var selectedStudents = [];
                for (var i = 0; i < $scope.subscribers.length; i++) {
                    if ($scope.subscribers[i].Selected === true) {
                        selectedStudents.push($scope.subscribers[i]['ID']);
                    }
                }
                $scope.isClicked = true;
                var params = {};
                params.Registrations = selectedStudents;
                eventsEndpoint.registrations.update.post(params, function (data) {
                    $scope.isClicked = false;
                    if (data.success)
                        Notification.success("הרשמות עודכנו בצלחה");
                    else
                        Notification.error("נכשל בעדכון הרשמות");
                })
            });

        };

        $scope.addMonthlyPayment = function () {
            $mdDialog.show({
                controller: 'NewMonthlyPaymentDialog',
                templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/new-monthly-payment-dialog/new-monthly-payment-dialog.html',
                clickOutsideToClose: true,
                locals: {
                    'registrations': $scope.subscribers.filter(function (sub) {
                        return sub.Selected;
                    }),
                    'RegistrationsMonthlyTransactionID': undefined
                }
            }).then(function () {
                $scope.getSubscribers();
            });
        }

        $scope.groupRefund = function () {
            $mdDialog.show({
                controller: 'GroupRefundRegistrationDialog',
                templateUrl: 'app/main/pages/events-dialogs/group-refund-registration-dialog/group-refund-registration-dialog.html',
                clickOutsideToClose: true,
                locals: {
                    'Subscribers': $scope.subscribers.filter(function (el) {
                        return el.Selected
                    }),
                    'Event': event
                }
            }).then(function () {
                $scope.getSubscribers()
            });
        }

        $scope.getMergedRegFiles = function () {
            Notification.info("מייצר קובץ ..אנא המתן");
            filesService.getEventMergedFies($scope.event.ID)
        }


        $scope.getRegistrationsReport = function () {
            var params = {
                Events: JSON.stringify([$scope.event.ID])
            }
            eventsEndpoint.subscribers.report(params, $scope.event, function (data) {
            })
        }

        jQuery.extend(jQuery.fn.dataTableExt.oSort, {
            "eu-date-pre": function (a) {
                if (a == null || a == '') {
                    return 0;
                }
                var date = a.split('/');
                return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
            }
        });


        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).withOption('type', 'eu-date'),

        ];

        /**
         * Student Count
         * @param student
         */
        $scope.studentToggled = function (student) {
            if (student.Selected)
                $scope.selectedStudentsCount++;
            else
                $scope.selectedStudentsCount--;
        }

        $scope.getCoordinators = function () {
            coordinatorsEndpoint.get({Status: 1}, function (data) {
                $scope.coordinators = data;
                $scope.coordinators.forEach(function (coordinator) {
                    coordinator.Name = coordinator.FirstName + ' ' + coordinator.LastName;
                })
            })
        }

        $scope.testForMonthlyPayments = function () {

            let x = $scope.subscribers.find(function (student) {
                return student.MonthlyTransactionCount > 0;
            });
            return x;
        }

        $scope.approveRegistrations = function () {
            $mdDialog.show({
                controller: 'ApproveRegistrationsDialog',
                templateUrl: 'app/main/pages/events-dialogs/approve-registrations-dialog/approve-registrations-dialog.html',
                clickOutsideToClose: true,
                locals: {
                    'registrations': $scope.subscribers.filter(function (el) {
                        return el.Selected && !el.ApproveDate
                    })
                }
            }).then(function () {
                $scope.getSubscribers();
            });
        }
    }]);

angular.module('app.pages.event-management').controller('EventManagementStatisticsController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event','$timeout', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout) {

    /**
     * Get event Statistics after 250 mils
     */
    $timeout(function () {
        $scope.event = event.selectedEvent;
        $scope.getEventStatistics();
    },250);

    /**
     * Get Event Statistics
     */
    $scope.getEventStatistics = function () {
        $scope.statistics = false;
        if (!$scope.statistics || $scope.refreshTable) {
            var params = {};
            params.EventType = $scope.event.EventType;
            eventsEndpoint.statistics.get(params,$scope.event, function (data) {
                $scope.statistics = data;
                $scope.refreshTable = false;
                $scope.statistics.colors = ['#0DACF4','#D4DCFF','#FFE2D1','#541388'];
                $scope.statistics.options = {
                    legend: {display: true}
                };

            });
        }
    }

}]);

angular.module('app.pages.event-management').controller('EventManagementQuestionsController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event','$timeout','eventQuestion','$mdSidenav', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout,eventQuestion,$mdSidenav) {

    $scope.filters = undefined
    /**
     * Get event Questions after 250 mils
     */
    $timeout(function () {
        $scope.event = event.selectedEvent;
        $scope.getEventQuestions();
    },250);


    /**
     * Get Event Questions
     */
    $scope.getEventQuestions = function () {
        $scope.eventQuestions = false;
        var params = {};
        params.Status = 'ALL';
        if (!$scope.eventQuestions || $scope.refreshTable) {
            eventsEndpoint.questions.get(params,$scope.event, function (data) {
                $scope.eventQuestions = data;
                $scope.filterQuestions();
                $scope.refreshTable = false;
            });
        }
    };


    /**
     * Add existing questions to event
     */
    $scope.addQuestionsToEvent = function () {
        $mdDialog.show({
            controller         : 'AddQuestionsToEventController',
            templateUrl        : 'app/main/pages/events/views/events/event-management/tabs/questions/add-questions-to-event-dialog/add-questions-to-event-dialog.html',
            clickOutsideToClose: true,
        }).then(function () {
            $scope.refreshTable = true;
            $scope.getEventQuestions();
        });
    };

    /**
     * Create a new question and add it to event
     */
    $scope.createNewEventQuestion = function () {
        $mdDialog.show({
            controller         : 'NewQuestionDialogController',
            templateUrl        : 'app/main/pages/events-extras/views/questions/new-question-dialog/new-question-dialog.html',
            clickOutsideToClose: true,
            locals: {
                eventID: $scope.event.ID
            }
        }).then(function () {
            $scope.refreshTable = true;
            $scope.getEventQuestions();
        });
    };

    $scope.filterQuestions = function (){
        $scope.questions = $scope.eventQuestions.filter(function (q){
            return $scope.filters == undefined || q.Status == $scope.filters;
        });
    }

    /**
     * Set Table option
     * @type {any}
     */
/*    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('lengthMenu', [[10000000], ["הכל"]])
        .withDisplayLength(10000000);*/

    /**
     * Change the question Type
     * @param question
     */
    $scope.changeQuestionStatus = function (question) {
        if(question.Status == 1) {
            eventsEndpoint.questions.unlink.post($scope.event, question, function (data) {
                if(!data.success) {
                    Notification.error("נכשל בביטול שיוך")
                } else {
                    question.Status = 0;
                }
            })
        } else {
            eventsEndpoint.questions.relink.post($scope.event, question, function (data) {
                if(!data.success) {
                    Notification.error("נכשל בהוספת שיוך")
                } else {
                    question.Status = 1;
                }
            })
        }
    };

    /**
     * Set Type
     * @param type
     * @returns {string}
     */
    $scope.setType = function(type) {
        switch (type) {
            case "1":
            case 1:
                return "שאלה פתוחה";
            case "2":
            case 2:
                return "אפשרויות";
            case "3":
            case 3:
                return "קובץ";
            case "4":
            case 4:
                return "תאריך";
            case "5":
            case 5:
                return "צ'ק בוקס";
        }
    };



    $scope.openEventQuestionPanel = function (selectedQuestion) {
        eventQuestion.updateSelectedEventQuestion(selectedQuestion);
        $mdSidenav("edit-event-question-panel").open();
    }

}]);

angular.module('app.pages.event-management').controller('EventManagementTransportationController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event','$timeout', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout) {


    $scope.firstTime= false;

    /**
     * Get the event Transportation after 250 mils
     */
    $timeout(function () {
        $scope.event = event.selectedEvent;
        $scope.getEventTransportation();
        },250);

    /**
     * Get all events Transportation
     */
    $scope.getEventTransportation = function (newEvent) {
        $scope.event = event.selectedEvent;
        if (newEvent || $scope.firstTime===false) {
            $scope.firstTime= true;
            $scope.eventTransportation = false;
            eventsEndpoint.transportation.get($scope.event, function (data) {
                $scope.eventTransportation = data;
            })
        }
    };

    /**
     * Add Transportation to event
     */
    $scope.addTransportationToEvent = function () {
        $mdDialog.show({
            controller         : 'AddTransportationToEventController',
            templateUrl        : 'app/main/pages/events/views/events/event-management/tabs/transportation/add-transportation-to-event-dialog/add-transportation-to-event-dialog.html',
            clickOutsideToClose: true,
            locals: {
                eventID: $scope.event.ID
            }
        }).then(function () {
            $scope.getEventTransportation(true);
        });
    };

    /**
     * Add new Transportation dialog
     */
    $scope.addNewTransportationToEvent = function () {
        $mdDialog.show({
            controller         : 'AddNewTransportationToEventController',
            templateUrl        : 'app/main/pages/events/views/events/event-management/tabs/transportation/add-new-transportation-to-event-dialog/add-new-transportation-to-event-dialog.html',
            clickOutsideToClose: true,
            locals: {
                eventID: $scope.event.ID
            }
        }).then(function () {
            $scope.getEventTransportation(true);
        });
    };

    /**
     * Change the Transportation Type
     * @param transportation
     */
    $scope.changeTransportationStatus = function (transportation) {
        transportation.Status = transportation.Status == 1? 0 : 1;
        eventsEndpoint.transportation.update.post($scope.event, transportation, function (data) {
            if(!data.success) {
                Notification.error("נכשל בעדכון")
            }
        })
    };

}]);

angular.module('app.pages.event-management').controller('EventDiscountsController', EventDiscountsController);
function EventDiscountsController($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout,$mdSidenav,generalDiscount, eventsEndpoint) {

    $scope.event = event.selectedEvent;
    $scope.filterg = 1;
    $scope.filters = 1;
    /**
     * Get Event Discount after 350 mils
     */
    $timeout(function () {
        $scope.getEventDiscounts();
    }, 350);


    /**
     * Get event discounts template file
     */

    $scope.downloadEventsDiscountsTemplateFile = function(){
        eventsEndpoint.discounts.student.emptyTemplate.get(function(data){

        });

    }

    /**
     * Get event discounts from API
     */
    $scope.getEventDiscounts = function () {

        $rootScope.discountsLoading = true;
        eventsEndpoint.discounts.get($scope.event, function (data) {
            $scope.FamilyLevelDiscount = data.FamilyLevelDiscount;
            $scope.BrotherDiscount = data.BrotherDiscount;
            $scope.RegistrationDiscount = data.RegistrationDiscount;
            $scope.GeneralDiscount = data.GeneralDiscount;
            $scope.StudentDiscount = data.StudentDiscount;
            $scope.DatesDiscounts = data.DateDiscount;
            $rootScope.discountsLoading = false;
        });
    };

    /**
     * Set the selected tab index
     * @param tab
     */
    $scope.setTab = function (tab) {
        //$scope.selectedTab = tab;
    }

    /******************************************************************* Brother Discounts Start *******************************************************************/

    $scope.addNewBrotherDiscount = function () {
        $mdDialog.show({
            controller: 'NewBrotherDiscountDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-brother-discount-dialog/new-brother-discount-dialog.html',
            clickOutsideToClose: false,
            locals: {
                brotherCount: $scope.BrotherDiscount.length + 1
            }
        }).then(function () {
            $scope.overWrite = true;
            $scope.getEventDiscounts();
        });
    };

    /******************************************************************* Brother Discounts End *******************************************************************/

    /******************************************************************* Registration Discounts Start *******************************************************************/

    $scope.addNewRegistrationDiscount = function () {
        $mdDialog.show({
            controller: 'NewRegistrationDiscountDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-registration-discount-dialog/new-registration-discount-dialog.html',
            clickOutsideToClose: false,
            locals: {
                registrationCount: $scope.RegistrationDiscount.length + 2
            }
        }).then(function () {
            $scope.overWrite = true;
            $scope.getEventDiscounts();
        });
    };

    /******************************************************************* Brother Discounts End *******************************************************************/


    /******************************************************************* General Discounts *******************************************************************/

    /**
     * Get the updated when the discount is saved
     */
    $scope.$on('isSave:updated', function () {
        $scope.getEventDiscounts();
    });

    /**
     * Edit general discount
     * @param selectedGeneralDiscount
     */
    $scope.editGeneralDiscount = function (selectedGeneralDiscount) {
        $mdSidenav("general-discount-panel").open();
        generalDiscount.updateSelectedGeneralDiscount(selectedGeneralDiscount);
    };

    /**
     * Open a dialog for new general discount creation
     */
    $scope.createNewGeneralDiscount = function () {
        $mdDialog.show({
            controller: 'NewGeneralDiscountDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-general-discount-dialog/new-general-discount-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getEventDiscounts();
        });
    };

    $scope.changeStatus = function (discountValue) {
        var params = {};
        params.EventID = discountValue.EventID;
        params.ID = discountValue.ID;
        if (discountValue.Status == 1)
            params.Status = 0;
        else
            params.Status = 1;

        $scope.isClicked = true;
        eventsEndpoint.discounts.general.status.post(params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.error("נכשל");
            else {
               $scope.GeneralDiscount.forEach(function(ele){
                   if(ele.ID == params.ID){
                       ele.Status = params.Status;
                   }
               });
            }
        });

    };


    /************ General Discounts End *****************/


    /******************************************************************* Student Discounts Start *******************************************************************/

    /**
     * Open the dialog for a new student discount creation
     */
    $scope.createNewStudentDiscount = function () {
        $mdDialog.show({
            controller: 'NewStudentDiscountDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-student-discount-dialog/new-student-discount-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getEventDiscounts();
        });
    };
    /**
     * Switches the status of the student discount
     * @param discount
     */
    $scope.changeStudentDiscountStatus = function (discount) {
        discount.Status = !discount.Status;
    };


    /******************************************************************* Student Discounts End *******************************************************************/

    /******************************************************************* Date Discounts Start *******************************************************************/

    /**
     * Open the dialog for a new student discount creation
     */
    $scope.createNewDateDiscount = function () {
        $mdDialog.show({
            controller: 'NewDateDiscountDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-date-discount-dialog/new-date-discount-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getEventDiscounts();
        });
    };

    $scope.$watch('DatesDiscounts', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newVal, oldVal, 'date-discount-view');
    }, true);

    /******************************************************************* Date Discounts End *******************************************************************/

    /******************************************************************* SAVE CHANGES *******************************************************************/

    /**
     * Look for changes in the student discount
     */
    $scope.$watch('StudentDiscount', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newVal, oldVal, 'student-discount-view');
    }, true);

    /**
     * Look for changes in the fmily discount
     */
    $scope.$watch('FamilyLevelDiscount', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newVal, oldVal, 'family-level-view');
    }, true);

    /**
     * Look for changes in the Brother discount
     */
    $scope.$watch('BrotherDiscount', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function') {
            $rootScope.editDataHandler(newVal, oldVal, 'brother-discount-view', $scope.overWrite);
            if ($scope.overWrite)
                $scope.overWrite = false;
        }

    }, true);

    /**
     * Look for changes in the Registration discounts
     */
    $scope.$watch('RegistrationDiscount', function (newVal, oldVal) {
        if (typeof $rootScope.editDataHandler === 'function') {
            $rootScope.editDataHandler(newVal, oldVal, 'registration-discount-view', $scope.overWrite);
            if ($scope.overWrite)
                $scope.overWrite = false;
        }

    }, true);

    $scope.uploadExcelFile = function () {
        $mdDialog.show({
            controller         : 'UploadController',
            templateUrl        : 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'events',
                uploadID: $scope.event.ID+"/discount/students",
                restrictTo: ['xlsx','csv']
            }
        }).then(function () {
           $scope.getEventDiscounts();
        });
    }

}

angular.module('app.pages.event-management').controller('EventManagementFilesController', ['$scope', '$rootScope', '$mdDialog','eventsEndpoint','student','$location','Notification','dtOptions','DTOptionsBuilder','event','$timeout', function ($scope, $rootScope, $mdDialog,eventsEndpoint,student,$location,Notification,dtOptions,DTOptionsBuilder,event,$timeout) {

    $scope.finishedLoading = false;
    $scope.reset = false;

    /**
     * Get Events files after 250 mils
     */
    $timeout(function () {
        $scope.getEventFiles();
        $scope.getEventHealthDeclarationSchedulers();
    },250);


    /**
     * Get event files from API
     */
    $scope.getEventFiles = function () {
        $scope.activeModule = event.getActiveModule();
        $scope.eventFiles = false;
        $scope.event = event.selectedEvent;
        $timeout(function () {
            if(!$scope.eventFiles || $scope.eventFiles.length===0) {
                eventsEndpoint.files.get($scope.event, function (data) {
                    if(data) {
                        $scope.eventFiles = data;
                        angular.forEach($scope.eventFiles, function (file, key) {
                            file.Icon = getFileIcon(file);
                            file.Type = getFileType(file);
                            file.selectedBranches = [];
                            angular.forEach(file.Branches, function (branch, key) {
                                if(branch.Active===1) {
                                    file.selectedBranches.push(branch);
                                }
                            });
                            file.selectedSettlements = [];
                            angular.forEach(file.Settlements, function (settlement, key) {
                                if(settlement.Active===1) {
                                    file.selectedSettlements.push(settlement);
                                }
                            });
                        });
                        $scope.finishedLoading = true;
                    }
                });
            }
        },200)

    };

    $scope.getEventHealthDeclarationSchedulers = function(){
        eventsEndpoint.files.healthDeclaration.scheduler.get($scope.event.ID,function(data){
           $scope.eventHealthDeclarationSchedulers = data;
        });
    }

    $scope.addNewScheduler = function (){
        if(!Array.isArray($scope.eventHealthDeclarationSchedulers))
            $scope.eventHealthDeclarationSchedulers = [];
        var tempScheduler = {
            EventID: $scope.event.ID,
            Interface: 3,
            Addressee: $scope.event.EventType == 0? 3 : 1,
            Status: 1,
            Timestamp: $scope.event.StartDate,
        }
        eventsEndpoint.files.healthDeclaration.scheduler.post(tempScheduler,function(data){
            if(data.ID)
                $scope.eventHealthDeclarationSchedulers.push(data);
            else
                Notification.error('התרחשה שגיאה');
        });
    }

    $scope.saveScheduler = function(scheduler){
        eventsEndpoint.files.healthDeclaration.scheduler.update.post(scheduler,function(data){
            if(data.success)
                Notification.success('עודכן בהצלחה');
            else
                Notification.error('התרחשה שגיאה');
        })
    }

    /**
     * A call to files uploading controller
     */
    $scope.uploadNewFileToEvent = function () {
        //if (checkIfAllFilesHaveBranches())
            $mdDialog.show({
                controller         : 'UploadController',
                templateUrl        : 'app/upload/upload.html',
                clickOutsideToClose: false,
                locals: {
                    uploadTo: 'events',
                    uploadID: $scope.event.ID,
                    restrictTo: ['pdf']
                }
            }).then(function () {
                $scope.eventFiles = [];
                $scope.reset = true;
                $scope.getEventFiles();
            });
        //else Notification.error("לא ניתן להוסיף קובץ חדש. יש לשייך את כל הקבצים הקיימים תחילה לסניף אחד לפחות")
    };


    $scope.uploadHealthDeclarationFile = function () {
            $mdDialog.show({
                controller         : 'UploadController',
                templateUrl        : 'app/upload/upload.html',
                clickOutsideToClose: false,
                locals: {
                    uploadTo: 'events',
                    uploadID: $scope.event.ID + '/health-declaration',
                    restrictTo: ['pdf']
                }
            }).then(function(){
                eventsEndpoint.files.healthDeclaration.get($scope.event,function(data){
                    $scope.event.healthDeclaration = data.File;
                })
            })
    };


    function checkIfAllFilesHaveBranches() {
        var flag = true;
        angular.forEach($scope.eventFiles, function (file, key) {
           if (file.selectedBranches.length===0 && file.Status==1)
               flag = false;
        });

        return flag;
    }

    /**
     * Look for changes in the event files
     */
    $scope.$watch('eventFiles', function (newVal,oldVal) {
        if(typeof $rootScope.editDataHandler === 'function' && $scope.finishedLoading)
            $rootScope.editDataHandler(newVal,oldVal,'event-files-view',$scope.reset);
        if ($scope.reset)
            $scope.reset = !$scope.reset;
    },true);


    /**
     * Get the icon name for md-icon by file extension
     * @param file
     * @returns {string}
     */
    var getFileIcon = function (file) {
        var ext = getFileType(file),
            doc = ['doc','docx','docm'],
            xls = ['xls','xlsx','xlsm'],
            pdf = ['pdf'],
            icon = '';

        if(doc.indexOf(ext) != '-1')
            icon = 'icon-file-word';
        else if (xls.indexOf(ext) != '-1')
            icon = 'icon-file-excel';
        else if (pdf.indexOf(ext) != '-1')
            icon = 'icon-file-pdf';
        else
            icon = 'icon-file';
        return icon;
    };

    /**
     * Get the file extension
     * @param file
     * @returns {string}
     */
    var getFileType = function (file) {
        return file.Path.substr(file.Path.lastIndexOf('.')+1)
    };


    $scope.viewFile = function(file) {
        window.open( file);
    }

    $scope.generate24Hours = function(){
        arr = [];
        for (var i = 1; i <= 24; i++)
            arr.push(i);
        return arr;
    }



}]);

angular.module('app.pages.users').controller('NewCoordinatorEventDialogController', ['$scope', '$rootScope', '$mdDialog', 'coordinatorsEndpoint', 'eventsEndpoint', 'Notification','$timeout', 'coordinatorID',
    function ($scope, $rootScope, $mdDialog, coordinatorsEndpoint, eventsEndpoint, Notification,$timeout, coordinatorID) {

        $scope.newEvent = {};
        /**
         * Save new CoordinatorEvent
         */
        $scope.saveNewCoordinatorEvent = function () {
            $scope.isClicked = true;
            coordinatorsEndpoint.events.post(coordinatorID, {EventID: $scope.newEvent.eventID}, function (data) {
                $scope.isClicked = false;
                if (data.success)
                    Notification.success("מאורע שוייך בהצלחה")
                else
                    Notification.error("התרחשה שגיאה")

                $mdDialog.hide();
            })

        };

        $scope.eventKeyPress = function (event) {
            var currentState = event.target.value;
            $timeout(function () {
                if (currentState != undefined && currentState.length > 0 && currentState == event.target.value)
                    $scope.getEvents(currentState);
            }, 1000)
        }

        /**
         * Get Events
         */
        $scope.getEvents = function (name) {
            var params = {
                Status: 1,
                Master: 0,
                FreeSearch: name
            };
            eventsEndpoint.get(params, function (data) {
                $scope.events = data;
            })
        }

        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

    }]);

angular.module('app.pages.users').controller('NewParentDialogController', ['$scope', '$rootScope', '$mdDialog','studentsEndpoint','student','$location','Notification',
    function ($scope, $rootScope, $mdDialog,studentsEndpoint,student,$location,Notification) {

        /**
         * Save new Student
         */
        $scope.saveNewParent = function () {
                $scope.isClicked =true;
                studentsEndpoint.parent.post(student.selectedStudent,$scope.newParent,function (data) {
                        $scope.isClicked =false;
                        if (data.ID)
                            $mdDialog.hide();
                        else
                            Notification.info("נכשל ביצירה : דואר אלקטרוני/תועדה מזהה/דרכון קיימים במערכת")

                })
        };

        $scope.ChangeToPassport = function () {
                $scope.tz=!$scope.tz
        };

        /**
         * Close the dialog
         */
        $scope.closeDialog =function () {
            $mdDialog.cancel();
        };

        $scope.pattern = function () {
                if (!$scope.tz)
                        return "/^[0-9]{9,9}$/";
                return "";
        };

        $scope.changeShowMore =function () {
                $scope.more=!$scope.more;

        };

        $scope.relations =['אמא','אבא','סבא','סבתא','אפוטרופוס']


}]);

angular.module('app.pages.users').controller('NewEducatorDialogController', ['$scope', '$rootScope', '$mdDialog','studentsEndpoint','student','$location','Notification', function ($scope, $rootScope, $mdDialog,studentsEndpoint,student,$location,Notification) {


    $scope.newEducator = {};
    $scope.newEducator.Email = angular.copy(student.selectedStudent.Email);

    /**
     * Save new Student
     */
    $scope.sendInvitationToNewEducator = function () {
        $scope.isClicked =true;
        studentsEndpoint.educator.post(student.selectedStudent,$scope.newEducator,function (data) {
            $scope.isClicked =false;
            if (!data.success)
                Notification.info("דואר אלקטרוני קיים עבור משתמש אחר");

            $mdDialog.hide();

        })
    };





    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };



}]);

angular.module('app.pages.activities-profile').controller('SendActivityHealthDeclarationController', SendActivityHealthDeclarationController)

function SendActivityHealthDeclarationController($scope, $rootScope, $mdDialog, activitiesEndpoint, Notification,activity,meeting) {

    $scope.newHealthDeclarationMessage = {
        ActivityID: activity.ID,
        Students: []
    }

    $scope.getStudents = function (){
        $scope.isClicked = true;
        activitiesEndpoint.students.get(activity,meeting,function (data){
            $scope.students = data;
            $scope.newHealthDeclarationMessage.students = $scope.students.map(function(student){
                return student.ID;
            })
            $scope.isClicked = false;
        })
    }



    /**
     * Save new meeting
     */
    $scope.sendMessages = function () {
        $scope.isClicked = true;
        var params = Object.assign({},$scope.newHealthDeclarationMessage);
        params.Students = JSON.stringify(params.students);
        activitiesEndpoint.meetings.healthDeclaration.post($scope.newHealthDeclarationMessage.ActivityID,meeting.ID,params, function (data) {
            $scope.isClicked = false;
            if (!data.success) {
                Notification.info("שגיאה");
            } else {
                Notification.success("הודעות נשלחו בהצלחה");
            }
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

(function ()
{
    'use strict';

    angular
        .module('app.pages.settings_menu', []).config(config).run(run);

    function run($rootScope,msNavigationService) {
        $rootScope.$watch('User',function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel) {
                if ($rootScope.User.SuperAdmin==1) {
                    msNavigationService.saveItem('pages.settings_menu', {
                        title : 'הגדרות מערכת',
                        icon  : 'icon-cog',
                        weight: 5
                    });

                    msNavigationService.saveItem('pages.settings_menu.settings_menu_general-settings', {
                        title : 'כללי',
                        icon  : 'icon-monitor',
                        state : 'app.pages_settings_menu_general-settings'

                    });
                    msNavigationService.saveItem('pages.settings_menu.settings_menu_accountancy-settings', {
                        title : 'הנהלת חשבונות',
                        icon  : 'icon-cash-100',
                        state : 'app.pages_settings_menu_accountancy-settings'

                    });
                    msNavigationService.saveItem('pages.settings_menu.settings_menu_admin-settings', {
                        title : 'מערכת ניהול',
                        icon  : 'icon-laptop-mac',
                        state : 'app.pages_settings_menu_admin-settings'

                    });
                    msNavigationService.saveItem('pages.settings_menu.settings_menu_profile-settings', {
                        title : 'פרופיל הורה',
                        icon  : 'icon-account',
                        state : 'app.pages_settings_menu_profile-settings'

                    });
                    msNavigationService.saveItem('pages.settings_menu.settings_menu_external-registrations-settings', {
                        title : 'הרשמות חיצוניות',
                        icon  : 'icon-account-box-outline',
                        state : 'app.pages_settings_menu_external-registrations-settings'
                    });
                    msNavigationService.saveItem('pages.settings_menu.categories', {
                        title: 'ניהול קטגוריות',
                        icon: 'icon-apps',
                        state: 'app.pages_settings_categories',
                    });
                    msNavigationService.saveItem('pages.settings_menu.locations', {
                        title: 'ניהול אולמות',
                        icon: 'icon-bank',
                        state: 'app.pages_settings_locations',
                    });
                }
            }
        });

    }
    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pages.settings_menu', {
                abstract: true,
                url     : '/settings_menu'
            })
            .state('app.pages_settings_menu_general-settings', {
                url      : '/general-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/general-settings/general-settings.html',
                        controller : 'GeneralSettingsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/general-settings');
                    }
                }
            })
            .state('app.pages_settings_menu_accountancy-settings', {
                url      : '/accountancy-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/accountancy-settings/accountancy-settings.html',
                        controller : 'AccountancySettingsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/accountancy-settings');
                    }
                }
            })
            .state('app.pages_settings_menu_admin-settings', {
                url      : '/admin-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/admin-settings/admin-settings.html',
                        controller : 'AdminSettingsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/admin-settings');
                    }
                }
            })
            .state('app.pages_settings_menu_profile-settings', {
                url      : '/profile-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/profile-settings/profile-settings.html',
                        controller : 'ProfileSettingsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/profile-settings');
                    }
                }
            })
            .state('app.pages_settings_menu_external-registrations-settings', {
                url      : '/external-registrations-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/external-registrations-settings/external-registrations-settings.html',
                        controller : 'ExternalRegistrationsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/external-registrations');
                    }
                }
            })
            .state('app.pages_settings_categories', {
                url: '/events-categories',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/categories/categories.html',
                        controller: 'EventsCategoriesController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/events-categories');
                    }
                },
                bodyClass: 'events'

            })
            .state('app.pages_settings_locations', {
                url: '/locations',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/locations/locations.html',
                        controller: 'LocationsController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/events-locations');
                    }
                },
                bodyClass: 'events'

            })



    }
})();


angular.module('app.pages.settings_menu').controller('NewTagDialogController', ['$scope', '$rootScope', '$mdDialog', 'Notification', 'tagsEndpoint',
    function ($scope, $rootScope, $mdDialog, Notification, tagsEndpoint) {

        $scope.newTag = {};

        /**
         * Save new Student
         */
        $scope.saveNewTag = function () {
            $scope.isClicked = true;
            tagsEndpoint.create.post($scope.newTag, function (data) {
                if (!data.success) {
                    Notification.error('התרחשה שגיאה');
                    $scope.isClicked = false;
                } else
                    $mdDialog.hide();
            });

        };

        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

    }]);

angular.module('app.pages.events').controller('AccountsPopupController', AccountsPopupController);

function AccountsPopupController($scope, $rootScope, $mdDialog, appConfig, systemSettingsEndpoint, eventsEndpoint, $location, Notification, event, $timeout, organizationsEndpoint, settingsEndpoint, msNavigationService, locationsEndpoint, Terminal, Upload) {

    $scope.init = function () {
        $scope.Terminal = Terminal;
        $scope.getAccountancySettings();
        $scope.isClicked = false;
    };
    $scope.getAccountancySettings = function () {
        settingsEndpoint.accountancy.getByTerminal($scope.Terminal, function (data) {
            $scope.accountancy = data;
            $scope.terminalManagement = data.TerminalManagment;
        });
    }

    $scope.updateAccountancy = function () {
        $scope.isClicked = true;
        $scope.accountancy.TerminalID = $scope.Terminal.ID;
        $scope.accountancy.TerminalManagment = 1;
        settingsEndpoint.accountancy.post($scope.accountancy, function (data) {
            $scope.isClicked = false;
            if (data.success) {
                Notification.success("הפרטים עדוכונו בהצלחה");
            }
        })
    }
    /**
     * Close the dialog
     */

    $scope.addBank = function () {
        if (!$scope.accountancy.Banks) {
            $scope.accountancy.Banks = [];
        }
        $scope.accountancy.Banks.push({Name: '', Code: '', Number: ''});
    };
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

///////////////////////

    $scope.systemSettings = {};


    /**
     * Get System Settings
     */
    $scope.getSystemSettings = function () {
        systemSettingsEndpoint.names.get(function (data) {
            $scope.systemSettings = data;
            $scope.extractFileName(data.BrandLogo)

        }, $scope.Terminal['ID']);
    };


    $scope.viewFile = function (file) {
        window.open(file);
    }

    $scope.extractFileName = function (fileName) {
        if (!fileName || fileName === '') {
            $scope.filename = '';
            return;
        }
        var split = fileName.split('/');
        $scope.filename = split[split.length - 1];
    };
    /**
     * update SystemSettings
     */
    $scope.updateSystemSettings = function () {
        var params = {};
        params.Names = $scope.systemSettings;
        params.TerminalID = $scope.Terminal['ID'];
        $scope.isClicked = true;
        systemSettingsEndpoint.names.post(params, function (data) {
            $scope.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        })
    }

    $scope.viewFile = function (file) {
        window.open(file);
    }

    /**
     * Get Admin Images
     */
    $scope.getAdminImages = function () {
        settingsEndpoint.admin.images.get(function (data) {
            $scope.adminImages = data;
        })
    }

    /**
     * Update Admin Images
     */
    $scope.updateAdminImageSettings = function () {
        $scope.isClicked = true;
        var params = {};
        params.Images = $scope.adminImages;
        settingsEndpoint.admin.images.post(params, function (data) {
            Notification.success("פרטים עודכנו בהצלחה");
            $scope.isClicked = false;

        })
    }


    /**
     * UploadFile
     * @param file
     */
    $scope.uploadFile = function (file) {
        if (!file)
            return;
        var maxAllowedSize = 1024 * 1024;
        if (file.size > maxAllowedSize) {

            return;
        }
        $scope.isClicked = true;
        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else
            uploadURL = appConfig.serverUrl + '/upload/files?brand=' + $rootScope.brandName;

        var headers = {};
        headers.Authorization = 'Bearer ' + $rootScope.User.AccessToken;
        Upload.upload({
            url: uploadURL,
            headers: headers,
            data: {
                file: file,
            }
        }).then(function (resp) {

            $scope.isClicked = false;
            $scope.systemSettings.BrandLogo = resp.data.Path;
            $scope.extractFileName(resp.data.Path);
            // image.Value = resp.data.Path;
        }, function (resp) {
            console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage);
        });


    }
}

angular.module('app.pages.settings_menu').controller('AccountPopupController', AccountPopupController);

function AccountPopupController($scope, $rootScope, $mdDialog, settingsEndpoint, Terminal, Notification) {

    var vm = this;

    vm.getAccountancySettings = getAccountancySettings;
    vm.getAccountancyTerminals = getAccountancyTerminals;
    vm.updateAccountancy = updateAccountancy;
    vm.addBank = addBank;
    vm.addNewTerminal = addNewTerminal;
    vm.checkTerminalsValidity = checkTerminalsValidity;
    vm.checkSingleDefaultTerminal = checkSingleDefaultTerminal;
    vm.updateAccountancyTerminals = updateAccountancyTerminals;
    vm.terminalManagement = 1;
    vm.Terminal = Terminal;

    vm.init = init;
    vm.init()

    function init() {
        vm.getAccountancySettings();
    }

    /**
     * Get Accountancy Settings
     */
    function getAccountancySettings() {
        settingsEndpoint.accountancy.getByTerminal(vm.Terminal, function (data) {
            vm.accountancy = data;
            vm.terminalManagement = data.TerminalManagment;
        });
    }


    /**
     * Update Accountancy
     */

    function updateAccountancy() {
        vm.isClicked = true;
        settingsEndpoint.accountancy.post(vm.accountancy, function (data) {
            vm.isClicked = false;
            if (data.success)
                Notification.success("הפרטים עדוכונו בהצלחה")
        })
    }

    /**
     * Add New Bank
     */
    function addBank() {
        var newBank = {};
        newBank.Name = '';
        newBank.Code = '';
        newBank.Number = '';
        vm.accountancy.Banks.push(newBank);
    }

    //----------------------------------------------TERMINALS---------------------------------------------------------//

    /**
     * get terminals
     */
    function getAccountancyTerminals() {
        settingsEndpoint.accountancy.terminals.get(function (data) {
            vm.terminals = data
        });
    }

    function updateAccountancyTerminals() {
        vm.isClicked = true;
        settingsEndpoint.accountancy.terminals.post({Terminals: vm.terminals}, function (data) {
            vm.isClicked = false;
            if (data.success) {
                Notification.success("המסופים עדוכונו בהצלחה")
                vm.terminals = data.data;
            }
        });
    }

    function checkTerminalsValidity() {
        var fields = ['Name', 'TerminalID', 'TerminalUser', 'TerminalPassword'];
        var fieldsValidity = vm.terminals && vm.terminals.reduce(function (acc, terminal) {
            return acc && fields.reduce(function (acc2, field) {
                return acc2 && terminal[field].length > 0;
            }, true);
        }, true);
        return fieldsValidity && checkSingleDefaultTerminal();
    }

    /**
     *
     * @returns {boolean}
     */
    function checkSingleDefaultTerminal() {
        var defaultTerminalsAmount = vm.terminals.reduce(function (acc, terminal) {
            return acc + terminal.IsDefaultTerminal;
        }, 0)
        return defaultTerminalsAmount == 1;
    }

    /**
     *
     */
    function addNewTerminal() {
        vm.terminals.push({
            Name: '',
            TerminalID: '',
            TerminalUser: '',
            TerminalPassword: '',
            IsDefaultTerminal: checkSingleDefaultTerminal() ? 0 : 1
        })
    }

    $scope.$watch('vm.accountancy', function (newValue, oldValue) {

        $rootScope.editDataHandler(newValue, oldValue, 'accountancy-panel')
    }, true);
}

angular.module('app.pages.users').controller('ParentPanelController', ['$scope','parent','$rootScope', function($scope,parent,$rootScope) {

    $scope.$on('selectedParent:updated', function() {
        $scope.parent= parent.selectedParent;
    });
    $scope.$watchCollection('parent',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'parent-panel')
    });

    $scope.relations =['אמא','אבא','אחר']



}]);
angular.module('app.pages.users').controller('NewReportDialogController', NewReportDialogController);

function NewReportDialogController($scope, $rootScope, settlementsEndpoint, reportsEndpoint, groupsEndpoint, gradesEndpoint, Notification, $mdDialog, eventsEndpoint, $timeout, $element, activitiesEndpoint, event) {

    $scope.report = {};

    /**
     * Get Fields By Report Type
     */
    $scope.getFields = function () {
        var params = {
            Status: 1
        };
        $scope.getGrades();
        $scope.getSettlements();
        $scope.getEventCategories();

        /*if ($scope.report.Type > 7 && !$scope.events)
            $scope.getEvents();*/
        $scope.fields = false;
        $scope.report.Settlements = null;
        $scope.report.Groups = null;
        $scope.report.Grades = null;
        $scope.report.Status = null;
        $scope.report.Canceld = null;
        $scope.report.Fields = null;
        $scope.report.endDate = moment().format('DD/MM/YYYY');
        $scope.report.startDate = moment().startOf('year').format('DD/MM/YYYY');
        $scope.report.Events = null;
        $scope.report.Categories = null;
        $scope.report.Gender = null;
        $scope.report.extraFields = null;
        reportsEndpoint.fields.get($scope.report.Type, function (data) {
            $scope.fields = data;
        });

    };

    /***
     * Get Group By settlement
     */
    $scope.getGroups = function () {
        var params = {};
        params.SettlementIdes = [];
        var settlements = angular.copy($scope.report.Settlements);
        params.SettlementIdes = settlements.map(function (settlement) {
            return settlement.ID;
        })
        params.SettlementIdes = JSON.stringify(params.SettlementIdes);
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        })
    };

    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })
    }

    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };


    $scope.addToReportEvents = function (value) {
        if (!$scope.report.Events) {
            $scope.report.Events = [];
        }
        $scope.report.Events = $scope.report.Events.filter(function (event) {
            return value.ID != event.ID;
        });
        $scope.report.Events.push(value);
    }


    $scope.getEventCategories = function () {
        eventsEndpoint.categories.eventsCategories({BottomUp: 1}, function (data) {
            $scope.categories = data;
        })
        /*eventsEndpoint.categories.get({calendar: true, EventsCount: true, AsArray: true}, function (data) {
            $scope.categories = data.filter(function (category) {
                return category.EventsCount > 0;
            });
            $scope.categories.forEach(function (category) {
                category.Path.reverse();
            })
        })*/
    }

    $scope.removeFromReportEvents = function (eventToRemove) {
        $scope.report.Events = $scope.report.Events.filter(function (event) {
            return eventToRemove.ID != event.ID;
        })
    }


    $scope.eventKeyPress = function (event) {
        var currentState = event.target.value;
        $timeout(function () {
            if (currentState != undefined && currentState.length > 0 && currentState == event.target.value)
                $scope.getEvents(currentState);
        }, 1000)
    }
    /**
     * Get all events
     */
    $scope.getEvents = function (searchTerm) {
        var params = {};
        params.Limit = 10000;
        if ($scope.report.Type == 13)
            params.EventType = 1;
        params.FreeSearch = searchTerm;
        if ($scope.report.Categories && $scope.report.Categories.length) {
            var modules = event.modulesMap;
            modules = Object.values(modules).filter(function (module) {
                return $scope.report.Categories.indexOf(module.masterCategoryID) != -1;
            }).map(function (module) {
                return module.name;
            });
            params.GeneralEventTypes = modules;
        }
        eventsEndpoint.get(params, function (data) {
            $scope.events = data.map(function (event) {
                return {ID: event.ID, Name: event.Name};
            });
        });
    };

    $scope.getActivities = function () {
        var params = {};
        params['Groups'] = $scope.report.Groups;
        params['Grades'] = $scope.report.Grades;
        activitiesEndpoint.get(params, function (data) {
            $scope.activities = data;
        })
    };

    /**
     * Save new report
     * @param exportReport
     * @param dontSave
     */
    $scope.saveNewReport = function (exportReport, dontSave) {
        $scope.report.Export = !!exportReport;
        $scope.report.DontSave = !!dontSave;
        var params = angular.copy($scope.report);
        params.Settlements = JSON.stringify(params.Settlements);
        params.Groups = JSON.stringify(params.Groups);
        if (Array.isArray(params.Events))
            params.Events = params.Events.map(function (event) {
                return event.ID;
            });
        else
            params.Events = [];
        params.Events = JSON.stringify(params.Events);

        params.Grades = JSON.stringify(params.Grades);
        params.Fields = JSON.stringify(params.Fields);
        params.Activities = JSON.stringify(params.Activities);
        params.Categories = JSON.stringify(params.Categories);
        params.HebYear = $scope.report.HebYear;

        $scope.isClicked = true;
        if ($rootScope.AdminLevel === 2 && params.Settlements == "null") {
            params.Settlements = JSON.stringify($scope.Settlements);
        }
        if (!$scope.report.Export && !$scope.report.DontSave) {
            reportsEndpoint.post(params, function (data) {
                if (!data.success)
                    Notification.info("נכשל בהוספת דוח חדש");
                else
                    Notification.success("דוח נשמר בהצלחה");
                $mdDialog.hide();
                $scope.isClicked = false;
            })
        } else {
            Notification.info("מכין דוח אנא המתן..");
            $timeout(function () {
                if ($scope.isClicked)
                    Notification.info("פעולה זו יכולה להימשך מספר שניות");
            }, 10000);
            reportsEndpoint.saveExport.get(params, function (data) {
                // $mdDialog.hide();
                $scope.isClicked = false;
            })
        }

    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });

    $scope.clearSearchTerm = function () {
        $scope.searchTerm = '';
    };


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };
}

(function ()
{
    'use strict';

    angular
        .module('app.pages.parent-profile', ['datatables'])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_parent-profile', {
            url      : '/parent-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/parents/parents-profile/parents-profile.html',
                    controller: 'ParentProfileController'
                }
            },
            resolve  : {
                DashboardData: function ()
                {
                    localStorage.setItem("path", '/parent-profile');
                }
            },
            bodyClass: 'parents-profile'
        });


    }

})();

angular.module('app.pages.parent-profile').controller('ParentProfileController', ParentProfileController);

function ParentProfileController($scope, studentsEndpoint, $rootScope, $location, settlementsEndpoint, usersEndpoint, $mdSidenav, $mdDialog, tagsEndpoint, DTOptionsBuilder, $timeout, parent, parentsEndpoint, dtOptions, Notification, student, receiptsService, $window, $cookies, appConfig, DTColumnDefBuilder, gradesEndpoint, groupsEndpoint, tokenEndpoint) {


    $scope.searchText = '';
    $scope.relations = ['אמא', 'אבא', 'אחר'];
    $scope.HMOS = ["קופת חולים מאוחדת", "מכבי שירות בריאות", "שירותי בריאות כללית", "לאומית שירותי בריאות"];
    $scope.grades = [];
    $scope.parentsGroups = [];

    function init() {
        var parentObject = {};
        parentObject.ID = $location.search().ID;
        if (!parentObject.ID) {
            $location.path('/parents');
        } else {
            resolveParent(parentObject);
        }
        $scope.currentParentID = parentObject.ID;

    }

    init();

    $scope.$watch(function () {
        if ($location.path().includes('parent'))
            return $location.search()
    }, function (data) {
        if (data && $scope.currentParentID !== null && data.ID != $scope.currentParentID) {
            if (data.ID) {
                delete $scope.parent;
                init();
            }
        }
    });

    /**
     * resolve the parent by the ID stored in parentObject
     * @param parentObject
     */
    function resolveParent(parentObject) {
        parentsEndpoint.get(parentObject, function (response) {
            if (response.data.items[0]) {
                $scope.parent = response.data.items[0];
                $scope.CurrentTotalCash = $scope.parent.TotalCash;
                $scope.searchText = $scope.parent.City;
                parent.updateSelectedParent($scope.parent);
                $scope.getGroupsBySettlementAndGrade(false, true);
                $scope.getContactForms();
                $scope.getGrades();
                $scope.getFamily();
                $scope.getPayments();
                $scope.getRegistrations();
                $scope.getSubsidyForms();
                $scope.getCash();
                $scope.getSettlements();
                $scope.getCancellationForms();
                $scope.getParentTags();
                getTags();
                setComments();
            } else
                $location.path('/parents');
        })
    }

    /**
     * Get All Grades
     */
    $scope.getGrades = function () {
        $scope.grades = [];
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };

    /**
     * Get group by branch
     */
    $scope.getGroupsBySettlementAndGrade = function (loadAll, firstCall) {
        if (loadAll) {
            groupsEndpoint.get({Status: 1}, function (data) {
                $scope.parentsGroups = data;
            })
        } else if ($scope.parent.GradeID > 0 && $scope.parent.SettlementID > 0) {
            var params = {
                GradeID: $scope.parent.GradeID,
                SettlementID: $scope.parent.SettlementID,
                Status: 1
            };
            $scope.parentsGroups = [];
            groupsEndpoint.get(params, function (data) {
                $scope.parentsGroups = data;
                if (firstCall) {
                    var foundGroup = $scope.parentsGroups.find(function (group) {
                        return group.ID == $scope.parent.ID;
                    });
                    if (!foundGroup)
                        $scope.getGroupsBySettlementAndGrade(true);
                }
            })
        }

    };

    /**
     * Get All Tags
     */
    function getTags() {
        tagsEndpoint.get({Status: 1}, function (data) {
            $scope.tags = data;
        })
    }

    $scope.getParentTags = function () {
        usersEndpoint.tags.get({ParentID: $scope.parent.ID}, function (data) {
            $scope.parentTags = data;
        })
    }

    $scope.updateTagStatus = function (tag) {
        tag.Status = tag.Status = 1 ? 0 : 1;
        usersEndpoint.tags.update.post(tag, function (data) {
            if (!data.success) {
                tag.Status = tag.Status = 1 ? 0 : 1;
                Notification.error('התרחשה תקלה');
            }
        })
    }

    $scope.openAddNewUserTagsDialog = function () {
        $mdDialog.show({
            controller: 'NewUserTagsDialogController',
            templateUrl: 'app/main/pages/users/views/new-user-tag-dialog/new-user-tag-dialog.html',
            locals: {
                userID: undefined,
                studentID: undefined,
                parentID: $scope.parent.ID
            },
            clickOutsideToClose: true
        }).then(function () {
            $scope.getParentTags();
        });
    };

    /**
     * Check for changes in parent object
     */
    $scope.$watch('parent', function (newValue, oldValue) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'parent-profile')
    }, true);

    /**
     * Get Parent Family
     */
    $scope.getFamily = function () {
        $scope.editEd = true;
        $scope.family = false;
        $timeout(function () {
            parentsEndpoint.family.get($scope.parent, function (data) {
                $scope.family = data;
            })
        }, 500);
    };

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.tagsQuerySearch = function (query) {
        return query ? $scope.tags.filter(createFilterForTags(query)) : [];
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterForTags(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * Open student panel
     * @param selecteFamilyMember
     */
    $scope.editFamily = function (selecteFamilyMember) {
        if (selecteFamilyMember.ParentID > 0) {
            $mdSidenav("parent-panel").open();
            parent.updateSelectedParent(selecteFamilyMember);
        } else {
            $mdSidenav("student-panel").open();
            student.updateSelectedStudent(selecteFamilyMember);
        }

    };

    $scope.deleteFamily = function (familyMember) {
        var message = familyMember.ParentID > 0 ? 'האם אתה בטוח/ה שברצונך למחוק את הבן/בת זוג?' : 'האם אתה בטוח/ה שברצונך למחוק ילד זה?';
        var confirm = $mdDialog.confirm()
            .title('מחיקת ילד')
            .textContent(message)
            .targetEvent(null)
            .ok('מחק')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function () {
            deleteFamilyMember(familyMember);
        });
    };

    var deleteFamilyMember = function (familyMember) {
        if (familyMember.ParentID > 0) {
            parentsEndpoint.family.deleteSpouse.post($scope.parent.ID, function () {
                Notification.success("בן/בת זוג נמחק בהצלחה");
                $scope.getFamily();
            })
        } else {
            var params = {
                StudentID: familyMember.ID,
                ParentID: $scope.parent.ID
            };
            parentsEndpoint.family.delete.post(params, function () {
                Notification.success("ילד נמחק בהצלחה");
                $scope.getFamily();
            })
        }

    };

    /**
     * Get Parent Payments
     */
    $scope.getPayments = function () {
        $timeout(function () {
            parentsEndpoint.receipts.get($scope.parent, function (data) {
                $scope.receipts = data;
            })
        }, 500)
    };

    /**
     * Get Parent Cash
     */
    $scope.getCash = function () {
        return
        if ($rootScope.AdminLevel < 2) return;
        $timeout(function () {
            parentsEndpoint.cash.get($scope.parent, function (data) {
                $scope.cashTrans = data;
                $scope.CurrentTotalCash = data.length > 0 ? data[0]['Total'] : 0;
            })
        }, 500)
    };

    /**
     * Get parent Contact Forms
     */
    $scope.getContactForms = function () {
        $scope.contacts = false;
        $timeout(function () {
            parentsEndpoint.contact.get($scope.parent, function (data) {
                $scope.contactss = data;
            })
        }, 500);
    };


    /**
     * Get parent Contact Forms
     */
    $scope.getSubsidyForms = function () {
        $scope.subsidyes = false;
        $timeout(function () {
            parentsEndpoint.subsidy.get($scope.parent, function (data) {
                $scope.subsidyes = data;
                $scope.subsidyes.forEach(function (sub) {
                    if (sub.typeForm) {
                        sub.Parent1PrivateIDFile = JSON.parse(sub.Parent1PrivateIDFile);
                        if (sub.Parent2PrivateIDFile) {
                            sub.Parent2PrivateIDFile = JSON.parse(sub.Parent2PrivateIDFile);
                        }
                        sub.Parent1Paycheck1File = JSON.parse(sub.Parent1Paycheck1File);
                        if (sub.Parent2Paycheck1File) {
                            sub.Parent2Paycheck1File = JSON.parse(sub.Parent2Paycheck1File);
                        }
                        sub.Parent1Paycheck2File = JSON.parse(sub.Parent1Paycheck2File);
                        if (sub.Parent2Paycheck2File) {
                            sub.Parent2Paycheck2File = JSON.parse(sub.Parent2Paycheck2File);
                        }
                        sub.Parent1Paycheck3File = JSON.parse(sub.Parent1Paycheck3File);
                        if (sub.Parent2Paycheck3File) {
                            sub.Parent2Paycheck3File = JSON.parse(sub.Parent2Paycheck3File);
                        }
                        if (sub.OtherFiles) {
                            sub.OtherFiles = JSON.parse(sub.OtherFiles);
                        }

                        if (sub.MoreKids && sub.MoreKids !== "[]") {
                            var kids = {};
                            kids['IDs'] = sub.MoreKids;
                            studentsEndpoint.get(kids, function (response) {
                                $scope.moreKids = response.data.items;
                            })
                        }
                    }
                })
            })
        })
    };


    /**
     * Get parent Contact Forms
     */
    $scope.getCancellationForms = function () {
        $scope.subsidyes = false;
        $timeout(function () {
            parentsEndpoint.cancellation.get($scope.parent, function (data) {
                $scope.cancellation = data;
            })
        }, 500);
    };

    $scope.getRegistrations = function () {
        $scope.contacts = false;
        $timeout(function () {
            parentsEndpoint.registrations.get($scope.parent, function (data) {
                $scope.registrations = data;
            })
        }, 500);
    };


    /**
     * Update Password
     */
    $scope.updateParentPassword = function (newPassword) {
        $scope.isClicked = true;
        if (!$scope.parent.LastLogin) {
            Notification.error("ההורה לא רשום למערכת");
        } else {
            $scope.isClicked = true;
            var params = {};
            params.Password = newPassword;
            parentsEndpoint.password.update.post($scope.parent, params, function (data) {
                $scope.isClicked = false;
                if (data.success) {
                    Notification.success("סיסמא עודכנה בהצלחה");
                } else
                    Notification.error("נכשל בעדכון סיסמא");
            })
        }


        /**
         * Download receipt
         * @param receiptID
         * @param type
         */
        $scope.downloadReceipt = function (receiptID, type) {
            Notification.info("מייצר קבלה..אנא המתן");
            receiptsService.getReceiptByID(receiptID, type)
        };

        /**
         * Convert Payment Type to string
         * @param registrationValue
         */
        $scope.getPaymentType = function (registrationValue) {
            switch (registrationValue.PaymentType) {
                case 0 :
                    registrationValue.PaymentType = "ללא עלות";
                    break;
                case 1 :
                    registrationValue.PaymentType = "אשראי";
                    break;
                case 2 :
                    registrationValue.PaymentType = "מזומן";
                    break;
                case 3 :
                    registrationValue.PaymentType = "העברה בנקאית";
                    break;
                case 4 :
                    registrationValue.PaymentType = "צ'ק";
                    break;
                case 11:
                    registrationValue.PaymentType = "הוראת קבע אשראי";
                    break;
            }
        };

        $scope.reSendReceipt = function (receipt) {
            Notification.info("שולח קבלה..");
            receiptsService.getReceiptByID(receipt.ID, receipt.Type, function () {
                Notification.success("קבלה נשלחה בהצלחה");
            }, true);
        };

        $scope.simulateQuery = false;
        $scope.isDisabled = false;


        // ******************************
        // Internal methods
        // ******************************

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            var results = query ? $scope.states.filter(createFilterFor(query)) : $scope.states,
                deferred;
            if ($scope.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
    }

    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.cancelRegistration = function (registration) {

        $mdDialog.show({
            controller: 'CancelRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };

    $scope.showFullRegistration = function (registration) {
        $mdDialog.show({
            controller: 'FullRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html',
            clickOutsideToClose: true,
            locals: {'registration': registration}
        })
    };

    /**
     * Open The Subsidy Dialog
     * @param subsidy
     */
    $scope.openSubsidyDialog = function (subsidy) {
        $mdDialog.show({
            controller: 'SubsidyDialogController',
            templateUrl: 'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/subsidy-dialog.html',
            clickOutsideToClose: true,
            locals: {'subsidy': subsidy, 'moreKids': $scope.moreKids}
        });
    };

    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.refundRegistration = function (registration) {

        $mdDialog.show({
            controller: 'RefundRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
            $scope.getCash();
        });
    };

    /**
     * Open The Cancellation Dialog
     * @param cancel
     */
    $scope.openCancellationDialog = function (cancel) {
        $mdDialog.show({
            controller: 'CancellationDialogController',
            templateUrl: 'app/main/pages/forms-dialogs/cancellation-dialog/cancellation-dialog.html',
            clickOutsideToClose: true,
            locals: {'cancel': cancel}
        });
    };

    /**
     * Open Contact Form Dialog
     * @param contactForm
     */
    $scope.openContactDialog = function (contactForm) {
        $mdDialog.show({
            controller: 'ContactDialogController',
            templateUrl: 'app/main/pages/forms-dialogs/contact-dialog/contact-dialog.html',
            clickOutsideToClose: true,
            locals: {'contactForm': contactForm}
        });
    };


    /**
     * @param receiptID
     * @param type
     */
    $scope.downloadReceipt = function (receiptID, type) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receiptID, type)
    };

    /**
     * Convert Payment Type to string
     * @param registrationValue
     */
    $scope.getPaymentType = function (registrationValue) {
        switch (registrationValue.PaymentType) {
            case 0 :
                registrationValue.PaymentType = "ללא עלות";
                break;
            case 1 :
                registrationValue.PaymentType = "אשראי";
                break;
            case 2 :
                registrationValue.PaymentType = "מזומן";
                break;
            case 3 :
                registrationValue.PaymentType = "העברה בנקאית";
                break;
            case 4 :
                registrationValue.PaymentType = "צ'ק";
                break;
        }
    };


    $scope.loginToProfile = function (parent) {
        if (!parent)
            parent = $scope.parent;
        delete $cookies.remove(appConfig.profileTokenName);
        localStorage.removeItem(appConfig.profilePathCokieName);
        tokenEndpoint.special.post({TokenData: {ParentID: parent.ID}}, function (data) {
            if (data.success) {
                $cookies.put(appConfig.adminProfileTokenName, data.Token, {domain: location.hostname == 'localhost' ? 'localhost' : appConfig.appDomain});

                if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
                    $window.open('http://localhost:4200/', '_blank');
                else if (location.host === appConfig.locationHost)
                    $window.open(appConfig.developmentProfilePath, '_blank');
                else
                    $window.open(appConfig.prodctionProfilePath, '_blank');
            } else {
                Notification.error('התרחשה שגיאה');
            }

        });
    };

    $scope.reSendReceipt = function (receipt) {
        Notification.info("שולח קבלה..");
        receiptsService.getReceiptByID(receipt.ID, function () {
            Notification.success("קבלה נשלחה בהצלחה");
        }, true);
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withOption('responsive', true)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('order', [[0, 'desc']]);

    $scope.regDtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withOption('responsive', true)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('order', [[1, 'desc']]);


    $scope.cashDtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withOption('responsive', true)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('order', []);

    $scope.simulateQuery = false;
    $scope.isDisabled = false;

    // list of `state` value/display objects
    $scope.states = loadAll();
    $scope.querySearch = querySearch;


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
        var results = query ? $scope.states.filter(createFilterFor(query)) : $scope.states,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }

    $scope.setCity = function (city) {
        $scope.parent.City = city.value
    };


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמייה,כרמים,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        return allStates.split(',').map(function (state) {
            return {
                value: state,
                display: state
            };
        });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.value.indexOf(lowercaseQuery) === 0);
        };

    }

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });

    $scope.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0)
            .withOption('type', 'date')
    ];


    /**
     * Add comments in Staff
     * @param content
     */
    $scope.addComment = function () {
        var content = $rootScope.commentText;
        content = content.replace(/(\r\n|\n|\r)/gm, "<br>");
        var comment = {};
        comment.badgeClass = 'info';
        //comment.badgeIconClass='glyphicon-check';
        comment.user = $rootScope.User.FirstName + " " + $rootScope.User.LastName;
        comment.content = content;
        comment.date = Date.now();
        $scope.Comments.splice(0, 0, comment);

        var dopComments = angular.copy($scope.Comments);
        dopComments = JSON.stringify(dopComments);
        $scope.parent.Comments = dopComments;
        $rootScope.commentText = '';
    };

    /**
     * Set Comments
     */
    function setComments() {
        if ($scope.parent.Comments)
            $scope.Comments = JSON.parse($scope.parent.Comments);
        else
            $scope.Comments = [];
    }

    $scope.deleteCashTransaction = function (cash) {
        parentsEndpoint.cash.delete({CashID: cash.ID, ParentID: $scope.parent.ID}, function (data) {
            $scope.getCash();
        })
    }


    /**
     * Get All Settlements
     */
    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        });

    }

    /**
     * Open new parent dialog
     */
    $scope.openNewParentDialog = function () {
        $mdDialog.show({
            controller: 'NewFamilyMemberDialogController',
            templateUrl: 'app/main/pages/users/views/parents/parents-profile/tabs/family/new-family-member-dialog/new-family-member-dialog.html',
            clickOutsideToClose: true,
            locals: {
                ParentID: $scope.parent.ID,
            }
        }).then(function () {
            $scope.getFamily();
        });

    };

}

(function ()
{
    'use strict';

    angular
        .module('app.pages.new-educator', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {

        $stateProvider.state('app.pages_new-educator', {
            url      : '/new-educator',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/users/views/students/new-educator/new-educator.html',
                    controller : 'NewEducatorController'
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/users/views/students/new-educator');
    }

})();
angular.module('app.pages.new-educator').controller('NewEducatorController', ['$scope', '$rootScope','$location' ,'educatorsEndpoint','Notification','$timeout','appConfig','$cookies',function($scope, $rootScope,$location,educatorsEndpoint,Notification,$timeout,appConfig,$cookies) {


    $scope.showHideText = 'הצג';
    $scope.inputType = 'password';
    $scope.showHideImg = "/assets/icons/show.svg";
    $scope.matchPasswords = false;
    $scope.matchFlags = true;
    $scope.password = '';
    $scope.passwordVerify = '';
    $scope.form = {};
    $scope.success = false;
    $scope.loading = false;
    $scope.appConfig = appConfig;
    $scope.errorInfo = "";

    /**
     * Valid the new admin request for register a new admin
     */
    $scope.validRequest = function () {
        var params = {};
        params.token =  $location.search().tempToken;
        educatorsEndpoint.new.valid.post(params,function (data) {
            if (data.success)
                $scope.valid=true;
            else{
                $location.path("/");
                $scope.notValid=true;
            }

        })
    };
    $scope.matchPass = function () {
        if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length > 5) {
            $scope.matchPasswords = true;
            $scope.matchFlags = true;
        } else if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length < 6) {
            $scope.shortPass = true;
            $scope.matchFlags = true;
        } else {
            $scope.shortPass = false;
            $scope.matchPasswords = false;
            $scope.matchFlags = false;
        }
    }

    /**
     * Display or hide the password
     */
    $scope.showHidePassword = function () {
        if ($scope.inputType == "password") {
            $scope.inputType = "text";
            $scope.showHideText = 'הסתר';
            $scope.showHideImg = "/assets/icons/hide.svg";
        } else {
            $scope.inputType = "password";
            $scope.showHideText = 'הצג';
            $scope.showHideImg = "/assets/icons/show.svg";
        }

    };

    /**
     * Submit the new admin sing up
     */
    $scope.submit = function () {
        $scope.form.token = $location.search().tempToken;
        educatorsEndpoint.new.post($scope.form, function (data) {
            if (typeof data == 'string' || data instanceof String) {
                $scope.errorInfo = data;
                $scope.fail = true;
                $timeout(function () {
                    $scope.fail = false;
                }, 5000);
            }
            else if (data.ID) {
                $rootScope.User = data;
                setUserType();
                saveUser();
                $scope.success = true;
            }
            else
                $scope.errorInfo = "Error!";
            $scope.loading = true;
        })

    };

    /**
     * Set the admin type
     */
    function setUserType() {
        if ($rootScope.User.StudentID)
            $rootScope.AdminLevel = 1;
        else if ($rootScope.User.IsCoordinator)
            $rootScope.AdminLevel = 2;
        else
            $rootScope.AdminLevel = 3;
    }

    function saveUser() {
        var expireTime = +new Date() + (24 * 3600000);
        $cookies.put(appConfig.adminTokenName, $rootScope.User.AccessToken, [{expires: expireTime}]);
        $scope.loogin = false;
        $timeout(function () {
            if ($rootScope.AdminLevel !== 3)
                $location.path('/students');
            else
                $location.path('/dashboard');
        }, 250)
    }

    /**
     * href to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };

}]);

angular.module('app.pages.student-profile').controller('StudentProfileController', StudentProfileController);

function StudentProfileController($interval, $scope,appConfig,$cookies,$window, $rootScope, $location, usersEndpoint, $mdSidenav, $mdDialog, DTOptionsBuilder, $timeout, student, studentsEndpoint, parent, dtOptions, Notification, gradesEndpoint, receiptsService, groupsEndpoint, DTColumnDefBuilder, tagsEndpoint, rolesEndpoint, settlementsEndpoint, organizationsEndpoint,tokenEndpoint) {

    $scope.student = {
        Tags: [],
        extraFields: [],
        filterTags: 0
    };
    $scope.Tags = [];
    $scope.tagsStatus = 1;
    $scope.selectedTab = 0;
    $scope.count = 0;
    $scope.newUser = false;
    $scope.searchText = '';
    $scope.HMOS = ["קופת חולים מאוחדת", "מכבי שירות בריאות", "שירותי בריאות כללית", "לאומית שירותי בריאות"];
    $scope.Comments = [];
    $scope.displayTags = [];
    $scope.registrations = [];
    $scope.studentsGroups = [];
    $scope.contactss = [];
    $scope.family = [];
    $scope.roles = [];
    $scope.branches = [];
    $scope.grades = [];
    $scope.organizations = [];
    $scope.externalStudent = false;


    /**
     * Init Student Profile
     */
    function init() {
        var studentObject = {};
        studentObject.ID = $location.search().ID;
        if (!studentObject.ID) {
            $location.path('/students');
        } else {
            resolveStudent(studentObject);
        }
        $scope.currentStudentID = studentObject.ID;
    }

    init();

    $scope.$watch(function () {
        if($location.path().includes('student'))
            return  $location.search()
    }, function (data) {
        if (data && $scope.currentStudentID !== null && data.ID != $scope.currentStudentID) {
            if (data.ID) {
                delete $scope.student;
                init();
            }
        }
    });
    $scope.openAddNewUserTagsDialog = function () {
        $mdDialog.show({
            controller: 'NewUserTagsDialogController',
            templateUrl: 'app/main/pages/users/views/new-user-tag-dialog/new-user-tag-dialog.html',
            locals: {
                userID: undefined,
                studentID: $scope.student.ID,
                parentID: undefined
            },
            clickOutsideToClose: true
        }).then(function () {
            getUserTags();
        });
    };

    $scope.updateTagStatus = function (tag){
        tag.Status = tag.Status = 1? 0 : 1;
        usersEndpoint.tags.update.post(tag,function (data){
            if(!data.success) {
                tag.Status = tag.Status = 1? 0 : 1;
                Notification.error('התרחשה תקלה');
            }
        })
    }
    /**
     * resolve the student by the ID stored in studentObject
     * @param studentObject
     */
    function resolveStudent(studentObject) {
        studentsEndpoint.get(studentObject, function (response) {
            if (response.data.items[0]) {
                $scope.student = response.data.items[0];
                student.updateSelectedStudent($scope.student);
                $scope.getGroupsBySettlementAndGrade(false,true);
                $scope.getGrades();
                setComments();
                getUserTags();
                getRoles();
                getExtraFields();
                getCityAndSettlements();
                getOrganizations();
                $scope.getFamily();
                $scope.getRegistrations();
                $scope.getCancellationForms();
                $scope.getContactForms()
                //$scope.getExternalOrganizationInfo();
            } else
                $location.path('/student-profile');
        })
    }

    /**
     * Watch for changes in the student
     */
    $scope.$watch('student', function (newValue, oldValue) {
        if (typeof $rootScope.editDataHandler === 'function') {
            $rootScope.editDataHandler(newValue, oldValue, 'student-panel');
        }
    }, true);

    $scope.$watch('student.extraFields', function (newValue, oldValue) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'student-extra-field-values')
    }, true);

    $scope.getExternalOrganizationInfo = function () {
        var params = {
            PrivateID: $scope.student.PrivateID,
            ExternalOrganization: $scope.student.Organization
        }
        studentsEndpoint.get(params, function (data) {
            if (data.data && data.data.items)
                $scope.externalStudent = data.data.items[0];
            else
                $scope.externalStudent = false;
        })
    }

    /**
    /**
     * Get All Tags
     */
    function getUserTags() {
        usersEndpoint.tags.get({StudentID: $scope.student.ID}, function (data) {
            $scope.Tags = data;
            $scope.Tags = data;
        })
    }

    /**
     * Get Roles
     */
    function getRoles() {
        var params = {};
        params.withNames = true;
        rolesEndpoint.educator.get(params, function (data) {
            $scope.roles = data;
        })
    }

    function getExtraFields() {
        if ($scope.student.extraFields === undefined) {
            studentsEndpoint.studentExtraFieldsValues.get($scope.student.ID, function (response) {
                $scope.student.extraFields = response;
            });
        }
    }

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.tagsQuerySearch = function (query) {
        return query ? $scope.tags.filter(createFilterForTags(query)) : [];
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterForTags(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Get All Grades
     */
    $scope.getGrades = function () {
        $scope.grades = [];
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };

    /**
     * Get group by branch
     */
    $scope.getGroupsBySettlementAndGrade = function (loadAll,firstCall) {
        if(loadAll){
            groupsEndpoint.get({Status:1}, function (data) {
                $scope.studentsGroups = data;
            })
        }
        else if($scope.student.GradeID > 0 && $scope.student.SettlementID > 0){
            var params = {
                GradeID: $scope.student.GradeID,
                SettlementID: $scope.student.SettlementID,
                Status: 1
            };
            $scope.studentsGroups = [];
            groupsEndpoint.get(params, function (data) {
                $scope.studentsGroups = data;
                if(firstCall){
                    var foundGroup = $scope.studentsGroups.find(function(group){
                        return group.ID == $scope.student.ID;
                    });
                    if(!foundGroup)
                        $scope.getGroupsBySettlementAndGrade(true);
                }
            })
        }

    };

    /**
     * Login To Parent Profile
     * @param parent
     */
    $scope.loginToProfile = function (parent) {
        delete $cookies.remove(appConfig.profileTokenName);
        localStorage.removeItem(appConfig.profilePathCokieName);
        tokenEndpoint.special.post({TokenData: {ParentID: parent.ID}},function (data){
            if(data.success){
                $cookies.put(appConfig.adminProfileTokenName, data.Token,{domain: location.hostname == 'localhost'? 'localhost' : appConfig.appDomain});

                if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
                    $window.open('http://localhost:4200/', '_blank');
                else if (location.host === appConfig.locationHost)
                    $window.open(appConfig.developmentProfilePath, '_blank');
                else
                    $window.open(appConfig.prodctionProfilePath, '_blank');
            } else {
                Notification.error('התרחשה שגיאה');
            }

        });
    }


    /**

     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('order', [0, "desc"])
        .withOption('responsive', true)
        .withOption('autoWidth', false)
        .withDOM('lrtip');

    /**
     * Get Student Family
     */
    $scope.getFamily = function () {
        $scope.editEd = true;
        $scope.family = [];
        var started = false;
        var interval = $interval(function () {
            if ($scope.student && $scope.student.ID && !started) {
                started = true;
                studentsEndpoint.family.get($scope.student.ID, function (data) {
                    $scope.family = data;
                });
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                }
            }
        }, 2000);
    };

    /**
     * Get Student Registrations
     */
    $scope.getRegistrations = function () {
        $scope.registrations = [];
        var started = false;
        var interval = $interval(function () {
            if ($scope.student && $scope.student.ID && !started) {
                started = true;
                studentsEndpoint.registrations.get($scope.student.ID, function (data) {
                    $scope.registrations = data;
                });
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                }
            }
        }, 2000);
    };

    /**
     * Get Student Registrations
     */
    $scope.getContactForms = function () {
        $scope.contacts = [];
        var started = false;
        var interval = $interval(function () {
            if ($scope.student && $scope.student.ID && !started) {
                started = true;
                studentsEndpoint.contact.get($scope.student.ID, function (data) {
                    $scope.contactss = data;
                });
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                }
            }
        }, 2000);
    };

    /**
     * Get Student Registrations
     */
    $scope.getCancellationForms = function () {
        $scope.contacts = [];
        var started = false;
        var interval = $interval(function () {
            if ($scope.student && $scope.student.ID && !started) {
                started = true;
                studentsEndpoint.cancellation.get($scope.student.ID, function (data) {
                    $scope.cancellation = data;
                });
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                }
            }
        }, 2000);

    };

    /**
     * Open The Cancellation Dialog
     * @param cancel
     */
    $scope.openCancellationDialog = function (cancel) {
        $mdDialog.show({
            controller: 'CancellationDialogController',
            templateUrl: 'app/main/pages/forms-dialogs/cancellation-dialog/cancellation-dialog.html',
            clickOutsideToClose: true,
            locals: {'cancel': cancel}
        });
    };


    /**
     * Open The Contact Dialog
     * @param contactForm
     */
    $scope.openContactDialog = function (contactForm) {
        $mdDialog.show({
            controller: 'ContactDialogController',
            templateUrl: 'app/main/pages/forms-dialogs/contact-dialog/contact-dialog.html',
            clickOutsideToClose: true,
            locals: {'contactForm': contactForm}
        });
    };

    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.cancelRegistration = function (registration) {

        $mdDialog.show({
            controller: 'CancelRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };


    /**
     * change to seblling profile
     * @param student
     */
    $scope.moveToProfile = function (student) {
        $scope.student = student;
        student.selectedStudent = student;
        $scope.getFamily();
        $scope.getRegistrations();
        $scope.getContactForms();
        $scope.getCancellationForms();
        $scope.selectedTab = 0;
    };

    /**
     * Edit parent
     * @param selectedParent
     */
    $scope.editParent = function (selectedParent) {
        $mdSidenav("parent-panel").open();
        parent.updateSelectedParent(selectedParent);
    };


    /**
     * Dialog for delete parent
     * @param selectedParent
     * @param ev
     */
    $scope.deleteParentDialog = function (selectedParent, ev) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת הורה')
            .textContent('האם אתה בטוח/ה שברצונך למחוק הורה?')
            .targetEvent(ev)
            .ok('מחק')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function () {
            deleteParent(selectedParent);
        });
    };


    /**
     * Delete Parent from studnet
     * @param selectedParent
     */
    var deleteParent = function (selectedParent) {
        var index = $scope.family.indexOf(selectedParent);
        $scope.family.splice(index, 1);
        studentsEndpoint.parent.delete.post($scope.student.ID, selectedParent.ID, function (data) {
            if (!data.success) {
                $scope.family.push(selectedParent);
                Notification.error("שגיאה 2")
            }
        })
    };

    /**
     * Open new parent dialog
     */
    $scope.openNewParentDialog = function () {
        $mdDialog.show({
            controller: 'NewParentDialogController',
            templateUrl: 'app/main/pages/users/views/students/student-profile/new-parent-dialog/new-parent-dialog.html',
            clickOutsideToClose: true,
        }).then(function () {
            $scope.getFamily();
            $scope.getRegistrations();
            $scope.getContactForms();
            $scope.getCancellationForms();

        });

    };

    /**
     * open create new Educator dialog
     */
    $scope.openNewEducatorDialog = function () {
        $mdDialog.show({
            controller: 'NewEducatorDialogController',
            templateUrl: 'app/main/pages/users/views/students/student-profile/new-educator-dialog/new-educator-dialog.html',
            clickOutsideToClose: true
        })
    };


    /**
     * Show Fill Reg
     * @param registration
     */
    $scope.showFullRegistration = function (registration) {
        $mdDialog.show({
            controller: 'FullRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html',
            clickOutsideToClose: true,
            locals: {'registration': registration}
        })
    };


    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.refundRegistration = function (registration) {

        $mdDialog.show({
            controller: 'RefundRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };


    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.cancelRegistration = function (registration) {

        $mdDialog.show({
            controller: 'CancelRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };

    function getOrganizations() {
        organizationsEndpoint.get(function (data) {
            $scope.organizations = data["movements"];
        });
    }


    /**
     * Download receipt
     * @param receiptID
     * @param type
     */
    $scope.downloadReceipt = function (receiptID, type) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receiptID, type)
    };


    function getCityAndSettlements() {
        $scope.simulateQuery = false;
        $scope.isDisabled = false;
        $scope.getSettlements();
        $scope.querySearch = querySearch;
    }

    $scope.getSettlements = function () {
        $scope.settlements = [];
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })

    };


    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
        var source = $scope.settlements;
        var results = query ? $scope.settlements.filter(createFilterFor(query)) : source,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }

    /**
     * Set City
     * @param city
     */
    $scope.setCity = function (city) {
        $scope.student.SettlementID = city.value;
    };

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.display.trim().indexOf(lowercaseQuery) === 0);
        };

    }

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });

    $scope.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1)
            .withOption('type', 'eu-date')
    ];


    /**
     * Get Payment Type
     * @param registrationValue
     * @returns {string}
     */
    $scope.getPaymentType = function (registrationValue) {
        switch (registrationValue.PaymentType) {
            case -1:
            case '-1':
                return 'מעורב';
            case 0:
            case "0":
                return "ללא עלות";
                break;
            case 1:
            case "1":
                return "אשראי";
                break;
            case 2:
            case "2":
                return "מזומן";
                break;
            case 3:
            case "3":
                return "העברה בנקאית";
                break;
            case 4:
            case "4":
                return "צ'ק";
                break;
            case 5:
            case "5":
                return "טופס התחייבות";
                break;
            case 11:
            case '11':
                return "הוראת קבע אשראי";
                break
            default:
                return "ללא עלות";
                break;
        }
    };


    /**
     * Add comments in Staff
     */
    $scope.addComment = function () {
        var content = $rootScope.commentText;
        content = content.replace(/(\r\n|\n|\r)/gm, "<br>");
        var comment = {};
        comment.badgeClass = 'info';
        //comment.badgeIconClass='glyphicon-check';
        comment.user = $rootScope.User.FirstName + " " + $rootScope.User.LastName;
        comment.content = content;
        comment.date = Date.now();
        $scope.Comments.splice(0, 0, comment);

        var dopComments = angular.copy($scope.Comments);
        dopComments = JSON.stringify(dopComments);
        $scope.student.Comments = dopComments;
        $rootScope.commentText = '';


    };

    /**
     * Set Comments
     */
    function setComments() {
        if ($scope.student.Comments)
            $scope.Comments = JSON.parse($scope.student.Comments);
        else
            $scope.Comments = [];
    }

}

angular.module('app.pages.users').controller('NewStudentsDialogController', ['$scope', '$rootScope', '$mdDialog', 'studentsEndpoint', 'student', '$location', 'Notification', 'privateIDCheck', 'gradesEndpoint', 'organizationsEndpoint', 'settlementsEndpoint', function ($scope, $rootScope, $mdDialog, studentsEndpoint, student, $location, Notification, privateIDCheck, gradesEndpoint, organizationsEndpoint, settlementsEndpoint) {
    $scope.newStudent = {
        organization: '',
    };
    /**
     * Save new Student
     */
    $scope.saveNesStudent = function () {
        if (!$scope.tz)
            if (privateIDCheck.privateIDCheck($scope.newStudent.PrivateID) === false) {
                Notification.error("תעודות זהות של החניך לא תקינה");
                return;
            }

        if ($scope.newStudent.Parent1 && $scope.newStudent.Parent1 !== '') {
            if (privateIDCheck.privateIDCheck($scope.newStudent.Parent1) === false) {
                Notification.error("תעודות זהות של הורה 1 לא תקינה");
                return;
            }
        }

        if ($scope.newStudent.Parent2 && $scope.newStudent.Parent2 !== '') {
            if (privateIDCheck.privateIDCheck($scope.newStudent.Parent2) === false) {
                Notification.error("תעודות זהות של הורה 2 לא תקינה");
                return;
            }
        }
        $scope.isClicked = true;

        studentsEndpoint.post($scope.newStudent, function (data) {
            $scope.isClicked = false;
            if (data.ID) {
                location.href = "/student-profile?ID=" + data.ID;
                $mdDialog.hide();
            } else {
                Notification.info("נכשל ביצירה : תועדה מזהה/דרכון קיימים במערכת")
            }
        })

    };

    /**
     * Change the pattern to passport
     * @constructor
     */
    $scope.ChangeToPassport = function () {
        $scope.tz = !$scope.tz
    };

    /**
     * Get All Branches And Groups
     */
    $scope.getBranches = function (external) {
        $scope.editEd = !$scope.editEd;
        var params = {};
        params.Status = 1;
        if (external) {
            params.organization = external;
        }
    };

    $scope.getSettlements = function () {
        $scope.settlements = [];
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })
    };

    /**
     * Get All Grades
     */
    $scope.getGrades = function () {
        $scope.grades = [];
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };

    $scope.getOrganizations = function () {
        organizationsEndpoint.get(function (data) {
            $scope.organizations = data["movements"];
        });
    };


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    /**
     * If its a TZ add ng-pattern for tz
     * @returns {*}
     */
    $scope.pattern = function () {
        if (!$scope.tz)
            return "/^[0-9]{9,9}$/";
        return "";
    };

    /**
     * Looking for changes in the selected organization
     */
    $scope.$watchCollection('newStudent.organization', function (newValue, oldValue) {
        $scope.getBranches(newValue);
        $scope.getGrades(newValue);
    });
}]);

angular.module('app.pages.users').controller('StudentPanelController', ['$scope', 'student', '$rootScope', '$timeout', 'gradesEndpoint', 'settlementsEndpoint', function ($scope, student, $rootScope, $timeout, gradesEndpoint, settlementsEndpoint) {

    /**
     * Set the selected student
     */
    $scope.$on('selectedStudent:updated', function () {
        $scope.student = student.selectedStudent;
        $scope.searchText = null;
        $scope.selectedItem = null;
        if($scope.settlements && $scope.settlements.length){
            $scope.searchText = $scope.settlements.filter(function (settlement) {
                return settlement.value === $scope.student.SettlementID;
            })[0]['display'];

        }
        $scope.getGrades();
    });

    /**
     * Change all fields
     */
    $scope.changeAllFields = function () {
        $scope.allFields = !$scope.allFields;
    };

    /**
     * Get Grades
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        })
    };

    $scope.getSettlements = function () {
        $scope.settlements = [];
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data.map(function (settlement) {
                return {
                    value: settlement.ID,
                    display: settlement.Name,
                };
            });
        });
        if($scope.student && $scope.student.SettlementID){
            $scope.searchText = $scope.settlements.filter(function (settlement) {
                return settlement.value === $scope.student.SettlementID;
            })[0]['display'];
        }

    };

    /**
     * Look for changes in the student object
     */
    $scope.$watchCollection('student', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'student-panel')
    });

    $scope.setCity = function (city) {
        $scope.student.City = city.value;
    };

    $scope.setSettlement = function (settlement) {
        $scope.student.SettlementID = settlement.value;
        $scope.student.SettlementName = settlement.display;
    };


    $scope.simulateQuery = false;
    $scope.isDisabled = false;

    // list of `state` value/display objects
    $scope.states = loadAll();
    $scope.querySearch = querySearch;


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
        var source = $scope.settlements;
        var results = query ? source.filter(createFilterFor(query)) : source,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

        var allStates = 'אבו גוש,אבו סנאן,אבו קורינאת (יישוב),אבו תלול,אבטין,אבטליון,אביאל,אביבים,אביגדור,אביחיל,\n' +
            'אביטל,אביעזר,אבירים,אבן יהודה,אבן מנחם,אבן ספיר,אבן שמואל,אבני איתן,אבני חפץ,אבנת,\n' +
            'אבשלום,אדורה,אדירים,אדמית,אדרת,אודים,אודם,אוהד,אום אל-פחם,אום אל-קוטוף,\n' +
            'אום בטין,אומן,אומץ,אופקים,אור הגנוז,אור הנר,אור יהודה,אור עקיבא,אורה,אורות,\n' +
            'אורטל,אורים,אורנים,אורנית,אושה,אזור,אחווה,אחוזם,אחוזת ברק,אחיהוד,\n' +
            'אחיטוב,אחיסמך,אחיעזר,איבים,אייל,איילת השחר,אילון,אילות,אילנייה,אילת,\n' +
            'אירוס,איתמר,איתן,איתנים,אכסאל,אל -עזי,אל -עריאן,אל -רום,אל סייד,אלומה,\n' +
            'אלומות,אלון הגליל,אלון מורה,אלון שבות,אלוני אבא,אלוני הבשן,אלוני יצחק,אלונים,אלי-עד,אליאב,\n' +
            'אליכין,אליפז,אליפלט,אליקים,אלישיב,אלישמע,אלמגור,אלמוג,אלעד,אלעזר,\n' +
            'אלפי מנשה,אלקוש,אלקנה,אמונים,אמירים,אמנון,אמציה,אניעם,אספר,אעבלין,\n' +
            'אפיק,אפיקים,אפק,אפרת,ארבל,ארגמן,ארז,אריאל,ארסוף,אשבול,\n' +
            'אשבל,אשדוד,אשדות יעקב (איחוד),אשדות יעקב (מאוחד),אשחר,אשכולות,אשל הנשיא,אשלים,אשקלון,אשרת,\n' +
            'אשתאול,באקה אל-גרביה,באר אורה,באר גנים,באר טוביה,באר יעקב,באר מילכה,באר שבע,בארות יצחק,בארותיים,\n' +
            'בארי,בוסתן הגליל,בועיינה-נוג\'ידאת,בוקעאתא,בורגתה,בחן,בטחה,ביצרון,ביר אל-מכסור,ביר הדאג\',\n' +
            'בירייה,בית אורן,בית אל,בית אלעזרי,בית אלפא,בית אריה,בית ברל,בית ג\'ן,בית גוברין,בית גמליאל,\n' +
            'בית דגן,בית הגדי,בית הלוי,בית הלל,בית העמק,בית הערבה,בית השיטה,בית זיד,בית זית,בית זרע,\n' +
            'בית חורון,בית חירות,בית חלקיה,בית חנן,בית חנניה,בית חשמונאי,בית יהושע,בית יוסף,בית ינאי,בית יצחק-שער חפר,\n' +
            'בית לחם הגלילית,בית מאיר,בית נחמיה,בית ניר,בית נקופה,בית עובד,בית עוזיאל,בית עזרא,בית עריף,בית צבי,\n' +
            'בית קמה,בית קשת,בית רבן,בית רימון,בית שאן,בית שמש,בית שערים,בית שקמה,ביתן אהרן,ביתר עילית,\n' +
            'בלפוריה,בן זכאי,בן עמי,בן שמן (כפר נוער),בן שמן (מושב),בני ברק,בני דקלים,בני דרום,בני דרור,בני יהודה,\n' +
            'בני נצרים,בני עטרות,בני עי"ש,בני ציון,בני ראם,בניה,בנימינה-גבעת עדה*,בסמ"ה,בסמת טבעון,בענה,\n' +
            'בצרה,בצת,בקוע,בקעות,בר גיורא,בר יוחאי,ברוכין,ברור חיל,ברוש,ברכה,\n' +
            'ברכיה,ברעם,ברק,ברקאי,ברקן,ברקת,בת הדר,בת חן,בת חפר,בת ים,\n' +
            'בת עין,בת שלמה,ג\'דיידה-מכר,ג\'ולס,ג\'לג\'וליה,ג\'סר א-זרקא,ג\'ש (גוש חלב),ג\'ת,גאולי תימן,גאולים,\n' +
            'גאליה,גבולות,גבים,גבע,גבע בנימין,גבע כרמל,גבעולים,גבעון החדשה,גבעות בר,גבעת אבני,\n' +
            'גבעת אלה,גבעת ברנר,גבעת השלושה,גבעת זאב,גבעת ח"ן,גבעת חיים (איחוד),גבעת חיים (מאוחד),גבעת יואב,גבעת יערים,גבעת ישעיהו,\n' +
            'גבעת כ"ח,גבעת ניל"י,גבעת עוז,גבעת שמואל,גבעת שמש,גבעת שפירא,גבעתי,גבעתיים,גברעם,גבת,\n' +
            'גדות,גדיש,גדעונה,גדרה,גונן,גורן,גורנות הגליל,גזית,גזר,גיאה,\n' +
            'גיבתון,גיזו,גילון,גילת,גינוסר,גיניגר,גינתון,גיתה,גיתית,גלאון,\n' +
            'גלגל,גליל ים,גלעד (אבן יצחק),גמזו,גן הדרום,גן השומרון,גן חיים,גן יאשיה,גן יבנה,גן נר,\n' +
            'גן שורק,גן שלמה,גן שמואל,גנות,גנות הדר,גני הדר,גני טל,גני יוחנן,גני עם,גני תקווה,\n' +
            'געש,געתון,גפן,גרופית,גשור,גשר,גשר הזיו,גת (קיבוץ),גת רימון,דאלית אל-כרמל,\n' +
            'דבורה,דבורייה,דבירה,דברת,דגניה א\',דגניה ב\',דוב"ב,דולב,דור,דורות,\n' +
            'דחי,דייר אל-אסד,דייר חנא,דייר ראפאת,דימונה,דישון,דלייה,דלתון,דמיידה,דן,\n' +
            'דפנה,דקל,דריג\'את,האון,הבונים,הגושרים,הדר עם,הוד השרון,הודיות,הודייה,\n' +
            'הושעיה,הזורע,הזורעים,החותרים,היוגב,הילה,המעפיל,הסוללים,העוגן,הר אדר,\n' +
            'הר גילה,הר עמשא,הראל,הרדוף,הרצלייה,הררית,ורד יריחו,ורדון,זבדיאל,זוהר,\n' +
            'זיקים,זיתן,זכרון יעקב,זכריה,זמר,זמרת,זנוח,זרועה,זרזיר,זרחיה,\n' +
            'ח\'ואלד,חבצלת השרון,חבר,חגור,חגי,חגלה,חד-נס,חדיד,חדרה,חוג\'ייראת (ד\'הרה) (שבט),\n' +
            'חולדה,חולון,חולית,חולתה,חוסן,חוסנייה,חופית,חוקוק,חורה,חורפיש,\n' +
            'חורשים,חזון,חיבת ציון,חיננית,חיפה,חירות,חלוץ,חלמיש,חלץ,חמאם,\n' +
            'חמד,חמדיה,חמדת,חמרה,חניאל,חניתה,חנתון,חספין,חפץ חיים,חפצי-בה,\n' +
            'חצב,חצבה,חצור הגלילית,חצור-אשדוד,חצרים,חרב לאת,חרוצים,חריש,חרמש,חרשים,\n' +
            'חשמונאים,טבריה,טובא-זנגרייה,טורעאן,טייבה,טייבה (בעמק),טירה,טירת יהודה,טירת כרמל,טירת צבי,\n' +
            'טל שחר,טל-אל,טללים,טלמון,טמרה,טמרה (יזרעאל),טנא,טפחות,יאנוח-ג\'ת,יבול,\n' +
            'יבנאל,יבנה,יגור,יגל,יד בנימין,יד השמונה,יד חנה,יד מרדכי,יד נתן,יד רמב"ם,\n' +
            'ידידה,יהוד,יהל,יובל,יובלים,יודפת,יונתן,יושיביה,יזרעאל,יחיעם,\n' +
            'יטבתה,ייט"ב,יכיני,ינוב,ינון,יסוד המעלה,יסודות,יסעור,יעד,יעל,\n' +
            'יעף,יערה,יפיע,יפית,יפעת,יפתח,יצהר,יציץ,יקום,יקיר,\n' +
            'יקנעם (מושבה),יקנעם עילית,יראון,ירדנה,ירוחם,ירושלים,ירחיב,ירכא,ירקונה,ישע,\n' +
            'ישעי,ישרש,יתד,כאבול,כאוכב אבו אל-היג\'א,כברי,כדורי,כדיתה,כוכב השחר,כוכב יאיר,\n' +
            'כוכב יעקב,כוכב מיכאל,כורזים,כחל,כחלה,כיסופים,כישור,כליל,כלנית,כמאנה,\n' +
            'כמהין,כמון,כנות,כנף,כנרת (מושבה),כנרת (קבוצה),כסיפה,כסלון,כסרא-סמיע,כעביה-טבאש-חג\'אג\'רה,\n' +
            'כפר אביב,כפר אדומים,כפר אוריה,כפר אחים,כפר ביאליק,כפר ביל"ו,כפר בלום,כפר בן נון,כפר ברא,כפר ברוך,\n' +
            'כפר גדעון,כפר גלים,כפר גליקסון,כפר גלעדי,כפר דניאל,כפר האורנים,כפר החורש,כפר המכבי,כפר הנגיד,כפר הנוער הדתי,\n' +
            'כפר הנשיא,כפר הס,כפר הרא"ה,כפר הרי"ף,כפר ויתקין,כפר ורבורג,כפר ורדים,כפר זוהרים,כפר זיתים,כפר חב"ד,\n' +
            'כפר חושן,כפר חיטים,כפר חיים,כפר חנניה,כפר חסידים א\',כפר חסידים ב\',כפר חרוב,כפר טרומן,כפר יאסיף,כפר ידידיה,\n' +
            'כפר יהושע,כפר יונה,כפר יחזקאל,כפר יעבץ,כפר כמא,כפר כנא,כפר מונש,כפר מימון,כפר מל"ל,כפר מנדא,\n' +
            'כפר מנחם,כפר מסריק,כפר מצר,כפר מרדכי,כפר נטר,כפר סאלד,כפר סבא,כפר סילבר,כפר סירקין,כפר עבודה,\n' +
            'כפר עזה,כפר עציון,כפר פינס,כפר קאסם,כפר קיש,כפר קרע,כפר ראש הנקרה,כפר רוזנואלד (זרעית),כפר רופין,כפר רות,\n' +
            'כפר שמאי,כפר שמואל,כפר שמריהו,כפר תבור,כפר תפוח,כרכום,כרם בן זמרה,כרם בן שמן,כרם יבנה (ישיבה),כרם מהר"ל,\n' +
            'כרם שלום,כרמי יוסף,כרמי צור,כרמיאל,כרמייה,כרמים,כרמל,לבון,לביא,לבנים,\n' +
            'להב,להבות הבשן,להבות חביבה,להבים,לוד,לוזית,לוחמי הגיטאות,לוטם,לוטן,לימן,\n' +
            'לכיש,לפיד,לפידות,לקיה,מאור,מאיר שפיה,מבוא ביתר,מבוא דותן,מבוא חורון,מבוא חמה,\n' +
            'מבוא מודיעים,מבואות ים,מבועים,מבטחים,מבקיעים,מבשרת ציון,מג\'ד אל-כרום,מג\'דל שמס,מגאר,מגדים,\n' +
            'מגדל,מגדל העמק,מגדל עוז,מגדלים,מגידו,מגל,מגן,מגן שאול,מגשימים,מדרך עוז,\n' +
            'מדרשת בן גוריון,מדרשת רופין,מודיעין עילית,מודיעין-מכבים-רעות*,מולדה*,מולדת,מוצא עילית,מוקייבלה,מורן,מורשת,\n' +
            'מזור,מזכרת בתיה,מזרע,מזרעה,מחולה,מחנה הילה*,מחנה טלי*,מחנה יהודית*,מחנה יוכבד*,מחנה יפה*,\n' +
            'מחנה מרים*,מחנה תל נוף*,מחניים,מחסיה,מטולה,מטע,מי עמי,מיטב,מייסר,מיצר,\n' +
            'מירב,מירון,מישר,מיתר,מכורה,מכחול,מכמורת,מכמנים,מלאה,מלילות,\n' +
            'מלכייה,מלכישוע,מנוחה,מנוף,מנות,מנחמיה,מנרה,מנשית זבדה,מסד,מסדה,\n' +
            'מסילות,מסילת ציון,מסלול,מסעדה,מעברות,מעגלים,מעגן,מעגן מיכאל,מעוז חיים,מעון,\n' +
            'מעונה,מעיין ברוך,מעיין צבי,מעיליא,מעלה אדומים,מעלה אפרים,מעלה גלבוע,מעלה גמלא,מעלה החמישה,מעלה לבונה,\n' +
            'מעלה מכמש,מעלה עירון,מעלה עמוס,מעלה שומרון,מעלות-תרשיחא,מענית,מעש,מפלסים,מצדות יהודה,מצובה,\n' +
            'מצליח,מצפה,מצפה אבי"ב,מצפה אילן,מצפה יריחו,מצפה נטופה,מצפה רמון,מצפה שלם,מצר,מרגליות,\n' +
            'מרום גולן,מרחב עם,מרחביה (מושב),מרחביה (קיבוץ),מרכז שפירא,משאבי שדה,משגב דב,משגב עם,משהד,משואה,\n' +
            'משואות יצחק,משכיות,משמר איילון,משמר דוד,משמר הירדן,משמר הנגב,משמר העמק,משמר השבעה,משמר השרון,משמרות,\n' +
            'משמרת,משען,מתן,מתת,מתתיהו,נאות גולן,נאות הכיכר,נאות מרדכי,נאות סמדר,נאעורה,\n' +
            'נבטים,נגבה,נגוהות,נהורה,נהלל,נהרייה,נוב,נוגה,נווה,נווה אור,\n' +
            'נווה אטי"ב,נווה אילן,נווה איתן,נווה דניאל,נווה זוהר,נווה זיו,נווה חריף,נווה ים,נווה ימין,נווה ירק,\n' +
            'נווה מבטח,נווה מיכאל,נווה שלום,נועם,נוף איילון,נופים,נופית,נופך,נוקדים,נורדייה,\n' +
            'נורית,נחושה,נחל עוז,נחלה,נחליאל,נחלים,נחם,נחף,נחשולים,נחשון,\n' +
            'נחשונים,נטועה,נטור,נטע,נטעים,נטף,ניין,ניל"י,ניצן,ניצן ב\',\n' +
            'ניצנה (קהילת חינוך),ניצני סיני,ניצני עוז,ניצנים,ניר אליהו,ניר בנים,ניר גלים,ניר דוד (תל עמל),ניר ח"ן,ניר יפה,\n' +
            'ניר יצחק,ניר ישראל,ניר משה,ניר עוז,ניר עם,ניר עציון,ניר עקיבא,ניר צבי,נירים,נירית,\n' +
            'נירן,נס הרים,נס עמים,נס ציונה,נעורים,נעלה,נעמ"ה,נען,נצר חזני,נצר סרני,\n' +
            'נצרת,נצרת עילית,נשר,נתיב הגדוד,נתיב הל"ה,נתיב העשרה,נתיב השיירה,נתיבות,נתניה,סאג\'ור,\n' +
            'סאסא,סביון*,סגולה,סואעד (חמרייה)*,סולם,סוסיה,סופה,סח\'נין,סלמה,סלעית,\n' +
            'סמר,סנסנה,סעד,סער,ספיר,סתרייה,ע\'ג\'ר,עבדון,עברון,עגור,\n' +
            'עדי,עדנים,עוזה,עוזייר,עולש,עומר,עופר,עוצם,עזוז,עזר,\n' +
            'עזריאל,עזריה,עזריקם,עטרת,עידן,עיילבון,עיינות,עילוט,עין איילה,עין אל-אסד,\n' +
            'עין גב,עין גדי,עין דור,עין הבשור,עין הוד,עין החורש,עין המפרץ,עין הנצי"ב,עין העמק,עין השופט,\n' +
            'עין השלושה,עין ורד,עין זיוון,עין חוד,עין חצבה,עין חרוד (איחוד),עין חרוד (מאוחד),עין יהב,עין יעקב,עין כרם-בי"ס חקלאי,\n' +
            'עין כרמל,עין מאהל,עין נקובא,עין עירון,עין צורים,עין קנייא,עין ראפה,עין שמר,עין שריד,עין תמר,\n' +
            'עינת,עיר אובות,עכו,עלומים,עלי,עלי זהב,עלמה,עלמון,עמוקה,עמינדב,\n' +
            'עמיעד,עמיעוז,עמיקם,עמיר,עמנואל,עמקה,ענב,עספיא,עפולה,עפרה,\n' +
            'עץ אפרים,עצמון שגב,עראבה,עראמשה*,ערב אל נעים,ערד,ערוגות,ערערה,ערערה-בנגב,עשרת,\n' +
            'עתלית,עתניאל,פארן,פדואל,פדויים,פדיה,פוריידיס,פורייה - כפר עבודה,פורייה - נווה עובד,פורייה עילית,\n' +
            'פורת,פטיש,פלך,פלמחים,פני חבר,פסגות,פסוטה,פעמי תש"ז,פצאל,פקיעין (בוקייעה),\n' +
            'פקיעין חדשה,פרדס חנה-כרכור,פרדסייה,פרוד,פרזון,פרי גן,פתח תקווה,פתחיה,צאלים,צביה,\n' +
            'צבעון,צובה,צוחר,צופייה,צופים,צופית,צופר,צוקי ים,צוקים,צור הדסה,\n' +
            'צור יצחק,צור משה,צור נתן,צוריאל,צורית,ציפורי,צלפון,צנדלה,צפרייה,צפרירים,\n' +
            'צפת,צרופה,צרעה,קבוצת יבנה,קדומים,קדימה-צורן,קדמה,קדמת צבי,קדר,קדרון,\n' +
            'קדרים,קוממיות,קורנית,קטורה,קיסריה,קלחים,קליה,קלנסווה,קלע,קציר,\n' +
            'קצר א-סר,קצרין,קריית אונו,קריית ארבע,קריית אתא,קריית ביאליק,קריית גת,קריית טבעון,קריית ים,קריית יערים,\n' +
            'קריית יערים (מוסד),קריית מוצקין,קריית מלאכי,קריית נטפים,קריית ענבים,קריית עקרון,קריית שלמה,קריית שמונה,קרני שומרון,קשת,\n' +
            'ראמה,ראס אל-עין,ראס עלי,ראש העין,ראש פינה,ראש צורים,ראשון לציון,רבבה,רבדים,רביבים,\n' +
            'רביד,רגבה,רגבים,רהט,רווחה,רוויה,רוח מדבר,רוחמה,רומאנה,רומת הייב,\n' +
            'רועי,רותם,רחוב,רחובות,רחלים,ריחאנייה,ריחן,ריינה,רימונים,רינתיה,\n' +
            'רכסים,רם-און,רמות,רמות השבים,רמות מאיר,רמות מנשה,רמות נפתלי,רמלה,רמת גן,רמת דוד,\n' +
            'רמת הכובש,רמת השופט,רמת השרון,רמת יוחנן,רמת ישי,רמת מגשימים,רמת צבי,רמת רזיאל,רמת רחל,רנן,\n' +
            'רעים,רעננה,רקפת,רשפון,רשפים,רתמים,שאר ישוב,שבי ציון,שבי שומרון,שבלי - אום אל-גנם,\n' +
            'שגב-שלום,שדה אילן,שדה אליהו,שדה אליעזר,שדה בוקר,שדה דוד,שדה ורבורג,שדה יואב,שדה יעקב,שדה יצחק,\n' +
            'שדה משה,שדה נחום,שדה נחמיה,שדה ניצן,שדה עוזיהו,שדה צבי,שדות ים,שדות מיכה,שדי אברהם,שדי חמד,\n' +
            'שדי תרומות,שדמה,שדמות דבורה,שדמות מחולה,שדרות,שואבה,שובה,שובל,שוהם,שומרה,\n' +
            'שומרייה,שוקדה,שורש,שורשים,שושנת העמקים,שזור,שחר,שחרות,שיבולים,שיטים,\n' +
            'שייח\' דנון,שילה,שילת,שכניה,שלווה,שלווה במדבר,שלוחות,שלומי,שלומית,שמיר,\n' +
            'שמעה,שמרת,שמשית,שניר,שעב,שעל,שעלבים,שער אפרים,שער הגולן,שער העמקים,\n' +
            'שער מנשה,שערי תקווה,שפיים,שפיר,שפר,שפרעם,שקד,שקף,שרונה,שריגים (לי-און),\n' +
            'שריד,שרשרת,שתולה,שתולים,תאשור,תדהר,תובל,תומר,תושייה,תימורים,\n' +
            'תירוש,תל אביב -יפו,תל יוסף,תל יצחק,תל מונד,תל עדשים,תל קציר,תל שבע,תל תאומים,תלם,\n' +
            'תלמי אליהו,תלמי אלעזר,תלמי ביל"ו,תלמי יוסף,תלמי יחיאל,תלמי יפה,תלמים,תמרת,תנובות,תעוז,\n' +
            'תפרח,תקומה,תקוע,תרבין א-צאנע (יישוב)*,תרום,';

        return allStates.split(',').map(function (state) {
            return {
                value: state,
                display: state
            };
        });


    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.display.indexOf(lowercaseQuery) === 0);
        };

    }


}]);

angular.module('app.pages.users').controller('ChangeGroupOrGradeDialogController', ['$scope', '$rootScope', '$mdDialog','studentsEndpoint','student','$location','Notification','students','settlementsEndpoint','gradesEndpoint',
    function ($scope, $rootScope, $mdDialog,studentsEndpoint,student,$location,Notification,students,settlementsEndpoint,gradesEndpoint) {

    $scope.students = students;

    $scope.changeForm = {};
    $scope.changeForm.Students = [];

    var studentObj = {};
    /**
     * Get All selected students
     */
    for (var i=0;i<$scope.students.length;i++) {
        if($scope.students[i].Selected ===true) {
            studentObj = {};
            studentObj.ID = $scope.students[i].ID;
            $scope.changeForm.Students.push(studentObj);
        }

    }

    $scope.getSettlements = function (){
        settlementsEndpoint.get({},function (data){
            $scope.settlements = data;
        })
    }

    /**
     * Get all branches groups
     */
    $scope.getGroupsByBranch = function () {
        $scope.groups = false;
        settlementsEndpoint.groups.get($scope.changeForm.BranchID,function (data) {
            $scope.groups = data;
        })
    };


    $scope.getGrades = function () {
        var params = {};
        params.Status =1;
        gradesEndpoint.get(params,function (data) {
            $scope.grades = data;
        })
    };

    $scope.updateGradeAndGroups = function () {
        $scope.isClicked = true;
        studentsEndpoint.groups.upgrade.post($scope.changeForm,function (data) {
            if (data.success)
                Notification.success("חניכים עודכנו בהצלחה!");
            else
                Notification.error("נכשל בעדכון");
            $scope.isClicked = false;
            $mdDialog.hide();
        })
    };


    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

(function () {
    'use strict';

    angular
        .module('app.pages.utils', ['datatables'])
        .config(config).run(run);

    function run($rootScope, msNavigationService) {
        $rootScope.$watch('User', function () {
            if ($rootScope.AdminLevel) {
                msNavigationService.saveItem('pages.utils', {
                    title: 'עזרים',
                    icon: 'icon-auto-fix',
                    weight: 6
                });
                msNavigationService.saveItem('pages.utils.reports', {
                    title: 'דוחות',
                    icon: 'icon-file-excel',
                    state: 'app.pages_utils_reports',
                });
                msNavigationService.saveItem('pages.utils.contacts', {
                    title: 'אנשי קשר',
                    icon: 'icon-account-box',
                    state: 'app.pages_utils_contacts',
                });
                msNavigationService.saveItem('pages.utils.activities', {
                    title: $rootScope.User.Activities,
                    icon: 'icon-leaf',
                    state: 'app.pages_utils_activities',
                });
                switch ($rootScope.AdminLevel) {
                    case 3:
                    case 2:
                        msNavigationService.saveItem('pages.utils.files', {
                            title: 'קבצים',
                            icon: 'icon-file',
                            state: 'app.pages_utils_files',
                        });
                        break;
                }
            }
        });

    }


    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.pages_utils_files', {
            url: '/files',
            views: {
                'content@app': {
                    templateUrl: 'app/main/pages/utils/views/files/files.html',
                    controller: 'FilesController as vm'
                }
            },
            resolve: {
                DashboardData: function (ValidToken) {
                    ValidToken.validUserToken();
                    localStorage.setItem("path", '/files');
                }
            },
            bodyClass: 'files'
        })
            .state('app.pages_utils_reports', {
                url: '/reports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/utils/views/reports/reports.html',
                        controller: 'ReportsController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/reports');
                    }
                },
                bodyClass: 'reports'
            })
            .state('app.pages_utils_contacts', {
                url: '/contacts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/utils/views/contacts/contacts.html',
                        controller: 'ContactsController as vm'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/contacts');
                    }
                },
                bodyClass: 'contacts'
            })
            .state('app.pages_utils_activities', {
                url: '/activities',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/utils/views/activities/activities.html',
                        controller: 'ActivitiesController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/activities');
                    }
                }
            })


    }

})();

angular.module('app.pages.utils').controller('NewContactDialogController', ['$scope', '$rootScope', '$mdDialog','contactsEndpoint','$location','Notification','groupsEndpoint', function ($scope, $rootScope, $mdDialog,contactsEndpoint,$location,Notification,groupsEndpoint) {



    $scope.init = function(){
        $scope.selectedGroups = [];
        $scope.phoneChecked = false
        if($location.url().indexOf('group') === -1){
            $scope.getGroups();
        }
    }

    /**
     * Save new Student
     */
    $scope.saveNewContact = function () {
        $scope.isClicked = true;
        if($location.url().indexOf('group') === -1) {

            $scope.newContact.Groups = $scope.selectedGroups.map(function(group){
                return group.ID;
            });
        } else {
            var search = $location.search();
            if($scope.newContact.ID){
                if($location.url().indexOf('group') !== -1){
                    $scope.newContact.Groups.push(search.ID)
                }
            }
            else {
                if($location.url().indexOf('group') !== -1){
                    $scope.newContact.Groups = [search.ID]
                }
            }
        }

        if($scope.newContact.ID){
            contactsEndpoint.update.post($scope.newContact,function (data) {
                $scope.isClicked = false;
                Notification.info("איש קשר נוצר בהצלחה")
                $mdDialog.hide();
            });
        } else {
            contactsEndpoint.post($scope.newContact,function (data) {
                $scope.isClicked = false;
                Notification.info("איש קשר נוצר בהצלחה")
                $mdDialog.hide();
            }) ;
        }


    };

    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(item) {
            return (item.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    $scope.getGroups = function(){
        $scope.editEd = !$scope.editEd;
        var params = {};
        params.Status =1;
        groupsEndpoint.get(params,function(data){
            $scope.groups = data;
        });
    }

    $scope.groupsQuerySearch = function (query) {
        var results = query ?
            $scope.groups.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.checkForPhone = function(){
        var phone = $scope.newContact.Phone;
        if(phone.length != 10)
            return;
        contactsEndpoint.get({Phone:phone},function (data) {
            if(data.length){//existing contact
                $scope.newContact = data[0];
            } else {
                $scope.phoneChecked = true;
            }
        })
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

angular.module('app.pages.utils').controller('NewActivitiesDialogController', NewActivitiesDialogController)

function NewActivitiesDialogController($scope, $rootScope, $mdDialog, activitiesEndpoint, student, $location, Notification, groupsEndpoint, settlementsEndpoint, activities) {

    $scope.newActivities = {
        Date: moment().format('DD/MM/YYYY')
    }

    /**
     * Get All Branches
     */
    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })
    };

    /**
     * Get Groups
     * @param withNoParams
     */
    $scope.getGroups = function () {
        var params = {
            SettlementIdes: $scope.newActivities.settlements
        };
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        })
    };

    /**
     * Save new Activities
     * @param profile
     */
    $scope.saveNewActivities = function (profile) {
        $scope.isClicked = true;
        activitiesEndpoint.post($scope.newActivities, function (data) {
            $scope.isClicked = false;
            if (!data.ID) {
                Notification.info("שגיאה");
            } else {
                if (profile) {
                    $location.path("/activities-profile").search({ID: data.ID})
                }

            }
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.utils').controller('ContactsPanelController', ContactsPanelController);
function ContactsPanelController($scope,contact,$rootScope,groupsEndpoint) {



    /**
     * Set the current Contact
     */
    $scope.$on('selectedContact:updated', function () {
        $scope.contact = contact.selectedContact;
        $scope.selectedBranches = [];
        $scope.selectedGroups = [];

        if(contact.branches){
            $scope.branches = contact.branches;
            $scope.branches.forEach(function (branch) {
                if($scope.contact.Branches.indexOf(branch.ID) !== -1)
                    $scope.selectedBranches.push(branch);
            });
        }

        if(contact.groups){
            $scope.groups = contact.groups;
            $scope.groups.forEach(function (group) {
                if($scope.contact.Groups.indexOf(group.ID) !== -1)
                    $scope.selectedGroups.push(group);
            });
        }
    });

    /**
     * Get changes in the contact object
     */
    $scope.$watchCollection('contact', function (newValue, oldValue) {
        if(oldValue)
            $rootScope.editDataHandler(newValue, oldValue, 'contact-panel')
    });

    $scope.$watchCollection('selectedBranches', function (newValue, oldValue) {
        if(newValue && oldValue) {
            var str = [];
            $scope.contact.Branches = newValue.map(function (branch) {
                str.push(branch.Name);
                return branch.ID;
            });
            $scope.contact.branchesString = str.join(',');
        }
    });

    $scope.$watchCollection('selectedGroups', function (newValue, oldValue) {
        if(newValue && oldValue) {
            var str = [];
            $scope.contact.Groups = newValue.map(function (group) {
                str.push(group.Name);
                return group.ID;
            });
            $scope.contact.groupsString = str.join(',');
        }
    });

    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(item) {
            return (item.Name.indexOf(lowercaseQuery) !== -1);
        };
    }

    $scope.getGroups = function(){
        $scope.editEd = !$scope.editEd;
        var params = {};
        params.Status =1;
        groupsEndpoint.get(params,function(data){
            $scope.groups = data;
            $scope.groups.forEach(function (group) {
                if($scope.contact.Groups.indexOf(group.ID) != -1)
                    $scope.selectedGroups.push(group);
            })
        });
    }

    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.groupsQuerySearch = function (query) {
        var results = query ?
            $scope.groups.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.$watchCollection('vm.contact-panel',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'contact-panel')
    });
}

angular.module('app.pages.activities-profile').controller('ActivitiesProfileController', ActivitiesProfileController);
function ActivitiesProfileController($scope, $rootScope,$location,usersEndpoint,$mdSidenav,$mdDialog, DTOptionsBuilder,$timeout,activities,activitiesEndpoint,parent,dtOptions,Notification) {

    $scope.selectedTab = 0;
    $scope.count = 0;
    $scope.newUser = false;

    $scope.init = function(){
        var activityObject = {};
        activityObject.ID = $location.search().ID;
        if (!activityObject.ID) {
            $location.path('/activities');
        } else {
            resolveActivity(activityObject);
        }
    }


    function resolveActivity(activityObject){
        activitiesEndpoint.get({ID: activityObject.ID},function(data) {
            $scope.activities = data[0];
            $scope.getMeetings();
        })

    }


    /**
     * Look for changes in the activities object
     */
    $scope.$watchCollection('activities', function (newValue, oldValue) {
        if (typeof  $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'activities-panel')
    });

    /**
     * Get Students Attendance
     */
    $scope.getMeetings = function () {
        activitiesEndpoint.meetings.get($scope.activities, function (data) {
            $scope.meetings = data;
        })
    };

    /**
     * Update Student Attendance
     * @param student
     * @param noAttendance
     */
    $scope.updateStudentAttendance = function (student,noAttendance) {
        if(! noAttendance){
            if (student.Attendance == 1)
                student.Attendance = 0;
            else
                student.Attendance = 1;
        }
        activitiesEndpoint.attendance.post($scope.activities, student, function (data) {
            if (!data.success)
                Notification.info("ארעה שגיאה");
        })
    };


    /**
     * Open the create new student Dialog
     */
    $scope.openNewMeetingtDialog = function () {
        $mdDialog.show({
            controller: 'NewActivityMeetingDialogController',
            templateUrl: 'app/main/pages/utils/views/activities/activities-profile/tabs/meetings/new-activity-meeting-dialog/new-activity-meeting-dialog.html',
            clickOutsideToClose: true,
            locals: {
                activity: $scope.activities
            }
        }).then(function () {
            $scope.getMeetings();
        });
    };

    /**
     * Open the create new student Dialog
     */
    $scope.openMeetingHealthDeclarationMessageDialog = function (meeting) {
        $mdDialog.show({
            controller: 'SendActivityHealthDeclarationController',
            templateUrl: 'app/main/pages/utils/views/activities/activities-profile/send-activity-health-declaration-dialog/send-activity-health-declaration-dialog.html',
            clickOutsideToClose: true,
            locals: {
                activity: $scope.activities,
                meeting: meeting
            }
        }).then(function () {
            $scope.getMeetings();
        });
    };

    $scope.updateMeetingStatus = function(meeting){
        activitiesEndpoint.meetings.update($scope.activities,meeting,function (data){
            if(!data.success)
                Notification.error('התרחשה שגיאה');
        })
    }


    $scope.viewFile = function(file) {
        window.open( file);
    }


    $scope.uploadHealthDeclarationFile = function () {
        $mdDialog.show({
            controller         : 'UploadController',
            templateUrl        : 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'activities',
                uploadID: $scope.activities.ID + '/health-declaration',
                restrictTo: ['pdf']
            }
        }).then(function(){
            $scope.init();
        })
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


}

angular.module('app.pages.utils').controller('ActivitiesPanelController', ActivitiesPanelController);
function ActivitiesPanelController($scope,activities,$rootScope) {

    /**
     * Set the current Activities
     */
    $scope.$on('selectedActivities:updated', function () {
        $scope.activities = activities.selectedActivities;
        /**
         * Get changes in the activities object
         */
        $scope.$watchCollection('activities', function (newValue, oldValue) {
            if (typeof  $rootScope.editDataHandler === 'function')
                $rootScope.editDataHandler(newValue, oldValue, 'activities-panel')
        })
    });




}

angular.module('app.pages.events').controller('NewLocationDialogController', NewLocationDialogController);
function NewLocationDialogController($scope, $mdDialog,locationsEndpoint,Notification,successCallback,settlementsEndpoint) {

    $scope.newLocation = {
        IsRoom: 0
    };

    $scope.getSettlements = function (){
        settlementsEndpoint.get({},function (data){
            $scope.settlements = data;
        })
    }

    /**
     * Save new Question
     */
    $scope.saveNewLocation = function () {
        $scope.isClicked = true;
        $scope.newLocation.Layout = JSON.stringify([]);
        locationsEndpoint.post($scope.newLocation, function (data) {
            $scope.isClicked = false;
            if (data.success) {
                Notification.success('אולם נוצרה בהצלחה')
                successCallback();
            }
            else
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

(function ()
{
    'use strict';

    angular.module('app.pages.location-management', ['datatables','ui.calendar']).config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_location-management', {
            url      : '/location-management',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/settings-menue/views/locations/location-management/location-management.html',
                    controller: 'LocationManagementController'
                }
            },
            resolve  : {
                DashboardData: function () {
                    localStorage.setItem("path", '/location-management');
                }
            },
            bodyClass: 'location-management'
        });


    }

})();

angular.module('app.pages.location-management').controller('LocationManagementController',LocationManagementController);

function LocationManagementController($scope,$rootScope,$location,event, $mdSidenav, $mdDialog, DTOptionsBuilder, dtOptions, Notification, appConfig,settlementsEndpoint,locationsEndpoint) {
    var vm =this;

    vm.currentSection = undefined;
    vm.currentSectionID = undefined;
    vm.currentRowID = undefined;
    vm.currentRow = undefined;
    vm.location = false;
    vm.dayBook = false;
    vm.calendarDisplay = true;
    vm.dayBookCalendar = [[]];
    vm.getSettlements = getSettlements;
    vm.setCurrentSection = setCurrentSection;
    vm.addNewSection = addNewSection;
    vm.deleteCurrentSection = deleteCurrentSection;
    vm.setCurrentRow = setCurrentRow;
    vm.addNewRow = addNewRow;
    vm.deleteCurrentRow = deleteCurrentRow;
    vm.unsetCurrentRow = unsetCurrentRow;
    vm.updateLayout = updateLayout;
    vm.init = init;
    vm.search = {
    }
    vm.hours = [];
    vm.getAllHours = getAllHours;
    vm.addNewHour = addNewHour;
    vm.saveHours = saveHours;
    vm.deleteHour = deleteHour;
    vm.displayHoursSave = displayHoursSave;
    vm.setSeatAsNotAvailable = setSeatAsNotAvailable;
    vm.toggleSeatsSelection = toggleSeatsSelection;
    vm.next = next;
    vm.prev = prev;
    vm.goToEvent = goToEvent;
    vm.seatsSelection = false;
    vm.uiConfig = {
        calendar: {
            editable: true,
            eventLimit: true,
            header: '',
            handleWindowResize: false,
            aspectRatio: 1,
            viewRender: function (view) {
                vm.calendarView = view;
                vm.calendar = vm.calendarView.calendar;
                vm.currentMonthShort = vm.calendar.getDate().format('MMM');
            },
            columnFormat: {
                month: 'ddd',
                week: 'ddd D',
                day: 'ddd M'
            },
            selectable: true,
            selectHelper: true,
            dayClick: function (date, jsEvent, view) {
                vm.calendar.changeView('agendaDay');
                vm.calendar.gotoDate(date);
            },
            eventClick: function (info) {
                vm.goToEvent(info.id,info.module);
            }
        }
    };


    function init() {
        var location = {};
        location.ID = $location.search().ID;
        location.dayBook = true;
        if (!location.ID) {
            $location.path('/locations');
        }
        else {
            resolveLocation(location);
            vm.getSettlements();
        }
    }

    function resolveLocation(location) {
        locationsEndpoint.get(location, function (data) {
            if (data[0]) {
                vm.location = data[0];
                vm.dayBook = vm.location.daybook;
                vm.location.Layout = JSON.parse(vm.location.Layout);
                vm.getAllHours();
                parseDayBook();
            }
            else
                $location.path('/locations');
        });
    }

    function parseDayBook(){
        vm.dayBook.forEach(function (event) {
            if(event.repeatType == 0){
                var parts = event.locationStartDate.split(' ');
                var date = parts[0].split('/');
                var time = parts[1].split(':');
                var startDate = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                var parts = event.locationEndDate.split(' ');
                var date = parts[0].split('/');
                var time = parts[1].split(':');
                var endDate = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                vm.dayBookCalendar[0].push({
                    id: event.eventID,
                    title: event.eventName,
                    start: startDate,
                    end: endDate,
                    module: event.module,
                });
            }
            if(event.repeatType == 1){
                event.meetings.forEach(function (meeting){
                    var parts = meeting.Day.split('/');
                    var time = meeting.StartTime.split(':');
                    var startDate = new Date(parts[2], parts[1] - 1, parts[0], time[0], time[1]);
                    var time = meeting.EndTime.split(':');
                    var endDate = new Date(parts[2], parts[1] - 1, parts[0], time[0], time[1]);
                    vm.dayBookCalendar[0].push({
                        id: event.eventID,
                        title: event.eventName,
                        start: startDate,
                        end: endDate,
                        module: event.module,
                    });
                })
            }
            if(event.repeatType == 2){
                event.meetings.forEach(function (meeting) {
                    var parts = event.startDate.split('/');
                    var startDayOfEvent = new Date(parts[2].slice(0,4), parts[1] - 1, parts[0]);
                    parts = event.endDate.split('/');
                    var endDateOfEvent = new Date(parts[2].slice(0,4), parts[1] - 1, parts[0]);
                    while (startDayOfEvent.getDay() + 1 != meeting.Day) {
                        startDayOfEvent.setDate(startDayOfEvent.getDate() + 1)
                    }
                    var startTime = meeting.StartTime.split(':');
                    var endTime = meeting.EndTime.split(':');
                    var startDate = startDayOfEvent;
                    while (startDate < endDateOfEvent) {
                        startDate.setHours(Number(startTime[0]));
                        startDate.setMinutes(Number(startTime[1]));
                        var endDate = new Date(startDate.getTime());
                        endDate.setHours(Number(endTime[0]));
                        endDate.setMinutes(Number(endTime[1]));
                        vm.dayBookCalendar[0].push({
                            id: event.eventID,
                            title: event.eventName,
                            start: new Date(startDate.getTime()),
                            end: new Date(endDate.getTime()),
                            module: event.module,
                        });
                        startDate.setDate(startDate.getDate() + 7);
                    }
                })
            }


        })
    }

    function goToEvent(id,module){
        event.setActiveModule(module);
        $location.url('/event-management?ID=' + id);
    }

    /**
     * Go to next on current view (week, month etc.)
     */
    function next() {
        vm.calendarView.calendar.next();
    }

    /**
     * Go to previous on current view (week, month etc.)
     */
    function prev() {
        vm.calendarView.calendar.prev();
    }

    function getSettlements () {
        settlementsEndpoint.get({}, function (data) {
            vm.settlements = data;
        })
    }

    function setCurrentSection(){
        vm.currentRow = undefined;
        vm.currentSection = vm.location.Layout.filter(function(section){
            return section.ID == vm.currentSectionID;
        })[0];
    }

    function addNewSection (){
        var lastSectionID = 0;
        if(vm.location.Layout.length > 0){
            lastSectionID = Number(vm.location.Layout[vm.location.Layout.length-1]['ID']);
        }
        var length = vm.location.Layout.push({
            ID: lastSectionID + 1,
            Name: '',
            Rows: [],
        })
        vm.currentSection = vm.location.Layout[length-1];
        vm.currentRow = undefined;
    }

    function deleteCurrentSection (){
        vm.location.Layout = vm.location.Layout.filter(function (section){
            return section.ID != vm.currentSection.ID;
        })
        vm.currentRow = undefined;
        vm.currentSection = undefined;
    }

    function setCurrentRow(){
        vm.currentRow = vm.currentSection.Rows.filter(function(row){
            return row.ID == vm.currentRowID;
        })[0];
    }

    function addNewRow(){
        $mdDialog.show({
            controller: 'NewRowDialogController',
            templateUrl: 'app/main/pages/settings-menue/views/locations/location-management/tabs/sections/new-row-dialog/new-row-dialog.html',
            clickOutsideToClose: true,
            locals : {
                successCallback: function(row){
                  vm.currentRow =  row;
                },
                currentSection: vm.currentSection
            }
        });
    }

    function deleteCurrentRow (){
        vm.currentSection.Rows = vm.currentSection.Rows.filter(function(row){
            return row.ID != vm.currentRow.ID;
        });
        vm.currentRow = undefined;
    }

    function unsetCurrentRow(){
        vm.currentRow = undefined;
    }

    function updateLayout(){
        var locationDup = {
            ID: vm.location.ID,
            Layout: JSON.stringify(vm.location.Layout)
        }
        locationsEndpoint.update.post(locationDup,function (data){
            if(data.success)
                Notification.success('עודכן בהצלחה');
            else
                Notification.error('עדכון נכשל');
        })
    }

/******************************* hours*************************************/

    function getAllHours(){
        vm.hours = [];
        locationsEndpoint.workingHours.get(vm.location.ID,function(data){
            data.forEach(function (hour) {
                var time = hour.FromHour.split(':');
                hour.FromHour= new Date(1970,0,1,time[0],time[1],0);
                time = hour.ToHour.split(':');
                hour.ToHour = new Date(1970,0,1,time[0],time[1],0);
            });
            vm.hours = data;
        });
    }

    function addNewHour(){
        vm.hours.push({
            LocationID: vm.location.ID,
            Day: 1,
            FromHour: new Date(1970,0,1,8,0,0),
            ToHour: new Date(1970,0,1,16,0,0)
        });
    }

    function saveHours(){
        var tmpHours = [];
        vm.hours.forEach(function(hour){
            tmpHours.push(Object.assign({},hour));
        });
        tmpHours.forEach(function (hour) {
            hour.FromHour = hour.FromHour.getHours() + ':' + hour.FromHour.getMinutes();
            hour.ToHour = hour.ToHour.getHours() + ':' + hour.ToHour.getMinutes();
        })
        locationsEndpoint.workingHours.update.post(vm.location.ID,{hours:tmpHours},function(data){
            vm.getAllHours();
        });
    }

    function deleteHour(hour){
        locationsEndpoint.workingHours.delete.post(hour,function (data) {
            vm.getAllHours();
        });
    }

    function displayHoursSave(){
        var flag = false;
        vm.hours.forEach(function (hour) {
            if(hour.dirty || !hour.ID)
                flag = true;
        });
        return flag;
    }

    function toggleSeatsSelection(){
        vm.seatsSelection = !vm.seatsSelection;
    }


    function setSeatAsNotAvailable(sectionID,rowID,seatID,seat){
        if(! vm.seatsSelection)
            return;
        var params = {
            LocationID: vm.location.ID,
            SectionID: sectionID,
            RowID: rowID,
            SeatID: seatID
        }
        if(seat.notAvailable == 2){
            params.Op = 'delete';
            locationsEndpoint.occupiedSeats.update.post(params,function (data){
                delete seat.notAvailable;
            })
        } else if(! seat.notAvailable){
            params.Op = 'create';
            locationsEndpoint.occupiedSeats.update.post(params,function (data){
                seat.notAvailable = 2;
            })
        }
    }

    /**********************************************************************************************/

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');

    /**
     * Look for changes in the selected Questions
     */
    $scope.$watch('vm.location', function (newValue, oldValue) {
        if(newValue && oldValue){
            var tmpNewValue = Object.assign({},newValue);
            delete tmpNewValue.Layout;
            $rootScope.editDataHandler(tmpNewValue, oldValue, 'location-panel')
        }
    }, true);
}


angular.module('app.pages.events').controller('NewCategoryDialogController', NewCategoryDialogController);
function NewCategoryDialogController($scope, $mdDialog,questionsEndpoint,ParentCategory,eventsEndpoint,Notification,successCallback) {

    $scope.newCategory = {};

    if(ParentCategory != null){
        $scope.newCategory.ParentCategoryID = ParentCategory.ID;
        $scope.newCategory.ParentCategoryName = ParentCategory.Name;
    }
    /**
     * Save new Question
     */
    $scope.saveNewCategory = function () {
        $scope.isClicked = true;
        eventsEndpoint.categories.post($scope.newCategory, function (data) {
            $scope.isClicked = false;
            if (data.success) {
                Notification.success('קטגוריה נוצרה בהצלחה')
                successCallback();
            }
            else
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('CategoryPanelController', CategoryPanelController);

function CategoryPanelController($scope, category, $rootScope, settingsEndpoint, eventsEndpoint) {
    $scope.terminalManagement = 0;
    /**
     * Set the selected Category
     */
    $scope.getTerminals = function () {
        if ($rootScope.AdminLevel < 2) return;
        $scope.getAccountancySettings();
        eventsEndpoint.categories.getTerminals(function (data) {
            $scope.terminals = data;

        })
    }
    $scope.getAccountancySettings = function () {
        settingsEndpoint.accountancy.get(function (data) {
            $scope.terminalManagement = data.TerminalManagment;

        });
    }

    $scope.$on('selectedCategory:updated', function () {
        $scope.category = category.selectedCategory;
        if (!Array.isArray($scope.category.CancelEmails))
            $scope.category.CancelEmails = JSON.parse($scope.category.CancelEmails);
    });

    /**
     * Look for changes in the selected Category
     */
    $scope.$watch('category', function (newValue, oldValue) {

        $rootScope.editDataHandler(newValue, oldValue, 'category-panel')
    }, true);


}

angular.module('app.pages.settings_menu').controller('FieldPanelController', FieldPanelController);
function FieldPanelController($scope, extraField, $rootScope) {


    /**
     * Set the selected Field
     */
    $scope.$on('selectedField:updated', function () {
        $scope.field = extraField.selectedField;
    });

    /**
     * Look for changes in the selected Field
     */
    $scope.$watch('field', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'field-panel')
    }, true);


}

angular.module('app.pages.settings_menu').controller('NewFieldDialogController', NewFieldDialogController);
function NewFieldDialogController($scope, $mdDialog,systemSettingsEndpoint,Notification) {

    $scope.newField = {
        Required: 1,
    };
    $scope.newField.Values = [];

    /**
     * Save new Field
     */
    $scope.saveNewField = function () {
        $scope.isClicked = true;

        systemSettingsEndpoint.studentExtraFields.post({field: $scope.newField}, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.error("נכשל ביצירה");
            $mdDialog.hide();
        })

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewSingleRegistrationInfoDialogController', NewSingleRegistrationInfoDialogController);

function NewSingleRegistrationInfoDialogController($scope, $rootScope, $mdDialog, eventsEndpoint, $location, Notification, selectedEvent) {

    $scope.init = function () {
        $scope.event = selectedEvent;
        $scope.dataFetched = 0;
        $scope.selectedTransportation = {};
        $scope.locationSelected = {};
        $scope.quantity = 1;
        $scope.getQuestions();
        $scope.getTransportation();
        $scope.getEventLocation();
    };

    $scope.autocompleteQuestions = function (question){
        $scope.isClicked = true;
        if(question.Description.includes('ת.ז.') || question.Description.includes('תעודת זהות')){
            eventsEndpoint.questions.autocomplete.get({'QuestionID':question.QuestionsID,'Answer':question.Answer},function (data){
                data.forEach(function (answer){
                    var existingQuestion = $scope.questions.find(function (question){
                        return question.QuestionsID == answer.QuestionsID;
                    });
                    if(existingQuestion)
                        existingQuestion.Answer = answer.Answer;
                });
                $scope.isClicked = false;
            })
        }
        $scope.isClicked = false;
    }

    $scope.getQuestions = function () {
        eventsEndpoint.questions.get({}, $scope.event, function (data) {
            $scope.questions = data;
            $scope.questions.forEach(function (question) {
                if (question['AnswerType'] == 2) {
                    question['Options'] = question['Options'].split(",");
                }
            })
            $scope.dataFetched++;
        })
    };

    $scope.getTransportation = function () {
        eventsEndpoint.transportation.get($scope.event, function (data) {
            $scope.transportation = data;
            $scope.dataFetched++;
        })
    };

    $scope.getEventLocation = function () {
        if (!$scope.event.LocationID) {
            $scope.location = false;
            $scope.dataFetched++;
        } else {
            eventsEndpoint.locations.get($scope.event.ID, function (data) {
                if (data.location && data.layout.length) {
                    $scope.location = data;
                    $scope.location.layout = JSON.parse($scope.location.layout);
                }
                $scope.dataFetched++;
            })
        }
    }

    $scope.saveSeat = function (sectionID, rowID, seatID) {
        if ($scope.locationSelected.SectionID != undefined &&
            $scope.locationSelected.RowID != undefined &&
            $scope.locationSelected.SeatID != undefined) {
            var section = $scope.location.layout.find(function (section) {
                return section.ID == $scope.locationSelected.SectionID
            });
            var row = section.Rows.find(function (row) {
                return row.ID == $scope.locationSelected.RowID
            });
            var seat = row.Seats.find(function (seat) {
                return seat.ID == $scope.locationSelected.SeatID
            });
            seat.reserved = false;
        }

        $scope.locationSelected.SectionID = sectionID;
        $scope.locationSelected.RowID = rowID;
        $scope.locationSelected.SeatID = seatID;
    }

    $scope.moveToNextStep = function (currentLocation) {
        switch (currentLocation) {
            case 0://questions
                if ($scope.transportation.length > 0)
                    $scope.selectedTab++;
                else if ($scope.location && $scope.location.Layout.length > 0)
                    $scope.selectedTab++;
                else
                    $scope.closeDialog(true);
                break;
            case 1://transportation
                if ($scope.location && $scope.location.Layout.length > 0)
                    $scope.selectedTab++;
                else
                    $scope.closeDialog(true);
                break;
            case 2://location
                $scope.closeDialog(true);
                break;
            default:
                $scope.closeDialog(true);
        }

    }


    /**
     * Close the dialog
     */
    $scope.closeDialog = function (response) {
        if (response == false)
            $mdDialog.hide({success: false})
        if(isNaN($scope.quantity) || $scope.quantity < 1){
            Notification.error('חובה לבחור כמות תקינה');
            return;
        }
        $scope.event.Questions = $scope.questions
        $scope.event.Transportation = $scope.transportation;
        $scope.event.Location = $scope.locationSelected;
        $mdDialog.hide({
            success: true,
            event: $scope.event,
            quantity: $scope.quantity
        });
    };
}

angular.module('app.pages.events').controller('NewEventsDialogController', NewEventsDialogController);

function NewEventsDialogController($scope, $rootScope, $mdDialog, eventsEndpoint, $location, Notification, event, $timeout, organizationsEndpoint, msNavigationService, locationsEndpoint) {

    $scope.init = function () {
        $scope.activeModule = event.getActiveModule();
        $scope.externalOnly = $scope.activeModule.name === "ReligiousServices" || $scope.activeModule.name === "RevachaPnimi";
        $scope.getEventCategories();
        $scope.newEvent = {
            ExposeToExternalOrganization: 0,
            exposedOrganizations: [],
            DuplicateEventSelect: 1,
            EventType: 0,
            fieldsToDuplicate: [],
            duplicateAllFields: 1
        };
        if ($scope.externalOnly) {
            $scope.newEvent.EventType = '1';
        }
        $scope.getEvents();
        $scope.setType();
        $scope.getOrganizations();
        $scope.getLocations();
        $scope.fieldsToDuplicate = [
            {
                groupLabel: 'הנחות',
                fields: [
                    {fieldName: 'EventBrotherDiscount', displayName: 'הנחת אחים'},
                    {fieldName: 'EventFamilyDiscount', displayName: 'הנחות משפחה'},
                    {fieldName: 'EventStudentDiscount', displayName: 'הנחות תושב'},
                    {fieldName: 'GeneralDiscount', displayName: 'הנחות כלליות'}
                ]
            },
            {
                groupLabel: 'מחירים',
                fields: [
                    {fieldName: 'EventsSettlementPrice', displayName: 'מחיר לפי יישוב ושכבות'},
                    {fieldName: 'EventGroupPrice', displayName: 'מחיר לפי קבוצות'}
                ]
            },
            {
                groupLabel: 'אחר',
                fields: [
                    {fieldName: 'EventsQuestions', displayName: 'שאלות מאורע'},
                    {fieldName: 'EventTransportation', displayName: 'הסעות מאורע'},
                    {fieldName: 'EventBranches', displayName: 'שיוכים לפי יישוב'},
                    {fieldName: 'EventsGrades', displayName: 'שיוכים לפי שכבה'},
                    {fieldName: 'EventFile', displayName: 'קבצים'}
                ]
            }
        ];

    };


    $scope.setType = function () {
        var active = msNavigationService.getActiveItem();
        $scope.title = active.node.title;
    };

    $scope.validateDates = function (messageAbort) {
        var event = true;
        if ($scope.newEvent.StartDate && $scope.newEvent.EndDate)
            event = moment($scope.newEvent.StartDate, 'DD/MM/YYYY HH:mm') < moment($scope.newEvent.EndDate, 'DD/MM/YYYY HH:mm');
        if (!event && !messageAbort) {
            Notification.error('תאריכי אירוע לא תקינים');
        }
        return event;
    }

    /**
     * Save new Event
     */

    $scope.saveNewEvent = function () {

        if (!$scope.validateDates())
            return;
        var active = msNavigationService.getActiveItem();
        $scope.isClicked = true;
        $scope.newEvent.IsProduct = $scope.activeModule.isProduct ? 1 : 0;
        $scope.newEvent.GeneralEventType = active.node.generalEventType;
        if(+$scope.newEvent.DuplicateEventSelect === 3){
            $scope.newEvent.IsProduct = 1;
            $scope.newEvent.CategoryID = $scope.activeModule.masterCategoryID;
        }
        eventsEndpoint.post($scope.newEvent, function (data) {
            $scope.isClicked = false;
            if (!data.ID)
                Notification.info("נכשל ביצירה");
            else {
                $location.url('/event-management?ID=' + data.ID);
            }
            $mdDialog.hide();
        })
    };

    $scope.getOrganizations = function () {
        organizationsEndpoint.get(function (data) {
            $scope.organizations = data["movements"].map(function (org) {
                return {Name: org}
            });
        });
    };

    $scope.setName = function () {
        $scope.newEvent.Name = $scope.newEvent.DuplicateEvent.Name;
    };

    $scope.getEvents = function () {
        var params = {
            Status: 1,
            GeneralEventType: $scope.activeModule.name
        };
        eventsEndpoint.get(params, function (data) {
            $scope.events = data;
        })
    };

    $scope.getLocations = function () {
        locationsEndpoint.get({Status: 1}, function (data) {
            $scope.locations = data;
        })
    }

    $scope.getEventCategories = function () {
        eventsEndpoint.categories.eventsCategories({ParentCategoryID: $scope.activeModule.masterCategoryID}, function (data) {
            $scope.categories = data;
        })
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    $scope.organizationsQuerySearch = function (query) {
        var results = query ? $scope.organizations.filter(createFilterFor(query)) : [];
        return results;
    };

    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };

    }
}

angular.module('app.pages.events').controller('NewMultipleRegistrationDialogController', NewMultipleRegistrationDialogController);

function NewMultipleRegistrationDialogController($scope, $rootScope, $mdDialog, eventsEndpoint, $location, Notification, events, DTOptionsBuilder, dtOptions, $interval, settingsEndpoint, appConfig, tranzilaEndpoint, pelecardEndpoint, $sce, studentsEndpoint, receiptsService) {

    $scope.newRegistration = {}
    $scope.eventNamesAndQuantities = [];
    $scope.payments = [];

    $scope.init = function () {
        $scope.events = events;
        $scope.events.forEach(function (cartEvent) {

            $scope.eventNamesAndQuantities.push({
                ID: cartEvent.event.ID,
                Name: cartEvent.event.Name,
                Quantity: cartEvent.quantity
            })
        });
        $scope.selectedTab = 0;
    };

    $scope.moveToNextStep = function () {
        $scope.selectedTab++;
    }

    $scope.userValidation = function () {
        if ($scope.newRegistration.LastName && $scope.newRegistration.FirstName && $scope.newRegistration.UserEmail && $scope.newRegistration.UserPhoneNumber) {
            if ($scope.newRegistration.LastName.length > 0 &&
                $scope.newRegistration.FirstName.length > 0 &&
                $scope.newRegistration.UserEmail.length > 0 && $scope.newRegistration.UserPhoneNumber.length > 0) {
                return true;
            }
        }
        return false;
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        clearAllIntervals()
        $mdDialog.cancel();
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', false)
        .withDOM('lrtip')


    /*************************************************  PAYMENTS  *****************************************************/
    /**
     * Get Price for event by student
     */
    $scope.getPrice = function () {
        var params = {};

        params.EventType = 1;
        params.SelectedEvents = JSON.stringify($scope.events);
        params.FirstName = $scope.newRegistration.FirstName;
        params.LastName = $scope.newRegistration.LastName;
        params.UserEmail = $scope.newRegistration.UserEmail;
        params.UserPhoneNumber = $scope.newRegistration.UserPhoneNumber;

        eventsEndpoint.price.post(params, function (data) {
            if (data.success === false) {
                Notification.error("לא ניתן לרשום משתתף זה");
                $mdDialog.hide();
            } else {
                $scope.items = data.Items;
                $scope.DealID = data.DealID;
                $scope.events = data.Items[0]
                $scope.newRegistration.Price = $scope.getTotalPrice($scope.items);
                $scope.newRegistration.NewPrice = $scope.newRegistration.Price;
                $scope.newRegistration.UserID = data.Items[0].ID;
                if ($scope.newRegistration.NewPrice > 0)
                    $scope.addPayment($scope.newRegistration.NewPrice);
            }
            $scope.moveToNextStep();
        })
    };

    $scope.getTotalPrice = function (items) {
        if (!items)
            return 0;
        var total = 0;
        items[0]['SelectedEvents'].forEach(function (event) {
            total += parseFloat(event.NewPrice);
        })
        return total;
    }

    $scope.addPayment = function (amount) {
        var payment = getEmptyPayment();
        payment.Amount = amount;
        payment.Email = $scope.newRegistration.UserEmail;
        payment.Name = $scope.newRegistration.FirstName + ' ' + $scope.newRegistration.LastName;
        payment.FirstName = $scope.newRegistration.FirstName;
        payment.LastName = $scope.newRegistration.LastName;
        $scope.payments.push(payment);
    };

    function getEmptyPayment() {
        return {
            Type: '',
            Amount: '',
            AccountName: '',
            BankNumber: '',
            BranchNumber: '',
            AccountNumber: '',
            fileReceipt: '',
            fileName: '',
            BrandAccountNumber: '',
            CheckOwner: '',
            NumberOfCheck: '',
            checks: [],
            PaymentStatus: 1,
            iframe: '',
            FirstName: '',
            Name: '',
            LastName: '',
            Email: '',
            DealID: '',
            ReceiptID: '',
            RegistrationID: '',
            interval: false,
            paymentStatusDisabled: false,
        }
    }

    $scope.removePayment = function (index) {
        var amount = $scope.payments[index].Amount;
        $scope.payments.splice(index, 1);
        $scope.payments[$scope.payments.length - 1].Amount += amount;
    };

    $scope.addPaymentMissingPrice = function () {
        var sum = 0;
        $scope.payments.forEach(function (payment) {
            sum += payment.Amount;
        })
        var newAmount = $scope.getTotalPrice($scope.items);
        newAmount -= sum;
        $scope.addPayment(newAmount);
    };

    $scope.savePayment = function (index) {
        $scope.payments[index].ReceiptID = 'saved';
    };


    function clearAllIntervals() {
        $scope.payments.forEach(function (payment) {
            if (payment.interval)
                $interval.cancel(payment.interval);
        })
    }

    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    };

    $scope.changePaymentStatusByType = function (payment) {
        payment.paymentStatusDisabled = false;

        if ($rootScope.AdminLevel < 3) {
            payment.paymentStatusDisabled = true;
        }
        switch (payment.Type) {
            case 0://free
                break;
            case 1://credit card
                payment.PaymentStatus = 1;
                payment.paymentStatusDisabled = true;
                break;
            case 2://cash
                if ($rootScope.AdminLevel < 3) {
                    payment.PaymentStatus = 2;//payed to coordinator
                } else {
                    payment.PaymentStatus = $rootScope.advancedCashierOptions ? 5 : 1;
                }
                break;
            case 3://bank transfer
                payment.PaymentStatus = 1;
                payment.paymentStatusDisabled = true;
                break;
            case 4://checks
                if ($rootScope.AdminLevel < 3) {
                    payment.PaymentStatus = 2;//payed to coordinator
                } else {
                    payment.PaymentStatus = $rootScope.advancedCashierOptions ? 5 : 1;
                }
                break;
            case 11://credit card monthly
                payment.PaymentStatus = 1;
                payment.paymentStatusDisabled = true;
                break;
        }
    }

    /**
     * Check the payment type
     */
    $scope.checkIfNoCharge = function (index) {
        $scope.success = false;
        var payment = $scope.payments[index];
        $scope.changePaymentStatusByType(payment);
        if (payment.Type == 3) {
            settingsEndpoint.accountancy.banks.get({},function (data) {
                $scope.banks = data;
            })
        } else {
            /* if (!$scope.copy)
                 $scope.copy = angular.copy($scope.event.Price);
             if (payment.Type == 0)
                 $scope.event.Price = 0;
             else
                 $scope.event.Price = $scope.copy;*/
            if (payment.Type == 1) {
                $scope.getIframe(payment);
                if (payment.interval)
                    $interval.cancel(payment.interval);
                payment.interval = $interval(function () {
                    if (!params)
                        var params = {
                            DealID: payment.DealID
                        };
                    if ($scope.success) {
                        $interval.cancel(payment.interval);
                        return;
                    }
                    params.Type = payment.Type;
                    if (appConfig.paymentCompany == 1) {
                        tranzilaEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                    $scope.success = true;
                                    payment.ReceiptID = data['receiptID'];
                                    payment.RegistrationID = data['registrationID'];
                                    $interval.cancel(payment.interval);
                                    $scope.restrictDialogClose = true;
                                    payment.iframe = false;
                                } else {
                                    Notification.error("שגיאה")
                                }
                                $scope.success = true;
                                $interval.cancel(payment.interval);
                            }

                        })
                    } else {
                        pelecardEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                    $scope.success = true;
                                    payment.ReceiptID = data['receiptID'];
                                    payment.RegistrationID = data['registrationID'];
                                    $interval.cancel(payment.interval);
                                    $scope.restrictDialogClose = true;
                                    payment.iframe = false;
                                } else {
                                    Notification.error("שגיאה")
                                }
                                $scope.success = true;
                                //$mdDialog.hide();
                                $interval.cancel(payment.interval);
                            }

                        })
                    }

                }, 4000);
            } else if (payment.interval)
                $interval.cancel(payment.interval);
        }

        if (payment.Type === 4) {
            payment.checks = [];
        }
    };

    /**
     * Get pelecrd iframe
     */
    $scope.getIframe = function (payment) {
        var items = JSON.stringify(angular.copy($scope.items));
        var params = {};
        params.Total = $scope.getTotalPrice($scope.items);
        //params.Payments = $scope.event.MaxPayments;
        params.DealID = $scope.DealID;
        params.Amount = payment.Amount;
        params.Items = items;
        params.Name = payment.Name;
        params.Email = payment.Email;
        if (appConfig.paymentCompany == 1) {
            tranzilaEndpoint.get(params, function (data) {
                payment.iframe = data.Iframe;
                payment.DealID = data.DealID;
            });
        } else {
            pelecardEndpoint.get(params, function (data) {
                payment.iframe = data.Iframe;
                payment.DealID = data.DealID;
            });
        }
    };

    $scope.generateChecks = function (index) {
        $scope.payments[index].checks = [];
        for (var i = 0; i < $scope.payments[index].NumberOfCheck; i++) {
            $scope.payments[index].checks.push({
                CheckBank: undefined,
                CheckBranch: '',
                CheckAccountNumber: '',
                CheckNumber: '',
                CheckMaturityDate: '',
                CheckAmount: '',
            });
        }
    };

    $scope.paymentsValidity = function () {
        var totalSum = 0;
        for (var i = 0; i < $scope.payments.length; i++) {
            var priceToCharge = $scope.payments[i].Amount;
            totalSum += priceToCharge;
            if ($scope.payments[i].ReceiptID == '')
                return false;
            if ($scope.payments[i].checks.length === 0)
                continue;

            for (var j = 0, sum = 0; j < $scope.payments[i].checks.length; j++) {
                sum += $scope.payments[i].checks[j].CheckAmount;
            }
            if (sum !== priceToCharge) {
                return false;
            }
        }

        return $scope.getTotalAmountsValidity();
    };

    $scope.getTotalAmountsValidity = function () {
        var totalPrice = $scope.getTotalPrice($scope.items);
        var sum = 0;
        for (var i = 0; i < $scope.payments.length; i++) {
            if ($scope.payments[i].Type != 1 || ($scope.payments[i].Type == 1 && $scope.payments[i].ReceiptID != ''))
                sum += $scope.payments[i].Amount;
        }
        return sum === totalPrice;
    }

    $scope.checkChecksValidity = function (payment) {
        if (payment.Type != 4)
            return true;
        var tmp = 0;
        payment.checks.forEach(function (check) {
            tmp += check.CheckAmount;
        });
        return tmp == payment.Amount;
    }

    /**
     * Save the new Registration
     */
    $scope.saveNewRegistration = function (newReg) {
        $scope.isClicked = true;
        $scope.newRegistration.Items = JSON.stringify(angular.copy($scope.items));
        $scope.newRegistration.MultipleRegistrations = true;
        $scope.newRegistration.EventType = 1;

        if ($scope.payments.length > 0)
            $scope.newRegistration.payments = $scope.payments;
        else {
            $scope.newRegistration.PaymentType = 0;
        }

        studentsEndpoint.events.multiple.post($scope.newRegistration, function (data) {
            if (data.success) {
                Notification.success("הרשמה בוצעה בהצלחה!");
                if (data.Receipts) {
                    data.Receipts.forEach(function (ReceiptID) {
                        downloadReceipt(ReceiptID);
                    })
                }
            } else
                Notification.error("התרחשה שגיאה");
            $scope.isClicked = false;
            $scope.closeDialog();
        })
    };

    function downloadReceipt(receiptID) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receiptID, 1)
    };
}

angular.module('app.pages.event-management').controller('EventManagementController', EventManagementController);

function EventManagementController($scope, $rootScope, $location, usersEndpoint, $mdSidenav, $mdDialog, settingsEndpoint, DTOptionsBuilder, $timeout, parent, parentsEndpoint, dtOptions, Notification, event, eventsEndpoint, gradesEndpoint, $element, appConfig, settlementsEndpoint, organizationsEndpoint, locationsEndpoint, coordinatorsEndpoint) {


    $scope.association = {};
    $scope.watchCount = 0;
    $scope.logo = appConfig.logo;
    $scope.activeModule = undefined;
    $scope.disableLocationSelect = false;
    $scope.floatRegex = /^[+-]?\d+(\.\d+)?$/;

    $scope.xx = function (a, b, c) {
        return true;
    }
    $scope.validateDates = function (type, message) {
        if ($scope.event && $scope.event.Level == 1)
            return true;
        if (!$scope.event)
            return true;
        var event = true;
        var format = 'DD/MM/YYYY HH:mm';
        if ($scope.event.StartDate && $scope.event.EndDate)
            event = moment($scope.event.StartDate, format) < moment($scope.event.EndDate, format);
        var registration = true;
        if ($scope.event.RegistrationStartDate && $scope.event.RegistrationEndDate)
            registration = moment($scope.event.RegistrationStartDate, format) < moment($scope.event.RegistrationEndDate, format);
        var combined = true;
        if ($scope.event.EndDate && $scope.event.RegistrationEndDate)
            combined = moment($scope.event.EndDate, format) >= moment($scope.event.RegistrationEndDate, format);
        if (!event && (!type || type == 1)) {
            Notification.error('תאריכי אירוע לא תקינים');
        }
        if (!registration && (!type || type == 2)) {
            Notification.error('תאריכי הרשמה לא תקינים');
        }
        if (!combined && (!type || type == 3)) {
            Notification.error('תאריך סוף הרשמה אינו יכול להיות אחרי תאריך סוף אירוע')
        }
        return event && registration && combined;
    }

    $scope.generateFastLink = function () {
        var url = '';
        if ($scope.event.EventType == 1)
            url = appConfig.productionExternalPath + 'fast-link/' + $scope.event.ID;
        else
            url = appConfig.prodctionProfilePath + 'events/fast-link/' + $scope.event.ID;
        navigator.clipboard.writeText(url).then(function () {
            Notification.success('קישור הועתק בהצלחה');
        }, function (error) {
            Notification.error('התרחשה שגיאה');
        })
    }

    $scope.getCoordinators = function () {
        var params = {
            Status: 1
        }
        coordinatorsEndpoint.get(params, function (data) {
            $scope.coordinators = data;
        })
    }

    $scope.getOrganizations = function () {
        organizationsEndpoint.get(function (data) {
            $scope.organizations = data["movements"].map(function (org) {
                return {Name: org}
            });
        });
    };

    $scope.getLocations = function () {
        locationsEndpoint.get({Status: 1}, function (data) {
            $scope.locations = data.filter(function (e) {
                return e['CanBeUsed'];
            });
        })
    }

    $scope.getEventLocation = function () {
        eventsEndpoint.locations.get($scope.event.ID, function (data) {
            $scope.event.location = data;
            $scope.event.location.layout = JSON.parse($scope.event.location.layout);
        });
    }

    $scope.getEventLocationReport = function () {
        eventsEndpoint.locations.report($scope.event.ID, function () {

        })
    }

    $scope.markSeatAsNotAvailable = function (sectionID, rowID, seatID, seat) {
        var params = {
            LocationID: $scope.event.LocationID,
            SectionID: sectionID,
            RowID: rowID,
            SeatID: seatID,
            EventID: $scope.event.ID
        };
        if (seat.notAvailable == 2)
            return;
        else {
            params.Op = seat.notAvailable == 1 ? 'delete' : 'create';
            locationsEndpoint.occupiedSeats.update.post(params, function (data) {
                seat.notAvailable = seat.notAvailable == 1 ? 0 : 1;
            })
        }
    }


    /**
     * Init Student Profile
     */
    function init() {
        $scope.activeModule = event.getActiveModule();
        var eventObject = {};
        eventObject.ID = $location.search().ID;
        $scope.getOrganizations();
        $scope.getLocations();
        if (!eventObject.ID || !$scope.activeModule) {
            $location.path('/events');
        } else {
            resolveEvent(eventObject);
        }
        //add query change listener for the fast search
        /*$scope.currentEventID = null;
        $rootScope.fastSearchWatch = $scope.$watch(function () {
            return $location.search()
        }, function (data) {
            if ($scope.currentEventID !== null && data.ID !== $scope.currentEventID) {
                if (data.ID) {
                    eventObject = {};
                    eventObject.ID = data.ID;
                    if (!eventObject.ID) {
                        $location.path('/events');
                    } else {
                        resolveEvent(eventObject);
                    }
                }
            }

        });*/
    }

    init();

    /**
     * resolve the event by the ID stored in the eventObject
     * @param eventObject
     */
    function resolveEvent(eventObject) {
        eventsEndpoint.get(eventObject, function (data) {
            if (data[0]) {
                $scope.activeModule = event.getActiveModule();
                if ($scope.activeModule.name != data[0].GeneralEventType) {
                    event.setActiveModule(data[0].GeneralEventType);
                    $scope.activeModule = event.getActiveModule();
                }
                $scope.event = data[0];
                $scope.getGlobalMaxNumOfPayments();
                $scope.event.exposedOrganizations = [];
                event.updateSelectedEvent($scope.event);
                getEvents();
                getAllEvents();
                $scope.getSettlements();
                $scope.getAssociation();
                $scope.getAllGrades();
                $scope.getTotalDonations();
                $scope.getEventCategories();
                if ($scope.event.LocationID)
                    $scope.getEventLocation();
                if (!$scope.event.Groups)
                    $scope.event.Groups = [];
                $scope.currentEventID = $scope.event.ID;
                $scope.disableLocationSelect = $scope.testIfDatePassed($scope.event['RegistrationStartDate']);
            } else
                $location.path('/events');

        });
    }

    $scope.testIfDatePassed = function (dateString) {
        if(!dateString ||!dateString.length) {
            return true;
        }
        var parts = dateString.split(' ');
        var datePart = parts[0];
        var timePart = parts[1];
        var dateParts = datePart.split('/');
        var day = dateParts[0];
        var month = dateParts[1];
        var year = dateParts[2];
        var swappedDateString = month + '/' + day + '/' + year + ' ' + timePart;
        return Date.parse(swappedDateString) < Date.now();
    }


    /**
     * Look for changes in the event object
     */
    $scope.$watch('event', function (newValue, oldValue) {
        if (!$scope.validateDates()) {
            return;
        }
        if (!newValue && !oldValue)
            return;
        if (oldValue && newValue && newValue['MemberEvent'] != oldValue['MemberEvent'] && newValue['MemberEvent'] == 0) {
            $scope.event['MemberYear'] = 0;
        }
        if (oldValue && newValue && (!isNaN(newValue['LocationID']) && newValue['LocationStartDate'] != oldValue['LocationStartDate'] || newValue['LocationEndDate'] != oldValue['LocationEndDate'])) {
            eventsEndpoint.locations.checkOccupancy({
                eventID: $scope.event.ID,
                start: $scope.event.LocationStartDate,
                end: $scope.event.LocationEndDate
            }, function (data) {
                if (!data.success && data.message) {
                    Notification.error(data.message);
                    $scope.invalidLocationDates = true;
                }
                if (data.success) {
                    $scope.invalidLocationDates = false;
                    $rootScope.editDataHandler(newValue, oldValue, 'event-management');
                }
            })
            return;
        }
        if ($rootScope.editDataHandler && oldValue) {
            if ((newValue['Address'] === undefined && oldValue['Address'] !== undefined) || $scope.invalidLocationDates)
                return;
            else
                $rootScope.editDataHandler(newValue, oldValue, 'event-management')
        }
    }, true);

    /**
     * Get Events
     */
    function getEvents() {
        var params = {};
        params.Limit = 10000;
        params.Master = 1;
        params.WithOutEventID = $scope.event.ID;
        eventsEndpoint.get(params, function (data) {
            $scope.events = data;
        })
    }

    /**
     * Get Events
     */
    function getAllEvents() {
        var params = {};
        params.Limit = 10000;
        params.WithOutEventID = $scope.event.ID;
        eventsEndpoint.get(params, function (data) {
            $scope.allEvents = data;
        })
    }

    /**
     * Set selected tab index
     * @param tab
     */
    $scope.setTab = function (tab) {
        $scope.selectedTab = tab;
    };

    /**
     * Check if the year is set
     */
    $scope.checkIfYearIsSet = function () {
        if ($scope.event.MemberEvent == 0)
            $scope.event.MemberYear = null;
    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });

    $scope.clearSearchTerm = function () {
        $scope.searchTerm = '';
    };

    $scope.updateImage = function () {
        $mdDialog.show({
            controller: 'UploadController',
            templateUrl: 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'events',
                uploadID: $scope.event.ID + "/image",
                restrictTo: []
            }
        }).then(function () {
            $scope.event.Image = $rootScope.fileResp.data.Path;
        });
    };


    /******************************************************** Event Associations Start ********************************************************/

    /**
     * Get Event Association
     */
    $scope.getAssociation = function () {
        $scope.association = {};
        eventsEndpoint.association.get($scope.event, function (data) {
            $scope.association.Settlements = data.Settlements;
            $scope.association.Grades = data.Grades;
            $scope.association.Members = data.Members;
        });
    };

    /**
     * Update the event association
     */
    $scope.updateEventAssociation = function () {
        $scope.isClick = true;
        var params = {
            EventID: $scope.event.ID,
            Settlements: JSON.stringify($scope.association.Settlements),
            Grades: JSON.stringify($scope.association.Grades)
        }
        eventsEndpoint.association.update.post(params, $scope.event, function (data) {
            $scope.isClick = false;
        })
    };


    /**
     * Get All Grades
     */
    $scope.getAllGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
            $scope.grades2 = data;

        })
    };

    /**
     * grades query search
     * @param query
     * @returns {Array}
     */
    $scope.gradesQuerySearch = function (query) {
        var results = query ?
            $scope.grades.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * grades query search
     * @param query
     * @returns {Array}
     */
    $scope.grades2QuerySearch = function (query) {
        var results = query ?
            $scope.grades2.filter(createFilterFor(query)) : [];
        return results;
    };


    /**
     * Look for changes in Settlements and remove the selected settlements
     */
    $scope.$watchCollection('association.Settlements', function (newValue, oldValue) {
        angular.forEach($scope.settlements, function (settlementsValue) {
            angular.forEach($scope.association.Settlements, function (dataValue) {
                if (settlementsValue.ID === dataValue.ID) {
                    var index = $scope.settlements.indexOf(settlementsValue);
                    if (index != -1)
                        $scope.settlements.splice(index, 1);
                }
            });
        });
        var flag = false;
        angular.forEach(oldValue, function (oldValueValue) {
            angular.forEach(newValue, function (newValueValue) {
                if (newValueValue.ID == oldValueValue.ID) {
                    flag = true
                }
            });
            if (!flag)
                $scope.settlements.push(oldValueValue);
            flag = false;
        });
    });

    /**
     * Look for changes in Grades and remove the selected grade
     */
    $scope.$watchCollection('association.Grades', function (newValue, oldValue) {
        angular.forEach($scope.grades, function (gradesValue) {
            angular.forEach($scope.association.Grades, function (dataValue) {
                if (gradesValue.ID === dataValue.ID) {
                    var index = $scope.grades.indexOf(gradesValue);
                    if (index != -1)
                        $scope.grades.splice(index, 1);
                }
            });
        });
        var flag = false;
        angular.forEach(oldValue, function (oldValueValue) {
            angular.forEach(newValue, function (newValueValue) {
                if (newValueValue.ID == oldValueValue.ID) {
                    flag = true
                }
            });
            if (!flag)
                $scope.grades.push(oldValueValue);
            flag = false;
        });
    });


    $scope.addNewStudentAssociation = function () {
        $mdDialog.show({
            controller: 'NewStudentAssociation',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/association/new-student-association-dialog/new-student-association-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getAssociation();
        });
    };

    $scope.changeStudentStatus = function (student) {
        var params = {};
        params.EventID = $scope.event.ID;
        params.StudentID = student.StudentID;
        params.AssociationID = student.ID;
        params.Status = student.Status;
        eventsEndpoint.association.members.update.post(params, function (data) {
            if (data)
                Notification.success("סטטוס עודכן בהצלחה")
        })
    };


    $scope.uploadExcelFile = function () {
        $mdDialog.show({
            controller: 'UploadController',
            templateUrl: 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'events',
                uploadID: $scope.event.ID + "/association/members",
                restrictTo: ['xlsx', 'csv']
            }
        }).then(function () {
            $scope.getAssociation();
        });
    }

    $scope.downloadEmptyStudentsAssociationFile = function () {
        eventsEndpoint.association.members.emptyFile.get({EventID: $scope.event.ID}, function () {

        })
    }

    $scope.resetMonthlyPayment = function () {
        if ($scope.event.MonthlyPayment != 1) {
            $scope.event.ExtraPrice = undefined;
            $scope.event.RegNeedApproval = 0;
        }
    }
    /******************************************************** Event Prices By Settlements Start ********************************************************/

    $scope.createNewPriceBySettlement = function () {
        $mdDialog.show({
            controller: 'NewSettlementPriceController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/payments/new-settlement-price-dialog/new-settlement-price-dialog.html',
            clickOutsideToClose: false,
            locals: {eventID: $scope.event.ID}
        }).then(function () {
            $scope.getPriceBySettlements();
        });
    };

    $scope.getPriceBySettlements = function () {
        $scope.priceBySettlements = [];
        eventsEndpoint.branches.price.get($scope.event.ID, function (data) {
            $scope.priceBySettlements = data;
        })
    };

    $scope.changeSettlementPriceStatus = function (priceBySettlement) {
        if (priceBySettlement.Status)
            priceBySettlement.Status = 0;
        else
            priceBySettlement.Status = 1;

        eventsEndpoint.branches.price.update.post(priceBySettlement, function (data) {
            Notification.success("סטטוס עודכן בהצלחה");
        })
    };

    /******************************************************** Event Association End ********************************************************/

    /*********************************************************Event Price By Groups Start**************************************************/


    $scope.createNewPriceByGroup = function () {
        $mdDialog.show({
            controller: 'NewGroupPriceController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/payments/new-group-price-dialog/new-group-price-dialog.html',
            clickOutsideToClose: false,
            locals: {eventID: $scope.event.ID}
        }).then(function () {
            $scope.getPriceByGroups();
        });
    };

    $scope.getPriceByGroups = function () {
        $scope.priceByGroups = [];
        eventsEndpoint.groups.price.get($scope.event.ID, function (data) {
            $scope.priceByGroups = data;
        })
    };

    $scope.changeGroupPriceStatus = function (priceByGroup) {
        if (priceByGroup.Status)
            priceByGroup.Status = 0;
        else
            priceByGroup.Status = 1;

        eventsEndpoint.groups.price.update.post(priceByGroup, function (data) {
            Notification.success("סטטוס עודכן בהצלחה");
        })
    };

    /*********************************************************Event Price By Group End******************************************************/

    /******************************************************** Event Fees Start ********************************************************/

    //not in use since number of credit payments is chosen inside the Iframe, and we have no control over it

    /*$scope.getEventFees = function(){
        eventsEndpoint.fees.get($scope.event.ID,function (data) {
            $scope.fees = data;
        })
    }

    $scope.createNewFee = function () {
        $mdDialog.show({
            controller: 'NewEventFeeController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/payments/new-event-fee-dialog/new-event-fee-dialog.html',
            clickOutsideToClose: false,
            locals : {event : $scope.event,fees: $scope.fees}
        }).then( function () {
            $scope.getEventFees();
        });
    }

    $scope.deleteEventFee = function (fee) {
        eventsEndpoint.fees.delete(fee,function(data){
            $scope.getEventFees();
        })
    }*/

    /******************************************************** Event Fees End ********************************************************/

    /******************************************************** Event suggestions ********************************************************/

    $scope.filterEventSuggestions = 1;
    $scope.suggestions = [];

    $scope.getSuggestions = function () {
        $scope.loadingSuggestions = false;
        eventsEndpoint.suggestions.get($scope.event.ID, function (data) {
            $scope.suggestions = data;
            $scope.loadingSuggestions = true;
        });
    }

    $scope.createNewEventSuggestion = function () {
        $mdDialog.show({
            controller: 'NewEventSuggestionController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/suggestions/new-suggestion-dialog/new-suggestion-dialog.html',
            clickOutsideToClose: false,
            locals: {event: $scope.event}
        }).then(function () {
            $scope.getSuggestions();
        });
    }

    $scope.changeSuggestionStatus = function (suggestion) {
        suggestion.Status = suggestion.Status == 1 ? 0 : 1;
        eventsEndpoint.suggestions.update({ID: suggestion.SuggestionID, Status: suggestion.Status}, function () {
            Notification.success('עדכון בוצע בהצלחה');
        });
    }
    /******************************************************** Event suggestions End********************************************************/

    /******************************************************** Event donations *************************************************************/

    $scope.getDonations = function () {
        if (!$scope.donations) {
            eventsEndpoint.donations.get($scope.event.ID, function (data) {
                $scope.donations = data;
            });
        }
    }

    $scope.getTotalDonations = function () {
        eventsEndpoint.donations.total($scope.event.ID, function (data) {
            $scope.totalDonations = data;
        });
    }

    /******************************************************** Event donations End *********************************************************/

    /******************************************************** Event meeting days *********************************************************/

    $scope.getMeetingDays = function () {
        $scope.disableMeetings = true;
        eventsEndpoint.meetingDays.get({EventID: $scope.event.ID}, function (data) {
            data.forEach(function (meeting) {
                var time = meeting.StartTime.split(':');
                meeting.StartTime = new Date(1970, 0, 1, time[0], time[1], 0);
                time = meeting.EndTime.split(':');
                meeting.EndTime = new Date(1970, 0, 1, time[0], time[1], 0);
            })

            $scope.meetingDays = data;
            $scope.disableMeetings = false;
        })
    }
    $scope.createMeetingDay = function () {
        $scope.disableMeetings = true;
        var meetingDay = {
            EventID: $scope.event.ID,
            RepeatType: $scope.event.RepeatType,
            Day: $scope.event.RepeatType == 1 ? moment().format('DD/MM/YYYY') : 1,
            StartTime: '08:00',
            EndTime: '09:00'
        }
        eventsEndpoint.meetingDays.post(meetingDay, function (data) {
            if (data.success)
                $scope.getMeetingDays();
            else
                Notification.error('התרחשה שגיאה');
            $scope.disableMeetings = false;
        })
    }

    $scope.updateMeetingDay = function (meetingDay) {
        $scope.disableMeetings = true;
        var newObj = Object.assign({}, meetingDay)
        newObj.StartTime = newObj.StartTime.getHours() + ':' + newObj.StartTime.getMinutes();
        newObj.EndTime = newObj.EndTime.getHours() + ':' + newObj.EndTime.getMinutes();
        eventsEndpoint.meetingDays.update(newObj, function (data) {
            if (!data.success)
                Notification.error('התרחשה שגיאה');
            $scope.disableMeetings = false;
        })
    }

    $scope.deleteMeetingDay = function (meetingDay) {
        $scope.disableMeetings = true;
        eventsEndpoint.meetingDays.delete(meetingDay, function (data) {
            if (data.success)
                $scope.getMeetingDays();
            else
                Notification.error('התרחשה שגיאה');
            $scope.disableMeetings = false;
        })
    }

    /******************************************************** Event meeting days End *********************************************************/

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withOption('responsive', true)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');

    $scope.moveToMemberPrifile = function (reg) {
        if (reg.StudentID)
            $location.url('/student-profile?ID=' + reg.StudentID);
        else
            $location.url('/parent-profile?ID=' + reg.ParentID);
    };

    $scope.organizationsQuerySearch = function (query) {
        var results = query ? $scope.organizations.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.settlementsQuerySearch = function (query) {
        var results = query ? $scope.settlements.filter(createFilterFor(query)) : [];
        return results;
    };

    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })
    };


    $scope.getGlobalMaxNumOfPayments = function () {
        settingsEndpoint.accountancy.maxPayments.get(function (data) {
            $scope.globalMaxNumOfPayments = data.max > 0 ? data.max : 100;
            if ($rootScope.User.MaxNumOfPayments) {
                $scope.globalMaxNumOfPayments = Math.min($rootScope.User.MaxNumOfPayments, $scope.globalMaxNumOfPayments);
            }
        },{EventID: $scope.event.ID })
    }
    /*******************************************************************************************************************/

    $scope.getEventCategories = function () {
        eventsEndpoint.categories.eventsCategories({ParentCategoryID: $scope.activeModule.masterCategoryID}, function (data) {
            $scope.categories = data;
        })
    }
}

angular.module('app.pages.events').controller('QuestionPanelController', QuestionPanelController);
function QuestionPanelController($scope,question,$rootScope) {


    /**
     * Set the selected Question
     */
    $scope.$on('selectedQuestion:updated', function () {
        $scope.question = question.selectedQuestion;
    });

    /**
     * Look for changes in the selected Questions
     */
    $scope.$watch('question', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'question-panel')
    }, true);


};
angular.module('app.pages.events').controller('NewQuestionDialogController', NewQuestionDialogController);
function NewQuestionDialogController($scope, $mdDialog,questionsEndpoint,Notification,eventID,settlementsEndpoint) {

    $scope.newQuestion = {};
    $scope.newQuestion.Options = [];
    $scope.eventID = eventID;

    /**
     * Save new Question
     */
    $scope.saveNewQuestion = function () {
        $scope.isClicked = true;
        var params = {};
        params.newQuestion = $scope.newQuestion;
        params.eventID = $scope.eventID;


        questionsEndpoint.post(params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();


        })

    };

    $scope.getSettlements = function (){
        settlementsEndpoint.get({},function (data){
            $scope.settlements = data;
        })
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('EventMeetingPanelController', EventMeetingPanelController);
function EventMeetingPanelController($scope,eventMeeting,$rootScope) {


    /**
     * Set the selected Question
     */
    $scope.$on('selectedMeeting:updated', function () {
        $scope.meeting = eventMeeting.selectedMeeting;
    });

    /**
     * Look for changes in the selected Questions
     */
    $scope.$watch('meeting', function (newValue, oldValue) {
        if (typeof  $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'meeting-panel')
    }, true);


};

(function ()
{
    'use strict';

    angular.module('app.pages.event-meeting-management', ['datatables']).config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_event-meeting-management', {
            url      : '/meeting-management',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/events-extras/views/attendance/meeting-management/meeting-management.html',
                    controller: 'MeetingManagementController'
                }
            },
            resolve  : {
                DashboardData: function () {
                    localStorage.setItem("path", '/meeting-management');
                }
            },
            bodyClass: 'event-meeting-management'
        });


    }

})();

angular.module('app.pages.event-meeting-management').controller('MeetingManagementController', MeetingManagementController);

function MeetingManagementController($scope, $rootScope, $location, $mdSidenav, settlementsEndpoint, $mdDialog, DTOptionsBuilder, dtOptions, Notification, groupsEndpoint, $element, contactsEndpoint, contact, gradesEndpoint, eventsEndpoint, systemSettingsEndpoint) {


    function init() {
        var meeting = {};
        meeting.ID = $location.search().ID;
        if (!meeting.ID) {
            $location.path('/events-attendance');
        } else {
            resolveMeeting(meeting);
        }
    }

    /**
     * resolve the meeting by the ID stored in the meetingObject
     * @param meetingObject
     */
    function resolveMeeting(meetingObject) {
        eventsEndpoint.meetings.get(meetingObject, function (data) {

            if (data[0]) {
                $scope.meeting = data.find(function (meeting) {
                    return +meeting.ID === +meetingObject.ID;
                });
                $scope.getAttendance(meetingObject['ID']);
                $scope.getStatusValues();
            } else
                $location.path('/events-attendance');
        });
    }

    $scope.getAttendance = function (ID) {
        eventsEndpoint.meetings.attendance.get({MeetingID: ID}, function (data) {
            $scope.attendance = data;
        })
    }

    $scope.getStatusValues = function () {
        systemSettingsEndpoint.names.get(function (data) {
            $scope.statusArray = data.AttendenceStatus == "" ? [] : splitArray(data.AttendenceStatus);
        })
    }
    $scope.markMember = function (member) {
        member.Attendance = 'נוכח';
        $scope.updateAttendance(member);
    }

    function splitArray(str) {
        var newStr = str.replace(/[[]|[\]]/g, "").replace(/"/g, "");
        return newStr.split(",");
    }

    $scope.updateAttendance = function (student) {
        eventsEndpoint.meetings.attendance.update(student, function (data) {
            if (!data.success)
                Notification.error('התרחשה שגיאה בעדכון');
        })
    }

    $scope.$watchCollection('meeting', function (newValue, oldValue) {
        if (typeof $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'meeting-panel')
    });

    /**
     * Set selected tab index
     * @param tab
     */
    $scope.setTab = function (tab) {
        $scope.selectedTab = tab;
    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });

    $scope.clearSearchTerm = function () {
        $scope.searchTerm = '';
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', false)
        .withDOM('lrtip');

    init();
}

angular.module('app.pages.events').controller('NewEventMeetingController', NewEventMeetingController);
function NewEventMeetingController($scope, $mdDialog,Notification,eventsEndpoint,$location,$timeout) {

    $scope.newMeeting = {
        Date: moment().format('DD/MM/YYYY  HH:mm')
    };

    $scope.getEvents = function (name){
        var params = {
            Status: 1,
            FreeSearch: name
        };
        eventsEndpoint.get(params,function (data){
            $scope.events = data;
        })
    }

    $scope.eventKeyPress = function(event) {
        var currentState = event.target.value;
        $timeout(function () {
            if (currentState != undefined && currentState.length > 0 && currentState == event.target.value)
                $scope.getEvents(currentState);
        }, 1000)
    }

    /**
     * Save new Question
     */
    $scope.saveNewMeeting = function () {
        $scope.isClicked = true;
        eventsEndpoint.meetings.post($scope.newMeeting, function (data) {
            $scope.isClicked = false;
            if (data.ID) {
               $mdDialog.hide(data.ID)
            }
            else{
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();}
        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };


    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    $scope.createFilterFor = function(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

}

angular.module('app.pages.events').controller('TransportationStopsPanel',TransportationStopsPanel);
    function TransportationStopsPanel(transportation,$scope, $rootScope, $mdDialog,transportationEndpoint,student,$location,Notification) {

    $scope.transportation = transportation;
    $scope.transportation.Stops = $scope.transportation.Stops.map(function(stop){
        stop.expanded = false;
        return stop;
    })

    /**
     * Save new Transportation
     */
    $scope.saveNewStops = function () {
        $scope.isClicked = true;
        transportationEndpoint.stops.update($scope.transportation,function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();
        })
    };

    $scope.addNewStop = function(){
        $scope.transportation.Stops.push({
            TransportationID: $scope.transportation.ID,
            Name: '',
            Description: '',
            Status: 1,
            order: $scope.transportation.Stops.length + 1,
            expanded: true
        })
    }

    $scope.deleteStop = function(index){
        $scope.transportation.Stops.splice(index,1);
    }
    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.events').controller('NewTransportationDialogController', ['$scope', '$rootScope', '$mdDialog','transportationEndpoint','student','$location','Notification', function ($scope, $rootScope, $mdDialog,transportationEndpoint,student,$location,Notification) {

    $scope.neTransportation = {};
    $scope.neTransportation.Options = [];

    /**
     * Save new Transportation
     */
    $scope.saveNewTransportation = function () {
        $scope.isClicked = true;
        transportationEndpoint.post($scope.newTransportation,function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();
        })
    };
    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };



}]);

angular.module('app.pages.events').controller('TransportationPanelController', ['$scope','transportation','$rootScope', function($scope,transportation,$rootScope) {

    /**
     * Set the selected Transportation
     */
    $scope.$on('selectedTransportation:updated', function() {
        $scope.transportation= transportation.selectedTransportation;
    });


    /**
     * Look for changes in the transportation
     */
    $scope.$watch('transportation',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'transportation-panel')
    },true);




}]);
angular.module('app.pages.users').controller('GroupsPanelController', GroupsPanelController);
function GroupsPanelController($scope,group,$rootScope,gradesEndpoint,settlementsEndpoint) {

    /**
     * Set the selected group
     */
    $scope.$on('selectedGroup:updated', function () {
        $scope.orignalObject = false;
        $scope.group = group.selectedGroup;
        $scope.getSettlements();
        $scope.getGrades();
    });

    /**
     * Look gor changes on the group object
     */
    $scope.$watchCollection('group', function (newValue) {
        if (!$scope.orignalObject)
            $scope.orignalObject = angular.copy(newValue);

        angular.forEach(newValue, function (value, key) {
            if (newValue[key] != $scope.orignalObject[key] && (key == 'BranchID' || key == 'GradeID' || key == 'SettlementID')) {
                if (key == 'BranchID') {
                    angular.forEach($scope.branches, function (branchValue, branchKey) {
                        if ($scope.branches[branchKey].ID == value)
                            newValue.BranchName = $scope.branches[branchKey].Name;
                    })
                }
                if(key == 'SettlementID'){

                    newValue.City = $scope.settlements.filter(function(settlement){

                        return settlement.ID === value;
                    })[0]['Name'];
                }
                else {
                    angular.forEach($scope.grades, function (gradesValue, gradesKey) {
                        if ($scope.grades[gradesKey].ID == value)
                            newValue.GradeName = $scope.grades[gradesKey].Name;
                    })
                }
            }
        })
    });

    /**
     * Look gor changes on the group object
     */
    $scope.$watchCollection('group', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'groups-panel')
    });

    /**
     * Get Settlements
     */
    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        });

    };

    /**
     * Get All Branches And Groups
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };

    $scope.clearSearchTerm = function() {
        $scope.searchTerm = '';
    };


}

(function ()
{
    'use strict';

    angular.module('app.pages.group-management', ['datatables']).config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_group-management', {
            url      : '/group-management',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/branches/views/groups/group-management/group-management.html',
                    controller: 'GroupManagementController'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken) {
                    ValidToken.validUserToken();
                    localStorage.setItem("path", '/group-management');
                }
            },
            bodyClass: 'group-management'
        });


    }

})();

angular.module('app.pages.group-management').controller('GroupManagementController',GroupManagementController);
function GroupManagementController($scope, $rootScope, $location, $mdSidenav,settlementsEndpoint, $mdDialog, DTOptionsBuilder, dtOptions, Notification, groupsEndpoint,$element, contactsEndpoint,contact,gradesEndpoint,studentsEndpoint,parentsEndpoint) {


    function init() {
        var groupObject = {};
        groupObject.ID = $location.search().ID;
        if (!groupObject.ID) {
            $location.url('/mange-groups');
        }
        else {
            resolveGroup(groupObject);
            $scope.getSettlements();
            $scope.getGrades();
        }
    }



    /**
     * resolve the group by the ID stored in the groupObject
     * @param groupObject
     */
    function resolveGroup(groupObject) {
        groupsEndpoint.get(groupObject, function (data) {
            if (data[0]) {
                $scope.group = data[0];
                $scope.getContacts();
                $scope.getStudents();
                $scope.getParents();
            }
            else
                $location.path('/branches');

        });
    }

    $scope.getStudents = function (){
        var params = {
            Status: 1,
            GroupID: $scope.group.ID
        }
        studentsEndpoint.get(params,function(data){
            $scope.groupStudents = data.data.items;
        })
    }

    $scope.getParents = function (){
        var params = {
            Status: 1,
            GroupID: $scope.group.ID
        }
        parentsEndpoint.get(params,function(data){
            $scope.groupParents = data.data.items;
        })
    }

    $scope.getSettlements = function (){
        settlementsEndpoint.get({},function (data){
            $scope.settlements = data;
        })
    }

    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };




    /*************contacts*****************/
    $scope.contactsSearch = {
        freeSearchFromDB: '',
        Status: 1
    }

    $scope.getContacts = function(reset){
        if(reset){
            $scope.contactsSearch = {
                freeSearchFromDB: '',
                Status: 1
            }
            return;
        }
        $scope.contacts = false;
        $scope.groupContacts = false;
        contactsEndpoint.get($scope.contactsSearch,function (data) {
            $scope.contacts = data;
            $scope.groupContacts = data.filter(function(contact){
                return contact.Groups.indexOf($scope.group.ID) !== -1;
            });
        });
    }

    $scope.addNewContact = function(){
        $mdDialog.show({
            controller: 'NewContactDialogController',
            templateUrl: 'app/main/pages/utils/views/contacts/new-contact-dialog/new-contact-dialog.html',
            clickOutsideToClose: false
        }).then(function(){
            $scope.getContacts();
        });
    }

    $scope.checkForExistingContact = function(contact){
        var existing = $scope.contacts.filter(function(c){
            return c.Name === contact.Name;
        });
        if(existing.length){
            contact = Object.assign(existing[0]);
        }
    }

    $scope.editContact = function (selectedContact) {
        contact.updateSelectedContact(selectedContact);
        $mdSidenav("contact-panel").open();
    };


    /*************contacts*****************/

    $scope.$watchCollection('group', function (newValue, oldValue) {
        if (typeof  $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'groups-panel')
    });

    /**
     * Set selected tab index
     * @param tab
     */
    $scope.setTab = function (tab) {
        $scope.selectedTab = tab;
    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });

    $scope.clearSearchTerm = function() {
        $scope.searchTerm = '';
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');

    init();
}

(function () {
    'use strict';

    angular
        .module('app.pages.branches', []).config(config).run(run);

    function run($rootScope, msNavigationService) {
        $rootScope.$watch('User', function () {

            /**
             * Set the pagFes by the admin level
             */
            if ($rootScope.AdminLevel && $rootScope.User) {
                msNavigationService.deleteItem('pages.branches');
                msNavigationService.saveItem('pages.branches', {
                    title: 'שלוחות',
                    icon: 'icon-domain',
                    weight: 2
                });
                switch ($rootScope.AdminLevel) {
                    case 1:
                        msNavigationService.deleteItem('pages.branches');
                        break;
                    case 2:
                        msNavigationService.saveItem('pages.branches.mange-groups', {
                            title: 'ניהול ' + $rootScope.User.Groups,
                            icon: 'icon-account-multiple',
                            state: 'app.pages_branches_mange-groups'
                        });
                        break;
                    case 3:
                        msNavigationService.saveItem('pages.branches.manage-settlements', {
                            title: 'ניהול '+ $rootScope.orgTypeBranchName.plural,
                            icon: 'icon-city',
                            state: 'app.pages_branches_manage-settlements'
                        });
                        msNavigationService.saveItem('pages.branches.mange-grades', {
                            title: 'ניהול ' + $rootScope.User.Grades,
                            icon: 'icon-chair-school',
                            state: 'app.pages_branches_mange-grades'
                        });
                        msNavigationService.saveItem('pages.branches.mange-groups', {
                            title: 'ניהול ' + $rootScope.User.Groups,
                            icon: 'icon-account-multiple',
                            state: 'app.pages_branches_mange-groups'
                        });


                }
            }
        });

    }

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.pages.branches', {
                abstract: true,
                url: '/branches'
            })
            .state('app.pages_branches_manage-settlements', {
                url: '/manage-settlements',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/branches/views/settlements/manage-settlements.html',
                        controller: 'ManageSettlementsController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/mange-settlements');
                    }
                },
                bodyClass: 'manage-settlements'

            })
            .state('app.pages_branches_mange-groups', {
                url: '/mange-groups',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/branches/views/groups/mange-groups.html',
                        controller: 'ManageGroupsController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/mange-groups');
                    }
                },
                bodyClass: 'branches'
            })
            .state('app.pages_branches_mange-grades', {
                url: '/mange-grades',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/branches/views/grades/mange-grades.html',
                        controller: 'ManageGradesController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/mange-grades');
                    }
                },
                bodyClass: 'branches'
            })
    }
})();


angular.module('app.pages.branches').controller('NewGroupDialogController', NewGroupDialogController);
function NewGroupDialogController($scope,$rootScope, $mdDialog,groupsEndpoint,Notification,gradesEndpoint, settlementsEndpoint) {

    $scope.settlements = [];
    /**
     * Save new Branch
     */
    $scope.saveNewGroup = function () {
        $scope.isClicked = true;
        groupsEndpoint.post($scope.newGroup, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה");
            $mdDialog.hide();
        })
    };


    /**
     * Get Settlements
     */
    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        });
    };

    /**
     * Get All Branches And Groups
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

(function ()
{
    'use strict';

    angular
        .module('app.pages.accountancy',  ['moment-picker']).config(config).run(run);

    function run($rootScope,msNavigationService) {
        $rootScope.$watch('User',function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel && ($rootScope.User.SuperAdmin == 1 || $rootScope.User.AccountancyPer == 1)) {
                switch ($rootScope.AdminLevel) {
                    case 3:
                        msNavigationService.saveItem('pages.accountancy', {
                            title : 'הנהלת חשבונות',
                            icon  : 'icon-credit-card-multiple',
                            weight: 5
                        });
                        if($rootScope.advancedCashierOptions){
                            msNavigationService.saveItem('pages.accountancy.accountancy_cashier', {
                                title : 'קופה',
                                icon  : 'icon-checkbox-multiple-marked-outline',
                                state : 'app.pages_accountancy_cashier'
                            });
                        }
                        msNavigationService.saveItem('pages.accountancy.accountancy_receipt-transaction', {
                            title : 'עסקאות אשראי',
                            icon  : 'icon-credit-card',
                            state : 'app.pages_accountancy_receipt-transaction'
                        });
                        msNavigationService.saveItem('pages.accountancy.accountancy_checks', {
                            title : 'המחאות',
                            icon  : 'icon-view-agenda',
                            state : 'app.pages_accountancy_checks'
                        });
                        msNavigationService.saveItem('pages.accountancy.accountancy_receipts', {
                            title : 'קבלות',
                            icon  : 'icon-file-document',
                            state : 'app.pages_accountancy_receipts'
                        });
                        msNavigationService.saveItem('pages.accountancy.accountancy_export-movements', {
                            title : 'יצוא תנועות',
                            icon  : 'icon-file-document-box',
                            state : 'app.pages_accountancy_export-movements'
                        });
                        msNavigationService.saveItem('pages.accountancy.accountancy_payments-match', {
                            title : 'התאמות חשבוניות',
                            icon  : 'icon-arrange-send-to-back',
                            state : 'app.pages_accountancy_payments-match'
                        });
                        break;
                }
            }
        });

    }
    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pages.accountancy', {
                abstract: true,
                url     : '/accountancy'
            })
            .state('app.pages_accountancy_cashier', {
                url      : '/cashier',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/accountancy/views/cashier/cashier.html',
                        controller : 'CashierController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/cashier');
                    }
                }
            })
            .state('app.pages_accountancy_receipt-transaction', {
                url      : '/receipt-transactions',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/accountancy/views/receipt-transactions/receipt-transactions.html',
                        controller : 'receiptTransactionsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/receipt-transactions');
                    }
                }
            })
            .state('app.pages_accountancy_checks', {
                url      : '/checks',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/accountancy/views/checks/checks.html',
                        controller : 'ChecksController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/checks');
                    }
                }
            })
            .state('app.pages_accountancy_receipts', {
                url      : '/receipts',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/accountancy/views/receipts/receipts.html',
                        controller : 'ReceiptsController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/receipts');
                    }
                }
            })
            .state('app.pages_accountancy_export-movements', {
            url      : '/export-movements',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/accountancy/views/export-movements/export-movements.html',
                    controller : 'ExportMovementsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/export-movements');
                }
            }
        })
            .state('app.pages_accountancy_payments-match', {
            url      : '/payments-match',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/accountancy/views/payments-match/payments-match.html',
                    controller : 'PaymentsMatchController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/payments-match');
                }
            }
        })
        ;





    }
})();


angular.module('app.pages.accountancy').controller('CreateBankReferenceFilesDialogContrtoller', CreateBankReferenceFilesDialogContrtoller);
function CreateBankReferenceFilesDialogContrtoller($scope,$rootScope, $mdDialog,pdfFilesService,receipts) {

    $scope.receipts = receipts;
    $scope.files = {
        Date: moment().format('DD/MM/YYYY')
    }
    $scope.isClicked = false;

    $scope.generateFiles = function (){
        $scope.isClicked = true;
        var params = {
            Date: $scope.files.Date,
            Receipts: JSON.stringify($scope.receipts)
        }
        pdfFilesService.getBankReference(params,function (data){
            $scope.closeDialog();
        })
    }

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

angular.module('app.pages.users').controller('ManageSettlementsPanelController', ManageSettlementsPanelController);
function ManageSettlementsPanelController($scope,settlement,$rootScope,settlementsEndpoint,$timeout) {


    /**
     * Set the selected branch
     */
    $scope.$on('selectedSettlement:updated', function () {
        $scope.settlement = settlement.selectedSettlement;
    });


    $scope.simulateQuery = false;
    $scope.isDisabled = false;

    // list of `state` value/display objects
    $scope.querySearch = querySearch;


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
        var results = query ? $scope.states.filter(createFilterFor(query)) : $scope.states,
            deferred;
        if ($scope.simulateQuery) {
            deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
            return results;
        }
    }


    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(state) {
            return (state.value.indexOf(lowercaseQuery) === 0);
        };

    }


    /**
     * Look for changes in the settlement
     */
    $scope.$watchCollection('settlement', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'manage-settlements-panel')
    })

}

angular.module('app.pages.branches').controller('NewGradesDialogController', NewGradesDialogController);
function NewGradesDialogController($scope, $mdDialog,gradesEndpoint,Notification) {

    /**
     * Save new Branch
     */
    $scope.saveNewGrade = function () {
        $scope.isClicked = true;
        gradesEndpoint.post($scope.newGrade, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("נכשל ביצירה");

            $mdDialog.hide();
        })
    };


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}
angular.module('app.pages.users').controller('GradesPanelController', GradesPanelController);
function GradesPanelController($scope,grade,$rootScope) {

    /**
     * Set the selected Geade
     */
    $scope.$on('selectedGrade:updated', function () {
        $scope.grade = grade.selectedGrade;
    });

    /**
     * Look for changes in the grade object
     */
    $scope.$watchCollection('grade', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'grades-panel')
    });

}
angular.module('app.pages.users').controller('PaymentMatchController', PaymentMatchController);
function PaymentMatchController($scope, $mdDialog,$location,dealID,paymentsEndpoint,DTOptionsBuilder,dtOptions) {

    var vm =this;

    vm.getDeal = getDeal;
    vm.closeDialog =closeDialog;


    function getDeal() {
        var params = {};
        params.DealID = dealID;
        paymentsEndpoint.deals.get(params,function (data) {
            vm.deal = data;
        })

    }

    function closeDialog() {
        $mdDialog.cancel();
    }

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');
}



(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_tabbed', {
            url  : '/ui/page-layouts/simple/tabbed',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/tabbed/tabbed.html',
                    controller : 'SimpleTabbedController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed')
        .controller('SimpleTabbedController', SimpleTabbedController);

    /** @ngInject */
    function SimpleTabbedController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav', {
            url  : '/ui/page-layouts/simple/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html',
                    controller : 'SimpleLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav')
        .controller('SimpleLeftSidenavController', SimpleLeftSidenavController);

    /** @ngInject */
    function SimpleLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-iii', {
            url  : '/ui/page-layouts/simple/right-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html',
                    controller : 'SimpleRightSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii')
        .controller('SimpleRightSidenavIIIController', SimpleRightSidenavIIIController);

    /** @ngInject */
    function SimpleRightSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-ii', {
            url  : '/ui/page-layouts/simple/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'SimpleRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii')
        .controller('SimpleRightSidenavIIController', SimpleRightSidenavIIController);

    /** @ngInject */
    function SimpleRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth-ii', {
            url  : '/ui/page-layouts/carded/fullwidth-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html',
                    controller : 'CardedFullwidthIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii')
        .controller('CardedFullwidthIIController', CardedFullwidthIIController);

    /** @ngInject */
    function CardedFullwidthIIController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_fullwidth', {
            url  : '/ui/page-layouts/simple/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/fullwidth/fullwidth.html',
                    controller : 'SimpleFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth')
        .controller('SimpleFullwidthController', SimpleFullwidthController);

    /** @ngInject */
    function SimpleFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav', {
            url  : '/ui/page-layouts/carded/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html',
                    controller : 'CardedLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav')
        .controller('CardedLeftSidenavController', CardedLeftSidenavController);

    /** @ngInject */
    function CardedLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth', {
            url  : '/ui/page-layouts/carded/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth/fullwidth.html',
                    controller : 'CardedFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth')
        .controller('CardedFullwidthController', CardedFullwidthController);

    /** @ngInject */
    function CardedFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav', {
            url  : '/ui/page-layouts/simple/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html',
                    controller : 'SimpleRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav')
        .controller('SimpleRightSidenavController', SimpleRightSidenavController);

    /** @ngInject */
    function SimpleRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-iii', {
            url  : '/ui/page-layouts/simple/left-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html',
                    controller : 'SimpleLeftSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii')
        .controller('SimpleLeftSidenavIIIController', SimpleLeftSidenavIIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-ii', {
            url  : '/ui/page-layouts/simple/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'SimpleLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii')
        .controller('SimpleLeftSidenavIIController', SimpleLeftSidenavIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav-ii', {
            url  : '/ui/page-layouts/carded/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'CardedRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii')
        .controller('CardedRightSidenavIIController', CardedRightSidenavIIController);

    /** @ngInject */
    function CardedRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_theme-colors', {
            url      : '/ui/theme-colors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/theme-colors/theme-colors.html',
                    controller : 'ThemeColorsController as vm'
                }
            },
            bodyClass: 'theme-colors'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('CustomThemeDialogController', CustomThemeDialogController);

    /** @ngInject */
    function CustomThemeDialogController(marvilixTheming, $mdDialog, marvilixGenerator, $cookies, $window)
    {
        // Data
        var vm = this;
        vm.palettes = marvilixTheming.getRegisteredPalettes();
        vm.themes = marvilixTheming.getRegisteredThemes();

        // Delete Unnecessary hue value
        delete vm.palettes.grey['1000'];

        // Methods
        vm.rgba = marvilixGenerator.rgba;
        vm.setTheme = setTheme;
        vm.closeDialog = closeDialog;

        //////////

        // If custom theme exist keep using it otherwise set default as a custom
        if ( !vm.themes.custom )
        {
            vm.theme = angular.copy(vm.themes['default'].colors);
        }
        else
        {
            vm.theme = vm.themes.custom.colors;
        }

        /**
         * Put custom theme into the cookies
         * and reload for generate styles
         */
        function setTheme()
        {
            $cookies.putObject('customTheme', vm.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav', {
            url  : '/ui/page-layouts/carded/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html',
                    controller : 'CardedRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav')
        .controller('CardedRightSidenavController', CardedRightSidenavController);

    /** @ngInject */
    function CardedRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav-ii', {
            url  : '/ui/page-layouts/carded/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'CardedLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii')
        .controller('CardedLeftSidenavIIController', CardedLeftSidenavIIController);

    /** @ngInject */
    function CardedLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
angular.module('app.pages.utils').controller('ReportsController', ['$scope', '$rootScope','$location' ,'reportsEndpoint','Notification','$timeout','$mdDialog','DTOptionsBuilder','dtOptions',
    function($scope, $rootScope,$location,reportsEndpoint,Notification,$timeout,$mdDialog,DTOptionsBuilder,dtOptions) {

    $scope.reports = [];

    /**
     * Get Reports
     */
    $scope.getReports = function () {
        $scope.reports = false;
        reportsEndpoint.get($scope.search,function (data) {
            $scope.reports = data;
        })

    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('responsive',true)
        .withOption('bFilter', false)
        .withDOM('lrtip');



    /**
     * Export report
     */
    $scope.exportReport = function (report) {
        $scope.isClicked=true;
        Notification.info("מייצר דוח אנא המתן..");
        $timeout(function () {
            if ($scope.isClicked)
            Notification.info("פעולה זו יכולה להימשך מספר שניות");
        },10000);
        reportsEndpoint.export.get(report.ID,function () {
            $scope.isClicked=false;

        })
    };


    /**
     * Open new Report Dialog
     */
    $scope.openNewReportDialog = function () {
        $mdDialog.show({
            controller         : 'NewReportDialogController',
            templateUrl        : 'app/main/pages/utils/views/reports/new-report-dialog/new-report-dialog.html',
            clickOutsideToClose: true
        }).then(function () {

        });
    };

    /**
     * Delete report dialog
     * @param report
     */
    $scope.deleteReportDialog = function (report,ev) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת דוח')
            .textContent('האם אתה בטוח/ה שברצונך למחוק דוח זה?')
            .targetEvent(ev)
            .ok('מחק')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function() {
            deleteReport(report);
        });
    };

    /**
     * Delete report
     * @param report
     */
    var deleteReport = function (report) {
        reportsEndpoint.delete.post(report.ID,function (data) {
            if (data.success) {
                Notification.success("דוח נמחק");
                $scope.getReports();
            }
            else
                Notification.error("נשכל במחיקת דוח");
        })
    };

}]);

angular.module('app.pages.utils').controller('FilesController', FilesController);

function FilesController(filesEndpoint,DTOptionsBuilder,dtOptions,$mdDialog,Notification,DTColumnDefBuilder) {

    var vm =this;
    vm.getFiles = getFiles;
    vm.deleteFileDialog= deleteFileDialog;
    vm.openNewFileDialog =openNewFileDialog;
    vm.updateDescription =updateDescription;
    vm.files = [];

    /**
     * Get Reports
     */
    function getFiles() {
        vm.files = false;
        filesEndpoint.get(vm.search,function (data) {
            vm.files = data;
        })

    }

    /**
     * Open delete file doalog
     * @param file
     */
    function deleteFileDialog(file) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת קובץ')
            .textContent('האם אתה בטוח/ה שברצונך למחוק קובץ זה?')
            .ok('מחיקה')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function() {
           deleteFile(file);
        });
    }

    /**
     * delete file
     * @param file
     */
    function deleteFile(file) {
        vm.files = false;
        filesEndpoint.delete.post(file,function (data) {
            vm.files = data;
            getFiles();
        })
    }

    function openNewFileDialog() {
        $mdDialog.show({
            controller         : 'UploadController',
            templateUrl        : 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {uploadTo: 'files',uploadID :'new',restrictTo :[]}
        }).then(function () {
            getFiles();
        });
    }

    function updateDescription(file) {
        filesEndpoint.update.post(file,function () {
          Notification.success("תיאור נשמר בהצלחה!")
        })
    }

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];

}



angular.module('app.pages.users').controller('ParentsController', ParentsController);

function ParentsController($scope, $rootScope, $mdSidenav, $mdDialog, $location, usersEndpoint, Notification, msUtils, $timeout, $document, DTColumnDefBuilder, DTOptionsBuilder, dtOptions, groupsEndpoint, parentsEndpoint, parent, $window, $cookies, appConfig, tagsEndpoint, gradesEndpoint, settlementsEndpoint, tokenEndpoint, recentSearchService) {

    var vm = this;

    vm.search = {};
    vm.search.Tags = [];
    vm.parents = [];
    vm.pageData = {total: 0};
    vm.getParents = getParents;
    vm.getTags = getTags;
    vm.tagsQuerySearch = tagsQuerySearch;
    vm.goToParentsPanel = goToParentsPanel;
    vm.loginToProfile = loginToProfile;
    vm.setAll = setAll;
    vm.openSendEmail = openSendEmail;
    vm.openSendSMS = openSendSMS;
    vm.excelExport = excelExport;
    vm.testForSelected = testForSelected;
    vm.getSettlements = getSettlements;
    vm.getGroups = getGroups;
    vm.getGrades = getGrades;
    vm.loadSearch = loadSearch;
    vm.init = init;

    function init() {
        vm.getTags();
        vm.getSettlements();
        vm.getGrades();
        vm.loadSearch();
    }

    function loadSearch() {
        var search = recentSearchService.get($location.path());
        if (search) {
            vm.search = search;
        }
    }

    function isEmptySearch() {
        for(var key in vm.search) {
            if(['Start', 'Length', 'order'].indexOf(key) >= 0)
                continue;

            var value = vm.search[key];
            if (key == "Tags") {
                if (value.length > 0) {
                    return false;
                }
            } else {
                if (value != null && value != '') {
                    return false;
                }
            }
        }
        return true;
    }

    function getGroups() {
        var params = {
            SettlementIdes: vm.search.settlements,
            GradesIdes: vm.search.grades
        }
        groupsEndpoint.get(params, function (data) {
            vm.groups = data;
        })
    }

    function getGrades() {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            vm.grades = data;
        })
    }

    function getSettlements() {
        settlementsEndpoint.get({}, function (data) {
            vm.settlements = data;
        });
    }

    /**
     * Get parents
     */
    function getParents(noFilter) {
        if (noFilter) {
            vm.search = {};
            recentSearchService.save($location.path(), vm.search);
            return;
        }
        if(isEmptySearch())
        {
            vm.parents = [];
            Notification.info('יש לעשות סינון לפי שדה אחד לפחות')
            return;
        }
        recentSearchService.save($location.path(), vm.search);

        vm.parents = false;
        vm.isClicked = true;

        parentsEndpoint.get(vm.search, function (response) {
            vm.selectAll = false;
            vm.parents = response.data.items;
        });
    }

    function getTags() {
        var params = {};
        params.withNames = true;
        params.TagType = 2;
        tagsEndpoint.get(params, function (data) {
            vm.tags = data;
        })
    }


    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    function tagsQuerySearch(query) {
        return query ? vm.tags.filter(createFilterForTags(query)) : [];
    }

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterForTags(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * Open parent panel
     * @param selectedParent
     */
    function goToParentsPanel(selectedParent) {
        $mdSidenav("parent-panel").open();
        parent.updateSelectedParent(selectedParent);
    }


    /**
     * Login To Parent Profile
     * @param parent
     */
    function loginToProfile(parent) {
        delete $cookies.remove(appConfig.profileTokenName);
        localStorage.removeItem(appConfig.profilePathCokieName);
        tokenEndpoint.special.post({TokenData: {ParentID: parent.ID}}, function (data) {
            if (data.success) {
                $cookies.put(appConfig.adminProfileTokenName, data.Token, {domain: location.hostname == 'localhost' ? 'localhost' : appConfig.appDomain});

                if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
                    $window.open('http://localhost:4200/', '_blank');
                else if (location.host === appConfig.locationHost)
                    $window.open(appConfig.developmentProfilePath, '_blank');
                else
                    $window.open(appConfig.prodctionProfilePath, '_blank');
            } else {
                Notification.error('התרחשה שגיאה');
            }

        });

    }


    function setAll(selectAll) {
        if (selectAll) {
            for (var i = 0; i < vm.parents.length; i++) {
                vm.parents[i].Selected = true;
            }
            Notification.info("שים לב.<br> ניתן לבחור חניכים מהתצוגה בלבד. <br>כדי לבחור את כל החניכים יש לשנות את מספר החניכים המוצגים. ")

        } else
            for (var i = 0; i < vm.parents.length; i++) {
                vm.parents[i].Selected = false;
            }
    }

    function testForSelected() {
        return !!vm.parents.find(function (parent) {
            return parent.Selected;
        })
    }


    /**
     * Open send sms dialog
     */
    function openSendSMS() {
        $mdDialog.show({
            controller: 'SMSDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
            locals: {'students': vm.parents, 'external': false, 'type': 3},
            clickOutsideToClose: false

        });
    }

    /**
     * open send email
     */
    function openSendEmail() {
        $mdDialog.show({
            controller: 'EmailDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
            locals: {'students': vm.parents, 'external': false, 'type': 3},
            clickOutsideToClose: false

        });
    }

    function excelExport() {
        var params = {
            Parents: vm.parents.filter(function (parent) {
                return parent.Selected
            }).map(function (parent) {
                return parent.ID
            })
        }
        parentsEndpoint.export.get(params, function (data) {

        });
    }

    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withOption('responsive', true)
        .withPaginationType('full_numbers')
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('lengthMenu', [[10, 50, 100, 500, 1000, 5000], [10, 50, 100, 500, 1000, 5000]]);


}

angular.module('app.pages.users').controller('StudentsController', StudentsController);

function StudentsController($scope, $rootScope, $mdSidenav, $mdDialog, tagsEndpoint, Notification, $location,
                            DTColumnDefBuilder, usersEndpoint, msUtils, $timeout, $document, DTOptionsBuilder,
                            dtOptions, groupsEndpoint, studentsEndpoint, student, gradesEndpoint, rolesEndpoint,
                            settlementsEndpoint, organizationsEndpoint, recentSearchService) {

    var vm = this;
    vm.search = {
        settlements: [],
        groups: [],
        grades: [],
        tags: [],
        Tags: [],
        roles: [],
        organizations: []
    };

    vm.settlements = [];
    vm.groups = [];
    vm.grades = [];
    vm.organizations = [];
    vm.students = [];
    vm.selectedStudentsCount = 0;
    vm.dtInstance = {};
    vm.isClicked = false;
    vm.getSettlements = getSettlements;
    vm.getOrganizations = getOrganizations;
    vm.getTags = getTags;
    vm.getRoles = getRoles;
    vm.getGrades = getGrades;
    vm.getStudents = getStudents;
    vm.openStudentPanel = openStudentPanel;
    vm.openNewStudentDialog = openNewStudentDialog;
    vm.setAll = setAll;
    vm.openSendEmail = openSendEmail;
    vm.openSendSMS = openSendSMS;
    vm.openChangeGroupGrades = openChangeGroupGrades;
    vm.excelExport = excelExport;
    vm.studentToggled = studentToggled;
    vm.getGroups = getGroups;
    vm.loadSearch = loadSearch;

    function loadSearch() {
        var search = recentSearchService.get($location.path());
        if (search) {
            vm.search = search;
        }
    }

    /**
     * Get All Settlements
     */
    function getSettlements() {
        settlementsEndpoint.get({}, function (data) {
            vm.settlements = data;
        });
    }

    function getGroups() {
        var params = {}
        if (vm.search.settlements && vm.search.settlements.length > 0) {
            params.SettlementIdes = vm.search.settlements
        }
        if (vm.search.grades && vm.search.grades.length > 0) {
            params.GradesIdes = vm.search.grades
        }
        groupsEndpoint.get(params, function (data) {
            vm.groups = data;
        })
    }

    function getOrganizations() {
        organizationsEndpoint.get(function (data) {
            vm.organizations = data["movements"];
        });
    }

    /**
     * Get Tags
     */
    function getTags() {
        var params = {
            Status: 1
        };
        tagsEndpoint.get(params, function (data) {
            vm.tags = data;
        })
    }

    /**
     * get roles
     */
    function getRoles() {
        var params = {
            withNames: true
        };
        rolesEndpoint.educator.get(params, function (data) {
            vm.roles = data;
        })
    }

    /**
     * Get Grades
     */
    function getGrades() {
        var params = {
            Status: 1
        };
        gradesEndpoint.get(params, function (data) {
            vm.grades = data;
        })
    }

    /**
     * Get All Students
     */
    function getStudents(noFilter) {
        if (noFilter) {
            vm.search = {
                settlements: [],
                groups: [],
                grades: [],
                educator: undefined,
                status: 1,
                tags: [],
                roles: [],
                educatorStatus: undefined,
                type: undefined,
                freeSearchFromDB: undefined
            }
            recentSearchService.save($location.path(), vm.search);
            return;
        }
        recentSearchService.save($location.path(), vm.search);
        var canContinueFlag = Object.keys(vm.search).filter(function (key){
            return ['status','order','Start','Length'].indexOf(key) == -1;
        }).find(function (key){
            return vm.search[key].length > 0;
        })
        if(!canContinueFlag) {
            Notification.info('יש לעשות סינון לפי שדה אחד לפחות')
            return;
        }

        vm.students = false;
        vm.isClicked = true;

        var params = {
            GradesIdes: vm.search.grades,
            SettlementsIdes: vm.search.settlements,
            GroupIdes: vm.search.groups,
            FreeSearch: vm.search.freeSearchFromDB,
            Status: vm.search.status,
            Tags: vm.search.tags,
            Roles: vm.search.roles,
            Type: vm.search.educator,
            StudentType: vm.search.type,
            EducatorStatus: vm.search.educatorStatus
        };

        vm.selectedStudentsCount = 0;
        vm.loader = true;
        studentsEndpoint.get(params, function (response) {
            vm.students = response.data && response.data.items.length ? response.data.items : [];
            vm.selectAll = false;
            vm.isClicked = false;
        })
    }

    /**
     * Open the student panel
     * @param selectedStudent
     */
    function openStudentPanel(selectedStudent) {
        $mdSidenav("student-panel").open();
        student.updateSelectedStudent(selectedStudent);
    }

    /**
     * Open the create new student Dialog
     */
    function openNewStudentDialog() {
        $mdDialog.show({
            controller: 'NewStudentsDialogController',
            templateUrl: 'app/main/pages/users/views/students/new-students-dialog/new-students-dialog.html',
            clickOutsideToClose: false
        });
    }


    /**
     * Set All
     * @param selectAll
     */
    function setAll(selectAll) {
        if (selectAll) {
            vm.students.forEach(function(student){
                student.Selected = true;
            })
            vm.selectedStudentsCount = vm.students.length;
        } else {
            vm.students.forEach(function(student){
                student.Selected = false;
            })
            vm.selectedStudentsCount = 0;
        }
    }

    /**
     * Open send sms dialog
     */
    function openSendSMS() {
        $mdDialog.show({
            controller: 'SMSDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
            locals: {'students': vm.students, 'external': false, 'type': 1},
            clickOutsideToClose: false
        });
    }

    /**
     * open send email
     */
    function openSendEmail() {
        $mdDialog.show({
            controller: 'EmailDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
            locals: {'students': vm.students, 'external': false, 'type': 1},
            clickOutsideToClose: false
        });
    }

    /**
     * Open change group grade dialog
     */
    function openChangeGroupGrades() {
        $mdDialog.show({
            controller: 'ChangeGroupOrGradeDialogController',
            templateUrl: 'app/main/pages/users/views/students/change-group-grade-dialog/change-group-grade-dialog.html',
            locals: {'students': vm.students},
            clickOutsideToClose: false
        }).then(function () {
            getStudents();
        });
    }

    /**
     * Student Count
     * @param student
     */
    function studentToggled(student) {
        if (student.Selected)
            vm.selectedStudentsCount++;
        else
            vm.selectedStudentsCount--;
    }

    function excelExport() {
        var params = {
            Students: vm.students.filter(function (student) {
                return student.Selected
            }).map(function (student) {
                return student.ID
            })
        }
        studentsEndpoint.export.get(params, function (data) {});
    }

    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('responsive', true)
        .withOption('bFilter', false)
        .withOption('lengthMenu', [[10, 50, 100, 500, 1000, 5000], [10, 50, 100, 500, 1000, 5000]])
        .withDOM('lrtip');

    vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(0).notSortable()];


}

angular.module('app.pages.utils').controller('ContactsController', ContactsController);

function ContactsController(contactsEndpoint,DTOptionsBuilder,dtOptions,contact,$mdDialog,Notification,DTColumnDefBuilder,$mdSidenav,groupsEndpoint) {

    var vm =this;
    vm.getContacts = getContacts;
    vm.deleteContactDialog= deleteContactDialog;
    vm.createNewContactDialog = createNewContactDialog;
    vm.getGroups = getGroups;
    vm.editContact = editContact;
    vm.contacts = [];

    /**
     * Get Reports
     */
    function getContacts(reset) {
        if(reset){
            vm.search = {
                freeSearchFromDB: ''
            }
        }
        vm.contacts = false;
        contactsEndpoint.get(vm.search,function (data) {
            data.forEach(function (contact) {

                contact.groupsString = [];
                vm.groups.forEach(function (group) {
                    if(contact.Groups.indexOf(group.ID) != -1)
                        contact.groupsString.push(group.Name);
                });
                contact.groupsString = contact.groupsString.join(',');
            })
            vm.contacts = data;
        })
    }

    function getGroups(){
        groupsEndpoint.get({Status:1},function(data){
            vm.groups = data;
        });
    }

    function createNewContactDialog() {
        $mdDialog.show({
            controller: 'NewContactDialogController',
            templateUrl: 'app/main/pages/utils/views/contacts/new-contact-dialog/new-contact-dialog.html',
            clickOutsideToClose: false
        }).then(function(){
            getContacts();
        });
    }

    function editContact(selectedContact){
        contact.updateSelectedContact(selectedContact,vm.groups);
        $mdSidenav("contact-panel").open();
    }

    /**
     * Open delete contact dialog
     * @param contact
     */
    function deleteContactDialog(contact) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת איש קשר')
            .textContent('האם אתה בטוח/ה שברצונך למחוק איש קשר זה?')
            .ok('מחיקה')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function() {
            deleteContact(contact);
        });
    }

    /**
     * delete contact
     * @param contact
     */
    function deleteContact(contact) {
        vm.contacts = false;
        contactsEndpoint.delete(contact,function (data) {
            vm.contacts = data;
            getContacts();
        })
    }

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('responsive',true)
        .withOption('bFilter', false)
        .withDOM('lrtip');

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),
    ];

}



angular.module('app.pages.utils').controller('ActivitiesController', ActivitiesController);
function ActivitiesController($scope, $rootScope,$location,usersEndpoint,$mdSidenav,$mdDialog, DTOptionsBuilder,$timeout,activities,activitiesEndpoint,parent,dtOptions,Notification,groupsEndpoint ,event,settlementsEndpoint) {


    $scope.activities = [];
    $scope.search = {};
    $scope.search.settlements = [];
    $scope.search.groups = [];
    $scope.groups = [];

    $scope.getSettlements = function (){
        settlementsEndpoint.get({},function (data){
            $scope.settlements = data;
        })
    }

    /**
     * Get all settlements groups
     */
    $scope.getGroups = function () {
        var params = {};
        params.status = 1;
        params.SettlementIdes = $scope.search.Settlements;
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        })
    };


    /**
     * Get All Students
     */
    $scope.getActivities = function (noFilter) {
        $scope.isClicked = true;
        if (noFilter) {
            $scope.search = {
                Settlements: [],
                Groups: [],
                Status: '1',
                FreeSearchFromDB: undefined
            };
        }

        $scope.activities = false;
        activitiesEndpoint.get($scope.search, function (data) {
            $scope.isClicked = false;
            $scope.activities = data;
        })

    };

    /**
     * Open the activities panel
     * @param selectedActivities
     */
    $scope.openActivitiesPanel = function (selectedActivities) {
        $mdSidenav("activities-panel").open();
        activities.updateSelectedActivities(selectedActivities);
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('responsive',true)
        .withOption('bFilter', false)
        .withDOM('lrtip');

    /**
     * move to Activities profile
     */
    $scope.openActivitiesProfile = function (selectedActivities) {
        activities.updateSelectedActivities(selectedActivities);
        $location.path("/activities-profile")
    };


    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.settlementsQuerySearch = function (query) {
        var results = query ?
            $scope.settlements.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    $scope.groupsQuerySearch = function (query) {
        var results = query ?
            $scope.groups.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Open the create new student Dialog
     */
    $scope.openNewStudentDialog = function () {
        $mdDialog.show({
            controller: 'NewActivitiesDialogController',
            templateUrl: 'app/main/pages/utils/views/activities/new-activities-dialog/new-activities-dialog.html',
            clickOutsideToClose: true
        }).then(function () {
            $scope.getActivities();
        });
    };

    /**
     * Filter by status
     * @param item
     * @returns {boolean}
     */
    $scope.filterByStatus = function (item) {
        if ($scope.search.status == 1)
            return item.Status == 1;
        else if ($scope.search.status == 0)
            return item.Status == 0;
        else
            return true;
    };

    /**
     * Filter by Educator
     * @param item
     * @returns {boolean}
     */
    $scope.filterByEducator = function (item) {
        if ($scope.search.educator == 1)
            return item.EducatorID > 0;
        else if ($scope.search.educator == 0)
            return item.EducatorID == null;
        else
            return true;
    }
}

angular.module('app.pages.users').controller('NewUserTagsDialogController', ['$scope', '$rootScope', '$mdDialog', 'Notification', 'tagsEndpoint', 'usersEndpoint', 'userID', 'parentID', 'studentID',
    function ($scope, $rootScope, $mdDialog, Notification, tagsEndpoint, usersEndpoint, userID, parentID, studentID) {

        $scope.newUserTag = {
            UserID: userID,
            ParentID: parentID,
            StudentID: studentID,
            Tags: []
        };

        $scope.getTags = function () {
            tagsEndpoint.get({Status: 1}, function (data) {
                $scope.tags = data;
            })
        }
        /**
         * Save new Student
         */
        $scope.saveNewUserTag = function () {
            $scope.isClicked = true;

            usersEndpoint.tags.post($scope.newUserTag, function (data) {
                if (!data.success) {
                    Notification.error('התרחשה שגיאה');
                    $scope.isClicked = false;
                } else
                    $mdDialog.hide();
            });

        };

        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

    }]);

angular.module('app.pages.events').controller('LocationsController', LocationsController);
function LocationsController($scope, $rootScope,DTOptionsBuilder,dtOptions,$location,$mdDialog,settlementsEndpoint,locationsEndpoint) {

    $scope.loading = false;
    $scope.search = {
        settlements: [],
        Status: 1
    };
    $scope.locations = [];


    $scope.getSettlements = function (){
        settlementsEndpoint.get({},function (data){
            $scope.settlements = data;
        })
    }

    $scope.settlementsQuerySearch = function (query) {
        var results = query ?
            $scope.settlements.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    $scope.getLocations = function(reset){
        if(reset){
            $scope.search = {
                Status: 1,
                settlements: [],
                FreeSearchFromDB: '',
                SettlementIDs: [],
            }
            $scope.locations = [];
            return;
        }
        $scope.loading = true;
        $scope.locations = false;
        $scope.search.SettlementIDs = $scope.search.settlements.map(function(settlement){
            return settlement.ID;
        })
        locationsEndpoint.get($scope.search,function(data){
            $scope.locations = data;
            $scope.locations.forEach(function(location){
                location.Layout = JSON.parse(location.Layout);
            });
            $scope.loading = false;
        })
    }



    $scope.openNewLocationDialog = function () {
        $mdDialog.show({
            controller: 'NewLocationDialogController',
            templateUrl: 'app/main/pages/settings-menue/views/locations/new-location-dialog/new-location-dialog.html',
            clickOutsideToClose: true,
            locals : {
                successCallback: $scope.getLocations
            }
        });
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip')
        .withOption('order', [1, 'desc']);

}

angular.module('app.pages.events').controller('EventsCategoriesController', EventsCategoriesController);
function EventsCategoriesController($scope, $rootScope,$location,$mdDialog,$mdSidenav,Notification,eventsEndpoint,appConfig,category,settingsEndpoint,event) {

    $scope.loading = false;
    $scope.currentCategories = [];
    $scope.previousCategoriesState = [];
    $scope.previousCategories = [];
    $scope.currentCategory = null;
    $scope.masterCategories = [];

    $scope.init = function (){
        $scope.getCategoriesTree();
        $scope.getAdminImages();
        $scope.getMasterEvents();
    }

    $scope.getMasterEvents = function(){
        $scope.masterCategories = Object.values(event.modulesMap).map(function (category){
            return category.masterCategoryID;
        })
    }

    $scope.isMasterCategory = function (id){
        return $scope.masterCategories.find(function (categoryID){
            return categoryID == id;
        });
    }

    $scope.getCategoriesTree = function (){
        $scope.loading = true;
        eventsEndpoint.categories.get({},function (data){
            $scope.currentCategories = data;
            $scope.previousCategoriesState = [];
            $scope.previousCategories = [];
            $scope.currentCategory = null;
            $scope.loading = false;
        })
    }

    /**
     * Get Admin Images
     */
    $scope.getAdminImages = function() {
        settingsEndpoint.admin.images.get(function (data) {
            $scope.defaultLogo = data.find(function(value){
                return value.Property == 'LogoAdmin';
            }).Value;
        })
    }



    $scope.openNewCategoryDialog = function () {
        $mdDialog.show({
            controller: 'NewCategoryDialogController',
            templateUrl: 'app/main/pages/settings-menue/views/categories/new-category-dialog/new-category-dialog.html',
            clickOutsideToClose: true,
            locals : {
                ParentCategory : $scope.currentCategory,
                successCallback: $scope.getCategoriesTree
            }
        });
    };

    $scope.deleteCategory = function (category){
        eventsEndpoint.categories.delete({CategoryID:category.ID},function(data){
            if(data.success) {
                Notification.success('קטגוריה נמחקה בהצלחה');
                $scope.getCategoriesTree();
            } else
                Notification.info('התרחשה שגיאה במחיקה');
        })
    }

    /**
     * Edit Category
     */
    $scope.editCategory = function (selectedCategory) {
        category.updateSelectedCategory(selectedCategory);
        $mdSidenav("category-panel").open();
    };

    $scope.enterCategory = function (category){
        $scope.currentCategory = category;
        $scope.previousCategories.push($scope.currentCategory);
        var arr = [];
        $scope.currentCategories.forEach(function (cat){
            arr.push(cat);
        })
        $scope.previousCategoriesState.push(arr);
        $scope.currentCategories = category.ChildrenCategories;
    }

    $scope.goToPreviousState = function(){
        $scope.currentCategories = $scope.previousCategoriesState.pop();
        $scope.currentCategory = $scope.previousCategories.pop();
    }

    $scope.updateImage = function(category) {
        $mdDialog.show({
            controller         : 'UploadController',
            templateUrl        : 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'events/category',
                uploadID: category.ID + "/image",
                restrictTo: []
            }
        }).then(function () {
            category.Image = $rootScope.fileResp.data.Path;
        });
    };


}

angular.module('app.pages.settings_menu').controller('ProfileSettingsController', ProfileSettingsController);

function ProfileSettingsController($rootScope, $document, systemSettingsEndpoint, Notification, settingsEndpoint, DTOptionsBuilder, dtOptions, $mdSidenav, $mdDialog, extraField, birthdaySettingsEndpoint) {


    var vm = this;
    vm.options = {};
    vm.options.contentsLangDirection = 'rtl';
    vm.options.height = '600px';
    vm.profile = {};
    vm.mandatoryStudentFields = [
        'PrivateID',
        'FirstName',
        'LastName',
        'GradeID',
        'SettlementID',
    ];

    vm.getTerms = getTerms;
    vm.updateTerms = updateTerms;
    vm.getProfilePopUpAlert = getProfilePopUpAlert;
    vm.updateProfilePopUpAlert = updateProfilePopUpAlert;
    vm.getEmails = getEmails;
    vm.updateSettings = updateSettings;
    vm.getProfileSettings = getProfileSettings;
    vm.fetchAllStudentFields = fetchAllStudentFields;
    vm.updateStudentFields = updateStudentFields;
    vm.openNewFieldDialog = openNewFieldDialog;
    vm.fetchAllExtraStudentFields = fetchAllExtraStudentFields;
    vm.editField = editField;
    vm.updateSystemBirthdaySettings = updateSystemBirthdaySettings;
    vm.getSystemBirthdaySettings = getSystemBirthdaySettings;
    vm.extraFieldType = extraFieldType;
    vm.viewFile = viewFile;


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', true)
        .withDOM('lrtip');

    /**
     * Get Terms
     */
    function getTerms() {
        systemSettingsEndpoint.terms.get(function (data) {
            vm.terms = data;
            setTimeout(function () {
                $rootScope.quillEditor.terms.clipboard.dangerouslyPasteHTML(vm.terms.Name);
            })
        })
    }

    /**
     * Update Terms for profile
     */
    function updateTerms() {
        var params = Object.assign({}, vm.terms);
        params.Name = $rootScope.quillEditor.terms.root.innerHTML;

        systemSettingsEndpoint.terms.post(params, function (data) {
            Notification.success("תנאים עודכנו בהצלחה");
        })
    }

    /**
     * get profile pop up alert
     */
    function getProfilePopUpAlert() {
        systemSettingsEndpoint.ProfilePopUpAlert.get(function (data) {
            var theDiv = $document.find('#onetTimePopup .ql-formats');
            if (theDiv && theDiv.length > 0) {
                theDiv[theDiv.length - 1].remove();
            }
            vm.profilePopUpAlert = data;
            setTimeout(function () {
                $rootScope.quillEditor.popupAlert.clipboard.dangerouslyPasteHTML(vm.profilePopUpAlert.Name);
            })
        })
    }

    /**
     * Update profile pop up alert
     */
    function updateProfilePopUpAlert() {
        var params = Object.assign({}, vm.profilePopUpAlert);
        params.Name = $rootScope.quillEditor.popupAlert.root.innerHTML;
        systemSettingsEndpoint.ProfilePopUpAlert.post(params, function (data) {
            Notification.success("הודעת פרופיל עודכנה בהצלחה");
        })
    }

    /**
     * Get emails
     */
    function getEmails() {
        settingsEndpoint.forms.emails.get(function (data) {
            if (data) {
                vm.settings = data;
                angular.forEach(vm.settings, function (value, key) {
                    if (angular.isUndefined(value.Value) || value.Value === '' || value.Value == null)
                        vm.settings[key].Value = [];
                    else {
                        try {
                            vm.settings[key].Value = JSON.parse(value.Value);
                        } catch (error) {
                            vm.settings[key].Value = value.Value;
                        }

                    }
                });
                vm.settingsReady = true;
            }
        })
    }

    /**
     * Update settings
     */
    function updateSettings() {
        var settings = vm.settings.slice();
        settings.forEach(function (value) {
            if (value.Property == "contactFromTypes") {
                value.Value = JSON.stringify(value.Value);
            }
            if (value.Property == "ContactText") {
                value.Value = JSON.stringify([value.Value]);
            }
        });

        var params = {
            settings: settings
        };
        settingsEndpoint.post(params, function (data) {
            if (data.success)
                Notification.success('הגדרות נשמרו בהצלחה!');
            else
                Notification.error('נכשל בשמירת הגדרות!');
            vm.getEmails();
        })

        updateProfileSettings();
    }


    /**
     * Update Profile Settings
     */
    function updateProfileSettings() {
        vm.isClicked = true;
        settingsEndpoint.profile.post(vm.profile, function (data) {
            vm.isClicked = false;

        })
    }

    /**
     * Get Profile Settings
     */
    function getProfileSettings() {
        settingsEndpoint.profile.get(function (data) {
            vm.profile = data;
        })
    }

    function fetchAllStudentFields() {
        systemSettingsEndpoint.studentFields.all.get([], function (data) {
            var arr = [];
            Object.keys(data).map(function (key) {
                var obj = data[key];
                obj.required = (obj.required === 1);
                obj.requiredForParent = (obj.requiredForParent === 1);
                arr.push(obj);
            });
            vm.studentfields = arr;
        });
    }

    function updateStudentFields() {
        vm.isClicked = true;
        systemSettingsEndpoint.studentFields.all.post({fields: vm.studentfields}, function () {
            Notification.success("פרטים עודכנו בהצלחה");
            vm.isClicked = false;
        });
    }

    function openNewFieldDialog() {
        $mdDialog.show({
            controller: 'NewFieldDialogController',
            templateUrl: 'app/main/pages/settings-menue/views/profile-settings/new-field-dialog/new-field-dialog.html',
            clickOutsideToClose: true,
        }).then(function () {
            fetchAllExtraStudentFields();
        });
    }


    function fetchAllExtraStudentFields() {
        systemSettingsEndpoint.studentExtraFields.get([], function (data) {
            var arr = [];
            Object.keys(data).map(function (key) {
                arr.push(data[key]);
            });
            vm.extraStudentFields = arr;
        });
    }

    /**
     * Edit field
     */
    function editField(selectedField) {
        extraField.updateSelectedField(selectedField);
        $mdSidenav("field-panel").open();
    }

    /**
     * update BirthdaySettings
     */
    function updateSystemBirthdaySettings() {
        vm.isClicked = true;
        birthdaySettingsEndpoint.post(vm.birthdaySettings, function (data) {
            vm.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        })
    }

    /**
     * Get BirthdaySettings
     */
    function getSystemBirthdaySettings() {
        birthdaySettingsEndpoint.get(function (data) {
            vm.birthdaySettings = data;
        })
    }

    /**
     * Set Type
     * @param type
     * @returns {string}בצ
     */
    function extraFieldType(type) {
        switch (type) {
            case "1":
            case 1:
                return "שאלה פתוחה";
                break;
            case "2":
            case 2:
                return "אפשרויות";
                break;
            case "3":
            case 3:
                return "תאריך";
                break;
            case "4":
            case 4:
                return "קובץ";
                break;
        }
    }

    function viewFile(file) {
        window.open(file);
    }

    function updateHealthDeclaration(declaration) {
        $mdDialog.show({
            controller: 'UploadController',
            templateUrl: 'app/upload/upload.html',
            clickOutsideToClose: false,
            locals: {
                uploadTo: 'system-settings',
                uploadID: "health-declaration",
                restrictTo: ['pdf']
            }
        }).then(function () {
            vm.getEmails()
        });
    }
}





angular.module('app.pages.settings_menu').controller('ExternalRegistrationsController', ExternalRegistrationsController);

function ExternalRegistrationsController($rootScope,settingsEndpoint,Notification) {


    var vm = this;

    vm.getExternalSettings =getExternalSettings;
    vm.updateExternalSettings =updateExternalSettings;
    vm.externalEvent = {};
    vm.options = {};
    vm.options.contentsLangDirection   = 'rtl';
    vm.options.height = '600px';

    /**
     * get external settings
     */
    function getExternalSettings(){
        settingsEndpoint.external.get(function(data){
            if(data && data.length){
                data.forEach(function(ent){
                    vm.externalEvent[ent.Entity] = ent.Name;
                })
                setTimeout(function (){
                    $rootScope.quillEditor.Terms.clipboard.dangerouslyPasteHTML(vm.externalEvent.Terms);
                })
            }
        })
    }
    /**
     * update external settings
     */
    function updateExternalSettings(){
        vm.externalEvent.Terms = $rootScope.quillEditor.Terms.root.innerHTML;
        var params = {
            External: vm.externalEvent,
        };

        settingsEndpoint.external.post(params,function(data){
            if(data.success){
                Notification.success("עודכן בהצלחה");
            }else{
                Notification.error("לא עודכן ישנה בעיה");
            }
        })
    }

}

angular.module('app.pages.settings_menu').controller('GeneralSettingsController', GeneralSettingsController);

function GeneralSettingsController(systemSettingsEndpoint, settingsEndpoint, Notification, appConfig, $rootScope, Upload) {


    var vm = this;
    vm.systemSettings = {};
    vm.uploadFile = uploadFile;
    vm.getAccountancySettings = getAccountancySettings;
    vm.getSystemSettings = getSystemSettings;
    vm.updateSystemSettings = updateSystemSettings;
    vm.getAdminImages = getAdminImages;
    vm.updateAdminImageSettings = updateAdminImageSettings;
    vm.viewFile = viewFile;
    vm.managedTerminals = false;


    function getAccountancySettings() {
        settingsEndpoint.accountancy.get(function (data) {
            vm.accountancy = data;

            vm.managedTerminals = +data.TerminalManagment === 1;
        });
    }

    /**
     * Get System Settings
     */
    function getSystemSettings() {
        systemSettingsEndpoint.names.get(function (data) {
            vm.systemSettings = data;
        })
    }

    /**
     * update SystemSettings
     */
    function updateSystemSettings() {
        var params = {};
        params.Names = vm.systemSettings;
        vm.isClicked = true;
        systemSettingsEndpoint.names.post(params, function (data) {
            vm.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        })
    }

    function viewFile(file) {
        window.open(file);
    }

    /**
     * Get Admin Images
     */
    function getAdminImages() {
        settingsEndpoint.admin.images.get(function (data) {
            vm.adminImages = data;
        })
    }

    /**
     * Update Admin Images
     */
    function updateAdminImageSettings() {
        vm.isClicked = true;
        var params = {};
        params.Images = vm.adminImages;
        settingsEndpoint.admin.images.post(params, function (data) {
            Notification.success("פרטים עודכנו בהצלחה");
            vm.isClicked = false;

        })
    }


    /**
     * UploadFile
     * @param file
     */
    function uploadFile(file, image) {
        if (!file)
            return;
        var maxAllowedSize = 1024 * 1024;
        if (file.size > maxAllowedSize) {

            return;
        }
        vm.isClicked = true;
        image.FileName = file.name;
        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else
            uploadURL = appConfig.serverUrl + '/upload/files?brand=' + $rootScope.brandName;

        var headers = {};
        headers.Authorization = 'Bearer ' + $rootScope.User.AccessToken;
        Upload.upload({
            url: uploadURL,
            headers: headers,
            data: {
                file: file,
            }
        }).then(function (resp) {
            vm.isClicked = false;
            image.Value = resp.data.Path;
        }, function (resp) {
            console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage);
        });


    }
}





(function ()
{
    'use strict';

    angular
        .module('app.pages.profile-forms', []).config(config).run(run);

    function run($rootScope,msNavigationService) {
        $rootScope.$watch('User',function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel) {
                switch ($rootScope.AdminLevel) {
                    case 3:
                        msNavigationService.saveItem('pages.profile-forms', {
                            title : 'ריכוז פניות',
                            icon  : 'icon-clipboard-text',
                            weight: 5
                        });

                        msNavigationService.saveItem('pages.profile-forms.profile-forms_cancel-form', {
                            title : 'בקשות ביטול',
                            icon  : 'icon-cancel',
                            state : 'app.pages_profile-forms_cancel-form'

                        });

                        msNavigationService.saveItem('pages.profile-forms.profile-forms_contact-form', {
                            title : 'פניות צור קשר',
                            icon  : 'icon-email',
                            state : 'app.pages_profile-forms_contact-form'

                        });

                        msNavigationService.saveItem('pages.profile-forms.profile-forms_subsidy-form', {
                            title : 'בקשות סבסוד',
                            icon  : 'icon-file-document',
                            state : 'app.pages_profile-forms_subsidy-form'

                        });
                        break;

                }
            }
        });

    }
    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pages.profile-forms', {
                abstract: true,
                url     : '/profile-forms'
            })
            .state('app.pages_profile-forms_cancel-form', {
                url      : '/cancel-form',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/profile-forms/views/cancel-form/cancel-form.html',
                        controller : 'CancelFormController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/cancel-form');
                    }
                }
            })
            .state('app.pages_profile-forms_contact-form', {
                url      : '/contact-form',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/profile-forms/views/contact-form/contact-form.html',
                        controller : 'ContactFormController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/contact-form');
                    }
                }
            })
            .state('app.pages_profile-forms_subsidy-form', {
                url      : '/subsidy-form',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/profile-forms/views/subsidy-form/subsidy-form.html',
                        controller : 'SubsidyFormController as vm'
                    }
                },
                resolve  : {
                    DashboardData: function (ValidToken)
                    {
                        ValidToken.validUserToken();
                        localStorage.setItem("path",'/subsidy-form');
                    }
                }
            })
    }
})();


angular.module('app.pages.profile-forms').controller('CancelFormController', CancelFormController);

function CancelFormController ($scope,DTOptionsBuilder,dtOptions,eventsEndpoint,formsEndpoint,$mdDialog,DTColumnDefBuilder, $location, recentSearchService) {


    var vm = this;
    vm.getEvents = getEvents;
    vm.getCancelForms= getCancelForms;
    vm.openCancellationDialog = openCancellationDialog;
    vm.searchTerm = '';
    vm.cancellation=  [];

    vm.loadSearch = loadSearch;

    function loadSearch()
    {
        var search = recentSearchService.get($location.path());
        if(search) {
            vm.search = search;
        }
    }

    /**
     * get Events
     */
    function getEvents() {
        eventsEndpoint.get([],function (data) {
            vm.events = data;
        })
    }

    function getCancelForms(reset) {
        if (reset) {
            vm.search = {};
            recentSearchService.save($location.path(), vm.search);
            return;
        }
        recentSearchService.save($location.path(), vm.search);
        vm.cancellation= false;
        formsEndpoint.cancellation.get(vm.search,function (data) {
            vm.cancellation = data;
        })
    }

    /**
     * Open The Cancellation Dialog
     * @param cancel
     */
    function openCancellationDialog(cancel) {
        $mdDialog.show({
            controller         : 'CancellationDialogController',
            templateUrl        : 'app/main/pages/forms-dialogs/cancellation-dialog/cancellation-dialog.html',
            clickOutsideToClose: true,
            locals : {'cancel' : cancel}
        });
    };


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive',true)
        .withOption('order', [0, 'desc']);

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });


    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];


}





angular.module('app.pages.events').controller('EventsController', EventsController);

function EventsController($scope, $rootScope, $location, $mdDialog, DTOptionsBuilder, dtOptions, gradesEndpoint, eventsEndpoint,reportsEndpoint, event, DTColumnDefBuilder, $interval, settlementsEndpoint, msNavigationService, recentSearchService) {

    $scope.table = {
        dtInstance: {}
    };

    $scope.loadSearch = function () {
        var search = recentSearchService.get($location.path());
        if (search) {
            $scope.search = search;
        }
    }

    $scope.search = {
        EventType: 0
    };
    $scope.search.settlements = [];
    $scope.search.grades = [];
    $scope.brand = $rootScope.brandName;
    $scope.activeModule = undefined;
    $scope.searchFirstTime = false;
    $scope.externalOnly = false;
    $scope.cartEvents = [];

    $scope.init = function () {
        $scope.getSettlements();
        $scope.getCostingCodes();
        $scope.getGrades();
        $scope.loadSearch();
    };

    $rootScope.$watch('$routeChangeSuccess', function (data) {
        var interval = $interval(function () {
            var active = msNavigationService.getActiveItem();
            if (active != null) {
                $scope.title = active.node.title;
                $scope.externalOnly = active.node.generalEventType === 'ReligiousServices' ||  active.node.generalEventType === 'RevachaPnimi';
                event.setActiveModule(active.node.generalEventType);
                $scope.activeModule = event.getActiveModule();
                $scope.search.EventType = $scope.activeModule.defaultEventTypeSearch;
                if ($scope.externalOnly) {
                    $scope.search.EventType = '1';
                }
                $scope.getEventCategories();
                $interval.cancel(interval);
            }
        }, 600);
    });

    $scope.getCostingCodes = function () {
        reportsEndpoint.epr.info({}, function (data) {
            $scope.costingCodes = data.Codes;
        });
    };
    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })
    }

    /**
     * Get All Branches And Groups
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        });

    };

    /**
     * Get Events
     */
    $scope.getEvents = function (noFilter) {
        $scope.isClicked = true;
        var params = {};
        if (noFilter) {
            $scope.searchFirstTime = false;
            $scope.search.EventType = 0;
            $scope.search.CostingCode = null;
            $scope.search.settlements = [];
            $scope.search.grades = [];
            $scope.search.FreeSearch = null;
            $scope.search.freeSearchFromDB = null;
            $scope.search.status = 1;
            $scope.search.CategoryID = null;
            if ($scope.activeModule.registrationDates) {
                $scope.search.dateStatus = 1;
            }
            $scope.events = [];
        }
        if (!$scope.activeModule.registrationDates) {
            delete $scope.search.dateStatus;
        }
        recentSearchService.save($location.path(), $scope.search);

        params.gradesIdes = [];
        for (var i = 0; i < $scope.search.grades.length; i++) {
            params.gradesIdes.push($scope.search.grade[i].ID)
        }
        params.FreeSearch = $scope.search.freeSearchFromDB;
        if (!$scope.EventType) {
            params.GradesIdes = JSON.stringify(params.gradesIdes);
        } else {
            params.GradesIdes = [];
        }
        params.Status = $scope.search.status;
        params.EventType = $scope.search.EventType;
        params.CostingCode = $scope.search.CostingCode;
        params.Limit = $scope.search.Limit;
        params.DateStatus = $scope.search.dateStatus;

        params.RegistrationCount = true;
        var active = msNavigationService.getActiveItem()
        params.GeneralEventType = active.node.generalEventType;
        params.CategoryID = $scope.search.CategoryID;
        // if(!params.CategoryID.length){
        //     params.CategoryID = null;
        // }

        eventsEndpoint.get(params, function (data) {
            $scope.searchFirstTime = true;
            $scope.isClicked = false;
            $scope.events = data;

        })

    };


    $scope.openNewEventDialog = function () {
        $mdDialog.show({
            controller: 'NewEventsDialogController',
            templateUrl: 'app/main/pages/events/views/events/new-event-dialog/new-event-dialog.html',
            clickOutsideToClose: true,
        });
    };


    $scope.getEventCategories = function () {
        eventsEndpoint.categories.eventsCategories({ParentCategoryID: $scope.activeModule.masterCategoryID}, function (data) {
            $scope.categories = data;
        })
    }

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', true)
        .withDOM('lrtip')
        .withOption('order', [1, 'desc']);


    $scope.settlementsQuerySearch = function (query) {
        var results = query ?
            $scope.settlements.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * grades query search
     * @param query
     * @returns {Array}
     */
    $scope.gradesQuerySearch = function (query) {
        var results = query ?
            $scope.grades.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });
    if ($scope.activeModule && $scope.activeModule.eventDates) {
        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(2).withOption('type', 'eu-date'),
            DTColumnDefBuilder.newColumnDef(3).withOption('type', 'eu-date'),
            DTColumnDefBuilder.newColumnDef(4).withOption('type', 'eu-date')

        ];
    }
    /********************************** START cart **********************************************/

    $scope.getCartTotalQuantity = function () {
        var total = 0;
        $scope.cartEvents.forEach(function (cartEvent) {
            total += cartEvent.quantity;
        })
        return total;
    }

    $scope.addToCart = function (event, quantity) {
        $scope.cartEvents.push({event: event, quantity: quantity})
    }

    $scope.removeFromCart = function (event) {
        $scope.cartEvents = $scope.cartEvents.filter(function (cartEvent) {
            return cartEvent.ID != event.ID;
        })
    }

    $scope.isInCart = function (event) {
        return !!$scope.cartEvents.find(function (cartEvent) {
            return cartEvent.ID == event.ID;
        })
    }

    /**
     * Open create Registration Dialog
     */
    $scope.openNewSingleRegistrationDialog = function (event) {
        $mdDialog.show({
            controller: 'NewSingleRegistrationInfoDialogController',
            templateUrl: 'app/main/pages/events/views/events/new-single-registration-info-dialog/new-single-registration-info-dialog.html',
            clickOutsideToClose: false,
            locals: {
                selectedEvent: event
            }
        }).then(function (data) {
            if (data.success) {
                $scope.addToCart(data.event, data.quantity);
            }
        });
    };

    $scope.openNewMultipleRegistrationsDialog = function () {
        $mdDialog.show({
            controller: 'NewMultipleRegistrationDialogController',
            templateUrl: 'app/main/pages/events/views/events/new-multiple-registrations-dialog/new-multiple-registrations-dialog.html',
            clickOutsideToClose: true,
            locals: {
                events: $scope.cartEvents
            },
            onRemoving: function () {
                $scope.cartEvents = [];
            }
        });
    };


    /********************************** END cart **********************************************/

}

angular.module('app.pages.settings_menu').controller('AdminSettingsController', AdminSettingsController);


function AdminSettingsController($rootScope,$mdDialog, tagsEndpoint, Notification, rolesEndpoint, systemSettingsEndpoint, gradesEndpoint, studentsEndpoint, organizationsEndpoint) {

    var vm = this;
    vm.getTags = getTags;
    vm.updateTags = updateTags;
    vm.getRoles = getRoles;
    vm.updateRoles = updateRoles;
    vm.getSystemSettings = getSystemSettings;
    vm.systemSettings = {};
    vm.systemSettings.AttendenceStatus = [];
    vm.getGrades = getGrades;
    vm.updateGrade = updateGrade;
    vm.getOrganizations = getOrganizations;
    vm.updateOrganizations = updateOrganizations;
    vm.organizationsQuerySearch = organizationsQuerySearch;
    vm.updateTagStatus = updateTagStatus;
    vm.openNewTagDialog = openNewTagDialog;
    vm.getSystemSettings();

    /**
     * Get Tags
     */
    function getTags() {
        tagsEndpoint.get({}, function (data) {
            vm.tags = data;
        });
    }

    function updateTagStatus(tag){
        tag.Status = tag.Status == 1? 0 : 1;
        tagsEndpoint.update.post(tag,function (data){
            if(! data.success)
                Notification.error('התרחשה שגיאה')
        })
    }

    function openNewTagDialog () {
        $mdDialog.show({
            controller: 'NewTagDialogController',
            templateUrl: 'app/main/pages/settings-menue/views/admin-settings/tabs/new-tag-dialog/new-tag-dialog.html',
            clickOutsideToClose: true
        }).then(function () {
            vm.getTags();
        });
    };

    /**
     * Update Tags
     */
    function updateTags() {
        updateSystemSettings();
    }

    /**
     * Get Roles
     */
    function getRoles() {
        rolesEndpoint.get([], function (data) {
            vm.roles = data;
        })
    }

    /**
     * Update Roles
     */
    function updateRoles() {
        vm.isClikced = true;
        var params = {};
        params.Roles = JSON.stringify(angular.copy(vm.roles));
        rolesEndpoint.post(params, function (data) {
            vm.isClikced = false;
            if (data.success)
                Notification.success("תפקידים עודכנו");

        });
    }

    /**
     * Get System Settings
     */
    function getSystemSettings() {
        systemSettingsEndpoint.names.get(function (data) {
            vm.systemSettings = data;
            var tmp =  splitArray(vm.systemSettings.AttendenceStatus);
            console.log(tmp)
            vm.systemSettings.AttendenceStatus = vm.systemSettings.AttendenceStatus == "" ? [] : splitArray(vm.systemSettings.AttendenceStatus);
            getOrganizations();

        })
    }

    /**
     * update SystemSettings
     */
    function updateSystemSettings() {
        var params = {};
        params.Names = vm.systemSettings;
        params.Names.AttendenceStatus = JSON.stringify(params.Names.AttendenceStatus);
        vm.isClicked = true;
        systemSettingsEndpoint.names.post(params, function (data) {
            vm.isClicked = false;
            Notification.success("הגדרות עודכנו בהצלחה");
        })
    }

    function splitArray(str) {
        var newStr = str.replace(/[[]|[\]]/g, "").replace(/"/g, "");
        var arr = newStr.split(",");
        return arr;
    }

    /**
     * Get All Grades
     */
    function getGrades() {
        var params = {};
        params.Status = 1;
        vm.grades = false;
        gradesEndpoint.get(params, function (data) {
            vm.grades = data;
        });
    }

    /**
     * Update grade
     */
    function updateGrade() {
        vm.isClicked = true;
        studentsEndpoint.grades.upgrade.post(vm.upgrade, function (data) {
            vm.isClicked = false;
            if (data.success) {
                Notification.success("עודכן בהצלחה");
                vm.upgrade = {};
            } else
                Notification.error("נכשל בעדכון");


        })
    }

    function getOrganizations() {

        organizationsEndpoint.get(function (data) {
            vm.orgNames = data.names;
            vm.organizations = data["movements"].map(function (org) {
                return {Name: org}
            });
            initOrganizations();
        });
    }

    function initOrganizations() {
        try {
            vm.systemSettings.Organizations = JSON.parse(vm.systemSettings.Organizations);
        }catch(e){
            vm.systemSettings.Organizations = [];
        }
    }

    function updateOrganizations() {
        vm.systemSettings.Organizations = JSON.stringify(vm.systemSettings.Organizations);
        updateSystemSettings();
    }

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    function organizationsQuerySearch(query) {
        var results = query ? vm.organizations.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

}

angular.module('app.pages.profile-forms').controller('ContactFormController', ContactFormController);

function ContactFormController($scope, DTOptionsBuilder, dtOptions, settingsEndpoint, eventsEndpoint, formsEndpoint, $mdDialog, DTColumnDefBuilder, $location, recentSearchService) {


    var vm = this;
    vm.getContactForms = getContactForms;
    vm.openContactDialog = openContactDialog;
    vm.getTypes = getTypes;
    vm.searchTerm = '';
    vm.contact = [];
    vm.loadSearch = loadSearch;

    function loadSearch() {
        var search = recentSearchService.get($location.path());
        if (search) {
            vm.search = search;
        }
    }

    vm.loadSearch();
    vm.getTypes();

    function getTypes() {
        settingsEndpoint.forms.emails.get(function (data) {
            if (data) {
                data = data.find(function (item) {
                    return item['Property'] === 'contactFromTypes';
                });
                vm.types = JSON.parse(data['Value']);
            }
        });
    }

    function getContactForms(reset) {
        if (reset) {
            vm.search = {};
            recentSearchService.save($location.path(), vm.search);
            return;
        }
        recentSearchService.save($location.path(), vm.search);
        vm.contact = false;
        formsEndpoint.contact.get(vm.search, function (data) {
            vm.contact = data;
        })
    }

    /**
     * Open The Contact Dialog
     * @param contactForm
     */
    function openContactDialog(contactForm) {
        $mdDialog.show({
            controller: 'ContactDialogController',
            templateUrl: 'app/main/pages/forms-dialogs/contact-dialog/contact-dialog.html',
            clickOutsideToClose: true,
            locals: {'contactForm': contactForm}
        });
    };


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive', true)
        .withOption('order', [0, 'desc']);

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });


    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];


}





angular.module('app.pages.settings_menu').controller('AccountancySettingsController', AccountancySettingsController);

function AccountancySettingsController($scope, $rootScope, $mdDialog, settingsEndpoint, Notification) {

    var vm = this;

    vm.getAccountancySettings = getAccountancySettings;
    vm.getAccountancyTerminals = getAccountancyTerminals;
    vm.updateAccountancy = updateAccountancy;
    vm.addBank = addBank;
    vm.addNewTerminal = addNewTerminal;
    vm.checkTerminalsValidity = checkTerminalsValidity;
    vm.checkSingleDefaultTerminal = checkSingleDefaultTerminal;
    vm.updateAccountancyTerminals = updateAccountancyTerminals;
    vm.showExtraDetails = showExtraDetails;
    vm.terminalManagement = 1;


    /**
     * Get Accountancy Settings
     */

    function getAccountancySettings() {
        settingsEndpoint.accountancy.get(function (data) {
            vm.accountancy = data;
            vm.terminalManagement = data.TerminalManagment;
        });
    }

    /**
     * Update Accountancy
     */
    function showExtraDetails(item) {
        $mdDialog.show({
            controller: 'AccountsPopupController',
            templateUrl: 'app/main/pages/settings-menue/views/accountancy-settings/tabs/accountsPopup/accountsPopup.html',
            clickOutsideToClose: false,
            locals:{
                Terminal: item
            }

        }).then(function () {
            $scope.overWrite = true;
            $scope.getEventDiscounts();
        });
    };

    function updateAccountancy() {
        vm.isClicked = true;
        settingsEndpoint.accountancy.post(vm.accountancy, function (data) {
            vm.isClicked = false;
            if (data.success)
                Notification.success("הפרטים עדוכונו בהצלחה")
        })
    }

    /**
     * Add New Bank
     */
    function addBank() {
        var newBank = {};
        newBank.Name = '';
        newBank.Code = '';
        newBank.Number = '';
        vm.accountancy.Banks.push(newBank);
    }

    //----------------------------------------------TERMINALS---------------------------------------------------------//

    /**
     * get terminals
     */
    function getAccountancyTerminals() {
        settingsEndpoint.accountancy.terminals.get(function (data) {
            vm.terminals = data
        });
    }

    function updateAccountancyTerminals() {
        vm.isClicked = true;
        settingsEndpoint.accountancy.terminals.post({Terminals: vm.terminals}, function (data) {
            vm.isClicked = false;
            if (data.success) {
                Notification.success("המסופים עדוכונו בהצלחה")
                vm.terminals = data.data;
            }
        });
    }

    function checkTerminalsValidity() {
        var fields = ['Name', 'TerminalID', 'TerminalUser', 'TerminalPassword'];
        var fieldsValidity = vm.terminals && vm.terminals.reduce(function (acc, terminal) {
            return acc && fields.reduce(function (acc2, field) {
                return acc2 && terminal[field].length > 0;
            }, true);
        }, true);
        return fieldsValidity && checkSingleDefaultTerminal();
    }

    /**
     *
     * @returns {boolean}
     */
    function checkSingleDefaultTerminal() {
        var defaultTerminalsAmount = vm.terminals.reduce(function (acc, terminal) {
            return acc + terminal.IsDefaultTerminal;
        }, 0)
        return defaultTerminalsAmount == 1;
    }

    /**
     *
     */
    function addNewTerminal() {
        vm.terminals.push({
            Name: '',
            TerminalID: '',
            TerminalUser: '',
            TerminalPassword: '',
            IsDefaultTerminal: checkSingleDefaultTerminal() ? 0 : 1
        })
    }

    $scope.$watch('vm.accountancy', function (newValue, oldValue) {

        $rootScope.editDataHandler(newValue, oldValue, 'accountancy-panel')
    }, true);
}

(function () {
    'use strict';

    angular
        .module('app.pages.events-extras', ['datatables', 'ui.sortable'])
        .config(config).run(run);


    function run($rootScope, msNavigationService) {

        /**
         * Set the pages by the admin level
         */
        $rootScope.$watch('User', function () {
            if ($rootScope.AdminLevel) {
                switch ($rootScope.AdminLevel) {
                    //guide-student
                    case 1:
                        msNavigationService.saveItem('pages.events-extras', {
                            title: 'ניהול מאורעות',
                            icon: 'icon-weather-sunny',
                            weight: 3
                        });
                        msNavigationService.saveItem('pages.events-extras.attendance', {
                            title: 'מפגשי מאורעות',
                            icon: 'icon-account-check',
                            state: 'app.pages_events_extras_attendance',
                            weight: 6
                        });
                        break;
                        //coordinator
                    case 2:
                        msNavigationService.saveItem('pages.events-extras', {
                            title: 'ניהול מאורעות',
                            icon: 'icon-weather-sunny',
                            weight: 3
                        });

                        if ($rootScope.User.EventsPer === 1) {
                            msNavigationService.saveItem('pages.events-extras.registrations', {
                                title: 'הרשמות',
                                icon: 'icon-file-document-box',
                                state: 'app.pages_events_extras_registrations',
                                weight: 2
                            });
                            msNavigationService.saveItem('pages.events-extras.questions', {
                                title: 'שאלות',
                                icon: 'icon-format-list-numbers',
                                state: 'app.pages_events_extras_questions',
                                weight: 3
                            });
                            msNavigationService.saveItem('pages.events-extras.transportation', {
                                title: 'הסעות',
                                icon: 'icon-bus',
                                state: 'app.pages_events_extras_transportation',
                                weight: 4
                            });
                            msNavigationService.saveItem('pages.events-extras.attendance', {
                                title: 'מפגשי מאורעות',
                                icon: 'icon-account-check',
                                state: 'app.pages_events_extras_attendance',
                                weight: 6
                            });
                        }
                        if ($rootScope.User.Marketing)
                            msNavigationService.saveItem('pages.events-extras.marketing', {
                                title: 'שיווק ' + $rootScope.User.Events,
                                icon: 'icon-cart',
                                state: 'app.pages_events_extras_marketing',
                                weight: 2

                            });
                        break;
                    //admin
                    default:
                        msNavigationService.saveItem('pages.events-extras', {
                            title: 'ניהול מאורעות',
                            icon: 'icon-weather-sunny',
                            weight: 3
                        });
                        msNavigationService.saveItem('pages.events-extras.marketing', {
                            title: 'שיווק ' + $rootScope.User.Events,
                            icon: 'icon-cart',
                            state: 'app.pages_events_extras_marketing',
                            weight: 5
                        });
                        var regPArams = {
                            title: 'הרשמות',
                            icon: 'icon-file-document-box',
                            state: 'app.pages_events_extras_registrations',
                            weight: 6
                        };
                        if($rootScope.User.WaitingApprovalRegistrations && $rootScope.User.WaitingApprovalRegistrations > 0){
                            regPArams.badge = {
                                content: $rootScope.User.WaitingApprovalRegistrations,
                                color  : '#FF6F00'
                            };
                        }
                        msNavigationService.saveItem('pages.events-extras.registrations',regPArams );
                        msNavigationService.saveItem('pages.events-extras.questions', {
                            title: 'שאלות',
                            icon: 'icon-format-list-numbers',
                            state: 'app.pages_events_extras_questions',
                            weight: 7
                        });
                        msNavigationService.saveItem('pages.events-extras.transportation', {
                            title: 'הסעות',
                            icon: 'icon-bus',
                            state: 'app.pages_events_extras_transportation',
                            weight: 8
                        });
                        msNavigationService.saveItem('pages.events-extras.attendance', {
                            title: 'מפגשי מאורעות',
                            icon: 'icon-account-check',
                            state: 'app.pages_events_extras_attendance',
                            weight: 9
                        });
                        if($rootScope.automaticMonthlyCharge ) {//&& $rootScope.User.Email == "amitm@pionet.co.il"

                            msNavigationService.saveItem('pages.events-extras.charge', {
                                title: 'חיוב הוראות קבע',
                                icon: 'icon-cash',
                                state: 'app.pages_events_extras_charge',
                                weight: 9
                            });
                        }
                        break;
                }
            }
        },true);
    }

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.pages_events_extras_questions', {
                url: '/events-questions',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/events-extras/views/questions/questions.html',
                        controller: 'QuestionsController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/events-questions');
                    }
                },
                bodyClass: 'events'
            })
            .state('app.pages_events_extras_transportation', {
                url: '/events-transportation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/events-extras/views/transportation/transportation.html',
                        controller: 'TransportationController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/events-transportation');
                    }
                },
                bodyClass: 'events'
            })
            .state('app.pages_events_extras_registrations', {
                url: '/events-registrations',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/events-extras/views/registrations/registrations.html',
                        controller: 'RegistrationsController'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/events-registrations');
                    }
                },
                bodyClass: 'events'
            })
            .state('app.pages_events_extras_marketing', {
                url: '/events-marketing',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/events-extras/views/marketing/marketing.html',
                        controller: 'MarketingController as vm'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/events-marketing');
                    }
                },
                bodyClass: 'events'
            })
            .state('app.pages_events_extras_attendance', {
                url: '/events-attendance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/events-extras/views/attendance/attendance.html',
                        controller: 'AttendanceController as vm'
                    }
                },
                resolve: {
                    DashboardData: function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/events-attendance');
                    }
                },
                bodyClass: 'events'
            })
            .state('app.pages_events_extras_charge', {
                url: '/events-charge',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/events-extras/views/monthlyCharge/monthlyCharge.html',
                        controller: 'MonthlyChargeController as vm'
                    }
                },
                resolve: {
                    DashboardData: ["ValidToken", function (ValidToken) {
                        ValidToken.validUserToken();
                        localStorage.setItem("path", '/events-charge');
                    }]
                },
                bodyClass: 'events'
            })
    }

})();

angular.module('app.pages.events-extras').controller('QuestionsController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','usersEndpoint', 'msUtils', '$timeout','$document', 'DTOptionsBuilder','dtOptions','questionsEndpoint','groupsEndpoint','parentsEndpoint','question','Notification', 'recentSearchService'
    ,function($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,questionsEndpoint,groupsEndpoint,parentsEndpoint,question,Notification, recentSearchService) {

        $scope.questions = [];
        $scope.isClicked= false;
        $scope.search = {};

        $scope.loadSearch = loadSearch;

        function loadSearch()
        {
            var search = recentSearchService.get($location.path());
            if(search) {
                $scope.search = search;
            }
        }

        $scope.loadSearch();


        /**
         * Get All Questions
         */
        $scope.getQuestions = function () {
            recentSearchService.save($location.path(), $scope.search);
            $scope.questions = false;
            questionsEndpoint.get($scope.search,function (data) {
                $scope.isClicked= false;
                $scope.questions = data;
            })
        };


        /**
         * Open the new Questions dialog
         */
        $scope.openNewQuestionDialog = function () {
            $mdDialog.show({
                controller         : 'NewQuestionDialogController',
                templateUrl        : 'app/main/pages/events-extras/views/questions/new-question-dialog/new-question-dialog.html',
                clickOutsideToClose: true,
                locals: {
                    eventID: null
                }
            }).then(function () {
                $scope.getQuestions();
            });
        };

        /**
         * Edit Question
         */
        $scope.editQuestion = function (selectedQuestion) {
            question.updateSelectedQuestion(selectedQuestion);
            $mdSidenav("question-panel").open();
        };

        /**
         * open the Confirm delete Questions dialog
         * @param selectedQuestion
         * @param ev
         */
        $scope.deleteQuestionDialog = function (selectedQuestion,ev) {
            var confirm = $mdDialog.confirm()
                .title('מחיקת שאלה')
                .textContent('האם אתה בטוח שברצונך למחוק את שאלה זו? ')
                .targetEvent(ev)
                .ok('מחק')
                .cancel('בטל');
            $mdDialog.show(confirm).then(function() {
                deleteQuestion(selectedQuestion)
            })

        };

        /**
         * Delete the Questions
         * @param selectedQuestion
         */
        var deleteQuestion = function (selectedQuestion) {
            var index = $scope.questions.indexOf(selectedQuestion);
            $scope.questions.splice(index, 1);
            questionsEndpoint.delete.post(selectedQuestion, function (data) {
                if (!data.success) {
                    Notification.info("השאלה מקושרת ל"+$rootScope.User.Event+" קיים - לא ניתן למחוק");
                    $scope.questions.push(selectedQuestion);
                }
            })
        };


        /**
         * Filter by status
         * @param item
         * @returns {boolean}
         */
        $scope.filterByStatus = function (item) {
            if ($scope.search.status==1)
                return item.Status==1;
            else if ($scope.search.status==0)
                return item.Status==0;
            else
                return true;
        };

        /**
         * Set Type
         * @param type
         * @returns {string}
         */
        $scope.setType = function(type) {
            switch (type) {
                case "1":
                case 1:
                    return "שאלה פתוחה";
                case "2":
                case 2:
                    return "אפשרויות";
                case "3":
                case 3:
                    return "קובץ";
                case "4":
                case 4:
                    return "תאריך";
                case "5":
                case 5:
                    return "צ'ק בוקס";
            }
        };


        /**
         * Set Table option
         * @type {any}
         */
        $scope.dtOptions = DTOptionsBuilder
            .newOptions()
            .withLanguage(dtOptions.language)
            .withDOM('lfrtp')
            .withOption('responsive',true)
            .withOption('bFilter', false)
            .withDOM('lrtip');

    }]);

angular.module('app.pages.profile-forms').controller('SubsidyFormController', SubsidyFormController);
angular.module('app.pages.profile-forms').controller('SubsidyFormController', SubsidyFormController);

function SubsidyFormController ($scope, DTOptionsBuilder, dtOptions, eventsEndpoint, formsEndpoint, $mdDialog, DTColumnDefBuilder,studentsEndpoint,parentsEndpoint, $location, recentSearchService) {


    var vm = this;
    vm.getSubsidyForms= getSubsidyForms;
    vm.openSubsidyDialog = openSubsidyDialog;
    vm.searchTerm = '';
    vm.subsidyes=  [];

    vm.loadSearch = loadSearch;

    function loadSearch()
    {
        var search = recentSearchService.get($location.path());
        if(search) {
            vm.search = search;
        }
    }

    vm.loadSearch();

    /**
     * Get parent Contact Forms
     */
    function getSubsidyForms(reset) {
        if (reset) {
            vm.search = {};
            recentSearchService.save($location.path(), vm.search);
            return;
        }
        recentSearchService.save($location.path(), vm.search);
        vm.subsidyes = false;
        formsEndpoint.subsidy.get(vm.search,function (data) {
            vm.subsidyes = data;
        })
    }


    /**
     * Open The Subsidy Dialog
     * @param subsidy
     */
    function openSubsidyDialog(subsidy) {
        var DBSubsidy;
        var kids = [];
        parentsEndpoint.subsidy.getByID(subsidy.ParentID,subsidy.SubsidyID,function (data) {
            DBSubsidy = data;
            DBSubsidy.forEach(function (sub) {
                if (sub.typeForm) {
                    sub.Parent1PrivateIDFile = JSON.parse(sub.Parent1PrivateIDFile);
                    if (sub.Parent2PrivateIDFile) {
                        sub.Parent2PrivateIDFile = JSON.parse(sub.Parent2PrivateIDFile);
                    }
                    sub.Parent1Paycheck1File = JSON.parse(sub.Parent1Paycheck1File);
                    if (sub.Parent2Paycheck1File) {
                        sub.Parent2Paycheck1File = JSON.parse(sub.Parent2Paycheck1File);
                    }
                    sub.Parent1Paycheck2File = JSON.parse(sub.Parent1Paycheck2File);
                    if (sub.Parent2Paycheck2File) {
                        sub.Parent2Paycheck2File = JSON.parse(sub.Parent2Paycheck2File);
                    }
                    sub.Parent1Paycheck3File = JSON.parse(sub.Parent1Paycheck3File);
                    if (sub.Parent2Paycheck3File) {
                        sub.Parent2Paycheck3File = JSON.parse(sub.Parent2Paycheck3File);
                    }
                    if (sub.OtherFiles) {
                        sub.OtherFiles = JSON.parse(sub.OtherFiles);
                    }

                    if (sub.MoreKids && sub.MoreKids !== "[]") {
                        var kids = {};
                        kids['IDs'] = sub.MoreKids;
                        studentsEndpoint.get(kids, function (response) {
                            kids = response.data.items;
                        })
                    }
                }
            });
            $mdDialog.show({
                controller: 'SubsidyDialogController',
                templateUrl: 'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/subsidy-dialog.html',
                clickOutsideToClose: true,
                locals: {'subsidy': DBSubsidy[0],'moreKids' : kids}
            });
        });

    }


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip')
        .withOption('order', [0, 'desc']);

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a === '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });


    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];


}





angular.module('app.pages.events-extras').controller('MarketingController', MarketingController);

function MarketingController($rootScope,filesEndpoint, DTOptionsBuilder, dtOptions,gradesEndpoint, $mdDialog,marketingEndpoint,settlementsEndpoint, $location, recentSearchService) {

    var vm =this;
    vm.getGrades = getGrades;
    vm.getSettlements = getSettlements;
    vm.settlementsQuerySearch =settlementsQuerySearch;
    vm.gradesQuerySearch =gradesQuerySearch;
    vm.openSendSMS= openSendSMS;
    vm.openSendEmail =openSendEmail;
    vm.getEvents = getEvents;
    vm.getLeads =getLeads;
    vm.setAll = setAll;
    vm.search = {};
    vm.search.settlements = [];
    vm.search.grades = [];
    vm.grades= [];
    vm.leads = [];
    vm.loadSearch = loadSearch;

    function loadSearch()
    {
        var search = recentSearchService.get($location.path());
        if(search) {
            vm.search = search;
        }
    }

    function getSettlements(){
        settlementsEndpoint.get({},function (data){
            vm.settlements = data;
        })
    }
    /**
     * Get Grades
     */
    function getGrades() {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params,function (data) {
            vm.grades = data;
        })
    }


    /**
     * Get Events
     */
    function getEvents() {
        marketingEndpoint.leads.events.get(function (data) {
            vm.events= data;
        })
    }

    function getLeads(reset) {
        if (reset){
            vm.search = {};
            vm.search.settlements = [];
            vm.search.grades = [];
            recentSearchService.save($location.path(), vm.search);
            return;
        }
        recentSearchService.save($location.path(), vm.search);
        vm.leads =false;
        marketingEndpoint.leads.get(vm.search,function (data) {
            vm.leads = data;
        })
    }

    /**
     * Settlements query search
     * @param query
     * @returns {Array}
     */
     function settlementsQuerySearch(query) {
        var results = query ? vm.settlements.filter(createFilterFor(query)) : [];
        return results;
    }



    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    function gradesQuerySearch(query) {
        if (vm.grades)
            var results = query ? vm.grades.filter(createFilterFor(query)) : [];
        return results;
    }


    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }

    /**
     * Open send sms dialog
     */
      function openSendSMS() {
        $mdDialog.show({
            controller         : 'SMSDialogController',
            templateUrl        : 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
            locals : {'students' : vm.leads,'external': false ,"type": 1 },
            clickOutsideToClose: false

        });
    };

    /**
     * open send email
     */
     function openSendEmail() {
        $mdDialog.show({
            controller         : 'EmailDialogController',
            templateUrl        : 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
            locals : {'students' : vm.leads,'external': false,"type": 1  },
            clickOutsideToClose: false

        });
    }

    /**
     * Select All
     * @param selectAll
     */
      function setAll(selectAll) {
        if (selectAll) {
            for (var i=0;i<vm.leads.length;i++) {
                vm.leads[i].Selected = true;
            }
        }
        else
            for (var i=0;i<vm.leads.length;i++) {
                vm.leads[i].Selected = false;
            }
    }



    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('responsive',true)
        .withOption('bFilter', false)
        .withDOM('lrtip');

}



angular.module('app.pages.events-extras').controller('AttendanceController', AttendanceController);

function AttendanceController(filesEndpoint, DTOptionsBuilder, dtOptions, gradesEndpoint, $mdDialog, eventsEndpoint, eventMeeting, $mdSidenav, $timeout, $location, recentSearchService) {

    var vm = this;
    vm.getEvents = getEvents;
    vm.getMeetings = getMeetings;
    vm.openNewMeetingDialog = openNewMeetingDialog;
    vm.editMeeting = editMeeting;
    vm.eventKeyPress = eventKeyPress;
    vm.meetings = [];
    vm.search = {
        eventID: undefined,
        StartDate: moment().subtract(7, 'd').format('DD/MM/YYYY'),
        EndDate: moment().add(1, 'd').format('DD/MM/YYYY'),
        FreeSearchFromDB: '',
    }
    vm.loadSearch = loadSearch;

    function loadSearch() {
        var search = recentSearchService.get($location.path());
        if (search) {
            vm.search = search;
        }
    }

    vm.loadSearch();

    function eventKeyPress(event) {
        var currentState = event.target.value;
        $timeout(function () {
            if (currentState != undefined && currentState.length > 0 && currentState == event.target.value)
                vm.getEvents(currentState);
        }, 1000)
    }


    /**
     * Get Events
     */
    function getEvents(name) {
        var params = {
            Status: 1,
            FreeSearch: name
        };
        eventsEndpoint.get(params, function (data) {
            vm.events = data;
        })
    }


    function getMeetings(reset) {
        if (reset) {
            vm.search = {
                eventID: undefined,
                StartDate: moment().format('DD/MM/YYYY'),
                EndDate: moment().format('DD/MM/YYYY'),
                FreeSearchFromDB: '',
            }
        }
        recentSearchService.save($location.path(), vm.search);
        vm.meetings = false;
        eventsEndpoint.meetings.get(vm.search, function (data) {
            vm.meetings = data;
        })
    }


    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    function openNewMeetingDialog() {
        $mdDialog.show({
            controller: 'NewEventMeetingController',
            templateUrl: 'app/main/pages/events-extras/views/attendance/new-event-meeting-dialog/new-event-meeting-dialog.html',
            clickOutsideToClose: true
        }).then(function (res) {
            if (res) {
                $timeout(function () {
                    $location.url('/meeting-management?ID=' + res);
                }, 500);

            }
        });
    }

    /**
     * Edit Category
     */
    function editMeeting(selectedMeeting) {
        eventMeeting.updateSelectedMeeting(selectedMeeting)
        $mdSidenav("meeting-panel").open();
    }


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', true)
        .withDOM('lrtip');

}



angular.module('app.pages.events-extras').controller('TransportationController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','usersEndpoint', 'msUtils', '$timeout','$document', 'DTOptionsBuilder','dtOptions','transportationEndpoint','groupsEndpoint','parentsEndpoint','transportation','Notification'
    ,function($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,transportationEndpoint,groupsEndpoint,parentsEndpoint,transportation,Notification) {

        $scope.transportation = [];
        $scope.isClicked= false;
        $scope.search = {};

        /**
         * Get All Transportation
         */
        $scope.getTransportation = function () {
            $scope.transportation = false;
            transportationEndpoint.get(function (data) {
                $scope.transportation = data;
            })
        };


        /**
         * Open add new Transportation Dialog
         */
        $scope.openNewTransportationDialog = function () {
            $mdDialog.show({
                controller         : 'NewTransportationDialogController',
                templateUrl        : 'app/main/pages/events-extras/views/transportation/new-transportation-dialog/new-transportation-dialog.html',
                clickOutsideToClose: true
            }).then(function () {
                $scope.getTransportation();
            });
        };

        $scope.openTransportationStopsPanel = function (transport){
            $mdDialog.show({
                controller         : 'TransportationStopsPanel',
                templateUrl        : 'app/main/pages/events-extras/views/transportation/transportation-stops-panel/transportation-stops-panel.html',
                clickOutsideToClose: false,
                locals             : {
                    transportation: transport
                }
            }).then(function () {
                $scope.getTransportation();
            });
        }

        /**
         * Edit transportation
         */
        $scope.editTransportation = function (selectedTransportation) {
            transportation.updateSelectedTransportation(selectedTransportation);
            $mdSidenav("transportation-panel").open();
        };

        /**
         * Open the delete Transportation alert
         * @param selectedTransportation
         * @param ev
         */
        $scope.deleteTransportationDialog = function (selectedTransportation,ev) {
            var confirm = $mdDialog.confirm()
                .title('מחיקת שאלה')
                .textContent('האם אתה בטוח שברצונך למחוק את שאלה זו? ')
                .targetEvent(ev)
                .ok('מחק')
                .cancel('בטל');
            $mdDialog.show(confirm).then(function() {
                deleteTransportation(selectedTransportation)
            })

        };

        /**
         * Delete Transportation
         * @param selectedTransportation
         */
        var deleteTransportation = function (selectedTransportation) {
            var index = $scope.transportation.indexOf(selectedTransportation);
            $scope.transportation.splice(index, 1);
            transportationEndpoint.delete.post(selectedTransportation, function (data) {
                if (!data.success) {
                    Notification.info("ההסעה מקושרת ל"+$rootScope.User.Event+" קיים - לא ניתן למחוק");
                    $scope.transportation.push(selectedTransportation);
                }
            })
        };


        /**
         * Filter by status
         * @param item
         * @returns {boolean}
         */
        $scope.filterByStatus = function (item) {
            if ($scope.search.status==1)
                return item.Status==1;
            else if ($scope.search.status==0)
                return item.Status==0;
            else
                return true;
        };

        /**
         * Set Table option
         * @type {any}
         */
        $scope.dtOptions = DTOptionsBuilder
            .newOptions()
            .withLanguage(dtOptions.language)
            .withDOM('lfrtp')
            .withOption('responsive',true)
            .withOption('bFilter', false)
            .withDOM('lrtip');

    }]);

angular.module('app.pages.events-extras').controller('RegistrationsController', RegistrationsController);

function RegistrationsController($scope, $rootScope, $mdSidenav, DTColumnDefBuilder, settlementsEndpoint, groupsEndpoint, reportsEndpoint, gradesEndpoint, $mdDialog, usersEndpoint, msUtils, $timeout, $document, DTOptionsBuilder, dtOptions, receiptsEndpoint, receiptsService, Notification, eventsEndpoint, $element, $location, recentSearchService) {


    $scope.registrations = [];
    $scope.search = {};
    $scope.search.settlements = [];
    $scope.search.groups = [];
    $scope.search.grades = [];
    $scope.selectedStudentsCount = 0;
    $scope.loadSearch = loadSearch;

    $scope.getCostingCodes = function () {
        reportsEndpoint.epr.info({}, function (data) {
            $scope.costingCodes = data.Codes;
        });
    };

    $scope.init = function () {
        $scope.search.FromDate = moment().startOf('year').format('DD/MM/YYYY')
        $scope.search.ToDate = moment().format('DD/MM/YYYY')
        $scope.getCostingCodes();
        $scope.getEventCategories();
        $scope.getSettlements();
        $scope.getGrades();
        $scope.loadSearch();
    }

    function loadSearch() {
        var search = recentSearchService.get($location.path());
        if (search) {
            $scope.search = search;
        }
    }

    $scope.getRegistrations = function (reset) {
        if (reset) {
            $scope.search = {
                FromDate : moment().startOf('year').format('DD/MM/YYYY'),
                ToDate : moment().format('DD/MM/YYYY')
            };
        }

        $scope.registrations = false;
        $scope.isClicked = true;
        $scope.search.Limit = 1000;
        recentSearchService.save($location.path(), $scope.search);
        eventsEndpoint.registrations.get($scope.search, function (data) {
            $scope.selectedStudentsCount = 0;
            $scope.isClicked = false;
            if (data)
                $scope.registrations = data;
        });
    };

    $scope.getGroups = function () {
        var params = {
            SettlementIdes: $scope.search.settlements
        }
        groupsEndpoint.get(params, function (data) {
            $scope.groups = data;
        });
    }

    $scope.clearSearchTerm = function () {
        $scope.searchTerm = '';
    };

    /**
     * Download receipt
     * @param receipt
     * @param type
     */
    $scope.downloadReceipt = function (receipt, type) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receipt, type)

    };

    $scope.getSettlements = function () {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })
    }


    $scope.getEventCategories = function () {
        eventsEndpoint.categories.get({calendar: true, AsArray: true}, function (data) {
            $scope.categories = data;
            $scope.categories.forEach(function (category) {
                category.Path.reverse();
            })
        })
    }

    /**
     * Get Grades
     */
    $scope.getGrades = function () {
        var params = {};
        params.Status = 1;
        gradesEndpoint.get(params, function (data) {
            $scope.grades = data;
        })
    };

    /**
     * Settlements query search
     * @param query
     * @returns {Array}
     */
    $scope.settlementsQuerySearch = function (query) {
        var results = query ? $scope.settlements.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    $scope.groupsQuerySearch = function (query) {
        var results = query ? $scope.groups.filter(createFilterFor(query)) : [];
        return results;
    };


    /**
     * Groups query search
     * @param query
     * @returns {*}
     */
    $scope.gradesQuerySearch = function (query) {
        if ($scope.grades)
            var results = query ? $scope.grades.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * Get Events for selected
     */
    $scope.getEvents = function () {
        var params = {CategoryIdes: JSON.stringify($scope.search.categories)}
        eventsEndpoint.get(params, function (data) {
            $scope.events = data;
        })
    };

    $element.find('input').on('keydown', function (ev) {
        ev.stopPropagation();
    });


    /**
     * Show full Registration
     * @param registration
     */
    $scope.showFullRegistration = function (registration) {
        $mdDialog.show({
            controller: 'FullRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html',
            clickOutsideToClose: true,
            locals: {'registration': registration}
        })
    };

    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.refundRegistration = function (registration) {

        $mdDialog.show({
            controller: 'RefundRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };


    /**
     * Open Cancel Registration Dialog
     * @param registration
     */
    $scope.cancelRegistration = function (registration) {

        $mdDialog.show({
            controller: 'CancelRegistrationDialogController',
            templateUrl: 'app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html',
            locals: {'registration': registration, external: false},
            clickOutsideToClose: true
        }).then(function () {
            $scope.getRegistrations();
        });
    };


    /**
     * Update payments status
     */
    $scope.changePaymentsStatus = function () {

        var confirm = $mdDialog.confirm()
            .title('שינוי סטטוס תשלום')
            .textContent('האם אתה בטוח/ה שברצונך לאשר הזמנות אלו?')
            .ok('אישור')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function () {
            var selectedStudents = $scope.registrations.filter(function (reg) {
                return reg.Selected && reg.PaymentType == 2 && reg.PaymentStatus == 2;
            }).map(function (reg) {
                return reg.ID;
            });
            $scope.isClicked = true;
            eventsEndpoint.registrations.update.post({Registrations: selectedStudents}, function (data) {
                $scope.isClicked = false;
                if (data.success) {
                    Notification.success("הרשמות עודכנו בצלחה");
                    $scope.getRegistrations();
                } else
                    Notification.error("נכשל בעדכון הרשמות");
            })
        });

    };

    /**
     * Student Count
     * @param reg
     */
    $scope.studentToggled = function (reg) {
        if (reg.Selected)
            $scope.selectedStudentsCount++;
        else
            $scope.selectedStudentsCount--;
    }

    /**
     * Set all params
     * @param selectAll
     */
    $scope.setAll = function (selectAll) {
        if (selectAll) {
            $scope.registrations.forEach(function (reg) {
                reg.Selected = selectAll;
                $scope.selectedStudentsCount++;
            })
        } else {
            $scope.registrations.forEach(function (reg) {
                reg.Selected = false;
            })
            $scope.selectedStudentsCount = 0;
        }

    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive', true)
        .withOption('order', [1, 'desc']);

    $scope.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).notSortable()

    ];

    $scope.approveRegistrations = function () {
        $mdDialog.show({
            controller: 'ApproveRegistrationsDialog',
            templateUrl: 'app/main/pages/events-dialogs/approve-registrations-dialog/approve-registrations-dialog.html',
            clickOutsideToClose: true,
            locals: {
                'registrations': $scope.registrations.filter(function (el) {
                    return el.Selected && !el.ApproveDate
                }).slice()
            }
        }).then(function () {
            $scope.getRegistrations();
        });
    }

}

angular.module('app.pages.events-extras').controller('MonthlyChargeController', MonthlyChargeController);

function MonthlyChargeController($scope, $rootScope, $document, $mdDialog, $timeout, $sce, settingsEndpoint, paymentsEndpoint, DTOptionsBuilder, dtOptions, DTColumnDefBuilder) {
    $scope.table = {
        dtInstance: {}
    };
    $scope.chargingDone = false;
    $scope.summaryLabel = '';
    $scope.chargeDates = [];
    $scope.selectedTab = 0;
    $scope.chargeUsers = [];
    $scope.chargeDatesDetails = [];
    $scope.chargeID = null;
    $scope.chargeUser = null;
    $scope.events = [];
    $scope.chargeType = 1;
    $scope.percentDiscount = 0;
    $scope.selectAll = false;
    $scope.newPrice = 0;
    $scope.selectRegsCount = 0;
    $scope.selectEventsCount = 0;
    $scope.isClicked = false;
    $scope.step = 0;
    $scope.finalData = {};
    $scope.chargesLength = 0;
    $scope.step2Counter = 0;
    /**
     * Get Events
     */

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', true)
        .withDOM('lrtip')
        .withOption('order', [1, 'desc']);


    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "eu-date-pre": function (a) {
            if (a == null || a == '') {
                return 0;
            }
            var date = a.split('/');
            return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
        }
    });
    if ($scope.activeModule && $scope.activeModule.eventDates) {
        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(2).withOption('type', 'eu-date'),
            DTColumnDefBuilder.newColumnDef(3).withOption('type', 'eu-date'),
            DTColumnDefBuilder.newColumnDef(4).withOption('type', 'eu-date')

        ];
    }

    ////

    $scope.trustSrc = function () {
        return $sce.trustAsResourceUrl('https://emekyizrael-admin-v2.signmeapp.co.il/charge');
    };
    $scope.setTab = function (tab) {
        $scope.selectedTab = tab;
    };
    $scope.getChargeDates = function (detailed, internal) {
        if (!internal) {
            $scope.isClicked = true;
        }
        var params = {detailed: detailed, MonthlyChargeID: $scope.chargeID};
        paymentsEndpoint.getMonthlyChargesList(params, function (data) {
            if (detailed) {
                if (data['step']) {
                    $scope.isClicked = true;
                    $timeout(function () {

                        $scope.getChargeDates(1, true);
                    }, 5000);

                } else {
                    if (!internal || !$scope.chargeDatesDetails.length) {
                        $scope.chargeDatesDetails = data;
                    } else {
                        data.forEach(function (charge) {
                            var selectedCharge = $scope.chargeDatesDetails.find(function (c) {
                                return c.RegistrationID === charge.RegistrationID;
                            });
                            if (selectedCharge) {
                                selectedCharge.StatusCode = charge.StatusCode;
                                selectedCharge.ReceiptID = charge.ReceiptID;
                            }
                        });
                    }
                    var cnt = 0;
                    $scope.chargeDatesDetails.forEach(function (charge) {
                        if (charge.StatusCode && charge.StatusCode.length) {
                            cnt++;
                        }
                    });
                    if ($scope.chargeDatesDetails.length > cnt) {
                        $scope.chargingDone = false;
                        $scope.summaryLabel = 'התהליך טרם הסתיים';
                        $scope.summaryLabel += ', ';
                        $scope.summaryLabel += 'בוצעו ' + cnt + ' מתוך ' + $scope.chargeDatesDetails.length + ' חיובים';
                        $timeout(function () {
                            $scope.getChargeDates(1, true);
                        }, 5000);

                    } else {
                        $scope.summaryLabel = 'התהליך הסתיים';
                        $scope.chargingDone = true;
                    }
                }
            } else {
                $scope.chargeDates = data;
            }
            if (!data['step']) {
                $scope.isClicked = false;
            }
        });
    };
    $scope.getChargeDates(0);
    $scope.excelExport = function () {
        paymentsEndpoint.exportMonthlyResults({chargeID: $scope.chargeID}, function (data) {

        });
    };

    $scope.chargeEvents = function () {

        var confirm = $mdDialog.confirm()
            .title('חיוב הרשמות')
            .textContent('האם את/ה בטוח/ה שברצונך לחייב הרשמות אלו?')
            .ok('אישור')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function () {
            $scope.chargeDatesDetails = [];
            $scope.isClicked = true;
            var params = {
                Status: 1,
                MonthlyPayment: 1,
                ChargeType: $scope.chargeType,
                PercentDiscount: $scope.percentDiscount,
                Amount: $scope.newPrice,
                Step: 3,
                PreviewDataOnly: 0
            };
            paymentsEndpoint.createMonthly(params, function (data) {
                $scope.chargeID = data.ID;
                $scope.monthlyID = data.ID;
                var regsToCharge = [];
                $scope.events.forEach(function (event) {
                    event['Registrations'].forEach(function (reg) {
                        if (reg.Selected) {
                            regsToCharge.push(reg.ID);
                        }
                    });
                    if (regsToCharge.length > 0) {
                        $scope.chargesLength++;
                    }
                });
                if (regsToCharge.length > 0) {
                    $scope.getEvents(3, regsToCharge);

                }

            });
        });

    };
    /**
     * Get Events
     */
    $scope.getEvents = function (step, eventIDOrRegs) {
        $scope.isClicked = true;
        if (step === 1)
            $scope.events = [];

        $scope.selectRegsCount = 0;
        $scope.selectEventsCount = 0;
        $scope.selectAll = false;
        var params = {
            Status: 1,
            MonthlyPayment: 1,
            ChargeType: $scope.chargeType,
            PercentDiscount: $scope.percentDiscount,
            Amount: $scope.newPrice,
            Step: step,
            PreviewDataOnly: [1, 2].includes(step) ? 1 : 0
        };
        if (eventIDOrRegs) {
            var tmp = step === 3 ? 'Registrations' : 'EventID';
            params[tmp] = eventIDOrRegs;
        }
        if (step === 3) {
            params['MonthlyID'] = $scope.monthlyID;
        }
        paymentsEndpoint.getMonthly(params, function (data) {

            if (step === 1) {
                $scope.events = data;
                $scope.step2Counter = 0;
                $scope.step2Counter = $scope.events.length;
                $scope.events.forEach(function (event) {

                    $scope.getEvents(2, event.ID);
                });
            }
            if (step === 2) {
                $scope.step2Counter--;
                var selectedEvent = $scope.events.find(function (e) {
                    return e.ID === eventIDOrRegs;
                });
                selectedEvent.Registrations = data[0]['Registrations'];
                var emptys = [];
                selectedEvent.Registrations.forEach(function (reg) {
                    if (!reg.Price || reg.Price === 0) {
                        emptys.push(reg);
                    }
                    reg.Selected = false;
                });
                emptys.forEach(function (reg) {
                    selectedEvent.Registrations.splice(selectedEvent.Registrations.indexOf(reg), 1);
                });
                if ($scope.step2Counter === 0) {
                    $scope.isClicked = false;
                }
            }
            if (step === 3) {
                $scope.chargesLength--;
                $timeout(function () {
                    $scope.getChargeDates(0);
                    $scope.getChargeDates(1);
                    $scope.setTab(0);
                }, 500);
            }

            $scope.step = step;
        });
    };

    /**
     * Set all params
     * @param selectAll
     */
    $scope.setAll = function (selectAll) {
        if (selectAll) {
            $scope.events.forEach(function (event) {
                event.Selected = selectAll;
                $scope.selectEventsCount++;
                $scope.setAllRegs(selectAll, event);
            });
        } else {
            $scope.events.forEach(function (event) {
                event.Selected = false;
                $scope.setAllRegs(false, event);
            });
            $scope.selectEventsCount = 0;
        }
    };


    /**
     * Set all params
     * @param selectAll regs
     */
    $scope.setAllRegs = function (selectAll, event) {
        var selectedEvent = $scope.events.find(function (e) {
            return e.ID === event.ID;
        });
        if (selectAll) {
            selectedEvent.Registrations.forEach(function (reg) {
                reg.Selected = selectAll;
                $scope.selectRegsCount++;
            });
        } else {
            selectedEvent.Registrations.forEach(function (reg) {
                reg.Selected = false;
            });
        }
        $scope.selectRegsCount = 0;
        $scope.events.forEach(function (event) {
            event.Registrations.forEach(function (reg) {
                if (reg.Selected) {
                    $scope.selectRegsCount++;
                }
            });
        });
    };


    /**
     * Student Count
     * @param reg
     */
    $scope.eventToggled = function (event) {
        if (event.Selected) {
            $scope.selectEventsCount++;
            $scope.setAllRegs(true, event);
        } else {
            $scope.selectEventsCount--;
            $scope.setAllRegs(false, event);
        }
    };
    /**
     * Student Count
     * @param reg
     */
    $scope.regsToggled = function (reg) {
        if (reg.Selected) {
            $scope.selectRegsCount++;
        } else {
            $scope.selectRegsCount--;
        }
    };

    $scope.openList = function (idx) {
        if (idx !== -1) {
            $scope.events.forEach(function (event, index) {
                if (index != idx) {
                    var tmpDiv = $document.find('.hiddenRow_' + (index + 1));
                    if (!tmpDiv[0].classList.contains('hiddenRow')) {
                        tmpDiv[0].classList.add('hiddenRow');
                    }
                }
            });
            var theDiv = $document.find('.hiddenRow_' + (idx + 1));
            if (theDiv[0].classList.contains('hiddenRow')) {
                theDiv[0].classList.remove('hiddenRow');
            } else {
                theDiv[0].classList.add('hiddenRow');
            }
        } else {
            var theDivs = $document.find('.hiddenRow');
            for (var i = 0; i < theDivs.length; i++) {
                theDivs[i].classList.remove('hiddenRow');
            }
        }

    };

}



angular.module('app.pages.users').controller('NewCoordinatorsDialogController', ['$scope', '$rootScope', '$mdDialog','coordinatorsEndpoint','coordinate','$location','Notification', function ($scope, $rootScope, $mdDialog,coordinatorsEndpoint,coordinate,$location,Notification) {

    /**
     * Save new Student
     */
    $scope.saveNesCoordinator = function () {
        $scope.isClicked = true;
        coordinatorsEndpoint.post($scope.newCoordinator,function (data) {
            $scope.isClicked = false;
            if (data.ID) {
                Notification.success("הזמנה נשלחה למשתמש")
                coordinate.updateSelectedCoordinate(data);
                $location.path('/coordinator-profile?ID='+data.ID);
                $mdDialog.hide();
            }
            else {
                Notification.info("דואר אלקטרוני קיים במערכת")
            }
        })

    };

    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };

}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.new-coordinator', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {

        $stateProvider.state('app.pages_new-coordinator', {
            url      : '/new-coordinator',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin/coordinators/new-coordinator/new-coordinator.html',
                    controller : 'NewCoordinatorController'
                }
            },
            bodyClass: 'profile'
        });


    }

})();

angular.module('app.pages.new-coordinator').controller('NewCoordinatorController', NewCoordinatorController)
function NewCoordinatorController($scope, $rootScope,$location,coordinatorsEndpoint,Notification,$timeout,appConfig,$cookies) {


    $scope.showHideText = 'הצג';
    $scope.inputType = 'password';
    $scope.showHideImg = "/assets/icons/show.svg";
    $scope.matchPasswords = false;
    $scope.matchFlags = true;
    $scope.password = '';
    $scope.passwordVerify = '';
    $scope.form = {};
    $scope.success = false;
    $scope.loading = false;
    $scope.appConfig = appConfig;
    $scope.errorInfo = "";

    /**
     * Valid the new admin request for register a new admin
     */
    $scope.validRequest = function () {
        var params = {};
        params.token =  $location.search().tempToken;
        coordinatorsEndpoint.new.valid.post(params,function (data) {
            if (data.success)
                $scope.valid=true;
            else{
                $location.path("/");
                $scope.notValid=true;
            }

        })
    };
    $scope.matchPass = function () {
        if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length > 5) {
            $scope.matchPasswords = true;
            $scope.matchFlags = true;
        } else if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length < 6) {
            $scope.shortPass = true;
            $scope.matchFlags = true;
        } else {
            $scope.shortPass = false;
            $scope.matchPasswords = false;
            $scope.matchFlags = false;
        }
    }

    /**
     * Display or hide the password
     */
    $scope.showHidePassword = function () {
        if ($scope.inputType == "password") {
            $scope.inputType = "text";
            $scope.showHideText = 'הסתר';
            $scope.showHideImg = "/assets/icons/hide.svg";
        } else {
            $scope.inputType = "password";
            $scope.showHideText = 'הצג';
            $scope.showHideImg = "/assets/icons/show.svg";
        }

    };

    /**
     * Submit the new admin sing up
     */
    $scope.submit = function () {
        $scope.form.token = $location.search().tempToken;
        coordinatorsEndpoint.new.post($scope.form, function (data) {
            if (typeof data == 'string' || data instanceof String) {
                $scope.errorInfo = data;
                $scope.fail = true;
                $timeout(function () {
                    $scope.fail = false;
                }, 5000);
            }
            else if (data.ID) {
                $rootScope.User = data;
                setUserType();
                saveUser();
                $scope.success = true;
            }
            else
                $scope.errorInfo = "Error!";
            $scope.loading = true;
        })

    };

    /**
     * Set the admin type
     */
    function setUserType() {
        if ($rootScope.User.StudentID)
            $rootScope.AdminLevel = 1;
        else if ($rootScope.User.IsCoordinator)
            $rootScope.AdminLevel = 2;
        else
            $rootScope.AdminLevel = 3;
    }

    function saveUser() {
        var expireTime = +new Date() + (24 * 3600000);
        $cookies.put(appConfig.adminTokenName, $rootScope.User.AccessToken, [{expires: expireTime}]);
        $scope.loogin = false;
        $timeout(function () {
            if ($rootScope.AdminLevel !== 3)
                $location.path('/students');
            else
                $location.path('/dashboard');
        }, 250)
    }

    /**
     * href to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };

}

angular.module('app.pages.users').controller('ManageGroupsController', ManageGroupsController);
function ManageGroupsController($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,groupsEndpoint,regionsEndpoint,group, settlementsEndpoint, recentSearchService) {


    $scope.search = {};
    $scope.search.settlements = [];

    loadSearch();

    function loadSearch()
    {
        var search = recentSearchService.get($location.path());
        if(search) {
            $scope.search = search;
        }
    }

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');


    /**
     * Get All Branches And Groups
     */
    $scope.getGroups = function (reset) {
        if (reset) {
            $scope.search = {};
            $scope.search.settlements = [];
            recentSearchService.save($location.path(), $scope.search);
            return;
        }
        recentSearchService.save($location.path(), $scope.search);
        $scope.isClicked = true;
        var params = {};
        params.SettlementIDs = [];
        params.SettlementIDs = $scope.search.settlements.map(function(settlement) {
            return settlement.ID;
        });
        params.SettlementIDs = JSON.stringify(params.SettlementIDs);



        params.FreeSearch = $scope.search.freeSearchFromDB;
        params.Status = $scope.search.status;
        params.Type = $scope.search.educator;
        $scope.groups = null;
        groupsEndpoint.get(params, function (data) {
            $scope.isClicked = false;
            $scope.groups = data;
        })
    };


    $scope.getSettlements = function() {
        $scope.settlements = [];
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        })
    };

    /**
     * Open side nev to update branch
     * @param selectedGroup
     */
    $scope.editGroup = function (selectedGroup) {
        group.updateSelectedGroup(selectedGroup);
        $mdSidenav("groups-panel").open();
    };

    /**
     * Add new branch dialog
     */
    $scope.addNewGroupDialog = function () {
        $mdDialog.show({
            controller: 'NewGroupDialogController',
            templateUrl: 'app/main/pages/branches/views/groups/new-group-dialog/new-group-dialog.html',
            clickOutsideToClose: false
        }).then(function () {
            $scope.getGroups();
        });
    };


    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.settlementsQuerySearch = function (query) {
        var results = query ?
            $scope.settlements.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


}




angular.module('app.pages.users').controller('CoordinatePanelController', ['$scope','coordinate','$rootScope','rolesEndpoint', function($scope,coordinate,$rootScope,rolesEndpoint) {




    /**
     * Set the selected Coordinators
     */
    $scope.$on('selectedCoordinate:updated', function() {
        $scope.coordinate= coordinate.selectedCoordinate;
        $scope.getRoles();
    });
    
    /**
     * Get Roles
     */
    $scope.getRoles =function () {
        var params = {};
        params.withNames = true;
        rolesEndpoint.get(params, function (data) {
            $scope.roles = data;
        })
    }

    /**
     * looking for changes in the Coordinators object
     */
    $scope.$watchCollection('coordinate',function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue,'coordinate-panel')
    })







}]);
(function ()
{
    'use strict';

    angular
        .module('app.pages.coordinators-profile', ['datatables'])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_coordinators-profile', {
            url      : '/coordinator-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin/coordinators/coordinators-profile/coordinators-profile.html',
                    controller: 'CoordinatorProfileController'
                },

            },
            resolve  : {
                DashboardData: function ()
                {
                    localStorage.setItem("path",'/coordinator-profile');
                }
            },
            bodyClass: 'coordinator-profile'
        });


    }

})();

angular.module('app.pages.coordinators-profile').controller('CoordinatorProfileController',CoordinatorProfileController);
function CoordinatorProfileController($scope, $rootScope,$location,usersEndpoint,$mdSidenav,$mdDialog,rolesEndpoint,settingsEndpoint, DTOptionsBuilder,settlementsEndpoint,$timeout,coordinate,coordinatorsEndpoint,parent,dtOptions,Notification,eventsEndpoint) {



    /**
     * Init Student Profile
     */
    function init() {
        var coordinatorObject = {};
        coordinatorObject.ID = $location.search().ID;
        if (!coordinatorObject.ID) {
            $location.path('/coordinators');
        }
        else {
           resolveCoordinator(coordinatorObject);
        }
        $scope.currentCoordinatorID = coordinatorObject.ID;
        /*$scope.$watch(function(){
            if($location.path().includes('coordinator'))
                return  $location.search()
        }, function(data){
            if(data && $scope.currentCoordinatorID !== null && data.ID !== $scope.currentCoordinatorID){
                if (data.ID){
                    coordinatorObject = {};
                    coordinatorObject.ID = data.ID;
                    if (!coordinatorObject.ID) {
                        $location.path('/coordinators');
                    }
                    else {
                        resolveCoordinator(coordinatorObject);
                    }
                }
            }
        });*/
    }

    init();

    /**
     * resolve the coordinator by the ID stored in coordinatorObject
     * @param coordinatorObject
     */
    function resolveCoordinator(coordinatorObject) {
        coordinatorsEndpoint.get(coordinatorObject, function (data) {
            if (data[0]) {
                for (key in data[0]) {
                    if (data[0][key] == "null") {
                        data[0][key] = "";
                    }
                }
                $scope.coordinator = data[0];
                coordinate.updateSelectedCoordinate($scope.coordinator);
                $scope.getSettlements();
                $scope.getEventCategories();
                $scope.getCoordinatortEvents();
                $scope.getRoles();
            }
            else
                $location.path('/coordinators');
        })
    }

    /**
     * Looking gor changes in the Coordinators object
     */
    $scope.$watchCollection('coordinator', function (newValue, oldValue) {
        if (typeof  $rootScope.editDataHandler === 'function')
            $rootScope.editDataHandler(newValue, oldValue, 'coordinator-profile')
    });

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');

    /**
     * Get All Settlements
     */
    $scope.getSettlements = function() {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
            $scope.selectedSettlements = [];
            $scope.coordinator.Settlements.forEach(function(settlement){
               $scope.selectedSettlements.push($scope.settlements.find(function(set){
                   return set['ID'] == settlement['ID'];
               })) ;
            });
        });
    }

    $scope.getEventCategories = function () {
        $scope.selectedCategories = {
            categories: []
        }
        eventsEndpoint.categories.get({calendar: true,AsArray: true}, function (data) {
            $scope.categories = data;
            $scope.categories.forEach(function(category){
                category.Path.reverse();
            })
            $scope.selectedCategories.categories = $scope.coordinator.Categories.slice();
        })
    }

    $scope.updateSettlements = function () {
        $scope.isClicked = true;
        var params = {};
        $scope.coordinator.Settlements = $scope.selectedSettlements;
        localStorage.setItem("selectedCoordinator", JSON.stringify($scope.coordinator));
        params.SettlementIdes = JSON.stringify($scope.selectedSettlements);
        coordinatorsEndpoint.settlements.update.post($scope.coordinator, params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("שגיאה");
            else
                Notification.success($rootScope.orgTypeBranchName.plural + " עודכנו");

        })
    };

    $scope.updateCategories = function () {
        $scope.isClicked = true;
        var params = {};
        params.CategoryIdes = JSON.stringify($scope.selectedCategories.categories);
        coordinatorsEndpoint.categories.update.post($scope.coordinator, params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("שגיאה");
            else
                Notification.success("קטגוריות עודכנו");

        })
    };

    $scope.updateEvents = function () {
        $scope.isClicked = true;
        var params = {};
        params.EventIdes = JSON.stringify($scope.selectedEvents);
        coordinatorsEndpoint.events.update.post($scope.coordinator, params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.info("שגיאה");
            else
                Notification.success("מאורעות עודכנו");

        })
    };



    $scope.settlementsQuerySearch =  function (query) {
        var results = query ?
            $scope.settlements.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * open new Coordinators dialog
     */
    $scope.openNewCoordinatorDialog = function () {
        coordinatorsEndpoint.post($scope.coordinator, function (data) {
            if (data.ID)
                Notification.success("דואר אלקטרוני נשלח בהצלחה");
        })

    }

    /**
     * Get Roles
     */
    $scope.getRoles = function () {
        var params = {};
        params.withNames = true;
        rolesEndpoint.get(params, function (data) {
            $scope.roles = data;
        })
    }

    $scope.getGlobalMaxNumOfPayments = function () {
        settingsEndpoint.accountancy.maxPayments.get(function(data){
            $scope.globalMaxNumOfPayments = data.max;
        })
    }


    //------------------------------------- Coordinator Events -------------------------------------------------------/
    $scope.getCoordinatortEvents = function(){
        coordinatorsEndpoint.events.get($scope.coordinator.ID,function(data){
            $scope.coordinatorEvents = data;
        })
    }

    $scope.deleteCoordinatorEvents = function(coordinatorEventID){
        coordinatorsEndpoint.events.delete($scope.coordinator.ID,coordinatorEventID,function(data){
            if(data.success == false)
                Notification.error('התרחשה שגיאה');
            $scope.getCoordinatortEvents();
        })
    }

    $scope.createNewCoordinatorEvent = function () {
        $mdDialog.show({
            controller: 'NewCoordinatorEventDialogController',
            templateUrl: 'app/main/pages/admin/coordinators/coordinators-profile/tabs/events/new-coordinator-event-dialog/new-coordinator-event-dialog.html',
            clickOutsideToClose: true,
            locals: {
                coordinatorID: $scope.coordinator.ID
            }
        }).then(function () {
            $scope.getCoordinatortEvents();
        });
    };


}

angular.module('app.pages.events').controller('GroupRefundReceiptsDialog', GroupRefundReceiptsDialog);

function GroupRefundReceiptsDialog($scope, $rootScope, $mdDialog, Receipts, dtOptions, DTOptionsBuilder, eventsEndpoint, MultipleRefunds, RefundModel, Notification) {

    $scope.Receipts = Receipts;
    $scope.displayFilter = 1;
    $scope.filterReceipts = filterReceipts;
    $scope.MultipleRefunds = MultipleRefunds;
    $scope.RefundModel = RefundModel;


    function filterReceipts() {
        $scope.filteredReceipts = Receipts.filter(function (e) {
            if ($scope.displayFilter == 2) {
                $scope.setAll(false);
                return e.ReceiptsCount > 1;
            }
            if ($scope.displayFilter == 1) return e.ReceiptsCount == 1;
            if ($scope.displayFilter == 0) {
                $scope.setAll(false);
                return true;
            }
        });
    }

    $scope.filterReceipts();
    /**
     * Set all params
     * @param selectAll
     */
    $scope.setAll = function (selectAll) {
        $scope.filteredReceipts.forEach(function (receipt) {
            if (receipt.process == undefined)
                receipt.Selected = selectAll;
        })

    };

    $scope.GroupRefundRegistration = function () {
        $scope.refundesFinished = 0;
        $scope.startedRefunds = true;
        var receipts = $scope.filteredReceipts.filter(function (el) {
            return el.Selected
        })
        $scope.currentRefundingCount = receipts.length;
        receipts.forEach(function (receipt) {
            receipt.process = 0;
            eventsEndpoint.groupRefund.post({Receipts: [receipt]}, function (data) {
                if (Array.isArray(data)) {
                    if (data[0]['Success'])
                        receipt.process = 1;
                    else
                        receipt.process = -1;
                    receipt.Selected = false;
                } else
                    receipt.process = -1;
                $scope.refundesFinished++;
            });
        })

    }

    $scope.getRefundsAmount = function () {
        return $scope.Receipts.filter(function (el) {
            return el.Selected
        }).length
    }

    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', false)
        .withOption('paging', false)
        .withDOM('lrtip')

    $scope.closeDialog = function () {
        $mdDialog.hide()
    };
}

angular.module('app.pages.accountancy').controller('ChecksController', ChecksController);

function ChecksController(DTOptionsBuilder, dtOptions, receiptsEndpoint, receiptsService, Notification, DTColumnDefBuilder, $location, recentSearchService) {


    var vm = this;
    vm.checks = [];
    vm.search = {
        Future: null,
        Date: moment().format('DD/MM/YYYY')
    };
    vm.isClicked = false;
    vm.getChecks = getChecks;
    vm.downloadReceipt = downloadReceipt;
    vm.exportChecks = exportChecks;
    vm.loadSearch = loadSearch;

    function loadSearch()
    {
        var search = recentSearchService.get($location.path());
        if(search) {
            vm.search = search;
        }
    }

    vm.loadSearch();

    /**
     * Get All Receipts
     * @param reset
     */
    function getChecks(reset) {
        if (reset)
            vm.search = {
                Future: null,
                Date: moment().format('DD/MM/YYYY')
            };
        recentSearchService.save($location.path(), vm.search);
        vm.isClicked = true;
        vm.receipts = false;
        receiptsEndpoint.checks.get(vm.search, function (data) {
            vm.checks = data;
            vm.isClicked = false;
        })
    }

    /**
     * Download receipt
     * @param receiptID
     */
    function downloadReceipt(receiptID) {
        Notification.info("מייצר קבלה..אנא המתן");
        receiptsService.getReceiptByID(receiptID, 1);
    }

    function exportChecks(){
        vm.isClicked = true;
        var params = {};
        if(vm.search.Future == 3)
            params.Date = vm.search.Date
        receiptsEndpoint.checks.export(params,function (data){
            vm.isClicked = false;
        })
    }


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive', true)
        .withOption('order', [0, 'desc']);

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];


}


angular.module('app.pages.accountancy').controller('ReceiptsController', ReceiptsController);

function ReceiptsController($scope, DTOptionsBuilder,dtOptions,$mdDialog,receiptsEndpoint,receiptsService,Notification,DTColumnDefBuilder, $location, recentSearchService, dailySelectedReceipts) {


    var vm = this;
    vm.receipts = [];
    vm.search = {};
    vm.getReceipts=  getReceipts;
    vm.downloadReceipt= downloadReceipt;
    vm.loadSearch = loadSearch;
    vm.selectedCount = 0;
    vm.toggleCheckBox = toggleCheckBox;
    vm.setAll = setAll;
    vm.canBeSelected = canBeSelected;

    function loadSearch()
    {
        var search = recentSearchService.get($location.path());
        if(search) {
            vm.search = search;
        }
    }

    vm.loadSearch();

    /**
     * Get All Receipts
     * @param reset
     */
    function getReceipts(reset) {
        if (reset)
            vm.search = {};

        recentSearchService.save($location.path(), vm.search);
        vm.isClicked = true;
        vm.receipts = false;
        receiptsEndpoint.get(vm.search, function (data) {
            vm.receipts = data;
            vm.isClicked = false;
        })
    }

    function canBeSelected(receipt)
    {
        return receipt.PaymentStatus != 1 && receipt.PaymentStatus != 5 && receipt.Type == 1;
    }

    /**
     * Download receipt
     * @param receipt
     */
     function downloadReceipt(receipt) {
        Notification.info("מייצר קבלה..אנא המתן");
        if (receipt.EventType==1)
            receiptsService.getReceiptByID(receipt.ID,receipt.Type,false,false,true);
        else
            receiptsService.getReceiptByID(receipt.ID,receipt.Type);
    }

    function toggleCheckBox(receipt) {
        if (receipt.Selected) {
            receipt.Selected = true;
            vm.selectedCount++;
        }
        else {
            receipt.Selected = false;
            vm.selectedCount--;
        }
    }

    function setAll(selectAll) {
        vm.receipts.forEach(function (receipt){
            if(selectAll && canBeSelected(receipt)){
                receipt.Selected = true;
                vm.selectedCount++;
            } else {
                receipt.Selected = false;
                vm.selectedCount--;
            }
        })
    }

    $scope.changePaymentsStatus = function () {

        var confirm = $mdDialog.confirm()
            .title('שינוי סטטוס תשלום')
            .textContent('האם אתה בטוח/ה שברצונך לאשר הזמנות אלו?')
            .ok('אישור')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function() {
            var selectedReceipts = vm.receipts.filter(function (receipt){
                return receipt.Selected && vm.canBeSelected(receipt);
            }).map(function(receipt){
                dailySelectedReceipts.add(receipt);
                return receipt.ID;
            });
            $scope.isClicked = true;
            receiptsEndpoint.setPaid.post({Receipts: selectedReceipts},function (data) {
                $scope.isClicked = false;
                if (data.success) {
                    Notification.success("קבלות עודכנו בצלחה");
                    vm.getReceipts();
                }
                else
                    Notification.error("נכשל בעדכון הקבלות");
            })
        });

    };

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive',true)
        .withOption('order', [0, 'desc']);

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];


}


angular.module('app.pages.accountancy').controller('CashierController', CashierController);

function CashierController($mdDialog, DTOptionsBuilder, dtOptions, receiptsEndpoint, receiptsService, Notification, DTColumnDefBuilder, coordinatorsEndpoint, $location, recentSearchService, dailySelectedReceipts) {


    var vm = this;
    vm.receipts = [];
    vm.search = {
        StartDate: moment().format('DD/MM/YYYY'),
        EndDate: moment().format('DD/MM/YYYY'),
        PaymentStatus: 5
    };
    vm.exportReceiptID = [];
    vm.getReceipts = getReceipts;
    vm.downloadReceipt = downloadReceipt;
    vm.toggleCheckBox = toggleCheckBox;
    vm.setAll = setAll;
    vm.closeCashier = closeCashier;
    vm.exportCashier = exportCashier;
    vm.getBankReferenceFiles = getBankReferenceFiles;
    vm.getTotal = getTotal;
    vm.selectedCount = 0;
    vm.getCoordinators = getCoordinators;
    vm.loadSearch = loadSearch;

    function loadSearch() {
        var search = recentSearchService.get($location.path());
        if (search) {
            vm.search = search;
        }
    }

    function getCoordinators() {
        coordinatorsEndpoint.get({Status: 1}, function (data) {
            vm.coordinators = data;
        })
    }

    /**
     * Get All Receipts
     * @param reset
     */
    function getReceipts(reset) {
        if (reset)
            vm.search = {};
        recentSearchService.save($location.path(), vm.search);
        vm.isClicked = true;
        vm.receipts = false;
        var selectedReceipts = dailySelectedReceipts.get();
        receiptsEndpoint.cashier.get(vm.search, function (data) {
            const cash = [];
            if (data.cash && !Array.isArray(data.cash)) {
                Object.keys(data.cash).forEach(function (key) {
                    cash.push(data.cash[key]);
                });
                data.cash = cash;
            }
            data.cash.forEach(function (dataReceipt) {
                dataReceipt.dailySelected = false;
                if (selectedReceipts.indexOf(dataReceipt.ID) >= 0) {
                    dataReceipt.dailySelected = true;
                    dataReceipt.Selected = true;
                }
            });
            data.cash.sort(function (a, b) {
                if (a.dailySelected && !b.dailySelected)
                    return -1;
                else if (!a.dailySelected && b.dailySelected)
                    return 1;

                return 0;
            });
            vm.receipts = data;
            vm.settings = data.Settings;
            vm.isClicked = false;
        })
    }

    /**
     * Download receipt
     * @param receipt
     */
    function downloadReceipt(receipt) {
        Notification.info("מייצר קבלה..אנא המתן");
        if (receipt.EventType == 1)
            receiptsService.getReceiptByID(receipt.ID, receipt.Type, false, false, true);
        else
            receiptsService.getReceiptByID(receipt.ID, receipt.Type);
    }

    function toggleCheckBox(receipt) {
        if (receipt.Selected) {
            receipt.Selected = true;
            vm.selectedCount++;
        } else {
            receipt.Selected = false;
            vm.selectedCount--;
        }
    }

    function setAll(selectAll, type) {
        vm.receipts[type].forEach(function (receipt) {
            if (selectAll) {
                receipt.Selected = true;
                vm.selectedCount++;
            } else {
                receipt.Selected = false;
                vm.selectedCount--;
            }
        })
    }

    function closeCashier(paymentStatus) {
        if (vm.receipts.length == 0) {
            Notification.error('אין תשלומים לשינויי');
            return;
        }
        //var count = vm.receipts.cash.length + vm.receipts.futureChecks.length + vm.receipts.todayChecks.length;
        var count = 0;
        var countFunc = function (receipt) {
            count += receipt.Selected ? 1 : 0;
        }
        vm.receipts.cash.forEach(countFunc);
        vm.receipts.futureChecks.forEach(countFunc);
        vm.receipts.todayChecks.forEach(countFunc);
        if (count == 0) {
            Notification.error('אין תשלומים לשינויי');
            return;
        }
        var title, content;
        if (paymentStatus == 6) {
            title = 'סימון מזומן והמחאות כיצא להפקדה';
            content = 'האם אתה בטוח/ה שברצונך לסמן ' + count + ' תשלומים כיצאו להפקדה?'
        } else if (paymentStatus == 7) {
            title = 'סימון מזומן והמחאות כהופקד';
            content = 'האם אתה בטוח/ה שברצונך לסמן ' + count + ' תשלומים כהופקד?'
        }
        var confirm = $mdDialog.confirm()
            .title(title)
            .textContent(content)
            .ok('אישור')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function () {
            var receipts = [];
            var includeFunc = function (receipt) {
                if (receipt.Selected)
                    receipts.push(receipt);
            }
            vm.receipts.cash.forEach(includeFunc);
            vm.receipts.futureChecks.forEach(includeFunc);
            vm.receipts.todayChecks.forEach(includeFunc);
            receiptsEndpoint.cashier.close({Receipts: receipts, PaymentStatus: paymentStatus}, function (data) {
                if (data.success) {
                    Notification.success('כל התשלומים הופקדו בהצלחה');
                } else {
                    Notification.error('התרחשה שגיאה');
                }
                vm.getReceipts();
            });
        });
    }

    function exportCashier() {
        vm.isClicked = true;
        receiptsEndpoint.cashier.export(vm.search, function (data) {
            vm.isClicked = false;
        })
    }

    function getBankReferenceFiles() {
        var receipts = [];
        var addFunc = function (receipt) {
            if (receipt.Selected)
                receipts.push(receipt.ID);
        }
        vm.receipts.cash.forEach(addFunc);
        vm.receipts.todayChecks.forEach(addFunc);
        vm.receipts.futureChecks.forEach(addFunc);
        $mdDialog.show({
            controller: 'CreateBankReferenceFilesDialogContrtoller',
            templateUrl: 'app/main/pages/accountancy/views/cashier/create-bank-reference-files-dalog/create-bank-reference-files-dialog.html',
            clickOutsideToClose: false,
            locals: {
                receipts: receipts
            }
        }).then(function () {
            vm.getReceipts();
        });
        /*vm.isClicked = true;
        pdfFilesService.getBankReference(vm.search,function (data){
            vm.isClicked = false;
        })*/
    }

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder.newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive', true)
        .withOption('order', [0,])
        .withOption('lengthMenu', [[10000000], ["הכל"]])
        .withDisplayLength(10000000);

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];

    function getTotal(items) {

        var sum = 0;
        var hasSelected = Array.isArray(items) && items.find(function (item) {
            return item.Selected;
        });
        if (hasSelected) {
            Array.isArray(items) && items.filter(function (item) {
                return item.Selected;
            }).forEach(function (item) {
                if (+item['PaymentType'] === 4 && item['ChecksData'])
                    sum += +item['ChecksData']['CheckAmount'];
                else
                    sum += item.Amount;
            })
        } else {
            Array.isArray(items) && items.forEach(function (item) {
                if (+item['PaymentType'] === 4 && item['ChecksData'])
                    sum += +item['ChecksData']['CheckAmount'];
                else
                    sum += item.Amount;
            })
        }

        return sum;
    }


}


angular.module('app.pages.users').controller('ManageSettlementsController', ManageSettlementsController);
function ManageSettlementsController($scope,$rootScope,$mdSidenav,$mdDialog,DTOptionsBuilder,dtOptions,settlement,settlementsEndpoint, recentSearchService, $location) {


    $scope.settlements = [];

    loadSearch();

    function loadSearch()
    {
        var search = recentSearchService.get($location.path());
        if(search) {
            $scope.search = search;
        }
    }

    /**
     * Get All Settlements
     */
    $scope.getSettlements = function (reset) {
        if (reset) {
            $scope.search = {};
            recentSearchService.save($location.path(), {});
            return;
        }
        recentSearchService.save($location.path(), $scope.search);
        $scope.settlements = false;
        settlementsEndpoint.get($scope.search, function (data) {
            $scope.settlements = data;
        })
    };

    /**
     * Open side nev to update branch
     * @param selectedSettlement
     */
    $scope.editSettlement = function (selectedSettlement) {
        settlement.updateSelectedSettlement(selectedSettlement);
        $mdSidenav("manage-settlements-panel").open();
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');


}

angular.module('app.pages.users').controller('ManageGradesController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','usersEndpoint', 'msUtils', '$timeout','$document', 'DTOptionsBuilder','dtOptions','gradesEndpoint','grade', 'recentSearchService'
    ,function($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,gradesEndpoint,grade, recentSearchService) {

        $scope.search = {};
        $scope.grades= [];

        loadSearch();

        function loadSearch()
        {
            var search = recentSearchService.get($location.path());
            if(search) {
                $scope.search = search;
            }
        }

        /**
         * Set Table option
         * @type {any}
         */
        $scope.dtOptions = DTOptionsBuilder
            .newOptions()
            .withLanguage(dtOptions.language)
            .withOption('responsive',true)
            .withDOM('lfrtp')
            .withOption('bFilter', false)
            .withDOM('lrtip');


        /**
         * Get All Grades
         */
        $scope.getGrades = function () {
            $scope.grades= false;
            $scope.isClicked = true;
            recentSearchService.save($location.path(), $scope.search);
            gradesEndpoint.get($scope.search,function (data) {
                $scope.isClicked = false;
                $scope.grades = data;
            });
        };

        /**
         * Open side nev to update Grade
         * @param selectedGrade
         */
        $scope.editGrade = function (selectedGrade) {
            grade.updateSelectedGrade(selectedGrade);
            $mdSidenav("grades-panel").open();
        };

        /**
         * Add new Grade dialog
         */
        $scope.addNewGradesDialog = function () {
            $mdDialog.show({
                controller         : 'NewGradesDialogController',
                templateUrl        : 'app/main/pages/branches/views/grades/new-grades-dialog/new-grades-dialog.html',
                clickOutsideToClose: false
            }).then(function () {
                $scope.getGrades();
            });
        };


    }]);




angular.module('app.pages.accountancy').controller('receiptTransactionsController', receiptTransactionsController);

function receiptTransactionsController($mdDialog, DTOptionsBuilder, dtOptions, paymentsEndpoint, reportsEndpoint, receiptsService, Notification, settingsEndpoint, DTColumnDefBuilder, eventsEndpoint, $location, recentSearchService) {


    var vm = this;
    vm.transactions = [];
    vm.search = {
        startDate: moment().format('DD/MM/YYYY'),
        endDate: moment().format('DD/MM/YYYY')
    };
    vm.getTransactions = getTransactions;
    vm.downloadReceipt = downloadReceipt;
    vm.exportTransactions = exportTransactions;
    vm.statuses = receiptsService.getCreditCardStatusesCodes();
    vm.getEventCategories = getEventCategories;
    vm.getAccountancySettings = getAccountancySettings;
    vm.getCostingCodes = getCostingCodes;
    vm.terminalManagement = 0;
    vm.init = init;
    vm.costingCodes = [];
    vm.loadSearch = loadSearch;

    function loadSearch() {
        var search = recentSearchService.get($location.path());
        if (search) {
            vm.search = search;
        }
    }

    function init() {
        vm.loadSearch();
        vm.getCostingCodes();
        vm.getAccountancySettings();
    }

    function getCostingCodes() {
        reportsEndpoint.epr.info({}, function (data) {
            vm.costingCodes = data.Codes;
        });
    };

    /**
     * Get All Receipts
     * @param reset
     */
    function getTransactions(reset) {
        if (reset) {
            vm.search = {
                startDate: moment().format('DD/MM/YYYY'),
                endDate: moment().format('DD/MM/YYYY')

            };
            vm.searchTerm = '';
        } else {

            recentSearchService.save($location.path(), vm.search);
            vm.isClicked = true;
            vm.transactions = false;
            paymentsEndpoint.receiptTransactions.get(vm.search, function (data) {
                vm.transactions = data;
                vm.isClicked = false;
            })
        }
    }

    function getAccountancySettings() {
        settingsEndpoint.accountancy.get(function (data) {
            vm.terminalManagement = data.TerminalManagment;
            vm.getEventCategories();
        });
    }

    function exportTransactions() {
        vm.isClicked = true;
        paymentsEndpoint.receiptTransactions.export(vm.search, function (data) {
            vm.isClicked = false;
        })
    }

    /**
     * Download receipt
     * @param receipt
     */
    function downloadReceipt(receipt) {
        Notification.info("מייצר קבלה..אנא המתן");
        if (receipt.EventType == 1)
            receiptsService.getReceiptByID(receipt.ID, receipt.Type, false, false, true);
        else
            receiptsService.getReceiptByID(receipt.ID, receipt.Type);
    }

    function getEventCategories() {
        var params = {calendar: true, EventsCount: true, AsArray: true};
        if (vm.terminalManagement) params['onlyParents'] = true;
        eventsEndpoint.categories.get(params, function (data) {
            vm.categories = data.filter(function (category) {
                return category.EventsCount > 0;
            });
            if (vm.terminalManagement) {
                vm.categories.forEach(function (category) {
                    category.Path.reverse();
                })
            }
        })
    }

    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder.newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive', true)
        .withOption('order', [0,])
        .withOption('lengthMenu', [[10000000], ["הכל"]])
        .withDisplayLength(10000000);

    vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0).withOption('type', 'eu-date'),

    ];
}


angular.module('app.pages.accountancy').controller('ExportMovementsController', ExportMovementsController)

function ExportMovementsController(reportsEndpoint, eventsEndpoint, settingsEndpoint) {

    var vm = this;
    vm.search = {
        From: moment().startOf('month').format('DD/MM/YYYY'),
        To: moment().format('DD/MM/YYYY')
    };
    vm.createReport = createReport;
    vm.getEPRInfo = getEPRInfo;
    vm.init = init;
    vm.getTerminals = getTerminals;
    vm.getAccountancySettings = getAccountancySettings;
    vm.showTerminals = showTerminals;
    vm.terminals = [];
    vm.terminalManagement = 0;


    function showTerminals() {
        if (+vm.search.Type == 2) return false;
        if (+vm.search.Type == 3) return true;
        if (+vm.search.Type == 1) {
            var arr1 = [
                "לאומיקארד",
                "אמריקן אקפרס",
                "דיינרס",
                "ויזה כ.א.ל",
                "ישראכראט"
            ];
            if (!Array.isArray(vm.search.Payments)) return false;
            const isFounded = arr1.some(function (ai) {
                return vm.search.Payments.includes(ai)
            });

            return isFounded;


        }

    }

    function getTerminals() {
        eventsEndpoint.categories.getTerminals(function (data) {
            vm.terminals = data;
            vm.getAccountancySettings();
        })
    }

    function getAccountancySettings() {
        settingsEndpoint.accountancy.get(function (data) {

            vm.terminalManagement = data.TerminalManagment;
            // setInterval(function () {
            //     console.log(vm.search.Payments);
            // }, 2000);
        });
    }

    function init() {
        //vm.getEPRInfo();
        vm.getTerminals();
    }

    /**
     * Create Report
     */
    function createReport() {
        vm.load = true;
        var params = angular.copy(vm.search);
        params.Fields = JSON.stringify(params.Fields);
        reportsEndpoint.movements.get(params, function () {
            vm.load = false;
        })
    }

    function getEPRInfo(e) {
        vm.load = true;
        var params = {};
        var fromTime = vm.search.From.split('/');
        if (vm.search.Type == 4) {
            if (fromTime && fromTime.length == 3) {
                vm.search.From = fromTime[1] + '/' + fromTime[2];
            }
        } else {
            if (fromTime && fromTime.length == 2) {
                vm.search.From = '1/' + vm.search.From;
            }
        }
        if (vm.search.Type == 2)
            params.Cash = true;
        if (vm.search.Type == 3)
            params.CreditCardOnly = true;
        reportsEndpoint.epr.info(params, function (data) {
            vm.load = false;
            vm.payments = data.Payments;
            vm.codes = data.Codes;
        })
    }


}

angular.module('app.pages.accountancy').controller('PaymentsMatchController', PaymentsMatchController);

function PaymentsMatchController(DTOptionsBuilder, dtOptions, paymentsEndpoint, Notification, receiptsEndpoint, eventsEndpoint, settingsEndpoint, $mdDialog) {

    var vm = this;
    vm.search = {
        StartDate: moment().format('DD/MM/YYYY'),
        EndDate: moment().format('DD/MM/YYYY')
    };
    vm.payments = [];
    vm.getPayments = getPayments;
    vm.createPayment = createPayment;
    vm.updateMatchDate = updateMatchDate;
    vm.openPaymentMatchDialog = openPaymentMatchDialog;
    vm.getPaymentsByMonth = getPaymentsByMonth;
    vm.getEventCategories = getEventCategories;
    vm.getAccountancySettings = getAccountancySettings;
    vm.init = init;
    vm.terminalManagement = 0;


    function init() {
        vm.getAccountancySettings();
    }

    function getAccountancySettings() {
        settingsEndpoint.accountancy.get(function (data) {
            vm.terminalManagement = data.TerminalManagment;

            if (vm.terminalManagement) vm.getEventCategories();
        });
    }


    /**
     * Get Payments
     */
    function getPayments() {
        vm.payments = false;
        paymentsEndpoint.match.get(vm.search, function (data) {
            vm.payments = data;
        })
    }

    /**
     * Create Payment
     * @param payment
     */
    function createPayment(payment) {
        /*if (!payment.MatchDate || payment.ReceiptID){
            Notification.error("חובה להזין תאריך להתאמה");
            return;
        }*/
        paymentsEndpoint.fix.post(payment, function (data) {
            if (data.success) {
                Notification.success("חשבונית נוצרה בהצלחה");
                payment.Disable = true;
                payment.ReceiptMatch = true;
            } else
                Notification.error("נכשל ביצירת חשבונית");

        })
    }

    /**
     * Update Match Date
     */
    function updateMatchDate(payment) {
        if (!payment.ReceiptMatch || !payment.TransactionMatch)
            return;
        var params = {};
        if (payment.Type == 1)
            params['ReceiptID'] = payment.ReceiptID;
        else
            params['ReceiptID'] = payment.ID;
        params['MatchDate'] = payment.MatchDate;
        params['PaymentType'] = payment.Type;
        receiptsEndpoint.matchDate.update.post(params, function (data) {
            if (data.success)
                Notification.success("קבלה עודכנה בהצלחה");
            else
                Notification.error("נכשל בעדכון קבלה");
        })

    }

    function openPaymentMatchDialog(payment) {
        $mdDialog.show({
            controller: 'PaymentMatchController as vm',
            templateUrl: 'app/main/pages/accountancy/views/payments-match/payment-match-dialog/payment-match-dialog.html',
            clickOutsideToClose: false,
            locals: {
                dealID: payment.Type == 1 ? payment.DealID : payment.RegistrationID
            }
        });
    }

    /**
     * Get Payments Month
     */
    function getPaymentsByMonth() {
        vm.paymentsByMonth = false;
        paymentsEndpoint.match.month.get(function (data) {
            vm.paymentsByMonth = data;
        })
    }

    function getEventCategories() {
        eventsEndpoint.categories.get({
            calendar: true,
            EventsCount: true,
            AsArray: true,
            onlyParents: true
        }, function (data) {
            vm.categories = data.filter(function (category) {
                return category.EventsCount > 0;
            });
        })
    }


    /**
     * Set Table option
     * @type {any}
     */
    vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', true)
        .withDOM('lrtip')
        .withOption('order', [0, 'desc']);

}

(function ()
{
    'use strict';

    angular
        .module('app.pages.manage-admins', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.pages_manage-admins', {
            url    : '/manage-admins',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin/admin-management/manage-admins.html',
                    controller: 'ManageAdminsController'
                }
            }, resolve  : {
                "check": function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/manage-admins');

                }
            }
        }) .state('app.pages_users_coordinators', {
            url      : '/coordinators',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin/coordinators/coordinators.html',
                    controller : 'CoordinatorsController'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/coordinators');
                }
            },
            bodyClass: 'educators'

        });

    }

})();

angular.module('app.pages.manage-admins').controller('NewAdminDialogController', NewAdminDialogController);
function NewAdminDialogController ($scope, $mdDialog,adminEndpoint,Notification) {

    /**
     * Save new admin
     */
    $scope.saveNewAdmin = function () {
        $scope.isClicked = true;
        adminEndpoint.post($scope.newAdmin, function (data) {
            if (data.ID) {
                Notification.success("הזמנה נשלחה בהצלחה");
                $mdDialog.hide();
            }

            else
                Notification.error("דואר אלקטרוני קיים במערכת");

        })
    };

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

(function ()
{
    'use strict';

    angular
        .module('app.admin-profile-panel',[])

})();

angular.module('app.admin-profile-panel').controller('AdminProfilePanelController',AdminProfilePanelController);
function AdminProfilePanelController($scope,$rootScope,adminProfile) {
    /**
     * Set the admin
     */
    $scope.$on('adminProfile:updated', function () {
        $scope.adminProfile = adminProfile.admin;
    });

    /**
     * Look For changes in the Admin object
     */
    $scope.$watch('adminProfile', function (newValue, oldValue) {
        $rootScope.editDataHandler(newValue, oldValue, 'admin-profile-panel')
    }, true);

}
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_blank', {
            url  : '/ui/page-layouts/blank',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/blank/blank.html',
                    controller : 'BlankController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank')
        .controller('BlankController', BlankController);

    /** @ngInject */
    function BlankController()
    {
        // Data

        // Methods

        //////////
    }

})();
angular.module('app.pages.users').controller('EmailDialogController', ['$scope', '$rootScope', '$mdDialog', 'emailEndpoint', 'student', '$location',
    'Notification', 'students', '$timeout', '$interval', 'external', 'type', 'appConfig', 'Upload',
    function ($scope, $rootScope, $mdDialog, emailEndpoint, student, $location, Notification, students, $timeout, $interval, external, type, appConfig, Upload) {

        $scope.type = type;
        $scope.students = students;
        var selectedStudents = $scope.students.filter(function (student) {
            return student.Selected;
        });
        $scope.students = selectedStudents;
        $scope.sendsEmailes = 0;
        $scope.email = {};
        $scope.externalEmail = external;

        if ($scope.type == 1) {
            $scope.typeText = "חניכים";
        } else if ($scope.type == 2) {
            $scope.typeText = $rootScope.User.Coordinators;
        } else {
            $scope.typeText = 'הורים';
            $scope.email.parentsOnly = 1;
        }



        $scope.sendEmail = function () {
            $scope.email.Students = $scope.students.map(function (student) {
                return {ID: student.ID, StudentID: student.StudentID, Email: student['Email']};
            });
            if ($scope.externalEmail)
                $scope.email.Type = 1;
            $scope.isClicked = true;


            var tmpText = $rootScope.quillEditor.emailMsg.root.innerHTML;
            var div = document.createElement("div");
            div.innerHTML = tmpText;
            var imgs = div.getElementsByTagName("img");
            var imagesToUpload = [];
            for (var i = 0; i < imgs.length; i++) {
                imagesToUpload.push(imgs[i].src);
            }
            for (var i = 0; i < imgs.length; i++) {
                var el = document.createElement("img");
                el.setAttribute('id', 'img' + i);
                el.setAttribute('class', 'quillUploadedImages');
                imgs[i].parentNode.replaceChild(el, imgs[i]);
            }

            $scope.uploadFile(imagesToUpload, div);


        };

        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

        $scope.dataURLtoFile = function (dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[arr.length - 1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type: mime});
        }

        $scope.uploadFile = function (base64Arr, theDiv) {
            if (!base64Arr)
                return true;
            var files = [];
            base64Arr.forEach(function (base64, index) {
                var fileName = ('img' + index) + '.' + base64.substring(base64.indexOf('/') + 1, base64.indexOf(';base64'));
                files.push($scope.dataURLtoFile(base64, fileName));
            });

            var uploadURL = '';
            if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
                uploadURL = appConfig.localHostUrl + '/upload/files?brand=' + $rootScope.brandName;
            else if (location.host === appConfig.locationHost)
                uploadURL = appConfig.developmentHostUrl + '/upload/files?brand=' + $rootScope.brandName;
            else
                uploadURL = appConfig.serverUrl + '/upload/files?brand=' + $rootScope.brandName;

            var promisses = [];
            for (var i = 0; i < files.length; i++) {
                promisses.push(Upload.upload({
                    url: uploadURL + "&XDEBUG_SESSION_START",
                    data: {files: files[i]},
                    headers: {
                        Authorization: 'Bearer ' + $rootScope.User.AccessToken
                    }
                }));
            }
            Promise.all(promisses).then(function (values) {
                console.log(values);
                var imageElements = theDiv.getElementsByClassName('quillUploadedImages');

                for (var i = 0; i < imageElements.length; i++) {
                    imageElements[i].setAttribute('aria-label', values[i].data['Path']);
                    // imageElements[i].innerText = values[i].data['Path'];
                }
                $scope.email.Text = theDiv.innerHTML;


                var totalStudents = $scope.email.Students.length;
                var studentsPerChunk = 50; // Number of students per chunk
                var chunks = [];
                for (var i = 0; i < totalStudents; i += studentsPerChunk) {
                    chunks.push($scope.email.Students.slice(i, i + studentsPerChunk));
                }
                var cnt = chunks.length;
                var emailClone = angular.copy($scope.email);
                chunks.forEach(function (chunk) {

                    emailClone.Students = chunk;
                    emailEndpoint.post(emailClone, function (data) {
                        cnt--;
                        if (!data.success)
                            // Notification.success("הודעה נשלחה בהצלחה");
                        // else
                            Notification.error("נכשל בשליחת הודעה");
                        if (cnt <= 0) {
                            $scope.isClicked = false;
                            $mdDialog.hide();
                        }
                    })

                });


            });
            // }).then(function (resp) {
            //     console.log(resp);
            //
            //     debugger
            // }, function (resp) {
            //     console.log('Error status: ' + resp.status);
            // }, function (evt) {
            //     var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            //     console.log('progress: ' + progressPercentage);
            // });

        };
    }]);

angular.module('app.pages.users').controller('SMSDialogController', ['$scope', '$rootScope', '$mdDialog', 'smsEndpoint', 'student', '$location', 'Notification', 'students', 'external', 'type',
    function ($scope, $rootScope, $mdDialog, smsEndpoint, student, $location, Notification, students, external, type) {

        $scope.students = students;
        $scope.type = type;
        $scope.sms = {};
        $scope.sms.Students = [];
        $scope.externalSMS = external;

        $scope.type = type;
        if ($scope.type == 1) {
            $scope.typeText = 'חניכים';
        } else if ($scope.type == 2) {
            $scope.typeText = $rootScope.User.Coordinators;
        } else {
            $scope.typeText = 'הורים';
            $scope.sms.parentsOnly = 1;
        }

        $scope.sms.Students = $scope.students.filter(function (student) {
            return student.Selected;
        }).map(function (student) {
            return {
                ID: student.ID,
                StudentID: student.StudentID,
                ParentID: student.ParentID,
                PhoneNumber: student.PhoneNumber,
                MobileNumber: student.MobileNumber
            }
        });


        /**
         * Send SMS to students\parents
         */
        $scope.sendSMS = function () {
            if ($scope.externalSMS)
                $scope.sms.Type = 1;
            $scope.isClicked = true;
            Notification.info("שולח הודעות..");
            var totalStudents = $scope.sms.Students.length;
            var studentsPerChunk = 50; // Number of students per chunk
            var chunks = [];
            for (var i = 0; i < totalStudents; i += studentsPerChunk) {
                chunks.push($scope.sms.Students.slice(i, i + studentsPerChunk));
            }

            var smsClone = angular.copy($scope.sms);
            var cnt = chunks.length;
            chunks.forEach(function (chunk) {
                smsClone.Students = chunk;
                smsEndpoint.post(smsClone, function (data) {
                    cnt--;
                    if (!data.success)
                        Notification.error("נכשל בשליחת הודעה");
                    if (cnt <= 0) {
                        $scope.isClicked = false;
                        $mdDialog.hide();
                    }
                });
            });
            // smsEndpoint.post($scope.sms,function (data) {
            //     $scope.isClicked= false;
            //     if (data.success)
            //         Notification.success("הודעה נשלחה בהצלחה");
            //     else
            //         Notification.error("נכשל בשליחת הודעה");
            //
            //     $mdDialog.hide();
            // })

        };

        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

    }]);

(function () {
    'use strict';

    var app = angular.module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'ui-notification',
                'chart.js',
                'vsGoogleAutocomplete',
                'moment-picker',
                'materialCalendar',
                'angular-timeline',
                'ngProgress',
                'ngQuill'
            ]);
    app.constant('NG_QUILL_CONFIG', {
        /*
         * @NOTE: this config/output is not localizable.
         */
        modules: {
            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                ['blockquote', 'code-block'],

                [{'header': 1}, {'header': 2}],               // custom button values
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'script': 'sub'}, {'script': 'super'}],     // superscript/subscript
                [{'indent': '-1'}, {'indent': '+1'}],         // outdent/indent
                [{'direction': 'rtl'}],                         // text direction

                [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
                [{'header': [1, 2, 3, 4, 5, 6, false]}],

                [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                [{'font': []}],
                [{'align': []}],

                ['clean'],                                         // remove formatting button

                ['link', 'image', 'video']                         // link and image, video
            ]
        },
        theme: 'snow',
        debug: 'warn',
        formats: {
            align: 'right'
        },
        placeholder: 'החל רשום כאן...',
        readOnly: false,
        bounds: document.body,
        scrollContainer: null
    })

    app.config([
        'ngQuillConfigProvider',
        'NG_QUILL_CONFIG',

        function (ngQuillConfigProvider, NG_QUILL_CONFIG) {
            ngQuillConfigProvider.set(NG_QUILL_CONFIG)
        }
    ])
})();

angular.module('app.core').factory('usersEndpoint', ['API', function (API) {

    return {
        tags: {
            get: function (params, handler) {
                API.sendRequest("/users/" + params.UserID + "/tags", 'GET', params, handler, true);
            },
            post: function (tag, handler) {
                API.sendRequest("/users/" + tag.UserID + "/tags", 'POST', tag, handler, true);
            },
            update: {
                post: function (tag, handler) {
                    API.sendRequest("/users/" + tag.userID + "/tags/" + tag.ID + "/update", 'POST', tag, handler, true);
                }
            }

        }

    }

}]);

angular.module('app.core').factory('tranzilaEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/tranzila/iframe", 'POST', params, handler, true);
        },
        getJ5: function (params,handler) {
            API.sendRequest("/tranzila/j5iframe", 'POST', params, handler, true);
        },
        monthlyPayment:{
            post:  function (params,handler) {
                API.sendRequest("/tranzila/monthlyPayment", 'POST', params, handler, true);
            },
        },
        valid : {
            post: function (params,handler) {
                API.sendRequest("/tranzila/valid", 'POST', params, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('transportationEndpoint', ['API', function (API) {

    return {
        get: function (handler) {
            API.sendRequest("/transportation", 'GET', null, handler, true);
        },
        post: function (transportation, handler) {
            API.sendRequest("/transportation", 'POST', transportation, handler, true);
        },
        update: {
            post: function (transportation, handler) {
                API.sendRequest("/transportation/" + transportation.ID + "/update", 'POST', transportation, handler, true);
            }
        },
        delete: {
            post: function (transportation, handler) {
                API.sendRequest("/transportation/" + transportation.ID + "/delete", 'POST', null, handler, true);
            }
        },
        stops: {
            update: function (transportation, handler) {
                    API.sendRequest("/transportation/" + transportation.ID + "/stops/update", 'POST', transportation, handler, true);
                }

        }
    }
}]);

angular.module('app.core').factory('tokenEndpoint', ['API', function (API) {

    return {
        special: {
            post: function (params,handler) {
                API.sendRequest("/token/addData", 'POST', params, handler, true);
            },
        }


    }
}]);

angular.module('app.core').factory('tagsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/tags", 'GET', params, handler, true);
        },
        update: {
            post: function (tag,handler) {
                API.sendRequest("/tags/" + tag.ID + "/update", 'POST', tag, handler, true);
            },
        },
        create: {
            post: function (tag,handler) {
                API.sendRequest("/tags", 'POST', tag, handler, true);
            },
        }


    }
}]);

angular.module('app.core').factory('systemSettingsEndpoint', ['API', function (API) {

    return {
        names: {
            post: function (params, handler) {
                API.sendRequest("/system-settings/names", 'POST', params, handler, true);
            },
            get: function (handler, id) {
                API.sendRequest('/system-settings/names' + (id ? ('/' + id) : ''), 'GET', null, handler, true);
            }
        },
        birthday: {
            post: function (params, handler) {
                API.sendRequest("/system-settings/birthday", 'POST', params, handler, true);
            },
            get: function (handler) {
                API.sendRequest("/system-settings/birthday", 'GET', null, handler, true);
            }
        },
        terms: {
            get: function (handler) {
                API.sendRequest("/system-settings/terms", 'GET', null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/system-settings/terms", 'POST', params, handler, true);
            }
        },
        ProfilePopUpAlert: {
            get: function (handler) {
                API.sendRequest("/system-settings/profilePopUpAlert", 'GET', null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/system-settings/profilePopUpAlert", 'POST', params, handler, true);
            }
        },
        studentFields: {
            all: {
                get: function (params, handler) {
                    API.sendRequest("/system-settings/fetchAllStudentFields", "GET", null, handler, true);
                },
                post: function (params, handler) {
                    API.sendRequest("/system-settings/updateStudentFields", 'POST', params, handler, true);
                }
            },
        },
        studentExtraFields: {
            get: function (params, handler) {
                API.sendRequest("/system-settings/fetchAllExtraStudentFields", "GET", null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/system-settings/addStudentExtraFields", "POST", params, handler, true);
            },
            update: function (params, handler) {
                API.sendRequest("/system-settings/updateStudentExtraFields", "POST", params, handler, true);
            },
        }
    }
}]);

angular.module('app.core').factory('studentsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/students",'GET', params, handler, true);
        },
        post : function (student,handler) {
            API.sendRequest("/students",'POST', student, handler, true);
        },
        registrations : {
            get: function (studentID,handler) {
                API.sendRequest("/students/"+studentID+"/registrations",'GET', null, handler, true);
            },
            fullRegistration : {
                get: function (memberID,registration,handler) {
                    API.sendRequest("/students/"+memberID+"/registrations/"+registration.ID,'GET', null, handler, true);
                },
            },
            addExtraCharge: {
                post:  function (memberID,registration,handler) {
                    API.sendRequest("/students/"+memberID+"/registrations/"+registration.ID+"/extra-charge",'POST', null, handler, true);
                },
            },
            update :{
                post: function (registration,handler) {
                    API.sendRequest("/students/"+registration.StudentID+"/registrations/"+registration.ID+"/update",'POST', registration, handler, true);
                },
            },
            confirm : {
                post: function (registration,handler) {
                    API.sendRequest("/students/"+registration.StudentID+"/registrations/"+registration.ID+"/confirm",'POST', registration, handler, true);
                }
            },
            logs: {
                get: function (registration,handler) {
                    API.sendRequest("/students/"+registration.StudentID+"/registrations/"+registration.ID+"/logs",'GET', null, handler, true);
                }
            },
            questions :{
                update :{
                    post: function (registration,questions,handler) {
                        API.sendRequest("/students/"+registration.StudentID+"/registrations/"+registration.ID+"/questions/update",'POST', questions, handler, true);
                    }
                }
            },
            transportation :{
                update :{
                    post: function (registration,transportation,handler) {
                        API.sendRequest("/students/"+registration.StudentID+"/registrations/"+registration.ID+"/transportation/update",'POST', transportation, handler, true);
                    }
                }
            },
            refunds: {
                get: function (registration,handler) {
                    API.sendRequest("/students/"+registration.StudentID+"/registrations/"+registration.ID+"/refunds/total",'GET',null, handler, true);
                }
            },
            isRegistered: function(studentID,eventID,handler){
                API.sendRequest("/students/"+studentID+"/checkRegistrations/"+eventID,'GET', null, handler, true);
            },
            payments: {
                post: function (payment,handler) {
                    API.sendRequest("/students/"+payment.StudentID+"/registrations/"+payment.RegistrationID+"/payment",'POST', payment, handler, true);
                }
            },
            monthlyChargeTransaction:{
                delete:function (payment,handler) {
                    API.sendRequest("/students/"+payment.StudentID+"/registrations/"+payment.RegistrationID+"/monthlyChargeTransaction/"+payment.ID+"/delete",'POST', payment, handler, true);
                }
            }
        },
        update : {
            post: function (student,handler) {
                API.sendRequest("/students/"+student.ID+"/update",'POST', student, handler, true);
            }
        },
        family : {
            get: function (studentID,handler) {
                API.sendRequest("/students/"+studentID+"/family",'GET', null, handler, true);
            }
        },
        parent : {
            post: function (student,parent,handler) {
                API.sendRequest("/students/"+student.ID+"/parent",'POST', parent, handler, true);
            },
            delete : {
                post: function (studentID,parentID,handler) {
                    API.sendRequest("/students/"+studentID+"/parent/"+parentID+"/delete",'POST', null, handler, true);
                }
            },
            get: function (studentID,handler) {
                API.sendRequest("/students/"+studentID+"/parents",'GET', null, handler, true);
            }
        },
        groups : {
            get: function (student,params,handler) {
                API.sendRequest("/students/"+student.ID +"/groups/"+student.BranchID, 'GET', params, handler, true);
            },
            upgrade : {
                post: function (params,handler) {
                    API.sendRequest("/students/groups/upgrade", 'POST',params, handler, true);
                }
            }
        },
        scheduling : {
            post: function (student,params,handler) {
                    API.sendRequest("/students/"+student.ID +"/scheduling", 'POST',params, handler, true);
            }
        },
        educator : {
            post: function (student,educator,handler) {
                API.sendRequest("/students/"+student.ID +"/educator", 'POST',educator, handler, true);
            }
        },
        studentPrivateID : {
            get: function (student,handler) {
                API.sendRequest("/students/"+student.PrivateID, 'GET', null, handler, true);
            }
        },
        events: {
            get: function (params, handler) {
                API.sendRequest("/students/"+params.ID+"/events/active", 'GET', null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/students/"+params.StudentID+"/events", 'POST', params, handler, true);
            },
            multiple: {
                post :function (params, handler) {
                    API.sendRequest("/students/events/multiple", 'POST', params, handler, true);
                },
            },
            refund : {
                post: function (params, handler) {
                    API.sendRequest("/students/"+params.StudentID+"/events/refund", 'POST', params, handler, true);
                },
            },
            cancel : {
                post: function (params, handler) {
                    API.sendRequest("/students/"+params.StudentID+"/events/cancel", 'POST', params, handler, true);
                }
            }
        },
        contact :{
            get: function (studentID, handler) {
                API.sendRequest("/students/"+studentID+"/contact", 'GET', null, handler, true);
            }
        },
        sms : {
            post: function (params, handler) {
                API.sendRequest("/students/sms", 'POST', params, handler, true);
            }
        },
        email : {
            post: function (params, handler) {
                API.sendRequest("/students/email", 'POST', params, handler, true);
            }
        },
        grades : {
            upgrade : {
                post: function (params, handler) {
                    API.sendRequest("/students/grades/upgrade", 'POST', params, handler, true);
                }
            }
        },
        cancellation : {
            get: function (studentID, handler) {
                API.sendRequest("/students/"+studentID+"/cancellation", 'GET', null, handler, true);
            }
        },
        studentExtraFieldsValues: {
            get: function(studentID, handler) {
                API.sendRequest("/students/" + studentID + "/field-values","GET",null,handler,true);
            },
            update: function(params, handler) {
                API.sendRequest("/students/" + params.studentID + "/update-field-values","POST",{fields: params.fields},handler,true);
            },
        },
        export : {
            get: function (params,handler) {
                API.sendRequest("/students/export",'GET', params, handler, true,true);
            }
        },
    }
}]);


angular.module('app.core').factory('statisticsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/statistics", 'GET', params, handler, true);
        }
    }
}]);

angular.module('app.core').factory('smsEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/sms", 'POST', params, handler, true);
        }
    }
}]);

angular.module('app.core').factory('settlementsEndpoint', ['API', function (API) {

    var cachedSettlements;

    return {
        get: function (params,handler) {
            if(params && Object.keys(params).length == 0){
                if(cachedSettlements)
                    handler(cachedSettlements);
                else{
                    API.sendRequest("/settlements", 'GET', params, function(data){
                        cachedSettlements = data;
                        handler(data);
                    }, true);
                }
            } else
                API.sendRequest("/settlements", 'GET', params, handler, true);
        },
        update : {
            post: function (settlement,handler) {
                API.sendRequest("/settlements/"+settlement.ID +"/update", 'POST', settlement, handler, true);
            }
        },
    }
}]);

angular.module('app.core').factory('settingsEndpoint', ['API', function (API) {

    return {
        post: function (params, handler) {
            API.sendRequest("/settings", 'POST', params, handler, true);
        },
        updates: {
            get: function (handler) {
                API.sendRequest("/settings/updates", 'GET', null, handler, true);
            }
        },
        forms: {
            emails: {
                get: function (handler) {
                    API.sendRequest("/settings/forms/emails", 'GET', null, handler, true);
                }
            }
        },
        accountancy: {
            get: function (handler) {
                API.sendRequest("/settings/accountancy", 'GET', null, handler, true);
            },
            getByTerminal: function (params, handler) {
                API.sendRequest("/settings/terminal/accountancy/" + params.ID, 'GET', null, handler, true);
            },
            post: function (data, handler) {
                API.sendRequest("/settings/accountancy", 'POST', data, handler, true);
            },
            banks: {
                get: function (params, handler) {
                    API.sendRequest("/settings/accountancy/banks", 'GET', params, handler, true);
                }
            },
            terminals: {
                get: function (handler) {
                    API.sendRequest("/settings/accountancy/terminals", 'GET', null, handler, true);
                },
                post: function (data, handler) {
                    API.sendRequest("/settings/accountancy/terminals/update", 'POST', data, handler, true);
                }
            },
            maxPayments: {
                get: function (handler, params) {
                    API.sendRequest("/settings/accountancy/globalMaxNumOfPayments", 'GET', params, handler, true);
                },
            }
        },
        profile: {
            get: function (handler) {
                API.sendRequest("/settings/profile", 'GET', null, handler, true);
            },
            post: function (settings, handler) {
                API.sendRequest("/settings/profile", 'POST', settings, handler, true);
            },
            images: {
                get: function (handler) {
                    API.sendRequest("/settings/profile/images", 'GET', null, handler, true);
                },
                post: function (settings, handler) {
                    API.sendRequest("/settings/profile/images", 'POST', settings, handler, true);
                },
            },

        },
        admin: {
            images: {
                get: function (handler) {
                    API.sendRequest("/settings/admin/images", 'GET', null, handler, false);
                },
                post: function (settings, handler) {
                    API.sendRequest("/settings/admin/images", 'POST', settings, handler, true);
                },
            }
        },
        external: {
            get: function (handler) {
                API.sendRequest("/system-settings/external", "GET", null, handler, false);
            },
            post: function (params, handler) {
                API.sendRequest("/system-settings/external", "POST", params, handler, false);
            }
        }
    }
}]);

angular.module('app.core').factory('searchEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/search", 'GET', params, handler, true);
        }
    }
}]);

angular.module('app.core').factory('rolesEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/roles", 'GET', params, handler, true);
        },
        post: function (tags,handler) {
            API.sendRequest("/roles", 'POST', tags, handler, true);
        },
        educator : {
            get: function (params,handler) {
                API.sendRequest("/roles/educator", 'GET', params, handler, true);
            },
            post: function (tags,handler) {
                API.sendRequest("/roles/educator", 'POST', tags, handler, true);
            },
        }


    }
}]);

angular.module('app.core').factory('reportsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/reports",'GET', params, handler, true);
        },
        post: function (params,handler) {
            API.sendRequest("/reports",'POST', params, handler, true);
        },
        fields : {
            get: function (reportID,handler) {
                API.sendRequest("/reports/" +reportID +"/fields",'GET', null, handler, true);
            }
        },
        export : {
            get: function (reportID,handler) {
                API.sendRequest("/reports/" +reportID,'GET', null, handler, true,true);
            }
        },
        saveExport : {
            get: function (params,handler) {
                API.sendRequest("/reports/save/export",'GET', params, handler, true,true);
            },
        },
        delete : {
            post: function (reportID,handler) {
                API.sendRequest("/reports/" +reportID +"/delete",'POST', null, handler, true);
            },
        },
        movements : {
            get: function (params,handler) {
                API.sendRequest("/reports/movements/get", 'GET', params, handler, true,true);
            }
        },
        epr: {
            info:function (params,handler) {
                API.sendRequest("/reports/epr/info", 'GET', params, handler, true);
            }
        }

    }
}]);

angular.module('app.core').factory('regionsEndpoint', ['API', function (API) {

    return {
        get: function (handler) {
            API.sendRequest("/regions", 'GET', null, handler, true);
        }
    }
}]);

angular.module('app.core').factory('regionalCouncilsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/regionalCouncils", 'GET', params, handler, true);
        },
        areas: {
            get: function (handler) {
                API.sendRequest("/regionalCouncils/areas", 'GET', null, handler, true);
            },
        }
    }
}]);

angular.module('app.core').factory('receiptsEndpoint', ['API', function (API) {

    return {
        get: function (params, handler) {
            API.sendRequest("/receipts", 'GET', params, handler, true);
        },
        setPaid: {
            post: function (params, handler) {
                API.sendRequest("/receipts/setPaid", 'POST', params, handler, true);
            },
        },
        matchDate: {
            update: {
                post: function (params, handler) {
                    API.sendRequest("/receipts/" + params.ReceiptID + "/match-date/update", 'POST', params, handler, true);
                }
            }
        },
        cashier: {
            get: function (params, handler) {
                    API.sendRequest("/receipts/cashier", 'GET', params, handler, true);
            },
            close: function (params, handler) {
                API.sendRequest("/receipts/cashier/close", 'POST', params, handler, true);
            },
            export: function (params, handler) {
                API.sendRequest("/receipts/cashier/export", 'GET', params, handler, true,true);
            },
        },
        checks: {
            get: function (params, handler) {
                API.sendRequest("/receipts/checks", 'GET', params, handler, true);
            },
            export: function (params, handler) {
                API.sendRequest("/receipts/checks/export", 'GET', params, handler, true,true);
            },
        }


    }
}]);

angular.module('app.core').factory('questionsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/questions", 'GET', params, handler, true);
        },
        post: function (params,handler) {
            API.sendRequest("/questions", 'POST', params, handler, true);
        },
        update : {
            post: function (question,handler) {
                API.sendRequest("/questions/"+question.ID+"/update", 'POST', question, handler, true);
            }
        },
        delete : {
            post: function (question,handler) {
                API.sendRequest("/questions/"+question.ID+"/delete", 'POST', null, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('pelecardEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/pelecard/iframe", 'POST', params, handler, true);
        },
        refundIframe: function (params,handler){
            API.sendRequest("/pelecard/refund/iframe", 'POST', params, handler, true);
        },
        getJ2: function (params,handler) {
            API.sendRequest("/pelecard/j2Iframe", 'POST', params, handler, true);
        },
        monthlyPayment:{
            post:  function (params,handler) {
                API.sendRequest("/pelecard/monthlyPayment", 'POST', params, handler, true);
            },
        },
        valid : {
            post: function (params,handler) {
                API.sendRequest("/pelecard/valid", 'POST', params, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('paymentsEndpoint', ['API', function (API) {

    return {
        getMonthly: function (params, handler) {
            API.sendRequest('/pelecard/monthlyPayment/full', 'POST', params, handler, true);
        },
        exportMonthlyResults: function (params, handler) {
            API.sendRequest('/pelecard/monthlyPayment/full/export', 'GET', params, handler, true, true);
        },
        getMonthlyChargesList: function (params, handler) {
            API.sendRequest('/pelecard/monthlyPayment/full', 'GET', params, handler, true);
        },
        createMonthly: function (params, handler) {
            API.sendRequest('/pelecard/monthlyPayment/full/create', 'POST', params, handler, true);
        },
        match: {
            get: function (params, handler) {
                API.sendRequest('/payments/match', 'GET', params, handler, true);
            },
            month: {
                get: function (handler) {
                    API.sendRequest('/payments/match/month', 'GET', null, handler, true);
                }
            }
        },
        fix: {
            post: function (params, handler) {
                API.sendRequest('/payments/fix', 'POST', params, handler, true);
            }
        },
        deals: {
            get: function (params, handler) {
                API.sendRequest('/payments/deals/' + params.DealID, 'GET', params, handler, true);
            }
        },
        receiptTransactions: {
            get: function (params, handler) {
                API.sendRequest('/payments/receiptTransactions', 'GET', params, handler, true);
            },
            export: function (params, handler) {
                API.sendRequest('/payments/receiptTransactions/export', 'GET', params, handler, true, true);
            }
        }
    };
}]);

angular.module('app.core').factory('parentsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/parents", 'GET', params, handler, true);
        },
        family : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/family", 'GET', null, handler, true);
            },
            delete : {
                post: function (selectedStudent,handler) {
                    API.sendRequest("/parents/"+selectedStudent.ParentID+"/students/"+selectedStudent.StudentID+"/delete", 'POST', selectedStudent, handler, true);
                },
            },
            deleteSpouse: {
                post: function (ParentID,handler) {
                    API.sendRequest("/parents/"+ParentID+"/spouse/delete", 'POST', ParentID, handler, true);
                },
            },
            addFamilyMember: {
                post: function (familyMember,handler) {
                    API.sendRequest("/parents/"+familyMember.ParentID+"/family", 'POST', familyMember, handler, true);
                },
            }
        },
        registration : {
            get: function (registrationID,handler) {
                API.sendRequest("/parents/registration/"+registrationID, 'GET', null, handler, true);
            },
            isRegistered: function(parentID,eventID,handler){
                API.sendRequest("/parents/"+parentID+"/checkRegistrations/"+eventID,'GET', null, handler, true);
            },
        },
        parentByPrivateID : {
            get: function (parent,handler) {
                API.sendRequest("/parents/privateID/"+parent.PrivateID, 'GET', null, handler, true);
            }
        },
        update : {
            post: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID +"/update", 'POST', parent, handler, true);
            }
        },
        receipts : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/receipts", 'GET', null, handler, true);
            }
        },
        contact : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/contact", 'GET', null, handler, true);
            }
        },
        cash : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/cash", 'GET', null, handler, true);
            },
            delete: function (params,handler) {
                API.sendRequest("/parents/"+params.ParentID+"/cash/"+params.CashID+"/delete", 'POST', params, handler, true);
            },
        },
        subsidy : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/subsidy", 'GET', null, handler, true);
            },
            getByID: function (parentID,subsidyID,handler) {
                API.sendRequest("/parents/"+parentID+"/subsidy/"+subsidyID, 'GET', null, handler, true);
            },
            update : {
                post: function (subsidy,handler) {
                    API.sendRequest("/parents/subsidy/"+ subsidy.ID+"/update", 'POST', subsidy, handler, true);
                }
            }
        },
        cancellation : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/cancellation", 'GET', null, handler, true);
            }
        },
        registrations : {
            get: function (parent,handler) {
                API.sendRequest("/parents/"+parent.ID+"/registrations", 'GET', null, handler, true);
            }
        },
        password : {
            update : {
                post: function (parent,params,handler) {
                    API.sendRequest("/parents/"+parent.ID+"/password/update", 'POST', params, handler, true);
                }
            }

        },
        export : {
            get: function (params,handler) {
                API.sendRequest("/parents/export",'GET', params, handler, true,true);
            }
        },

    }
}]);

angular.module('app.core').factory('organizationsEndpoint', ['API','$http', function (API,$http) {

    return {
        get: function (handler) {
            $http.get('assets/organizations.json').success(handler)
        },
    }
}]);

angular.module('app.core').factory('marketingEndpoint', ['API', function (API) {

    return {
        leads :{
            get: function (params,handler) {
                API.sendRequest("/marketing/leads", 'GET', params, handler, true);
            },
            events : {
                get: function (handler) {
                    API.sendRequest("/marketing/leads/events", 'GET', null, handler, true);
                }
            }
        }

    }
}]);

angular.module('app.core').factory('locationsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/locations", 'GET', params, handler, true);
        },
        post: function (location,handler) {
            API.sendRequest("/locations", 'POST', location, handler, true);
        },
        update : {
            post: function (location,handler) {
                API.sendRequest("/locations/"+location.ID+"/update", 'POST', location, handler, true);
            }
        },
        workingHours: {
            get: function (locationID,handler) {
                API.sendRequest("/locations/"+locationID+"/workingHours", 'GET', null, handler, true);
            },
            post: function (location,handler) {
                API.sendRequest("/locations/workingHours", 'POST', location, handler, true);
            },
            update : {
                post: function (locationID,hours,handler) {
                    API.sendRequest("/locations/"+locationID+"/workingHours/update", 'POST', hours, handler, true);
                }
            },
            delete: {
                post: function (hour,handler) {
                    API.sendRequest("/locations/workingHours/"+hour.ID+"/delete", 'POST', hour, handler, true);
                }
            }
        },
        occupiedSeats: {
            update: {
                post:  function (params,handler) {
                    API.sendRequest("/locations/"+params.LocationID+"/occupiedSeats", 'POST', params, handler, true);
                }
            }
        }
    }
}]);

angular.module('app.core').factory('groupsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/groups", 'GET', params, handler, true);
        },
        post: function (group,handler) {
            API.sendRequest("/groups", 'POST', group, handler, true);
        },
        update : {
            post: function (group,handler) {
                API.sendRequest("/groups/"+group.ID+"/update", 'POST', group, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('gradesEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/grades", 'GET', params, handler, true);
        },
        post: function (grades,handler) {
            API.sendRequest("/grades", 'POST', grades, handler, true);
        },
        update : {
            post: function (group,handler) {
                API.sendRequest("/grades/"+group.ID+"/update", 'POST', group, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('formsEndpoint', ['API', function (API) {

    return {
        cancellation : {
            get: function (params,handler) {
                API.sendRequest("/forms/cancellation", 'GET', params, handler, true);
            },
            update : {
                post: function (form,handler) {
                    API.sendRequest("/forms/cancellation/"+form.ID+"/update", 'POST', form, handler, true);
                },
            }
        },
        contact : {
            get: function (params,handler) {
                API.sendRequest("/forms/contact", 'GET', params, handler, true);
            },
            update : {
                post: function (form,handler) {
                    API.sendRequest("/forms/contact/"+form.ID+"/update", 'POST', form, handler, true);
                },
            }
        },
        subsidy : {
            get: function (params,handler) {
                API.sendRequest("/forms/subsidy", 'GET', params, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('filesEndpoint', ['API', function (API) {

    return {
        get: function (prams,handler) {
            API.sendRequest("/files",'GET', prams, handler, true);
        },
        delete :{
            post: function (file,handler) {
                API.sendRequest("/files/"+file.ID+"/delete",'POST', null, handler, true);
            }
        },
        update : {
            post: function (file,handler) {
                API.sendRequest("/files/"+file.ID+"/update",'POST', file, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('externalRegistrationEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/external-registration/events/"+params.EventID+"/new-registration",'POST', params, handler, true);
        },
        subscribers : {
            get: function (params,handler) {
                API.sendRequest("/external-registration/events/"+params.EventID+"/subscribers",'GET', params, handler, true);
            },
        },
        tranzila : {
            get: function (params,handler) {
                API.sendRequest("/external-registration/tranzila",'GET', params, handler, true);
            },
            valid : {
                post: function (params,handler) {
                    API.sendRequest("/external-registration/tranzila/valid",'POST', params, handler, true);
                },
            }
        },
        registrations : {
            update : {
                post: function (registration,handler) {
                    API.sendRequest("/external-registration/registrations/"+registration.ID+"/update",'POST', registration, handler, true);
                },
            },
            payments : {
                update : {
                    post: function (params,handler) {
                        API.sendRequest("/external-registration/registrations/payment/status/update",'POST', params, handler, true);
                    },
                },
            },
            cancel : {
                post: function (params,handler) {
                    API.sendRequest("/external-registration/registrations/"+params.RegistrationID+"/cancel",'POST', params, handler, true);
                },
            },
            refund : {
                post: function (params,handler) {
                    API.sendRequest("/external-registration/registrations/"+params.RegistrationID+"/refund",'POST', params, handler, true);
                },
                groupRefund: function (params,handler) {
                    API.sendRequest("/external-registration/registrations/"+params.RegistrationID+"/group-refund",'POST', params, handler, true);
                },
            },
            fullRegistration : {
                get: function (registration,handler) {
                    API.sendRequest("/external-registration/"+registration.ID,'GET', registration, handler, true);
                },
            },
            confirm : {
                post: function (registration,handler) {
                    API.sendRequest("/external-registration/"+registration.ID+"/confirm",'POST', registration, handler, true);
                }
            },
            questions : {
                update : {
                    post: function (registration,params,handler) {
                        API.sendRequest("/external-registration/"+registration.ID+"/questions/update",'POST', params, handler, true);
                    }
                }

            },
            logs : {
                get: function (registration,handler) {
                    API.sendRequest("/external-registration/"+registration.ID+"/logs",'GET', registration, handler, true);
                },
            }

        },
    }
}]);

angular.module('app.core').factory('eventsEndpoint', ['API', function (API) {

    return {
        get: function (params, handler) {
            API.sendRequest("/events", 'GET', params, handler, true);
        },
        post: function (event, handler) {
            API.sendRequest("/events", 'POST', event, handler, true);
        },
        update: {
            post: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/update", 'POST', event, handler, true);
            }
        },
        receiptsForGroupRefund: {
            post: function (params, handler) {
                API.sendRequest("/events/group-refund-receipts", 'POST', params, handler, true);
            }
        },
        groupRefund: {
            post: function (params, handler) {
                API.sendRequest("/events/group-refund", 'POST', params, handler, true);
            }
        },
        price: {
            get: function (params, handler) {
                API.sendRequest("/events/price", 'GET', params, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/events/price", 'POST', params, handler, true);
            }
        },
        association: {
            get: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/association", 'GET', null, handler, true);
            },
            update: {
                post: function (association, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/association/update", 'POST', association, handler, true);
                }
            },
            members: {
                post: function (params, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/association/members", 'POST', params, handler, true);
                },
                update: {
                    post: function (params, handler) {
                        API.sendRequest("/events/" + params.EventID + "/association/members/" + params.StudentID + "/update", 'POST', params, handler, true);
                    },
                },
                emptyFile: {
                    get: function (params, handler) {
                        API.sendRequest("/events/" + params.EventID + "/association/members/empty-file", 'GET', params, handler, true, true);
                    },
                }
            }
        },
        questions: {
            get: function (params, event, handler) {
                API.sendRequest("/events/" + event.ID + "/questions", 'GET', params, handler, true);
            },
            add: {
                post: function (event, params, handler) {
                    API.sendRequest("/events/" + event.ID + "/questions/add", 'POST', params, handler, true);
                }
            },
            unlink: {
                post: function (event, question, handler) {
                    API.sendRequest("/events/" + event.ID + "/questions/" + question.ID + "/unlink", 'POST', null, handler, true);
                }
            },
            relink: {
                post: function (event, question, handler) {
                    API.sendRequest("/events/" + event.ID + "/questions/" + question.ID + "/relink", 'POST', null, handler, true);
                }
            },
            update: {
                post: function (question, handler) {
                    API.sendRequest("/events/" + question.EventID + "/questions/" + question.ID + "/update", 'POST', question, handler, true);
                }
            },
            autocomplete: {
                get: function (params, handler) {
                    API.sendRequest("/events/questions/autocomplete", 'GET', params, handler, true);
                }
            }
        },
        transportation: {
            get: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/transportation", 'GET', null, handler, true);
            },
            post: function (event, transportation, handler) {
                API.sendRequest("/events/" + event.ID + "/transportation", 'POST', transportation, handler, true);
            },
            unlink: {
                post: function (event, transportation, handler) {
                    API.sendRequest("/events/" + event.ID + "/transportation/" + transportation.ID + "/unlink", 'POST', null, handler, true);
                }
            },
            relink: {
                post: function (event, transportation, handler) {
                    API.sendRequest("/events/" + event.ID + "/transportation/" + transportation.ID + "/relink", 'POST', null, handler, true);
                }
            },
            update: {
                post: function (event, transportation, handler) {
                    API.sendRequest("/events/" + event.ID + "/transportation/" + transportation.EventTransportationID + "/update", 'POST', transportation, handler, true);
                }
            }
        },
        files: {
            get: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/files", 'GET', null, handler, true);
            },
            update: {
                post: function (params, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/files/update", 'POST', params, handler, true);
                }
            },
            healthDeclaration: {
                get: function (event, handler) {
                    API.sendRequest("/events/" + event.ID + "/health-declaration", 'GET', null, handler, true);
                },
                scheduler: {
                    get: function (eventID, handler) {
                        API.sendRequest("/events/" + eventID + "/health-declaration/scheduler", 'GET', null, handler, true);
                    },
                    post: function (scheduler, handler) {
                        API.sendRequest("/events/" + scheduler.EventID + "/health-declaration/scheduler", 'POST', scheduler, handler, true);
                    },
                    update: {
                        post: function (scheduler, handler) {
                            API.sendRequest("/events/" + scheduler.EventID + "/health-declaration/scheduler/" + scheduler.ID, 'POST', scheduler, handler, true);
                        }
                    }
                }
            }
        },
        subscribers: {
            get: function (params, event, handler) {
                API.sendRequest("/events/" + event.ID + "/subscribers", 'GET', params, handler, true);
            },
            report: function (params, event, handler) {
                API.sendRequest("/events/" + event.ID + "/subscribers/report", 'GET', params, handler, true, true);
            },
            unpaidReport: function (params, event, handler) {
                API.sendRequest("/events/" + event.ID + "/subscribers/unpaid", 'GET', params, handler, true, true);
            }
        },
        discounts: {
            get: function (event, handler) {
                API.sendRequest("/events/" + event.ID + "/discount", 'GET', null, handler, true);
            },
            date: {
                post: function (event, params, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/date", 'POST', params, handler, true);
                },
                status: {
                    post: function (discount, handler) {
                        API.sendRequest("/events/" + discount.EventID + "/discount/date/" + discount.DiscountID + "/status", 'POST', discount, handler, true);
                    }
                },
                update: {
                    post: function (eventID, discountID, params, handler) {
                        API.sendRequest("/events/" + eventID + "/discount/date/" + discountID + "/update", 'POST', params, handler, true);
                    }
                }
            },
            level: {
                post: function (level, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/family", 'POST', level, handler, true);
                }
            },
            brother: {
                post: function (brother, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/brothers", 'POST', brother, handler, true);
                }
            },
            registration: {
                post: function (brother, event, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/registrations", 'POST', brother, handler, true);
                },
            },
            general: {
                post: function (event, params, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/general", 'POST', params, handler, true);
                },
                status: {
                    post: function (discount, handler) {
                        API.sendRequest("/events/" + discount.EventID + "/discount/general/" + discount.DiscountID + "/status", 'POST', discount, handler, true);
                    }
                },
                update: {
                    post: function (eventID, discountID, params, handler) {
                        API.sendRequest("/events/" + eventID + "/discount/general/" + discountID + "/update", 'POST', params, handler, true);
                    }
                }
            },
            student: {
                post: function (event, studentID, params, handler) {
                    API.sendRequest("/events/" + event.ID + "/discount/student/" + studentID, 'POST', params, handler, true);
                },
                update: {
                    post: function (event, params, handler) {
                        API.sendRequest("/events/" + event.ID + "/discount/students/update", 'POST', params, handler, true);
                    },


                },
                emptyTemplate: {
                    get: function (event, params, handler) {
                        API.sendRequest("/events/discount/students/empty-file", 'GET', params, handler, true, true);
                    },


                }
            }

        },
        statistics: {
            get: function (params, event, handler) {
                API.sendRequest("/events/" + event.ID + "/statistics", 'GET', params, handler, true);
            }
        },
        registrations: {
            get: function (params, handler) {
                API.sendRequest("/events/registrations", 'GET', params, handler, true);
            },
            update: {
                post: function (params, handler) {
                    API.sendRequest("/events/registrations/payment-status/update", 'POST', params, handler, true, true);
                },
            },
            amount: {
                get: function (event, handler) {
                    API.sendRequest("/events/" + event.ID + "/registrationsAmount", 'GET', null, handler, true);
                }
            },
            swap: {
                post: function (event, handler) {
                    API.sendRequest("/events/registrations/" + event.oldRegistrationID + "/swap", 'POST', event, handler, true, true);
                }
            },
            approve: {
                post: function (params, handler) {
                    API.sendRequest("/events/registrations/approve", 'POST', params, handler, true);
                },
                amount: {
                    get: function (handler) {
                        API.sendRequest("/events/registrations/waiting-approval", 'GET', null, handler, true);
                    },
                }
            }
        },
        branches: {
            price: {
                post: function (params, handler) {
                    API.sendRequest("/events/" + params.EventID + "/branches/price", 'POST', params, handler, true);
                },
                get: function (eventID, handler) {
                    API.sendRequest("/events/" + eventID + "/branches/price", 'GET', null, handler, true);
                },
                update: {
                    post: function (priceByBranch, handler) {
                        API.sendRequest("/events/branches/price/" + priceByBranch.ID + "/update", 'POST', priceByBranch, handler, true);
                    },
                }
            }
        },
        areas: {
            price: {
                post: function (params, handler) {
                    API.sendRequest("/events/" + params.EventID + "/areas/price", 'POST', params, handler, true);
                },
                get: function (eventID, handler) {
                    API.sendRequest("/events/" + eventID + "/areas/price", 'GET', null, handler, true);
                },
                update: {
                    post: function (priceByArea, handler) {
                        API.sendRequest("/events/areas/price/" + priceByArea.ID + "/update", 'POST', priceByArea, handler, true);
                    },
                }
            }
        },
        groups: {
            price: {
                post: function (params, handler) {
                    API.sendRequest("/events/" + params.EventID + "/groups/price", 'POST', params, handler, true);
                },
                get: function (eventID, handler) {
                    API.sendRequest("/events/" + eventID + "/groups/price", 'GET', null, handler, true);
                },
                update: {
                    post: function (priceByGroup, handler) {
                        API.sendRequest("/events/groups/price/" + priceByGroup.ID + "/update", 'POST', priceByGroup, handler, true);
                    },
                }
            }
        },
        fees: {
            get: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/fees", 'GET', null, handler, true);
            },
            update: function (fee, handler) {
                API.sendRequest("/events/" + fee.EventID + "/fees/update", 'POST', fee, handler, true);
            },
            create: function (fee, handler) {
                API.sendRequest("/events/" + fee.EventID + "/fees", 'POST', fee, handler, true);
            },
            delete: function (fee, handler) {
                API.sendRequest("/events/" + fee.EventID + "/fees/" + fee.ID + "/delete", 'POST', null, handler, true);
            },
        },
        suggestions: {
            get: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/suggestions", 'GET', null, handler, true);
            },
            update: function (suggestion, handler) {
                API.sendRequest("/events/suggestions/" + suggestion.ID + "/update", 'POST', suggestion, handler, true);
            },
            create: function (suggestion, handler) {
                API.sendRequest("/events/suggestions", 'POST', suggestion, handler, true);
            },
        },
        donations: {
            get: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/donations", 'GET', null, handler, true);
            },
            total: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/donations/total", 'GET', null, handler, true);
            },
        },
        categories: {
            get: function (params, handler) {
                API.sendRequest("/events/category", 'GET', params, handler, true);
            },
            getTerminals: function (handler) {
                API.sendRequest("/events/category/terminals", 'GET', null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/events/category", 'POST', params, handler, true);
            },
            update: function (params, handler) {
                const pid = params.CategoryID ? params.CategoryID : params.ID;
                API.sendRequest("/events/category/" + pid + "/update", 'POST', params, handler, true);
            },
            delete: function (params, handler) {
                API.sendRequest("/events/category/" + params.CategoryID + "/delete", 'POST', params, handler, true);
            },
            eventsCategories: function (params, handler) {
                API.sendRequest("/events/category/events", 'GET', params, handler, true);
            },
        },
        locations: {
            get: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/location", 'GET', null, handler, true);
            },
            checkOccupancy: function (params, handler) {
                API.sendRequest("/events/" + params.eventID + "/location/occupancy", 'GET', params, handler, true);
            },
            report: function (eventID, handler) {
                API.sendRequest("/events/" + eventID + "/location/report", 'GET', null, handler, true, true);
            },
        },
        meetings: {
            get: function (params, handler) {
                API.sendRequest("/events/meetings", 'GET', params, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/events/meetings", 'POST', params, handler, true);
            },
            update: function (params, handler) {
                API.sendRequest("/events/meetings/" + params.MeetingID + "/update", 'POST', params, handler, true);
            },
            attendance: {
                get: function (params, handler) {
                    API.sendRequest("/events/meetings/" + params.MeetingID + "/attendance", 'GET', params, handler, true);
                },
                update: function (params, handler) {
                    API.sendRequest("/events/meetings/" + params.MeetingID + "/attendance/" + params.ID + "/update", 'POST', params, handler, true);
                },
            }
        },
        meetingDays: {
            get: function (params, handler) {
                API.sendRequest("/events/" + params.EventID + "/meeting-days", 'GET', null, handler, true);
            },
            post: function (params, handler) {
                API.sendRequest("/events/" + params.EventID + "/meeting-days", 'POST', params, handler, true);
            },
            update: function (params, handler) {
                API.sendRequest("/events/" + params.EventID + "/meeting-days/" + params.ID + "/update", 'POST', params, handler, true);
            },
            delete: function (params, handler) {
                API.sendRequest("/events/" + params.EventID + "/meeting-days/" + params.ID + "/delete", 'POST', params, handler, true);
            },
        }
    }
}
]);

angular.module('app.core').factory('emailEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/email", 'POST', params, handler, true);
        }
    }
}]);

angular.module('app.core').factory('educatorsEndpoint', ['API', function (API) {

    return {

        groups : {
            get: function (educator,handler) {
                API.sendRequest("/educators/"+educator.ID +"/groups", 'GET', educator, handler, true);
            },
            post: function (params,handler) {
                API.sendRequest("/educators/groups", 'POST', params, handler, true);
            },
            update : {
                post: function (group,handler) {
                    API.sendRequest("/educators/"+group.EducatorID +"/groups/"+group.ID+"/update", 'POST', group, handler, true);
                }
            }
        },
        new : {
            post: function (params,handler) {
                API.sendRequest("/educators/new", 'POST', params, handler, false);
            },
            valid : {
                post: function (token,handler) {
                    API.sendRequest("/educators/new/valid", 'POST', token, handler, false);
                }
            }

        }

    }
}]);

angular.module('app.core').factory('coordinatorsEndpoint', ['API', function (API) {

    return {
        get: function (params, handler) {
            API.sendRequest("/coordinators", 'GET', params, handler, true);
        },
        post: function (coordinator, handler) {
            API.sendRequest("/coordinators", 'POST', coordinator, handler, true);
        },
        update: {
            post: function (coordinator, handler) {
                API.sendRequest("/coordinators/" + coordinator.ID + "/update", 'POST', coordinator, handler, true);
            }
        },
        settlements: {
            update: {
                post: function (coordinator, selectedSettlements, handler) {
                    API.sendRequest("/coordinators/" + coordinator.ID + "/settlements/update", 'POST', selectedSettlements, handler, true);
                }
            }
        },
        categories: {
            update: {
                post: function (coordinator, selectedCategories, handler) {
                    API.sendRequest("/coordinators/" + coordinator.ID + "/categories/update", 'POST', selectedCategories, handler, true);
                }
            }
        },
        events: {
            get: function (coordinatorID, handler) {
                API.sendRequest("/coordinators/" + coordinatorID + "/events", 'GET', null, handler, true);
            },
            post: function (coordinatorID,params, handler) {
                API.sendRequest("/coordinators/" + coordinatorID + "/events", 'POST', params, handler, true);
            },
            delete: function (coordinatorID,CoordinatorEventID, handler) {
                API.sendRequest("/coordinators/" + coordinatorID + "/events/" + CoordinatorEventID + "/delete", 'POST', null, handler, true);
            }
        },
        new: {
            post: function (params, handler) {
                API.sendRequest("/coordinators/new", 'POST', params, handler, false);
            },
            valid: {
                post: function (token, handler) {
                    API.sendRequest("/coordinators/new/valid", 'POST', token, handler, false);
                }
            }

        }
    }
}]);

angular.module('app.core').factory('contactsEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/contacts", 'GET', params, handler, true);
        },
        post: function (contact,handler) {
            API.sendRequest("/contacts", 'POST', contact, handler, true);
        },
        update : {
            post: function (contact,handler) {
                API.sendRequest("/contacts/"+contact.ID+"/update", 'POST', contact, handler, true);
            }
        },
        delete : function (contact,handler) {
                API.sendRequest("/contacts/"+contact.ID+"/delete", 'POST', null, handler, true);
            }
        ,
        associations: {
            post: function (contactID,handler) {
                API.sendRequest("/contacts/"+contactID+"/associations", 'GET', null, handler, true);
            },
            delete: function (contactID,IDs,handler) {
                API.sendRequest("/contacts/"+contactID+"/associations/delete", 'POST', IDs, handler, true);
            }
        }
    }
}]);

angular.module('app.core').factory('citiesEndpoint', ['API', function (API) {

    return {
        get: function (handler) {
            API.sendRequest("/cities", 'GET', null, handler, true);
        },

        post: function (city,handler) {
            API.sendRequest("/cities", 'POST', city, handler, true);
        },
        update : {
            post: function (city,handler) {
                API.sendRequest("/cities/"+city.ID+"/update", 'POST', city, handler, true);
            }
        }
    }
}]);

/* deprecated
angular.module('app.core').factory('branchesEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/branches", 'GET', params, handler, true);
        },
        post: function (branch,handler) {
            API.sendRequest("/branches", 'POST', branch, handler, true);
        },
        update : {
            post: function (branch,handler) {
                API.sendRequest("/branches/"+branch.ID+"/update", 'POST', branch, handler, true);
            }
        },
        groups : {
            get: function (branchID,handler) {
                API.sendRequest("/branches/"+branchID+"/groups", 'GET', null, handler, true);
            }
        },
        hours: {
            get: function (branchID,handler) {
                API.sendRequest("/branches/"+branchID+"/hours", 'GET', null, handler, true);
            },
            update: function (branchID,hours,handler) {
                API.sendRequest("/branches/"+branchID+"/hours/update", 'POST', hours, handler, true);
            },
            delete: function (hour,handler) {
                API.sendRequest("/branches/"+hour.BranchID+"/hours/"+hour.ID+"/delete", 'POST', hour, handler, true);
            }
        },
        files: {
            get:  function (branchID,params,handler) {
                API.sendRequest("/branches/"+branchID+"/files", 'GET', params, handler, true);
            },
            update: function (file,handler) {
                API.sendRequest("/branches/"+file.BranchID+"/files/update", 'POST', file, handler, true);
            },
            upload: function (file,handler) {
                API.sendRequest("/branches/"+file.BranchID+"/files", 'POST', file, handler, true);
            },
            delete: function (file,handler) {
                API.sendRequest("/branches/"+file.BranchID+"/files/"+file.ID+"/delete", 'POST', null, handler, true);
            },
        }
    }
}]);
*/

angular.module('app.core').factory('birthdaySettingsEndpoint', ['API', function (API) {

    return {
        post: function (params,handler) {
            API.sendRequest("/birthday-settings",'POST', params, handler, true);
        },
        get: function (handler) {
            API.sendRequest("/birthday-settings",'GET', null, handler, true);
        }
    }
}]);

angular.module('app.core').factory('areasEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/areas", 'GET', params, handler, true);
        },
        post: function (area,handler) {
            API.sendRequest("/areas", 'POST', area, handler, true);
        },
        update :{
            post: function (area,handler) {
                API.sendRequest("/areas/"+area.ID+"/update", 'POST', area, handler, true);
            }
        },
        cities : {
            get: function (area,handler) {
                API.sendRequest("/areas/"+area.ID+"/cities", 'GET', null, handler, true);
            }
        }

    }
}]);

angular.module('app.core').factory('adminEndpoint', ['API', function (API) {

    return {
        post: function (user,handler) {
            API.sendRequest("/admins", 'POST', user, handler,true);
        },
        get: function (params,handler) {
            API.sendRequest("/admins", 'GET', params, handler,true);
        },
        login: {
            post: function (params,handler) {
                API.sendRequest("/admins/login", 'POST', params, handler,false);
            }
        },

        validToken : {
            post: function (params,handler) {
                API.sendRequest("/admins/validToken", 'POST', params, handler,false);
            }
        },
        update : {
            post: function (userID,user,handler) {
                API.sendRequest("/admins/"+userID+"/update", 'POST', user, handler,true);
            }
        },
        password: {
            post: function (userID,passwords,handler) {
                API.sendRequest("/admins/"+userID+"/password", 'POST', passwords, handler,true);
            }
        },
        delete : {
            post: function (userID,handler) {
                API.sendRequest("/admins/"+userID+"/delete", 'POST', null, handler,true);
            }
        }
        ,
        new : {
            post: function (params,handler) {
                API.sendRequest("/admins/new", 'POST', params, handler,false);
            },
            valid : {
                post: function (params,handler) {
                    API.sendRequest("/admins/new/valid", 'POST', params, handler,false);
                }
            }
        },
        forgot : {
            post: function (params,handler) {
                API.sendRequest("/admins/forgot", 'POST', params, handler,false);
            },
            valid : {
                post: function (params,handler) {
                    API.sendRequest("/admins/forgot/valid", 'POST', params, handler,false);
                }

            },
            reset : {
                post: function (params,adminID, handler) {
                    API.sendRequest("/admins/"+adminID+"/reset", 'POST', params, handler, false);
                }
            }
        }


    }

}]);

angular.module('app.core').factory('activitiesEndpoint', ['API', function (API) {

    return {
        get: function (params,handler) {
            API.sendRequest("/activities", 'GET', params, handler, true);
        },
        post: function (activities,handler) {
            API.sendRequest("/activities", 'POST', activities, handler, true);
        },
        update : {
            post: function (activities,handler) {
                API.sendRequest("/activities/"+activities.ID+"/update", 'POST', activities, handler, true);
            }
        },
        meetings: {
            get: function (activities,handler) {
                API.sendRequest("/activities/"+activities.ID+"/meetings", 'GET', null, handler, true);
            },
            post: function (activities,meeting,handler) {
                API.sendRequest("/activities/"+activities.ID+"/meetings", 'POST', meeting, handler, true);
            },
            update: function (activities,meeting,handler) {
                API.sendRequest("/activities/"+activities.ID+"/meetings/" + meeting.ID + "/update", 'POST', meeting, handler, true);
            },
            healthDeclaration: {
                post: function (activityID,meetingID,params,handler) {
                    API.sendRequest("/activities/"+activityID+"/meetings/"+meetingID+"/send-Health-declaration-emails", 'POST', params, handler, true);
                },
            },
        },
        students:{
            get: function (activities,meeting,handler) {
                API.sendRequest("/activities/"+activities.ID+"/meetings/"+meeting.ID+"/students", 'GET', null, handler, true);
            }
        },
        attendance : {
            get: function (activities,handler) {
                API.sendRequest("/activities/"+activities.ID+"/attendance", 'GET', null, handler, true);
            },
            post: function (activities,attendance,handler) {
                API.sendRequest("/activities/"+activities.ID+"/attendance/"+attendance.ID, 'POST', attendance, handler, true);
            }
        }
    }
}]);

(function ()
{
    'use strict';

    angular
        .module('app.pages_auth_reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/reset-password',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/password-reset/reset-password/reset-password.html',
                    controller : 'ResetPasswordController',
                    controllerAs : 'vm'

                }
            },
            bodyClass: 'reset-password'
        });


    }

})();
angular.module('app.pages_auth_reset-password').controller('ResetPasswordController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','adminEndpoint', 'msUtils', '$timeout','$cookies','Notification', function($scope,$rootScope,$mdSidenav,$mdDialog,$location,adminEndpoint, msUtils, $timeout, $cookies,Notification) {


    $scope.fail = false;
    $scope.resetPasswordForm = {};
    $scope.resetPasswordForm.email = null;
    $scope.wrongid = false;
    $scope.success = false;
    $scope.request = false;
    $scope.form = {};

    /**
     * Back to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };


    /**
     * Send email to user with temp token
     */
    $scope.forgot = function () {
        $scope.fail = false;
        $scope.isClicked = true;
        $scope.request = true;
        if(!$scope.form.email){
            $scope.wrongid = true;
            $scope.isClicked = false;
            $scope.request = false;
        }else{
            adminEndpoint.forgot.post($scope.form, function (data) {
                if (data.success)
                    $scope.success = true;
                else {
                    $scope.fail = true;
                    $timeout(function () {
                        $scope.fail = false;
                    }, 5000);
                }
                $scope.request = false;
            })
        }
    };



}]);

angular.module('app.pages.users').controller('ContactDialogController', ContactDialogController);
function ContactDialogController($scope, $mdDialog,$location,contactForm,Notification,formsEndpoint) {

    $scope.contactForm = contactForm;

    /**
     * Get files
     */
    $scope.getFiles = function () {

        for (var i = 0; i < subsidy.Files.length; i++)
            window.open(subsidy.Files[i].Path, subsidy.Files[i].ID);
    };
    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    $scope.updateContactForm = function () {
        formsEndpoint.contact.update.post($scope.contactForm,function (data) {
            if (data.success) {
                Notification.success("פרטים עודכנו בהצלחה");
                $mdDialog.hide();

            }
            else {
                Notification.error("נכשל בעדכון פרטים");
                $mdDialog.cancel();

            }

        })
    }

}

(function ()
{
    'use strict';

    angular
        .module('app.pages_auth_forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/password-reset/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController',
                    controllerAs : 'vm'

                }
            },
            bodyClass: 'forgot-password'
        });


    }

})();
angular.module('app.pages_auth_forgot-password').controller('ForgotPasswordController', ['$scope','$rootScope','$mdSidenav','$mdDialog','$location','adminEndpoint', 'msUtils', '$timeout','$cookies','Notification','appConfig', function($scope,$rootScope,$mdSidenav,$mdDialog,$location,adminEndpoint, msUtils, $timeout, $cookies,Notification,appConfig) {

    $scope.showHideText = 'הצג';
    $scope.inputType = 'password';
    $scope.showHideImg = "/assets/icons/show.svg";
    $scope.matchPasswords = false;
    $scope.matchFlags = true;
    $scope.password = '';
    $scope.passwordVerify = '';
    $scope.form = {};
    $scope.success = false;
    $scope.loading = false;
    $scope.errorInfo = "";

    /**
     * Back to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };

    /**
     * Valid the user temp token
     */
    $scope.checkUserToken = function () {
        var params = {};
        params.token =  $location.search().tempToken;
        adminEndpoint.forgot.valid.post(params,function (data) {
            if (!data.ID) {
               $location.path("/")

            }
            else {
                $scope.valid=true;
                $scope.admin=data;

            }
        })
    };
    $scope.matchPass = function () {
        if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length > 5) {
            $scope.matchPasswords = true;
            $scope.matchFlags = true;
        } else if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length < 6) {
            $scope.shortPass = true;
            $scope.matchFlags = true;
        } else {
            $scope.shortPass = false;
            $scope.matchPasswords = false;
            $scope.matchFlags = false;
        }
    };
    /**
     * Login user to system
     */
    $scope.submit = function () {
        $scope.loading =true;
        $scope.form.Token = $location.search().tempToken;
        adminEndpoint.forgot.reset.post($scope.form, $scope.admin.ID, function (data) {
            if (data.ID) {
                $scope.success = true;
                $rootScope.User = data;
                $timeout(function(){
                    saveUser();
                },4000)
                setUserType();

            }
            else if(data.message)
                Notification.error(data.message)
            else
                $scope.errorInfo = "Error!";
            $scope.loading = false;
        })
    };

    function saveUser() {
        var expireTime = + new Date() +(24 * 3600000);
        $cookies.put(appConfig.adminTokenName,$rootScope.User.AccessToken,[{expires:expireTime}]);
        $scope.loogin = false;
        $timeout(function () {
            if ($rootScope.AdminLevel!==3)
                $location.path('/students');
            else
                $location.path('/dashboard');
        },250)
    }

    /**
     * Show or hide the password
     * @param field
     * @param ev
     */
    $scope.showHidePassword = function () {
        if ($scope.inputType == "password") {
            $scope.inputType = "text";
            $scope.showHideText = 'הסתר';
            $scope.showHideImg = "/assets/icons/hide.svg";
        } else {
            $scope.inputType = "password";
            $scope.showHideText = 'הצג';
            $scope.showHideImg = "/assets/icons/show.svg";
        }

    };


    /**
     * Set the admin type
     */
    function setUserType() {
        if ($rootScope.User.StudentID)
            $rootScope.AdminLevel =1;
        else if ($rootScope.User.IsCoordinator)
            $rootScope.AdminLevel =2;
        else
            $rootScope.AdminLevel =3;
    }


}]);

angular.module('app.pages.users').controller('CancellationDialogController', CancellationDialogController);
function CancellationDialogController($scope, $mdDialog,$location,cancel,Notification,formsEndpoint) {

    $scope.cancel = cancel;

    /**
     * Get files
     */
    $scope.getFiles = function () {

        for (var i = 0; i < subsidy.Files.length; i++)
            window.open(subsidy.Files[i].Path, subsidy.Files[i].ID);
    };
    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

    $scope.updateCancellationForm = function () {
        formsEndpoint.cancellation.update.post($scope.cancel,function (data) {
            if (data.success) {
                Notification.success("פרטים עודכנו בהצלחה");
                $mdDialog.hide();

            }
            else {
                Notification.error("נכשל בעדכון פרטים");
                $mdDialog.cancel();

            }

        })
    }

}

angular.module('app.pages.events').controller('RefundRegistrationDialogController', ['$scope', '$rootScope', '$mdDialog', 'parentsEndpoint', 'studentsEndpoint', 'student', '$location', 'Notification', 'event', 'eventsEndpoint', 'registration', 'external', 'externalRegistrationEndpoint', 'pelecardEndpoint', '$sce', 'appConfig', '$interval', 'tranzilaEndpoint',
    function ($scope, $rootScope, $mdDialog, parentsEndpoint, studentsEndpoint, student, $location, Notification, event, eventsEndpoint, registration, external, externalRegistrationEndpoint, pelecardEndpoint, $sce, appConfig, $interval, tranzilaEndpoint) {

        $scope.cancelRegistration = {};
        $scope.registration = registration;
        $scope.registration.DecimalFinalPrice = $scope.registration.FinalPrice ? parseFloat($scope.registration.FinalPrice) : parseFloat($scope.registration.Price);
        $scope.registration.FinalPrice = $scope.registration.FinalPrice ? parseInt($scope.registration.FinalPrice) : parseInt($scope.registration.Price);

        $scope.parentLoaded = false;
        $scope.amountConfirmed = false;
        $scope.invalidAmountMessage = false;
        $scope.receipts = [];
        $scope.iframe = undefined;
        $scope.DealID = undefined;
        $scope.interval = undefined;

        function init() {
            parentsEndpoint.registration.get($scope.registration.ID, function (data) {
                $scope.parent = data;
                $scope.cancelRegistration.ParentID = data.ID ? data.ID : null;
                $scope.parentLoaded = true;
            });

            studentsEndpoint.registrations.refunds.get($scope.registration, function (data) {
                $scope.amountConfirmed = 0;
                $scope.monthlyPayment = data.MonthlyPayment == 1 ? 1 : 0;
                Object.keys(data.Receipts).forEach(function (key) {
                    $scope.amountConfirmed += Number(data.Receipts[key].left);
                })
                $scope.receipts = data.Receipts;
                //$scope.cancelRegistration.Refund = Math.max(0,$scope.amountConfirmed);
                // if ($scope.amountConfirmed <= 0 && $scope.registration.PaymentType != 11) {
                if ($scope.amountConfirmed <= 0 || data.regFullyRefunded) {
                    Notification.error("הרשמה זו זוכתה במלואה!");
                    $mdDialog.hide();
                }
            })
        }

        init();

        $scope.changeRefundValue = function () {
            if ($scope.monthlyPayment == 1)
                $scope.cancelRegistration.Refund = Math.min($scope.cancelRegistration.ReceiptForRefund.left, $scope.amountConfirmed);
            else if ($scope.monthlyPayment == 0) {
                // Use DecimalFinalPrice for refund types that allow decimals, otherwise use rounded FinalPrice
                var priceToUse = ($scope.cancelRegistration.RefundType == 1 || $scope.cancelRegistration.RefundType == 6)
                    ? $scope.registration.FinalPrice
                    : $scope.registration.DecimalFinalPrice;
                $scope.cancelRegistration.Refund = Math.min($scope.cancelRegistration.ReceiptForRefund.left, priceToUse);
            } else {
                Notification.error("התרחשה שגיאה");
                $mdDialog.cancel();
            }
        }

        $scope.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        };

        /**
         * Send refund Registration request
         */
        $scope.refundRegistration = function () {
            $scope.cancelRegistration.RegistrationID = $scope.registration.ID;
            $scope.cancelRegistration.StudentID = registration.StudentID;
            $scope.cancelRegistration.ParentID = registration.ParentID;
            $scope.cancelRegistration.UserID = registration.UserID;
            $scope.cancelRegistration.ReceiptID = $scope.cancelRegistration.ReceiptForRefund.ReceiptID;
            if ($scope.cancelRegistration.RefundType == 6) {//need Iframe for new card
                $scope.isClikced = true;
                pelecardEndpoint.refundIframe($scope.cancelRegistration, function (data) {
                    $scope.iframe = data.Iframe;
                    $scope.DealID = data.DealID;
                    $scope.isClikced = false;
                    $scope.interval = $interval(function () {
                        var params = {
                            DealID: $scope.DealID
                        }
                        if (appConfig.paymentCompany == 1) {
                            tranzilaEndpoint.valid.post(params, function (data) {
                                if (data) {
                                    if (data.success) {
                                        Notification.success("זיכויי בוצעה בהצלחה!");
                                    } else {
                                        Notification.error("שגיאה")
                                    }
                                    $interval.cancel($scope.interval);
                                    $mdDialog.cancel();
                                }
                            })
                        } else {
                            pelecardEndpoint.valid.post(params, function (data) {
                                if (data) {
                                    if (data.success) {
                                        Notification.success("זיכויי בוצעה בהצלחה!");
                                    } else {
                                        Notification.error("שגיאה")
                                    }
                                    $interval.cancel($scope.interval);
                                    $mdDialog.cancel();
                                }
                            })
                        }
                    }, 4000);
                });
            } else {
                $scope.isClikced = true;
                if (!external) {
                    studentsEndpoint.events.refund.post($scope.cancelRegistration, function (data) {
                        if (typeof data == 'string')
                            Notification.error(data);
                        else if (data.success)
                            Notification.success("פעולה הסתיימה בהצלחה");
                        else
                            Notification.error("פעולה נכשלה");
                        $scope.isClikced = false;
                        $mdDialog.hide();
                    });
                } else {
                    externalRegistrationEndpoint.registrations.refund.post($scope.cancelRegistration, function (data) {
                        if (typeof data == 'string')
                            Notification.error(data);
                        else if (data.success)
                            Notification.success("פעולה הסתיימה בהצלחה");
                        else
                            Notification.error("פעולה נכשלה");
                        $scope.isClikced = false;
                        $mdDialog.hide();
                    })
                }
            }

        };


        /**
         * Close the dialog
         */
        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

        $scope.checkAmount = function () {
            var tmpAmount;
            $scope.invalidAmountMessage = false;
            if ($scope.cancelRegistration.Refund > 0) {
                tmpAmount = $scope.cancelRegistration.Refund.toString().split(".");
                // אם שיטת הזיכוי היא 1 או 6 - לא לאפשר חצאים, אחרת לאפשר עד חצי שקל

                if ($scope.cancelRegistration.RefundType == 1 || $scope.cancelRegistration.RefundType == 6) {
                    if (tmpAmount[1] && tmpAmount[1].length > 0) {
                        // לא לאפשר בכלל עשרוניים
                        $scope.cancelRegistration.Refund = +tmpAmount[0];
                    }
                } else {
                    if (tmpAmount[1] && tmpAmount[1].length > 2) {
                        tmpAmount[1] = tmpAmount[1].slice(0, 2);
                        $scope.cancelRegistration.Refund = +tmpAmount.join(".");
                    }
                    // לאפשר רק חצאים (0 או 50 אגורות)
                    if (tmpAmount[1]) {
                        var decPart = tmpAmount[1].padEnd(2, '0');
                        // בדיקה אם זה לא 00 או 50 בדיוק
                        if (decPart !== '00' && decPart !== '50') {
                            // לעגל לחצי הקרוב
                            var intPart = +tmpAmount[0];
                            var decPartNum = +decPart;
                            if (decPartNum < 25) {
                                $scope.cancelRegistration.Refund = intPart;
                            } else if (decPartNum < 75) {
                                $scope.cancelRegistration.Refund = intPart + 0.5;
                            } else {
                                $scope.cancelRegistration.Refund = intPart + 1;
                            }
                        }
                    }
                }
            }
            if ($scope.cancelRegistration.Refund < 1)
                $scope.cancelRegistration.Refund = 1;

            // Use DecimalFinalPrice for refund types that allow decimals, otherwise use rounded FinalPrice
            var priceToUse = ($scope.cancelRegistration.RefundType == 1 || $scope.cancelRegistration.RefundType == 6)
                ? $scope.registration.FinalPrice
                : $scope.registration.DecimalFinalPrice;

            if ($scope.monthlyPayment == 0 && $scope.cancelRegistration.Refund > Math.min($scope.cancelRegistration.ReceiptForRefund.left, priceToUse))
                $scope.cancelRegistration.Refund = Math.min($scope.cancelRegistration.ReceiptForRefund.left, priceToUse);
            else if ($scope.monthlyPayment == 1 && $scope.cancelRegistration.Refund > $scope.cancelRegistration.ReceiptForRefund.left)
                $scope.cancelRegistration.Refund = $scope.cancelRegistration.ReceiptForRefund.left;
        }


    }]);

angular.module('app.pages.manage-admins').controller('CoordinatorsController',CoordinatorsController);
function CoordinatorsController($scope,$rootScope,$mdSidenav,$mdDialog,$location,usersEndpoint, msUtils, $timeout, $document,DTOptionsBuilder,dtOptions,groupsEndpoint,coordinatorsEndpoint,coordinate,rolesEndpoint,settlementsEndpoint) {

    if (!$rootScope.User)
        $location.path('/dashboard');

    $scope.search = {};
    $scope.coordinators = [];
    $scope.search.settlements = [];
    $scope.search.groups = [];
    $scope.coordinators = [];

    /**
     * Get All Settlements
     */
    $scope.getSettlements = function() {
        settlementsEndpoint.get({}, function (data) {
            $scope.settlements = data;
        });

    }

    /**
     * Get Coordinators
     * @param noFilter
     */
    $scope.getCoordinators = function (noFilter) {
        $scope.isClicked = true;
        $scope.coordinators = null;
        if (!noFilter) {
            var params = {};
            $scope.isClicked = true;
            params.FreeSearch = $scope.search.freeSearchFromDB;
            params.SettlementIDs = JSON.stringify($scope.search.settlements);
            params.Status = $scope.search.status;
            params.Role = $scope.search.role;
        }
        else {
            $scope.search = {};
            $scope.search.groups = [];
            return;
        }

        coordinatorsEndpoint.get(params, function (data) {
            $scope.dtInstance = {};
            $scope.isClicked = false;
            $scope.coordinators = data;
        })

    };

    /**
     * Open new Coordinators
     */
    $scope.openNewCoordinatDialog = function () {
        $mdDialog.show({
            controller: 'NewCoordinatorsDialogController',
            templateUrl: 'app/main/pages/admin/coordinators/new-coordinators-dialog/new-coordinators-dialog.html',
            clickOutsideToClose: false
        });
    };

    /**
     * Move to user profile
     */
    $scope.goToCoordinatProfile = function (selectedCoordinate) {
        coordinate.updateSelectedCoordinate(selectedCoordinate);
        $location.path("/coordinator-profile")
    };

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.branchesQuerySearch = function (query) {
        var results = query ?
            $scope.branches.filter(createFilterFor(query)) : [];
        return results;
    };

    /**
     * Branches query search
     * @param query
     * @returns {Array}
     */
    $scope.settlementsQuerySearch = function(query) {
        var results = query ? $scope.settlements.filter(createFilterFor(query)) : [];
        return results;
    };


    /**
     * Create filter for query from auto complete
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact.Name.indexOf(lowercaseQuery) != -1);
        };
    }


    /**
     * Open  Coordinators Panel
     * @param selectedCoordinate
     */
    $scope.openCoordinatPanel = function (selectedCoordinate) {
        $mdSidenav("coordinate-panel").open();
        coordinate.updateSelectedCoordinate(selectedCoordinate);
    };


    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive',true)
        .withDOM('lrtip');


    $scope.setAll = function (selectAll) {
        if (selectAll) {
            for (var i = 0; i < $scope.coordinators.length; i++) {
                $scope.coordinators[i].Selected = true;
            }
        }
        else
            for (var i = 0; i < $scope.coordinators.length; i++) {
                $scope.coordinators[i].Selected = false;
            }
    };

    /**
     * Open send sms dialog
     */
    $scope.openSendSMS = function () {
        $mdDialog.show({
            controller: 'SMSDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html',
            locals: {'students': $scope.coordinators, 'external': false, 'type': 2},
            clickOutsideToClose: false

        });
    };

    /**
     * open send email
     */
    $scope.openSendEmail = function () {
        $mdDialog.show({
            controller: 'EmailDialogController',
            templateUrl: 'app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html',
            locals: {'students': $scope.coordinators, 'external': false, 'type': 2},
            clickOutsideToClose: false

        });
    };

    /**
     * Get Roles
     */
    $scope.getRoles =function () {
        var params = {};
        params.withNames = true;
        rolesEndpoint.get(params, function (data) {
            $scope.roles = data;
        })
    }




}

angular.module('app.pages.events').controller('CancelRegistrationDialogController', ['$scope', '$rootScope', '$mdDialog','studentsEndpoint','student','$location','Notification','event','eventsEndpoint','registration','external','externalRegistrationEndpoint', function ($scope, $rootScope, $mdDialog,studentsEndpoint,student,$location,Notification,event,eventsEndpoint,registration,external,externalRegistrationEndpoint) {


    $scope.registration = registration;
    $scope.registration.FinalPrice= parseInt($scope.registration.FinalPrice);

    /**
     * Send cancel Registration request
     */
    $scope.cancelReg = function () {
        $scope.cancelRegistration.ReceiptID =  $scope.registration.ReceiptID;
        $scope.cancelRegistration.RegistrationID =  $scope.registration.ID;
        $scope.cancelRegistration.StudentID = registration.StudentID;
        $scope.isClikced=true;
        if (!external)
            studentsEndpoint.events.cancel.post($scope.cancelRegistration,function (data) {
                if (typeof data =='string')
                    Notification.error(data);
                else if (data.success)
                    Notification.success("פעולה הסתיימה בהצלחה");
                else
                    Notification.error("פעולה נכשלה");
                $scope.isClikced=false;
                $mdDialog.hide();
            });
        else
            externalRegistrationEndpoint.registrations.cancel.post($scope.cancelRegistration,function (data) {
                if (typeof data =='string')
                    Notification.error(data);
                else if (data.success)
                    Notification.success("פעולה הסתיימה בהצלחה");
                else
                    Notification.error("פעולה נכשלה");
                $scope.isClikced=false;
                $mdDialog.hide();
            })

    };


    /**
     * Close the dialog
     */
    $scope.closeDialog =function () {
        $mdDialog.cancel();
    };




}]);

angular.module('app.pages.events').controller('GroupRefundRegistrationDialog',GroupRefundRegistrationDialog);
function GroupRefundRegistrationDialog( $scope, $rootScope, $mdDialog,Subscribers,Event,student,$location,Notification,eventsEndpoint, externalRegistrationEndpoint ){

    $scope.cancelRegistration = {
        RefundType: 1,
        Refund: 0,
        RefundModel: 1,
        Cancel: 0,
        RefundComment: "",
        CancelComment:"",
        RegistrationIDs: Subscribers,
        EventID: Event.selectedEvent.ID,
        EventType:  Event.selectedEvent.EventType,
        RefundStartDate: '',
        RefundEndDate: '',
        MonthlyPayment: Event.selectedEvent.MonthlyPayment,
        MultipleRefunds: 0
    }
    $scope.maxAmount = 100;
    $scope.closeWhenDone = true;
    $scope.DateValid = false;
    $scope.cancelRegistration.RegistrationIDs = Subscribers.map(function (subscriber){return subscriber.ID});

    $scope.GroupRefundRegistration = function () {
        $scope.isClikced=true;

        //if ($scope.cancelRegistration.EventType == 0) {//0 == חוג

            eventsEndpoint.receiptsForGroupRefund.post($scope.cancelRegistration, function (data) {
                if (typeof data == 'string') {
                    Notification.error(data);
                    $scope.closeWhenDone = false;
                }
                else if (Array.isArray(data)) {
                    $mdDialog.show({
                        controller: 'GroupRefundReceiptsDialog',
                        templateUrl: 'app/main/pages/events-dialogs/group-refund-registration-dialog/group-refund-receipts-dialog/group-refund-receipts-dialog.html',
                        clickOutsideToClose: true,
                        locals: {
                            'Receipts': data,
                            'MultipleRefunds': $scope.cancelRegistration.MultipleRefunds,
                            'RefundModel': $scope.cancelRegistration.RefundModel
                        },
                    }).then(function(data){
                        $mdDialog.hide();
                    });
                }
                else
                    Notification.error("פעולה נכשלה");
                $scope.isClikced = false;
                if($scope.closeWhenDone) $mdDialog.hide();

            });
        /*}
        else{
            externalRegistrationEndpoint.registrations.refund.groupRefund($scope.cancelRegistration,function (data) {
                if (typeof data =='string') {
                    Notification.error(data);
                    $scope.closeWhenDone = false;
                }
                else if (data.success)
                    Notification.success("פעולה הסתיימה בהצלחה");
                else
                    Notification.error("פעולה נכשלה");
                $scope.isClikced=false;

                if($scope.closeWhenDone) $mdDialog.hide();
            })
        }*/
    };

    $scope.closeDialog = function () {

        $mdDialog.cancel();
    };
}

angular.module('app.pages.users').controller('FullRegistrationDialogController', FullRegistrationDialogController);

function FullRegistrationDialogController($scope, $timeout, $rootScope, $http, Upload, appConfig, $sce, pelecardEndpoint, tranzilaEndpoint, $interval, $mdDialog, registration, studentsEndpoint, Notification, DTOptionsBuilder, dtOptions, settingsEndpoint, receiptsService, $sce, eventsEndpoint) {

    $scope.fileNames = {};
    $scope.approved = true;

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip');


    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $scope.registrations.Registration.ReceiptID.forEach(function (payment) {
            if (payment.interval)
                $interval.cancel(payment.interval);
        })
        $mdDialog.cancel();
    };

    /**
     * Get the full Registration
     */
    $scope.getFullRegistration = function () {
        $scope.initializing = 0;
        var memberID;
        if (registration.StudentID)
            memberID = registration.StudentID;
        else if (registration.ParentID)
            memberID = registration.ParentID;
        else
            memberID = registration.UserID;
        studentsEndpoint.registrations.fullRegistration.get(memberID, registration, function (data) {
            $scope.registrations = data;
            $scope.eventID = data.Registration.ParentEventID;
            if (+$scope.registrations.Registration.RegNeedApproval === 1 && !$scope.registrations.Registration.ApproveDate) $scope.approved = false;
            $scope.registrations.Questions.filter(function (question) {
                return question.AnswerType == 5;
            }).forEach(function (question) {
                question.Answer = question.Answer == 'true';
            })
            for (var i = 0; i < $scope.registrations.Registration.ReceiptID.length; i++)
                if ($scope.registrations.Registration.ReceiptID[i].ChecksData && $scope.registrations.Registration.ReceiptID[i].ChecksData.length)
                    $scope.registrations.Registration.ReceiptID[i].ChecksData = JSON.parse($scope.registrations.Registration.ReceiptID[i].ChecksData);
            setFileName();
            getLogs();
            getBanks();
            getParents();
        });
        setTimeout(function () {
            $scope.resetButtons();
        }, 1000);

    };

    /**
     * Update registration
     * @param registration
     */


    $scope.resetButtons = function (registration) {
        var outerDiv = document.querySelector('.full-registration-dialog');
        if (outerDiv) {
            var prevButton = outerDiv.querySelector('md-prev-button');
            if (prevButton) {
                prevButton.addEventListener('click', $scope.prevTab);
            }
            var nextButton = outerDiv.querySelector('md-next-button');
            if (nextButton) {
                nextButton.addEventListener('click', $scope.nextTab);
            }
        }
    };
    $scope.prevTab = function (e) {
        // e.preventDefault();
        var outerDiv = document.querySelector('.full-registration-dialog');
        var listOfTabs = outerDiv.querySelectorAll('md-tab-item');
        var availableTabs = [];
        listOfTabs.forEach(function (tab, idx) {
            if (!tab.classList.contains('md-disabled')) {
                availableTabs.push(idx);
            }
        });
        var idx = availableTabs.findIndex(function (tab) {
            return tab === $scope.selectedTab;
        });
        if (idx > 0) {
            setTimeout(function () {
                $scope.selectedTab = availableTabs[idx - 1];
            }, 400);
        }
    };
    $scope.nextTab = function (e) {
        // e.preventDefault();
        var outerDiv = document.querySelector('.full-registration-dialog');
        var listOfTabs = outerDiv.querySelectorAll('md-tab-item');
        var availableTabs = [];
        listOfTabs.forEach(function (tab, idx) {
            if (!tab.classList.contains('md-disabled')) {
                availableTabs.push(idx);
            }
        });
        var idx = availableTabs.findIndex(function (tab) {
            return tab === $scope.selectedTab;
        });
        if (idx < availableTabs.length - 1) {
            setTimeout(function () {
                $scope.selectedTab = availableTabs[idx + 1];
            }, 400);
        }
    };

    $scope.updateRegistration = function (registration) {
        $scope.isClicked = true;
        delete registration['ReceiptID'];
        delete registration['RefundReceiptID'];
        studentsEndpoint.registrations.update.post(registration, function (data) {
            $scope.isClicked = false;
            Notification.success("הרשמה עודכנה בהצלחה");
            $rootScope.$broadcast("Registration-Update");
            $mdDialog.hide()
        })
    };


    /**
     * confirm registration and send receipt
     * @param registration
     */
    $scope.sendReceipt = function (registration) {

        if (registration.ReceiptID || registration.PaymentStatus == 0 || registration.PaymentStatus == 3)
            return;
        if ($scope.initializing >= 1 && location.hostname !== "localhost") {
            $scope.initializing++;
            return;
        } else
            $scope.isClicked = true;
        studentsEndpoint.registrations.confirm.post(registration, function (data) {
            $scope.isClicked = false;
            Notification.success("הרשמה עודכנה בהצלחה");
            Notification.info("קבלה נשלחה ללקוח");
            $rootScope.$broadcast("Registration-Update");
            getLogs();
        })
    };

    $scope.changePaymentStatusByType = function (payment) {
        payment.paymentStatusDisabled = false;

        if ($rootScope.AdminLevel < 3) {
            payment.paymentStatusDisabled = true;
        }
        switch (payment.PaymentType) {
            case 0://free
                break;
            case 1://credit card
                payment.PaymentStatus = 1;
                payment.paymentStatusDisabled = true;
                break;
            case 2://cash
                if ($rootScope.AdminLevel < 3) {
                    payment.PaymentStatus = 2;//payed to coordinator
                } else {
                    payment.PaymentStatus = $rootScope.advancedCashierOptions ? 5 : 1;
                }
                break;
            case 3://bank transfer
                payment.PaymentStatus = 1;
                payment.paymentStatusDisabled = true;
                break;
            case 4://checks
                if ($rootScope.AdminLevel < 3) {
                    payment.PaymentStatus = 2;//payed to coordinator
                } else {
                    payment.PaymentStatus = $rootScope.advancedCashierOptions ? 5 : 1;
                }
                break;
            case 11://credit card monthly
                payment.PaymentStatus = 1;
                payment.paymentStatusDisabled = true;
                break;
        }
    }

    /**
     * get Logs
     */
    function getLogs() {
        $scope.logs = false;
        studentsEndpoint.registrations.logs.get(registration, function (data) {
            $scope.logs = data
        })
    }

    function setFileName() {
        if ($scope.registrations.Registration.FileRecipt != null) {
            $scope.fileName2 = $scope.registrations.Registration.FileRecipt.replace(/^.*[\\\/]/, '')
        }
        if ($scope.registrations.Registration.File != null) {
            $scope.fileName = $scope.registrations.Registration.File.replace(/^.*[\\\/]/, '')
        }
    }

    /**
     * Update Questions
     * @param questions
     */
    $scope.updateQuestions = function (questions) {
        $scope.isClicked = true;
        var params = {};
        params.Questions = questions;
        studentsEndpoint.registrations.questions.update.post(registration, params, function () {
            $scope.isClicked = false;
            Notification.success("שאלות עודכנו בהצלחה");
            getLogs();
        })
    };

    /**
     * Update regTransportation
     */
    $scope.updateTransportation = function () {
        $scope.isClicked = true;
        var params = {};
        params.TransportationTo = $scope.registrations.Transportation.SelectedTransportationTo;
        params.TransportationStopTo = $scope.registrations.Transportation.SelectedTransportationStopTo
        params.TransportationFrom = $scope.registrations.Transportation.SelectedTransportationFrom;
        params.TransportationStopFrom = $scope.registrations.Transportation.SelectedTransportationStopFrom;
        studentsEndpoint.registrations.transportation.update.post(registration, params, function (data) {
            if (!data.success) {
                Notification.error('נכשל בעדכון');
            } else {
                $scope.isClicked = false;
                Notification.success("הסעות עודכנו בהצלחה");
                getLogs();
            }
        })
    };

    /**
     * Get Banks
     */
    function getBanks() {
        settingsEndpoint.accountancy.banks.get({EventID: $scope.registrations.Registration['EventID']}, function (data) {
            $scope.banks = data;
        })
    }

    /**
     * Re send Receipt
     * @param receiptID
     * @param type
     */
    $scope.reSendReceipt = function (receiptID, type) {
        Notification.info("שולח קבלה..");
        receiptsService.getReceiptByID(receiptID, type, function () {
            Notification.success("קבלה נשלחה בהצלחה");
        }, true);
    };

    /**
     * Set Price
     * @param FinalPrice
     * @param Discount
     * @returns {number}
     */
    $scope.setPrice = function (FinalPrice, Discount) {
        return parseInt(FinalPrice) + parseInt(Discount)
    };

    /**
     * Open File in new widnwos
     * @param path
     */
    $scope.openFile = function (path) {
        window.open(path, '_blank');
    };

    /**
     * Update Questions
     * @param question
     */
    $scope.updateOptionFile = function (question) {
        var file = document.getElementById(question.ID);
        file = file.files[0];
        var params = new FormData();
        question.filename = new Date().getTime() + "_" + file.name;
        params.append("files", file, question.filename);
        params.append("brand", $rootScope.brandName);
        params.append("upload_file", 'true');

        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files';
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files';
        else
            uploadURL = appConfig.serverUrl + '/upload/files';

        $http.post(uploadURL, params, {
            headers: {'Content-Type': 'multipart/form-data', 'Accept': 'application/json'},
            withCredentials: true
        }).then(function (data) {
            question.Answer = data.Path;
        });

    };


    /**
     * Open File
     */
    $scope.viewFile = function (file) {
        window.open(file);
    };

    /**
     * UploadFile
     * @param file
     */
    $scope.uploadFile = function (file, q, question, ds) {
        if (!file)
            return;
        $scope.isClicked = true;
        var qu = question;
        if (question) {
            $scope.fileNames[qu.ID] = file.name;
        } else if (ds) {
            $scope.fileName2 = file.name;
        } else {
            $scope.fileName = file.name;
        }
        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl + '/upload/files?brand=' + $rootScope.brandName;
        else
            uploadURL = appConfig.serverUrl + '/upload/files?brand=' + $rootScope.brandName;

        Upload.upload({
            url: uploadURL,
            data: {file: file, 'accessToken': $rootScope.User.AccessToken}
        }).then(function (resp) {
            if (q != null) {
                $scope.registrations.Questions.forEach(function (ele) {
                    if (ele.ID == question.ID) {
                        ele.Answer = resp.data.Path;
                    }
                });
            } else if (ds) {
                //$scope.registrations.Registration.FileRecipt = resp.data.Path;
                $scope.registrations.Registration.ReceiptID[0].FileRecipt = resp.data.Path;
            } else {
                //$scope.registrations.Registration.File = resp.data.Path;
                $scope.registrations.Registration.ReceiptID[0].FileRecipt = resp.data.Path;
            }
            Notification.success("קובץ הועלה");
            $scope.isClicked = false;

        }, function (resp) {
            console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage);
        });

    }

    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    };

    $scope.isFullyPaid = function () {
        if (!$scope.registrations || !$scope.registrations.Registration.ReceiptID)
            return false;
        var total = 0;
        $scope.registrations.Registration.ReceiptID.forEach(function (receipt) {
            if (receipt.PaymentType == 4 && receipt.ChecksData.length > 0 && Array.isArray(receipt.ChecksData))
                receipt.ChecksData.forEach(function (check) {
                    total += Number(check.CheckAmount);
                })
            else
                total += Number(receipt.Sum);
        })
        if ($scope.registrations.cashTrans && $scope.registrations.cashTrans.Amount < 0)
            total -= $scope.registrations.cashTrans.Amount;
        return total === ($scope.registrations.Registration.FinalPrice + $scope.registrations.Registration.DonationAmount);
    }

    $scope.getMissingPaymentAmount = function () {
        var total = 0;
        $scope.registrations.Registration.ReceiptID.forEach(function (receipt) {
            if (receipt.PaymentType == 4 && receipt.ChecksData.length > 0 && Array.isArray(receipt.ChecksData))
                receipt.ChecksData.forEach(function (check) {
                    total += Number(check.CheckAmount);
                })
            else
                total += Number(receipt.Sum);
        })
        return Math.max(($scope.registrations.Registration.FinalPrice + $scope.registrations.Registration.DonationAmount) - total, 0);
    }

    $scope.addEmptyPayment = function () {
        $scope.registrations.Registration.ReceiptID.unshift({
            PaymentType: undefined,
            Sum: $scope.getMissingPaymentAmount(),
        });
        $scope.emptyPaymentAdded = true;
    }

    $scope.addExtraCharge = function () {
        var memberID;
        if (registration.StudentID)
            memberID = registration.StudentID;
        else if (registration.ParentID)
            memberID = registration.ParentID;
        else
            memberID = registration.UserID;
        studentsEndpoint.registrations.addExtraCharge.post(memberID, registration, function (data) {
            if (data.success) {
                Notification.success('חיוב בוצע בהצלחה');
                $mdDialog.hide();
            } else {
                Notification.error('התרחשה שגיאה');
            }
        })
    }

    $scope.addMonthlyPayment = function (monthlyChargeID) {
        $mdDialog.show({
            controller: 'NewMonthlyPaymentDialog',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/new-monthly-payment-dialog/new-monthly-payment-dialog.html',
            clickOutsideToClose: true,
            locals: {
                'registrations': [$scope.registrations.Registration],
                'RegistrationsMonthlyTransactionID': monthlyChargeID
            },
            multiple: true
        });
        /*if (appConfig.paymentCompany == 1) {
            tranzilaEndpoint.monthlyPayment.post(params, function (data) {
                if(data.successCount && data.successCount == 1)
                    $scope.getFullRegistration()
                else
                    Notification.error('עסקה נכשלה');
            });
        }
        else {
            pelecardEndpoint.monthlyPayment.post(params, function (data) {
                if(data.successCount && data.successCount == 1)
                    $scope.getFullRegistration()
                else
                    Notification.error('עסקה נכשלה');
            });
        }*/
    }

    $scope.removeMonthlyPayment = function (payment) {
        var confirm = $mdDialog.confirm()
            .title('מחיקת הוראת קבע')
            .textContent('האם אתה בטוח שברצונך למחוק את הוראת הקבע')
            .ok('אישור')
            .cancel('ביטול');
        $mdDialog.show(confirm).then(function () {
            payment.StudentID = $scope.registrations.Registration.StudentID;
            studentsEndpoint.registrations.monthlyChargeTransaction.delete(payment, function (data) {
                if (!data.success)
                    Notification.error('התרחשה שגיאה');
                else
                    Notification.success('הוראת קבע נמחקה בהצלחה');
            })
        });
    }

    $scope.setParent = function () {
        var payment = $scope.registrations.Registration.ReceiptID[0];
        payment.Name = payment.parent.Name;
        payment.Email = payment.parent.Email;
    };

    /**
     * Check the payment type
     */
    $scope.setPaymentType = function () {
        var payment = $scope.registrations.Registration.ReceiptID[0];
        $scope.changePaymentStatusByType(payment);
        if (payment.PaymentType == 3) {
            settingsEndpoint.accountancy.banks.get({EventID: $scope.registrations.Registration['EventID']}, function (data) {
                $scope.banks = data;
            })
        } else {
            if ([1, 11].indexOf(payment.PaymentType) != -1) {
                $scope.getIframe(payment);
                if (payment.interval)
                    $interval.cancel(payment.interval);
                payment.interval = $interval(function () {
                    if (!params) {
                        var params = {};
                        params.DealID = payment.DealID;
                    }
                    if ($scope.success) {
                        $interval.cancel(payment.interval);
                        return;
                    }
                    if (appConfig.paymentCompany == 1) {
                        tranzilaEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                } else {
                                    Notification.error("שגיאה");
                                    $scope.removeEmptyPayment();
                                }
                                $scope.getFullRegistration();
                                $interval.cancel(payment.interval);
                            }

                        })
                    } else {
                        pelecardEndpoint.valid.post(params, function (data) {
                            if (data) {
                                if (data.success) {
                                    Notification.success("עסקה בוצעה בהצלחה!");
                                } else {
                                    Notification.error("שגיאה");
                                    $scope.removeEmptyPayment();
                                }
                                $scope.getFullRegistration();
                                $interval.cancel(payment.interval);
                            }

                        })
                    }

                }, 4000);
            } else if (payment.interval)
                $interval.cancel(payment.interval);
        }

        if (payment.PaymentType === 4) {
            payment.ChecksData = [];
        }
    };

    /**
     * Get pelecrd iframe
     */
    $scope.getIframe = function (payment) {
        var params = {
            Amount: payment.Sum,
            RegistrationID: $scope.registrations.Registration.ID,
            Email: $scope.registrations.Registration.ReceiptID[0].Email,
            Name: $scope.registrations.Registration.ReceiptID[0].Name
        };
        if (appConfig.paymentCompany == 1) {
            if (payment.PaymentType == 1) {
                tranzilaEndpoint.get(params, function (data) {
                    payment.iframe = data.Iframe;
                    payment.DealID = data.DealID;
                });
            } else if (payment.PaymentType == 11) {
                tranzilaEndpoint.getJ5(params, function (data) {
                    payment.iframe = data.Iframe;
                    payment.DealID = data.DealID;
                });
            }
        } else {
            if (payment.PaymentType == 1) {
                pelecardEndpoint.get(params, function (data) {
                    payment.iframe = data.Iframe;
                    payment.DealID = data.DealID;
                });
            } else if (payment.PaymentType == 11) {
                pelecardEndpoint.getJ2(params, function (data) {
                    payment.iframe = data.Iframe;
                    payment.DealID = data.DealID;
                });
            }
        }
    };

    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    };

    $scope.savePayment = function (payment) {
        payment.StudentID = $scope.registrations.Registration.StudentID;
        payment.RegistrationID = $scope.registrations.Registration.ID;
        payment.Amount = payment.Sum;
        if (payment.PaymentType == 4)
            payment.ChecksData = JSON.stringify(payment.ChecksData);
        studentsEndpoint.registrations.payments.post(payment, function (data) {
            if (data.success) {
                Notification.success("עסקה בוצעה בהצלחה!");
            } else {
                Notification.error("שגיאה");
                $scope.emptyPaymentAdded = false;
            }
            $scope.getFullRegistration();
        })
    }

    $scope.removeEmptyPayment = function () {
        $scope.registrations.Registration.ReceiptID.pop();
        $scope.emptyPaymentAdded = false;
    }

    $scope.generateChecks = function () {
        var receipt = $scope.registrations.Registration.ReceiptID[0];
        receipt.ChecksData = [];
        for (var i = 0; i < receipt.NumberOfCheck; i++) {
            receipt.ChecksData.push({
                CheckNumber: undefined,
                CheckMaturityDate: undefined,
                CheckAmount: undefined,
            });
        }
    };

    $scope.swapEvent = function (ID) {
        $mdDialog.show({
            multiple: true,
            controller: 'SwapEventDialogController',
            templateUrl: 'app/main/pages/events/views/events/event-management/tabs/subscribers/swap-event-dialog/swap-event-dialog.html',
            clickOutsideToClose: true,
            locals: {
                'oldRegistrationID': $scope.registrations.Registration.ID,
                'eventID': $scope.eventID,
            }

        }).then(function (isSuccess) {
            if (isSuccess) {
                $scope.closeDialog();
            }
        });
    }

    function getParents() {
        studentsEndpoint.parent.get($scope.registrations.Registration.StudentID, function (data) {
            $scope.parents = data;
        });
    };

    $scope.approveRegistration = function () {
        registration.Selected = true;
        $mdDialog.show({
            controller: 'ApproveRegistrationsDialog',
            templateUrl: 'app/main/pages/events-dialogs/approve-registrations-dialog/approve-registrations-dialog.html',
            clickOutsideToClose: true,
            locals: {
                'registrations': [registration]
            }
        }).then(function () {
            $mdDialog.hide();
        });

    }
}

(function ()
{
    'use strict';

    angular
        .module('app.pages.new-admin', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider)
    {

        $stateProvider.state('app.pages_new-admin', {
            url      : '/new-admin',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin/new-admin/new-admin.html',
                    controller : 'NewAdminController'
                }
            },
            bodyClass: 'profile'
        });

    }

})();
angular.module('app.pages.new-admin').controller('NewAdminController', NewAdminController);
function NewAdminController($scope, $rootScope,$location,adminEndpoint,Notification,$timeout,appConfig,$cookies) {


    $scope.showHideText = 'הצג';
    $scope.inputType = 'password';
    $scope.showHideImg = "/assets/icons/show.svg";
    $scope.matchPasswords = false;
    $scope.matchFlags = true;
    $scope.password = '';
    $scope.passwordVerify = '';
    $scope.form = {};
    $scope.appConfig = appConfig;
    $scope.success = false;
    $scope.loading = false;
    $scope.errorInfo = "";

    /**
     * Valid the new admin request for register a new admin
     */
    $scope.validRequest = function () {
        var params = {};
        params.token =  $location.search().tempToken;
        adminEndpoint.new.valid.post(params,function (data) {
            if (data.ID) {
                $scope.form.email= data.Email;
                $scope.valid=true;
            }
            else{
                $location.path("/");
                $scope.notValid=true;
            }

        })
    };

    $scope.matchPass = function () {
        if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length > 5) {
            $scope.matchPasswords = true;
            $scope.matchFlags = true;
        } else if ($scope.form.password == $scope.passwordVerify && $scope.form.password.length < 6) {
            $scope.shortPass = true;
            $scope.matchFlags = true;
        } else {
            $scope.shortPass = false;
            $scope.matchPasswords = false;
            $scope.matchFlags = false;
        }
    }

    /**
     * Display or hide the password
     */
    $scope.showHidePassword = function () {
        if ($scope.inputType == "password") {
            $scope.inputType = "text";
            $scope.showHideText = 'הסתר';
            $scope.showHideImg = "/assets/icons/hide.svg";
        } else {
            $scope.inputType = "password";
            $scope.showHideText = 'הצג';
            $scope.showHideImg = "/assets/icons/show.svg";
        }

    };

    /**
     * Submit the new admin sing up
     */
    $scope.submit = function () {
        $scope.form.token = $location.search().tempToken;
        adminEndpoint.new.post($scope.form, function (data) {
            if (typeof data == 'string' || data instanceof String) {
                $scope.errorInfo = data;
                $scope.fail = true;
                $timeout(function () {
                    $scope.fail = false;
                }, 5000);
            }
            else if (data.ID) {
                $rootScope.User = data;
                setUserType();
                saveUser();
                $scope.success = true;
            }
            else
                $scope.errorInfo = "Error!";
            $scope.loading = true;
        })

    };

    /**
     * Set the admin type
     */
    function setUserType() {
        if ($rootScope.User.StudentID)
            $rootScope.AdminLevel = 1;
        else if ($rootScope.User.IsCoordinator)
            $rootScope.AdminLevel = 2;
        else
            $rootScope.AdminLevel = 3;
    }

    function saveUser() {
        var expireTime = +new Date() + (24 * 3600000);
        $cookies.put(appConfig.adminTokenName, $rootScope.User.AccessToken, [{expires: expireTime}]);
        $scope.loogin = false;
        $timeout(function () {
            if ($rootScope.AdminLevel !== 3)
                $location.path('/students');
            else
                $location.path('/dashboard');
        }, 250)
    }



    /**
     * href to login page
     */
    $scope.goToLogin = function () {
        $location.path("/");
    };

}

angular.module('app.pages.events').controller('ApproveRegistrationsDialog', ApproveRegistrationsDialog);

function ApproveRegistrationsDialog($scope, $rootScope, $mdDialog, registrations, eventsEndpoint, Notification,dtOptions,DTOptionsBuilder,msNavigationService) {
    $scope.isClicked = false;
    $scope.selectAll = true;
    $scope.registrations = registrations;
    $scope.actions = {
        ExtraCharge: 1,
        RequiredEvents: 1
    }

    $scope.approveRegistrations = function (){
        $scope.isClicked = true;
        var registrations = $scope.registrations.filter(function (el){return el.Selected}).map(function(el){return el.ID});
        var params = {
            Registrations: registrations,
            Actions: $scope.actions
        }
        eventsEndpoint.registrations.approve.post(params,function (data){
            if(data.success){
                Notification.success('הרשמות אושרו בהצלחה');
                $mdDialog.hide();
                eventsEndpoint.registrations.approve.amount.get(function (data){
                    msNavigationService.getActiveItem().node.badge.content = data.Count;
                })
            }
            else {
                Notification.error('התרחשה שגיאה');
                $mdDialog.cancel();
            }
            $scope.isClicked = false;
        })
    }

    $scope.setAll = function (){
        $scope.registrations.forEach(function (reg){
            reg.Selected = $scope.selectAll;
        })
    }

    $scope.getMemberName = function (reg){

        if(reg.MemberName && reg.MemberName.length > 0)
            return reg.MemberName;
        else
            return reg.FirstName+' '+reg.LastName;
    }

    $scope.getSelectedAmount = function (){
        return $scope.registrations.filter(function (el){return el.Selected}).length
    }

    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', false)
        .withDOM('lrtip')

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };
}

(function ()
{
    'use strict';

    angular.module('app.pages.admin-profile', []).config(config);


    /** @ngInject */
    function config($stateProvider)
    {

        $stateProvider.state('app.pages_admin-profile', {
            url      : '/admin-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin/admin-profile/admin-profile.html',
                    controller : 'AdminProfileController'
                }
            },
            resolve: {
                DashboardData: function (ValidToken) {
                    ValidToken.validUserToken();
                    localStorage.setItem("path", '/admin-profile');
                }
            },
            bodyClass: 'profile'
        });

    }

})();

angular.module('app.pages.admin-profile').controller('AdminProfileController', AdminProfileController);
function AdminProfileController($scope, $rootScope,$location,adminEndpoint,Notification) {


    if (!$rootScope.User)
        $location.path('/dashboard');

    $scope.goodFile = true;

    /**************************************************************** EDIT FUNCTIONS START ****************************************************************/
    /**
     * Update admin
     */
    $scope.editAdmin = function () {
        $scope.isClicked = true;
        var params = {
            ID: $rootScope.User.ID,
            FirstName: $rootScope.User.FirstName,
            LastName: $rootScope.User.LastName,
            Email: $rootScope.User.Email,
            Image: $rootScope.User.ProfileImage
        };
        adminEndpoint.update.post($rootScope.User.ID, params, function (data) {
            $scope.isClicked = false;
            if (!data.success)
                Notification.error("נכשל בשמירת נתונים");
            else
                Notification.success("פרופיל עודכן בהצלחה!");
        })
    };

    /**
     * Check file size
     */
    $scope.checkSize = function (file) {
        var image = file;
        if (image && image.name) {
            var size = image.size / 1024;
            if (!image.type.includes('image')) {
                Notification.info("הקובץ חייב להיות תמונה");
                image.value = "";
                $rootScope.User.ProfileImage = null;
                $scope.goodFile = false;
            }
            if (size > 2000) {
                Notification.info("גודל קובץ מקסימלי - 2MB");
                image.value = "";
                $rootScope.User.ProfileImage = null;
                $scope.goodFile = false;
            } else {
                if (image && image.name) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        $rootScope.User.ProfileImage = e.target.result;
                    }
                    reader.readAsDataURL(image);
                    $scope.goodFile = true;
                    var fakeInput = document.getElementById('fake-input');
                    fakeInput.innerHTML = image.name;
                }
            }
        }
    };

    /**
     * Update the admin password
     */
    $scope.updatePassword = function () {
        var params = {
            ID: $rootScope.User.ID,
            oldPass: $rootScope.User.oldPassword,
            newPass: $rootScope.User.newPassword
        };
        adminEndpoint.password.post($rootScope.User.ID, params, function (data) {
            $scope.isClicked = false;
            if (data == 'nomatch')
                Notification.error("הסיסמא הנוכחית שהזנת - שגויה");
            else if (!data.success)
                Notification.error("נכשל בשמירת נתונים");
            else {
                $rootScope.User.oldPassword = '';
                $rootScope.User.newPassword = '';
                $rootScope.User.newPasswordConfirmation = '';
                Notification.success("סיסמא עודכנה בהצלחה!");
            }
        })
    };
    /**************************************************************** EDIT FUNCTIONS END ****************************************************************/

}

angular.module('app.pages.manage-admins').controller('ManageAdminsController', ManageAdminsController );
function ManageAdminsController($scope,$mdSidenav,$mdDialog,adminEndpoint, $document,adminProfile,Notification,DTOptionsBuilder,dtOptions) {


    $scope.admins = [];
    /**
     * Resent invasions  to admin
     * @param admin
     */
    $scope.sendAgain = function (admin) {
        adminEndpoint.post(admin, function (data) {
            if (data.ID)
                Notification.success("הזמנה נשלחה בהצלחה");
            else
                Notification.error("נכשל בשליחת הזמנה");

        })
    };


    /**
     * Get all admins
     */
    $scope.getAdmins = function () {
        $scope.admins = false;
        adminEndpoint.get($scope.search, function (data) {
            if (data)
                $scope.admins = data;
        });

    };

    /**
     * Open new user dialog
     * @param ev
     */
    $scope.openNewAdminUserDialog = function (ev) {
        $mdDialog.show({
            controller: 'NewAdminDialogController',
            controllerAs: '$scope',
            templateUrl: 'app/main/pages/admin/admin-management/new-admin-dialog/new-admin-dialog.html',
            parent: angular.element($document.find('#content-container')),
        }).then(function () {
            $scope.getAdmins();
        });
    };

    /**
     * Edit Admin Profile
     */
    $scope.editAdminProfile = function (selectedAdmin) {
        adminProfile.updateAdminProfile(selectedAdmin);
        $mdSidenav("admin-profile-panel").open();
    };


    /**
     * Change admin Status
     * @param admin
     */
    $scope.changeAdminStatus = function (admin) {
        statusSwitch(admin);
        adminEndpoint.update.post(admin.ID, admin, function (data) {
            if (!data.success)
                Notification.error('נכשל בעדכון')
        })
    };

    /**
     * Change the status online
     * @param admin
     */
    var statusSwitch = function (admin) {
        admin.Status = admin.Status === 1 ? 0 : 1;
    };

    /**
     * Set Table option
     * @type {any}
     */
    $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withOption('responsive', true)
        .withDOM('lrtip');


}
(function ()
{
    'use strict';

    angular
        .module('app.dashboard',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config).run(run);

    function run($rootScope,msNavigationService) {

        /**
         * Set the pages by the admin level
         */
        $rootScope.$watch('User',function () {

            if ($rootScope.AdminLevel) {

                switch ($rootScope.AdminLevel) {
                    case 1:
                        msNavigationService.deleteItem('apps');
                        break;
                    case 2:
                        msNavigationService.deleteItem('apps');
                        break;

                }

            }

        });

    }

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dashboard', {
            url      : '/dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/dashboard');
                }
            },
            bodyClass: 'dashboard'
        });
        msNavigationServiceProvider.saveItem('apps', {
            title: 'סטטיסטיקות',
            icon  : 'icon-tile-four',
            state: 'app.dashboard',
            quickstate: 'app.dashboard',
            weight: 1
        });

    }

})();

angular.module('app.dashboard').controller('NewUpdatesDialogController',NewUpdatesDialogController);
function NewUpdatesDialogController($scope, $rootScope, $mdDialog,$timeout) {

    $scope.disable = true;
    $timeout(function () {
        $scope.disable = false;
    },10000);

    /**
     * Close the dialog
     */
    $scope.closeDialog = function () {
        $mdDialog.cancel();
    };

}

(function ()
{
    'use strict';

    angular
        .module('app.ui.typography', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_typography', {
            url      : '/ui/typography',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/typography/typography.html',
                    controller : 'TypographyController as vm'
                }
            },
            bodyClass: 'typography'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography')
        .controller('TypographyController', TypographyController);

    /** @ngInject */
    function TypographyController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('ThemeColorsController', ThemeColorsController);

    /** @ngInject */
    function ThemeColorsController(marvilixTheming, $mdDialog, $document)
    {
        var vm = this;
        // Data
        vm.themes = marvilixTheming.themes;

        // Methods
        vm.createTheme = createTheme;
        //////////

        function createTheme(ev)
        {
            $mdDialog.show({
                controller         : 'CustomThemeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.icons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.ui_icons', {
            url      : '/ui/icons',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/icons/icons.html',
                    controller : 'IconsController as vm'
                }
            },
            resolve  : {
                Icons: function (msApi)
                {
                    return msApi.resolve('icons@get');
                }
            },
            bodyClass: 'icons'
        });

        // Api
        msApiProvider.register('icons', ['assets/icons/selection.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons')
        .controller('IconsController', IconsController);

    /** @ngInject */
    function IconsController(Icons)
    {
        var vm = this;

        // Data
        vm.icons = Icons.icons;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_material-colors', {
            url  : '/ui/material-colors',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/material-colors/material-colors.html',
                    controller : 'MaterialColorsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors')
        .controller('MaterialColorsController', MaterialColorsController);

    /** @ngInject */
    function MaterialColorsController($mdColorPalette)
    {
        var vm = this;

        // Data
        vm.palettes = $mdColorPalette;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_forms', {
            url      : '/ui/forms',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/forms/forms.html',
                    controller : 'FormsController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms')
        .controller('FormsController', FormsController);

    /** @ngInject */
    function FormsController($mdDialog)
    {
        var vm = this;

        // Data
        vm.horizontalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.verticalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.basicForm = {};
        vm.formWizard = {};
        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
        'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
        'WY').split(' ').map(function (state)
        {
            return {abbrev: state};
        });

        // Methods
        vm.sendForm = sendForm;
        vm.showDataDialog = showDataDialog;
        vm.submitHorizontalStepper = submitHorizontalStepper;
        vm.submitVerticalStepper = submitVerticalStepper;

        //////////

        /**
         * Submit horizontal stepper data
         * @param event
         */
        function submitHorizontalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.horizontalStepper);

            // Reset the form model
            vm.horizontalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit vertical stepper data
         *
         * @param event
         */
        function submitVerticalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.verticalStepper);

            // Reset the form model
            vm.verticalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */
        function showDataDialog(ev, data)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: data
                },
                clickOutsideToClose: true
            });
        }

        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });

            // Clear the form data
            vm.formWizard = {};
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_helper-classes', {
            url      : '/ui/helper-classes',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/helper-classes/helper-classes.html',
                    controller : 'HelperClassesController as vm'
                }
            },
            bodyClass: 'helper-classes'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes')
        .controller('HelperClassesController', HelperClassesController);

    /** @ngInject */
    function HelperClassesController()
    {
        // Data

        // Methods

        //////////
    }
})();



angular.module('app.core').service('transportation', function($rootScope) {

    this.updateSelectedTransportation = function (selectedTransportation) {
        this.selectedTransportation = selectedTransportation;
        $rootScope.$broadcast('selectedTransportation:updated',selectedTransportation);
    };
});

angular.module('app.core').service('student', function($rootScope) {

    this.updateSelectedStudent = function (selectedStudent) {
        this.selectedStudent = selectedStudent;
        $rootScope.$broadcast('selectedStudent:updated',selectedStudent);
    };
});

angular.module('app.core').service('settlement', function($rootScope) {

    this.updateSelectedSettlement = function (selectedSettlement) {
        this.selectedSettlement = selectedSettlement;
        $rootScope.$broadcast('selectedSettlement:updated',selectedSettlement);
    };
});

angular.module('app.core').service('question', function($rootScope) {

    this.updateSelectedQuestion = function (selectedQuestion) {
        this.selectedQuestion = selectedQuestion;
        $rootScope.$broadcast('selectedQuestion:updated',selectedQuestion);
    };
});

angular.module('app.core').service('parent', function($rootScope) {

    this.updateSelectedParent = function (selectedParent) {
        this.selectedParent = selectedParent;
        $rootScope.$broadcast('selectedParent:updated',selectedParent);
    };
});

angular.module('app.core').service('group', function($rootScope) {

    this.updateSelectedGroup = function (selectedGroup) {
        this.selectedGroup = selectedGroup;
        $rootScope.$broadcast('selectedGroup:updated',selectedGroup);
    };
});

angular.module('app.core').service('grade', function($rootScope) {

    this.updateSelectedGrade = function (selectedGrade) {
        this.selectedGrade = selectedGrade;
        $rootScope.$broadcast('selectedGrade:updated',selectedGrade);
    };
});

angular.module('app.core').service('generalDiscount', function($rootScope) {

    this.updateSelectedGeneralDiscount = function (selectedGeneralDiscount) {
        this.selectedGeneralDiscount = selectedGeneralDiscount;
        $rootScope.$broadcast('selectedGeneralDiscount:updated',selectedGeneralDiscount);
    };
    this.isSave = function (value) {
        $rootScope.$broadcast('isSave:updated',value);
    }
});

angular.module('app.core').service('extraField', function($rootScope) {

    this.updateSelectedField = function (selectedField) {
        this.selectedField = selectedField;
        $rootScope.$broadcast('selectedField:updated',selectedField);
    };
});

angular.module('app.core').service('eventQuestion', function($rootScope) {

    this.updateSelectedEventQuestion = function (selectedEventQuestion) {
        this.selectedEventQuestion = selectedEventQuestion;
        $rootScope.$broadcast('selectedEventQuestion:updated',selectedEventQuestion);
    };
});

angular.module('app.core').service('eventMeeting', function($rootScope) {

    this.updateSelectedMeeting = function (selectedMeeting) {
        this.selectedMeeting = selectedMeeting;
        $rootScope.$broadcast('selectedMeeting:updated',selectedMeeting);
    };
});

angular.module('app.core').service('event', function ($rootScope) {


    this.updateSelectedEvent = function (selectedEvent) {
        this.selectedEvent = Object.assign({}, selectedEvent);
        delete this.selectedEvent.location;
        $rootScope.$broadcast('selectedEvent:updated', selectedEvent);
    };
    this.levhasharonMap = {
        Events: {
            name: 'Events',
            pluralTitle: 'אירועי נוער',
            singleTitle: 'אירוע נוער',
            sittingPlaces: true,
            external: true,
            monthlyPayment: false,
            memberEvents: true,
            masterCategoryID: 1,
            healthDeclaration: true,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        Products: {
            name: 'Products',
            pluralTitle: 'מוצרים',
            singleTitle: 'מוצר',
            sittingPlaces: false,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 2,
            healthDeclaration: false,
            isProduct: true,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        SummerCamps: {
            name: 'SummerCamps',
            pluralTitle: 'קייטנות',
            singleTitle: 'קייטנה',
            sittingPlaces: true,
            external: false,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 3,
            healthDeclaration: true,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        Kindergarten: {
            name: 'Kindergarten',
            pluralTitle: 'מעונות וצהרונים',
            singleTitle: 'מעון/ צהרון',
            sittingPlaces: false,
            external: false,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 5,
            healthDeclaration: true,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        LeisureAndAfterSchool: {
            name: 'LeisureAndAfterSchool',
            pluralTitle: 'אירועי פנאי וחוגים',
            singleTitle: 'אירוע פנאי/ חוג',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 4,
            healthDeclaration: true,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        InternalEvents: {
            name: 'InternalEvents',
            pluralTitle: 'מועצה פנימי',
            singleTitle: 'מועצה פנימי',
            sittingPlaces: false,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 6,
            healthDeclaration: false,
            eventDates: false,
            registrationDates: false,
            defaultEventTypeSearch: 1,
            fastRegistrationEnables: true
        },
        ReligiousServices: {
            name: 'ReligiousServices',
            pluralTitle: 'שירותי דת ותרבות יהודית',
            singleTitle: 'שירותי דת ותרבות יהודית',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 7,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        GoldenAge: {
            name: 'GoldenAge',
            pluralTitle: 'הגיל השלישי',
            singleTitle: 'הגיל השלישי',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 8,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        Tourism: {
            name: 'Tourism',
            pluralTitle: 'תיירות',
            singleTitle: 'תיירות',
            sittingPlaces: true,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 133,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        CommunitySecurity: {
            name: 'CommunitySecurity',
            pluralTitle: 'ביטחון קהילתי',
            singleTitle: 'ביטחון קהילתי',
            sittingPlaces: true,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 134,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        }, Psychology: {
            name: 'Psychology',
            pluralTitle: 'שירות פסיכולוגי',
            singleTitle: 'שירות פסיכולוגי',
            sittingPlaces: false,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 11,
            healthDeclaration: false,
            isProduct: true,
            registrationDates: true,
            eventDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: true
        }
    };
    this.megidoMap = {
        Sports: {
            name: 'Sports',
            pluralTitle: 'ספורט',
            singleTitle: 'ספורט',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 1,
            healthDeclaration: true,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        Gilor: {
            name: 'Gilor',
            pluralTitle: 'גילאור',
            singleTitle: 'גילאור',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 2,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        Education: {
            name: 'Education',
            pluralTitle: 'חינוך',
            singleTitle: 'חינוך',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 3,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        Library: {
            name: 'Library',
            pluralTitle: 'ספרייה',
            singleTitle: 'ספרייה',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 4,
            healthDeclaration: true,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        Reut: {
            name: 'Reut',
            pluralTitle: 'רעות',
            singleTitle: 'רעות',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 5,
            healthDeclaration: true,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        MusicAndDance: {
            name: 'MusicAndDance',
            pluralTitle: 'מוזיקה ומחול',
            singleTitle: 'מוזיקה ומחול',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 6,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false

        },
        MegidoTech: {
            name: 'MegidoTech',
            pluralTitle: 'מגידוטק',
            singleTitle: 'מגידוטק',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 7,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        YouthCenter: {
            name: 'YouthCenter',
            pluralTitle: 'מרכז צעירים',
            singleTitle: 'מרכז צעירים',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 8,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        InternalCouncil: {
            name: 'InternalCouncil',
            pluralTitle: 'מועצה פנימי',
            singleTitle: 'מועצה פנימי',
            sittingPlaces: false,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 9,
            healthDeclaration: false,
            eventDates: false,
            registrationDates: false,
            defaultEventTypeSearch: 1,
            fastRegistrationEnables: true
        },
        Products: {
            name: 'Products',
            pluralTitle: 'מוצרים',
            singleTitle: 'מוצרים',
            sittingPlaces: false,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 10,
            healthDeclaration: false,
            isProduct: true,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false


        }

    };
    this.izraelMap = {
        Omanut: {
            name: 'Omanut',
            pluralTitle: 'בית האומנויות',
            singleTitle: 'בית האומנויות',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 51,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        Education: {
            name: 'Education',
            pluralTitle: 'אגף החינוך',
            singleTitle: 'אגף החינוך',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 50,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        },
        Sports: {
            name: 'Sports',
            pluralTitle: 'ספורט',
            singleTitle: 'ספורט',
            sittingPlaces: true,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 1,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        }, Catedra: {
            name: 'Catedra',
            pluralTitle: 'קתדרה',
            singleTitle: 'קתדרה',
            sittingPlaces: false,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 34,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        }, YouthAndScholarship: {
            name: 'YouthAndScholarship',
            pluralTitle: 'צעירים ומלגות',
            singleTitle: 'צעירים ומלגות',
            sittingPlaces: false,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 35,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        }, Yeshuvim: {
            name: 'Yeshuvim',
            pluralTitle: 'יישובים',
            singleTitle: 'יישובים',
            sittingPlaces: false,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 42,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        }, KidsAndYouth: {
            name: 'KidsAndYouth',
            pluralTitle: 'ילדים ונוער',
            singleTitle: 'ילדים ונוער',
            sittingPlaces: false,
            external: false,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 43,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        }, Revaha: {
            name: 'Revaha',
            pluralTitle: 'רווחה',
            singleTitle: 'רווחה',
            sittingPlaces: false,
            external: true,
            monthlyPayment: true,
            memberEvents: false,
            masterCategoryID: 56,
            healthDeclaration: false,
            eventDates: true,
            registrationDates: true,
            defaultEventTypeSearch: 0,
            fastRegistrationEnables: false
        }, RevachaPnimi: {
            name: 'RevachaPnimi',
            pluralTitle: 'רווחה פנימי',
            singleTitle: 'רווחה פנימי',
            sittingPlaces: false,
            external: true,
            monthlyPayment: false,
            memberEvents: false,
            masterCategoryID: 57,
            healthDeclaration: false,
            eventDates: false,
            registrationDates: false,
            defaultEventTypeSearch: 1,
            fastRegistrationEnables: true
        }
    };
    var mapName = $rootScope.brandName + 'Map';
    this.modulesMap = this[mapName];

    this.setActiveModule = function (module) {
        if (isNaN(module)) {
            this.activeModule = this.modulesMap[module];
        } else {
            this.activeModule = this.modulesMap.find(function (module) {

                return module.masterCategoryID == module;
            })
        }
        localStorage.setItem("activeModule", JSON.stringify(this.activeModule));
    }

    this.getActiveModule = function () {
        // if (this.activeModule)
        //     return this.activeModule;
        var jsonStr = localStorage.getItem('activeModule');
        var storageActiveModule = jsonStr && jsonStr !== 'undefined' ? JSON.parse(jsonStr) : null;
        if (storageActiveModule) {
            this.setActiveModule(storageActiveModule.name);
            return this.activeModule;
        } else {
            this.fixActiveModule();
            return this.activeModule;
        }
        return false;
    }

    this.fixActiveModule = function () {
        var arr = Object.values(this.modulesMap);
        this.setActiveModule(arr[0].name);
        // var path = window.location.pathname.toString().toLowerCase();
        // var search = window.location.search.toString().toLowerCase();
        // var regex = /ID=\d+/;
        // switch (path){
        //     case '/event-management':
        //         if(regex.test(search)){
        //             this.getTheModuleName();
        //         }
        //         this.activeModule = this.modulesMap['Events'];
        //         break;
        // }

    }
});

angular.module('app.core').service('coordinate', function($rootScope) {

    this.updateSelectedCoordinate = function (selectedCoordinate) {
        this.selectedCoordinate = selectedCoordinate;
        $rootScope.$broadcast('selectedCoordinate:updated',selectedCoordinate);
    };
});

angular.module('app.core').service('contact', function($rootScope) {

    this.updateSelectedContact = function (selectedContact,groups) {
        this.groups = groups;
        this.selectedContact = selectedContact;
        $rootScope.$broadcast('selectedContact:updated',selectedContact);
    };
});

angular.module('app.core').service('category', function($rootScope) {

    this.updateSelectedCategory = function (selectedCategory) {
        this.selectedCategory = selectedCategory;
        $rootScope.$broadcast('selectedCategory:updated',selectedCategory);
    };
});

angular.module('app.core').service('branch', function($rootScope) {

    this.updateSelectedBranch = function (selectedBranch) {
        this.selectedBranch = selectedBranch;
        $rootScope.$broadcast('selectedBranch:updated',selectedBranch);
    };
});

angular.module('app.core').service('area', function($rootScope) {

    this.updateSelectedArea = function (selectedArea) {
        this.selectedArea = selectedArea;
        $rootScope.$broadcast('selectedArea:updated',selectedArea);
    };
});

angular.module('app.core').service('adminProfile', function($rootScope) {

    this.updateAdminProfile = function (adminProfile) {
        this.admin = adminProfile;
        $rootScope.$broadcast('adminProfile:updated',adminProfile);
    };
});

angular.module('app.core').service('activities', function($rootScope) {

    this.updateSelectedActivities = function (selectedActivities) {
        this.selectedActivities = selectedActivities;
        $rootScope.$broadcast('selectedActivities:updated',selectedActivities);
    };
});

(function ()
{
    'use strict';

    angular.module('app.save-changes',[])

})();

angular.module('app.save-changes').controller('SaveChangesController', ['$scope', '$rootScope', '$mdSidenav', '$mdDialog', '$location', '$timeout', 'Notification', 'event', 'studentsEndpoint', 'contactsEndpoint', 'parentsEndpoint', 'groupsEndpoint', 'gradesEndpoint', 'coordinatorsEndpoint', 'questionsEndpoint', 'eventsEndpoint', 'transportationEndpoint', 'activitiesEndpoint', 'generalDiscount', 'adminEndpoint', 'systemSettingsEndpoint','settingsEndpoint', 'settlementsEndpoint', 'locationsEndpoint',
    function ($scope, $rootScope, $mdSidenav, $mdDialog, $location, $timeout, Notification, event, studentsEndpoint, contactsEndpoint, parentsEndpoint, groupsEndpoint, gradesEndpoint, coordinatorsEndpoint, questionsEndpoint, eventsEndpoint, transportationEndpoint, activitiesEndpoint, generalDiscount, adminEndpoint, systemSettingsEndpoint,settingsEndpoint, settlementsEndpoint, locationsEndpoint) {

        /**
         * Save edit of Enter key
         */
        var closeByEsc = function () {
            var bodyElement = angular.element('body');
            bodyElement.on('keyup keypress keydown', function (e) {
                if (e.keyCode === 27) {
                    $scope.closeWithOutSaving();
                }
            });
        };

        /**
         * Save edit of Enter key
         */
        var saveOnEnter = function () {
            //if (angular.element('#'+$scope.view).length ) {
            var input = angular.element("#" + $scope.view + " input");
            input.keypress(function (e) {
                if (e.keyCode === 13) {
                    $scope.editObject();
                }
            });
            // }
        };

        /**
         * Check for change in the location.
         * If page was change close the current side nev
         */
        $rootScope.$on("$locationChangeStart", function () {
            var url = $location.url();
            if (!$rootScope.location)
                $rootScope.location = url;
            if ($rootScope.location !== url) {
                $rootScope.location = url;
                try {
                    if (angular.element('#' + $scope.view).length)
                        $mdSidenav($scope.view).close();
                } catch (e) {
                    console.info(e);
                }

            }
        });

        $scope.$watch('values', function () {
            if ($scope.values.length === 0 && $scope.view) {
                $scope.toggleSaveChangesPanel('close');
                $scope.disableSideBar.removeClass('active');
                $scope.disabletoolBar.removeClass('active');
                $rootScope.isEdit = false;
            }
        });


        /**
         * Toggle save changes panel
         * @param state
         */
        $scope.toggleSaveChangesPanel = function (state) {
            if (state === 'open') {
                angular.element('md-sidenav-bottom').removeClass('md-closed');
            } else {
                angular.element('md-sidenav-bottom').addClass('md-closed');
            }
        };

        /**
         * Handel Edit Data of Object|Array
         * @param newValue Object|Array the new Values of the object|Array
         * @param oldValue Object|Array the old Values of the object|Array
         * @param view string the current view or state
         * @param overwrite boolean true for overwrite the originalObject
         */
        $rootScope.editDataHandler = function (newValue, oldValue, view, overwrite) {
            // true for overwrite the originalObject
            if (overwrite) {
                $scope.originalObject = newValue;
                return;
            }
            //First Check of Handler
            firstDataHandler(newValue, oldValue, view);
            //check if its a new user
            if (oldValue && newValue) {
                if (newValue.id != oldValue.id || newValue.ID != oldValue.ID) {
                    $scope.changed = false;
                    return;
                }
                //compere the new user values and the old user values
                checkForChanges(newValue, $scope.originalObject);
                //end the handler
                $timeout(function () {
                    endHandler();
                }, 350)
            }
        };

        /**
         * Last handler of Data handler
         */
        function endHandler() {
            //check if there is a $$hashKey value in the array
            if ($scope.values[$scope.values.length - 1] === "$$hashKey") {
                $scope.values.pop()
            }
            //check for Ignore Fields
            $scope.values = $scope.values.filter(onlyUnique)
            checkForIgnoreFields();
            $timeout(function () {
                //if there is values in the values array open the saveChange Panel
                if ($scope.values.length > 0) {
                    if (!$scope.changed || $scope.closes) {
                        $rootScope.isEdit = true;
                        $scope.disableSideBar.addClass('active');
                        $scope.disabletoolBar.addClass('active');

                        $scope.toggleSaveChangesPanel('open');
                        //set close by esc
                        closeByEsc()
                    }
                    $scope.changed = true;
                }
                //if there is no value in the values array close the panel
                else {
                    $rootScope.isEdit = false;

                    $scope.toggleSaveChangesPanel('close');
                    $scope.disableSideBar.removeClass('active');
                    $scope.disabletoolBar.removeClass('active');

                }
            }, 200)

        }

        /**
         * Reset the Data Handler and set the default values
         * @param newValue object|array
         * @param oldValue object|array
         * @param view string view
         */
        function firstDataHandler(newValue, oldValue, view) {

            //check if its a new Object
            if (oldValue && newValue)
                if (newValue.ID != oldValue.ID)
                    return;

            //reset the originalObject if the view was changed
            if ($scope.view)
                if ($scope.view !== view)
                    $scope.originalObject = null;

            //reset params
            $scope.view = view;
            $scope.newValue = newValue;
            $scope.values = [];

            //check if the original User is saved
            if ((!$scope.originalObject || Object.keys($scope.originalObject).length === 0) && oldValue)
                $scope.originalObject = angular.copy(oldValue);

            //check if its a new originalObject
            else if ($scope.originalObject && oldValue)
                if ($scope.originalObject.ID != oldValue.ID)
                    $scope.originalObject = angular.copy(oldValue);

            //get the vertical-navigation element
            $scope.disableSideBar = angular.element(document.querySelector('#vertical-navigation'));
            $scope.disabletoolBar = angular.element(document.querySelector('#toolbar'));
            //disableSideBar
            angular.element('md-backdrop').click(function () {
                $mdSidenav(view).open();
            });
            //set default save on enter
            saveOnEnter();
        }

        /**
         * Check for changes in the
         * @param newValue
         * @param originalObject
         */
        function checkForChanges(newValue, originalObject) {
            //Run over the new value and camper him to the original Object
            angular.forEach(newValue, function (value, key) {
                if (key == 'location')
                    return;
                //check if the key is birthday to fix birthdays that are not in proper format.
                if (key == "Birthday" && originalObject[key] != null && originalObject[key] != "undefined") {
                    var split = originalObject[key].split("/");
                    split.forEach(function (val, i) {
                        if (val.length < 2) {
                            split[i] = "0" + val;
                        }
                    });
                    originalObject[key] = split.join("/");
                    split = newValue[key].split("/");
                    split.forEach(function (val, i) {
                        if (val.length < 2) {
                            split[i] = "0" + val;
                        }
                    });
                    newValue[key] = split.join("/");
                }
                //camper the values in the object - case for type object
                if (newValue[key] != originalObject[key] && typeof newValue[key] !== 'object' && typeof newValue[key] != "undefined") {

                    if (key !== "$$hashKey") {
                        if (location.hostname === "localhost")
                            console.log('Change Detector: ' + key);
                        $scope.values.push(key);
                        $scope.closes = true;
                    }
                }
                //in case that the array length in equals, run over the object/array
                else {
                    if (newValue != undefined && newValue[key] != undefined && originalObject != undefined && originalObject[key] != undefined && isArray(newValue[key]) && newValue[key].length != originalObject[key].length) {
                        if (location.hostname === "localhost") {
                            console.log('Change Detector: ' + key);
                        }
                        $scope.values.push(key);
                        $scope.closes = true;
                    } else
                        angular.forEach(newValue[key], function (objectValue, objectKey) {
                            //check for changes in the objectValue
                            if ((newValue[key] && originalObject[key]) && !angular.equals(newValue[key][objectKey], originalObject[key][objectKey]) && objectKey !== '$$hashKey' && objectKey !== "$$mdSelectId") {
                                //if there is some changes check if the value is array
                                if (isArray(newValue[key][objectKey]) && isArray(originalObject[key][objectKey])) {
                                    //if the vale is object check for changes in the length.
                                    if (newValue[key][objectKey].length !== originalObject[key][objectKey].length) {
                                        //if the object length is changed, get tha different between the the originalObject and the new value
                                        //and add the amount to the values array
                                        var numberOfChangeObjects = Math.abs(Object.keys(newValue[key][objectKey]).length - Object.keys(originalObject[key][objectKey]).length);
                                        for (var i = 0; i < numberOfChangeObjects; i++) {
                                            if (location.hostname === "localhost")
                                                console.log('Change Detector: ' + objectKey);
                                            $scope.values.push(objectKey);
                                        }
                                    } else {
                                        //if the object length is not changed,run over the function
                                        checkForChanges(newValue[key][objectKey], originalObject[key][objectKey]);
                                    }
                                } else {
                                    //if its not array and not object add the value to the values array.
                                    if (location.hostname === "localhost")
                                        console.log('Change Detector: ' + key);
                                    $scope.values.push(key);
                                    $scope.closes = true;
                                }

                            }
                        })
                }

            });
        }

        /**
         * Check if object is array
         * @param obj object|array
         * @returns {boolean} true if its n array
         */
        function isArray(obj) {
            var type = Object.prototype.toString.call(obj)
            return type === "[object Array]";
        }

        /**
         * Ignore Fields for values array
         */
        function checkForIgnoreFields() {

            var ignoreArray = ['GroupName', 'EducatorGroupName', 'GradeName', 'CreateTime',
                'CreatedTime', 'EducatorsCreatedTime', 'ParentID', "EducatorID", "EducatorGroupID"
                , 'Selected'];
            var index = -1;
            for (var i = 0; i < ignoreArray.length; i++) {
                index = $scope.values.indexOf(ignoreArray[i]);
                if (index > -1) {
                    $scope.values.splice(index, 1);
                }
            }


        }

        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }

        /**
         * Close the edit without saving
         */
        $scope.closeWithOutSaving = function () {
            $scope.closes = true;
            $scope.values = [];
            $rootScope.isEdit = false;
            //if it is the same object run over and overwrite the object
            if ($scope.originalObject)
                if ($scope.newValue.ID == $scope.originalObject.ID)
                    angular.forEach($scope.newValue, function (value, key) {
                        $scope.newValue[key] = $scope.originalObject[key]
                    });

            //close the panel after originalObject has ben overwrite
            $timeout(function () {
                $scope.originalObject = null;
                $mdSidenav($scope.view).close();
                $scope.toggleSaveChangesPanel('close');
                $scope.disabletoolBar = angular.element(document.querySelector('#toolbar'));
                $scope.disableSideBar = angular.element(document.querySelector('#vertical-navigation'));
                $scope.disabletoolBar.removeClass('active');
                $scope.disableSideBar.removeClass('active');
            }, 350)

        };

        /**
         * Close from X button
         */
        $rootScope.closePanel = function () {
            if ($scope.values.length > 0)
                confirmCloseWithOutSavingPopUp();
            else
                $scope.closeWithOutSaving();
        };

        /**
         * Alert the user that the changes will be overwrite
         * @param ev
         */
        function confirmCloseWithOutSavingPopUp(ev) {
            var confirm = $mdDialog.confirm()
                .title('ביטול שינויים')
                .textContent('האם אתה בטוח/ה שברצונך לצאת ללא שמירה?')
                .targetEvent(ev)
                .ok('צא ללא שמירה')
                .cancel('ביטול');
            $mdDialog.show(confirm).then(function () {
                $scope.closeWithOutSaving();
            });
        }

        /**
         * Edit the object by sending post request
         */
        $scope.editObject = function () {
            $scope.values = [];
            $scope.changed = false;
            $scope.closes = false;
            $scope.originalObject = false;
            $rootScope.isEdit = false;
            routSavingChanges();
            $scope.disabletoolBar.removeClass('active');
            $scope.disableSideBar.removeClass('active');
            $scope.toggleSaveChangesPanel('close');
            //if (angular.element('#'+$scope.view).length )
            $mdSidenav($scope.view).close();


        };

        /**
         * Route the saving of the object
         */
        function routSavingChanges() {
            switch ($scope.view) {
                case "accountancy-panel":
                    updateAccountancy();
                    break;
                case "student-panel":
                    updateStudent();
                    break;
                case "student-profile":
                    updateStudent();
                    break;
                case "parent-panel":
                    updateParent();
                    break;
                case "parent-profile":
                    updateParent();
                    break;
                case "groups-panel":
                    updateGroup();
                    break;
                case "grades-panel":
                    updateGrade();
                    break;
                case "coordinate-panel":
                    updateCoordinator();
                    break;
                case  "coordinator-profile":
                    updateCoordinator();
                    break;
                case "question-panel":
                    updateQuestion();
                    break;
                case "category-panel":
                    updateCategory();
                    break;
                case "location-panel":
                    updateLocation();
                    break;
                case "event-panel":
                    updateEvent();
                    break;
                case "event-management":
                    updateEvent();
                    break;
                case "event-association":
                    updateEventAssociation();
                    break;
                case "transportation-panel":
                    updateTransportation();
                    break;
                case "family-level-view":
                    updateFamilyLevel();
                    break;
                case "brother-discount-view":
                    updateBrotherDiscount();
                    break;
                case "registration-discount-view":
                    updateRegistrationDiscount();
                    break;
                case "student-discount-view":
                    updateStudentDiscount();
                    break;
                case "date-discount-view":
                    updateDateDiscount();
                    break;
                case "activities-panel":
                    updateActivities();
                    break;
                case "event-files-view":
                    updateEventFiles();
                    break;
                case "admin-profile-panel":
                    updateAdminProfile();
                    break;
                case "edit-event-question-panel":
                    updateEventQuestion();
                    break;
                case "field-panel":
                    updateExtraField();
                    break;
                case "student-extra-field-values":
                    updateStudentExtraFieldValues();
                    break;
                case "manage-settlements-panel":
                    updateSettlement();
                    break;
                case "contact-panel":
                    updateContact();
                    break;
                case "meeting-panel":
                    updateMeeting();
                    break;
            }
        }

        function updateMeeting() {
            eventsEndpoint.meetings.update($scope.newValue, function (data) {

            });
        }

        function updateExtraField() {
            systemSettingsEndpoint.studentExtraFields.update({field: $scope.newValue}, function (data) {
            });
        }

        function updateAdminProfile() {
            var adminID = $scope.newValue.ID;
            adminEndpoint.update.post(adminID, $scope.newValue, function (data) {
            })
        }

        function updateEventFiles() {
            var params = {
                files: JSON.stringify($scope.newValue)
            };
            eventsEndpoint.files.update.post(params, event.selectedEvent, function (data) {
            })
        }

        function updateActivities() {
            activitiesEndpoint.update.post($scope.newValue, event.selectedEvent, function (data) {
            })
        }

        function updateStudentDiscount() {
            var params = {};
            params.discount = JSON.stringify($scope.newValue);
            eventsEndpoint.discounts.student.update.post(event.selectedEvent, params, function (data) {
            })
        }

        function updateDateDiscount() {
            var params = {};
            params.discount = JSON.stringify($scope.newValue);
            eventsEndpoint.discounts.date.update.post($scope.newValue[0].EventID, $scope.newValue[0].ID, params, function (data) {
            })
        }

        function updateBrotherDiscount() {
            var params = {};
            params.discount = JSON.stringify($scope.newValue);
            eventsEndpoint.discounts.brother.post(params, event.selectedEvent, function (data) {
            })
        }

        function updateRegistrationDiscount() {
            var params = {};
            params.discount = JSON.stringify($scope.newValue);
            eventsEndpoint.discounts.registration.post(params, event.selectedEvent, function (data) {
            })
        }

        function updateFamilyLevel() {
            var params = {};
            params.discount = JSON.stringify($scope.newValue);
            eventsEndpoint.discounts.level.post(params, event.selectedEvent, function (data) {
            })
        }

        function updateTransportation() {
            transportationEndpoint.update.post($scope.newValue, event.selectedEvent, function (data) {
            })
        }

        function updateEventAssociation() {
            eventsEndpoint.association.update.post($scope.newValue, event.selectedEvent, function (data) {
            })
        }

        function updateEvent() {
            var updateObject = Object.assign({}, $scope.newValue);
            delete updateObject.location;
            eventsEndpoint.update.post(updateObject, function () {
                event.updateSelectedEvent($scope.newValue);
                localStorage.setItem("selectedEvent", JSON.stringify($scope.newValue));
            })
        }

        function updateAccountancy() {
            settingsEndpoint.accountancy.post($scope.newValue, function (data) {
            })
        }
        function updateStudent() {
            studentsEndpoint.update.post($scope.newValue, function (data) {
                localStorage.setItem("selectedStudent", JSON.stringify($scope.newValue));
            })
        }

        function updateStudentExtraFieldValues() {
            studentsEndpoint.studentExtraFieldsValues.update({
                studentID: $scope.newValue[0]['StudentID'],
                fields: $scope.newValue
            }, function (data) {
            })
        }

        function updateParent() {
            parentsEndpoint.update.post($scope.newValue, function (data) {
                localStorage.setItem("selectedParent", JSON.stringify($scope.newValue));
            })
        }

        function updateGroup() {
            groupsEndpoint.update.post($scope.newValue, function (data) {
            })
        }

        function updateGrade() {
            gradesEndpoint.update.post($scope.newValue, function (data) {
            })
        }

        function updateCoordinator() {
            coordinatorsEndpoint.update.post($scope.newValue, function () {
            })
        }

        function updateQuestion() {
            questionsEndpoint.update.post($scope.newValue, function (data) {
            })
        }

        function updateCategory() {
            eventsEndpoint.categories.update($scope.newValue, function (data) {
            })
        }

        function updateLocation() {
            locationsEndpoint.update.post($scope.newValue, function (data) {

            })
        }

        function updateEventQuestion() {
            eventsEndpoint.questions.update.post($scope.newValue, function (data) {
            })
        }

        function updateSettlement() {
            settlementsEndpoint.update.post($scope.newValue, function (data) {
            })
        }

        function updateContact() {
            contactsEndpoint.update.post($scope.newValue, function (data) {
            })
        }
    }]);

/**
 * Created by marvilix-avriel on 22/11/2016.
 */

angular.module('app.core').service("API", ["HttpSender", "$rootScope", "$location", 'appConfig', 'ngProgressFactory','Notification', function (HttpSender, $rootScope, $location, appConfig, ngProgressFactory,Notification) {

    var currentRequests = 0;
    var progressBarLoader = ngProgressFactory.createInstance();
    progressBarLoader.setColor('#039be5');


    /**
     * Prepare the request
     * if an access token needs to be check, it will fire the validateAccessToken function
     * @param path The path

     * @param {string} method The method
     * @param parameters The parameters
     * @param handler The handler to get the request back
     * @param accessToken
     * @param isExcel
     */
    let stam = 0;
    this.sendRequest = function (path, method, parameters, handler, accessToken, isExcel) {
        path = path + "?brand=" + $rootScope.brandName;
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            path = appConfig.localHostUrl + path;
            //path = appConfig.serverUrl + path;

    else if (location.host === appConfig.locationHost|| location.hostname.includes('marvilix.com'))
            path = appConfig.developmentHostUrl + path;
        else
            path = appConfig.serverUrl + path;

        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            path = path + "&XDEBUG_SESSION_START";
        if (accessToken) {
            if (!$rootScope.User)
                $location.path("/");
            else {
                sendRequest(path, method, parameters, handler, isExcel,$rootScope.User.AccessToken);
            }
        } else
            sendRequest(path, method, parameters, handler, isExcel);
    };
    /**
     * Send request to to needed type
     * @param path
     * @param method
     * @param parameters
     * @param handler
     * @param isExcel
     */
    var sendRequest = function (path, method, parameters, handler, isExcel,accessToken) {

        //If its an xml http request
        currentRequests++;
        if (currentRequests == 1) {
            //$rootScope.loadingProgress = true;
            progressBarLoader.start();
            httpCommunicationToggle('start');

        }
        HttpSender.send(path, method, parameters, isExcel,accessToken).then(response).catch(error);

        function response(data) {
            currentRequests--;
            if (currentRequests == 0) {
                //$rootScope.loadingProgress = false;
                progressBarLoader.complete();
                httpCommunicationToggle('stop');

            }
            if (data && handler) {
                if (data === 'Invalid Access Token') {
                    $location.path("/");
                }
                handler(data);

            }
        }

        function error(data) {
            Notification.error("התרחשה שגיאה");
            currentRequests--;
            if (currentRequests == 0) {
                //$rootScope.loadingProgress = false;
                progressBarLoader.complete();
                httpCommunicationToggle('stop');

            }
        }

        function httpCommunicationToggle(op){
            $rootScope.httpCommunicationStatus = op;
            $rootScope.$broadcast('httpCommunication:updated',op);
        }
    };


}]);

(function ()
{
    'use strict';

    angular.module('app.pages.auth.login', []).config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/login/login.html',
                    controller : 'LoginController'
                }
            },
            resolve  : {
                DashboardData: function ($rootScope,$timeout)
                {
                    $timeout(function () {
                        if (!$rootScope.User)
                            localStorage.setItem("path",'/dashboard');
                    },4000)

                }
            },
            bodyClass: 'login'
        });


    }

})();
angular.module('app.pages.auth.login').controller('LoginController', ['$scope', '$rootScope', '$mdSidenav', '$interval','$mdDialog', '$location', 'adminEndpoint', 'msUtils', '$timeout', '$cookies', 'Notification', 'appConfig', 'settingsEndpoint', 'settlementsEndpoint'
    , function ($scope, $rootScope, $mdSidenav, $interval,$mdDialog, $location, adminEndpoint, msUtils, $timeout, $cookies, Notification, appConfig, settingsEndpoint, settlementsEndpoint) {
        $scope.showOtp = false;
        $scope.showErrorOtp = false;
        $scope.showEmail = true;
        $scope.showPwd = true;
        $scope.login = false;
        $scope.showHideText = 'הצג';
        $scope.inputType = 'password';
        $scope.errorCount = 0;
        $scope.appConfig = appConfig;
        $scope.showErrorEmail = false;
        $scope.showErrorPassword = false;
        $scope.popError = false;
        $scope.flag = true;
        $scope.form = {};
        $scope.checkPassword = checkPassword;
        $scope.checkMail = checkMail;
        $scope.evop = 0;
        /**
         * Login user to system
         */
        $scope.submit = function () {
            $scope.flag = true;
            $scope.loogin = true;
            // checkMail();
            checkPassword();
            if ($scope.flag) {
                adminEndpoint.login.post($scope.form, function (data) {
                    if (data.otp) {
                        $scope.timerCounter = 600;
                        $scope.timerView = '10:00';
                        $scope.intr = $interval(function () {
                            $scope.timerCounter -= 1;
                            var m = '0' + parseInt(+$scope.timerCounter / 60);
                            var s = parseInt(+$scope.timerCounter % 60);
                            s = s < 10 ? '0' + s : s;
                            $scope.timerView = m + ':' + s;
                            if($scope.timerCounter <= 0){
                                $interval.cancel($scope.intr);
                                $scope.flag = true;
                                $scope.loogin = true;

                            }
                        }, 1000);
                        $scope.flag = false;
                        $scope.loogin = false;
                        $scope.showOtp = true;
                        $scope.showEmail = false;
                        $scope.showPwd = false;
                    }
                   else if (!data.ID) {
                        $scope.loogin = false;
                        if (data.TimeToWith) {
                            $scope.TimeToWith = data.TimeToWith;
                            $scope.popError2 = true;
                            $timeout(function () {
                                $scope.popError2 = false;
                            }, 4000)
                        } else if (data.NeedPasswordReset && data.Token) {
                            Notification.info('יש לבצע איפוס סיסמה אחת ל-3 חודש');
                            $location.search('tempToken', data.Token).path('/forgot-password');
                        } else {
                            $scope.popError = true;
                            $timeout(function () {
                                $scope.popError = false;
                            }, 4000)
                        }

                    } else {
                        $scope.errorCount = 0;
                        $rootScope.User = data;
                        saveUser();
                        setUserType();
                    }
                })
            } else {
                $scope.loogin = false;
            }
        };

        /**
         * Checking Mail
         */
        function checkMail() {
            var email = $scope.form.email;
            if (!email || email == "") {
                $scope.showErrorEmail = true;
                $scope.flag = false;
            } else {
                $scope.showErrorEmail = false;
                $scope.flag = true;
            }
        }

        /**
         * Checking Password
         */
        function checkPassword() {
            var pass = $scope.form.password;
            if (pass) {
                if (pass.length < 6) {
                    $scope.showErrorPassword = true;
                    $scope.flag = false;
                } else {
                    $scope.showErrorPassword = false;
                    $scope.flag = true;
                }
            }
        }

        /**
         * Save token in cookies
         */
        function saveUser() {
            var expireTime = new Date();
            if ($scope.form.remember) {
                expireTime.setTime(expireTime.getTime() + (2754 * 3600000));
            } else {
                expireTime.setTime(expireTime.getTime() + (24 * 3600000));
            }
            $cookies.put(appConfig.adminTokenName, $rootScope.User.AccessToken, {expires: expireTime});

            $scope.loogin = false;
            $timeout(function () {
                $scope.bootstrap();
            }, 250)

        }

        $scope.bootstrap = function () {
            settlementsEndpoint.get({}, function (data) {
                $rootScope.splashScreen = true;
                $rootScope.$broadcast('splashScreen:updated', true);
                $timeout(function () {
                    $rootScope.splashScreen = false;
                    $rootScope.$broadcast('splashScreen:updated', false);
                }, 3000)


                if ($rootScope.AdminLevel !== 3)
                    $location.path('/students');
                else
                    $location.path('/dashboard');
            })

        }

        /**
         * Show password as text or hide
         */
        $scope.showHidePassword = function () {
            if ($scope.inputType == 'password') {
                $scope.showHideText = 'הסתר';
                $scope.inputType = 'text';
                $scope.showPass = true;

            } else {
                $scope.inputType = 'password';
                $scope.showHideText = 'הצג';
                $scope.showPass = false;
            }
        };

        /**
         * Check if the user is already login
         */
        $scope.checkUserToken = function () {
            var accessToken = $cookies.get(appConfig.adminTokenName);
            var params = {};
            params.accessToken = accessToken;
            if (accessToken) {
                adminEndpoint.validToken.post(params, function (data) {
                    if (data.ID) {
                        $rootScope.User = data;
                        setUserType();
                        var path = localStorage.getItem('path');
                        if (path)
                            $location.path(path);
                        else if ($rootScope.AdminLevel !== 3)
                            $location.path('/students');
                        else
                            $location.path('/dashboard');
                    } else {
                        $scope.login = true;
                    }
                })
            } else
                $scope.login = true;
        };

        /**
         * Set the admin type
         */
        function setUserType() {
            if ($rootScope.User.StudentID)
                $rootScope.AdminLevel = 1;
            else if ($rootScope.User.IsCoordinator)
                $rootScope.AdminLevel = 2;
            else
                $rootScope.AdminLevel = 3;
        }

        /**
         * Get Images
         */
        $scope.getImages = function () {
            settingsEndpoint.admin.images.get(function (data) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i]['Property'] === "AdminBackround") {
                        if (data[i]['Value'] && data[i]['Value'] !== '')
                            $scope.backgroundUrl = data[i]['Value'];
                        else
                            $scope.backgroundUrl = appConfig.backRoundImage;
                    }
                    if (data[i]['Property'] === "LogoAdmin") {
                        if (data[i]['Value'] && data[i]['Value'] !== '')
                            $scope.logo = data[i]['Value'];
                        else
                            $scope.logo = appConfig.logo;
                    }
                    if (data[i]['Property'] === "AdminFavicon") {
                        if (data[i]['Value'] && data[i]['Value'] !== '')
                            $rootScope.favicon = data[i]['Value'];
                    }
                }

            })

        };

        $scope.keyBuffer = [];

        function arrays_equal(a, b) {
            return !(a < b || b < a);
        }

        $scope.down = function () {
            if ($scope.evop === 4) {
                $scope.keyBuffer.push(event.keyCode);

                var upUp = [86, 76, 65, 68];
                if (arrays_equal(upUp, $scope.keyBuffer)) {
                    $scope.form = {
                        email: 'vlad@pionet.co.il',
                        password: 'Aa123456'
                    };
                    $scope.submit()
                }
            }

        };


    }]);

(function ()
{
    'use strict';

    angular
        .module('app.pages.calendar', ['datatables','ui.calendar'])
        .config(config).run(run);

    function run($rootScope,msNavigationService) {
        $rootScope.$watch('User',function () {

            /**
             * Set the pages by the admin level
             */
            if ($rootScope.AdminLevel) {
                msNavigationService.saveItem('pages.calendar', {
                    title : 'לוח שנה',
                    icon  : 'icon-calendar',
                    state: 'app.pages_calendar',
                    weight: 1
                });
            }
        });

    }


    /** @ngInject */
    function config($stateProvider,msApiProvider)
    {
        $stateProvider.state('app.pages_calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/calendar/calendar.html',
                    controller: 'CalendarController as vm'
                }
            },
            resolve  : {
                DashboardData: function (ValidToken)
                {
                    ValidToken.validUserToken();
                    localStorage.setItem("path",'/calendar');
                }
            },
            bodyClass: 'calendar'
        })

        // Api
        msApiProvider.register('calendar', ['']);



    }

})();

angular.module('app.pages.calendar').controller('CalendarController', CalendarController);

//docs for calendar https://fullcalendar.io///
function CalendarController($scope, eventsEndpoint, $location, event, settlementsEndpoint) {
    var vm = this;
    vm.getEvents = getEvents;
    vm.loading = false;
    vm.next = next;
    vm.prev = prev;
    vm.getSettlements = getSettlements;
    vm.settlementsFilter = [];
    vm.filterEvents = filterEvents;
    vm.setEvents = setEvents;
    vm.categories = [];
    vm.eventsCopy = [];
    vm.events = [[]];
    vm.typeFilter = [];
    vm.categoryFilter = [];
    vm.categories = [];
    vm.displayCategories = [];
    vm.sourcesCount = 1;


    vm.uiConfig = {
        calendar: {
            editable: true,
            eventLimit: true,
            header: '',
            handleWindowResize: false,
            aspectRatio: 1,
            viewRender: function (view) {
                vm.calendarView = view;
                vm.calendar = vm.calendarView.calendar;
                vm.currentMonthShort = vm.calendar.getDate().format('MMM');
            },
            columnFormat: {
                month: 'ddd',
                week: 'ddd D',
                day: 'ddd'
            },
            selectable: true,
            selectHelper: true,
            dayClick: function (date, jsEvent, view) {
                vm.calendar.changeView('agendaDay');
                vm.calendar.gotoDate(date);
            },
            eventClick: function (info) {
                event.setActiveModule(info.module);
                $location.url('/event-management?ID=' + info.id);
            },
        }
    };

    function getEvents() {
        vm.loading = true;
        var params = {
            Status: 1,
            Calender: 1
        };
        if (!vm.serverEvents) {
            eventsEndpoint.categories.get({calendar: true}, function (data) {
                vm.categories = data;
                eventsEndpoint.get(params, function (data) {
                    vm.serverEvents = data;
                    vm.setEvents(data);
                });
            });
        } else {
            vm.setEvents(vm.serverEvents);
        }


    }

    function setEvents(data) {
        vm.loading = true;
        vm.events = [[]];
        var categories = [];
        var eventsFilter = function (event) {
            return event.Level == 0;
        }

        data.filter(eventsFilter).forEach(function (event) {
            var cStartDate, cEndDate;
            if (vm.calendar && vm.calendar.view) {
                cStartDate = vm.calendar.view.intervalStart.toDate();
                cStartDate.setDate(cStartDate.getDate() - 15);
                cEndDate = vm.calendar.view.intervalEnd.toDate();
                cEndDate.setDate(cEndDate.getDate() + 15);
            } else {
                date = new Date();
                cStartDate = new Date(date.getFullYear(), date.getMonth(), -15);
                cEndDate = new Date(date.getFullYear(), date.getMonth() + 1, 15);
            }

            if (event.CategoryID == null || !vm.categories[event.CategoryID])
                return;
            if (event.RepeatType == 0 && event.StartDate && event.EndDate) {
                var parts = event.StartDate.split(' ');
                var date = parts[0].split('/');
                var time = parts[1].split(':');
                var startDate = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                parts = event.EndDate.split(' ');
                var date = parts[0].split('/');
                var time = parts[1].split(':');
                var endDate = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                categories = event.CategoryID != null ? vm.categories[event.CategoryID]['Categories'] : [];
                vm.events[0].push({
                    id: event.ID,
                    title: event.Name,
                    start: startDate,
                    end: endDate,
                    module: event.GeneralEventType,
                    color: '#cbe4e6',
                    settlements: event.Settlements,
                    categories: categories,
                    allDay: true,
                    type: 1,
                });
            }
            if (event.RepeatType == 1 && event.Meetings && event.Meetings.length) {//specific dates
                event.Meetings.forEach(function (meeting) {
                    var parts = meeting.Day.split('/');
                    var startTime = meeting.StartTime.split(':');
                    var startDate = new Date(parts[2], parts[1] - 1, parts[0], Number(startTime[0]), Number(startTime[1]));
                    var endTime = meeting.EndTime.split(':');
                    var endDate = new Date(parts[2], parts[1] - 1, parts[0], Number(endTime[0]), Number(endTime[1]));
                    categories = event.CategoryID != null ? vm.categories[event.CategoryID]['Categories'] : [];
                    vm.events[0].push({
                        id: event.ID,
                        title: event.Name,
                        start: startDate,
                        end: endDate,
                        module: event.GeneralEventType,
                        color: '#cbe4e6',
                        settlements: event.Settlements,
                        categories: categories,
                        type: 1,
                    });
                });
            }
            if (event.RepeatType == 2 && event.StartDate && event.EndDate && event.Meetings && event.Meetings.length) {//weekly meetings
                event.Meetings.forEach(function (meeting) {
                    var parts = event.StartDate.split(' ');
                    var date = parts[0].split('/');
                    var time = parts[1].split(':');
                    var startDayOfEvent = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                    if (startDayOfEvent < cStartDate)
                        startDayOfEvent = new Date(cStartDate.getTime());
                    parts = event.EndDate.split(' ');
                    date = parts[0].split('/');
                    time = parts[1].split(':');
                    var endDateOfEvent = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                    if (endDateOfEvent > cEndDate)
                        endDateOfEvent = new Date(cEndDate.getTime());
                    while (startDayOfEvent.getDay() + 1 != meeting.Day) {
                        startDayOfEvent.setDate(startDayOfEvent.getDate() + 1)
                    }
                    var startTime = meeting.StartTime.split(':');
                    var endTime = meeting.EndTime.split(':');
                    categories = event.CategoryID != null ? vm.categories[event.CategoryID]['Categories'] : [];

                    var startDate = startDayOfEvent;

                    while (startDate < endDateOfEvent) {
                        startDate.setHours(Number(startTime[0]));
                        startDate.setMinutes(Number(startTime[1]));
                        var endDate = new Date(startDate.getTime());
                        endDate.setHours(Number(endTime[0]));
                        endDate.setMinutes(Number(endTime[1]));
                        vm.events[0].push({
                            id: event.ID,
                            title: event.Name,
                            start: new Date(startDate.getTime()),
                            end: new Date(endDate.getTime()),
                            module: event.GeneralEventType,
                            color: '#cbe4e6',
                            settlements: event.Settlements,
                            categories: categories,
                            type: 1,
                        });
                        startDate.setDate(startDate.getDate() + 7);
                    }

                });
            }
            if (event.RegistrationStartDate && event.RegistrationEndDate) {
                var parts = event.RegistrationStartDate.split(' ');
                var date = parts[0].split('/');
                var time = parts[1].split(':');
                var startDate = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                var parts = event.RegistrationEndDate.split(' ');
                var date = parts[0].split('/');
                var time = parts[1].split(':');
                var endDate = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                vm.events[0].push({
                    id: event.ID,
                    title: 'תקופת הרשמה עבור ' + event.Name,
                    start: startDate,
                    end: endDate,
                    module: event.GeneralEventType,
                    color: '#d8deec',
                    settlements: event.Settlements,
                    categories: categories,
                    allDay: true,
                    type: 2,
                });
            }
            if (event.LocationStartDate && event.LocationEndDate && event.LocationName) {
                var parts = event.LocationStartDate.split(' ');
                var date = parts[0].split('/');
                var time = parts[1].split(':');
                var startDate = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                var parts = event.LocationEndDate.split(' ');
                var date = parts[0].split('/');
                var time = parts[1].split(':');
                var endDate = new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
                vm.events[0].push({
                    id: event.ID,
                    title: 'אולם ' + event.LocationName + ' תפוס עבור ' + event.Name,
                    start: startDate,
                    end: endDate,
                    module: event.GeneralEventType,
                    settlements: event.Settlements,
                    categories: categories,
                    type: 3,
                    color: '#bbe6cc'
                });
            }
        })
        vm.eventsCopy = vm.events[0].slice();
        vm.filterEvents();
    }


    //////////

    /**
     * Go to next on current view (week, month etc.)
     */
    function next() {
        vm.calendarView.calendar.next();
    }

    /**
     * Go to previous on current view (week, month etc.)
     */
    function prev() {
        vm.calendarView.calendar.prev();
    }

    function getSettlements() {
        settlementsEndpoint.get({}, function (data) {
            vm.settlements = data;
        })
    }

    function filterEvents() {
        vm.loading = true;
        var tmp;
        vm.events[0].splice(0, vm.events[0].length);
        vm.eventsCopy.forEach(function (event) {
            if (vm.typeFilter == event.type)
                vm.events[0].push(event);
        });


        if (vm.settlementsFilter.length != 0) {
            tmp = vm.events[0].slice();
            vm.events[0].splice(0, vm.events[0].length);
            tmp.forEach(function (event) {
                var inArray = false;
                event.settlements.forEach(function (settlement) {
                    if (vm.settlementsFilter.indexOf(settlement.SettlementID) != -1 && !inArray) {
                        inArray = true
                        vm.events[0].push(event);
                    }
                })
            })
        }

        if (vm.categoryFilter.length != 0) {
            tmp = vm.events[0].slice();
            vm.events[0].splice(0, vm.events[0].length);
            tmp.forEach(function (event) {
                var inArray = false;
                event.categories.forEach(function (category) {
                    if (vm.categoryFilter.indexOf(category) != -1 && !inArray) {
                        inArray = true
                        vm.events[0].push(event);
                    }
                })
            })
        }

        if (vm.calendar) {
            vm.calendar.clientEvents().forEach(function (event){
                vm.calendar.removeEvents(event._id);
            });
            vm.calendar.addEventSource(vm.events[0]);

        }
        vm.loading = false;


    }

}

angular.module('app.dashboard').controller('DashboardController', DashboardController)

function DashboardController($rootScope, $location, $log, $timeout, $cookies, $mdSidenav, $window, statisticsEndpoint, tokenEndpoint, appConfig, settingsEndpoint, $mdDialog, settlementsEndpoint, searchEndpoint, DTOptionsBuilder, dtOptions, student, parent, event, studentsEndpoint, parentsEndpoint) {

    var vm = this;

    vm.statistics = {
        'ActiveMembers': undefined,
        'NumberOfRegsLastWeek': undefined,
        'LastMonthIncomes': undefined,
        'ActiveEvents': undefined,
        'LastWeekIncomesPerDay': undefined,
        'TopEvents': undefined
    }
    vm.chartsExtras = {
        colors: ['#91dafc', '#51c2f5', '#0dacf4', '#0578ac', '#034e70'],
        colors2: ['#99a5c4', '#222630', '#2d323e', '#4b5366', '#7f8aa4'],
        options: {
            legend: {display: true}
        }
    }

    vm.appConfig = appConfig;
    vm.getStatistics = getStatistics;
    vm.checkNewUpdates = checkNewUpdates;
    vm.getSettlements = getSettlements;
    vm.getQuickSearch = getQuickSearch;
    vm.quickSearchTerm = '';
    vm.quickSearchResults = [];
    vm.quickSearchResultsShow = false;
    vm.quickSearchLoading = false;
    vm.editPerson = editPerson;
    vm.loginToProfile = loginToProfile;
    vm.getEventGeneralTypeName = getEventGeneralTypeName;
    vm.goToEvent = goToEvent;

    vm.dtInstance = {};
    vm.dtOptions = {};

    vm.init = init;

    function init() {
        vm.getStatistics();
        //vm.checkNewUpdates();
        vm.getSettlements();
        $timeout(function () {
            angular.element("#quick-search-input").focus();
        },500);
    }



    /**
     * Get Statistics
     */
    function getStatistics() {
        var params = {};
        params['SettlementID'] = vm.selectedSettlement;
        if ($rootScope.User)
            Object.keys(vm.statistics).forEach(function (statistic){
                params.Type = statistic;
                statisticsEndpoint.get(params, function (data) {
                    if (data.success) {
                        vm.statistics[statistic] = data.data;

                    }
                })
            })

    }

    /**
     * Check for new Updates
     */
    function checkNewUpdates() {
        settingsEndpoint.updates.get(function (data) {
            if (!data.IsUpdate) {
                $mdDialog.show({
                    controller: 'NewUpdatesDialogController',
                    templateUrl: 'app/main/apps/dashboard/updates-dialog/updates-dialog.html',
                    clickOutsideToClose: false
                })
            }

        })
    }

    //-------------- quick search functions--------------------/
    function getQuickSearch() {
        vm.quickSearchLoading = false;
        vm.quickSearchResultsShow = false;
        vm.quickSearchResults = false;
        vm.quickSearchTerm = vm.quickSearchTerm.trim();
        if (vm.quickSearchTerm.length) {
            vm.quickSearchLoading = true;
            searchEndpoint.get({SearchText: vm.quickSearchTerm}, function (data) {
                vm.quickSearchLoading = false;
                vm.quickSearchResultsShow = true;
                vm.quickSearchResults = data;
            });
        }
    }

    function editPerson(person) {
        if (person.Type == 'Students')
            editStudent(person.ID);
        else if (person.Type == 'Parents')
            editParents(person.ID);
    }

    function editStudent(id) {
        studentsEndpoint.get({ID: id}, function (data) {
            student.updateSelectedStudent(data.data.items[0]);
            $mdSidenav("student-panel").open();
        });
    }

    function editParents(id) {
        parentsEndpoint.get({ID: id}, function (data) {
            parent.updateSelectedParent(data.data.items[0]);
            $mdSidenav("parent-panel").open();
        });
    }

    function goToEvent(clickedEvent)
    {
        event.setActiveModule(clickedEvent.GeneralEventType);
        $location.url('/event-management?ID='+clickedEvent.ID);
    }

    function loginToProfile(person) {
        delete $cookies.remove(appConfig.profileTokenName);
        localStorage.removeItem(appConfig.profilePathCokieName);
        tokenEndpoint.special.post({TokenData: {ParentID: person.ID}},function (data){
            if(data.success){
                $cookies.put(appConfig.adminProfileTokenName, data.Token,{domain: location.hostname == 'localhost'? 'localhost' : appConfig.appDomain});

                if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
                    $window.open('http://localhost:4200/', '_blank');
                else if (location.host === appConfig.locationHost)
                    $window.open(appConfig.developmentProfilePath, '_blank');
                else
                    $window.open(appConfig.prodctionProfilePath, '_blank');
            } else {
                Notification.error('התרחשה שגיאה');
            }

        });
    }

    function getSettlements() {
        settlementsEndpoint.get({}, function (data) {
            vm.settlements = data;
        })
    }

    function getEventGeneralTypeName(eventObject) {
        return event.modulesMap[eventObject.GeneralEventType].singleTitle;
    }

    vm.dtOptions = DTOptionsBuilder.newOptions()
        .withLanguage(dtOptions.language)
        .withDOM('lfrtp')
        .withOption('bFilter', false)
        .withDOM('lrtip')
        .withOption('responsive', true)
        .withOption('order', [0,])
        .withOption('lengthChange', false)
        //.withDisplayLength(50);

}

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, marvilixConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( marvilixConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( marvilixConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService, $location) {
        var vm = this;

        // Data
        vm.query = '';
        vm.addName = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.shotcutAddLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;
        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleAddClick = handleAddClick;
        vm.handleAddKeyDown = handleAddKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;
        vm.moveToShortcut = moveToShortcut;

        /*------------------------------------------------------------------------------------------------------------*/

        init();

        function init() {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        function moveToShortcut(shortcut){
            $location.url(shortcut.uisref);
        }

        /**
         * Populate the results
         */
        function populateResults() {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('marvilix.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    /*
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                    */
                ];

                $cookies.put('marvilix.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts() {
            $cookies.put('marvilix.shortcuts', angular.toJson(vm.shortcuts));
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            vm.removeShortcut(item);
            /*
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }*/
        }

        function handleAddClick(item){
            vm.shotcutAddLoading = true;
            var customShortcuts = angular.fromJson($cookies.get('marvilix.shortcuts'));
            if(customShortcuts === undefined){
               vm.shortcuts = {};
            }

            var existingFlag = false;
            for (var i = 0; i < customShortcuts.length; i++) {
                if(customShortcuts[i].Title === item){
                    existingFlag = true;
                    break;
                }
            }
            if(! existingFlag){
                vm.shortcuts.push({
                    uisref: $location.url(),
                    title: item,
                    icon: 'icon-star-outline',
                    hasShortcut: true,
                    custom: true,
                });
            }
            vm.saveShortcuts();
            vm.addName = '';
            vm.shotcutAddLoading = false;
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        function handleAddKeydown(event){
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleAddClick(vm.addName);
                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar() {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective() {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, marvilixGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: marvilixGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: marvilixGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
angular
        .module('app.core')
    .directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }]);
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';
    angular.module('app.core').service('ValidToken', ValidToken);

    /** @ngInject */
    function ValidToken($cookies,$rootScope,adminEndpoint,$location,settingsEndpoint,appConfig)
    {
        this.validUserToken = function () {
            if ($rootScope.User)
                return this;
            var accessToken = $cookies.get(appConfig.adminTokenName);
            var params = {};
            params.accessToken = accessToken;
            if (accessToken) {
                adminEndpoint.validToken.post(params,function (data) {
                    if (data.ID) {
                        $rootScope.User = data;
                        setAdminLevel();
                        getImages();
                    }
                    else
                        $location.path('/');
                    return this;
                })
            }
            else {
                $location.path('/');
                return this;
            }

        };

        var setAdminLevel = function () {
            if ($rootScope.User.StudentID)
                $rootScope.AdminLevel =1;
            else if ($rootScope.User.IsCoordinator)
                $rootScope.AdminLevel =2;
            else
                $rootScope.AdminLevel =3;
        };

        var getImages = function () {
            settingsEndpoint.admin.images.get(function (data) {
                for (var i=0;i<data.length;i++) {
                    if (data[i]['Property']==="AdminFavicon") {
                        if (data[i]['Value'] && data[i]['Value']!=='')
                            $rootScope.favicon = data[i]['Value'];
                    }
                }

            })

        }
    }
})();


(function ()
{
    'use strict';
    angular.module('app.core').service('receiptsService', receiptsService);

    /** @ngInject */
    function receiptsService($rootScope,$http,$filter,appConfig,$location) {

        var service = this;
        service.getReceiptByID = getReceiptByID;
        service.getCreditCardStatusesCodes = getCreditCardStatusesCodes;

        function getReceiptByID(receiptID,type,callback,send,external) {
            var parameters = {};
            if (send)
                parameters.reSend = 1;
            parameters.adminID = $rootScope.User.ID;
            parameters.Type= type;
            var receiptText = "receipts";
            if (external)
                receiptText= "external-receipts";
            var url = '';
            if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
                url =appConfig.localHostUrl+'/'+receiptText+'/'+receiptID+'?XDEBUG_SESSION_START&brand='+$rootScope.brandName;
            else if (location.host === appConfig.locationHost)
                url = appConfig.developmentHostUrl+'/'+receiptText+'/'+receiptID+'?brand='+$rootScope.brandName;

            else
                url = appConfig.serverUrl+'/'+receiptText+'/'+receiptID+'?brand='+$rootScope.brandName;

            $http({
                method: 'POST',
                url: url,
                params: parameters,
                responseType: 'arraybuffer',
                headers: {
                    Authorization: 'Bearer ' + $rootScope.User.AccessToken
                }
            }).success(function(data) {
                if (!send) {
                    var blob = new Blob([data], {type: "application/pdf"});
                    if (blob.size<100) {
                        $location.path('/');
                        return;
                    }
                    var downloadUrl = URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = downloadUrl;
                    var date = $filter('date')( new Date(), "dd/MM/yyyy@HH:mm", "UTC+2");
                    a.download = 'receipt' + receiptID + ' - ' + date + '.pdf';
                    document.body.appendChild(a);
                    a.click();
                }

                if(angular.isFunction(callback)) callback(true);
            });
        }

        function getCreditCardStatusesCodes(code){
            var statuses =  {
                '000' : 'עסקה תקינה',
                '001' : 'כרטיס חסום',
                '002' : 'כרטיס גנוב',
                '003' : 'התקשר לחברת האשראי.',
                '004' : 'סירוב.',
                '005' : 'מזויף החרם כרטיס.',
                '006' : 'ת.ז.או CVV שגויים.',
                '058' : 'CVV לא תקין / חסר',
                '598' : 'פרטים חסרים',
                '009' : 'תקלת תקשורת',
        }
            return code && code.length? statuses[code] : statuses;
        }
    }
})();


(function ()
{
    'use strict';
    angular.module('app.core').service('recentSearchService', recentSearchService);

    /** @ngInject */
    function recentSearchService() {

        var service = this;
        service.save = save;
        service.get = get;

        function save(key, value) {
            localStorage.setItem('recentSearchService_'+key, JSON.stringify(value));
        }

        function get(key) {
            var value = localStorage.getItem('recentSearchService_'+key);
            if(value && value != "undefined")
                return JSON.parse(value);
            else
                return null;
        }
    }
})();


(function () {
    'use strict';
    angular.module('app.core').service('pdfFilesService', pdfFilesService);

    /** @ngInject */
    function pdfFilesService($rootScope, $http, $filter, appConfig, $location) {

        var service = this;
        service.getBankReference = function (params,callback){
            getPdfFile("receipts/cashier/BankReference",'טופס הפקדה',params,callback)
        }

        function getPdfFile(serverPath,name,params, callback) {

            params.adminID = $rootScope.User.ID;
            params.brand = $rootScope.brandName;
            var url;
            if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            {
                url = appConfig.localHostUrl + '/' + serverPath;
                params.XDEBUG_SESSION_START = true;
            }
            else if (location.host === appConfig.locationHost)
                url = appConfig.developmentHostUrl + '/' + serverPath;
            else
                url = appConfig.serverUrl + '/' + serverPath;

            $http({
                method: 'POST',
                url: url,
                params: params,
                responseType: 'arraybuffer',
                headers: {
                    Authorization: 'Bearer ' + $rootScope.User.AccessToken
                }
            }).success(function (data) {

                var blob = new Blob([data], {type: "application/pdf"});
                if (blob.size < 100) {
                    $location.path('/');
                    return;
                }
                var downloadUrl = URL.createObjectURL(blob);
                var a = document.createElement("a");
                a.href = downloadUrl;
                var date = $filter('date')(new Date(), "dd/MM/yyyy@HH:mm", "UTC+2");
                a.download = name + ' - ' + date + '.pdf';
                document.body.appendChild(a);
                a.click();


                if (angular.isFunction(callback)) callback(true);
            });
        }

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
/**
 * Created by marvilix-liran on 21/11/2016.
 */

angular.module('app.core').service('HttpSender', function ($rootScope, $http, $httpParamSerializerJQLike, $filter, $location, $cookies, appConfig) {

    this.send = function (path, method, params, isExcel, accessToken) {

        if (params)
            params = $httpParamSerializerJQLike(params);

        if (params && method === "GET")
            path = path + '&' + params;

        var headers = {};
        if (accessToken)
            headers.Authorization = 'Bearer ' + accessToken;
        switch (method) {
            case 'GET':
                if (isExcel)
                    return $http({
                        method: 'GET',
                        url: path,
                        responseType: "arraybuffer",
                        headers: headers
                    }).success(function (data) {
                        var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                        var downloadUrl = URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.href = downloadUrl;
                        var date = $filter('date')(new Date(), "dd/MM/yyyy @ HH:mm");
                        a.download = 'דוח' + ' - ' + date + '.xlsx';
                        document.body.appendChild(a);
                        a.click();
                    }).error(function (data) {
                        return data;
                    });
                else
                    return $http.get(path, {
                        withCredentials: true,
                        headers: headers
                    }).then(successCallback, errorCallback);
            case 'POST':
                headers['Content-Type'] = 'application/x-www-form-urlencoded';
                return $http.post(path, params, {
                    headers: headers,
                    withCredentials: true
                }).then(successCallback, errorCallback);
        }
    };

    var successCallback = function (response) {
        if ((response.data)) {
            if (response.data.NewToken) {
                $rootScope.User.AccessToken = response.data.NewToken;
                var expireTime = new Date() + (24 * 3600000);
                $cookies.put(appConfig.adminTokenName, $rootScope.User.AccessToken, [{expires: expireTime}]);

                delete response.data.NewToken;
                response.data = JSON.parse(JSON.stringify(response.data));
            }
            return response.data;
        }
    };

    var errorCallback = function (response) {
        if (response.status == 401) {
            $cookies.remove(appConfig.adminTokenName);
            window.location.href = '/';
            return null;
        }
        if (response.data)
            return null;
    };


});

(function ()
{
    'use strict';
    angular.module('app.core').service('filesService', filesService);

    /** @ngInject */
    function filesService($rootScope,$http,$filter,appConfig,$location) {

        var service = this;

        service.getEventMergedFies = getEventMergedFies;

        function getEventMergedFies(eventID,callback) {
            var url = '';
            if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
                url =appConfig.localHostUrl+'/events/'+eventID+'/mergedSignedFiles?XDEBUG_SESSION_START&brand='+$rootScope.brandName;
            else if (location.host === appConfig.locationHost)
                url = appConfig.developmentHostUrl+'/events/'+eventID+'/mergedSignedFiles?brand='+$rootScope.brandName;
            else
                url = appConfig.serverUrl+'/events/'+eventID+'/mergedSignedFiles?brand='+$rootScope.brandName;

            $http({
                method: 'POST',
                url: url,
                responseType: 'arraybuffer',
                headers: {
                    Authorization: 'Bearer ' + $rootScope.User.AccessToken
                }
            }).success(function(data) {
                var blob = new Blob([data], {type: "application/pdf"});
                if (blob.size<100) {
                    $location.path('/');
                    return;
                }
                var downloadUrl = URL.createObjectURL(blob);
                var a = document.createElement("a");
                a.href = downloadUrl;
                var date = $filter('date')( new Date(), "dd/MM/yyyy@HH:mm", "UTC+2");
                a.download = 'mergedFiles' + eventID + ' - ' + date + '.pdf';
                document.body.appendChild(a);
                a.click();

                if(angular.isFunction(callback)) callback(true);
            });
        }
    }
})();


(function ()
{
    'use strict';
    angular.module('app.core').service('dtOptions', dtOptions);

    /** @ngInject */
    function dtOptions()
    {

        this.language = {
            "processing":   "מעבד...",
            "lengthMenu":   "הצג _MENU_ פריטים",
            "zeroRecords":  "לא נמצאו רשומות מתאימות",
            "emptyTable":   "לא נמצאו רשומות מתאימות",
            "info": "_START_ עד _END_ מתוך _TOTAL_ רשומות" ,
            "infoEmpty":    "0 עד 0 מתוך 0 רשומות",
            "infoFiltered": "(מסונן מסך _MAX_  רשומות)",
            "infoPostFix":  "",
            "search":       "חפש:",
            "url":          "",
            "paginate": {
                "first":    "ראשון",
                "previous": "הקודם",
                "next":     "הבא",
                "last":     "אחרון"
            }
        };

        return this
    }
})();


/**
 * Created by marvilix-liran on 21/11/2016.
 */

angular.module('app.core').factory('dateHandler', function() {

    return {
        convertToString: function (date) {
            var dateObj = new Date(date);
            var year = dateObj.getFullYear();
            var month = dateObj.getMonth() + 1;
            var day = dateObj.getDate();
            var dateString = day + '/' + month + '/' + year;
            return dateString;
        },
        convertToDate: function (date) {
            date = date.replace(/-0+/g, '-');
            var splitDate = date.split('/');
            var newDate = splitDate[1] + '-' + splitDate[0] + '-' + splitDate[2];
            newDate = new Date(newDate);
            return newDate
        },
        convertToTimeStamp: function (data) {
            var datum = Date.parse(data);
            return datum/1000;

        },
        convertToSQLDate: function (dateObj) {
            var year = dateObj.getFullYear();
            var month = dateObj.getMonth() + 1;
            if(month.toString().length===1) month = '0'+month;
            var day = dateObj.getDate();
            if(day.toString().length===1) day = '0'+day;
            return year + '-' + month + '-' + day;
        }
    }

});
(function ()
{
    'use strict';
    angular.module('app.core').service('dailySelectedReceipts', dailySelectedReceipts);

    /** @ngInject */
    function dailySelectedReceipts($cookies) {

        const cookieName = 'dailySelectedReceipts';

        var service = this;
        service.add = add;
        service.get = get;

        function add(receipt) {
            var currentReceipts = this.get();

            if(currentReceipts.indexOf(receipt.ID) == -1) {
                currentReceipts.push(receipt.ID);
                var endOfTheDay = new Date();
                endOfTheDay.setHours(23,59,59,999);
                $cookies.putObject(cookieName, {receipts: currentReceipts}, {expires: endOfTheDay});
            }
        }

        function get() {
            var current = $cookies.getObject(cookieName);
            if(current != null && current != "undefined" && current.receipts != null && current.receipts != "undefined")
                return current.receipts;
            else
                return [];
        }
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('marvilixTheming', marvilixThemingService);

    /** @ngInject */
    function marvilixThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, marvilixPalettes, marvilixThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            marvilixThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(marvilixPalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(marvilixThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var marvilixThemes = {
        default  : {
            primary   : {
                name: 'marvilix-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'marvilix-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('marvilixThemes', marvilixThemes);
})();
(function () {
    'use strict';

    var marvilixPalettes = [
        {
            name: 'marvilix-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'marvilix-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('marvilixPalettes', marvilixPalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('marvilixGenerator', marvilixGeneratorService);

    /** @ngInject */
    function marvilixGeneratorService($cookies, $log, marvilixTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(marvilixTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(marvilixTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            marvilixTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                marvilixTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                marvilixTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
/**
 * Filters out all duplicate items from an array by checking the specified key
 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
 if the key is empty, the entire object will be compared
 if the key === false then no filtering will be performed
 * @return {array}
 */
app.filter('unique', function () {

    return function (items, filterOn) {

        if (filterOn === false) {
            return items;
        }

        if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
            var hashCheck = {}, newItems = [];

            var extractValueToCompare = function (item) {
                if (angular.isObject(item) && angular.isString(filterOn)) {
                    return item[filterOn];
                } else {
                    return item;
                }
            };

            angular.forEach(items, function (item) {
                var valueToCheck, isDuplicate = false;

                for (var i = 0; i < newItems.length; i++) {
                    if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                        isDuplicate = true;
                        break;
                    }
                }
                if (!isDuplicate) {
                    newItems.push(item);
                }

            });
            items = newItems;
        }
        return items;
    };
});

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('cmdate', filterByIds);

    /** @ngInject */
    function filterByIds($filter)
    {
        return function (input,format) {
            input= input*1000;
            var date = $filter('date')(new Date(input), format);
            return date;

        }
    }




})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('paymentStatus', paymentStatus)
        .filter('registrationSource', registrationSource)
        .filter('registrationStatus', RegistrationStatus);


    /** @ngInject */
    function toTrustedFilter($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    }

    function RegistrationStatus() {
        return function (value) {
            switch (value) {
                case -1:
                case '-1':
                    return 'מוקפא';
                case 0:
                case '0':
                    return 'לא פעיל';
                case 1:
                case '1':
                    return 'פעיל';
                case -2:
                case '-2':
                    return 'מחכה לאישור הורה נוסף';
            }
        }
    }

    /** @ngInject */
    function paymentStatus() {
        return function (value) {
            switch (value) {
                case 1:
                case '1':
                    return 'שולם';
                case 2:
                case '2':
                    return 'שולם לרכז';
                case 3:
                case '3':
                    return 'טרם אושר';
                case 4:
                case '4':
                    return 'שולם חלקית';
                case 5:
                case '5':
                    return 'הופקד לקופה';
                case 6:
                case '6':
                    return 'יצא להפקדה';
                case 7:
                case '7':
                    return 'הופקד';
                default:
                    return 'לא שולם';

            }
        };
    }

    /** @ngInject */
    function registrationSource() {
        return function (value) {
            switch (value) {
                case 1:
                case '1':
                    return 'פרופיל הורה';
                case 2:
                case '2':
                    return 'מערכת ניהול';
                case 3:
                case '3':
                    return 'הרשמה חיצונית';
                default:
                    return 'לא ידוע';

            }
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter() {
        return function (text) {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter() {
        return function (value) {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter() {
        return function (doc) {
            if (!doc) {
                return;
            }
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function ($1) {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('marvilixConfig', marvilixConfigProvider);

    /** @ngInject */
    function marvilixConfigProvider()
    {
        // Default configuration
        var marvilixConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            marvilixConfiguration = angular.extend({}, marvilixConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(marvilixConfiguration[configName]) )
                {
                    return false;
                }

                return marvilixConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                marvilixConfiguration[configName] = configValue;
            }
        };
    }

})();
angular.module('app.core').service('appConfig', function ($rootScope) {

    this.setMarvilix = function () {
        $rootScope.appName = 'marvilix';
        $rootScope.brandName = 'marvilix';
        $rootScope.favicon = 'marvilix.ico';
        $rootScope.orgType = 'RC';
        $rootScope.orgTypeBranchName = {single: 'יישוב', plural: 'יישובים'};
        $rootScope.eventModules = ['summerCamp', 'leisureAndAfterSchool', 'Kindergarten', 'InternalEvents', 'ReligiousServices', 'GoldenAge'];
        $rootScope.advancedCashierOptions = true;
        $rootScope.smsEnabled = true;
        this.appName = 'מערכת ניהול marvilix';
        this.locationHost = 'admin-marvilix.marvilix.com';
        this.localHostUrl = 'http://signmeapp.local';
        this.serverUrl = 'https://api.signmeapp.co.il';
        this.developmentHostUrl = 'http://regional-council-api-dev.marvilix.com';
        this.profileTokenName = 'marvilixProfileAccessToken';
        this.profilePathCokieName = 'marvilixProfilePath';
        this.adminTokenName = 'marvilixAdminToken';
        this.adminProfileTokenName = 'marvilixAdminProfileToken';
        this.developmentProfilePath = 'http://marvilix.marvilix.com/';
        this.prodctionProfilePath = 'https://marvilix-profile.signmeapp.co.il/';
        this.developmentExternalPath = 'http://events-marvilix.marvilix.com/';
        this.productionExternalPath = 'https://marvilix-events.signmeapp.co.il/';
        this.appDomain = 'signmeapp.co.il';
        this.backRoundImage = '/assets/images/login/marvilix.jpg';
        this.logo = '/assets/images/logos/marvilix.png';
        this.paymentCompany = 2;
        this.orgType = 'RC';
        $rootScope.memberYearLogicEnabled = false;
        $rootScope.automaticMonthlyCharge = false;
    };

    this.setLevhasharon = function () {
        $rootScope.appName = 'מועצה אזורית לב השרון';
        $rootScope.brandName = 'levhasharon';
        $rootScope.favicon = 'levhasharon.ico';
        $rootScope.orgType = 'RC';
        $rootScope.orgTypeBranchName = {single: 'יישוב', plural: 'יישובים'};
        $rootScope.eventModules = ['summerCamp', 'leisureAndAfterSchool', 'Kindergarten', 'InternalEvents', 'ReligiousServices', 'GoldenAge', 'Tourism', 'CommunitySecurity', 'psychology'];
        $rootScope.advancedCashierOptions = true;
        $rootScope.smsEnabled = true;
        this.appName = 'מערכת ניהול מועצה אזורית לב השרון';
        this.locationHost = 'admin-levhasharon.marvilix.com';
        this.localHostUrl = 'http://signmeapp.local';
        this.serverUrl = 'https://api.signmeapp.co.il';
        this.developmentHostUrl = 'http://regional-council-api-dev.marvilix.com';
        this.profileTokenName = 'levhasharonProfileAccessToken';
        this.profilePathCokieName = 'levhasharonProfilePath';
        this.adminTokenName = 'levhasharonAdminToken';
        this.adminProfileTokenName = 'levhasharonAdminProfileToken';
        this.developmentProfilePath = 'http://levhasharon.marvilix.com/';
        this.prodctionProfilePath = 'https://levhasharon-profile.signmeapp.co.il/';
        this.developmentExternalPath = 'http://events-levhasharon.marvilix.com/';
        this.productionExternalPath = 'https://levhasharon-events.signmeapp.co.il/';
        this.appDomain = 'signmeapp.co.il';
        this.backRoundImage = '/assets/images/login/levhasharon.jpg';
        this.logo = '/assets/images/logos/levhasharon.png';
        this.paymentCompany = 2;
        this.orgType = 'RC';
        $rootScope.memberYearLogicEnabled = false;
        $rootScope.automaticMonthlyCharge = false;
    };


    this.setMegido = function () {
        $rootScope.appName = 'מועצה אזורית מגידו';
        $rootScope.brandName = 'megido';
        $rootScope.favicon = 'megido.ico';
        $rootScope.orgType = 'RC';
        $rootScope.orgTypeBranchName = {single: 'יישוב', plural: 'יישובים'};
        $rootScope.eventModules = ['gilor', 'sports', 'education', 'library', 'reut', 'musicAndDance', 'megidoTech', 'youthCenter', 'internalCouncil', 'products'];
        $rootScope.advancedCashierOptions = true;
        $rootScope.smsEnabled = true;
        this.appName = 'מערכת ניהול מועצה אזורית מגידו';
        this.locationHost = 'sma-admin.marvilix.com';
        this.localHostUrl = 'http://signmeapp.local';
        this.serverUrl = 'https://megido-api.signmeapp.co.il';
        this.developmentHostUrl = 'https://sma-api.marvilix.com';
        this.profileTokenName = 'megidoProfileAccessToken';
        this.profilePathCokieName = 'megidoProfilePath';
        this.adminTokenName = 'megidoAdminToken';
        this.adminProfileTokenName = 'megidoAdminProfileToken';
        this.developmentProfilePath = 'https://sma-profile.marvilix.com/';
        this.prodctionProfilePath = 'https://megido.signmeapp.co.il/';
        this.developmentExternalPath = 'http://events-megido.marvilix.com/';
        this.productionExternalPath = 'https://megido-events.signmeapp.co.il/';
        this.appDomain = 'signmeapp.co.il';
        this.backRoundImage = '/assets/images/login/megido.jpg';
        this.logo = '/assets/images/logos/megido.png';
        this.paymentCompany = 2;
        this.orgType = 'RC';
        $rootScope.memberYearLogicEnabled = false;
        $rootScope.automaticMonthlyCharge = false;
    };

    this.setEmekIzrael = function () {
        $rootScope.appName = 'מועצה אזורית עמק יזרעאל';
        $rootScope.brandName = 'izrael';
        $rootScope.favicon = 'megido.ico';
        $rootScope.orgType = 'RC';
        $rootScope.orgTypeBranchName = {single: 'יישוב', plural: 'יישובים'};
        $rootScope.eventModules = ['sports', 'catedra', 'youthAndScholarship', 'omanut', 'yeshuvim', 'kidsAndYouth', 'Education','Revaha','RevachaPnimi'];
        $rootScope.advancedCashierOptions = true;
        $rootScope.smsEnabled = true;
        this.appName = 'מערכת ניהול מועצה אזורית עמק יזרעאל';
        this.locationHost = 'sma-admin.marvilix.com';
        this.localHostUrl = 'http://signmeapp.local';
        this.serverUrl = 'https://emekyizrael-api.signmeapp.co.il';
        this.developmentHostUrl = 'https://sma-api.marvilix.com';
        this.profileTokenName = 'izraelProfileAccessToken';
        this.profilePathCokieName = 'izraelProfilePath';
        this.adminTokenName = 'izraelAdminToken';
        this.adminProfileTokenName = 'izraelAdminProfileToken';
        this.developmentProfilePath = 'https://sma-profile.marvilix.com/';
        this.prodctionProfilePath = 'https://emekyizrael.signmeapp.co.il/';
        this.developmentExternalPath = 'http://events-izrael.marvilix.com/';
        this.productionExternalPath = 'https://emekyizrael-events.signmeapp.co.il/';
        this.appDomain = 'signmeapp.co.il';
        this.backRoundImage = '/assets/images/login/megido.jpg';
        this.logo = '/assets/images/logos/megido.png';
        this.paymentCompany = 2;
        this.orgType = 'RC';
        $rootScope.memberYearLogicEnabled = false;
        $rootScope.automaticMonthlyCharge = true;
    };


    if (location.hostname.indexOf('marvilix') >= 0) {
        this.setEmekIzrael();
    } else if (location.hostname.indexOf('levhasharon') >= 0) {
        this.setLevhasharon();
    } else if (location.hostname.indexOf('megido') >= 0) {
        this.setMegido();
    } else if (location.host.indexOf('emekyizrael') >= 0) {
        this.setEmekIzrael();
    } else if (location.host.indexOf('localhost') >= 0) {
        this.setMegido();
    } else {
        // eslint-disable-next-line angular/window-service
        window.location.href = 'https://signmeapp.co.il';
    }

});

(function ()
{
    'use strict';

    angular
        .module('app.upload', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/upload');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.upload')
        .controller('UploadController', UploadController);

    /**
     *
     * @param $rootScope
     * @param $scope
     * @param Upload - upload plugin
     * @param $mdDialog
     * @param uploadTo(required, string) - set the object that the files will be attached to
     * @param uploadID(required, string) - set the object ID
     * @param restrictTo(optional, array) - restrict to specific file extensions
     * @param Notification
     * @param appConfig
     * @constructor
     */
    function UploadController($rootScope,$scope,Upload,$mdDialog,uploadTo,uploadID,restrictTo,Notification,appConfig) {

        var vm = this;
        vm.bodyEl = angular.element('body');


        $scope.closeDialog = function () {
            $mdDialog.hide();
        };

        $scope.$watch('files', function () {
            $scope.upload($scope.files);
        });

        $scope.filesUploading = [];

        var uploadURL = '';
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            uploadURL = appConfig.localHostUrl+'/'+uploadTo+'/'+uploadID+'/files?brand='+$rootScope.brandName+'&XDEBUG_SESSION_START';

        else if (location.host === appConfig.locationHost)
            uploadURL = appConfig.developmentHostUrl+'/'+uploadTo+'/'+uploadID+'/files?brand='+$rootScope.brandName;

        else
            uploadURL = appConfig.serverUrl+'/'+uploadTo+'/'+uploadID+'/files?brand='+$rootScope.brandName;


        $scope.upload = function (files) {
            if (files && files.length) {
                angular.forEach(files,function (file,key) {
                    var ext = getFileType(file);
                    if(restrictTo.length==0 || restrictTo.indexOf(ext)!='-1') {
                        $scope.isUpload = true;
                        Notification.info("נא להמתין לסיום טעינת הקבצים");
                        Upload.upload({
                            url: uploadURL,
                            data: {
                                file: file
                            },
                            headers: {
                                Authorization: 'Bearer ' + $rootScope.User.AccessToken
                            }
                        }).then(function (resp) {
                            $rootScope.fileResp = resp;
                            $scope.isUpload = false;
                            $scope.isUploading(false)
                            $mdDialog.hide();
                            Notification.success("קבצים נטענו בהצלחה!")

                        },null, function (evt) {
                            file.progress = parseInt(100.0 * evt.loaded / evt.total);
                            var index = $scope.filesUploading.indexOf(file);
                            if(index=='-1') {
                                $scope.filesUploading.push(file);
                            } else {
                                $scope.filesUploading[index] = file;
                            }
                            $scope.isUploading(true)
                        });
                    } else {
                        Notification.error('פורמט הקובץ אינו מותר');
                    }
                })
            }
        };

        /**
         * Get the file extension
         * @param file
         * @returns {string}
         */
        var getFileType = function (file) {
            return file.name.substr(file.name.lastIndexOf('.')+1)
        };

        /**
         * Function to check whether a file is being uploaded
         * @param status
         * @returns true or false
         */
        $scope.isUploading = function (status) {
            return $scope.fileInProgress = status;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope,$rootScope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: false,
            suppressScrollY: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        $scope.$on('httpCommunication:updated', function() {
            vm.httpCommunication = $rootScope.httpCommunicationStatus == 'start';
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $location, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $cookies, student, searchEndpoint, studentsEndpoint, coordinatorsEndpoint, coordinate, parent, parentsEndpoint, event, eventsEndpoint, $interval,appConfig) {
        var vm = this;

        vm.downloadAnyDesk = function (){
            window.open('https://download.anydesk.com/AnyDesk.exe','_blank');
        }

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            /* en: {
             'title'      : 'English',
             'translation': 'TOOLBAR.ENGLISH',
             'code'       : 'en',
             'flag'       : 'us'
             },*/
            he: {
                'title': 'עברית',
                'translation': 'TOOLBAR.HEBREW',
                'code': 'he',
                'flag': 'il'
            },
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.moveToProfile = moveToProfile;
        vm.eventKeyPress = eventKeyPress;
        vm.getSearchItemString = getSearchItemString;
        vm.getEventGeneralTypeName = getEventGeneralTypeName;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function getEventGeneralTypeName(eventObject) {
            return event.modulesMap[eventObject.GeneralEventType].singleTitle;
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            delete $cookies.remove(appConfig.adminTokenName);
            delete $cookies.remove("path");
            location.reload();
            msNavigationService.removeAll();
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en' && lang.code !== 'he') {
                var message = 'marvilix supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top left',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }


        vm.selectedItem = null;
        vm.searchText = null;
        vm.querySearch = querySearch;
        vm.lastSearchText = null;

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */

        function querySearch(query) {
            if (query.length < 3 || vm.lastSearchText === query)
                return function () {};
            var params = {};
            vm.results = [];
            params.SearchText = query;
            return searchEndpoint.get(params, function (data) {
                vm.results = data;
                vm.move = false;
                vm.lastSearchText = query;
                return data;
            });
        }

        function eventKeyPress() {
            if (vm.searchTerm != undefined && vm.searchTerm.length > 0)
                searchEndpoint.get({SearchText: vm.searchTerm},function (data){
                    vm.searchOptions = data;
                })
        }

        function getData() {
            /* if (vm.interval)
                 $interval.cancel(vm.interval);
             vm.load=true;*/
            var params = {};
            vm.results = [];
            params.SearchText = vm.searchText;
            searchEndpoint.get(params, function (data) {
                vm.load = false;
                vm.results = data;
                vm.move = false;
                return data;
                /*$timeout(function () {
                    var element =  document.getElementById("fl-input-0");
                    if (element)
                        element.blur();
                    else{
                        element=document.getElementById("fl-input-1").blur();
                        element.focus();
                    }
                },500);
                $timeout(function () {
                    var element =  document.getElementById("fl-input-0");
                    if (element)
                        element.focus();
                    else {
                        element=document.getElementById("fl-input-1").blur();
                        element.focus();
                    }

                },1500);*/
            });
        }

        function getSearchItemString(item){
            if (item.Type === 'Students')
                return item.FullName + ' (חניך)';
            else if (item.Type === 'Coordinators')
                return item.FullName + ' ('+$rootScope.User.Coordinator+')';
            else if (item.Type === 'Parents')
                return item.FullName + ' (הורה)';
            else if (item.Type === 'Events')
                return item.FullName + ' ( '+vm.getEventGeneralTypeName(item)+')';
        }

        function moveToProfile(item) {
            vm.searchTerm = undefined;
            vm.searchOptions = undefined;
            if (item.Type === 'Students')
                $location.url('/student-profile?ID=' + item.ID);
            /*else if (item.Type === 'Coordinators')
                $location.url('/coordinator-profile?ID=' + item.ID);*/
            else if (item.Type === 'Parents')
                $location.url('/parent-profile?ID=' + item.ID);
            else if (item.Type === 'Events') {
                event.setActiveModule(item.GeneralEventType);
                $location.url('/event-management?ID=' + item.ID);
            }
        }


    }


})();

// comments out all modules i don't need - daniel 09/02/2017

(function ()
{
    'use strict';

    /**
     * Main module of the marvilix
     */
    angular
        .module('marvilix', [

            // Common 3rd Party Dependencies
            'uiGmapgoogle-maps',
            'textAngular',
            'xeditable',
            'vsGoogleAutocomplete',
            'moment-picker',
            'ngFileUpload',
            'tooltips',
            'textAngular',
            // Core
            'app.core',
            'app.save-changes',
            // Navigation
            'app.navigation',
            // Toolbar
            'app.toolbar',
            //Upload
            'app.upload',
            // Profile Panel
            //'app.profile-panel',
            'app.admin-profile-panel',
            // Apps
            'app.dashboard',
            // Pages
            'app.pages',
        ]);
})();

(function () {
    'use strict';

    angular
        .module('marvilix')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope) {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        $rootScope.editorCreated = function (editor,identifier) {
            if(! $rootScope.quillEditor)
                $rootScope.quillEditor = {};
            $rootScope.quillEditor[identifier] = editor;
            editor.format('align', 'right');
        }
    }
})();

(function ()
{
    'use strict';
    angular.module('app.core').service('privateIDCheck', privateIDCheck);

    /** @ngInject */
    function privateIDCheck()
    {
      this.privateIDCheck = function(privateID) {
          var tot = 0;
          var tz = String(privateID);
          for (i=0; i<8; i++)
          {
              var x = (((i%2)+1)*tz.charAt(i));
              if (x > 9)
              {
                  x =x.toString();
                  x=parseInt(x.charAt(0))+parseInt(x.charAt(1))
              }
              tot += x;
          }
          return (tot + parseInt(tz.charAt(8))) % 10 === 0;
        };
        return this;

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, marvilixGenerator, marvilixConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        marvilixGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( marvilixConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }

        //global dataTable action buttons rehook for responsive views
        $(document).on('click','table tr.child td.child span.dtr-data button',function(){
            var classList = '.' + $(this).attr('class').split(' ').join('.');
            $(this).parents('tr').prev().find('button'+classList).click();
        });
        $(document).on('click','table tr.child td.child span.dtr-data a',function(){
            var classList = '.' + $(this).attr('class').split(' ').join('.');
            $(this).parents('tr').prev().find('a'+classList).click();
        });
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, marvilixConfigProvider)
    {

        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // marvilix theme configurations
        marvilixConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, editableThemes)
    {
        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';
/*
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;


        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });*/
    }
})();

(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .config(routeConfig)


    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise('/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController',
                        controllerAs: 'vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController',
                        controllerAs: 'vm'
                    },
                    'upload@app'   : {
                        templateUrl: layouts[layoutStyle].upload,
                        controller : 'UploadController',
                        controllerAs: 'vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController',
                        controllerAs: 'vm'
                    },
                    'adminProfilePanel@app': {
                        templateUrl: 'app/main/pages/admin/admin-management/admin-profile-panel/admin-profile-panel.html',
                        controller : 'AdminProfilePanelController'
                    },
                    'studentPanel@app': {
                        templateUrl: 'app/main/pages/users/views/students/student-panel/student-panel.html',
                        controller : 'StudentPanelController'
                    },
                    'fieldPanel@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/profile-settings/field-panel/field-panel.html',
                        controller : 'FieldPanelController'
                    },
                    'generalDiscountPanel@app': {
                        templateUrl: 'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/general-discount-panel/general-discount-panel.html',
                        controller : 'GeneralDiscountPanelController'
                    },
                    'parentPanel@app': {
                        templateUrl: 'app/main/pages/users/views/parents/parent-panel/parent-panel.html',
                        controller : 'ParentPanelController'
                    },
                    'groupPanel@app': {
                        templateUrl: 'app/main/pages/branches/views/groups/groups-panel/groups-panel.html',
                        controller : 'GroupsPanelController'
                    },
                    'gradePanel@app': {
                        templateUrl: 'app/main/pages/branches/views/grades/grades-panel/grades-panel.html',
                        controller : 'GradesPanelController'
                    },

                    'coordinatorPanel@app': {
                        templateUrl: 'app/main/pages/admin/coordinators/coordinators-panel/coordinators-panel.html',
                        controller : 'CoordinatePanelController'
                    },

                    'questionPanel@app': {
                        templateUrl: 'app/main/pages/events-extras/views/questions/question-panel/question-panel.html',
                        controller : 'QuestionPanelController'
                    },
                    'categoryPanel@app': {
                        templateUrl: 'app/main/pages/settings-menue/views/categories/category-panel/category-panel.html',
                        controller : 'CategoryPanelController'
                    },
                    'transportationPanel@app': {
                        templateUrl: 'app/main/pages/events-extras/views/transportation/transportation-panel/transportation-panel.html',
                        controller : 'TransportationPanelController'
                    },

                    'manageSettlementsPanel@app': {
                        templateUrl: 'app/main/pages/branches/views/settlements/manage-settlements-panel/manage-settlements-panel.html',
                        controller : 'ManageSettlementsPanelController'
                    },
                    'activitiesPanel@app': {
                        templateUrl: 'app/main/pages/utils/views/activities/activities-panel/activities-panel.html',
                        controller : 'ActivitiesPanelController'
                    },
                    'editEventQuestionPanel@app': {
                        templateUrl: 'app/main/pages/events/views/events/event-management/tabs/questions/edit-event-question-panel/edit-event-question-panel.html',
                        controller : 'EditEventQuestionPanelController as vm'
                    },
                    'contactsPanel@app': {
                        templateUrl: 'app/main/pages/utils/views/contacts/contact-panel/contact-panel.html',
                        controller : 'ContactsPanelController'
                    },
                    'meetingPanel@app': {
                        templateUrl: 'app/main/pages/events-extras/views/attendance/event-meeting-panel/event-meeting-panel.html',
                        controller : 'EventMeetingPanelController'
                    },

                    'saveChanges@app': {
                        templateUrl: 'app/main/pages/save-changes/save-changes.html',
                        controller : 'SaveChangesController'
                    }
                }
            });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController($scope,$rootScope,marvilixTheming)
    {
        var vm = this;
        vm.splashScreen = false;
        // Data
        vm.themes = marvilixTheming.themes;


        $scope.$on('splashScreen:updated', function() {
            vm.splashScreen = $rootScope.splashScreen;
        });

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('marvilix');
})();

(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .config(config);

    /** @ngInject */
    function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide,momentPickerProvider,$mdIconProvider)
    {

        $mdIconProvider
            .defaultIconSet('../../assets/icons/mdi.svg');


        // Put your common app configurations here

        momentPickerProvider.options({
            locale: "he",
        });

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyDYpkAWSyEAl81EVv1CNKOk1bZtkDc-zrI',
            //v: '3.20',
            libraries: 'visualization,places',
            language: 'he'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('he');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('marvilix')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui', [
            'app.ui.forms',
            'app.ui.helper-classes',
            'app.ui.icons',
            'app.ui.material-colors',
            'app.ui.page-layouts.blank',
            'app.ui.page-layouts.carded.fullwidth',
            'app.ui.page-layouts.carded.fullwidth-ii',
            'app.ui.page-layouts.carded.left-sidenav',
            'app.ui.page-layouts.carded.left-sidenav-ii',
            'app.ui.page-layouts.carded.right-sidenav',
            'app.ui.page-layouts.carded.right-sidenav-ii',
            'app.ui.page-layouts.simple.fullwidth',
            'app.ui.page-layouts.simple.left-sidenav',
            'app.ui.page-layouts.simple.left-sidenav-ii',
            'app.ui.page-layouts.simple.left-sidenav-iii',
            'app.ui.page-layouts.simple.right-sidenav',
            'app.ui.page-layouts.simple.right-sidenav-ii',
            'app.ui.page-layouts.simple.right-sidenav-iii',
            'app.ui.page-layouts.simple.tabbed',
            'app.ui.theme-colors',
            'app.ui.typography'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('ui', {
            title : 'USER INTERFACE',
            group : true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('ui.forms', {
            title: 'Forms',
            icon : 'icon-window-restore',
            state: 'app.ui_forms'
        });

        msNavigationServiceProvider.saveItem('ui.icons', {
            title: 'Icons',
            icon : 'icon-file-image-box',
            state: 'app.ui_icons'
        });

        msNavigationServiceProvider.saveItem('ui.typography', {
            title: 'Typography',
            icon : 'icon-format-size',
            state: 'app.ui_typography'
        });

        msNavigationServiceProvider.saveItem('ui.helper-classes', {
            title: 'Helper Classes',
            icon : 'icon-help-circle',
            state: 'app.ui_helper-classes'
        });

        msNavigationServiceProvider.saveItem('ui.theme-colors', {
            title: 'Theme Colors',
            icon : 'icon-palette-advanced',
            state: 'app.ui_theme-colors'
        });

        msNavigationServiceProvider.saveItem('ui.material-colors', {
            title: 'Material Colors',
            icon : 'icon-palette',
            state: 'app.ui_material-colors'
        });


        msNavigationServiceProvider.saveItem('ui.page-layouts', {
            title: 'Page Layouts',
            icon : 'icon-view-quilt'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded', {
            title: 'Carded'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_carded_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth-ii', {
            title: 'Full Width (II)',
            state: 'app.ui_page-layouts_carded_fullwidth-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_carded_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_carded_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_carded_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_carded_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple', {
            title: 'Simple'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_simple_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_simple_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_simple_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-iii', {
            title: 'Left Sidenav (III)',
            state: 'app.ui_page-layouts_simple_left-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_simple_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_simple_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-iii', {
            title: 'Right Sidenav (III)',
            state: 'app.ui_page-layouts_simple_right-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.tabbed', {
            title: 'Tabbed',
            state: 'app.ui_page-layouts_simple_tabbed'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.blank', {
            title: 'Blank',
            state: 'app.ui_page-layouts_blank'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages_auth_forgot-password',
            'app.pages_auth_reset-password',
            'app.pages.manage-admins',
            'app.pages.admin-profile',
            'app.pages.users',
            'app.pages.branches',
            'app.pages.group-management',
            'app.pages.student-profile',
            'app.pages.coordinators-profile',
            'app.pages.parent-profile',
            'app.pages.new-educator',
            'app.pages.events',
            'app.pages.events-extras',
            'app.pages.event-management',
            'app.pages.event-meeting-management',
            'app.pages.location-management',
            'app.pages.new-coordinator',
            'app.pages.new-admin',
            'app.pages.activities-profile',
            'app.pages.accountancy',
            'app.pages.calendar',
            'app.pages.profile-forms',
            'app.pages.settings_menu',
            'app.pages.utils'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('pages', {
            title : '',
            group : true,
            weight: 1
        });
    }
})();

angular.module("marvilix").run(["$templateCache", function($templateCache) {$templateCache.put("app/upload/upload.html","<md-dialog aria-label=\"העלאת קבצים\" class=\"uploader\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהעלאת קבצים</span><md-button ng-disabled=\"isUpload\" class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"UPLOAD.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ngf-drop ngf-select ng-model=\"files\" ngf-multiple=\"true\">\n<div ng-if=\"filesUploading.length==0\" class=\"upload hfs26\"><span>גרור קבצים לכל מקום או לחץ כאן</span></div><div \nng-if=\"filesUploading.length>0\"><md-card ng-repeat=\"file in filesUploading\"><md-card-title><md-card-title-text><span \nclass=\"md-headline\">{{file.name}}</span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" \nlayout-align=\"end center\"><md-progress-linear md-mode=\"determinate\" value=\"{{file.progress}}\"></md-progress-linear>\n</md-card-actions></md-card></div></md-dialog-content></md-dialog>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" ng-if=\"$root.User\" \nmd-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex \nlayout=\"column\"><div ng-if=\"$root.User\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" \nui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" \nflex></md-content><md-sidenav id=\"quick-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"quick-panel\" \nms-scroll ui-view=\"quickPanel\"></md-sidenav><md-sidenav id=\"student-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"student-panel\" ms-scroll ui-view=\"studentPanel\"></md-sidenav><md-sidenav id=\"general-discount-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"general-discount-panel\" ms-scroll \nui-view=\"generalDiscountPanel\"></md-sidenav><md-sidenav id=\"group-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"groups-panel\" ms-scroll ui-view=\"groupPanel\"></md-sidenav><md-sidenav id=\"grade-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"grades-panel\" ms-scroll ui-view=\"gradePanel\"></md-sidenav>\n<md-sidenav id=\"parent-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"parent-panel\" ms-scroll \nui-view=\"parentPanel\"></md-sidenav><md-sidenav id=\"coordinate-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"coordinate-panel\" ms-scroll ui-view=\"coordinatorPanel\"></md-sidenav><md-sidenav \nid=\"admin-profile-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"admin-profile-panel\" \nmd-is-locked-open ms-scroll ui-view=\"adminProfilePanel\"></md-sidenav><md-sidenav id=\"question-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"question-panel\" ms-scroll ui-view=\"questionPanel\">\n</md-sidenav><md-sidenav id=\"category-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"category-panel\" ms-scroll ui-view=\"categoryPanel\"></md-sidenav><md-sidenav id=\"location-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"location-panel\" ms-scroll ui-view=\"locationPanel\">\n</md-sidenav><md-sidenav id=\"transportation-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"transportation-panel\" ms-scroll ui-view=\"transportationPanel\"></md-sidenav><md-sidenav \nid=\"activities-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"activities-panel\" ms-scroll \nui-view=\"activitiesPanel\"></md-sidenav><md-sidenav id=\"field-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"field-panel\" ms-scroll ui-view=\"fieldPanel\"></md-sidenav><md-sidenav id=\"edit-event-question-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"edit-event-question-panel\" ms-scroll \nui-view=\"editEventQuestionPanel\"></md-sidenav><md-sidenav id=\"manage-settlements-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"manage-settlements-panel\" ms-scroll \nui-view=\"manageSettlementsPanel\"></md-sidenav><md-sidenav id=\"contact-panel\" class=\"md-sidenav-left md-whiteframe-4dp\" \nmd-component-id=\"contact-panel\" ms-scroll ui-view=\"contactsPanel\"></md-sidenav><md-sidenav id=\"meeting-panel\" \nclass=\"md-sidenav-left md-whiteframe-4dp\" md-component-id=\"meeting-panel\" ms-scroll ui-view=\"meetingPanel\">\n</md-sidenav><md-sidenav-bottom id=\"save-changes\" class=\"flex-100 md-closed\" md-component-id=\"save-changes\" flex \nui-view=\"saveChanges\" tabindex=\"-1\"></md-sidenav-bottom></div><md-content ng-if=\"!$root.User\" ms-scroll \nui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" title=\"דפים מועדפים\" title-direction=\"bottom\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\">\n</md-icon></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div class=\"shortcut-add\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"add-icon\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!MsShortcuts.shotcutAddLoading\"><md-icon md-menu-align-target md-font-icon=\"icon-star-outline\" class=\"icon s24\">\n</md-icon></div><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsShortcuts.shotcutAddLoading\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular></div><input type=\"text\" placeholder=\"הוסף דף נוכחי\" flex ng-model=\"MsShortcuts.addName\" \nng-model-options=\"MsShortcuts.queryOptions\" ng-keydown=\"MsShortcuts.handleAddKeyDown($event)\"></div><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"חפש\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.shortcuts\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.shortcuts.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.shortcuts | filter: MsShortcuts.query\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div><div class=\"title\" ng-click=\"MsShortcuts.moveToShortcut(result)\">{{result.title}}</div></div></div><md-icon \nmd-font-icon=\"icon-trash\" class=\"icon s18\" ng-click=\"MsShortcuts.handleResultClick(result)\"></md-icon></div></div>\n</div></div></md-menu-content></md-menu></div><md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" \naria-label=\"Add shortcut\" ng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\" style=\"max-height: 100%\"><div layout=\"row\" layout-align=\"start center\" \nflex><md-button id=\"navigation-toggle\" class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'navigation\')\" \nhide-gt-sm aria-label=\"Toggle navigation\"></md-button><ms-shortcuts></ms-shortcuts><img alt=\"any desk\" \nng-click=\"vm.downloadAnyDesk()\" id=\"anydesk\" class=\"ml5 cp\" src=\"assets/icons/anydesk.svg\"><div \nclass=\"toolbar-separator\"></div><md-button ng-href=\"/dashboard\">חיפוש מהיר</md-button><div ng-submit=\"\" \nclass=\"hide-im-mobile fast-search\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nalt=\"\" ng-src=\"{{$root.User.ProfileImage || \'assets/images/avatars/profile.jpg\'}}\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-if=\"false\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide show-gt-sm>{{$root.User.FirstName}} {{$root.User.LastName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ui-sref=\"app.pages_admin-profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button aria-label=\"User Management\">המשתמש שלי</md-button></md-menu-item><md-menu-item \nng-if=\"$root.User.SuperAdmin==1\" class=\"md-indent\" ui-sref=\"app.pages_manage-admins\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"icon\"></md-icon><md-button>ניהול משתמשים</md-button></md-menu-item>\n<md-menu-item ng-if=\"$root.User.SuperAdmin==0 || $root.User.SuperAdmin==1\" class=\"md-indent\" \nui-sref=\"app.pages_users_coordinators\"><md-icon md-font-icon=\"icon-tie\" class=\"icon\"></md-icon><md-button>ניהול רכזים\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">יציאה מהמערכת</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><div \nclass=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{$root.appName}}</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable fg1\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation><div class=\"fcc logo-container\" ng-class=\"{\'httpOn\':vm.httpCommunication}\"><svg \nng-class=\"{\'httpOn\':vm.httpCommunication}\" class=\"mt5\" xmlns=\"http://www.w3.org/2000/svg\" \nxmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"68\" height=\"50\" viewBox=\"0 0 68 50\"><defs><linearGradient \nid=\"linear-gradient\" x1=\"0.349\" y1=\"0.171\" x2=\"0.91\" y2=\"0.823\" gradientUnits=\"objectBoundingBox\"><stop offset=\"0\" \nstop-color=\"#545ad2\"/><stop offset=\"0.515\" stop-color=\"#039be5\"/><stop offset=\"1\" stop-color=\"#3acca5\"/>\n</linearGradient><clipPath id=\"clip-_50\"><rect width=\"68\" height=\"50\"/></clipPath></defs><g id=\"_50\" data-name=\"50\" \nclip-path=\"url(#clip-_50)\"><rect width=\"68\" height=\"50\" fill=\"transparent\"/><g id=\"Group_2216\" data-name=\"Group 2216\" \ntransform=\"translate(808 1552.604)\"><g id=\"Group_1925\" class=\"change-colors-http\" data-name=\"Group 1925\" \ntransform=\"translate(-805.834 -1514.296)\"><path id=\"Path_2847\" data-name=\"Path 2847\" \nd=\"M4.466,223.277a2,2,0,0,1,2.251,1.615l.012.061h1l-.011-.085c-.2-1.567-1.439-2.5-3.318-2.5-1.809,0-3.025.989-3.025,2.462,0,1.189.817,1.969,2.362,2.253l1.445.282c.984.179,1.5.644,1.5,1.345,0,.95-.825,1.565-2.1,1.565a2.312,2.312,0,0,1-2.569-1.992l-.01-.064H1l.009.084c.2,1.847,1.491,2.907,3.539,2.907,1.9,0,3.172-1.044,3.172-2.6,0-1.187-.8-1.941-2.374-2.24l-1.262-.245c-1.087-.193-1.639-.646-1.639-1.345,0-.913.792-1.5,2.017-1.5\" \ntransform=\"translate(-1.004 -222.367)\" fill=\"#fff\"/><rect id=\"Rectangle_1803\" data-name=\"Rectangle 1803\" width=\"0.983\" \nheight=\"5.806\" transform=\"translate(8.369 2.852)\" fill=\"#fff\"/><path id=\"Path_2848\" data-name=\"Path 2848\" \nd=\"M51.39,223.258a.638.638,0,0,0-.651.638.63.63,0,0,0,.651.638.637.637,0,0,0,.663-.638.644.644,0,0,0-.663-.638\" \ntransform=\"translate(-42.53 -223.111)\" fill=\"#fff\"/><path id=\"Path_2849\" data-name=\"Path 2849\" \nd=\"M72.256,239.174a3.15,3.15,0,0,0-2.054-.716,2.912,2.912,0,0,0-2.927,3.025,2.955,2.955,0,0,0,2.927,2.976,3.149,3.149,0,0,0,2.054-.716v.749h-.012v.075a1.8,1.8,0,0,1-1.895,1.944,1.754,1.754,0,0,1-1.86-1.274l-.013-.06H67.47l.014.087a2.928,2.928,0,0,0,5.756-.7v-5.913h-.983Zm0,3.387a2.3,2.3,0,0,1-1.944,1.013,2.069,2.069,0,0,1-2.042-2.091,2.047,2.047,0,0,1,2.042-2.14,2.3,2.3,0,0,1,1.944,1.013Z\" \ntransform=\"translate(-56.336 -235.802)\" fill=\"#fff\"/><path id=\"Path_2850\" data-name=\"Path 2850\" \nd=\"M117.437,238.532a2.983,2.983,0,0,0-2.017.755v-.571h-.983v5.806h.983v-4.065a2.371,2.371,0,0,1,1.87-1,1.59,1.59,0,0,1,1.65,1.772v3.294h.983V241.19a2.439,2.439,0,0,0-2.486-2.658\" \ntransform=\"translate(-95.713 -235.864)\" fill=\"#fff\"/><path id=\"Path_2851\" data-name=\"Path 2851\" \nd=\"M161.769,229.037l-3.311-5.558h-.791v8.474h1.02l-.024-6.251,2.769,4.611h.673l2.745-4.575-.012,6.215h1.02v-8.474h-.779Z\" \ntransform=\"translate(-131.808 -223.295)\" fill=\"#fff\"/><path id=\"Path_2852\" data-name=\"Path 2852\" \nd=\"M220,238.755a3.056,3.056,0,0,0,0,6.111,2.659,2.659,0,0,0,2.642-1.642l.034-.1H221.62l-.02.043a1.652,1.652,0,0,1-1.572.826A1.974,1.974,0,0,1,218,242.21h4.73l.081.041.012-.108a3.4,3.4,0,0,0,.013-.364A2.85,2.85,0,0,0,220,238.755m-.024.873a1.839,1.839,0,0,1,1.85,1.783H218a1.976,1.976,0,0,1,1.982-1.783\" \ntransform=\"translate(-181.339 -236.05)\" fill=\"#fff\"/><path id=\"Path_2853\" data-name=\"Path 2853\" \nd=\"M258.335,223.109l-3.85,8.535h1.1l1.077-2.423h4.271l1.077,2.423h1.1l-3.85-8.535Zm2.172,5.165H257.08l1.708-3.862Z\" \ntransform=\"translate(-212.645 -222.986)\" fill=\"#fff\"/><path id=\"Path_2854\" data-name=\"Path 2854\" \nd=\"M315.97,238.755a2.951,2.951,0,0,0-1.968.7V238.9h-.983v8.841H314v-3.575a2.952,2.952,0,0,0,1.968.7,3.056,3.056,0,0,0,0-6.111M314,240.64a2.186,2.186,0,0,1,1.87-1,2.171,2.171,0,0,1,0,4.341,2.186,2.186,0,0,1-1.87-1Z\" \ntransform=\"translate(-261.517 -236.05)\" fill=\"#fff\"/><path id=\"Path_2855\" data-name=\"Path 2855\" \nd=\"M360.685,238.755a2.951,2.951,0,0,0-1.969.7V238.9h-.983v8.841h.983v-3.575a2.951,2.951,0,0,0,1.969.7,3.056,3.056,0,0,0,0-6.111m-1.969,1.885a2.186,2.186,0,0,1,1.871-1,2.171,2.171,0,0,1,0,4.341,2.186,2.186,0,0,1-1.871-1Z\" \ntransform=\"translate(-298.851 -236.05)\" fill=\"#fff\"/></g><path id=\"Union_3\" data-name=\"Union 3\" \nd=\"M13.042,32.486c-6.3-.081-8.566-5.3-9.656-7.8l-.086-.2C2.286,22.162.284,17.871.264,17.828A2.806,2.806,0,0,1,5.35,15.455c.083.179,2.052,4.4,3.094,6.786l.089.2c1.154,2.655,2.1,4.4,4.582,4.43h.077A2.957,2.957,0,0,0,15.91,25.6a3.65,3.65,0,0,0,.249-3.319c-.492-1.032-1.422-2.907-2.322-4.72-.931-1.877-1.811-3.649-2.259-4.6a8.753,8.753,0,0,1,3.634-11.6A9.7,9.7,0,0,1,19.851.141a8.6,8.6,0,0,1,2.216.288,8.2,8.2,0,0,1,5.023,3.854c.7,1.243,2.6,4.925,4.346,8.339a4.106,4.106,0,0,0-1.021-.132h0a4.153,4.153,0,0,0-3.909,2.764l-.011.033c-1.738-3.4-3.633-7.073-4.3-8.252s-2.35-1.808-4.3-.744a3.148,3.148,0,0,0-1.25,4.272c.426.9,1.335,2.732,2.215,4.5.91,1.833,1.85,3.729,2.362,4.8a9.228,9.228,0,0,1-.589,8.759,8.486,8.486,0,0,1-7.448,3.861Zm46.1-1.807-9.73-20.8a4.186,4.186,0,0,0-.19-.722,4.114,4.114,0,0,0-5-2.562l2.459-5.023A2.806,2.806,0,0,1,49.2,0h.025a2.806,2.806,0,0,1,2.517,1.617L64.226,28.3a2.806,2.806,0,1,1-5.083,2.378ZM35.3,32.033a2.794,2.794,0,0,1-1.084-.9,2.836,2.836,0,0,1-.351-.564c-.037-.08-3.776-8.041-6-12.715a2.829,2.829,0,1,1,5.107-2.435c1.024,2.149,2.366,4.988,3.522,7.441L42.8,9.375a2.807,2.807,0,0,1,2.527-1.618h.033a2.807,2.807,0,0,1,2.523,4L39.034,30.679a2.8,2.8,0,0,1-3.73,1.353Zm11.027-9.558a3.006,3.006,0,1,1,3.006,3.006A3.006,3.006,0,0,1,46.331,22.475Z\" \ntransform=\"translate(-806 -1551)\" fill=\"url(#linear-gradient)\"/></g></g></svg></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/ui/helper-classes/helper-classes.html","<div id=\"helper-classes\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Helper Classes</div></div></div><div class=\"content\" layout=\"column\"><md-tabs md-dynamic-height><md-tab \nlabel=\"Padding & Margin Helpers\"><div class=\"md-title\">Padding Helpers</div><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>no-padding</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"no-padding\">No padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>padding-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"padding-5\">5px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>p-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"p-15\">15px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"padding-8\">8px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>p-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"p-32\">\n32px padding</span></hljs></div></div><div class=\"md-title\">Direction Specific Padding Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>\npadding-top-(5x)</span> <span>padding-right-(5x)</span> <span>padding-bottom-(5x)</span> <span>padding-left-(5x)</span>\n <span>padding-horizontal-(5x)</span> <span>padding-vertical-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-5\">5px from top</span> <span \nclass=\"padding-right-25\">25px from right</span> <span class=\"padding-bottom-10\">10px from bottom</span> <span \nclass=\"padding-left-20\">20px from left</span> <span class=\"padding-horizontal-5\">5px from left and right</span> <span \nclass=\"padding-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>pt-(5x)</span> <span>pr-(5x)</span> <span>pb-(5x)</span> <span>pl-(5x)</span> <span>ph-(5x)</span> <span>\npv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-5\">5px from top</span> <span class=\"pr-25\">25px from right</span> <span class=\"pb-10\">10px from bottom</span>\n <span class=\"pl-20\">20px from left</span> <span class=\"ph-5\">5px from left and right</span> <span class=\"pv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-top-(8x)</span> <span>padding-right-(8x)</span> <span>padding-bottom-(8x)</span> <span>padding-left-(8x)</span>\n <span>padding-horizontal-(8x)</span> <span>padding-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-8\">8px from top</span> <span \nclass=\"padding-right-24\">24px from right</span> <span class=\"padding-bottom-16\">16px from bottom</span> <span \nclass=\"padding-left-8\">8px from left</span> <span class=\"padding-horizontal-8\">8px from left and right</span> <span \nclass=\"padding-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>pt-(8x)</span> <span>pr-(8x)</span> <span>pb-(8x)</span> <span>pl-(8x)</span> <span>ph-(8x)</span> <span>\npv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-8\">8px from top</span> <span class=\"pr-24\">24px from right</span> <span class=\"pb-16\">16px from bottom</span>\n <span class=\"pl-8\">8px from left</span> <span class=\"ph-8\">8px from left and right</span> <span class=\"pv-8\">\n8px from top and bottom</span></hljs></div></div><div class=\"md-title\">Margin Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>no-margin</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"no-margin\">No margin</span></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>margin-(5x)</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-5\">5px margin</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>m-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"m-15\">15px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>margin-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"margin-8\">8px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>m-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"m-32\">32px margin</span></hljs></div></div><div class=\"md-title\">\nDirection Specific Margin Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 5, Max:100</div><span>margin-top-(5x)</span> <span>margin-right-(5x)</span> <span>margin-bottom-(5x)\n</span> <span>margin-left-(5x)</span> <span>margin-horizontal-(5x)</span> <span>margin-vertical-(5x)</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-5\">5px from top\n</span> <span class=\"margin-right-25\">25px from right</span> <span class=\"margin-bottom-10\">10px from bottom</span> \n<span class=\"margin-left-20\">20px from left</span> <span class=\"margin-horizontal-5\">5px from left and right</span> \n<span class=\"margin-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div\n class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>mt-(5x)</span> <span>mr-(5x)</span> <span>mb-(5x)</span> <span>ml-(5x)</span> <span>mh-(5x)</span> <span>\nmv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-5\">5px from top</span> <span class=\"mr-25\">25px from right</span> <span class=\"mb-10\">10px from bottom</span>\n <span class=\"ml-20\">20px from left</span> <span class=\"mh-5\">5px from left and right</span> <span class=\"mv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\nmargin-top-(8x)</span> <span>margin-right-(8x)</span> <span>margin-bottom-(8x)</span> <span>margin-left-(8x)</span> \n<span>margin-horizontal-(8x)</span> <span>margin-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-8\">8px from top</span> <span \nclass=\"margin-right-24\">24px from right</span> <span class=\"margin-bottom-16\">16px from bottom</span> <span \nclass=\"margin-left-8\">8px from left</span> <span class=\"margin-horizontal-8\">8px from left and right</span> <span \nclass=\"margin-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>mt-(8x)</span> <span>mr-(8x)</span> <span>mb-(8x)</span> <span>ml-(8x)</span> <span>mh-(8x)</span> <span>\nmv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-8\">8px from top</span> <span class=\"mr-24\">24px from right</span> <span class=\"mb-16\">16px from bottom</span>\n <span class=\"ml-8\">8px from left</span> <span class=\"mh-8\">8px from left and right</span> <span class=\"mv-8\">\n8px from top and bottom</span></hljs></div></div></md-tab><md-tab label=\"Width & Height Helpers\"><div class=\"md-title\">\nWidth Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>width-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"width-5\">5px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>w-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"w-350\">350px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>\nwidth-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"width-8\">8px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>w-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"w-560\">\n560px fixed width</span></hljs></div></div><div class=\"md-title\">Height Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>\nheight-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"height-5\">5px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>h-(5x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-350\">\n350px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>height-(8x)</span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"height-8\">\n8px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>h-(8x)</span></div>\n<hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-560\">\n560px fixed height</span></hljs></div></div></md-tab><md-tab label=\"Border Helpers\"><div class=\"md-title\">\nBorder Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>border</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border\">Border on all sides</span>\n</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>b</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"b\">Border on all sides</span></hljs></div></div><div class=\"md-title\">Direction Specific Border Helpers\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>border-top</span> <span>border-right</span> <span>border-bottom\n</span> <span>border-left</span> <span>border-horizontal</span> <span>border-vertical</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border-top\">Border top</span> <span \nclass=\"border-right\">Border right</span> <span class=\"border-bottom\">Border bottom</span> <span class=\"border-left\">\nBorder left</span> <span class=\"border-horizontal\">Border left and right</span> <span class=\"border-vertical\">\nBorder top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span>bt</span> <span>br</span> <span>bb</span> <span>bl</span> <span>bh</span> <span>\nbv</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"bt\">\nBorder top</span> <span class=\"br\">Border right</span> <span class=\"bb\">Border bottom</span> <span class=\"bl\">\nBorder left</span> <span class=\"bh\">Border left and right</span> <span class=\"bv\">Border top and bottom</span></hljs>\n</div></div><div class=\"md-title\">Border Radius Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 1, Max:12</div><span>brad-*</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"brad-2\">2px border radius</span> <span class=\"brad-5\">\n5px border radius</span></hljs></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/material-colors/material-colors.html","<div id=\"material-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Material Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div \nclass=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height md-swipe-content><md-tab \nng-repeat=\"(paletteName, palette) in vm.palettes\" \nmd-on-select=\"vm.selected = paletteName; vm.selectedPalette = palette\"><md-tab-label><span class=\"text-capitalize\">\n{{paletteName}}</span></md-tab-label></md-tab></md-tabs><md-content class=\"color-tab\"><div class=\"h3 pb-16\">\nmarvilix has classes for every single color from <a \nhref=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" target=\"_blank\">\nMaterial Design Color Palette</a>\n for your convenient. You can use them with pretty much every element except Angular Material directives.</div><div \nclass=\"color-header colored-bg\" ng-class=\"\'md-\'+vm.selected+\'-bg\'\" layout=\"row\" layout-align=\"start start\" layout-wrap \nlayout-padding><div flex=\"100\"><h3 class=\"text-capitalize\">{{vm.selected}}</h3></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div>500</div><div>\nrgb({{vm.selectedPalette[\'500\'].value[0]}},{{vm.selectedPalette[\'500\'].value[1]}},{{vm.selectedPalette[\'500\'].value[2]}})\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"colored-bg\" \nng-repeat=\"(hue, hueValue) in vm.selectedPalette\" flex=\"100\" layout=\"row\" layout-sm=\"column\" layout-padding \nng-class=\"vm.selected+\'-\'+hue+\'-bg\'\"><div flex>{{hue}}</div><div class=\"colored-bg\" \nng-class=\"\'md-\'+vm.selected+\'-\'+hue+\'-bg\'\" flex>.{{\'md-\'+vm.selected+\'-\'+hue+\'-bg\'}}</div><div flex>\n.{{vm.selected+\'-\'+hue+\'-bg\'}}</div><div class=\"fg-box white-bg md-whiteframe-2dp\" \nng-class=\"vm.selected+\'-\'+hue+\'-fg\'\">.{{vm.selected+\'-\'+hue+\'-fg\'}}</div></div></div></md-content></div></div>");
$templateCache.put("app/main/ui/forms/forms.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Forms</div></div></div><div class=\"content\" layout=\"column\"><div class=\"md-title\">Stepper</div><div \nclass=\"pb-16\"><b>ms-stepper</b>\n is a custom made form wizard directive. It follows Google\'s Material Design specifications and we recommend you to use it. If for some reason, it\'s not suitable for your project, you can always use the Form Wizard that we put together using md-tabs and forms.\n</div><form name=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.submitHorizontalStepper()\" \nng-model=\"vm.horizontalStepper\" novalidate><ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-1.html\'\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.horizontalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-2.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.horizontalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-3.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-4.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-5.html\'\"></div></ms-horizontal-stepper-step></form><div \nclass=\"mv-24\"></div><form name=\"verticalStepper\" ms-vertical-stepper ng-submit=\"vm.submitVerticalStepper()\" \nng-model=\"vm.verticalStepper\" novalidate><ms-vertical-stepper-step ng-form=\"verticalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-1.html\'\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.verticalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-2.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.verticalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-3.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-4.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-5.html\'\"></div></ms-vertical-stepper-step></form><div \nclass=\"md-title mt-32\">Form Wizard</div><div class=\"pb-16\">\nForm wizard is a combination of md-tabs and forms that we have created for you. You can have as many steps as you want.\n</div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Personal Information</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Lastname\" \nrequired><div ng-messages=\"wizardStep1.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLastname field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><input \ntype=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"wizardStep1.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input type=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" placeholder=\"Password\" required><div \nng-messages=\"wizardStep1.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.formWizard.passwordConfirm\" placeholder=\"Password (Confirm)\" required><div \nng-messages=\"wizardStep1.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword (Confirm) field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Address</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>City</label>\n<input type=\"text\" name=\"city\" ng-model=\"vm.formWizard.city\"></md-input-container><md-input-container flex><label>State\n</label><md-select ng-model=\"vm.formWizard.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">\n{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>Postal Code</label><input \nname=\"postalcode\" ng-model=\"vm.formWizard.postalCode\" placeholder=\"12345\" required ng-pattern=\"/^[0-9]{5}$/\" \nmd-maxlength=\"5\"><div ng-messages=\"wizardStep2.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>\nThat doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>\nPostal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Address</label><textarea ng-model=\"vm.formWizard.address\" md-maxlength=\"150\" max-rows=\"5\" \nrequired></textarea><div ng-messages=\"wizardStep2.address.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Address field is required.</span></div><div ng-message=\"md-maxlength\"><span>\nAddress can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Payment Method</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"cardholder\" ng-model=\"vm.formWizard.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"wizardStep3.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.formWizard.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"wizardStep3.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.formWizard.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required><div \nng-messages=\"wizardStep3.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>CC2 field is required.\n</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" \nng-model=\"vm.formWizard.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"wizardStep3.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Send</md-button></div></ms-form-wizard></div><div class=\"md-title mt-32\">\nBasic form with validation</div><div class=\"pb-16\">\nWith this form example, Submit button will only be activated if all the required fields are filled and if there is no error on the form.\n</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"form-title\">Optional form title</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"firstname\" ng-model=\"vm.basicForm.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"basicForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"lastname\" ng-model=\"vm.basicForm.lastname\" placeholder=\"Lastname\" required><div \nng-messages=\"basicForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nCity</label><input type=\"text\" name=\"city\" ng-model=\"vm.basicForm.city\"></md-input-container><md-input-container flex>\n<label>State</label><md-select ng-model=\"vm.basicForm.state\"><md-option ng-repeat=\"state in vm.states\" \nvalue=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>\nPostal Code</label><input name=\"postalcode\" ng-model=\"vm.basicForm.postalCode\" placeholder=\"12345\" required \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.postalcode.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div \nng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\">\n<span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Biography</label><textarea ng-model=\"vm.basicForm.biography\" md-maxlength=\"150\" max-rows=\"5\">\n</textarea></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></form></div><div \nclass=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex=\"40\"><div class=\"form-title\">Form ng-model data</div><div\n class=\"json-data-wrapper\"><pre>{{vm.basicForm | json}}</pre></div></div></div></div></div>");
$templateCache.put("app/main/ui/icons/icons.html","<div id=\"icons\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Icons</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://materialdesignicons.com/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\" layout=\"column\">\n<md-input-container class=\"md-block\"><label>Search an icon</label><input ng-model=\"vm.searchText\"></md-input-container>\n<div id=\"icons-list\" class=\"card md-whiteframe-1dp\" layout=\"row\" layout-wrap><div class=\"item\" \nng-repeat=\"icon in vm.icons | filter:{properties: {name:vm.searchText}} track by icon.properties.id\" \nlayout-align=\"start center\"><i class=\"icon icon-{{::icon.properties.name}} s40\"></i><div \nclass=\"name secondary-text text-center\">icon-{{::icon.properties.name}}</div></div></div></div></div>");
$templateCache.put("app/main/ui/theme-colors/theme-colors.html","<div id=\"theme-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Theme Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-warn reference-button\" ng-click=\"vm.createTheme($event);\"><md-icon md-font-icon=\"icon-palette\">\n</md-icon><span>Create Your Own Theme!</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" \nmd-dynamic-height md-swipe-content md-stretch-tabs=\"always\"><md-tab label=\"Primary Color\"><md-content \nclass=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/primary/primary.html\'\"></md-content></md-tab><md-tab \nlabel=\"Accent Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/accent/accent.html\'\">\n</md-content></md-tab><md-tab label=\"Warn Color\"><md-content class=\"color-tab\" \nng-include=\"\'app/main/ui/theme-colors/tabs/warn/warn.html\'\"></md-content></md-tab><md-tab label=\"Background Color\">\n<md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/background/background.html\'\"></md-content>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/typography/typography.html","<div id=\"typography\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Typography</div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Headings\"><div class=\"md-title\">Material design headings\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\" flex><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption secondary-text\">112px</div><span\n class=\"md-display-4\">Display 4</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"md-display-4\">Display 4</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">56px</div><span class=\"md-display-3\">Display 3</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-3\">Display 3</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">45px</div><span class=\"md-display-2\">Display 2</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-2\">Display 2</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">34px</div><span class=\"md-display-1\">Display 1</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-1\">Display 1</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">24px</div><span class=\"md-headline\">Headline</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-headline\">Headline</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">20px</div><span class=\"md-title\">Title</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-title\">Title</span></hljs></div>\n<div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><span class=\"md-subhead\">Subhead</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-subhead\">Subhead</span></hljs>\n</div></div><div class=\"md-title\">Headings</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">24px</div><h1>Heading 1</h1></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h1>Heading 1</h1><div class=\"h1\">Heading 1</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">20px</div><h2>Heading 2</h2></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h2>Heading 2</h2><div class=\"h2\">Heading 2</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><h3>Heading 3</h3></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h3>Heading 3</h3><div class=\"h3\">Heading 3</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">14px</div><h4>Heading 4</h4></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h4>Heading 4</h4><div class=\"h4\">Heading 4</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">13px</div><h5>Heading 5</h5></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h5>Heading 5</h5><div class=\"h5\">Heading 5</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">12px</div><h6>Heading 6</h6></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h6>Heading 6</h6><div class=\"h6\">Heading 6</div></hljs></div></div>\n</md-tab><md-tab label=\"Inline Text Elements\"><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><abbr \ntitle=\"Cascaded Style Sheet\">CSS</abbr></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><abbr title=\"Cascaded Style Sheet\">CSS</abbr></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>\nThis is a <mark>marked</mark> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <mark>marked</mark> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><del>\nThis is a deleted text.</del></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><del>This is a deleted text.</del></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><s>This is a strike-through text.</s></span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><s>\nThis is a strike-through text.</s></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span><u>This is an underlined text.</u></span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><u>This is an underlined text.</u></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span><small>This is a small text.</small></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><small>This is a small text.</small></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><strong>\nThis is a strong text.</strong></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scrollx><strong>This is a strong text.</strong></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><em>\nThis is an italic text.</em></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><em>This is an italic text.</em></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-super\">super</span>\n text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\nThis is a <span class=\"text-super\">super</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-sub\">sub</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-sub\">sub</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-capitalize\">capitalized</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-capitalized\">capitalized</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is an <span class=\"text-uppercase\">uppercase\n</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll>This is an <span class=\"text-uppercase\">uppercase</span> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span \nclass=\"text-lowercase\">LOWERCASE</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <span class=\"text-lowercase\">LOWERCASE</span> text.</hljs></div>\n</div></md-tab><md-tab label=\"Blockquotes & Lists\"><div class=\"md-title\">Blockquotes</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe\n</footer></blockquote></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><blockquote class=\"reverse\"><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote class=\"reverse\"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p>\n<footer>John Doe</footer></blockquote></hljs></div></div><div class=\"md-title\">Lists</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><ol><li>Ordered list item</li><li>Ordered list item<ol><li>\nOrdered list item</li><li>Ordered list item</li></ol></li><li>Ordered list item</li><li>Ordered list item</li></ol>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><ol><li>\nOrdered list item</li><li>Ordered list item<ol><li>Ordered list item</li><li>Ordered list item</li></ol></li><li>\nOrdered list item</li><li>Ordered list item</li></ol></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><ul><li>Unordered list item</li><li>Unordered list item\n<ul><li>Unordered list item</li><li>Unordered list item</li></ul></li><li>Unordered list item</li><li>\nUnordered list item</li></ul></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><ul><li>Unordered list item</li><li>Unordered list item<ul><li>Unordered list item</li><li>\nUnordered list item</li></ul></li><li>Unordered list item</li><li>Unordered list item</li></ul></hljs></div></div><div \nclass=\"md-title\">Definition lists</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><dl><dt>Definition term</dt>\n<dd>This is the definition description</dd><dt>Another definition term</dt><dd>\nThis is also another definition description</dd></dl></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>\nAnother definition term</dt><dd>This is also another definition description</dd></dl></hljs></div></div></md-tab>\n<md-tab label=\"Helpers\"><div class=\"md-title\">Font weight</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div\n layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">From 100 to 900</div><span class=\"font-weight-100\">font-weight: 100</span> <span>...</span> \n<span class=\"font-weight-900\">font-weight: 900</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-weight-100\">100 font weight</span> ... <span \nclass=\"font-weight-900\">900 font weight</span></hljs></div></div><div class=\"md-title\">Font Size</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiplies of 2, max: 120</div><span \nclass=\"font-size-20\">font-size: 20</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-size-20\">font-size: 20</span></hljs></div></div><div \nclass=\"md-title\">Line Height</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiplies of 2, max: 120</div><span>line-height: 2</span> <span>...</span> <span>line-height: 120</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"line-height-2\">\n2px line height</span> ... <span class=\"line-height-120\">120px line height</span></hljs></div></div><div \nclass=\"md-title\">Other helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-left\">\nLeft aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll><div class=\"text-left\">Left aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-center\">Center aligned text</div>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div \nclass=\"text-center\">Center aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-right\">Right aligned text</div></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-right\">\nRight aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed\">Boxed text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed\">Boxed text\n</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview md-grey-700-bg\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed-light\">Boxed text light</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed-light\">\nBoxed text light</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-strike\">Strike-through text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-strike\">\nStrike-through text</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-italic\">Italic text</div></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-italic\">Italic text\n</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><div class=\"text-semibold\">Semi-bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-semibold\">Semi-bold text</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"text-bold\">Bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><div class=\"text-bold\">Bold text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></hljs></div>\n</div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/apps/dashboard/dashboard.html","<div id=\"dashboard\" class=\"page-layout simple right-sidenav\" ng-init=\"vm.init()\" ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-gt-sm=\"row\"><div class=\"user-info\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div><div class=\"name\">\nשלום {{$root.User.FirstName}}</div><div class=\"hsf13 small-name\">{{vm.appConfig.appName}}</div></div></div></div><div \nclass=\"content\" flex><div><header class=\"md-accent-bg\"><div class=\"title\">חיפוש מהיר</div></header><md-content \nclass=\"quick-search-container\"><form><div layout=\"row\" class=\"aic\"><div flex=\"75\" flex-gt-sm=\"25\"><div \nclass=\"quick-search\"><md-input-container class=\"md-block\"><label>חיפוש מהיר</label><input \nng-model=\"vm.quickSearchTerm\" id=\"quick-search-input\"></md-input-container></div></div><div><md-button type=\"submit\" \nng-click=\"vm.getQuickSearch()\" class=\"md-raised md-accent\" aria-label=\"חפש\">סינון</md-button></div></div></form><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"vm.quickSearchLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"quick-search-results\" \nng-if=\"vm.quickSearchResultsShow\"><div class=\"quick-search-table-c\"><table id=\"quick-search-Table\" \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"searchObject in vm.quickSearchResults\"><td><strong>{{searchObject.FullName}}</strong><div \nng-if=\"searchObject.PrivateID\">{{searchObject.PrivateID}}</div></td><td><span ng-if=\"searchObject.Type == \'Students\'\">\nחניך</span> <span ng-if=\"searchObject.Type == \'Parents\'\">הורה</span> <span ng-if=\"searchObject.Type == \'Events\'\">\n{{vm.getEventGeneralTypeName(searchObject)}}</span></td><td><md-button \nng-if=\"searchObject.Type == \'Students\' || searchObject.Type == \'Parents\'\" ng-click=\"vm.editsearchObject(searchObject)\" \nclass=\"preview-user md-icon-button\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button><md-button \nng-if=\"searchObject.Type == \'Events\'\" ng-click=\"vm.goToEvent(searchObject)\" class=\"preview-user md-icon-button\" \ntitle=\"צפייה באירוע\"><md-icon md-svg-icon=\"settings\"></md-icon></md-button><md-button \nng-if=\"searchObject.Type == \'Students\'\" class=\"preview-user md-icon-button\" \nhref=\"/student-profile?ID={{searchObject.ID}}\" title=\"צפייה בפרופיל\"><md-icon md-svg-icon=\"settings\"></md-icon>\n</md-button><md-button ng-if=\"searchObject.Type == \'Parents\'\" class=\"preview-user md-icon-button\" \nhref=\"/parent-profile?ID={{searchObject.ID}}\" title=\"צפיה בפרופיל\"><md-icon md-svg-icon=\"settings\"></md-icon>\n</md-button><md-button ng-if=\"searchObject.Type == \'Parents\'\" class=\"preview-user md-icon-button\" \nng-click=\"vm.loginToProfile(searchObject)\" title=\"מעבר לפרופיל הורה\"><md-icon md-svg-icon=\"login\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></md-content></div><div><header class=\"md-accent-bg\"><div \nclass=\"md-toolbar-tools\"><div class=\"title\">סטטיסטיקה</div><div class=\"select-settlement\"><md-select \nng-model=\"vm.selectedSettlement\" ng-disabled=\"!vm.settlements\" class=\"md-accent-theme\" ng-change=\"vm.getStatistics()\" \nplaceholder=\"בחירת {{$root.orgTypeBranchName.single}}\"><md-option ng-value=\"null\">כל {{$root.orgTypeBranchName.plural}}\n</md-option><md-option ng-repeat=\"settlement in vm.settlements\" ng-value=\"settlement.ID\">{{settlement.Name}}\n</md-option></md-select></div></div></header></div><div ng-show=\"vm.statistics\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div>\n<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-60 line-height-72\" ng-if=\"vm.statistics.ActiveMembers\">{{vm.statistics.ActiveMembers}}\n</div><div class=\"vm10\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!vm.statistics.ActiveMembers\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"h3 secondary-text font-weight-500\">מספר תושבים פעילים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-60 line-height-72\" ng-if=\"vm.statistics.NumberOfRegsLastWeek\">\n{{vm.statistics.NumberOfRegsLastWeek}}</div><div class=\"vm10\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!vm.statistics.NumberOfRegsLastWeek\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"h3 secondary-text font-weight-500\">מספר הרשמות בשבוע החולף</div></div><div \nclass=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-60 line-height-72\" \nng-if=\"vm.statistics.LastMonthIncomes\">{{vm.statistics.LastMonthIncomes}}</div><div class=\"vm10\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!vm.statistics.LastMonthIncomes\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"h3 secondary-text font-weight-500\">הכנסות בחודש האחרון\n</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-60 line-height-72\" ng-if=\"vm.statistics.ActiveEvents\">\n{{vm.statistics.ActiveEvents}}</div><div class=\"vm10\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!vm.statistics.ActiveEvents\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"h3 secondary-text font-weight-500\">מספר אירועים פעילים</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nng-if=\"!vm.selectedSettlement\" class=\"h3 p-16\">הכנסות לפי ימים בשבוע</div><div class=\"vm10\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!vm.statistics.LastWeekIncomesPerDay\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-divider></md-divider><canvas class=\"chart chart-bar pb10\" \nng-if=\"vm.statistics.LastWeekIncomesPerDay\" chart-data=\"vm.statistics.LastWeekIncomesPerDay.Data\" \nchart-colors=\"vm.chartsExtras.colors\" chart-labels=\"vm.statistics.LastWeekIncomesPerDay.Labels\"></canvas>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\">\n<div class=\"h3 p-16\">חמשת המאורעות המבוקשים ביותר בשנה החולפת</div><md-divider></md-divider><div class=\"vm10\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!vm.statistics.TopEvents\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><canvas class=\"chart chart-pie pb10\" \nng-if=\"vm.statistics.TopEvents\" chart-data=\"vm.statistics.TopEvents.Data\" chart-colors=\"vm.chartsExtras.colors2\" \nchart-labels=\"vm.statistics.TopEvents.Labels\" chart-options=\"vm.chartsExtras.options\"></canvas></ms-widget-front>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/pages/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple tabbed\" ng-init=\"vm.getEvents();vm.getSettlements();\"><div \nclass=\"header Oct md-accent-bg\" ng-class=\"vm.currentMonthShort\"><div \nclass=\"header-content layout-align-space-between-stretch layout-column\" layout=\"column\" layout-align=\"space-between\">\n<div class=\"header-top layout-xs-column layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div \nclass=\"toolbar display-btns layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><button \nclass=\"md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" ng-click=\"vm.calendar.today()\" \ntitle=\"היום\"><md-icon md-font-icon=\"icon-calendar-today\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-calendar-today\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</button> <button class=\"md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.calendar.changeView(\'agendaDay\')\" title=\"תצוגה יומית\"><md-icon md-font-icon=\"icon-view-day\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-view-day\" role=\"img\" aria-hidden=\"true\"></md-icon><div \nclass=\"md-ripple-container\"></div></button> <button \nclass=\"md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" title=\"תצוגה שבועית\"><md-icon md-font-icon=\"icon-view-week\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-view-week\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</button> <button class=\"md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.calendar.changeView(\'month\')\" title=\"תצוגה חודשית\"><md-icon md-font-icon=\"icon-view-module\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-view-module\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</button></div><div class=\"toolbar layout-align-end-center layout-row\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"select-settlement mx-20\"><md-select ng-model=\"vm.settlementsFilter\" ng-disabled=\"!vm.settlements\" \nng-change=\"vm.filterEvents()\" placeholder=\"בחירת {{$root.orgTypeBranchName.single}}\" multiple=\"multiple\"><md-option \nng-repeat=\"settlement in vm.settlements\" ng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-select></div><div\n class=\"select-type mx-20\"><md-select ng-model=\"vm.typeFilter\" ng-change=\"vm.filterEvents()\" placeholder=\"בחירת תצוגה\" \nng-init=\"vm.typeFilter = 1\"><md-option ng-value=\"1\">מאורעות</md-option><md-option ng-value=\"2\">זמני הרשמה</md-option>\n<md-option ng-value=\"3\">שימוש באולמות</md-option></md-select></div><div class=\"select-category mx-20\"><md-select \nng-model=\"vm.categoryFilter\" ng-disabled=\"!vm.categories\" ng-change=\"vm.filterEvents()\" placeholder=\"בחירת קטגוריות\" \nmultiple=\"multiple\"><md-option ng-repeat=\"category in vm.categories\" ng-value=\"category.ID\">\n{{category.Path.join(\' › \')}}</md-option></md-select></div></div></div><div \nclass=\"header-bottom layout-align-center-center layout-row\" layout=\"row\" layout-align=\"center center\"><button \nclass=\"md-icon-button arrow md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.calendar.prev(); vm.getEvents()\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-chevron-left\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</button><div class=\"title ng-binding\">{{vm.calendar.view.title}}</div><button \nclass=\"md-icon-button arrow md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.calendar.next(); vm.getEvents()\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-chevron-right\" role=\"img\" aria-hidden=\"true\"></md-icon>\n<div class=\"md-ripple-container\"></div></button></div></div></div><div class=\"content\"><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"center relative\" ms-scroll style=\"height:100%\" ng-if=\"!vm.loading\"><div \nid=\"calendarView\" ui-calendar=\"vm.uiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div></div>");
$templateCache.put("app/main/pages/login/login.html","<div id=\"login\" ng-controller=\"LoginController\" ng-init=\"checkUserToken();getImages()\" ng-show=\"login\"><div \nclass=\"w100 inrowf\"><div id=\"login-form-wrapper\" class=\"fcc\"><div id=\"login-form\" class=\"h100 sflex fdc jcsb\"><div \nclass=\"topdiv\"><div class=\"top\"><div class=\"logo-wrapper\" ng-click=\"evop = evop + 2\" tabindex=\"0\" ng-keydown=\"down()\">\n<img ng-if=\"logo\" src=\"{{logo}}\" alt=\"Logo\" class=\"logo\"></div><div class=\"txt\"><h1 class=\"title hfs20 mb5 fw-medium\">\n{{$root.appName}}</h1></div></div><div class=\"f1 fcc\"><form \nng-keypress=\"[13, 32].includes($event.keyCode) && submit()\" name=\"loginForm\" id=\"loginForm\" class=\"inrowf\"><div \nclass=\"w100 mb30 relative\" ng-if=\"showEmail\"><label for=\"email\">מייל</label><input type=\"email\" id=\"email\" \nng-change=\"checkMail()\" ng-click=\"showErrorEmail = false\" ng-class=\"{error: showErrorEmail}\" ng-disabled=\"loogin\" \nng-model=\"form.email\" placeholder=\"כתובת מייל איתה נרשמת למערכת\"><div class=\"errorMsg\" \nng-class=\"{showError: showErrorEmail}\">כתובת מייל אינה תקינה</div></div><div class=\"w100 mb30 relative\" \nng-if=\"showOtp\"><label for=\"otp\">קוד אימות נשלח לתיבת הדואר האלקטרוני</label><input type=\"number\" id=\"otp\" \nng-click=\"showErrorOtp = false\" ng-class=\"{error: showErrorOtp}\" ng-disabled=\"loogin\" ng-model=\"form.OtpPwd\" \nplaceholder=\"קוד האימות שהתקבל\"><div class=\"errorMsg\" ng-class=\"{showError: showErrorOtp}\">הקוד שגוי</div><div \nclass=\"timer sflex jcsb aic\"><span>{{timerView}}</span> <button ng-click=\"submit()\" type=\"button\" class=\"resendButton\">\nשלח שוב</button></div></div><div class=\"w100 mb30 relative\" ng-if=\"showPwd\"><label for=\"password\">סיסמא</label><span \nclass=\"imginp sflex aic\" ng-class=\"{focus: focused , error: showErrorPassword}\"><input type=\"{{inputType}}\" \nng-change=\"checkPassword()\" ng-click=\"showErrorPassword = false\" ng-init=\"focused = false\" ng-focus=\"focused = true\" \nng-blur=\"focused = false\" ng-disabled=\"loogin\" id=\"password\" ng-model=\"form.password\" \nplaceholder=\"6 תווים (ספרות ואותיות בלועזית)\" required> <span ng-click=\"showHidePassword()\" class=\"showhide hfs13\">\n{{ showHideText }}</span><div class=\"errorMsg\" ng-class=\"{showError: showErrorPassword}\">סיסמא קצרה מדי</div><img \nng-if=\"!showPass\" ng-click=\"showHidePassword()\" src=\"/assets/icons/Show.svg\" alt=\"\"> <img ng-if=\"showPass\" \nng-click=\"showHidePassword()\" src=\"/assets/icons/Hide.svg\" alt=\"\"></span></div><div class=\"w100 inrowf mb30\"><div \nclass=\"w2s20 sflex aic\"><input type=\"checkbox\" name=\"remmber\" ng-model=\"form.remember\" id=\"remmber\"><label \nfor=\"remmber\">זכור אותי</label></div><div class=\"w2s20 sflex jcfe aic\"><a href=\"/reset-password\">שכחת סיסמא?</a></div>\n</div><div class=\"inrowf w100 jcc\"><div class=\"w100 sflex jcc\"><div ng-if=\"loogin\" class=\"loading\" \nng-class=\"{active: loogin}\"><span></span></div></div><button ng-disabled=\"loogin || loginForm.$invalid\" \nng-click=\"submit()\" class=\"stdButton green hfs15 fw-medium\">התחבר</button></div></form></div></div><div id=\"CopyR\" \nclass=\"center hfs15\"><span>Crafted By <a href=\"https://pionet.co.il\" class=\"notme pionet-logo\" target=\"_blank\"><img \nsrc=\"../../../assets/PionetLogo.svg\" alt=\"Pionet\"> </a>© All Rights Reserved</span></div></div></div><div \nng-if=\"backgroundUrl\" class=\"bgbox\" ng-style=\"{\'background-image\':\'url({{backgroundUrl}})\'}\"></div></div><div \nclass=\"errorBox inrowf\" ng-class=\"{show: popError}\"><div class=\"w100 sflex jcc aic\"><span class=\"hfs15\">\nמייל או סיסמא לא נכונים</span> <a href=\"/reset-password\">לחץ לשחזור סיסמא</a> <img src=\"/assets/icons/Close.svg\" \nalt=\"\" ng-click=\"popError = false\"></div></div><div class=\"errorBox inrowf\" ng-class=\"{show: popError2}\"><div \nclass=\"w100 sflex jcc aic\"><span class=\"hfs15\">משתמש חסום. יש להמתין {{TimeToWith}} דקות</span></div></div></div>");
$templateCache.put("app/main/pages/save-changes/save-changes.html","<md-content><div layout=\"row\" layout-align=\"space-between center\"><span layout-align=\"start center\"><span \nng-if=\"values.length == 1\">שדה 1 שונה האם ברצונך לשמור אותו?</span> <span ng-if=\"values.length > 1\">\n{{values.length}} שדות שונו, האם ברצונך לשמור אותם?</span> </span><span layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised md-button md-ink-ripple\" aria-label=\"שמירה\" ng-click=\"editObject()\">שמירה</md-button>\n<md-button class=\"md-primary md-raised md-button md-ink-rippl\" aria-label=\"ביטול\" ng-click=\"closeWithOutSaving()\">ביטול\n</md-button></span></div></md-content>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/ui/page-layouts/blank/blank.html","<div class=\"page-layout blank\" layout=\"row\"><h2>Blank page</h2></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-content.html","<div class=\"demo-content\"><img src=\"assets/images/etc/early-sunrise.jpg\" class=\"md-card-image\" alt=\"sunrise\"><h1>\nEarly Sunrise</h1><h4 class=\"secondary-text\">Demo Content</h4><p>\nOne morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.\n</p><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What\'s happened to me? \" he thought. It wasn\'t a dream.\n</p><footer>John Doe</footer></blockquote><p>\nHis room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.\n</p><p>\nIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.\n</p><p>\n\"How about if I sleep a little bit longer and forget all this nonsense\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.\n</p><p>\nHe must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. \"Oh, God\", he thought, \"what a strenuous career it is that I\'ve chosen!\n</p><p>\nTravelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.\n</p><p>\n\"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.\n</p><p>\n\"Getting up early all the time\", he thought, \"it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...\n</p></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-sidenav.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Sidenav Demo</md-subheader><md-list-item><p>\nSidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 16</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/dashboard/updates-dialog/updates-dialog.html","<md-dialog class=\"new-activities-dialog\" aria-label=\"New Task\"><form name=\"newActivitiesForm\" \ndata-ng-model=\"newActivitiesForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\" \nstyle=\"min-height: 30px;height: 57px\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">גרסה 2.7 (יוני 2020) - פרטי העדכון</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" ng-disabled=\"disable\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"overflow: visible !important\"><ul><li>שדרוג גרפי למערכת.</li><li>ביצוע התאמות נוספות למובייל.</li><li>\nהוספת אישור הורים חתום הכולל את כלל המידע המגיע מהאירוע ושמירתו כמסמך מצורף להרשמה במערכת.</li><li>\nהוספת מסך לניהול {{$root.User.Branch}}.</li><li>הוספת מסך לניהול קבוצה.</li><li>הוספת מנגנון פיצול תשלומים וזיכויים.\n</li><li>הוספת סוגי דו\"חות חדשים.</li><li>הוספת ספר טלפונים ארגוני.</li><li>\nהוספת רובד הרשאות לרכזים (שליחת SMS, שליחת מיילים, מספר תשלומים ל{{$root.User.Event}}).</li><li>\nהוספת מסך ניהול לבקשות סבסוד.</li><li>הוספת אפשרות להגבלת מספר תשלומים מקסימאלי לכלל התנועה.</li><li>\nהוספת סוג מחיר חדש ל{{$root.User.Event}}, לפי קבוצה.</li><li>הוספת סוג הנחה חדש ל{{$root.User.Event}}, לפי תאריכים.\n</li><li>אמץ חניך: מתן אפשרות להורים לתרום כסף ל{{$root.User.Event}} על מנת לאפשר השתתפות לחניכים בעלי מיעוט אמצעים.\n</li><li>מתן אפשרות להגבלת מספר חניכים ל{{$root.User.Event}}.</li><li>\nאפשרות ליצירת קישורים בין {{$root.User.Event}} ל{{$root.User.Event}} (או מוצרים) על מנת להציע להורה לקנות אותם במידה ורכש אחד מהם.\n</li><li>הוספת מיילים להפצת בקשות סבסוד לפי {{$root.User.Branch}} ולפי איזור.</li><li>שדרוג נראות עגלת קניות.</li></ul>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pages/events-dialogs/approve-registrations-dialog/approve-registrations-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\" style=\"min-width: 50vw\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">אישור הרשמה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"content\" flex><div><table id=\"type-subscribers-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><input \nng-model=\"selectAll\" type=\"checkbox\" ng-change=\"setAll(selectAll)\"></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר הרשמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם מלא</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ת.ז</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם מאורע</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך הרשמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">עלות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"reg in registrations\"><td><input type=\"checkbox\" ng-model=\"reg.Selected\"></td><td>{{reg.ID}}</td><td>\n{{getMemberName(reg)}}</td><td>{{reg.PrivateID}}</td><td>{{reg.EventName}}</td><td>\n{{reg.RegistrationTime | cmdate:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{reg.FinalPrice? reg.FinalPrice : reg.Price}} ₪</td>\n</tr></tbody></table></div><div class=\"mt20\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" \nng-model=\"actions.ExtraCharge\">חיוב דמי הרשמה</md-checkbox></div><div class=\"mt20\"><md-checkbox ng-true-value=\"1\" \nng-false-value=\"0\" ng-model=\"actions.RequiredEvents\">חיוב עבור מוצרים נלווים (במידה ויש)</md-checkbox></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"isClicked\" type=\"submit\" ng-click=\"approveRegistrations()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">אישור ({{getSelectedAmount()}})</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/dashboard/tabs/events.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/main/apps/dashboard/tabs/movement.html","");
$templateCache.put("app/main/pages/events-dialogs/cancel-registration-dialog/cancel-registration-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nביטול הרשמה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div class=\"content\" flex><md-content class=\"about-tab\" style=\"padding: 20px\"><form name=\"cancelRegForm\" \ndata-ng-model=\"cancelRegForm\" class=\"md-inline-form\" validate><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>סיבת ביטול</label><textarea \nng-model=\"cancelRegistration.CancelComment\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClikced\"></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"cancelRegForm.$invalid || isClikced\" \nng-click=\"cancelReg()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">ביטול הרשמה</md-button></div>\n</md-dialog-actions></form></md-content></div></md-dialog>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/full-registration-dialog.html","<md-dialog class=\"full-registration-dialog\" ng-init=\"getFullRegistration()\" style=\"min-width: 850px\"><form \nname=\"newCoordinatorsForm\" data-ng-model=\"newCoordinatorsForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">פרטי הזמנה {{registrations.Registration.ID}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>פרטי הרשמה</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/registration.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>אמצעי תשלום</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/paymnet.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-disabled=\"registrations.Questions.length==0\"><md-tab-label><span>שאלות</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/questions.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-disabled=\"registrations.Transportation.length==0\"><md-tab-label><span>הסעות</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/transportation.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"registrations.Registration.EventType != 1\" \nng-disabled=\"!registrations.Registration.SingedInfoFile &&\r\n                     registrations.Registration.HealthDeclarations.length == 0 &&\r\n                      (!registrations.Registration.DivorcedParentFiles || registrations.Registration.DivorcedParentFiles.length == 0)\">\n<md-tab-label><span>קבצים חתומים</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/signedFile.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"registrations.Registration.EventType != 1\" \nng-disabled=\"!registrations.Discounts || registrations.Discounts.length == 0\"><md-tab-label><span>הנחות</span>\n</md-tab-label><md-tab-body><md-content ng-disabled=\"$root.AdminLevel<3\" class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/discounts.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab \nng-disabled=\"!(registrations.Registration.RefundReceiptID.length && registrations.Registration.RefundReceiptID[0].RefundDate) && !registrations.Registration.Canceled && !registrations.Registration.ParentsCashTransID\">\n<md-tab-label><span>פרטי ביטול וזיכוי</span></md-tab-label><md-tab-body><md-content ng-disabled=\"$root.AdminLevel<3\" \nclass=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/cancel.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>היסטורית שינויים</span></md-tab-label><md-tab-body><md-content \nng-disabled=\"$root.AdminLevel<3\" class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/events-dialogs/full-registration-dialog/tabs/logs.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></form></md-dialog>");
$templateCache.put("app/main/pages/events-dialogs/group-refund-registration-dialog/group-refund-registration-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nזיכוי הרשמה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"content\" flex><md-content class=\"about-tab\" style=\"padding: 20px\"><form \nname=\"cancelRegistrationForm\" class=\"md-inline-form\" validate><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"credit-card\" class=\"name\"></md-icon><label>סוג זיכוי</label><md-select ng-required=\"true\" \nng-model=\"cancelRegistration.RefundModel\" placeholder=\"שיטת זיכוי\"><md-option ng-value=\"1\">סכום מלא</md-option>\n<md-option ng-value=\"2\">סכום לבחירה</md-option><md-option ng-value=\"3\">לפי אחוזים</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\" \nng-if=\"!cancelRegistration.EventType && cancelRegistration.MonthlyPayment\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><label>זיכוי קבלה מתאריך</label><div locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"cancelRegistration.RefundStartDate\" max-date=\"cancelRegistration.RefundEndDate\"><input \nautocomplete=\"off\" ng-model=\"cancelRegistration.RefundStartDate\" ng-required=\"true\" ng-disabled=\"isClicked\"></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\" \nng-if=\"!cancelRegistration.EventType && cancelRegistration.MonthlyPayment\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"cancelRegistration.RefundEndDate\" min-date=\"cancelRegistration.RefundStartDate\"><label>זיכוי עד תאריך\n</label><input autocomplete=\"off\" ng-model=\"cancelRegistration.RefundEndDate\" ng-disabled=\"isClicked\" \nng-required=\"true\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"cancelRegistration.RefundModel != 1\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label \nng-if=\"cancelRegistration.RefundModel == 2\">סכום לזיכוי</label><label ng-if=\"cancelRegistration.RefundModel == 3\">\nאחוז לזיכוי</label><input ng-model=\"cancelRegistration.Refund\" ng-disabled=\"isClikced\" ng-change=\"checkAmount()\" \ntype=\"number\" ng-focus=\"true\" ng-required=\"true\" min=\"0\" max=\"{{cancelRegistration.RefundModel == 3? 100: \'\' }}\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon>\n<label>סיבת זיכוי</label><textarea ng-model=\"cancelRegistration.RefundComment\" type=\"text\" ng-required=\"true\" \nng-disabled=\"isClikced\"></textarea></md-input-container><md-input-container class=\"md-block\" \nng-if=\"cancelRegistration.RefundModel != 1\"><p class=\"fcred\">\n*שים לב - במסך הבא יוצגו רק הזמנות שטרם בוצעה בהן פעולת זיכוי</p><md-checkbox \nng-model=\"cancelRegistration.MultipleRefunds\" ng-true-value=\"1\" ng-false-value=\"0\">הצג גם הזמנות מזוכות</md-checkbox>\n</md-input-container><md-divider></md-divider><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"cancelRegistration.Cancel\" ng-true-value=\"1\" ng-false-value=\"0\">ביטול הזמנה</md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"cancelRegistration.Cancel\"><md-icon \nmd-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>סיבת ביטול</label><textarea \nng-model=\"cancelRegistration.CancelComment\" type=\"text\" ng-required=\"true\"></textarea></md-input-container></form>\n</md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"cancelRegistrationForm.$invalid || isClikced\" \nng-click=\"GroupRefundRegistration()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">זיכוי הרשמה\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/events-dialogs/refund-registration-dialog/refund-registration-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\" ng-class=\"{\'with-iframe\': iframe}\"><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">זיכוי הרשמה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"h100\">\n<md-content class=\"about-tab h100\" ng-if=\"iframe\"><div class=\"iframe_container h100\"><iframe class=\"w100 h100\" \nsrc=\"{{trustSrc(iframe)}}\" frameborder=\"0\"></iframe></div></md-content><md-content class=\"about-tab h100\" \nng-if=\"!iframe\"><form name=\"refundRegistrationForm\" data-ng-model=\"refundRegistrationForm\" class=\"md-inline-form\" \nvalidate ng-if=\"amountConfirmed || registration.PaymentType == 11\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>סיבת זיכוי</label><textarea \nng-model=\"cancelRegistration.RefundComment\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClikced\"></textarea>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"credit-card\" class=\"name\"></md-icon>\n<label>קבלה לזיכויי</label><md-select ng-required=\"true\" ng-change=\"changeRefundValue()\" \nng-model=\"cancelRegistration.ReceiptForRefund\" placeholder=\"קבלה לזיכויי\" \nng-disabled=\"isClikced || !cancelRegistration.RefundComment\"><md-option ng-repeat=\"receipt in receipts\" \nng-value=\"receipt\" ng-disabled=\"receipt.left==0\">{{receipt.text}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>סכום לזיכוי</label>\n<input ng-model=\"cancelRegistration.Refund\" ng-disabled=\"isClikced || !cancelRegistration.ReceiptForRefund\" \nng-change=\"checkAmount()\" type=\"number\" ng-focus=\"true\" ng-required=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"credit-card\" class=\"name\"></md-icon><label>שיטת זיכוי</label><md-select \nrequired ng-model=\"cancelRegistration.RefundType\" placeholder=\"שיטת זיכוי\" \nng-disabled=\"isClikced || !cancelRegistration.ReceiptForRefund\" ng-change=\"checkAmount()\"><md-option ng-value=\"1\" \nng-if=\"[1,11].includes(cancelRegistration.ReceiptForRefund.PaymentType)\">אשראי</md-option><md-option ng-value=\"6\" \nng-if=\"[1,11].includes(cancelRegistration.ReceiptForRefund.PaymentType)\">אשראי אחר</md-option><md-option ng-value=\"8\" \nng-if=\"[1,11].includes(cancelRegistration.ReceiptForRefund.PaymentType)\">אשראי - לא דרך המערכת</md-option><md-option \nng-value=\"2\" ng-if=\"cancelRegistration.ReceiptForRefund.PaymentType != 7\">מזומן</md-option><md-option ng-value=\"3\" \nng-if=\"cancelRegistration.ReceiptForRefund.PaymentType != 7\">העברה בנקאית</md-option><md-option ng-value=\"4\" \nng-if=\"cancelRegistration.ReceiptForRefund.PaymentType != 7\">המחאה</md-option></md-select></md-input-container><div \nng-if=\"cancelRegistration.RefundType==1\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"credit-card\" \nclass=\"name\"></md-icon><label>CVV</label><input ng-model=\"cancelRegistration.CVV\" ng-disabled=\"isClikced\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"account-card-details\" class=\"name\">\n</md-icon><label>תעודה מזהה</label><input ng-model=\"cancelRegistration.PrivateID\" ng-disabled=\"isClikced\">\n</md-input-container></div><div ng-if=\"cancelRegistration.RefundType==7 && parent != false\"><md-input-container \nclass=\"md-block\"><div>שם ההורה לזיכויי: {{parent.LastName}} {{parent.FirstName}}</div></md-input-container></div>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"delete\" class=\"name\"></md-icon><label>האם לבטל הזמנה?\n</label><md-select ng-required=\"true\" ng-model=\"cancelRegistration.Cancel\" placeholder=\"האם לבטל הזמנה?\" \nng-disabled=\"isClikced\" ng-init=\"cancelRegistration.Cancel = 0\"><md-option ng-value=\"1\">כן</md-option><md-option \nng-value=\"0\">לא</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"cancelRegistration.Cancel\"><md-icon md-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>סיבת ביטול\n</label><textarea ng-model=\"cancelRegistration.CancelComment\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClikced\">\n</textarea></md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" \nng-model=\"cancelRegistration.SendEmail\" ng-init=\"cancelRegistration.SendEmail = 1\">שליחת קבלת זיכויי</md-checkbox>\n</md-input-container><div layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"refundRegistrationForm.$invalid || isClikced\" ng-click=\"refundRegistration()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">זיכוי הרשמה</md-button></div></form></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/admin/admin-management/manage-admins.html","<div id=\"manage-admins\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול משתמשים</span></div></div><div \nclass=\"content\"><div class=\"action-buttons\"><md-button ng-disabled=\"!admins\" ng-if=\"$root.User.SuperAdmin==1\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-systemUser-button\" ng-click=\"openNewAdminUserDialog()\" \naria-label=\"add systemUser\" title=\"הוספת משתמש חדש\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><form\n name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><md-select ng-model=\"search.Status\" \nplaceholder=\"סינון לפי סטטוס\" ng-disabled=\"!admins\" ng-init=\"search.Status=1\"><md-option ng-value=\"null\">הצג הכל\n</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"search.FreeSearchFromDB\" type=\"search\" ng-disabled=\"!admins\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!admins\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getAdmins()\">סינון</md-button><md-button ng-disabled=\"!admins\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getAdmins(true)\">בטל סינון</md-button></div></form><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!admins\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><table class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\" ng-show=\"admins\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשם פרטי</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם משפחה\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך התחברות אחרון</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"md-ink-ripple\" ng-repeat=\"admin in admins\"><td><img class=\"avatar\" alt=\"{{admin.FirstName}}\" \nng-src=\"{{admin.ProfileImage || \'assets/images/avatars/profile.jpg\'}}\"></td><td>{{admin.FirstName}}</td><td>\n{{admin.LastName}}</td><td>{{admin.Status==1 || place.Status==\'1\'? \'פעיל\' : \'לא פעיל\'}}</td><td><span \nng-if=\"admin.LastLogin>0\">{{admin.LastLogin*1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</span> <span ng-if=\"admin.LastLogin<0\">\nלא התחבר</span></td><td><md-button ng-if=\"!admin.CreateTime\" aria-label=\"Use Android\" ng-click=\"sendAgain(admin)\">\n<span>שלח הזמנה בשנית</span></md-button><md-button class=\"preview-user\" ng-click=\"editAdminProfile(admin)\"><md-icon \nmd-svg-icon=\"pencil\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/admin/admin-profile/admin-profile.html","<div id=\"admin-profile\" class=\"page-layout simple tabbed\" ng-init=\"\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nngf-select=\"checkSize($file)\" accept=\"image/*\" class=\"profile-image avatar huge cp\" \nng-src=\"{{ $root.User.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\"><div><div class=\"hsf13 small-name smm0a\">\nפרופיל שלי</div><div class=\"name\">{{$root.User.FirstName}} {{$root.User.LastName}}</div></div></div><div \nclass=\"actions\" layout=\"row\" layout-align=\"end center\"></div></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span>כללי</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/admin/admin-profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>סיסמה</span></md-tab-label><md-tab-body><md-content class=\"password-tab\" \nng-include=\"\'app/main/pages/admin/admin-profile/tabs/password/password.html\'\"></md-content></md-tab-body></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/pages/forms-dialogs/cancellation-dialog/cancellation-dialog.html","<md-dialog class=\"subsidy-dialog\" aria-label=\"New Task\"><form name=\"cancel-form\" data-ng-model=\"cancel-form\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nבקשת ביטול</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container\n class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם חניך</label><input \nng-value=\"cancel.StudentName\" type=\"text\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-brightness-5\"></md-icon><label>שם {{$root.User.Event}}</label><input \nng-value=\"cancel.EventName\" type=\"text\" readonly=\"readonly\"></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cancel\"></md-icon><label>סיבת ביטול</label><input \nng-value=\"cancel.Reason==\'Other\' ? \'אחר\'  : \'מחלה\'\" type=\"text\" readonly=\"readonly\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cancel\"></md-icon><label>אחר</label><textarea \nclass=\"overh-textarea\" type=\"text\" readonly=\"readonly\">{{cancel.OtherReason}}</textarea></md-input-container></div><div\n layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-check\"></md-icon><label>סטטוס\n</label><md-select ng-model=\"cancel.Status\"><md-option ng-value=\"\'טופל\'\">טופל</md-option><md-option \nng-value=\"\'טרם טופל\'\">טרם טופל</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><label>הערות (פנימי)</label><textarea \nng-model=\"cancel.Comments\"></textarea></md-input-container></div></form><a ng-if=\"cancel.FilePath\" \nstyle=\"font-size: 25px\" href=\"{{cancel.FilePath}}\" target=\"_self\" download=\"{{cancel.FileName}}\" \ntitle=\"{{cancel.FileName}}\" class=\"icon-file-document\"></a></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"updateCancellationForm()\">עדכון</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/pages/forms-dialogs/contact-dialog/contact-dialog.html","<md-dialog class=\"subsidy-dialog\" aria-label=\"New Task\"><form name=\"contactForm-form\" data-ng-model=\"contactForm-form\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nטופס צור קשר</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container\n class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם חניך</label><input \nng-model=\"contactForm.StudentName\" type=\"text\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם הורה</label><input \nng-model=\"contactForm.ParentName\" type=\"text\" readonly=\"readonly\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"file-document-box\"></md-icon><label>נושא יצירת קשר\n</label><input ng-model=\"contactForm.Type\" type=\"text\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\">\n<md-icon md-font-icon=\"icon-email\"></md-icon><label>פרטי ההודעה</label><textarea ng-model=\"contactForm.Text\" \ntype=\"text\" readonly=\"readonly\"></textarea></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container\n class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-check\"></md-icon><label>סטטוס</label><md-select \nng-model=\"contactForm.Status\"><md-option ng-value=\"\'טופל\'\">טופל</md-option><md-option ng-value=\"\'טרם טופל\'\">טרם טופל\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-clipboard-text\">\n</md-icon><label>הערות (פנימי)</label><textarea ng-model=\"contactForm.Comments\"></textarea></md-input-container></div>\n</form><a ng-if=\"contactForm.FilePath\" style=\"font-size: 25px\" href=\"{{contactForm.FilePath}}\" target=\"_self\" \ndownload=\"{{contactForm.FileName}}\" title=\"{{contactForm.FileName}}\" class=\"icon-file-document\"></a>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"updateContactForm()\">עדכון</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/admin/coordinators/coordinators.html","<div id=\"coordinators\" class=\"page-layout simple tabbed\" ng-init=\"getRoles();getSettlements()\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">ניהול {{$root.User.Coordinators}}</span></div></div><div class=\"content\"><div \nclass=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-newCoordinator-button\" \nng-click=\"openNewCoordinatDialog()\" ng-disabled=\"!coordinators\" aria-label=\"add systemUser\" \ntitle=\"הוספת {{$root.User.Coordinator}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-disabled=\"isClicked || !coordinators\" ng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" \nclass=\"md-fab md-accent md-icon-button\" id=\"send-emailes-button\" ng-click=\"openSendEmail()\" \naria-label=\"add systemUser\" title=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\"></md-icon></md-button><md-button \nng-disabled=\"isClicked || !coordinators\" ng-if=\"$root.smsEnabled && ($root.AdminLevel>2 || $root.User.SmsPer)\" \nclass=\"md-fab md-accent md-icon-button\" id=\"send-SMS-button\" ng-click=\"openSendSMS()\" title=\"שליחת הודעה\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cellphone-android\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><label>{{$root.orgTypeBranchName.single}}</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.settlements\" \nng-disabled=\"!coordinators\" multiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-disabled=\"!coordinators\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חפש {{$root.orgTypeBranchName.single}}..\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup ng-disabled=\"settlements\"><md-option ng-value=\"settlement.ID\" \nng-repeat=\"settlement in settlements |filter:searchTerm\">{{settlement.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.status\" \nplaceholder=\"סינון לפי סטטוס {{$root.User.Coordinators}}\" ng-disabled=\"!coordinators\"><md-option ng-value=\"null\">\nהצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים\n</md-option></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-icon \nmd-font-icon=\"icon-tie\"></md-icon><md-select ng-model=\"search.role\" placeholder=\"סינון לפי תפקיד\" \nng-disabled=\"!coordinators\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-repeat=\"role in roles\" \nng-value=\"role.Name\">{{role.Name}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label>\n<input id=\"free-search\" ng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!coordinators\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!coordinators\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getCoordinators()\">סינון</md-button>\n<md-button ng-disabled=\"!coordinators\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getCoordinators(true)\">\nבטל סינון</md-button></div></form></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!coordinators\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"coordinators\" class=\"coordinators-table-c\"><table id=\"coordinators-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><input ng-model=\"selectAll\" \ntype=\"checkbox\" ng-change=\"setAll(selectAll)\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">דואר אלקטרוני</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.orgTypeBranchName.plural}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"coordinator in coordinators | filter: filterByStatus  | filter: search.freeSearch\"><td><input \ntype=\"checkbox\" ng-model=\"coordinator.Selected\"></td><td>{{coordinator.FirstName}} {{coordinator.LastName}}</td><td>\n{{coordinator.Email}}</td><td><span ng-if=\"coordinator.Settlements\" \nng-repeat=\"(settlementKey,settlementValue) in coordinator.Settlements\">{{settlementValue.Name}} <span \nng-if=\"settlementKey<coordinator.Settlements.length-1\">,</span> </span><span ng-if=\"coordinator.Settlements.length==0\">\nללא שיבוץ</span></td><td>{{coordinator.Status==1 || coordinator.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button \nclass=\"preview-user\" ng-click=\"openCoordinatPanel(coordinator)\" title=\"עריכה מהירה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button><md-button class=\"preview-user md-icon-button\" href=\"/coordinator-profile?ID={{coordinator.ID}}\" \ntitle=\"צפייה בפרופיל\"><md-icon md-svg-icon=\"settings\"></md-icon></md-button></td></tr></tbody></table></div></div>\n</div>");
$templateCache.put("app/main/pages/admin/new-admin/new-admin.html","<div id=\"forgot-password\" class=\"sflex aic fdc\" ng-init=\"validRequest()\"><div id=\"forgot-form\" \nng-class=\"{hideme: success}\"><h2 class=\"hfs65 center\">{{appConfig.appName}} - רישום מנהל חדש</h2><form><div><label \nclass=\"formlabel dblock fw-medium\">סיסמא חדשה</label><div class=\"inputform\"><input ng-change=\"matchPass()\" \nng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" type=\"{{ inputType }}\" ng-model=\"form.password\" \nplaceholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" class=\"sflex aic btn\">\n{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\"><span \nng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span ng-class=\"{errors: shortPass}\">\nסיסא קצרה מדיי</span></h5></div></div><div class=\"mt40\"><label class=\"formlabel dblock fw-medium\">אימות סיסמא</label>\n<div class=\"inputform\"><input ng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" ng-change=\"matchPass()\" \ntype=\"{{ inputType }}\" ng-model=\"passwordVerify\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button \nng-click=\"showHidePassword()\" class=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5\n class=\"hfs13 sflex jcfe\"><span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"center mt40\"><div class=\"loading\" \nng-if=\"loading\" ng-class=\"{active: loading}\"><span></span></div><input type=\"submit\" \nng-disabled=\"!matchPasswords || loading\" ng-click=\"submit()\" value=\"עדכן סיסמא\"></div><div class=\"w100 center mt40\"><h4\n class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></form></div><div id=\"done-reset\" class=\"center\" \nng-class=\"{show: success}\"><img class=\"mb40\" src=\"/assets/icons/Done.svg\" alt=\"\"><h2 class=\"hfs65 mb30\">\nאיפוס סיסמא בוצע בהצלחה!</h2><h5 class=\"hfs27 fw-light\">מתבצע חיבור כעת</h5></div><div id=\"CopyR\" class=\"center hfs15\">\n<span>Crafted By <a href=\"https://pionet.co.il\" class=\"notme pionet-logo\" target=\"_blank\"><img \nsrc=\"../../../assets/PionetLogo.svg\" alt=\"Pionet\"> </a>© All Rights Reserved</span></div><div class=\"errorBox inrowf\" \nng-class=\"{show: fail}\"><div class=\"w100 center\"><span class=\"hfs15\">{{ errorInfo }}</span> <img \nsrc=\"/assets/icons/Close.svg\" alt=\"\" ng-click=\"fail = false\"></div></div></div>");
$templateCache.put("app/main/pages/password-reset/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"sflex aic fdc\" ng-init=\"checkUserToken()\" ng-hide=\"!valid\"><div id=\"forgot-form\" \nng-class=\"{hideme: success}\"><h2 class=\"hfs65 center\">יצירת סיסמא חדשה</h2><form><div><label \nclass=\"formlabel dblock fw-medium\">סיסמא חדשה</label><div class=\"inputform\"><input ng-disabled=\"loading\" \nng-change=\"matchPass()\" ng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" type=\"{{ inputType }}\" \nng-model=\"form.password\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" \nclass=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\">\n<span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"mt40\"><label \nclass=\"formlabel dblock fw-medium\">אימות סיסמא</label><div class=\"inputform\"><input ng-disabled=\"loading\" \nng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" ng-change=\"matchPass()\" type=\"{{ inputType }}\" \nng-model=\"passwordVerify\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" \nclass=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\">\n<span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"center mt40\"><div class=\"loading\" \nng-if=\"loading\" ng-class=\"{active: loading}\"><span></span></div><input type=\"submit\" \nng-disabled=\"!matchPasswords || loading\" ng-click=\"submit()\" value=\"עדכן סיסמא\"></div><div class=\"w100 center mt40\"><h4\n class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></form></div><div id=\"done-reset\" class=\"center\" \nng-class=\"{show: success}\"><img class=\"mb40\" src=\"/assets/icons/Done.svg\" alt=\"\"><h2 class=\"hfs65 mb30\">\nאיפוס סיסמא בוצע בהצלחה!</h2><h5 class=\"hfs27 fw-light\">מתבצע חיבור כעת</h5></div><div id=\"CopyR\" class=\"center hfs15\">\n<span>Crafted By <a href=\"https://pionet.co.il\" class=\"notme pionet-logo\" target=\"_blank\"><img \nsrc=\"../../../assets/PionetLogo.svg\" alt=\"Pionet\"> </a>© All Rights Reserved</span></div><div class=\"errorBox inrowf\" \nng-class=\"{show: fail}\"><div class=\"w100 center\"><span class=\"hfs15\">{{ errorInfo }}</span> <img \nsrc=\"/assets/icons/Close.svg\" alt=\"\" ng-click=\"fail = false\"></div></div></div>");
$templateCache.put("app/main/pages/password-reset/reset-password/reset-password.html","<div id=\"reset-password\" class=\"sflex aic fdc\"><div id=\"reset-part\" ng-class=\"{showme: success}\"><h2 \nclass=\"hfs65 mb20 center\">שכחת סיסמא?</h2><h3 class=\"hfs27 fw-light center\">\nנא להזין את כתובת המייל ואנחנו נשלח לך קישור לאיפוס סיסמא בדקות הקרובות</h3><form class=\"inrowf fdc\"><div \nclass=\"formlabel\"><label class=\"dblock fw-medium hfs15 mb5\" for=\"id\">דואר אלקטרוני</label><input type=\"email\" \nng-disabled=\"request\" ng-focus=\"wrongid = false\" ng-class=\"{error: wrongid }\" id=\"id\" ng-model=\"form.email\" \nplaceholder=\"דואר אלקטרוני איתו נרשמת למערכת\"><h5 class=\"hfs13 sflex jcfe\"><span ng-class=\"{errors: wrongid}\">\nדואר אלקטרוני לא תקין</span></h5></div><div class=\"w100 center buttonform\"><div class=\"loading\" ng-if=\"request\" \nng-class=\"{active: request}\"><span></span></div><input type=\"submit\" ng-disabled=\"request\" ng-click=\"forgot()\" \nvalue=\"איפוס סיסמא\"></div><div class=\"w100 center mt40\"><h4 class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4>\n</div></form></div><div id=\"reset-success\" ng-class=\"{showme: success}\"><img src=\"/assets/icons/Sent_1.svg\" alt=\"\"><h2 \nclass=\"hfs65 mb40\">הודעת איפוס סיסמא נשלחה בהצלחה!</h2><h6 class=\"hfs27\">\nברגעים אלו נשלח אלייך מייל עם קישור ליצירת סיסמת כניסה חדשה.</h6><h6 class=\"hfs27\">\nאם לא קיבלת מייל תוך מספר דקות, מומלץ לבדוק את תיבת דואר הזבל.</h6><div class=\"w100 center mt40\"><h4 class=\"hfs15\">\nלחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></div><div id=\"CopyR\" class=\"center hfs15\"><span>Crafted By <a \nhref=\"https://pionet.co.il\" class=\"notme pionet-logo\" target=\"_blank\"><img src=\"../../../assets/PionetLogo.svg\" \nalt=\"Pionet\"> </a>© All Rights Reserved</span></div><div class=\"errorBox inrowf\" ng-class=\"{show: fail}\"><div \nclass=\"w100 center\"><span class=\"hfs15\">מייל לא קיים במערכת</span> <img src=\"/assets/icons/Close.svg\" alt=\"\" \nng-click=\"fail = false\"></div></div></div>");
$templateCache.put("app/main/pages/sms-email-dialogs/email-dialog/email-dialog.html","<md-dialog class=\"email-dialog quill-dialog\" aria-label=\"New Task\"><form name=\"emailForm\" data-ng-model=\"emailForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nשליחת דואר אלקטרוני</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" ng-disabled=\"isClicked\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"isClicked\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><md-input-container class=\"md-block\" ng-if=\"!isClicked\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>מספר {{typeText}} שנבחרו</label><input \nng-value=\"students.length\" type=\"number\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nng-if=\"!externalEmail && type==1\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label>נמען ההודעה\n</label><md-select ng-required=\"true\" ng-model=\"email.Type\" placeholder=\"נמען\" ng-disabled=\"isClicked\"><md-option \nvalue=\"1\">חניכים בלבד</md-option><md-option value=\"2\">הורים בלבד</md-option><md-option value=\"3\">הורים וחניכים\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" \nclass=\"name\"></md-icon><label>נושא ההודעה</label><textarea ng-disabled=\"email.Students.length==0 || isClicked\" \nng-model=\"email.Subject\" ng-required=\"true\"></textarea></md-input-container><md-input-container class=\"md-block\">\n<ng-quill-editor format=\"text\" ng-model=\"email.Text\" on-editor-created=\"$root.editorCreated(editor,\'emailMsg\')\">\n</ng-quill-editor></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"emailForm.$invalid || isClicked || email.Students.length==0\" type=\"submit\" ng-click=\"sendEmail()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שליחת הודעה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/sms-email-dialogs/sms-dialog/sms-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\"><form name=\"smsForm\" data-ng-model=\"smsForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nשליחת הודעה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" ng-disabled=\"isClicked\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>מספר משתתפים שנבחרו</label><input \nng-value=\"sms.Students.length\" type=\"number\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"!externalSMS && type==1\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon>\n<label>נמען ההודעה</label><md-select ng-required=\"true\" ng-model=\"sms.Type\" placeholder=\"נמען\" ng-disabled=\"isClicked\">\n<md-option value=\"1\">חניכים בלבד</md-option><md-option value=\"2\">הורים בלבד</md-option><md-option value=\"3\">\nהורים וחניכים</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"name\"></md-icon><label>תוכן ההודעה</label><textarea \nng-disabled=\"sms.Students.length==0\" ng-model=\"sms.Text\" ng-required=\"true\" ng-disabled=\"isClicked\"></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"smsForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"sendSMS()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שליחת הודעה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar ml-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar ml-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button ml-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.horizontalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"horizontalStep1.firstname.$error\" ng-show=\"horizontalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.horizontalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"horizontalStep1.lastname.$error\" ng-show=\"horizontalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.horizontalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.horizontalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.horizontalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"horizontalStep4.address.$error\" ng-show=\"horizontalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.horizontalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"horizontalStep5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.horizontalStepper.step5.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"horizontalStep5.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.horizontalStepper.step5.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required>\n<div ng-messages=\"horizontalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>\nCC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span>\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.horizontalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"horizontalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.verticalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"verticalStep1.firstname.$error\" ng-show=\"verticalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.verticalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"verticalStep1.lastname.$error\" ng-show=\"verticalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.verticalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.verticalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.verticalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"verticalStep4.address.$error\" ng-show=\"verticalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.verticalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"step5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>Card holder field is required.\n</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" ng-model=\"vm.verticalStepper.step5.cardnumber\" \nplaceholder=\"Card Number\" required><div ng-messages=\"verticalStep5.cardnumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Card number field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"CC2\" ng-model=\"vm.verticalStepper.step5.cc2\" placeholder=\"CC2\" \nmd-maxlength=\"3\" required><div ng-messages=\"verticalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\">\n<span>CC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.verticalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"verticalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with page scroll</span></div><div \nclass=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span></div>\n<md-content class=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout carded left-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nflex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Left sidenav with page scroll</span></div></div>\n<div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>\nContent toolbar</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html","<div class=\"page-layout carded right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nRight sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>Content toolbar</p><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle right pane\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content\" flex ms-scroll>\n<div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll flex><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout carded right-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Right sidenav with page scroll\n</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>\nContent toolbar</p><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle right pane\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content \nclass=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div>\n</div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" \nms-scroll ms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth/fullwidth.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with independent scroll</span></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>\nContent toolbar</span></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nclass=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nLeft sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><p>Content toolbar</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout simple left-sidenav single-scroll\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with page scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Left Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout simple right-sidenav single-scroll\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with page scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with independent scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/fullwidth/fullwidth.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\"><span class=\"h2\">Fullwidth</span></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html","<div class=\"page-layout simple right-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Right Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html","<div class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with independent scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/tabbed/tabbed.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\"><span class=\"h2\">Tabbed</span>\n</div><div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Tab 1\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 2\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 3\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/primary/primary.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.primary.color}}</div><div flex>\n.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text\n</div><div flex>{{vm.themes.active.theme.primary.contrast1}}</div><div flex>.md-primary-bg</div></div><div \nclass=\"md-primary-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.primary.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-primary-bg .secondary-text</div></div><div class=\"md-primary-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.primary.contrast3}}</div><div class=\"hint-text\" flex>\n.md-primary-bg .hint-text</div></div><div class=\"md-primary-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .divider</div></div><div \nflex=\"100\" class=\"md-primary-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.primary.color}}</div><div flex>.md-primary-fg</div></div></div><div class=\"color\" \nlayout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" \nlayout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>\n.md-primary-bg .md-hue-1</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div \nflex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue1.contrast1}}</div><div flex>.md-primary-bg</div>\n</div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-1 .secondary-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div \nflex>.md-primary-bg .md-hue-2</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue2.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-2 .secondary-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div \nflex>.md-primary-bg .md-hue-3</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue3.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-3 .secondary-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div flex>.md-primary-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/accent/accent.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.accent.color}}</div><div flex>\n.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div>\n<div flex>{{vm.themes.active.theme.accent.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.accent.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-accent-bg .secondary-text</div></div><div class=\"md-accent-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.accent.contrast3}}</div><div class=\"hint-text\" flex>\n.md-accent-bg .hint-text</div></div><div class=\"md-accent-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .divider</div></div><div \nflex=\"100\" class=\"md-accent-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.accent.color}}</div><div flex>.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" \nlayout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Hue 1</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-bg .md-hue-1</div>\n</div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.accent.hue1.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-1 .secondary-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>\n.md-accent-bg .md-hue-2</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue2.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-2 .secondary-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>\n.md-accent-bg .md-hue-3</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue3.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-3 .secondary-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>.md-accent-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html","<md-dialog class=\"custom-theme-dialog\" aria-label=\"Custom Theme\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nCustom Theme Generator</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nlayout=\"row\" ng-repeat=\"type in [\'primary\', \'accent\', \'warn\', \'background\']\"><h3 class=\"type\">{{type}}</h3>\n<md-input-container><label>Palette</label><md-select ng-model=\"vm.theme[type].name\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].contrast, 1)}\">\n<md-option ng-value=\"palette\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\">{{palette}}\n</md-option></md-select></md-input-container><div layout=\"row\" \nng-repeat=\"hueType in [\'default\', \'hue-1\', \'hue-2\', \'hue-3\']\"><md-input-container><label>{{hueType}}</label><md-select \nng-model=\"vm.theme[type].hues[hueType]\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].contrast, 1)}\">\n<md-option ng-value=\"hue\" ng-repeat=\"(hue, opt) in vm.palettes[vm.theme[type].name]\" \nng-style=\"{\'background-color\': vm.rgba(opt.value), \'color\': vm.rgba(opt.contrast, 1)}\">{{hue}}</md-option></md-select>\n</md-input-container></div></div><md-divider></md-divider><div layout=\"row\"><p>\nTo make this theme permanent, copy the below code and add it into the \"marvilixThemes\" object in \"core/theming/marvilix-themes.constant.js\" file. You can also replace the \"CUSTOM_THEME_NAME\" with your theme name.\n</p></div><div layout=\"row\"><textarea readonly=\"readonly\" class=\"theme-object\">\"CUSTOM_THEME_NAME\" : {{vm.theme}}\n</textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.setTheme()\">Set Theme</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ui/theme-colors/tabs/warn/warn.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>\n.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.warn.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .secondary-text</div></div><div class=\"md-warn-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" \nlayout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .hint-text</div></div><div \nclass=\"md-warn-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .divider</div></div><div flex=\"100\" class=\"md-warn-fg\" layout=\"row\" layout-padding>\n<div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>.md-warn-fg</div>\n</div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg md-hue-1\" \nflex=\"100\" layout=\"row\" layout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}</div>\n<div flex>.md-warn-bg .md-hue-1</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Primary Text</div><div flex>{{vm.themes.active.theme.warn.hue1.contrast1}}</div><div flex>.md-warn-bg</div></div>\n<div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .md-hue-1 .secondary-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-1 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue1.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-1\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.warn.hue2.color}}</div><div flex>.md-warn-bg .md-hue-2</div></div><div \nclass=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue2.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-2\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-2 .secondary-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-2 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-2\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue2.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.warn.hue3.color}}</div><div flex>.md-warn-bg .md-hue-3</div></div><div \nclass=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue3.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-3\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-3 .secondary-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-3 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-3\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue3.color}}\n</div><div flex>.md-warn-fg</div></div></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/cancel.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"registrations\"><form name=\"PaymentForm\" \ndata-ng-model=\"PaymentForm\" class=\"md-inline-form\"><div class=\"row separate-block\" layout=\"row\" \nng-if=\"registrations.Registration.Canceled\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><label>תאריך ביטול</label>\n<input ng-if=\"registrations.Registration.Canceled\" \nng-value=\"registrations.Registration.Canceled*1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"file-document-box\" class=\"name\"></md-icon><label>סיבת ביטול</label><textarea \nng-model=\"registrations.Registration.CanceledComment\" ng-disabled=\"true\"></textarea></md-input-container></div></div>\n<div ng-repeat=\"refund in registrations.Registration.RefundReceiptID\" class=\"separate-block\"><div class=\"sflex jcsb\">\n<h2>קבלת זיכויי: {{refund.ID}}</h2><md-button ng-if=\"$root.AdminLevel==3 && refund.RefundID\" class=\"preview-user\" \ntitle=\"שליחת קבלה חוזרת\"><md-icon md-svg-icon=\"email\" ng-click=\"reSendReceipt(refund.RefundID,1)\"></md-icon>\n</md-button></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום זיכוי</label>\n<input ng-value=\"refund.RefundSum\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\">\n</md-icon><label>אמצעי תשלום זיכוי</label><input ng-model=\"refund.RefundPaymentTypeText\" ng-disabled=\"true\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-if=\"refund.RefundDate  || registrations.Registration.ParentsCashTransID \"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon>\n<label>תאריך זיכוי</label><input ng-value=\"refund.RefundDate * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"file-document-box\" class=\"name\"></md-icon><label>סיבת זיכוי</label><textarea \nng-model=\"refund.RefundComment\" ng-disabled=\"true\"></textarea></md-input-container></div></div></div><div \nng-if=\"registrations.cashTrans && registrations.cashTrans.Amount > 0\" class=\"separate-block\"><div class=\"row\" \nlayout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום זיכוי</label><input \nng-value=\"registrations.cashTrans.Amount\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><label>אמצעי תשלום זיכוי</label><input value=\"יתרת הורה\" ng-disabled=\"true\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><label>\nתאריך זיכוי</label><input ng-value=\"registrations.cashTrans.CreationTime*1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"file-document-box\" class=\"name\"></md-icon><label>סיבת זיכוי\n</label><textarea ng-model=\"registrations.cashTrans.Comment\" ng-disabled=\"true\"></textarea></md-input-container></div>\n</div></div></form></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/discounts.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"registrations.Discounts.length==0\"><span>לא קיימות הנחות</span></div><table \nng-show=\"registrations.Discounts.length>0\" class=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג הנחה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">רמה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום הנחה</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" ng-repeat=\"discount in registrations.Discounts\"><td>{{discount.DiscountType}}</td>\n<td>{{discount.Type==2 || discount.Type==\'2\' ? \'אחוזים\' : \'שקלים\'}}</td><td>\n{{discount.Level==2 || discount.Level==\'2\' ? \'מרובה\' : \'בודד\'}}</td><td>{{discount.Discount }}</td></tr></tbody>\n</table>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/logs.html","<div id=\"logs\" class=\"page-layout simple tabbed\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!logs\" style=\"padding: 30px\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"content\" ng-if=\"logs\" style=\"padding: 30px\"><table id=\"logs-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><th><div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">משתמש</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">פעולה</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">ערך ישן</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">ערך חדש</span></div></th></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"item in logs\" style=\"height: 35px\"><td><span class=\"dpn\">{{item.Date}}</span>\n{{item.Date*1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</td><td>{{item.AdminName}}</td><td>{{item.Type}}</td><td>\n{{item.OldValue}}</td><td>{{item.NewValue}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/paymnet.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div><label ng-if=\"!approved\" class=\"w100 dflex aic jcfs errMsg\">\nלביצוע פעולות בדף זה יש לאשר תחילה את ההרשמה.</label><md-button ng-if=\"!emptyPaymentAdded\" class=\"md-raised md-accent\" \nid=\"add-payment-button\" aria-label=\"add systemUser\" title=\"הוספת תשלום\" ng-click=\"addEmptyPayment()\" \nng-disabled=\"isClicked || !approved\"><md-icon md-font-icon=\"icon-plus\"></md-icon>הוספת תשלום</md-button><md-button \nng-if=\"registrations.Registration.ExtraPriceIncluded != 1 && registrations.Registration.MonthlyPayment == 1\" \nclass=\"md-raised md-accent\" id=\"add-extra-chargepayment-button\" aria-label=\"add systemUser\" title=\"חיוב דמי הרשמה\" \nng-click=\"addExtraCharge()\" ng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-plus\"></md-icon>חיוב דמי הרשמה\n</md-button></div><div ng-if=\"registrations.cashTrans && registrations.cashTrans.Amount < 0\" class=\"fcgreen\"><label>\nשימוש ביתרת הורה:</label><b>₪{{registrations.cashTrans.Amount * (-1)}}</b></div><div class=\"separate-block\" \nng-if=\"registrations.Registration.PaymentType == 11 && registrations.MonthlyTransactions.length > 0\"><div \nclass=\"row sflex jcsb\" layout=\"row\"><md-whiteframe class=\"md-whiteframe-1dp p10\" flex=\"45\" \nng-repeat=\"monthlyCharge in registrations.MonthlyTransactions\"><div><span class=\"fw-bold\">מספר אשראי: </span>\n{{monthlyCharge.CreditCardNumber.substr(monthlyCharge.CreditCardNumber.length - 4)}}</div><div><span class=\"fw-bold\">\nתוקף: </span>{{monthlyCharge.CreditCardExpDate}}</div><div><span class=\"fw-bold\">בעל הכרטיס: </span>\n{{monthlyCharge.CardHolderName}}</div><div><span class=\"fw-bold\">אחוז לחיוב: </span>{{monthlyCharge.ChargePercentage}}%\n</div><div class=\"sflex jcsb\"><md-button class=\"md-raised md-accent mr0 col2s30\" id=\"add-monthly-payment-button\" \naria-label=\"add systemUser\" title=\"חיוב בהוראת קבע\" ng-click=\"addMonthlyPayment(monthlyCharge.ID)\" \nng-disabled=\"isClicked || registrations.Registration.Status != 1 || !approved\"><md-icon \nmd-font-icon=\"icon-credit-card\"></md-icon>חיוב בהוראת קבע</md-button><md-button class=\"md-raised md-warn col2s30\" \naria-label=\"add systemUser\" title=\"מחיקת הוראת קבע\" ng-click=\"removeMonthlyPayment(monthlyCharge)\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></md-whiteframe></div></div><div\n ng-show=\"registrations\" ng-repeat=\"receipt in registrations.Registration.ReceiptID\" class=\"separate-block\"><div \nclass=\"sflex jcsb\" ng-if=\"receipt.ID\"><h2>קבלה: {{receipt.ID}}</h2><md-button \nng-if=\"$root.AdminLevel==3 && receipt.ReceiptID\" class=\"preview-user\" title=\"שליחת קבלה חוזרת\"><md-icon \nmd-svg-icon=\"email\" ng-click=\"reSendReceipt(receipt.ReceiptID,1)\"></md-icon></md-button></div><form name=\"PaymentForm\" \ndata-ng-model=\"PaymentForm\" class=\"md-inline-form\"><div layout=\"row\" flex=\"100\" \nng-if=\"event.EventType != 1 && ! receipt.ID\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>שם ומייל לקבלה</label>\n<md-select required=\"true\" ng-disabled=\"isClicked\" ng-model=\"receipt.parent\" ng-change=\"setParent()\" \nplaceholder=\"בחר הורה\"><md-option ng-repeat=\"parent in parents\" ng-value=\"parent\">{{parent.Name}} - {{parent.Email}}\n</md-option><md-option ng-value=\"\'other\'\">אחר</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" ng-if=\"receipt.parent === \'other\' || receipt.EventType == 1 || (receipt.ID && receipt.Name)\">\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם לקבלה</label><input ng-model=\"receipt.Name\" \nng-disabled=\"isClicked || receipt.ID\" required></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"email\">\n</md-icon><label>מייל לשליחת קבלה</label><input ng-model=\"receipt.Email\" type=\"email\" \nng-disabled=\"isClicked || receipt.ID\" required></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\" \nng-if=\"(receipt.PaymentType || ($root.AdminLevel == 3 && ! receipt.PaymentType)) && (receipt.PaymentType != 11 || receipt.ID)\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום</label>\n<input ng-model=\"receipt.Sum\" ng-disabled=\"!emptyPaymentAdded || receipt.ID\"></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"cash\" class=\"name\"></md-icon><label>אמצעי תשלום</label><md-select ng-required=\"true\" \nng-model=\"receipt.PaymentType\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID || !banks || !receipt.Name || !receipt.Email\" \nng-change=\"setPaymentType()\" placeholder=\"אמצעי תשלום\"><md-option ng-value=\"0\" disabled=\"disabled\">ללא חיוב</md-option>\n<md-option ng-value=\"1\">אשראי</md-option><md-option ng-value=\"2\">מזומן</md-option><md-option ng-value=\"3\" \nng-disabled=\"banks.length == 0\">העברה בנקאית</md-option><md-option ng-value=\"4\">המחאה</md-option><md-option \nng-value=\"11\" ng-if=\"registrations.Registration.MonthlyPayment == 1\">הוראת קבע באשראי</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סטטוס תשלום</label><md-select \nng-model=\"receipt.PaymentStatus\" ng-change=\"sendReceipt(registrations.Registration)\" \nng-disabled=\"isClicked || receipt.ID > 0 || ($root.AdminLevel<3 && !$root.User.Payments) || payment.paymentStatusDisabled\">\n<md-option ng-value=\"1\">שולם</md-option><md-option ng-value=\"2\">שולם ל{{$root.User.Coordinators}}</md-option><md-option\n ng-value=\"3\" ng-disabled=\"registrations.Registration.PaymentStatus==1 || registrations.Registration.PaymentStatus==2\">\nטרם אושר</md-option><md-option ng-value=\"5\" ng-if=\"$root.advancedCashierOptions\">הופקד לקופה</md-option><md-option \nng-value=\"6\" ng-if=\"$root.advancedCashierOptions\">יצא להפקדה</md-option><md-option ng-value=\"7\" \nng-if=\"$root.advancedCashierOptions\">הופקד</md-option><md-option ng-value=\"0\" \nng-disabled=\"registrations.Registration.PaymentStatus==1 || registrations.Registration.PaymentStatus==2\">לא שולם\n</md-option></md-select></md-input-container></div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"33\" ng-show=\"[1,11].indexOf(receipt.PaymentType) != -1 && receipt.CreditCardNumber\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>4 ספרות\n</label><input ng-value=\"receipt.CreditCardNumber.substr(receipt.CreditCardNumber.length-4)\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || registrations.Registration.PaymentStatus\" \nng-required=\"receipt.PaymentType==1\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\" ng-show=\"[1,11].indexOf(receipt.PaymentType) != -1 && receipt.ReceiptDate\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-calendar\" class=\"name\"></md-icon><label>תאריך</label><input \nvalue=\"{{receipt.ReceiptDate | cmdate:\'HH:mm:ss dd/MM/yyyy\'}}\" disabled=\"disabled\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-input-container \nid=\"forMonthContainer\"><div start-view=\"day\" locale=\"he\" format=\"MM/YYYY\" moment-picker=\"receipt.MonthYear\"><label>\nעבור חודש</label><div class=\"sflex\"><md-icon md-font-icon=\"icon-calendar-select ml10\"></md-icon><input \nautocomplete=\"off\" ng-model=\"receipt.MonthYear\"></div></div></md-input-container></div></div><div \nclass=\"iframe_container row w100\" layout=\"row\" ng-if=\"[1,11].indexof(receipt.PaymentType) != -1 && receipt.iframe\">\n<iframe style=\"height: 450px\" src=\"{{trustSrc(receipt.iframe)}}\" frameborder=\"0\" class=\"w100\"></iframe></div><div \nclass=\"row\" layout=\"row\" ng-show=\"receipt.PaymentType==3\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nשם בעל החשבון</label><input ng-model=\"receipt.AccountName\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" ng-required=\"receipt.PaymentType==3\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר בנק</label><input ng-model=\"receipt.BankNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" ng-required=\"receipt.PaymentType==3\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\" ng-show=\"receipt.PaymentType==3\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon>\n<label>מספר סניף</label><input ng-model=\"receipt.BranchNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" ng-required=\"receipt.PaymentType==3\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר חשבון</label><input ng-model=\"receipt.AccountNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" ng-required=\"receipt.PaymentType==3\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\" ng-show=\"receipt.PaymentType==3\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon class=\"name\"></md-icon><label>בנק</label><md-icon \nmd-svg-icon=\"bank\" class=\"name\"></md-icon><md-select ng-model=\"receipt.BrandAccountNumber\" \nng-disabled=\"!banks || isClicked || $root.AdminLevel!=3 || receipt.ID\"><md-option ng-repeat=\"bank in banks\" \nng-value=\"bank.Number\">{{bank.Name}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon ng-if=\"!receipt.FileRecipt\" md-svg-icon=\"upload\" \nclass=\"name\"></md-icon><md-icon ng-disabled=\"isClicked\" ng-if=\"receipt.FileRecipt\" md-svg-icon=\"eye\" \nhref=\"{{receipt.FileRecipt}}\" ng-click=\"viewFile(receipt.FileRecipt)\" style=\"cursor: pointer\" title=\"צפייה בקובץ\" \nclass=\"name\"></md-icon><label>אסמכתא</label><input ng-disabled=\"isClicked || receipt.ID\" \nngf-select=\"uploadFile($file,null,null,\'1\')\" placeholder=\"{{fileName2}}\" ng-model=\"file\" name=\"file\" \nstyle=\"cursor: pointer\" readonly=\"readonly\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-show=\"receipt.PaymentType==4\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל הצ\'ק</label><input \nng-model=\"receipt.CheckOwner\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || (receipt.ID && !$root.User.AccountancyPer)\" \nng-required=\"receipt.PaymentType==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר צ\'קים\n</label><input ng-model=\"receipt.NumberOfCheck\" ng-change=\"generateChecks()\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || receipt.ID\" ng-required=\"receipt.PaymentType==4\"></md-input-container>\n</div></div><div ng-repeat=\"check in receipt.ChecksData\" layout=\"row\" flex=\"100\" \nng-show=\"receipt.PaymentType==4 && receipt.ChecksData!= null\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-bank\" class=\"name\"></md-icon><label>\nבנק</label><input ng-model=\"check.CheckBank\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || (receipt.ID && !$root.User.AccountancyPer)\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר סניף</label><input ng-model=\"check.CheckBranch\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || (receipt.ID && !$root.User.AccountancyPer)\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר חשבון</label><input ng-model=\"check.CheckAccountNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || (receipt.ID && !$root.User.AccountancyPer)\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר המחאה</label><input ng-model=\"check.CheckNumber\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || (receipt.ID && !$root.User.AccountancyPer)\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-block md-icon-left\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"check.CheckMaturityDate\"><label>מועד פרעון</label><input \nng-required=\"newRegistration.Type==4\" autocomplete=\"off\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || (receipt.ID && !$root.User.AccountancyPer)\" \nng-value=\"check.CheckMaturityDate\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon>\n<label>סכום המחאה</label><input ng-model=\"check.CheckAmount\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || (receipt.ID && !$root.User.AccountancyPer)\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-font-icon=\"icon-comment-text\" class=\"name\"></md-icon><label>הערה לקבלה</label><input \nng-model=\"receipt.Comments\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || (receipt.ID && !$root.User.AccountancyPer)\"></md-input-container>\n</div></div><md-button ng-show=\"$root.AdminLevel==3 || $root.User.AccountancyPer\" type=\"submit\" \nng-disabled=\"isClicked || $root.AdminLevel!=3 || PaymentForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"savePayment(receipt)\">עדכון</md-button></form></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/questions.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"registrations.Questions.length==0\"><span>לא קיימותשאלות</span></div><form name=\"UserForm\" \nclass=\"md-inline-form\" validate ng-if=\"registrations.Questions.length>0\"><div layout=\"row\" layout-wrap \nng-repeat=\"question in registrations.Questions\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\"><md-icon style=\"cursor: pointer\" md-svg-icon=\"help-circle\" class=\"name\"></md-icon><label \nng-if=\"question.AnswerType != 5\">{{question.Description}}</label><input ng-if=\"question.AnswerType==1\" \nng-model=\"question.Answer\" ng-disabled=\"isClicked || $root.AdminLevel<3\"><md-select ng-if=\"question.AnswerType==2\" \nng-model=\"question.Answer\" ng-disabled=\"isClicked || $root.AdminLevel<3\"><md-option \nng-repeat=\"questionOption in question.Options\" ng-value=\"questionOption\">{{questionOption}}</md-option></md-select><div\n ng-if=\"question.AnswerType==4\" start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"question.Answer\"><input\n autocomplete=\"off\" ng-model=\"question.Answer\" ng-disabled=\"isClicked || $root.AdminLevel<3\"></div><md-checkbox \nng-if=\"question.AnswerType == 5\" ng-required=\"question.Required\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-model=\"question.Answer\">{{question.Description}}</md-checkbox></md-input-container><div class=\"w100a relative\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nng-if=\"question.AnswerType==3\"><md-icon md-svg-icon=\"download\" class=\"name\"></md-icon><label>{{question.Description}}\n</label><input style=\"cursor: pointer\" ng-click=\"openFile(question.Answer)\" placeholder=\"לחצ\\י לצפייה בקובץ\" \nreadonly=\"readonly\"></md-input-container><label class=\"uploadfile\" ng-if=\"question.AnswerType==3\" \nfor=\"file{{question.ID}}\" title=\"החלפת קובץ\"><md-icon md-svg-icon=\"upload\" class=\"name\"></md-icon></label><input \nng-if=\"question.AnswerType==3\" ngf-select=\"uploadFile($file,\'q\',question,null)\" \nplaceholder=\"{{fileNames[question.ID]}}\" ng-model=\"file\" id=\"file{{question.ID}}\" name=\"file{{question.ID}}\" \nngf-pattern=\"\'image/*,application/pdf\'\" style=\"cursor: pointer; display:none\" readonly=\"readonly\"></div></div>\n<md-button ng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"updateQuestions(registrations.Questions)\">עדכון</md-button></form>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/registration.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"registrations.Registration\"><form name=\"UserForm\" \nclass=\"md-inline-form\"><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"calendar\" class=\"name\"></md-icon><label>תאריך רישום</label>\n<input ng-value=\"registrations.Registration.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום תשלום</label><input \nng-model=\"registrations.Registration.FinalPrice\" ng-disabled=\"registrations.Registration.PaymentType != 11\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>\nסכום {{$root.User.Event}}</label><input ng-if=\"registrations.Registration.Discount\" \nng-value=\"setPrice(registrations.Registration.FinalPrice,registrations.Registration.Discount)\" ng-disabled=\"true\"> \n<input ng-if=\"!registrations.Registration.Discount\" ng-value=\"registrations.Registration.FinalPrice\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"power\" class=\"name\"></md-icon><label>סטטוס הרשמה</label>\n<md-select ng-model=\"registrations.Registration.Status\"><md-option ng-value=\"\'1\'\" \nng-disabled=\"(registrations.Registration.Canceled > 0)\">פעיל</md-option><md-option ng-value=\"\'0\'\" disabled=\"disabled\">\nלא פעיל</md-option><md-option ng-value=\"\'-1\'\">מוקפא</md-option><md-option ng-value=\"\'-2\'\">מחכה לאישור הורה נוסף\n</md-option></md-select></md-input-container></div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"clipboard-text\" \nclass=\"name\"></md-icon><label>הערות פנימיות</label><textarea ng-model=\"registrations.Registration.InternalComments\" \nng-disabled=\"isClicked\"></textarea></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-if=\"registrations.Registration.EventType != 1\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>האם בוצע סבסוד להרשמה\n</label><md-select ng-model=\"registrations.Registration.Subsidization\" ng-disabled=\"isClicked || $root.AdminLevel<3 \">\n<md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div><div\n layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon \nng-if=\"!registrations.Registration.File\" md-svg-icon=\"upload\" class=\"name\"></md-icon><md-icon ng-disabled=\"isClicked\" \nng-if=\"registrations.Registration.File\" md-svg-icon=\"eye\" href=\"{{registrations.Registration.File}}\" \nng-click=\"viewFile(registrations.Registration.File)\" style=\"cursor: pointer\" title=\"צפייה בקובץ\" class=\"name\">\n</md-icon><label>עדכון קובץ</label><input ng-disabled=\"isClicked\" ngf-select=\"uploadFile($file,null,null,null)\" \nplaceholder=\"{{fileName}}\" ng-model=\"file\" name=\"file\" style=\"cursor: pointer\" readonly=\"readonly\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\" ng-if=\"registrations.Registration.Subsidization\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"account\"><md-icon \nmd-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>שם הגורם המסבסד</label><textarea \nng-model=\"registrations.Registration.SubsidizationName\" ng-disabled=\"isClicked\"></textarea></md-input-container></div>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"clipboard-text\" class=\"name\"></md-icon><label>סכום אשר סובסד</label><textarea \nng-model=\"registrations.Registration.SubsidizationSum\" ng-disabled=\"isClicked\"></textarea></md-input-container></div>\n</div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-input-container\n class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"account-box\" class=\"name\"></md-icon><label>מקור הרשמה</label><input \nng-value=\"(registrations.Registration.Type | registrationSource)  + \' (\' + registrations.Registration.executor + \')\'\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\" \nng-if=\"registrations.Registration.EventType != 1\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"account-box\" \nclass=\"name\"></md-icon><label>קבוצת {{$root.User.Event}}</label><md-select ng-model=\"registrations.Registration.Group\" \nng-disabled=\"isClicked || $root.AdminLevel == 1 \"><md-option \nng-repeat=\"group in registrations.Registration.EventsGroup\" ng-value=\"group\">{{group}}</md-option></md-select>\n</md-input-container></div></div><div class=\"row\" layout=\"row\" ng-if=\"registrations.Registration.SeatName\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon \nmd-font-icon=\"icon-border-inside\" class=\"name\"></md-icon><label>איזור</label><input \nng-value=\"registrations.Registration.SectionName\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon \nmd-font-icon=\"icon-format-align-justify\" class=\"name\"></md-icon><label>שורה</label><input \nng-value=\"registrations.Registration.RowName\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-font-icon=\"icon-view-week\" \nclass=\"name\"></md-icon><label>כסא</label><input ng-value=\"registrations.Registration.SeatName\" ng-disabled=\"true\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"name\">\n</md-icon><label>אישור שינויי מצב בריאותי</label><md-select ng-model=\"registrations.Registration.HealthChanges\" \nng-disabled=\"true || isClicked || $root.AdminLevel<3 \"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-font-icon=\"icon-camera\" class=\"name\"></md-icon><label>אישור שימוש בתמונות\n</label><md-select ng-model=\"registrations.Registration.ImageUsage\" \nng-disabled=\"true ||isClicked || $root.AdminLevel<3 \"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא\n</md-option></md-select></md-input-container></div></div><div ng-if=\"registrations.Registration.MonthlyPayment == 1\">\n<md-divider class=\"vm20\"></md-divider><div class=\"row aic\" layout=\"row\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"33\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\">\n</md-icon><label>גורם מאשר</label><input ng-value=\"registrations.Registration.ApproveName\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-font-icon=\"icon-calendar-blank\" class=\"name\"></md-icon><label>תאריך אישור</label><input \nng-if=\"registrations.Registration.ApproveDate != null\" \nng-value=\"registrations.Registration.ApproveDate | cmdate:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\"> <input \nng-if=\"registrations.Registration.ApproveDate == null\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\" ng-if=\"!registrations.Registration.ApproveDate\"><md-button \nng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"approveRegistration()\">אישור הרשמה</md-button></div></div></div><div \nng-if=\"registrations.Registration.UserName || registrations.Registration.UserPhone || registrations.Registration.UserEmail\">\n<md-divider class=\"vm20\"></md-divider><div class=\"row\" layout=\"row\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon>\n<label>שם משתתף</label><input ng-value=\"registrations.Registration.UserName\" ng-disabled=\"true\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-font-icon=\"icon-cellphone\" class=\"name\"></md-icon><label>טלפון</label><input \nng-value=\"registrations.Registration.UserPhone\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-font-icon=\"icon-email\" \nclass=\"name\"></md-icon><label>דוא\"ל</label><input ng-value=\"registrations.Registration.UserEmail\" ng-disabled=\"true\">\n</md-input-container></div></div></div><md-button ng-if=\"$root.AdminLevel>=2\" type=\"submit\" ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"updateRegistration(registrations.Registration)\">עדכון\n</md-button><md-button ng-if=\"eventID && $root.AdminLevel>=2\" type=\"button\" ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"swapEvent(registrations.Registration.ID)\">החלפת חוג</md-button>\n</form></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/signedFile.html","<div class=\"mb20\" ng-if=\"registrations.Registration.SingedInfoFile\"><div class=\"hfs18\">חוזר הורים</div><embed \nclass=\"w100 mh50vh\" ng-src=\"{{trustSrc(registrations.Registration.SingedInfoFile)}}\"><md-divider></md-divider></div>\n<div class=\"mb20\" ng-if=\"registrations.Registration.HealthDeclarations.length\"><div class=\"hfs18\">הצהרות בריאות</div>\n<div ng-repeat=\"file in registrations.Registration.HealthDeclarations\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-clock\" class=\"name\"></md-icon><label>\nשעת מילויי</label><input ng-value=\"file.Timestamp * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\">\n</md-input-container></div><embed class=\"w100 mh50vh\" ng-src=\"{{trustSrc(file.File)}}\"><md-divider></md-divider></div>\n</div><div class=\"mb20\" ng-if=\"registrations.Registration.DivorcedParentFiles\"><div class=\"hfs18\">הסכמי הורים גרושים\n</div><div ng-repeat=\"file in registrations.Registration.DivorcedParentFiles\" class=\"mt10\"><div layout=\"row\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"name\"></md-icon><label>שעת מילויי</label><input \nng-value=\"file.Timestamp * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם הורה</label><input \nng-value=\"file.ParentName? file.ParentName : \'חיצוני\'\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-md=\"33\" ng-if=\"file.Email\"><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon><label>שליחה למייל</label><input ng-value=\"file.Email\" \nng-disabled=\"true\"></md-input-container></div></div><embed class=\"w100 mh50vh\" ng-src=\"{{trustSrc(file.File)}}\">\n<md-divider></md-divider></div></div>");
$templateCache.put("app/main/pages/events-dialogs/full-registration-dialog/tabs/transportation.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!registrations\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"registrations.Transportation.length==0\"><span>לא קיימות הסעות</span></div><form name=\"UserForm\" \nclass=\"md-inline-form\" validate ng-if=\"registrations.Transportation.length>0\"><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>הסעה הלוך</label><md-select \nng-model=\"registrations.Transportation.SelectedTransportationTo\" ng-disabled=\"isClicked || $root.AdminLevel<3\">\n<md-option ng-repeat=\"transportation in registrations.Transportation\" ng-selected=\"transportation.Selected\" \nng-value=\"transportation\" ng-if=\"transportation.Way==1\">{{transportation.Name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" \nclass=\"name\"></md-icon><label>תחנה הלוך</label><md-select \nng-model=\"registrations.Transportation.SelectedTransportationStopTo\" ng-disabled=\"isClicked || $root.AdminLevel<3\">\n<md-option ng-repeat=\"stop in registrations.Transportation.SelectedTransportationTo.Stops\" ng-selected=\"stop.Selected\" \nng-value=\"stop\">{{stop.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>הסעה חזור</label><md-select \nng-disabled=\"isClicked || $root.AdminLevel<3\" ng-model=\"registrations.Transportation.SelectedTransportationFrom\">\n<md-option ng-repeat=\"transportation in registrations.Transportation\" ng-selected=\"transportation.Selected\" \nng-if=\"transportation.Way==2\" ng-value=\"transportation\">{{transportation.Name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" \nclass=\"name\"></md-icon><label>תחנה חזור</label><md-select \nng-model=\"registrations.Transportation.SelectedTransportationStopFrom\" ng-disabled=\"isClicked || $root.AdminLevel<3\">\n<md-option ng-repeat=\"stop in registrations.Transportation.SelectedTransportationFrom.Stops\" \nng-selected=\"stop.Selected\" ng-value=\"stop\">{{stop.Name}}</md-option></md-select></md-input-container></div><md-button \nng-if=\"$root.AdminLevel==3\" type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"updateTransportation()\">עדכון</md-button></form>");
$templateCache.put("app/main/ui/theme-colors/tabs/background/background.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-background-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.background.color}}</div><div \nflex>.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.background.contrast1}}</div><div flex>.md-background-bg</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.contrast2}}</div><div class=\"secondary-text\" flex>.md-background-bg .secondary-text\n</div></div><div class=\"md-background-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" layout-padding><div \nclass=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.background.contrast3}}</div><div class=\"hint-text\" flex>.md-background-bg .hint-text</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.background.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-background-bg .divider</div></div><div flex=\"100\" class=\"md-primary-bg md-background-fg\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.background.color}}\n</div><div flex>.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap \nlayout-align=\"center center\"><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nHue 1</div><div flex>{{vm.themes.active.theme.background.hue1.color}}</div><div flex>.md-background-bg .md-hue-1</div>\n</div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.background.hue1.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-1 .secondary-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue1.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-1 .hint-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-1\">As foreground color</div><div flex class=\"md-background-fg md-hue-1\">\n{{vm.themes.active.theme.background.hue1.color}}</div><div flex class=\"md-background-fg md-hue-1\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex>.md-background-bg .md-hue-2</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue2.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-2 .secondary-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue2.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-2 .hint-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-2\">As foreground color</div><div flex class=\"md-background-fg md-hue-2\">\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex class=\"md-background-fg md-hue-2\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex>.md-background-bg .md-hue-3</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue3.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-3 .secondary-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue3.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-3 .hint-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-3\">As foreground color</div><div flex class=\"md-background-fg md-hue-3\">\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex class=\"md-background-fg md-hue-3\">.md-background-fg\n</div></div></div>");
$templateCache.put("app/main/pages/events-dialogs/group-refund-registration-dialog/group-refund-receipts-dialog/group-refund-receipts-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nזיכוי הרשמה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"content\" flex style=\"max-height: 70vh; overflow-y: auto\"><md-content \nclass=\"about-tab\" style=\"padding: 20px\"><md-input-container class=\"md-block\" \nng-if=\"RefundModel != 1 && MultipleRefunds\"><p ng-if=\"RefundModel == 2\" class=\"fcred\">\n*שים לב! הסכום יתווסף להזמנות המזוכות, עד לסכום המקורי ששולם.</p><p ng-if=\"RefundModel == 3\" class=\"fcred\">\n*שים לב! בהזמנות מזוכות יתבצע זיכוי עד אחוז הזיכוי המבוקש מהסכום המקורי ששולם.</p></md-input-container><div \nclass=\"dflex aic jcsb\"><p class=\"fcred\">לא ניתן לזכות בזיכוי קבוצתי הרשמות עם יותר מקבלה אחת</p><md-input-container \nclass=\"md-icon-float md-block\"><md-select ng-model=\"displayFilter\" ng-change=\"filterReceipts()\" placeholder=\"סינון\">\n<md-option ng-value=\"0\">הצג הכל</md-option><md-option ng-value=\"1\">קבלה בודדת</md-option><md-option ng-value=\"2\">\nקבלות מרובות</md-option></md-select></md-input-container></div><form name=\"cancelRegistrationForm\" \nclass=\"md-inline-form\" validate><div ng-if=\"Receipts\"><table id=\"group-refunds-preview-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><input \nng-disabled=\"displayFilter != 1\" ng-model=\"selectAll\" type=\"checkbox\" \nng-change=\"displayFilter == 1 && setAll(selectAll)\"></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">ת.ז</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם מלא</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סכום קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סכום זיכויים קודמים</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סכום לזיכוי</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס זיכויי</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-class=\"{\'divorcedProblem\' : registrationValue.DivorcedParents && registrationValue.DivorcedParentsApprovals < 2,\r\n                                           \'proccesing\':Receipt.process == 0,\'success\': Receipt.process == 1, \'failed\': Receipt.process == -1}\" \nng-repeat=\"Receipt in filteredReceipts\"><td><input type=\"checkbox\" ng-model=\"Receipt.Selected\" \nng-disabled=\"Receipt.ReceiptCount>1 || (displayFilter != 1) || Receipt.process != undefined\" \nng-click=\"displayFilter == 1 && studentToggled(Receipt)\"></td><td>{{Receipt.PrivateID}}</td><td>{{Receipt.Name}}</td>\n<td>{{Receipt.ReceiptID}}</td><td>{{Receipt.Amount}} &#8362;</td><td>{{Receipt.Refunded}} &#8362;</td><td>\n{{Receipt.Refund}} &#8362;</td><td>{{Receipt.ReceiptDate * 1000 | date: \'dd/MM/yyyy\'}}</td><td><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"Receipt.process == 0\"></md-progress-linear><span ng-if=\"Receipt.process==-1\">נכשל</span>\n <span ng-if=\"Receipt.process==1\">הצליח</span> <span ng-if=\"Receipt.process==0\">בתהליך</span></td></tr></tbody></table>\n</div></form></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"cancelRegistrationForm.$invalid || refundesFinished != currentRefundingCount || getRefundsAmount() == 0\" \nng-click=\"GroupRefundRegistration()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nזיכוי הרשמות ({{getRefundsAmount()}})</md-button><md-button \nng-disabled=\"cancelRegistrationForm.$invalid || refundesFinished != currentRefundingCount\" ng-click=\"closeDialog()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">סגירה</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/accountancy/views/export-movements/export-movements.html","<div id=\"export-movements\" class=\"page-layout simple tabbed\" ng-init=\"vm.init()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">יצוא תנועות</span></div>\n</div><div class=\"content\"><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\" \nng-if=\"vm.search.Type == 4\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" \nformat=\"MM/YYYY\" moment-picker=\"vm.search.From\"><label>מתאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.From\" ng-disabled=\"vm.load\" required></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\" ng-if=\"vm.search.Type != 4\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.From\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.From\" \nng-disabled=\"vm.load\" required></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\" ng-if=\"vm.search.Type != 4\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" \nflex-xs=\"100\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"vm.search.To\"><label>עד לתאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.To\" ng-disabled=\"vm.load\" required></div></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\">\n<md-icon md-font-icon=\"icon-file-document-box\"></md-icon><label>סוג דוח</label><md-select ng-model=\"vm.search.Type\" \nng-disabled=\"vm.load\" placeholder=\"סוג דוח\" ng-change=\"vm.getEPRInfo(e)\"><md-option ng-value=\"\'1\'\">דו\"ח משיכה ל-EPR\n</md-option><md-option ng-value=\"\'4\'\">ייצוא תנועות EPR - חדש</md-option><md-option ng-value=\"\'2\'\">\nדו\"ח משיכה מזומן ל-EPR</md-option><md-option ng-value=\"\'3\'\">דו\"ח עסקאות בתשלומים</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"vm.terminalManagement\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-file-document-box\"></md-icon><label>חשבון</label><md-select ng-model=\"vm.search.TerminalID\" \nplaceholder=\"בחירת חשבון\" ng-required=\"vm.terminalManagement\"><md-option ng-repeat=\"terminal in vm.terminals\" \nng-value=\"terminal.ID\">{{terminal.Name}}</md-option></md-select></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" ng-if=\"vm.codes\"><md-input-container class=\"md-icon-float md-block\" \nflex=\"25\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><label>סעיף תקציבי</label><md-select \nmd-on-close=\"clearSearchTerm()\" ng-model=\"vm.search.CostingCodes\" ng-disabled=\"isClicked\" multiple=\"multiple\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר סעיף תקציבי\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\"><md-option \nng-repeat=\"code in vm.codes |filter:searchTerm\" ng-value=\"code\">{{code}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"vm.payments\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-file-document-box\"></md-icon><label>אמצעי תשלום</label><md-select ng-model=\"vm.search.Payments\" \nmultiple=\"\" ng-disabled=\"vm.load\" placeholder=\"אמצעי תשלום\"><md-option ng-repeat=\"payment in vm.payments\" \nng-value=\"payment\">{{payment}}</md-option></md-select></md-input-container></div></div><div class=\"search-actions row\" \nlayout=\"row\"><md-button type=\"submit\" \nng-disabled=\"(!vm.search.From && !vm.search.To) || !vm.search.Type || vm.load || UserForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.createReport()\">יצא דוח</md-button></div></form></div></div>\n<div ng-show=\"load\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/pages/accountancy/views/payments-match/payments-match.html","<div id=\"export-movements\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">התאמות מול ספק הסליקה</span></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>התאמות לפי תאריכים\n</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/accountancy/views/payments-match/tabs/match-by-dates.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/pages/accountancy/views/receipt-transactions/receipt-transactions.html","<div id=\"receipt-transactions\" class=\"page-layout simple tabbed\" ng-init=\"vm.init()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">עסקאות אשראי</span>\n</div></div><div class=\"content\"><div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"export-checks-button\" ng-click=\"vm.exportTransactions()\" aria-label=\"add systemUser\" title=\'ייצוא דו\"ח עסקאות\'>\n<md-icon md-font-icon=\"icon-file-excel\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.startDate\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.startDate\" \nng-disabled=\"!vm.transactions\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.endDate\"><label>עד תאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.endDate\" \nng-disabled=\"!vm.transactions\"></div></md-input-container></div></div><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" class=\"name\">\n</md-icon><label>מצב עסקה</label><md-select ng-model=\"vm.search.StatusCode\" ng-disabled=\"isClicked\"><md-option \nng-value=\"null\">הכל</md-option><md-option ng-value=\"1\">תקין</md-option><md-option ng-value=\"2\">לא תקין</md-option>\n</md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סוג עסקה\n</label><md-select ng-model=\"vm.search.Type\" ng-disabled=\"isClicked\" multiple=\"\"><md-option ng-value=\"1\">חיוב רגיל\n</md-option><md-option ng-value=\"2\">חיוב הוראת קבע</md-option><md-option ng-value=\"3\">יצירת הוראת קבע</md-option>\n<md-option ng-value=\"4\">זיכויי</md-option></md-select></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><label>שיוך לקטגוריה\n</label><md-icon md-svg-icon=\"apps\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"vm.search.CategoryID\" ng-disabled=\"isClicked\" data-ng-required=\"vm.terminalManagement\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר קטגוריה\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\"><md-option ng-value=\"null\">הכל</md-option>\n<md-option ng-repeat=\"category in vm.categories |filter:searchTerm\" ng-value=\"category.ID\">\n{{vm.terminalManagement ? category.Name : category.Path.join(\' › \')}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><label>\nסעיף תקציבי</label><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"vm.search.CostingCode\" ng-disabled=\"isClicked\" \nmultiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm1\" type=\"text\" \nng-disabled=\"isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר סעיף תקציבי\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\">\n<md-option ng-repeat=\"code in vm.costingCodes |filter:searchTerm1\" ng-value=\"code\">{{code}}</md-option></md-optgroup>\n</md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי\n</label><input ng-model=\"vm.search.FreeSearch\" ng-disabled=\"isClicked\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"UserForm.$invalid ||  vm.isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getTransactions()\">סינון</md-button><md-button type=\"reset\" \nclass=\"md-raised md-accent\" aria-label=\"ביטול סינון\" ng-click=\"vm.getTransactions(true)\" ng-disabled=\"vm.isClicked\">\nניקוי שדות</md-button></div></form></div></div><div ng-if=\"!vm.transactions\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"vm.transactions\" class=\"accountancy-table-c\"><table id=\"transactions-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nמזהה עסקה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">הרשמה</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">קוד תמחור</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מצב עסקה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג עסקה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">4 ספרות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תוקף</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">חברה סולקת</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר ריכוז</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מסוף</span></div></th></tr></thead><tbody>\n<tr class=\"entry-code-item\" \nng-class=\"{\'red\':transaction.StatusCode != \'000\',\'green\': transaction.StatusCode == \'000\'}\" \nng-repeat=\"transaction in vm.transactions | orderBy:ID\" dt-column-defs=\"vm.dtColumnDefs\"><td>{{transaction.ID}}</td>\n<td>{{transaction.Registration}}</td><td>{{transaction.CostingCode}}</td><td><span class=\"dpn\">\n{{transaction.TransactionInitTime}}</span>{{transaction.TransactionInitTime | cmdate:\'HH:mm:ss dd/MM/yyyy\'}}</td><td>\n{{transaction.StatusCodeText}}</td><td>{{transaction.Type}}</td><td>{{transaction.CreditCardNumber.substr(-4)}}</td>\n<td>{{transaction.CreditCardExpDate}}</td><td>{{transaction.CreditCardCompanyClearerName}}</td><td>\n{{transaction.MisparRikuz}}</td><td>{{transaction.Sum}}</td><td>{{transaction.TerminalName}}</td></tr></tbody></table>\n</div></div></div>");
$templateCache.put("app/main/pages/admin/admin-management/admin-profile-panel/admin-profile-panel.html","<md-content ms-scroll><form name=\"systemUserForm\" data-ng-model=\"systemUserForm\" class=\"md-inline-form\" validate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת מנהל</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{adminProfile.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\" \nclass=\"md-avatar avatar systemUser-avatar huge\" alt=\"{{adminProfile.UserName}}\"><div class=\"selectedUser-name\">\n{{ adminProfile.FirstName }} {{ adminProfile.LastName }}</div></div></div></md-toolbar><md-input-container \nclass=\"md-block\"><label>דואר אלקטרוני</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input \nng-model=\"adminProfile.Email\" type=\"email\" ng-disabled=\"true\" data-ng-required=\"$root.newSystemUser\" autofocus>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label>שם פרטי</label><md-icon \nmd-font-icon=\"icon-account\" class=\"email\"></md-icon><input ng-model=\"adminProfile.FirstName\" type=\"text\" \ndata-ng-required=\"$root.newSystemUser\" ng-disabled=\"adminProfile.GodMode == 1\"></md-input-container><md-input-container\n class=\"md-icon-float md-block\"><label>שם משפחה</label><md-icon md-font-icon=\"icon-account\" class=\"email\"></md-icon>\n<input ng-model=\"adminProfile.LastName\" type=\"text\" data-ng-required=\"$root.newSystemUser\" \nng-disabled=\"adminProfile.GodMode == 1\"></md-input-container><md-input-container class=\"md-block\"><label>\nהרשאות פיננסיות</label><md-icon md-font-icon=\"icon-credit-card-multiple\"></md-icon><md-select \nng-model=\"adminProfile.AccountancyPer\" ng-disabled=\"adminProfile.GodMode == 1\"><md-option ng-value=\"1\">כן</md-option>\n<md-option ng-value=\"0\">לא</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nהרשאות מלאות</label><md-icon md-font-icon=\"icon-lock\"></md-icon><md-select ng-model=\"adminProfile.SuperAdmin\" \nplaceholder=\"סטטוס\" ng-disabled=\"adminProfile.GodMode == 1\"><md-option ng-selected=\"adminProfile.SuperAdmin==1\" \nng-value=\"1\">כן</md-option><md-option ng-selected=\"adminProfile.SuperAdmin==0\" ng-value=\"0\">לא</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>סטטוס</label><md-icon md-font-icon=\"icon-power\">\n</md-icon><md-select ng-model=\"adminProfile.Status\" placeholder=\"סטטוס\" ng-disabled=\"adminProfile.GodMode == 1\">\n<md-option ng-selected=\"adminProfile.Status==1\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"adminProfile.Status==0\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></form>\n</md-content>");
$templateCache.put("app/main/pages/admin/admin-management/new-admin-dialog/new-admin-dialog.html","<md-dialog class=\"newAdmins-dialog\" aria-label=\"New Task\"><form name=\"newAdminsForm\" data-ng-model=\"newAdminsForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת מנהל חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>שם פרטי</label><input ng-model=\"newAdmin.FirstName\" type=\"text\" data-ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>שם משפחה</label><input ng-model=\"newAdmin.LastName\" type=\"text\" data-ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><label>אימייל:</label><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-required=\"true\" ng-model=\"newAdmin.Email\" type=\"email\" \nng-disabled=\"isClicked\" \nng-pattern=\"/[0-9a-zA-Z_-]+?(\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|)@[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z]{2,15}(|\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15})/\">\n</md-input-container><md-input-container class=\"md-block\"><label>הרשאות פיננסיות</label><md-icon \nmd-font-icon=\"icon-credit-card-multiple\"></md-icon><md-select ng-model=\"newAdmin.AccountancyPer\" \nng-disabled=\"isClicked\" required><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>הרשאות מלאות</label><md-icon \nmd-font-icon=\"icon-lock\"></md-icon><md-select ng-model=\"newAdmin.SuperAdmin\" ng-disabled=\"isClicked\" required>\n<md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"newAdminsForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewAdmin()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שלח הזמנה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events-extras/views/monthlyCharge/monthlyCharge.html","<div id=\"MonthlyChargePage\" class=\"page-layout simple tabbed\"><iframe src=\"{{trustSrc()}}\" class=\"w100 h100\" \nstyle=\"height: 90vh\"></iframe></div>");
$templateCache.put("app/main/pages/events-extras/views/registrations/registrations.html","<div id=\"registrations\" class=\"page-layout simple tabbed\" ng-init=\"init()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הרשמות</span></div>\n</div><div class=\"content\"><div class=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel>2\" \nclass=\"md-fab md-accent md-icon-button mb10 cash\" ng-click=\"changePaymentsStatus()\" title=\"אישור סטטוס תשלום רכזים\" \nng-disabled=\"selectedStudentsCount == 0\" aria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cash-100\"></md-icon>\n</md-button><md-button ng-if=\"$root.AdminLevel>2\" class=\"md-fab md-accent md-icon-button mb10 cash\" \nng-click=\"approveRegistrations()\" title=\"אישוריי הרשמות\" \nng-disabled=\"!registrations || registrations.length==0 || selectedStudentsCount == 0\" aria-label=\"add systemUser\">\n<md-icon md-font-icon=\"icon-check-all\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nng-if=\"$root.AdminLevel>1\" title=\"התחל לרשום שם {{$root.orgTypeBranchName.single}}\"><label>\n{{$root.orgTypeBranchName.plural}}</label><md-icon md-font-icon=\"icon-city\"></md-icon><md-select \nng-model=\"search.settlements\" ng-disabled=\"!settlements || isClicked\" ng-change=\"getGroups()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.orgTypeBranchName.plural}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup><md-option ng-repeat=\"settlement in settlements | filter: searchTerm\" \nng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" title=\"התחל לרשום שם  {{$root.User.Group}}\"><label>{{$root.User.Groups}}</label><md-icon\n md-font-icon=\"icon-account-multiple\"></md-icon><md-select ng-model=\"search.groups\" ng-disabled=\"!groups || isClicked\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm2\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Groups}}\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-repeat=\"group in groups | filter: searchTerm2\" \nng-value=\"group.ID\">{{group.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\" ng-if=\"$root.AdminLevel>1\" \ntitle=\"התחל לרשום שם {{$root.User.Grade}}\"><label>{{$root.User.Grades}}</label><md-icon \nmd-font-icon=\"icon-chair-school\"></md-icon><md-select ng-model=\"search.grades\" ng-disabled=\"!grades || isClicked\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm3\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Grades}}\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-repeat=\"grade in grades | filter: searchTerm3\" \nng-value=\"grade.ID\">{{grade.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block md-icon-left\">\n<md-icon md-font-icon=\"icon-apps\" class=\"name\"></md-icon><label>קטגוריות</label><md-select \nng-model=\"search.categories\" placeholder=\"קטגוריות\" multiple=\"multiple\" ng-change=\"getEvents()\"><md-option \nng-repeat=\"category in categories\" ng-value=\"category.ID\">{{category.Path.join(\' › \')}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-brightness-5\"></md-icon>\n<label>מאורע</label><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.Events\" \nng-disabled=\"isClicked || ! events || events.length == 0\" multiple=\"true\" ng-required=\"$root.AdminLevel<3\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" placeholder=\"חפש מאורע..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\">\n<md-option ng-value=\"event.ID\" ng-repeat=\"event in events |filter:searchTerm\">{{event.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס הזמנה\n</label><md-select ng-model=\"search.Status\" placeholder=\"סינון לפי סטטוס הזמנה\" ng-disabled=\"!registrations\" \nng-init=\"search.Status = 1\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">\nפעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option><md-option ng-value=\"-0\">קפואים</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"credit-card\"></md-icon><label>סטטוס תשלום\n</label><md-select ng-model=\"search.PaymentStatus\" placeholder=\"סינון לפי סטטוס תשלום\" ng-disabled=\"!registrations\" \nng-init=\"search.PaymentStatus = 1\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">שולם\n</md-option><md-option ng-value=\"2\">שולם ל{{$root.User.Coordinators}}</md-option><md-option ng-value=\"3\">טרם אושר\n</md-option><md-option ng-value=\"5\" ng-if=\"$root.advancedCashierOptions\">הופקד לקופה</md-option><md-option \nng-value=\"6\" ng-if=\"$root.advancedCashierOptions\">יצא להפקדה</md-option><md-option ng-value=\"7\" \nng-if=\"$root.advancedCashierOptions\">הופקד</md-option><md-option ng-value=\"0\">לא שולם</md-option></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"search.FromDate\"><label>מתאריך</label><input autocomplete=\"off\" \nng-model=\"search.FromDate\" ng-disabled=\"isClicked\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"search.ToDate\"><label>עד תאריך</label><input autocomplete=\"off\" ng-model=\"search.ToDate\" \nng-disabled=\"isClicked\"></div></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"$root.AdminLevel == 3\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"name\"></md-icon><label>ממתינים לאישור</label><md-select \nng-model=\"search.RegApproved\" ng-disabled=\"!registrations\"><md-option ng-value=\"null\">הכל</md-option><md-option \nng-value=\"1\">ממתינים לאישור</md-option><md-option ng-value=\"2\">קיבלו אישור</md-option></md-select></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><label>סעיף תקציבי</label>\n<md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.CostingCode\" ng-disabled=\"isClicked\" multiple=\"multiple\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm1\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר סעיף תקציבי\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\"><md-option \nng-repeat=\"code in costingCodes |filter:searchTerm1\" ng-value=\"code\">{{code}}</md-option></md-optgroup></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nid=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי\n</label><input ng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!registrations\"></md-input-container>\n</div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"isClicked || !search.FromDate || !search.ToDate || UserForm.$invalid \" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getRegistrations()\">סינון</md-button><md-button type=\"submit\" \nng-disabled=\"isClicked || !search.FromDate || !search.ToDate || UserForm.$invalid \" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getRegistrations(true)\">בטל סינון</md-button></div></form></div></div><div \nng-if=\"!registrations\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"registrations\" class=\"events-table-c\"><table \nid=\"registrations-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><input ng-model=\"selectAll\" type=\"checkbox\" ng-change=\"setAll(selectAll)\"></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך הרשמה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם שמשתתף</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם מאורע</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">עלות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס הזמנה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר קבלה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר זיכוי</span></div></th><th \nclass=\"secondary-text\" ng-if=\"$root.AdminLevel == 3\"><div class=\"table-header\"><span class=\"column-title\">גורם מאשר\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div>\n</th></tr></thead><tbody><tr ng-class=\"{\'divorcedProblem\' : reg.DivorcedParents && reg.DivorcedParentsApprovals < 2}\" \nclass=\"entry-code-item\" ng-repeat=\"reg in registrations | orderBy:ID\"><td><input type=\"checkbox\" \nng-model=\"reg.Selected\" ng-click=\"studentToggled(reg)\"></td><td><span class=\"dpn\">{{reg.RegistrationTime}}</span>\n{{reg.RegistrationTime | cmdate:\'dd/MM/yyyy HH:mm\'}}</td><td>{{reg.MemberName}}</td><td>{{reg.EventName}}</td><td>\n{{reg.Price}} ₪</td><td>{{reg.Status | registrationStatus}}</td><td>{{reg.PaymentStatus | paymentStatus}} <span \nng-if=\"reg.PaymentStatus == 2 && reg.CoordinatorName.length\">({{reg.CoordinatorName}})</span></td><td><div \nclass=\"sflex fdc hfs12\"><a ng-repeat=\"receiptID in reg.ReceiptID\" href=\"#\" ng-click=\"downloadReceipt(receiptID,1)\">\n{{receiptID}}</a></div></td><td><div class=\"sflex fdc hfs12\"><a ng-repeat=\"refundReceiptID in reg.RefundReceiptID\" \nng-if=\"refundReceiptID > 0\" href=\"#\" ng-click=\"downloadReceipt(refundReceiptID,2)\">{{refundReceiptID}}</a></div></td>\n<td ng-if=\"$root.AdminLevel == 3\"><span class=\"dpn\">{{reg.ApproveDate}}</span>{{reg.ApprovalInformation}}</td><td>\n<md-button ng-disabled=\"$root.AdminLevel!=3 || reg.Canceled>0\" class=\"preview-user cancel md-icon-button\" \nng-click=\"cancelRegistration(reg)\" title=\"{{reg.Canceled==\'0\' ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\"><md-icon \nng-class=\"{\'canceled\': reg.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-disabled=\"($root.AdminLevel!=3 && $root.User.AccountancyPer != 1) || reg.RefundDate || reg.ParentsCashTransID\" \nclass=\"preview-user refund md-icon-button\" ng-click=\"refundRegistration(reg)\" \ntitle=\"{{!reg.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\"><md-icon \nng-class=\"{\'refunded\': reg.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button><md-button \nclass=\"preview-user view md-icon-button\" ng-click=\"showFullRegistration(reg)\" title=\"צפייה בפרטי הזמנה\"><md-icon \nmd-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events-extras/views/transportation/transportation.html","<div id=\"transportation\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הסעות</span></div></div><div class=\"content\">\n<div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-newStudent-button\" \nng-click=\"openNewTransportationDialog()\" aria-label=\"add systemUser\" title=\"יצירת הסעה\" ng-disabled=\"isClicked\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"></div></div><form class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.status\" placeholder=\"סינון לפי סטטוס\" \nng-disabled=\"isClicked || transportation.length==0 || !transportation\" ng-init=\"search.status=1\"><md-option \nng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option \nng-value=\"null\">לא פעילים</md-option></md-select></md-input-container></div></div><div class=\"search-actions row\" \nlayout=\"row\"><md-button type=\"submit\" ng-disabled=\"!transportation \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"getTransportation()\">סינון</md-button></div></form><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!transportation\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"transportation\" class=\"events-table-c\"><table id=\"transportation-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם הסעה</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">כמות תחנות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" ng-repeat=\"item in transportation | filter:{ Status: search.status }\"><td>\n{{item.Name}}</td><td>{{item.Stops.length}}</td><td>{{item.Status==1 || item.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td>\n<td><md-button class=\"preview-user\" ng-click=\"editTransportation(item)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button><md-button class=\"preview-user\" ng-click=\"openTransportationStopsPanel(item)\" \ntitle=\"עריכת תחנות\"><md-icon md-svg-icon=\"bus\"></md-icon></md-button><md-button class=\"preview-user\" \nng-click=\"deleteTransportationDialog(item)\" title=\"מחיקה\"><md-icon md-svg-icon=\"delete\"></md-icon></md-button></td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/accountancy/views/cashier/cashier.html","<div id=\"cashier\" class=\"page-layout simple tabbed\" ng-init=\"vm.getCoordinators(); vm.loadSearch();\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">קופה</span></div></div><div class=\"content\"><div class=\"action-buttons\"><md-button\n class=\"md-fab md-accent md-icon-button\" id=\"cashier-button\" ng-click=\"vm.closeCashier(6)\" aria-label=\"add systemUser\" \ntitle=\"יצא להפקדה\"><md-icon md-font-icon=\"icon-briefcase-upload\"></md-icon></md-button><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"close-cashier-button\" ng-click=\"vm.closeCashier(7)\" \naria-label=\"add systemUser\" title=\"הופקד\"><md-icon md-font-icon=\"icon-bank\"></md-icon></md-button><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"export-cashier-button\" ng-click=\"vm.getBankReferenceFiles()\" \nng-disabled=\"vm.selectedCount == 0\" aria-label=\"add systemUser\" title=\"הפקת קבצי הפקדה\"><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" \nflex-xs=\"100\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"vm.search.StartDate\"><label>מתאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.StartDate\" ng-disabled=\"!vm.receipts\"></div></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" \nflex-xs=\"100\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"vm.search.EndDate\"><label>עד תאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.EndDate\" ng-disabled=\"!vm.receipts\"></div></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" \nclass=\"name\"></md-icon><label>סטטוס תשלום</label><md-select ng-model=\"vm.search.PaymentStatus\" \nplaceholder=\"סינון לפי סטטוס תשלום\" ng-disabled=\"!vm.receipts\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option\n ng-value=\"1\">שולם</md-option><md-option ng-value=\"2\">שולם ל{{$root.User.Coordinator}}</md-option><md-option \nng-value=\"3\">טרם אושר</md-option><md-option ng-value=\"5\">הופקד לקופה</md-option><md-option ng-value=\"6\">יצא להפקדה\n</md-option><md-option ng-value=\"7\">הופקד</md-option><md-option ng-value=\"0\">לא שולם</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><label>{{$root.User.Coordinator}} מפקיד</label><md-icon \nmd-font-icon=\"icon-tie\"></md-icon><md-select ng-model=\"vm.search.CoordinatorID\" ng-disabled=\"coordinators\" \nmultiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"{{$root.User.Coordinator}} מפקיד\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"coordinator in vm.coordinators | filter:searchTerm\" ng-value=\"coordinator.ID\">\n{{coordinator.FirstName}} {{coordinator.LastName}}</md-option></md-optgroup></md-select></md-input-container></div>\n</div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getReceipts()\">סינון</md-button></div></form></div></div><div\n ng-if=\"!vm.receipts\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.receipts\"><md-tabs md-dynamic-height><md-tab \nng-disabled=\"$root.isEdit && selectedTab!=0\" md-on-select=\"setTab(0)\"><md-tab-label><span>\nמזומן ({{vm.receipts.cash ? vm.receipts.cash.length : 0}})</span></md-tab-label><md-tab-body><md-content \nclass=\"no-background\"><div class=\"fw-bold mt-10\">סה\"כ: {{vm.getTotal(vm.receipts.cash)}} &#8362;</div><div \nclass=\"fw-bold mt-10\" ng-if=\"vm.settings && vm.settings.Cash\">מספר חשבון: {{vm.settings.Cash}}</div><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<input ng-model=\"vm.selectAllCash\" type=\"checkbox\" ng-change=\"vm.setAll(vm.selectAllCash,\'cash\')\"></span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג מסמך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר מסמך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-class=\"{\'dailySelectedRow\': receipt.dailySelected}\" \nng-repeat=\"receipt in vm.receipts.cash | orderBy:ID\" dt-column-defs=\"vm.dtColumnDefs\"><td><input type=\"checkbox\" \nng-model=\"receipt.Selected\" ng-click=\"vm.toggleCheckBox(receipt)\"></td><td><span class=\"dpn\">{{receipt.Date}}</span>\n{{receipt.Date | cmdate:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{receipt.Type == \'Receipt\' ? \'קבלה\' : \'זיכויי\'}}</td><td><a \nhref=\"#\" ng-click=\"vm.downloadReceipt(receipt)\">{{receipt.ID}}</a></td><td>{{receipt.Name}}</td><td>{{receipt.Amount}}\n</td><td>{{receipt.PaymentStatus | paymentStatus}} <span ng-if=\"receipt.PaymentStatus == 2 && receipt.CoordinatorName\">\n({{receipt.CoordinatorName}})</span></td></tr></tbody></table></md-content></md-tab-body></md-tab><md-tab \nng-disabled=\"$root.isEdit && selectedTab!=1\" md-on-select=\"setTab(1)\"><md-tab-label><span>\nהמחאות מזומן ({{vm.receipts.todayChecks ? vm.receipts.todayChecks.length : 0}})</span></md-tab-label><md-tab-body>\n<md-content class=\"no-background\"><div class=\"fw-bold mt-10\">סה\"כ: {{vm.getTotal(vm.receipts.todayChecks)}} &#8362;\n</div><div class=\"fw-bold mt-10\" ng-if=\"vm.settings && vm.settings.CashCheck\">מספר חשבון: {{vm.settings.CashCheck}}\n</div><table class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<input ng-model=\"vm.selectAllTodayChecks\" type=\"checkbox\" ng-change=\"vm.setAll(vm.selectAllTodayChecks,\'todayChecks\')\">\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר מסמך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">בעל המחאה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">בנק</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סניף</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">חשבון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר המחאה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך פרעון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"receipt in vm.receipts.todayChecks | orderBy:ID\" \ndt-column-defs=\"vm.dtColumnDefs\"><td><input type=\"checkbox\" ng-model=\"receipt.Selected\" \nng-click=\"vm.toggleCheckBox(receipt)\"></td><td><span class=\"dpn\">{{receipt.Date}}</span>\n{{receipt.Date | cmdate:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><a href=\"#\" ng-click=\"vm.downloadReceipt(receipt)\">\n{{receipt.ID}}</a></td><td>{{receipt.CheckOwner}}</td><td>{{receipt.ChecksData.CheckBank}}</td><td>\n{{receipt.ChecksData.CheckBranch}}</td><td>{{receipt.ChecksData.CheckAccountNumber}}</td><td>\n{{receipt.ChecksData.CheckNumber}}</td><td>{{receipt.ChecksData.CheckAmount}}</td><td>\n{{receipt.ChecksData.CheckMaturityDate}}</td><td>{{receipt.PaymentStatus | paymentStatus}} <span \nng-if=\"receipt.PaymentStatus == 2\">({{receipt.CoordinatorName}})</span></td></tr></tbody></table></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=2\" md-on-select=\"setTab(2)\"><md-tab-label>\n<span>המחאות לפרעון עתידי ({{vm.receipts.futureChecks ? vm.receipts.futureChecks.length : 0}})</span></md-tab-label>\n<md-tab-body><md-content class=\"no-background\"><div class=\"fw-bold mt-10\">\nסה\"כ: {{vm.getTotal(vm.receipts.futureChecks)}} &#8362;</div><div class=\"fw-bold mt-10\" \nng-if=\"vm.settings && vm.settings.FutureCheck\">מספר חשבון: {{vm.settings.FutureCheck}}</div><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<input ng-model=\"vm.selectAllFutureChecks\" type=\"checkbox\" \nng-change=\"vm.setAll(vm.selectAllFutureChecks,\'futureChecks\')\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר מסמך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">בעל המחאה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">בנק</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סניף</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">חשבון</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר המחאה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך פרעון</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"receipt in vm.receipts.futureChecks | orderBy:ID\" dt-column-defs=\"vm.dtColumnDefs\">\n<td><input type=\"checkbox\" ng-model=\"receipt.Selected\" ng-click=\"vm.toggleCheckBox(receipt)\"></td><td><span \nclass=\"dpn\">{{receipt.Date}}</span>{{receipt.Date | cmdate:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><a href=\"#\" \nng-click=\"vm.downloadReceipt(receipt)\">{{receipt.ID}}</a></td><td>{{receipt.CheckOwner}}</td><td>\n{{receipt.ChecksData.CheckBank}}</td><td>{{receipt.ChecksData.CheckBranch}}</td><td>\n{{receipt.ChecksData.CheckAccountNumber}}</td><td>{{receipt.ChecksData.CheckNumber}}</td><td>\n{{receipt.ChecksData.CheckAmount}}</td><td>{{receipt.ChecksData.CheckMaturityDate}}</td><td>\n{{receipt.PaymentStatus | paymentStatus}} <span ng-if=\"receipt.PaymentStatus == 2\">({{receipt.CoordinatorName}})</span>\n</td></tr></tbody></table></md-content></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/pages/accountancy/views/receipts/receipts.html","<div id=\"receipts\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">קבלות</span></div></div><div class=\"content\">\n<div class=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel>2\" class=\"md-fab md-accent md-icon-button mb10 cash\" \nng-click=\"changePaymentsStatus()\" title=\"אישור סטטוס תשלום רכזים\" ng-disabled=\"vm.selectedCount == 0\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cash-100\"></md-icon></md-button></div><div layout=\"row\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סוג מסמך</label><md-select \nng-model=\"vm.search.Type\" ng-disabled=\"isClicked\"><md-option ng-value=\"null\">הכל</md-option><md-option ng-value=\"1\">\nקבלות</md-option><md-option ng-value=\"2\">זיכויים</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סוג הרשמה</label><md-select ng-model=\"vm.search.EventType\" \nng-disabled=\"isClicked\"><md-option ng-value=\"null\">הכל</md-option><md-option ng-value=\"1\">פנימית</md-option><md-option \nng-value=\"2\">חיצונית</md-option></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש לפי מספר קבלה\n</label><input ng-model=\"vm.search.FreeSearch\" ng-disabled=\"isClicked\"></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><label>חיפוש לפי 4 ספרות אחרונות</label><input ng-model=\"vm.search.Last4Digit\" ng-disabled=\"isClicked\">\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><label>חיפוש לפי שם</label><input ng-model=\"vm.search.Name\" \nng-disabled=\"isClicked\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cash-100\"></md-icon><label>סטטוס תשלום\n</label><md-select ng-model=\"vm.search.PaymentStatus\" ng-disabled=\"isClicked\"><md-option ng-value=\"null\">הכל\n</md-option><md-option ng-value=\"1\">שולם</md-option><md-option ng-value=\"2\">שולם לרכז</md-option><md-option \nng-value=\"3\">טרם אושר</md-option><md-option ng-value=\"5\">הופקד לקופה</md-option><md-option ng-value=\"6\">יצא להפקדה\n</md-option><md-option ng-value=\"7\">הופקד</md-option><md-option ng-value=\"0\">לא שולם</md-option></md-select>\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getReceipts()\">סינון</md-button>\n<md-button ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getReceipts(true)\">\nבטל סינון</md-button></div></form></div></div><div ng-if=\"!vm.receipts\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"vm.receipts\" class=\"accountancy-table-c\"><table id=\"receipts-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<input ng-model=\"vm.selectAllRec\" type=\"checkbox\" ng-change=\"vm.setAll(vm.selectAllRec)\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר מסמך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג מסמך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פרטים נוספים</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">אמצעי תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"receipt in vm.receipts | orderBy:ID\" dt-column-defs=\"vm.dtColumnDefs\">\n<td><input type=\"checkbox\" ng-model=\"receipt.Selected\" ng-disabled=\"! vm.canBeSelected(receipt)\" \nng-click=\"vm.toggleCheckBox(receipt)\"></td><td><span class=\"dpn\">{{receipt.Date}}</span>\n{{receipt.Date | cmdate:\'dd/MM/yyyy HH:mm\'}}</td><td><a href=\"#\" ng-click=\"vm.downloadReceipt(receipt)\">{{receipt.ID}}\n</a></td><td>{{receipt.Name}}</td><td>{{receipt.Type==1 ? \'קבלה\' : \'זיכוי\'}}</td><td>{{receipt.CreditCardNumber}}</td>\n<td>{{receipt.Amount}}</td><td>{{receipt.PaymentType}}</td><td><span ng-if=\"receipt.PaymentStatus == 1\">שולם</span> \n<span ng-if=\"receipt.PaymentStatus == 2\">שולם לרכז</span> <span ng-if=\"receipt.PaymentStatus == 3\">טרם אושר</span> \n<span ng-if=\"receipt.PaymentStatus == 5\">הופקד לקופה</span> <span ng-if=\"receipt.PaymentStatus == 6\">יצא להפקדה</span> \n<span ng-if=\"receipt.PaymentStatus == 7\">הופקד</span> <span ng-if=\"receipt.PaymentStatus == 0\">לא שולם</span> <span \nng-if=\"receipt.PaymentStatus == 2 && receipt.CoordinatorName != null\">({{receipt.CoordinatorName}})</span></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/pages/accountancy/views/checks/checks.html","<div id=\"checks\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">המחאות</span></div></div><div class=\"content\">\n<div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" id=\"export-checks-button\" \nng-click=\"vm.exportChecks()\" aria-label=\"add systemUser\" title=\'ייצוא דו\"ח המחאות יומי\'><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סוג המחאות</label><md-select ng-model=\"vm.search.Future\" \nng-disabled=\"vm.isClicked\"><md-option ng-value=\"null\">הכל</md-option><md-option ng-value=\"1\">פרעון עתידי</md-option>\n<md-option ng-value=\"2\">הופקדו</md-option><md-option ng-value=\"3\">ליום ספציפי</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"vm.search.Future == 3\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.Date\"><label>תאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.Date\" \nng-disabled=\"vm.isClicked\"></div></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getChecks()\">סינון</md-button><md-button ng-disabled=\"isClicked\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"vm.getChecks(true)\">בטל סינון</md-button></div></form></div></div><div ng-if=\"!vm.checks\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"vm.checks\" class=\"accountancy-table-c\"><table id=\"checks-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nתאריך המחאה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר המחאה</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">בעל המחאה</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">קבלה</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"check in vm.checks  track by $index\" dt-column-defs=\"vm.dtColumnDefs\">\n<td><span class=\"dpn\">{{check.Timestamp}}</span>{{check.CheckMaturityDate}}</td><td>{{check.CheckAmount}}</td><td>\n{{check.CheckNumber}}</td><td>{{check.CheckOwner}}</td><td><a href=\"#\" ng-click=\"vm.downloadReceipt(check.ReceiptID)\">\n{{check.ReceiptID}}</a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events-extras/views/attendance/attendance.html","<div id=\"attendance\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">מפגשי מאורעות</span></div></div><div \nclass=\"content\"><div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-newMeeting-button\" ng-click=\"vm.openNewMeetingDialog()\" aria-label=\"add systemUser\" title=\"יצירת מפגש\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"vm.search.StartDate\"><label>מתאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.StartDate\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.EndDate\">\n<label>עד תאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.EndDate\"></div></md-input-container></div></div>\n<div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><label>מאורע\n</label><md-icon md-svg-icon=\"weather-sunny\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"vm.search.eventID\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" ng-keyup=\"vm.eventKeyPress($event)\" placeholder=\"חפש מאורע..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"!vm.events\">\n<md-option ng-value=\"event.ID\" ng-repeat=\"event in vm.events |filter:searchTerm\">{{event.Name}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><label>חיפוש חופשי</label><input ng-model=\"vm.search.FreeSearchFromDB\" type=\"search\"></md-input-container>\n</div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!vm.meetings\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getMeetings()\">סינון</md-button><md-button \nng-disabled=\"!vm.meetings\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getMeetings(true)\">בטל סינון\n</md-button></div></form><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!vm.meetings\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.meetings\"><table \nid=\"attendance-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">מאורע</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">הערות</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"meeting in vm.meetings\"><td>{{meeting.Name}}</td><td>{{meeting.Date}}</td><td>{{meeting.Comments}}</td><td>\n<md-button class=\"preview-user\" ng-click=\"vm.editMeeting(meeting)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button><md-button class=\"preview-user\" href=\"/meeting-management?ID={{meeting.ID}}\" title=\"ניהול מפגש\">\n<md-icon md-svg-icon=\"settings\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/branches/views/grades/mange-grades.html","<div id=\"grades\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול {{$root.User.Grades}}</span></div></div>\n<div class=\"content\"><div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" \nng-disabled=\"!grades\" id=\"add-newGrade-button\" ng-click=\"addNewGradesDialog()\" aria-label=\"add new Grade\" \ntitle=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><label>שכבת בוגרים</label><md-icon md-font-icon=\"icon-account-box\" class=\"name\">\n</md-icon><md-select ng-model=\"search.graduates\" placeholder=\"סינון לפי סוג שכבה\" ng-disabled=\"!grades\"><md-option \nng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option>\n</md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי\n</label><input id=\"free-search\" ng-model=\"search.freeSearch\" type=\"text\" ng-disabled=\"!grades\"></md-input-container>\n</div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getGrades()\">סינון</md-button></div></form></div></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!grades\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"grades\" class=\"branches-table-c\"><table \nid=\"grades-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשם {{$root.User.Grade}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שנתון</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שכבת בוגרים</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"grade in grades\"><td>{{grade.Name}}</td><td>{{grade.Year}}</td><td>\n{{grade.Graduates==\'1\' || grade.Graduates==1? \'כן\' : \'לא\'}}</td><td>\n{{grade.Status==1 || grade.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user md-icon-button\" \nng-click=\"editGrade(grade)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/pages/events-extras/views/marketing/marketing.html","<div id=\"marketing\" class=\"page-layout simple tabbed\" \nng-init=\"vm.getSettlements();vm.getGrades();vm.getEvents(); vm.loadSearch();\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">שיווק אירועים</span>\n</div></div><div class=\"content\"><div class=\"action-buttons\"><md-button ng-disabled=\"isClicked || !vm.leads\" \nng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" class=\"md-fab md-accent md-icon-button\" id=\"send-emailes-button\" \nng-click=\"vm.openSendEmail()\" aria-label=\"add systemUser\" title=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\">\n</md-icon></md-button><md-button ng-disabled=\"isClicked || !vm.leads\" \nng-if=\"$root.smsEnabled && ($root.AdminLevel>2 || $root.User.SmsPer)\" class=\"md-fab md-accent md-icon-button\" \nid=\"send-SMS-button\" ng-click=\"vm.openSendSMS()\" title=\"שליחת הודעה\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button></div><form name=\"UserForm\" class=\"md-inline-form\" \nvalidate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-brightness-5\"></md-icon><md-select \nng-model=\"vm.search.eventID\" placeholder=\"סינון לפי {{$root.User.Event}}\" ng-disabled=\"!vm.leads\" required><md-option \nng-repeat=\"event in vm.events\" ng-value=\"{{event.ID}}\">{{ event.Name}}</md-option></md-select></md-input-container>\n</div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"$root.AdminLevel>1\" title=\"התחל לרשום שם {{$root.orgTypeBranchName.single}}\">\n<label></label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-contact-chips ng-model=\"vm.search.settlements\" \nmd-contacts=\"vm.settlementsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.orgTypeBranchName.plural}}\"></md-contact-chips></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" \nng-if=\"$root.AdminLevel>1\" title=\"התחל לרשום שם שכבה\"><label></label><md-icon md-font-icon=\"icon-chair-school\">\n</md-icon><md-contact-chips ng-disabled=\"vm.search.freeSearchFromDB\" ng-model=\"vm.search.grades\" \nmd-contacts=\"vm.gradesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.User.Grades}}\"></md-contact-chips></md-input-container></div></div><div\n class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"vm.search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.leads\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!vm.leads || !vm.search.eventID\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getLeads()\">סינון</md-button><md-button \nng-disabled=\"!vm.leads\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getLeads(true)\">בטל סינון</md-button>\n</div></form><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!vm.leads\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.leads\" class=\"marketing-table-c\"><table \nid=\"leads-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<input ng-model=\"selectAll\" type=\"checkbox\" ng-change=\"vm.setAll(selectAll)\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מין</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">דואר אלקטרוני</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Settlement}}</span></div></th>\n</tr></thead><tbody><tr class=\"md-ink-ripple\" ng-repeat=\"student in vm.leads\"><td><input type=\"checkbox\" \nng-model=\"student.Selected\"></td><td><a href=\"/student-profile?ID={{student.ID}}\" style=\"cursor: pointer\">\n{{student.FirstName}} {{student.LastName}}</a></td><td>{{student.Gender==\'Male\' ? \'זכר\' : \'נקבה\'}}</td><td \nng-if=\"student.Gender==\'Male\'\">בן</td><td ng-if=\"student.Gender==\'Female\'\">בת</td><td ng-if=\"student.Gender==\'Other\'\">\nאחר</td><td><a href=\"mailto: {{student.Email}}\">{{student.Email}}</a></td><td>{{student.GroupName}}</td><td>\n{{student.GradeName}}</td><td>{{student.SettlementNAme}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events-extras/views/questions/questions.html","<div id=\"questions\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">שאלות</span></div></div><div class=\"content\">\n<div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-newStudent-button\" \nng-click=\"openNewQuestionDialog()\" aria-label=\"add systemUser\" title=\"יצירת שאלה\" ng-disabled=\"isClicked\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"></div></div><form class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.Status\" placeholder=\"סינון לפי סטטוס\" \nng-disabled=\"!questions\" ng-init=\"search.Status=1\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option \nng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"search.FreeSearchFromDB\" type=\"search\" ng-disabled=\"!questions\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!questions \" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getQuestions()\">סינון</md-button>\n</div></form><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!questions\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"questions\" \nclass=\"events-table-c\"><table id=\"questions-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שאלה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג שאלה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"question in questions  \"><td>{{question.Description}}</td><td>{{setType(question.AnswerType)}}</td><td>\n{{question.Status==1 || question.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user\" \nng-click=\"editQuestion(question)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button><md-button \nclass=\"preview-user\" ng-click=\"deleteQuestionDialog(question)\" title=\"מחיקה\"><md-icon md-svg-icon=\"delete\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/admin/coordinators/coordinators-panel/coordinators-panel.html","<md-content ms-scroll><form name=\"coordinatesForm\" id=\"coordinateForm\" data-ng-model=\"coordinateForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת {{$root.User.Coordinator}}</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-input-container class=\"md-icon-float md-block\">\n<label>שם פרטי</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"coordinate.FirstName\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>שם משפחה\n</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"coordinate.LastName\">\n</md-input-container><md-input-container class=\"md-block\"><label>דואר אלקטרוני</label><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-model=\"coordinate.Email\" dir=\"ltr\"></md-input-container>\n<md-input-container class=\"md-block\"><label>טלפון נייד</label><md-icon md-font-icon=\"icon-phone\"></md-icon><input \nng-model=\"coordinate.PhoneNumber\" dir=\"ltr\" type=\"tel\" data-ng-patter=\"/([.+-]\\d{0,3})?([.0-9+-]{6,12})/\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-tie\"></md-icon><label>תפקיד\n</label><md-select ng-model=\"coordinate.Role\" placeholder=\"תפקיד\"><md-option ng-repeat=\"role in roles\" \nng-value=\"role.Name\">{{role.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<label>סטטוס</label><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><md-select ng-model=\"coordinate.Status\" \nplaceholder=\"סטטוס\"><md-option ng-selected=\"coordinate.Status==1 || coordinate.Status==\'1\'\" ng-value=\"1\">פעיל\n</md-option><md-option ng-selected=\"coordinate.Status==0 || coordinate.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option>\n</md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/admin/coordinators/coordinators-profile/coordinators-profile.html","<div id=\"coordinator-profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" ng-src=\"{{coordinator.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\"><div>\n<div class=\"hsf13 small-name\">רכז</div><div class=\"name\">{{coordinator.FirstName}} {{coordinator.LastName}}</div></div>\n</div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button data-ng-if=\"coordinator.Email!= \'\'\" \nhref=\"mailto: {{coordinator.Email}}\" class=\"md-raised md-primary\">שליחת הודעה</md-button></div></div><div \nclass=\"content\" flex><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>כללי</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/admin/coordinators/coordinators-profile/tabs/about/about.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>הרשאות</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/admin/coordinators/coordinators-profile/tabs/permissions/permissions.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>{{$root.orgTypeBranchName.plural}}</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/admin/coordinators/coordinators-profile/tabs/settlements/settlements.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>קטגוריות</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" \nng-include=\"\'app/main/pages/admin/coordinators/coordinators-profile/tabs/categories/categories.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>מאורעות</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/admin/coordinators/coordinators-profile/tabs/events/events.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/admin/coordinators/new-coordinator/new-coordinator.html","<div id=\"forgot-password\" class=\"sflex aic fdc\" ng-init=\"validRequest()\"><div id=\"forgot-form\" \nng-class=\"{hideme: success}\"><h2 class=\"hfs65 center\">{{appConfig.appName}} - רישום משתמש חדש</h2><form><div><label \nclass=\"formlabel dblock fw-medium\">סיסמא חדשה</label><div class=\"inputform\"><input ng-change=\"matchPass()\" \nng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" type=\"{{ inputType }}\" ng-model=\"form.password\" \nplaceholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" class=\"sflex aic btn\">\n{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\"><span \nng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span ng-class=\"{errors: shortPass}\">\nסיסמא קצרה מדיי</span></h5></div></div><div class=\"mt40\"><label class=\"formlabel dblock fw-medium\">אימות סיסמא</label>\n<div class=\"inputform\"><input ng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" ng-change=\"matchPass()\" \ntype=\"{{ inputType }}\" ng-model=\"passwordVerify\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button \nng-click=\"showHidePassword()\" class=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5\n class=\"hfs13 sflex jcfe\"><span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"center mt40\"><div class=\"loading\" \nng-if=\"loading\" ng-class=\"{active: loading}\"><span></span></div><input type=\"submit\" \nng-disabled=\"!matchPasswords || loading\" ng-click=\"submit()\" value=\"עדכן סיסמא\"></div><div class=\"w100 center mt40\"><h4\n class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></form></div><div id=\"done-reset\" class=\"center\" \nng-class=\"{show: success}\"><img class=\"mb40\" src=\"/assets/icons/Done.svg\" alt=\"\"><h2 class=\"hfs65 mb30\">\nאיפוס סיסמא בוצע בהצלחה!</h2><h5 class=\"hfs27 fw-light\">מתבצע חיבור כעת</h5></div><div id=\"CopyR\" class=\"center hfs15\">\n<span>Crafted By <a href=\"https://www.marvilix.com\" target=\"_blank\">Marvilix </a>© All Rights Reserved</span></div><div\n class=\"errorBox inrowf\" ng-class=\"{show: fail}\"><div class=\"w100 center\"><span class=\"hfs15\">{{ errorInfo }}</span> \n<img src=\"/assets/icons/Close.svg\" alt=\"\" ng-click=\"fail = false\"></div></div></div>");
$templateCache.put("app/main/pages/admin/coordinators/new-coordinators-dialog/new-coordinators-dialog.html","<md-dialog class=\"newCoordinators-dialog\" aria-label=\"New Task\"><form name=\"newCoordinatorsForm\" \ndata-ng-model=\"newCoordinatorsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת {{$root.User.Coordinator}} חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input \nng-model=\"newCoordinator.FirstName\" data-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה\n</label><input ng-model=\"newCoordinator.LastName\" data-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><label>טלפון נייד</label><input \nng-model=\"newCoordinator.PhoneNumber\" data-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><label>דואר אלקטרוני</label><md-icon md-font-icon=\"icon-email\" class=\"email\">\n</md-icon><input ng-required=\"true\" ng-model=\"newCoordinator.Email\" dir=\"ltr\" type=\"email\" ng-disabled=\"isClicked\" \nng-pattern=\"/[0-9a-zA-Z_-]+?(\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|)@[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z]{2,15}(|\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15})/\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newCoordinatorsForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNesCoordinator()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nשמירה ומעבר לפרופיל</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/branches/views/groups/mange-groups.html","<div id=\"groups\" class=\"page-layout simple tabbed\" ng-init=\"getBranches();getSettlements();\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">ניהול {{$root.User.Groups}}</span></div></div><div class=\"content\"><div \nclass=\"action-buttons\"><md-button ng-show=\"$root.AdminLevel>1\" ng-disabled=\"isClicked\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newGroup-button\" ng-click=\"addNewGroupDialog()\" \naria-label=\"add new Group\" title=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"33\" ng-show=\"$root.AdminLevel>1\" title=\"התחל לרשום שם ה{{$root.orgTypeBranchName.single}}\"><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><label></label><md-contact-chips \nng-disabled=\"search.freeSearchFromDB || !settlements || isClicked\" ng-model=\"search.settlements\" \nng-change=\"getGroups()\" md-contacts=\"settlementsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.orgTypeBranchName.single}}\"></md-contact-chips>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"33\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"search.status\" \nplaceholder=\"סינון לפי סטטוס {{$root.User.Group}}\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\" selected=\"selected\">\nפעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><label>חיפוש חופשי</label><input id=\"free-search\" ng-model=\"search.freeSearchFromDB\" ng-disabled=\"isClicked\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getGroups()\">סינון</md-button><md-button\n ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getGroups(true)\">בטל סינון</md-button>\n</div></form></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"isClicked\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"!isClicked\" \nclass=\"branches-table-c\"><table id=\"groups-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם {{$root.User.Group}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.single}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"group in groups\"><td>{{group.Name}}</td><td><span ng-repeat=\"grade in group.GradesString\">\n{{grade}} <span ng-if=\"!$last\">,</span></span></td><td>{{group.City}}</td><td>\n{{group.Status==1 || group.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user md-icon-button\" \nng-click=\"editGroup(group)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button><md-button \nclass=\"preview-user md-icon-button\" href=\"/group-management?ID={{group.ID}}\" title=\"ניהול קבוצה\"><md-icon \nmd-svg-icon=\"settings\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/branches/views/settlements/manage-settlements.html","<div id=\"branches\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול {{$root.orgTypeBranchName.plural}}</span>\n</div></div><div class=\"content\"><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>\nחיפוש חופשי</label><input ng-model=\"search.freeSearch\" type=\"text\" ng-disabled=\"!settlements\"></md-input-container>\n</div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!settlements\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getSettlements()\">סינון</md-button><md-button \nng-disabled=\"!settlements\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getSettlements(true)\">בטל סינון\n</md-button></div></form></div></div><div ng-show=\"!settlements\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"settlements\" class=\"branches-table-c\"><table id=\"branches-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשם {{$root.orgTypeBranchName.single}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סוג {{$root.orgTypeBranchName.single}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"settlement in settlements\"><td>{{settlement.Name}}</td><td>{{settlement.Type}}</td>\n<td><md-button class=\"preview-user md-icon-button\" ng-click=\"editSettlement(settlement)\" title=\"עריכה\"><md-icon \nmd-svg-icon=\"pencil\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/profile-forms/views/cancel-form/cancel-form.html","<div id=\"cancel-forms\" class=\"page-layout simple tabbed\" ng-init=\"vm.getEvents(); vm.loadSearch();\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">טפסי בקשה לביטול {{$root.User.Events}}</span></div></div><div class=\"content\"><div\n layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon \nmd-font-icon=\"icon-brightness-5\"></md-icon><label>{{$root.User.Event}}</label><md-select \nmd-on-close=\"clearSearchTerm()\" ng-model=\"vm.search.EventID\" ng-disabled=\"!vm.events || !vm.cancellation\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Event}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-value=\"event.ID\" \nng-repeat=\"event in vm.events |filter:vm.searchTerm\">{{event.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"40\"><label>סטטוס</label><md-icon md-font-icon=\"icon-power\"></md-icon><md-select \nng-model=\"vm.search.Status\" ng-disabled=\"!vm.cancellation\"><md-option ng-value=\"null\">הכל</md-option><md-option \nng-value=\"\'טופל\'\">טופל</md-option><md-option ng-value=\"\'טרם טופל\'\">טרם טופל</md-option></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.FromDate\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.FromDate\" \nng-disabled=\"!vm.cancellation\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.ToDate\"><label>עד תאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.ToDate\" ng-disabled=\"!vm.cancellation\"></div></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><label>סיבת ביטול</label><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon><md-select ng-model=\"vm.search.Reason\" ng-disabled=\"!vm.cancellation\"><md-option \nng-value=\"null\">הכל</md-option><md-option ng-value=\"\'Illness\'\">מחלה</md-option><md-option ng-value=\"\'Other\'\">אחר\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><label>חיפוש חופשי</label><input ng-model=\"vm.search.FreeSearchFromDB\" type=\"search\" \nng-disabled=\"!vm.cancellation\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button\n type=\"submit\" ng-disabled=\"!vm.cancellation || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getCancelForms()\">סינון</md-button><md-button type=\"submit\" \nng-disabled=\"!vm.cancellation || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getCancelForms(true)\">איפוס סינון</md-button></div></form></div></div><div ng-if=\"!vm.cancellation\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"vm.cancellation\" class=\"forms-table-c\"><table id=\"cancellation-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם חניכ\\ה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.single}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם האירוע</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סיבת ביטול</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס פניה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"cancel in  vm.cancellation | orderBy:ID\"><td>\n{{cancel.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a href=\"/parent-profile?ID={{cancel.ParentID}}\" \ntarget=\"_blank\" style=\"cursor: pointer\">{{cancel.ParentName}}</a></td><td><a href=\"mailto:{{cancel.ParentEmail}}\">\n{{cancel.ParentEmail}}</a></td><td>{{cancel.ParentPhone}}</td><td><a href=\"/student-profile?ID={{cancel.StudentID}}\" \ntarget=\"_blank\" style=\"cursor: pointer\">{{cancel.StudentName}}</a></td><td>{{cancel.SettlementName}}</td><td>\n{{cancel.EventName}}</td><td>{{cancel.Reason==\'Other\' ? \'אחר\' : \'מחלה\'}}</td><td>{{cancel.Status}}</td><td><md-button \nclass=\"preview-user\" ng-click=\"vm.openCancellationDialog(cancel)\" title=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/profile-forms/views/contact-form/contact-form.html","<div id=\"contact-forms\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">טפסי צור קשר</span></div></div><div \nclass=\"content\"><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"40\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.FromDate\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.FromDate\" \nng-disabled=\"!vm.contact\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.ToDate\"><label>עד תאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.ToDate\" ng-disabled=\"!vm.contact\"></div></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><label>סטטוס</label><md-icon md-font-icon=\"icon-power\">\n</md-icon><md-select ng-model=\"vm.search.Status\" ng-disabled=\"!vm.contact\"><md-option ng-value=\"null\">הכל</md-option>\n<md-option ng-value=\"\'טופל\'\">טופל</md-option><md-option ng-value=\"\'טרם טופל\'\">טרם טופל</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"40\"><label>סוג פנייה</label><md-icon md-font-icon=\"icon-power\"></md-icon><md-select \nng-model=\"vm.search.Type\" ng-disabled=\"!vm.contact\"><md-option ng-value=\"null\">הכל</md-option><md-option \nng-repeat=\"type in vm.types\" ng-value=\"type\">{{type}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"vm.search.FreeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.contact\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!vm.contact || UserForm.$invalid \" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getContactForms()\">סינון</md-button><md-button type=\"submit\" \nng-disabled=\"!vm.contact || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getContactForms(true)\">איפוס סינון</md-button></div></form></div></div><div ng-if=\"!vm.contact\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"vm.contact\" class=\"forms-table-c\"><table id=\"contact-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם הנרשמ/ת</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.plural}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס פניה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג פנייה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"contactForm in  vm.contact | orderBy:ID\"><td>\n{{contactForm.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a \nhref=\"/parent-profile?ID={{contactForm.ParentID}}\" target=\"_blank\" style=\"cursor: pointer\">{{contactForm.ParentName}}\n</a></td><td><a href=\"mailto:{{contactForm.ParentEmail}}\">{{contactForm.ParentEmail}}</a></td><td>\n{{contactForm.ParentPhone}}</td><td><a ng-if=\"contactForm.StudentID\" \nhref=\"/student-profile?ID={{contactForm.StudentID}}\" target=\"_blank\" style=\"cursor: pointer\">\n{{contactForm.StudentName}}</a> <a ng-if=\"!contactForm.StudentID\" href=\"/parent-profile?ID={{contactForm.ParentID}}\" \ntarget=\"_blank\" style=\"cursor: pointer\">{{contactForm.ParentName}}</a></td><td>{{contactForm.SettlementName}}</td><td>\n{{contactForm.Status}}</td><td>{{contactForm.Type}}</td><td><md-button class=\"preview-user\" \nng-click=\"vm.openContactDialog(contactForm)\" title=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/profile-forms/views/subsidy-form/subsidy-form.html","<div id=\"subsidy-forms\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">בקשות סבסוד</span></div></div><div \nclass=\"content\"><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"></div><br><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.FromDate\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.FromDate\" \nng-disabled=\"!vm.subsidyes\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.ToDate\"><label>עד תאריך</label><input autocomplete=\"off\" \nng-model=\"vm.search.ToDate\" ng-disabled=\"!vm.subsidyes\"></div></md-input-container></div></div><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><label>סטטוס</label><md-icon md-font-icon=\"icon-power\">\n</md-icon><md-select ng-model=\"vm.search.Status\" ng-disabled=\"!vm.subsidyes\"><md-option ng-value=\"null\">הכל</md-option>\n<md-option ng-value=\"1\">טופל</md-option><md-option ng-value=\"-1\">טרם טופל</md-option></md-select></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"vm.search.FreeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.subsidyes\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!vm.subsidyes || UserForm.$invalid \" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getSubsidyForms()\">סינון</md-button><md-button type=\"submit\" \nng-disabled=\"!vm.subsidyes || UserForm.$invalid \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getSubsidyForms(true)\">איפוס סינון</md-button></div></form></div></div><div ng-if=\"!vm.subsidyes\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"vm.subsidyes\" class=\"forms-table-c\"><table id=\"contact-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"subsidyForm in  vm.subsidyes\"><td><span class=\"dpn\">{{subsidyForm.CreateTime}}\n</span>{{subsidyForm.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a \nhref=\"/parent-profile?ID={{subsidyForm.ParentID}}\" target=\"_blank\" style=\"cursor: pointer\">{{subsidyForm.ParentName}}\n</a></td><td><a href=\"mailto:{{subsidyForm.ParentEmail}}\">{{subsidyForm.ParentEmail}}</a></td><td>\n{{subsidyForm.ParentPhone}}</td><td ng-if=\"subsidyForm.ApprovedTime > 0\">טופל</td><td \nng-if=\"subsidyForm.ApprovedTime == 0 || subsidyForm.ApprovedTime == null\">טרם טופל</td><td><md-button \nclass=\"preview-user\" ng-click=\"vm.openSubsidyDialog(subsidyForm)\" title=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/accountancy-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\" \nng-init=\"vm.getAccountancySettings();vm.getAccountancyTerminals();\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הנהלת חשבונות</span></div></div><div \nclass=\"content\"><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>\nכללי</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/accountancy-settings/tabs/general.html\'\"></div></md-tab-body></md-tab>\n<md-tab ng-if=\"!vm.accountancy.TerminalManagment\"><md-tab-label><span>תיקי הכנסות</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/accountancy-settings/tabs/accounts.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"!vm.accountancy.TerminalManagment\"><md-tab-label><span>חשבונות בנק</span></md-tab-label>\n<md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/accountancy-settings/tabs/banks.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>חשבונות ומסופי אשראי</span></md-tab-label><md-tab-body style=\"background-color: #000000\">\n<div class=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/accountancy-settings/tabs/terminals.html\'\">\n</div></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/admin-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">מערכת ניהול</span></div></div><div \nclass=\"content\"><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>\nתגיות וסטטוסים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/admin-settings/tabs/tags.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>רכזים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/admin-settings/tabs/coordinators.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>העלאת שכבה</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div \nclass=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/admin-settings/tabs/upgrade-grade.html\'\"></div>\n</md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/general-settings/general-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\" \nng-init=\"vm.getSystemSettings();vm.getAdminImages();vm.getAccountancySettings();\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הגדרות כלליות</span>\n</div></div><div class=\"content\"><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab \nng-if=\"!vm.managedTerminals\"><md-tab-label><span>פרטי הארגון</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/general-settings/tabs/organization-details.html\'\"></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>התאמה אישית</span></md-tab-label><md-tab-body style=\"background-color: #000000\">\n<div class=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/general-settings/tabs/personalized.html\'\">\n</div></md-tab-body></md-tab><md-tab><md-tab-label><span>מילון מונחים</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/general-settings/tabs/entities.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/external-registrations-settings/external-registrations-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הרשמות חיצוניות</span></div></div><div \nclass=\"content\"><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>\nתנאי שימוש</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/external-registrations-settings/tabs/terms.html\'\"></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>לינקים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div \nclass=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/external-registrations-settings/tabs/links.html\'\">\n</div></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/profile-settings.html","<div id=\"general-settings\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">הגדרות פרופיל</span></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>תנאי שימוש</span>\n</md-tab-label><md-tab-body style=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/terms.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>טפסים ומיילים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div \nclass=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/forms.html\'\"></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>שדות חובה</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/fields.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>שדות דינמים</span></md-tab-label><md-tab-body style=\"background-color: #000000\"><div \nclass=\"about-tab\" ng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/fields-dy.html\'\"></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>מייל יום הולדת</span></md-tab-label><md-tab-body \nstyle=\"background-color: #000000\"><div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/birthday.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>הודעה קופצת בפרופיל</span></md-tab-label><md-tab-body style=\"background-color: #000000\">\n<div class=\"about-tab\" \nng-include=\"\'app/main/pages/settings-menue/views/profile-settings/tabs/profile-popup-alert.html\'\"></div></md-tab-body>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/events/views/events/events.html","<div id=\"events\" class=\"page-layout simple tabbed\" ng-init=\"init()\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול {{title}}</span></div></div><div \nclass=\"content\"><div class=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel>2 || $root.User.EventsPer==1\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newEvent-button\" ng-click=\"openNewEventDialog(title2)\" \naria-label=\"add systemUser\" title=\"יצירת {{activeModule.singleTitle}}\" ng-disabled=\"isClicked\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-if=\"($root.AdminLevel>2 || $root.User.EventsPay) && activeModule.fastRegistrationEnables\" \nclass=\"md-fab md-accent md-icon-button badge\" id=\"add-registrations-button\" \nng-click=\"openNewMultipleRegistrationsDialog()\" aria-label=\"add systemUser\" title=\"מעבר לעגלת קניות\" \nng-disabled=\"isClicked || getCartTotalQuantity() == 0\"><md-icon md-font-icon=\"icon-cart\"></md-icon><span class=\"badge\" \nng-class=\"{\'red\':getCartTotalQuantity() == 0,\'green\': getCartTotalQuantity() > 0}\">{{getCartTotalQuantity()}}</span>\n</md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" \nflex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div ng-if=\"activeModule.external\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><label>סוג {{title}}</label><md-select ng-model=\"search.EventType\" \nplaceholder=\"סוג {{title}}\" ng-disabled=\"isClicked\"><md-option ng-value=\"0\" ng-if=\"!externalOnly\">פורטל הורים\n</md-option><md-option ng-value=\"1\">אתר הרשמה ציבורי</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><label>סטטוס {{title2}}</label><md-select \nng-model=\"search.status\" ng-init=\"search.status=1\" placeholder=\"סינון לפי סטטוס {{title2}}\" ng-disabled=\"isClicked\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option \nng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\" ng-if=\"activeModule.registrationDates\"><md-input-container class=\"md-icon-float md-block\">\n<md-icon md-font-icon=\"icon-filter\"></md-icon><label ng-if=\"title.slice(-2) == \'ים\'\">{{title}} זמינים להרשמה בלבד\n</label><label ng-if=\"title.slice(-2) == \'ות\'\">{{title}} זמינות להרשמה בלבד</label><label \nng-if=\"title.slice(-2) != \'ות\' && title.slice(-2) != \'ים\'\">זמינים להרשמה</label><md-select \nng-model=\"search.dateStatus\" ng-init=\"search.dateStatus=1\" placeholder=\"{{title}} זמינים להרשמה בלבד\" \nng-disabled=\"isClicked\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">כן</md-option><md-option \nng-value=\"0\">לא</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><label>שיוך לקטגוריה</label><md-icon \nmd-svg-icon=\"apps\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.CategoryID\" \nng-disabled=\"isClicked\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-disabled=\"isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר קטגוריה\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\">\n<md-option ng-repeat=\"category in categories |filter:searchTerm\" ng-value=\"category.ID\">{{category.Path.join(\' › \')}}\n</md-option></md-optgroup></md-select></md-input-container></div></div><div ng-if=\"search.EventType == 0\" \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \ntitle=\"התחל לרשום שם ה{{$root.orgTypeBranchName.single}}\"><label></label><md-icon md-font-icon=\"icon-domain\"></md-icon>\n<md-contact-chips ng-disabled=\"search.freeSearchFromDB\" ng-model=\"search.settlements\" \nmd-contacts=\"settlementsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר {{$root.orgTypeBranchName.single}}\"></md-contact-chips></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" title=\"התחל לרשום שם {{$root.User.Grade}}\"><label></label><md-icon \nmd-font-icon=\"icon-chair-school\"></md-icon><md-contact-chips ng-disabled=\"search.freeSearchFromDB\" \nng-model=\"search.grades\" md-contacts=\"gradesQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר {{$root.User.Grades}}\"></md-contact-chips>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><label>סעיף תקציבי</label>\n<md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.CostingCode\" ng-disabled=\"isClicked\" multiple=\"multiple\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm1\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר סעיף תקציבי\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\"><md-option \nng-repeat=\"code in costingCodes |filter:searchTerm1\" ng-value=\"code\">{{code}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"isClicked\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"isClicked \" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getEvents()\">סינון</md-button>\n<md-button ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getEvents(true)\">בטל סינון\n</md-button></div></form></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"isClicked\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"!isClicked && searchFirstTime\" class=\"events-table-c\"><table id=\"events-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" \ndt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">קטגוריה</span></div></th><th class=\"secondary-text\" ng-if=\"activeModule.eventDates\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך התחלה</span></div></th><th class=\"secondary-text\" \nng-if=\"activeModule.eventDates\"><div class=\"table-header\"><span class=\"column-title\">תאריך סיום</span></div></th><th \nclass=\"secondary-text\" ng-if=\"activeModule.registrationDates\"><div class=\"table-header\"><span class=\"column-title\">\nתאריך סיום הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מחיר\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר נרשמים</span>\n</div></th><th class=\"secondary-text\" ng-if=\"$root.AdminLevel>2\"><div class=\"table-header\"><span class=\"column-title\">\nהכנסות</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th>\n</tr></thead><tbody><tr class=\"md-ink-ripple\" ng-repeat=\"event in events\"><td>{{event.Name}}</td><td>\n{{event.CategoryName}}</td><td ng-if=\"activeModule.eventDates\">{{event.StartDate}}</td><td \nng-if=\"activeModule.eventDates\">{{event.EndDate}}</td><td ng-if=\"activeModule.registrationDates\">\n{{event.RegistrationEndDate}}</td><td>{{event.Price}}</td><td>{{event.RegistrationCount}}</td><td \nng-if=\"$root.AdminLevel>2\">{{event.Total}}</td><td>{{event.Status==1 || event.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td>\n<td><md-button class=\"preview-user\" href=\"/event-management?ID={{event.ID}}\" title=\"ניהול {{title2}}\"><md-icon \nmd-svg-icon=\"settings\"></md-icon></md-button><md-button class=\"preview-user\" \nng-if=\"($root.AdminLevel>2 || $root.User.EventsPay) && activeModule.fastRegistrationEnables && !isInCart(event) && event.EventType == 1\" \nng-click=\"openNewSingleRegistrationDialog(event)\" title=\"הוסף לעגלה\"><md-icon class=\"green600\" \nmd-font-icon=\"icon-plus-circle\"></md-icon></md-button><md-button class=\"preview-user\" \nng-if=\"($root.AdminLevel>2 || $root.User.EventsPay) && activeModule.fastRegistrationEnables && isInCart(event) && event.EventType == 1\" \nng-click=\"removeFromCart(event)\" title=\"הורד מהעגלה\"><md-icon class=\"red600\" md-font-icon=\"icon-minus-circle\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/users/views/new-user-tag-dialog/new-user-tag-dialog.html","<md-dialog class=\"newUserTag-dialog\" aria-label=\"New Task\" ng-init=\"getTags()\"><form name=\"newUserTagForm\" \ndata-ng-model=\"newUserTagForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת תגיות לתושב</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת תגיות תושב\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content\n ms-scroll><div><md-input-container class=\"md-block\"><label>בחר תגיות להוספה</label><md-select \nmd-on-close=\"clearSearchTerm()\" ng-model=\"newUserTag.Tags\" ng-disabled=\"isClicked\" multiple=\"multiple\" required>\n<md-select-header class=\"demo-select-header\" placeholder=\"בחר תגיות\"><input ng-model=\"searchTerm\" type=\"text\" \nng-disabled=\"isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש תגיות\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\">\n<md-option ng-repeat=\"tag in tags |filter:searchTerm\" ng-value=\"tag.ID\">{{tag.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newUserTagForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewUserTag()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/settings-menue/views/categories/categories.html","<div id=\"categories\" class=\"page-layout simple tabbed\" ng-init=\"init()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול קטגוריות <span \nng-if=\"previousCategories.length\"><span ng-repeat=\"cat in previousCategories\"><i class=\"icon-chevron-right s18 arrow\">\n</i>{{cat.Name}}</span></span></span></div></div><div class=\"content\"><div class=\"action-buttons\"><md-button \nng-if=\"($root.AdminLevel>2 || $root.User.EventsPer==1) && previousCategoriesState.length > 0\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-new-category-button\" ng-click=\"openNewCategoryDialog()\" \naria-label=\"add systemUser\" title=\"יצירת קטגוריה\" ng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button><md-button ng-if=\"previousCategoriesState.length > 0\" class=\"md-fab md-accent md-icon-button\" \nid=\"back-to-prev-state\" ng-click=\"goToPreviousState()\" aria-label=\"add systemUser\" title=\"חזרה בעץ\" \nng-disabled=\"isClicked\"><md-icon md-svg-icon=\"replay\"></md-icon></md-button></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-if=\"!loading\"><ms-widget class=\"category-box\" \nflex=\"100\" flex-gt-xs=\"40\" flex-gt-md=\"40\" ng-repeat=\"category in currentCategories\"><ms-widget-front class=\"white-bg\">\n<div class=\"sflex h100\"><div class=\"media cp category-image fcc\" ng-click=\"updateImage(category)\"><img class=\"image\" \nsrc=\"{{category.Image}}\" ng-if=\"category.Image.length\"> <img class=\"image default-image\" src=\"{{defaultLogo}}\" \nng-if=\"! category.Image || category.Image.length == 0\"></div><div class=\"category-details\"><div \nclass=\"light-blue-fg hfs35 line-height-72 center\">{{category.Name}}</div><div \nclass=\"h3 secondary-text font-weight-500 center\">{{category.Description}}</div><div \nclass=\"h4 secondary-text font-weight-500 center\" ng-if=\"category.ChildrenCategories.length > 0\">\n({{category.ChildrenCategories.length}} תתי קטגוריות)</div></div><div class=\"sflex sflec fdc aic jcsa buttons\"><md-icon\n ng-click=\"enterCategory(category)\" class=\"preview-user cp\" title=\"בחר קטגוריה\" md-font-icon=\"icon-format-align-right\">\n</md-icon><md-icon ng-click=\"editCategory(category)\" class=\"preview-user cp\" title=\"עריכת קטגוריה\" \nmd-svg-icon=\"pencil\"></md-icon><md-icon \nng-if=\"! isMasterCategory(category.ID) && (!category.ChildrenCategories || category.ChildrenCategories.length == 0)\" \nclass=\"preview-user cp\" title=\"מחיקת קטגוריה\" ng-click=\"deleteCategory(category)\" md-svg-icon=\"delete\"></md-icon></div>\n</div></ms-widget-front></ms-widget><h2 ng-if=\"!loading && (!currentCategories || currentCategories.length == 0)\">\nל{{currentCategory.Name}} אין תת קטגוריות. לחץ על הפלוס על מנת ליצור תת קטגוריה חדשה</h2></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/locations/locations.html","<div id=\"locations\" class=\"page-layout simple tabbed\" ng-init=\"getSettlements()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול אולמות</span>\n</div></div><div class=\"content\"><div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-newSLocation-button\" ng-click=\"openNewLocationDialog()\" aria-label=\"add systemUser\" title=\"יצירת אולם\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><form class=\"md-inline-form\" \nvalidate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><label>{{$root.orgTypeBranchName.single}}</label><md-icon md-font-icon=\"icon-domain\">\n</md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.settlements\" ng-disabled=\"!locations\" \nmultiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-disabled=\"!locations\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.orgTypeBranchName.single}}..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"settlements\">\n<md-option ng-value=\"settlement.ID\" ng-repeat=\"settlement in settlements |filter:searchTerm\">{{settlement.Name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\">\n</md-icon><label>סטטוס</label><md-select ng-model=\"search.Status\" placeholder=\"סינון לפי סטטוס\" \nng-disabled=\"!locations\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\" \nselected=\"selected\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container>\n</div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-border-all\"></md-icon><label>אולם/ חדר ללא הושבה</label>\n<md-select ng-model=\"search.IsRoom\" placeholder=\"אולם/ חדר ללא הושבה\" ng-disabled=\"!locations\"><md-option \nng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">חדר הושבה</md-option><md-option ng-value=\"0\">אולם\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><label>חיפוש חופשי</label><input ng-model=\"search.FreeSearchFromDB\" type=\"search\" ng-disabled=\"!locations\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!locations \" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getLocations()\">סינון</md-button>\n<md-button ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getLocations(true)\">בטל סינון\n</md-button></div></form><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!locations\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"locations\" \nclass=\"locations-table-c\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nלא יתאפשר שיוך אולם אשר הוגדר כאולם הושבה ולא הוגדרו לו מושבים</span></div><table id=\"locations-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.single}}</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר איזורים</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">אולם / חדר ללא הושבה</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" ng-repeat=\"location in locations  \"><td>{{location.Name}}</td><td>\n{{location.SettlementName}}</td><td>{{location.Layout.length}}</td><td>\n{{location.IsRoom == 1? \'חדר ללא הושבה\' : \'אולם\'}}</td><td>\n{{location.Status==1 || location.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user\" \nhref=\"/location-management?ID={{location.ID}}\" title=\"ניהול אולם\"><md-icon md-svg-icon=\"settings\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents.html","<div id=\"parents\" class=\"page-layout simple tabbed\" ng-init=\"vm.init()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">ניהול הורים</span></div>\n</div><div class=\"content\"><div class=\"action-buttons\"><md-button ng-disabled=\"!vm.parents\" \nng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" class=\"md-fab md-accent md-icon-button\" id=\"send-emailes-button\" \nng-click=\"vm.openSendEmail()\" aria-label=\"add systemUser\" title=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\">\n</md-icon></md-button><md-button ng-disabled=\"!vm.parents\" \nng-if=\"$root.smsEnabled && ($root.AdminLevel>2 || $root.User.SmsPer)\" class=\"md-fab md-accent md-icon-button\" \nid=\"send-SMS-button\" ng-click=\"vm.openSendSMS()\" title=\"שליחת הודעה\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button><md-button \nng-disabled=\"!vm.parents || !vm.testForSelected()\" class=\"md-fab md-accent md-icon-button\" id=\"excel-export\" \nng-click=\"vm.excelExport()\" title=\"ייצוא לאקסל\" aria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-file-excel\">\n</md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\"><md-input-container class=\"md-icon-float md-block\" ng-if=\"$root.AdminLevel>1\" \ntitle=\"התחל לרשום שם {{$root.orgTypeBranchName.single}}\"><label>{{$root.orgTypeBranchName.plural}}</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" \nng-model=\"vm.search.SettlementsIdes\" multiple=\"multiple\" ng-disabled=\"!vm.settlements\" ng-change=\"vm.getGroups()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm1\" type=\"text\" \nng-disabled=\"!vm.settlements\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חפש {{$root.orgTypeBranchName.single}}..\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup ng-disabled=\"!vm.settlements\"><md-option ng-value=\"settlement.ID\" \nng-repeat=\"settlement in vm.settlements |filter:vm.searchTerm1\">{{settlement.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div ng-show=\"vm.groups && vm.groups.length > 0\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\"><md-input-container class=\"md-icon-float md-block\" ng-if=\"$root.AdminLevel>1\" \ntitle=\"התחל לרשום שם {{$root.User.Group}}\"><label>{{$root.User.Groups}}</label><md-icon \nmd-font-icon=\"icon-chair-school\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" \nng-model=\"vm.search.GroupsIdes\" multiple=\"multiple\" ng-disabled=\"!vm.groups\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm2\" type=\"text\" ng-disabled=\"!vm.groups\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Group}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"!vm.groups\"><md-option ng-value=\"group.ID\" \nng-repeat=\"group in vm.groups |filter:vm.searchTerm2\">{{group.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" ng-if=\"$root.AdminLevel>1\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"33\" title=\"התחל לרשום שם {{$root.User.Grades}}\"><label>{{$root.User.Grades}}</label><md-icon \nmd-font-icon=\"icon-chair-school\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" \nng-model=\"vm.search.GradesIdes\" multiple=\"multiple\" ng-disabled=\"!vm.grades\" ng-change=\"vm.getGroups()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm3\" type=\"text\" ng-disabled=\"!vm.grades\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Grades}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"!vm.grades\"><md-option ng-value=\"grade.ID\" \nng-repeat=\"grade in vm.grades |filter:vm.searchTerm3\">{{grade.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cash\" class=\"name\"></md-icon><label>דרגת הנחה</label>\n<md-select ng-model=\"vm.search.DiscountLevel\" placeholder=\"דרגת הנחה\" ng-disabled=\"!vm.parents\"><md-option ng-value=\"\">\nבחר רמה</md-option><md-option ng-value=\"1\">1</md-option><md-option ng-value=\"2\">2</md-option><md-option ng-value=\"3\">3\n</md-option><md-option ng-value=\"4\">4</md-option><md-option ng-value=\"5\">5</md-option><md-option ng-value=\"6\">6\n</md-option></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.DiscountLevelStartDate\"><label>תאריך התחלה של מתן הדרגה\n</label><input autocomplete=\"off\" ng-model=\"vm.search.DiscountLevelStartDate\" ng-disabled=\"!vm.parents\"></div>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"vm.search.DiscountLevelEndDate\"><label>תאריך סיום של מתן הדרגה</label>\n<input autocomplete=\"off\" ng-model=\"vm.search.DiscountLevelEndDate\" ng-disabled=\"!vm.parents\"></div>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><md-icon \nmd-svg-icon=\"pound-box\"></md-icon><md-select ng-model=\"vm.search.Tags\" placeholder=\"תגיות\" multiple=\"multiple\" \nng-disabled=\"isClicked\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm2\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש תגיות\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-repeat=\"tag in vm.tags | filter: searchTerm2\" \nng-value=\"tag.ID\">{{tag.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"vm.search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.parents\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"!vm.parents\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"vm.getParents()\">סינון</md-button></div></form></div></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.parents\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"vm.parents\" class=\"parents-table-c\"><table id=\"parents-Table\" \nclass=\"dataTable dt-responsive row-border hover\" datatable=\"\" dt-instance=\"dtInstance\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<input ng-model=\"vm.selectAll\" type=\"checkbox\" ng-change=\"vm.setAll(vm.selectAll)\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תעודה מזהה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">דואר אלקטרוני</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">טלפון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.single}}</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th>\n<div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"main-table-new\" ng-repeat=\"parent in vm.parents\"><td><input type=\"checkbox\" ng-model=\"parent.Selected\" \nng-click=\"$event.stopPropagation()\"></td><td>{{parent.PrivateID}}</td><td>{{parent.FirstName}} {{parent.LastName}}</td>\n<td><a href=\"mailto: {{parent.Email}}\">{{parent.Email}}</a></td><td>{{parent.MobileNumber}}</td><td>\n{{parent.SettlementName}}</td><td>{{parent.Status==1 || parent.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><div \nclass=\"fcc\"><md-button class=\"preview-user edit\" ng-click=\"vm.goToParentsPanel(parent)\" title=\"עריכה מהירה\"><md-icon \nmd-svg-icon=\"pencil\"></md-icon></md-button><md-button class=\"preview-user preview\" \nhref=\"/parent-profile?ID={{parent.ID}}\" title=\"צפיה בפרופיל\"><md-icon md-svg-icon=\"settings\"></md-icon></md-button>\n<md-button class=\"preview-user login\" ng-click=\"vm.loginToProfile(parent)\" title=\"מעבר לפרופיל הורה\"><md-icon \nmd-svg-icon=\"login\"></md-icon></md-button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/users/views/students/students.html","<div id=\"students\" class=\"page-layout simple tabbed\" \nng-init=\"vm.getSettlements();vm.getGrades();vm.getTags();vm.getRoles(); vm.loadSearch();\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-display-1 font-weight-300\">ניהול חניכים ומדריכים</span></div></div><div class=\"content\"><div \nclass=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel>=2\" class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.openNewStudentDialog()\" aria-label=\"add systemUser\" title=\"הוספת חניך חדש\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button ng-disabled=\"!vm.students || !vm.selectedStudentsCount\" \nng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.openSendEmail()\" aria-label=\"add systemUser\" title=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\">\n</md-icon></md-button><md-button ng-disabled=\"!vm.students || !vm.selectedStudentsCount\" \nng-if=\"$root.smsEnabled && ($root.AdminLevel>2 || $root.User.SmsPer)\" class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.openSendSMS()\" title=\"שליחת הודעה\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button><md-button \nng-disabled=\"!vm.students || !vm.selectedStudentsCount\" ng-if=\"false && $root.AdminLevel>2\" \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.openChangeGroupGrades()\" title=\"שינוי  {{$root.User.Group}}\\שכבה\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-chair-school\"></md-icon></md-button><md-button \nng-disabled=\"!vm.students || !vm.selectedStudentsCount\" class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.excelExport()\" title=\"ייצוא לאקסל\" aria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-file-excel\">\n</md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"studentsForm\" class=\"md-inline-form\" validate><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\" ng-if=\"$root.AdminLevel>1\"><md-icon md-font-icon=\"icon-domain\"></md-icon>\n<md-select ng-model=\"vm.search.settlements\" placeholder=\"{{$root.orgTypeBranchName.single}}\" multiple=\"multiple\" \nng-disabled=\"isClicked\" ng-blur=\"vm.getGroups()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTermSettlement\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.orgTypeBranchName.single}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup><md-option ng-repeat=\"settlement in  vm.settlements | filter: searchTermSettlement\" \nng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"$root.AdminLevel>1\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><md-icon \nmd-font-icon=\"icon-chair-school\"></md-icon><md-select ng-model=\"vm.search.groups\" placeholder=\"{{$root.User.Groups}}\" \nmultiple=\"multiple\" ng-disabled=\"isClicked || ! vm.groups\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTermGroup\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר {{$root.User.Groups}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"group in  vm.groups | filter: searchTermGroup\" ng-value=\"group.ID\">{{group.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"$root.AdminLevel>1\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><md-icon md-font-icon=\"icon-chair-school\"></md-icon><md-select \nng-model=\"vm.search.grades\" placeholder=\"{{$root.User.Grades}}\" multiple=\"multiple\" \nng-disabled=\"isClicked || ! vm.grades\" ng-blur=\"vm.getGroups()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTermGrade\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר {{$root.User.Grades}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"grade in  vm.grades | filter: searchTermGrade\" ng-value=\"grade.ID\">{{grade.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"$root.AdminLevel>1\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\">\n</md-icon><md-select ng-model=\"vm.search.educator\" placeholder=\"סינון מדריכים\\חניכים\" ng-disabled=\"!vm.students\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"0\">חניכים</md-option><md-option ng-value=\"1\">מדריכים\n</md-option></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select \nng-model=\"vm.search.status\" ng-init=\"vm.search.status=1\" placeholder=\"סינון לפי סטטוס חניך\" ng-disabled=\"!vm.students\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option \nng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" ng-show=\"$root.AdminLevel>1\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><md-icon \nmd-svg-icon=\"pound-box\"></md-icon><md-select ng-model=\"vm.search.tags\" placeholder=\"תגיות\" multiple=\"multiple\" \nng-disabled=\"isClicked\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTermTags\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש תגיות\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-repeat=\"tag in vm.tags | filter: searchTermTags\" \nng-value=\"tag.ID\">{{tag.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><md-icon md-svg-icon=\"tie\"></md-icon>\n<md-select ng-model=\"vm.search.roles\" placeholder=\"תפקיד מדריך\" multiple=\"multiple\" ng-disabled=\"isClicked\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTermRoles\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש תפקיד מדריך\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-repeat=\"role in vm.roles | filter: searchTermRoles\" \nng-value=\"role.Name\">{{role.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" ng-if=\"vm.search.educator!==0\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><md-select \nng-model=\"vm.search.educatorStatus\" placeholder=\"סטטוס מדריך\" ng-disabled=\"!vm.students\"><md-option ng-value=\"null\">\nהצג הכל</md-option><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><md-select ng-model=\"vm.search.type\" \nplaceholder=\"סינון לפי סוג חניך\" ng-disabled=\"!vm.students\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option \nng-value=\"1\">רגיל</md-option><md-option ng-value=\"2\">בוגר</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input \nng-model=\"vm.search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!vm.students\"></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" ng-disabled=\"isClicked\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"vm.getStudents()\">סינון</md-button><md-button ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getStudents(true)\">בטל סינון</md-button></div></form></div>\n</div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.isClicked\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"students-table-c\" ng-if=\"vm.students\"><table \nid=\"students-Table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><input ng-model=\"vm.selectAll\" type=\"checkbox\" \nng-change=\"vm.setAll(vm.selectAll)\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תעודות זהות</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מין</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">דואר אלקטרוני</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Grade}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.orgTypeBranchName.single}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מדריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג חניך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"student in vm.students\"><td><input type=\"checkbox\" ng-model=\"student.Selected\" \nng-click=\"$event.stopPropagation();vm.studentToggled(student)\"></td><td>{{student.PrivateID}}</td><td>\n{{student.FirstName}} {{student.LastName}}</td><td><span ng-if=\"student.Gender==\'Male\'\">בן</span> <span \nng-if=\"student.Gender==\'Female\'\">בת</span> <span ng-if=\"student.Gender==\'Other\'\">אחר</span> <span \nng-if=\"student.Gender==null || student.Gender.length == 0\"></span></td><td><a href=\"mailto: {{student.Email}}\">\n{{student.Email}}</a></td><td>{{student.GroupName}}</td><td>{{student.GradeName}}</td><td>{{student.SettlementName}}\n</td><td>{{student.EducatorID ? \'כן\' : \'לא\'}}</td><td>{{student.Type == 2 ? \'בוגר\' : \'רגיל\'}}</td><td>\n{{student.Status == 1 || student.Status == \'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button \nclass=\"preview-user md-icon-button\" ng-click=\"vm.openStudentPanel(student)\" title=\"עריכה\"><md-icon \nmd-svg-icon=\"pencil\"></md-icon></md-button><md-button class=\"edit-user md-icon-button\" \nhref=\"/student-profile?ID={{student.ID}}\" title=\"צפייה בפרופיל\"><md-icon md-svg-icon=\"settings\"></md-icon></md-button>\n</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/utils/views/activities/activities.html","<div id=\"activities\" class=\"page-layout simple tabbed\" ng-init=\"getSettlements();\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">\nניהול {{$root.User.Activities}}</span></div></div><div class=\"content\"><div class=\"action-buttons\"><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newStudent-button\" ng-click=\"openNewStudentDialog()\" \nng-disabled=\"!activities\" aria-label=\"add systemUser\" title=\"יצירת {{$root.User.Activity}}\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\" ng-show=\"$root.AdminLevel>1\" \ntitle=\"התחל לרשום שם {{$root.orgTypeBranchName.single}}\"><label>בחר {{$root.orgTypeBranchName.plural}}</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.Settlements\" \nmultiple=\"multiple\" ng-disabled=\"search.freeSearchFromDB\" ng-change=\"getGroups()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר {{$root.orgTypeBranchName.plural}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\">\n<md-option ng-value=\"settlement.ID\" ng-repeat=\"settlement in settlements |filter:searchTerm\">{{settlement.Name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\" title=\"התחל לרשום שם {{$root.User.Group}}\"><label>בחר {{$root.User.Groups}}\n</label><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"search.Groups\" multiple=\"multiple\" ng-disabled=\"search.freeSearchFromDB\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר {{$root.User.Groups}}\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\"><md-option ng-value=\"group.ID\" \nng-repeat=\"group in groups |filter:searchTerm\">{{group.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><label>סטטוס {{$root.User.Activity}}</label><md-icon md-font-icon=\"icon-filter\">\n</md-icon><md-select ng-model=\"search.status\" placeholder=\"סטטוס {{$root.User.Activity}}\" ng-disabled=\"!activities\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option \nng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon\n md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input ng-model=\"search.FreeSearchFromDB\" \ntype=\"search\" ng-disabled=\"!activities\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" \nng-disabled=\"isClicked || !activities || (search.branches.length>0 && search.groups.length==0)\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getActivities()\">סינון</md-button><md-button \nng-disabled=\"isClicked || !activities || (search.branches.length>0 && search.groups.length==0)\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getActivities(true)\">בטל סינון</md-button></div></form></div>\n</div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!activities\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"activities\" class=\"activities-table-c\"><table \nid=\"activities-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשם {{$root.User.Activity}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Groups}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">פעולות</span>\n</div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" ng-repeat=\"item in activities\"><td>{{item.Name}}</td><td>\n{{item.GroupName}}</td><td>{{item.Status==1 || item.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button \nclass=\"preview-activity md-icon-button\" ng-click=\"openActivitiesPanel(item)\" title=\"עריכה מהירה\"><md-icon \nmd-svg-icon=\"pencil\"></md-icon></md-button><md-button class=\"edit-activity md-icon-button\" \nhref=\"/activities-profile?ID={{item.ID}}\" title=\"פרופיל {{$root.User.Activity}}\"><md-icon md-svg-icon=\"settings\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/utils/views/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout simple tabbed\" ng-init=\"vm.getGroups()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">אנשי קשר</span></div>\n</div><div class=\"content\"><div class=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel==3\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newContact-button\" ng-click=\"vm.createNewContactDialog()\" \ntitle=\"הוספת איש קשר\" ng-disabled=\"!vm.contacts\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><form \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-select ng-model=\"vm.search.Status\" \nplaceholder=\"סינון לפי סטטוס אנשי קשר\" ng-init=\"vm.search.Status=1\" ng-disabled=\"!vm.contacts\"><md-option \nng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\" selected=\"selected\">פעילים</md-option><md-option \nng-value=\"0\">לא פעילים</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon\n md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input ng-model=\"vm.search.freeSearchFromDB\" \ntype=\"search\" ng-disabled=\"!vm.contacts\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"vm.isClicked || !vm.contacts || !vm.groups\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"vm.getContacts()\">סינון</md-button><md-button \nng-disabled=\"vm.isClicked || !vm.contacts || !vm.groups\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getContacts(true)\">בטל סינון</md-button></div></form><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!vm.contacts\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-if=\"vm.contacts\" class=\"contacts-table-c\"><table id=\"files-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">טלפון</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מייל</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תפקיד</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">קבוצות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תצוגה בפרופיל הורה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"contact in vm.contacts \"><td>{{contact.Name}}</td><td>{{contact.Phone}}</td><td>{{contact.Email}}</td><td>\n{{contact.Role}}</td><td><md-tooltip md-direction=\"right\" ng-if=\"contact.groupsString\">{{contact.groupsString}}\n</md-tooltip>{{contact.groupsString.length > 40? contact.groupsString.substr(0,40)+\'...\' : contact.groupsString}}</td>\n<td>{{contact.ShowInProfile? \'מוצג\' : \'לא מוצג\'}}</td><td>\n{{contact.Status==1 || contact.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button \nclass=\"preview-user md-icon-button\" ng-click=\"vm.editContact(contact)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button><md-button class=\"preview-user\" ng-disabled=\"vm.isClicked || $root.AdminLevel!=3\" \nng-click=\"vm.deleteContactDialog(contact)\" title=\"מחיקת איש קשר\"><md-icon md-svg-icon=\"delete\"></md-icon></md-button>\n</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/utils/views/files/files.html","<div id=\"files\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">קבצים</span></div></div><div class=\"content\">\n<div class=\"action-buttons\"><md-button ng-if=\"$root.AdminLevel==3\" class=\"md-fab md-accent md-icon-button\" \nid=\"add-newFile-button\" ng-click=\"vm.openNewFileDialog()\" title=\"הוספת קובץ\" ng-disabled=\"!vm.files\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><form class=\"md-inline-form\" validate><div class=\"filters\" \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex\\-md=\"33\" flex-xs=\"100\"><md-input-container id=\"free-search\" class=\"md-icon-float md-block\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי</label><input ng-model=\"vm.search.FreeSearch\" \ntype=\"search\" ng-disabled=\"!vm.files\"></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"vm.isClicked || !vm.files \" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"vm.getFiles()\">סינון</md-button></div></form><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!vm.files\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-if=\"vm.files\" class=\"files-table-c\"><table id=\"files-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך העלאה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג קובץ</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם קובץ</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תיאור</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"file in vm.files \"><td>{{file.Date *1000 | date:\'dd/MM/yyyy\'}}</td><td>{{file.Type}}</td><td><a \nhref=\"{{file.Path}}\" target=\"_blank\">{{file.Name}}</a></td><td><md-input-container class=\"md-icon-float md-block\">\n<label>תיאור</label><input ng-model=\"file.Description\" ng-disabled=\"vm.isClicked || $root.AdminLevel!=3\" \nng-blur=\"vm.updateDescription(file)\"></md-input-container></td><td><md-button class=\"preview-user\" \nng-disabled=\"vm.isClicked || $root.AdminLevel!=3\" ng-click=\"vm.deleteFileDialog(file)\" title=\"מחיקת קובץ\"><md-icon \nmd-svg-icon=\"delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/utils/views/reports/reports.html","<div id=\"reports\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-display-1 font-weight-300\">דוחות</span></div></div><div class=\"content\">\n<div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-newReport-button\" \nng-click=\"openNewReportDialog()\" title=\"יצירת דוח\" ng-disabled=\"!reports\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><form class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"search.FreeSearch\" type=\"search\" ng-disabled=\"!reports\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getReports()\">סינון</md-button></div>\n</form><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!reports\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"reports\" class=\"reports-table-c\"><table \nid=\"reports-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג דוח</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.plural}}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Groups}}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grades}}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שדות להצגה</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th>\n</tr></thead><tbody><tr class=\"md-ink-ripple\" ng-repeat=\"report in reports \"><td>{{report.Name}}</td><td>\n{{report.Type}}</td><td><span ng-if=\"!report.Settlements.length\">כולם</span> <span \nng-repeat=\"settlement in report.Settlements\">{{settlement.Name}}<span>{{$last ? \'\' : \', \'}}</span></span></td><td><span\n ng-if=\"!report.Groups\">כולם</span> <span ng-repeat=\"group in report.Groups\">{{group.Name}}<span>{{$last ? \'\' : \', \'}}\n</span></span></td><td><span ng-if=\"!report.Grades.length\">כולם</span> <span ng-repeat=\"grade in report.Grades\">\n{{grade.Name}}<span>{{$last ? \'\' : \', \'}}</span></span></td><td><span ng-if=\"report.Fields.length>0\">לפי בחירה</span> \n<span ng-if=\"!report.Fields\">הכל</span></td><td><md-button class=\"preview-user\" ng-disabled=\"isClicked\" \nng-click=\"exportReport(report)\">ייצא</md-button><md-button class=\"preview-user\" ng-disabled=\"isClicked\" \nng-click=\"deleteReportDialog(report)\">מחק</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/pages/accountancy/views/payments-match/payment-match-dialog/payment-match-dialog.html","<md-dialog class=\"subsidy-dialog\" aria-label=\"New Task\" style=\"min-width: 1000px\" ng-init=\"vm.getDeal()\"><form \nname=\"contactForm\" data-ng-model=\"contactForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">פרטי קבלה</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"about-tab\" style=\"padding: 50px\"><form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><label>תאריך יצירה</label><input \nng-value=\"vm.deal.CreateTime | cmdate:\'dd/MM/yyyy\'\" type=\"text\" readonly=\"readonly\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"account-box\" class=\"name\"></md-icon><label>מקור הרשמה</label>\n<input ng-value=\"vm.deal.Source | registrationSource\" readonly=\"readonly\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם המשלם</label>\n<input value=\"{{vm.deal.UserName}}\" type=\"text\" disable></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cash\"></md-icon><label>סכום כולל</label><input class=\"number-format\" \nng-value=\"vm.deal.Sum\" type=\"text\" readonly=\"readonly\"></md-input-container></div><div \nng-repeat=\"item in vm.deal.Items\" class=\"accountancy-table-c\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th>שם המשתתף</th><th>שם מאורע</th><th>מחיר סופי</th></tr></thead><tbody><tr \nng-repeat=\"event in item.SelectedEvents\"><td>{{item.FirstName ? item.FirstName + \' \' + item.LastName : item.Name}}</td>\n<td>{{event.Name}}</td><td>{{event.NewPrice}} &#8362;</td></tr></tbody></table><hr></div></form></md-content></form>\n</md-dialog>");
$templateCache.put("app/main/pages/accountancy/views/payments-match/tabs/match-by-dates.html","<div layout=\"row\" layout-wrap ng-init=\"vm.init()\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" \nflex-gt-lg=\"90\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-cash\" class=\"name\"></md-icon><label>סוג התאמה</label><md-select ng-model=\"vm.search.Type\" \nplaceholder=\"סוג התאמה\" ng-init=\"vm.search.Type=2\"><md-option ng-value=\"null\">הכל</md-option><md-option ng-value=\"1\">\nהתאמה מלאה</md-option><md-option ng-value=\"2\">התאמה בעייתית</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-cash\" class=\"name\"></md-icon><label>\nסוג מסמך</label><md-select ng-model=\"vm.search.DocType\" placeholder=\"סוג מסמך\" ng-disabled=\"!vm.payments\"><md-option \nng-value=\"null\">הכל</md-option><md-option ng-value=\"1\">קבלה</md-option><md-option ng-value=\"2\">זיכוי</md-option>\n</md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.StartDate\"><label>מתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.StartDate\" \nng-disabled=\"!vm.payments\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" flex=\"25\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"vm.search.EndDate\"><label>עד לתאריך</label><input autocomplete=\"off\" ng-model=\"vm.search.EndDate\" \nng-disabled=\"!vm.payments\"></div></md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\" ng-if=\"vm.terminalManagement\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><label>שיוך לקטגוריה</label><md-icon \nmd-svg-icon=\"apps\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"vm.search.CategoryID\" \nng-disabled=\"isClicked\" data-ng-required=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"בחר קטגוריה\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"isClicked\"><md-option ng-repeat=\"category in vm.categories |filter:searchTerm\" ng-value=\"category.ID\">\n{{category.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div><div \nclass=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"UserForm.$invalid || (!vm.search.StartDate && !vm.search.EndDate) || !vm.payments\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"vm.getPayments()\">ביצוע התאמה</md-button></div></form></div>\n</div><div ng-if=\"!vm.payments\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.payments\"><div ng-if=\"vm.payments.TotalCharge\">\n<span class=\"fw-bold\">סה\"כ סכום חיובים עבור התקופה: </span><span>&#8362;{{vm.payments.TotalCharge}}</span></div><div \nng-if=\"vm.payments.TotalMissingCharge\"><span class=\"fw-bold\">סה\"כ סכום חיובים חסר עבור התקופה: </span><span>\n&#8362;{{vm.payments.TotalMissingCharge}}</span></div><div ng-if=\"vm.payments.TotalRefunds\"><span class=\"fw-bold\">\nסה\"כ סכום זיכויים עבור התקופה: </span><span>&#8362;{{vm.payments.TotalRefunds}}</span></div><div \nng-if=\"vm.payments.TotalMissingRefunds\"><span class=\"fw-bold\">סה\"כ סכום זיכויים חסר עבור התקופה: </span><span>\n&#8362;{{vm.payments.TotalMissingRefunds}}</span></div></div><div ng-if=\"vm.payments\" class=\"accountancy-table-c\">\n<table id=\"payments-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">תאריך עסקה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סוג מסמך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">התאמה מערכת</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">התאמה חברת סליקה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סכום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-class=\"{\'green\':payment.ReceiptMatch && payment.TransactionMatch,\'red\':!payment.ReceiptMatch || !payment.TransactionMatch}\" \nng-repeat=\"payment in vm.payments.Data | orderBy:Date\" dt-column-defs=\"vm.dtColumnDefs\"><td>\n{{payment.Date | cmdate:\'dd/MM/yyyy HH:mm\'}}</td><td>{{payment.Type == 1 ? \'קבלה\' : \'זיכוי\'}}</td><td>\n{{payment.ReceiptMatch ? \'התאמה מלאה\' : \'קיימת בעיה\'}}</td><td>\n{{payment.TransactionMatch ? \'התאמה מלאה\' : \'קיימת בעיה\'}}</td><td>&#8362;{{payment.Sum}}</td><td><md-button \nng-if=\"!payment.ReceiptID && !payment.Disable\" ng-click=\"vm.createPayment(payment)\" class=\"preview-user\" \ntitle=\"יצירת קבלה + הרשמה\"><md-icon md-font-icon=\"icon-file-document\"></md-icon></md-button><md-button \nng-click=\"vm.openPaymentMatchDialog(payment)\" class=\"preview-user\" title=\"צפיה בפרטי קבלה\"><md-icon md-svg-icon=\"eye\">\n</md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/accountancy/views/payments-match/tabs/match-by-month.html","<div ng-init=\"vm.getPaymentsByMonth()\"><div ng-if=\"!vm.paymentsByMonth\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"vm.paymentsByMonth\" class=\"accountancy-table-c\"><table id=\"payments-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשנה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">חודש</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סה\"כ זיכווים ספק סליקה</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סה\"כ זיכויים מערכת</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סה\"כ חיובים ספק סליקה</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סה\"כ חיובים מערכת</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פער זיכויים</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פער חיובים</span></div></th></tr>\n</thead><tbody><tr class=\"entry-code-item\" ng-repeat=\"payment in vm.paymentsByMonth\" dt-column-defs=\"vm.dtColumnDefs\">\n<td>{{payment.Year}}</td><td>{{payment.Month}}</td><td><span class=\"number-format\">\n{{payment.TotalPaymentCompanyRefund}}</span></td><td><span class=\"number-format\">{{payment.TotalMarvilixRefund}}</span>\n</td><td><span class=\"number-format\">{{payment.TotalPaymentCompanyCharge}}</span></td><td><span class=\"number-format\">\n{{payment.TotalMarvilixCharge}}</span></td><td><span class=\"number-format\">{{payment.RefundDifferences}}</span></td>\n<td><span class=\"number-format\">{{payment.ChargeDifferences}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/events-extras/views/transportation/new-transportation-dialog/new-transportation-dialog.html","<md-dialog class=\"newTransportation-dialog\" aria-label=\"New Task\"><form name=\"newTransportationForm\" \ndata-ng-model=\"newTransportationForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">הוספת הסעה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><md-icon\n md-font-icon=\"icon-bus\"></md-icon><label>שם הסעה</label><textarea ng-model=\"newTransportation.Name\" type=\"text\" \nng-required=\"true\" ng-disabled=\"isClicked\"></textarea></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newTransportationForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewTransportation()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events-extras/views/transportation/transportation-stops-panel/transportation-stops-panel.html","<md-dialog class=\"newTransportation-dialog\" aria-label=\"New Task\"><form name=\"transportationStopsForm\" \ndata-ng-model=\"transportationStopsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">תחנות הסעה ({{transportation.Name}})</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><p>*ניתן לגרור את התחנות על מנת לסדר אותם לפי סדר ההגעה</p><div class=\"sflex fdc mb20\" \nui-sortable ng-model=\"transportation.Stops\"><div ng-repeat=\"(index,stop) in transportation.Stops\"><div \nclass=\"sflex jcsb aic\"><div>{{index + 1}}) {{stop.Name}}</div><div><md-button ng-if=\"!stop.expanded\" \nclass=\"preview-user\" ng-click=\"stop.expanded = true\" title=\"עוד מידע\"><md-icon md-svg-icon=\"plus\"></md-icon>\n</md-button><md-button ng-if=\"stop.expanded\" class=\"preview-user\" ng-click=\"stop.expanded = false\" title=\"פחות מידע\">\n<md-icon md-svg-icon=\"minus\"></md-icon></md-button><md-button class=\"preview-user\" ng-click=\"deleteStop(index)\" \ntitle=\"מחיקה\"><md-icon md-svg-icon=\"delete\"></md-icon></md-button></div></div><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"stop.expanded\"><md-icon md-font-icon=\"icon-bus\"></md-icon><label>שם התחנה</label>\n<textarea ng-model=\"stop.Name\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></textarea></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" ng-if=\"stop.expanded\"><md-icon md-svg-icon=\"view-headline\">\n</md-icon><label>תיאור</label><textarea ng-model=\"stop.Description\" type=\"text\" ng-disabled=\"isClicked\"></textarea>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"transportationStopsForm.$invalid || isClicked\" type=\"submit\" ng-click=\"addNewStop()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">הוספה</md-button><md-button \ndata-ng-disabled=\"transportationStopsForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewStops()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events-extras/views/transportation/transportation-panel/transportation-panel.html","<md-content ms-scroll><form name=\"questionForm\" id=\"questionForm\" data-ng-model=\"questionForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת הסעה</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-bus\"></md-icon><label>\nשם הסעה</label><input type=\"text\" ng-model=\"transportation.Name\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select \nng-model=\"transportation.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"transportation.Status==0 || transportation.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option><md-option \nng-selected=\"transportation.Status==1 || transportation.Status==\'1\'\" ng-value=\"1\">פעיל</md-option></md-select>\n</md-input-container></form></md-content>");
$templateCache.put("app/main/pages/accountancy/views/cashier/create-bank-reference-files-dalog/create-bank-reference-files-dialog.html","<md-dialog id=\"new-bank-reference-files-dialog\" aria-label=\"New Task\" style=\"overflow: visible\"><form \nname=\"newBankReferenceFilesForm\" data-ng-model=\"newGroupForm\" class=\"md-inline-form\" validate \nstyle=\"overflow: visible\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהפקת מסמכי הפקדה עבור {{receipts.length}} תשלומים</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div layout=\"column\" \nflex=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon>\n<div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"files.Date\"><label>תאריך הפקדה</label><input \nautocomplete=\"off\" ng-model=\"files.Date\" ng-disabled=\"isClicked\"></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newBankReferenceFilesForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"generateFiles()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">הפקת מסמך\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events-extras/views/attendance/event-meeting-panel/event-meeting-panel.html","<md-content ms-scroll style=\"overflow:visible !important\"><form name=\"meetingForm\" id=\"meetingForm\" \ndata-ng-model=\"meetingForm\" class=\"md-inline-form\" validate style=\"overflow:visible !important\"><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת מפגש</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-question-mark-circle\">\n</md-icon><label>שם המאורע</label><input disabled=\"disabled\" ng-model=\"meeting.Name\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon>\n<div locale=\"he\" format=\"DD/MM/YYYY HH:mm\" moment-picker=\"meeting.Date\"><label>שעת מפגש</label><input \nautocomplete=\"off\" ng-model=\"meeting.Date\"></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-format-align-right\"></md-icon><label>הערות</label><textarea \nng-model=\"meeting.Comments\" type=\"text\"></textarea></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/events-extras/views/attendance/meeting-management/meeting-management.html","<div id=\"meeting-management\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\"><div \nclass=\"hsf13 small-name\">מפגש</div><div class=\"name\">{{meeting.Name}}</div></div></div><div class=\"content\" flex><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!meeting\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-tabs md-dynamic-height id=\"meeting-management-tab\" \nng-if=\"meeting\"><md-tab ng-disabled=\"$root.isEdit && selectedTab!=0\" md-on-select=\"setTab(0)\"><md-tab-label><span>כללי\n</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events-extras/views/attendance/meeting-management/tabs/general/general.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab \nng-disabled=\"($root.AdminLevel == 2 && !$root.User.Attendance) ||  $root.isEdit && selectedTab!=1\" \nmd-on-select=\"setTab(1)\"><md-tab-label><span>נוכחות</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events-extras/views/attendance/meeting-management/tabs/attendance/attendance.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/events-extras/views/attendance/new-event-meeting-dialog/new-event-meeting-dialog.html","<md-dialog class=\"newLocation-dialog\" aria-label=\"New Task\" style=\"overflow: visible !important\"><form \nname=\"newLocationForm\" data-ng-model=\"newLocationForm\" class=\"md-inline-form\" validate \nstyle=\"overflow: visible !important\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nיצירת מפגש חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"overflow: visible !important\"><md-input-container class=\"md-icon-float md-block\"><label>מאורע</label><md-icon \nmd-svg-icon=\"weather-sunny\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"newMeeting.eventID\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" ng-keyup=\"eventKeyPress($event)\" placeholder=\"חפש מאורע..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"events\">\n<md-option ng-value=\"event.ID\" ng-repeat=\"event in events |filter:searchTerm\">{{event.Name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" format=\"DD/MM/YYYY HH:mm\" \nmoment-picker=\"newMeeting.Date\"><label>שעת מפגש</label><input autocomplete=\"off\" ng-model=\"newMeeting.Date\"></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-comment\" \nclass=\"name\"></md-icon><label>הערות</label><textarea ng-model=\"newMeeting.Comments\"></textarea></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newLocationForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewMeeting()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/admin/admin-profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nכללי</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div class=\"row\" \nlayout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-email\" \nclass=\"email\"></md-icon><label>דואר אלטקרני</label><input ng-model=\"$root.User.Email\" type=\"email\" \nng-disabled=\"$root.AdminLevel==1\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\" class=\"account\"></md-icon>\n<label>שם פרטי</label><input ng-model=\"$root.User.FirstName\" type=\"text\" ng-disabled=\"$root.AdminLevel==1\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon></md-icon>\n<label>שם משפחה</label><input ng-model=\"$root.User.LastName\" type=\"text\" ng-disabled=\"$root.AdminLevel==1\">\n</md-input-container></div></div><md-button ng-disabled=\"isClicked || !goodFile\" class=\"md-raised md-accent\" \naria-label=\"שמור את השדות\" ng-click=\"editAdmin()\" style=\"margin-right: 0px\">שמור</md-button></form></div></div></div>\n</div>");
$templateCache.put("app/main/pages/branches/views/grades/new-grades-dialog/new-grades-dialog.html","<md-dialog class=\"new-grade-dialog\"><form name=\"newGradeForm\" data-ng-model=\"newGroupForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" ng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-panorama-horizontal\" class=\"name\"></md-icon><label>שם</label><input ng-model=\"newGrade.Name\" \nng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-icon-float md-block\">\n<label>שנתון</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"newGrade.Year\" \nng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"\"></md-icon>\n<label>שכבת בוגרים</label><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><md-select \nng-model=\"newGrade.Graduates\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא\n</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newGradeForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewGrade()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/admin/admin-profile/tabs/password/password.html","<div layout=\"row\" layout-wrap><div class=\"password_update\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"70\">\n<div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">שינויי סיסמה</div></header><div class=\"content\"><ul><li>מינימום 8 תווים</li><li>אות אחת גדולה לפחות</li>\n<li>מספר אחד לפחות</li><li>אותיות באנגלית בלבד</li></ul><form name=\"PasswordForm\" class=\"md-inline-form\" \nng-submit=\"updatePassword()\" validate><div class=\"row\" layout=\"row\"><div class=\"full\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-key-variant\" class=\"email\"></md-icon><label>סיסמא נוכחית\n</label><input ng-model=\"$root.User.oldPassword\" type=\"password\" ng-required=\"true\"><div \nng-messages=\"$root.User.oldPassword.$error\"><div ng-message-exp=\"[\'required\']\"><span>השדה לא יכול להיות ריק</span>\n</div></div></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"full\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-lock\" class=\"account\"></md-icon><label>סיסמא חדשה</label>\n<input ng-model=\"$root.User.newPassword\" type=\"password\" ng-required=\"true\" \nng-pattern=\"/^(?=.*\\d)(?=.*[A-Z])(?!.*[^a-zA-Z0-9@#$^+=])(.{8,15})$/\"><div ng-messages=\"$root.User.newPassword.$error\">\n<div ng-message-exp=\"[\'required\', \'pattern\']\"><span>\nהסיסמא חייבת להיות באורך מינימלי של 8 תווים, צריכה להכיל לפחות אות אחת גדולה וספרה</span></div></div>\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"full\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon></md-icon><label>אימות סיסמא חדשה</label><md-icon md-font-icon=\"icon-lock\" \nclass=\"account\"></md-icon><input ng-model=\"$root.User.newPasswordConfirmation\" type=\"password\" \nng-class=\"{\'ng-valid\': $root.User.newPassword == $root.User.newPasswordConfirmation && $root.User.newPasswordConfirmation.length != 0}\" \nng-pattern=\"/^(?=.*\\d)(?=.*[A-Z])(?!.*[^a-zA-Z0-9@#$^+=])(.{8,15})$/\" ng-required=\"true\"><div \nng-messages=\"$root.User.newPasswordConfirmation.$error\"><div ng-message-exp=\"[\'pattern\']\"><span>\nהסיסמאות צריכות להיות זהות</span></div></div></md-input-container></div></div><md-button type=\"submit\" \nng-disabled=\"isClicked || (!$root.User.newPassword && !$root.User.newPasswordConfirmation)\" \nclass=\"md-raised md-accent\" aria-label=\"שמור את השדות\" style=\"margin-right: 0px\">שמור</md-button></form></div></div>\n</div></div>");
$templateCache.put("app/main/pages/branches/views/grades/grades-panel/grades-panel.html","<md-content ms-scroll><form name=\"gradeForm\" id=\"grade-panel\" data-ng-model=\"groupForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"padding-top: 25px\"><span class=\"title\">עריכה מהירה</span><md-button \nclass=\"md-icon-button\" ng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nclass=\"selectedUser-name\">{{ group.Name }}</div></div></md-toolbar><md-input-container class=\"md-icon-float md-block\">\n<label>שם</label><md-icon md-font-icon=\"icon-panorama-horizontal\" class=\"name\"></md-icon><input ng-model=\"grade.Name\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label>שנתון</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"grade.Year\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"\"></md-icon><label>שכבת בוגרים</label><md-icon \nmd-font-icon=\"icon-account-box\" class=\"name\"></md-icon><md-select ng-model=\"grade.Graduates\"><md-option \nng-selected=\"grade.Graduates==1 || grade.Graduates==\'1\'\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"grade.Graduates==0 || grade.Graduates==\'0\'\" ng-value=\"0\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><label>סטטוס</label>\n<md-select ng-model=\"grade.Status\" placeholder=\"סטטוס\"><md-option ng-selected=\"grade.Status==1 || grade.Status==\'1\'\" \nng-value=\"1\">פעיל</md-option><md-option ng-selected=\"grade.Status==0 || grade.Status==\'0\'\" ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/events-extras/views/questions/new-question-dialog/new-question-dialog.html","<md-dialog class=\"newQuestion-dialog\" aria-label=\"New Task\" ng-init=\"getSettlements()\"><form name=\"newQuestionForm\" \ndata-ng-model=\"newQuestionForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת שאלה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><label>תיאור השאלה(עד 255 תווים)</label><textarea \nng-model=\"newQuestion.Description\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\" maxlength=\"255\"></textarea>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-format-align-right\"></md-icon>\n<label>סוג שאלה</label><md-select ng-model=\"newQuestion.AnswerType\" placeholder=\"סוג שאלה\" ng-required=\"true\" \nng-disabled=\"isClicked\"><md-option ng-value=\"1\">שאלה פתוחה</md-option><md-option ng-value=\"2\">אפשרויות</md-option>\n<md-option ng-value=\"3\">קובץ</md-option><md-option ng-value=\"4\">תאריך</md-option><md-option ng-value=\"5\">צ\'ק בוקס\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"row\" \nflex=\"100\" ng-if=\"eventID\"><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select \nng-model=\"newQuestion.SettlementID\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm2\" \ntype=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"שיוך ל{{$root.orgTypeBranchName.single}} ספציפי\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-value=\"null\">\nכולם</md-option><md-option ng-repeat=\"settlement in settlements | orderBy:\'Name\' | filter:searchTerm2\" \nng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"newQuestion.AnswerType==2\"><label>אפשרויות</label><md-chips \nng-model=\"newQuestion.Options\" readonly=\"false\" md-removable=\"true\" ng-required=\"true\" ng-disabled=\"isClicked\">\n</md-chips></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newQuestionForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewQuestion()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events-extras/views/questions/question-panel/question-panel.html","<md-content ms-scroll><form name=\"questionForm\" id=\"questionForm\" data-ng-model=\"questionForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת שאלה</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-question-mark-circle\">\n</md-icon><label>תיאור השאלה</label><textarea ng-model=\"question.Description\" type=\"text\"></textarea>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-format-align-right\"></md-icon>\n<label>סוג שאלה</label><md-select ng-model=\"question.AnswerType\" placeholder=\"סוג שאלה\"><md-option \nng-selected=\"question.AnswerType==1 || question.AnswerType==\'1\'\" ng-value=\"1\">שאלה פתוחה</md-option><md-option \nng-selected=\"question.AnswerType==2 || question.AnswerType==\'2\'\" ng-value=\"2\">אפשרויות</md-option><md-option \nng-selected=\"question.AnswerType==3 || question.AnswerType==\'2\'\" ng-value=\"3\">קובץ</md-option><md-option \nng-selected=\"question.AnswerType==4 || question.AnswerType==\'4\'\" ng-value=\"4\">תאריך</md-option><md-option \nng-selected=\"question.AnswerType==5 || question.AnswerType==\'5\'\" ng-value=\"5\">צ\'ק בוקס</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"question.AnswerType==2\"><md-icon md-font-icon=\"\">\n</md-icon><label>אפשרויות</label><md-chips ng-model=\"question.Options\" readonly=\"false\" md-removable=\"true\"></md-chips>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס\n</label><md-select ng-model=\"question.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"question.Status==0 || question.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option><md-option \nng-selected=\"question.Status==1 || question.Status==\'1\'\" ng-value=\"1\">פעיל</md-option></md-select></md-input-container>\n</form></md-content>");
$templateCache.put("app/main/pages/branches/views/groups/group-management/group-management.html","<div id=\"group-management\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\"><div \nclass=\"hsf13 small-name\">{{$root.User.Group}}</div><div class=\"name\">{{group.Name}}</div></div></div><div \nclass=\"content\" flex><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!group\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-tabs md-dynamic-height \nid=\"group-management-tab\" ng-if=\"group\"><md-tab ng-disabled=\"$root.isEdit && selectedTab!=0\" md-on-select=\"setTab(0)\">\n<md-tab-label><span>כללי</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/groups/group-management/tabs/general/general.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=1\" md-on-select=\"setTab(1)\"><md-tab-label>\n<span>אנשי קשר</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/groups/group-management/tabs/contacts/contacts.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=2\" md-on-select=\"setTab(2)\"><md-tab-label>\n<span>תושבים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/branches/views/groups/group-management/tabs/students/students.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/branches/views/groups/new-group-dialog/new-group-dialog.html","<md-dialog class=\"new-group-dialog\" aria-label=\"New Task\" ng-init=\"getBranches();getSettlements();getGrades();\"><form \nname=\"newGroupForm\" data-ng-model=\"newGroupForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">הוספה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>שם</label><input ng-model=\"newGroup.Name\" \ntype=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>בחר {{$root.orgTypeBranchName.single}}</label>\n<md-select ng-model=\"newGroup.SettlementID\" ng-required=\"true\" ng-disabled=\"!settlements.length || isClicked\">\n<md-option ng-repeat=\"settlement in settlements\" ng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-chair-school\" class=\"name\">\n</md-icon><label>בחר {{$root.User.Grade}}</label><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"newGroup.Grades\" \nng-required=\"true\" multiple=\"true\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" \ntype=\"text\" ng-disabled=\"!grades || isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש שכבה..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!grades || isClicked\"><md-option ng-value=\"grade.ID\" ng-repeat=\"grade in grades |filter:searchTerm\">\n{{grade.Name}}</md-option></md-optgroup></md-select></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newGroupForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewGroup()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/branches/views/settlements/manage-settlements-panel/manage-settlements-panel.html","<md-content ms-scroll><form name=\"settlementsForm\" id=\"branchForm\" data-ng-model=\"settlementsForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת {{$root.orgTypeBranchName.single}}</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\" \naria-label=\"Close Dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label>שם</label>\n<input ng-model=\"settlement.Name\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nng-if=\"$root.orgType == \'RC\'\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>\nסוג {{$root.orgTypeBranchName.single}}</label><md-select ng-model=\"settlement.Type\" placeholder=\"סוג יישוב\" \nng-disabled=\"$root.AdminLevel<3\"><md-option ng-selected=\"settlement.Type== \'מושב\' \" ng-value=\"\'מושב\'\">מושב</md-option>\n<md-option ng-selected=\"settlement.Type== \'ישוב קהילתי\' \" ng-value=\"\'ישוב קהילתי\'\">ישוב קהילתי</md-option><md-option \nng-selected=\"settlement.Type== \'כפר\' \" ng-value=\"\'כפר\'\">כפר</md-option><md-option \nng-selected=\"settlement.Type== \'קיבוץ\' \" ng-value=\"\'קיבוץ\'\">קיבוץ</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"$root.orgType == \'CITY\'\"><md-icon md-font-icon=\"icon-power\"></md-icon>\n<label>סוג {{$root.orgTypeBranchName.single}}</label><md-select ng-model=\"settlement.Type\" \nplaceholder=\"סוג {{$root.orgTypeBranchName.single}}\" ng-disabled=\"$root.AdminLevel<3\"><md-option \nng-selected=\"settlement.Type== \'שכונה\' \" ng-value=\"\'שכונה\'\">שכונה</md-option></md-select></md-input-container></form>\n</md-content>");
$templateCache.put("app/main/pages/branches/views/groups/groups-panel/groups-panel.html","<md-content ms-scroll><form name=\"groupsForm\" id=\"groups-panel\" data-ng-model=\"groupForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"padding-top: 25px\"><span class=\"title\">עריכה מהירה</span><md-button \nclass=\"md-icon-button\" ng-click=\"$root.closePanel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><label>שם {{$root.User.Group}}</label><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><input ng-model=\"group.Name\" type=\"text\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon>\n<label>{{$root.orgTypeBranchName.single}}</label><md-select ng-model=\"group.SettlementID\" ng-required=\"true\" \nng-disabled=\"!settlements.length\"><md-option ng-repeat=\"settlement in settlements\" ng-value=\"settlement.ID\">\n{{settlement.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><label>{{$root.User.Grades}}</label><md-select \nmd-on-close=\"clearSearchTerm()\" ng-model=\"group.Grades\" ng-required=\"true\" multiple=\"true\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"!grades || isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש שכבה..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"!grades || isClicked\"><md-option ng-value=\"grade.ID\" \nng-repeat=\"grade in grades |filter:searchTerm\">{{grade.Name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon>\n<label>סטטוס</label><md-select ng-model=\"group.Status\" placeholder=\"סטטוס\" ng-disabled=\"$root.AdminLevel<2\"><md-option \nng-selected=\"group.Status==1 || group.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"group.Status==0 || group.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</form></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/tabs/accounts.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\">\n</md-icon><span class=\"title\">תיקי הכנסות יעודכנו בדו\"ח ייצוא הנהלת חשבונות מהמערכת</span></div><md-content \nclass=\"content md-padding\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.accountancy\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><form name=\"upgradeGradeForm\" \nclass=\"md-inline-form\" validate ng-show=\"vm.accountancy\"><div class=\"row\" layout=\"row\"><div class=\"half\">\n<md-input-container class=\"md-block\"><label>מספר קבוע המחאות מזומן</label><input ng-model=\"vm.accountancy.CashCheck\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><label>מספר קבוע המחאות דחויות</label><input ng-model=\"vm.accountancy.FutureCheck\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע ויזה</label><input ng-model=\"vm.accountancy.Visa\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><label>מספר קבוע ישראקרד</label><input ng-model=\"vm.accountancy.IsraCard\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע אמריקן אקספרס</label><input \nng-model=\"vm.accountancy.AmericanExpress\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div\n class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע מאסטקארד</label><input \nng-model=\"vm.accountancy.MasterCard\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע דיינרס</label>\n<input ng-model=\"vm.accountancy.Diners\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע מזומן</label><input ng-model=\"vm.accountancy.Cash\" \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע לאומיקארד</label><input \nng-model=\"vm.accountancy.LeumiCard\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע העברה בנקאית</label><input \nng-model=\"accountancy.BankTransfer\" ng-disabled=\"!accountancy || isClicked\"></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע חשבון פנימי</label>\n<input ng-model=\"vm.accountancy.InnerTrans\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div>\n<div class=\"half\"><md-input-container class=\"md-block\"><label>מספר תשלומים מקסימלי</label><input type=\"number\" \nng-model=\"vm.accountancy.GlobalMaxNumOfPayments\" ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container>\n</div></div><md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateAccountancy()\" \nstyle=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/tabs/banks.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\">\n</md-icon><span class=\"title\">\nחשבונות בנק שמקושרים לתנועה. בהוספת הרשמות חדשות באמצעות העברה בנקאית ניתן לבחור את החשבון שאליו הופקד התשלום.</span>\n</div><md-content class=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div><div \nclass=\"half\" lass=\"row\" layout=\"row\"><table class=\"dataTable row-border hover\"><thead><tr><th data-priority=\"1\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם בנק</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר תיק הכנסות</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.accountancy.Banks\"><td><md-input-container class=\"md-block\"><label>שם בנק\n</label><input ng-model=\"item.Name\" ng-disabled=\"vm.isClicked\"></md-input-container></td><td><md-input-container \nclass=\"md-block\"><label>מספר קבוע בנק</label><input ng-model=\"item.Number\" ng-disabled=\"vm.isClicked\">\n</md-input-container></td></tr></tbody></table></div></div><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.addBank()\" style=\"margin-right: 0px\">הוספת בנק</md-button><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateAccountancy()\" style=\"margin-right: 0px\">\nעדכון</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/tabs/general.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\"><md-content class=\"content md-padding\"><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.accountancy\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate ng-show=\"vm.accountancy\">\n<div layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-clock\" \nclass=\"name\"></md-icon><label>סגירת קופה אוטומטית בחצות</label><md-select ng-model=\"vm.accountancy.AutoCashierClose\" \nplaceholder=\"סגירת קופה אוטומטית בחצות\" ng-disabled=\"!vm.accountancy || vm.isClicked\"><md-option ng-value=\"1\">פעיל\n</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"name\"></md-icon><label>מייל לשליחת דו\"ח קופה בחצות</label><input \nng-model=\"vm.accountancy.CashierAutoEmail\" placeholder=\'מייל לשליחת דו\"ח קופה בחצות\' \nng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon><label>\nמייל לשליחת דו\"ח פרעון המחאות</label><input ng-model=\"vm.accountancy.ChecksAutoEmail\" \nplaceholder=\'מייל לשליחת דו\"ח פרעון המחאות\' ng-disabled=\"!vm.accountancy || vm.isClicked\"></md-input-container></div>\n</div><md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateAccountancy()\" \nstyle=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/tabs/terminals.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\"><md-input-container class=\"md-block\"><md-checkbox \nclass=\"md-secondary cb_title\" ng-model=\"vm.accountancy.TerminalManagment\" ng-true-value=\"1\" ng-false-value=\"0\">\nניהול ריבוי מסופים</md-checkbox></md-input-container><div class=\"info-header\" ng-if=\"vm.accountancy.TerminalManagment\">\n<md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nמסופי סליקת אשראי. לאחר הגדרתם, ניתן לקשר אותם לקטגוריית מאורעות ראשית.</span></div><md-content \nclass=\"content md-padding\" ng-if=\"vm.accountancy.TerminalManagment\"><form name=\"upgradeGradeForm\" \nclass=\"md-inline-form\" validate><div><div class=\"half\" lass=\"row\" layout=\"row\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th data-priority=\"1\" class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">שם חשבון</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מזהה מסוף</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם משתמש</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סיסמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מסוף ברירת מחדל</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.terminals\"><td><md-input-container\n class=\"md-block\"><label>שם חשבון</label><input ng-model=\"item.Name\" ng-disabled=\"vm.isClicked\"></md-input-container>\n</td><td><md-input-container class=\"md-block\"><label>מזהה מסוף</label><input ng-model=\"item.TerminalID\" \nng-disabled=\"vm.isClicked\"></md-input-container></td><td><md-input-container class=\"md-block\"><label>שם משתמש</label>\n<input ng-model=\"item.TerminalUser\" ng-disabled=\"vm.isClicked\"></md-input-container></td><td><md-input-container \nclass=\"md-block\"><label>סיסמה</label><input ng-model=\"item.TerminalPassword\" ng-disabled=\"vm.isClicked\">\n</md-input-container></td><td><md-input-container class=\"md-block\"><md-checkbox class=\"md-secondary\" \nng-model=\"item.IsDefaultTerminal\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.isClicked || (vm.checkSingleDefaultTerminal() && item.IsDefaultTerminal == 0)\"></md-checkbox>\n</md-input-container></td><td><md-button ng-disabled=\"vm.isClicked\" ng-click=\"vm.showExtraDetails(item)\" \nclass=\"md-raised md-accent\" ng-click=\"\" style=\"margin-right: 0px\">פרטים נוספים</md-button></td></tr></tbody></table>\n</div></div><md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.addNewTerminal()\" \nstyle=\"margin-right: 0px\">הוספת מסוף</md-button><md-button ng-disabled=\"vm.isClicked || !vm.checkTerminalsValidity()\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateAccountancyTerminals()\" style=\"margin-right: 0px\">עדכון</md-button>\n</form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/tabs/coordinators.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\" ng-init=\"vm.getRoles()\"><div class=\"info-header\"><md-icon \nmd-svg-icon=\"information\"></md-icon><span class=\"title\">\nניתן לייצר הגדרות תפקידים של רכזים, לדגומא רכז מפעלים. לאחר מכן תוכלו לשייך כל רכז לתפקיד ולבצע חיפוש של רכזים לפי התפקיד שלהם\n</span></div><md-content class=\"content md-padding\" ng-hide=\"!vm.roles\"><form class=\"md-inline-form\" validate>\n<md-input-container class=\"md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><label>הוספת תפקידי רכזים</label><md-chips ng-model=\"vm.roles\"></md-chips></md-input-container>\n<md-button class=\"md-raised md-accent\" ng-disabled=\"vm.isClikced\" ng-click=\"vm.updateRoles()\">עדכון</md-button></form>\n</md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/tabs/organizations.html","<md-content class=\"profile-box admin-settings info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon \nmd-svg-icon=\"information\"></md-icon><span class=\"title\">\nיש לבחור את האירגונים שעבורם שיתוף האירועים עבור החניכים יהיה פעיל</span></div><md-content class=\"content md-padding\">\n<form name=\"organizationsForm\" class=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"half\">\n<md-input-container class=\"md-icon-float md-block\" ng-if=\"$root.AdminLevel>2\" title=\"התחל לרשום שם ארגון\">\n<md-contact-chips ng-model=\"vm.systemSettings.Organizations\" md-contacts=\"vm.organizationsQuerySearch($query)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר ארגון\">\n</md-contact-chips></md-input-container></div></div><md-button \nng-disabled=\"vm.isClicked || organizationsForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"עדכן הרשאות\" \nng-click=\"vm.updateOrganizations()\" style=\"margin-right: 0px\">עדכן</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/tabs/tags.html","<div ng-init=\"vm.getTags()\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.tags\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.tags\"><div \nclass=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nתגיות מאפשרות לסווג תושבים לקבוצות. בעמודי הניהול תוכלו לבצע חיפוש וסינון לפי התגיות. סטטוסים מאפשרים סיווג נרשים ע\"פי סטטוסים בעמוד נרשמים למאורע.\n</span></div><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex jcsb aic\"><div \nclass=\"title\">תגיות תושבים</div><div class=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block m0\">\n<md-select ng-model=\"vm.statusFilter\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים\n</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container><md-button \nclass=\"md-icon-button\" aria-label=\"הוסף תגית\" title=\"הוספת תגית\" ng-click=\"vm.openNewTagDialog()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></header><div class=\"content\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם תגית</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"tag in vm.tags | filter: {Status: vm.statusFilter}\"><td>{{tag.Name}}</td><td><md-icon \nmd-font-icon=\"icon-power\" class=\"cp\" ng-class=\"{\'green600\':tag.Status==1, \'red600\':tag.Status==0}\" \nng-click=\"vm.updateTagStatus(tag)\"></md-icon></td></tr></tbody></table></div></div></div><div class=\"general\" \nlayout=\"column\" flex=\"100\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg sflex jcsb aic\"><div class=\"title\">סוגי סטטוס נוכחות</div></header><div class=\"content\"><md-chips \nng-model=\"vm.systemSettings.AttendenceStatus\"></md-chips><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.isClikced\" ng-click=\"vm.updateTags()\">עדכון</md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/tabs/upgrade-grade.html","<md-content class=\"profile-box info-box md-whiteframe-1dp\" ng-init=\"vm.getGrades()\"><div class=\"info-header\"><md-icon \nmd-svg-icon=\"information\"></md-icon><span class=\"title\">\nבכל סוף שנה\\תחילת שנה חדשה צריך להעביר את כל החניכים לשנה הבאה. <span class=\"red\">יש להתחיל מהשכבה הגובה ביותר</span>\n</span></div><md-content class=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div \nclass=\"row\" layout=\"row\"><md-input-container class=\"md-block\"><label>{{$root.User.Grade}} נבחרת</label><md-select \nng-model=\"vm.upgrade.SelectedGrade\" ng-required=\"true\" ng-disabled=\"!vm.grades || vm.isClicked \"><md-option \nng-repeat=\"gradeValue in vm.grades\" ng-value=\"gradeValue.ID\">{{gradeValue.Name}}</md-option></md-select>\n</md-input-container></div><div class=\"row\" layout=\"row\"><md-input-container class=\"md-block\"><label>\n{{$root.User.Grade}} חדשה</label><md-select ng-model=\"vm.upgrade.NewGrade\" \nng-disabled=\"!vm.upgrade.SelectedGrade || vm.isClicked \" ng-required=\"true\"><md-option \nng-repeat=\"gradeValue in vm.grades\" ng-value=\"gradeValue.ID\">{{gradeValue.Name}}</md-option></md-select>\n</md-input-container></div><div class=\"row\" layout=\"row\"><md-input-container class=\"md-block\"><md-radio-group \nng-model=\"vm.upgrade.Type\" ng-init=\"vm.upgrade.Type = 1\"><md-radio-button value=\"1\" \ntitle=\"יווצרו קבוצות חדשות עבור החניכים בהתאם לסניף ולשכבה החדשה\">יצירת קבוצות חדשות</md-radio-button><md-radio-button \nvalue=\"2\" title=\"הקבוצה הנוכחית של החניך תעלה שכבה ביחד איתו\">העלאת קבוצות ישנות</md-radio-button></md-radio-group>\n</md-input-container></div><md-button ng-disabled=\"vm.isClicked || upgradeGradeForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"עדכן שכבה\" ng-click=\"vm.updateGrade(grade)\" style=\"margin-right: 0px\">עדכן\n</md-button></form></md-content></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/new-field-dialog/new-field-dialog.html","<md-dialog class=\"newField-dialog\" aria-label=\"New Task\"><form name=\"newFieldForm\" data-ng-model=\"newFieldForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת שדה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><label>תיאור השדה</label><textarea ng-model=\"newField.Title\" \ntype=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></textarea></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-format-align-right\"></md-icon><label>סוג שדה</label><md-select \nng-model=\"newField.Type\" placeholder=\"סוג שדה\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">\nשאלה פתוחה</md-option><md-option ng-value=\"2\">אפשרויות</md-option><md-option ng-value=\"3\">תאריך</md-option><md-option \nng-value=\"4\">קובץ</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><label>האם להציג בפרופיל</label><md-select ng-model=\"newField.ShowInProfile\" \nplaceholder=\"האם להציג בפרופיל\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">כן</md-option>\n<md-option ng-value=\"0\">לא</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"newField.Type==2\"><label>אפשרויות</label><md-chips ng-model=\"newField.Values\" readonly=\"false\" \nmd-removable=\"true\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-chips></md-input-container><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"newField.Required\" ng-disabled=\"isClicked\" ng-true-value=\"1\" \nng-false-value=\"0\">שדה חובה</md-checkbox></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newFieldForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewField()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/settings-menue/views/general-settings/tabs/entities.html","<div flex=\"100\" flex-xs=\"100\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\">\n<md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nלכל ארגון יש את הטרמינולוגיה שלו, כאן תוכלו לשנות את השמות שיופיע בתוכנה ובפרופיל ההורה בלשון יחיד ורבים</span></div>\n<md-content class=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"row\" \nlayout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>שכבה</label><md-icon \nmd-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Grade\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><label>שכבות</label><md-icon md-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><input \nng-model=\"vm.systemSettings.Grades\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>קבוצה</label><input \nng-model=\"vm.systemSettings.Group\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon>\n<label>קבוצות</label><input ng-model=\"vm.systemSettings.Groups\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-leaf\" class=\"name\"></md-icon><label>פעילות</label><input \nng-model=\"vm.systemSettings.Activity\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>פעילויות</label><md-icon md-font-icon=\"icon-leaf\" \nclass=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Activities\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-tie\" class=\"name\"></md-icon><label>רכז</label><input \nng-model=\"vm.systemSettings.Coordinator\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div>\n<div class=\"half\"><md-input-container class=\"md-block\"><label>רכזים</label><md-icon md-font-icon=\"icon-tie\" \nclass=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Coordinators\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-calendar\" class=\"name\"></md-icon><label>\n{{$root.User.Event}}</label><input ng-model=\"vm.systemSettings.Event\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><label>{{$root.User.Events}}</label>\n<md-icon md-font-icon=\"icon-calendar\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.Events\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן מילון מונחים\" \nng-click=\"vm.updateSystemSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/general-settings/tabs/organization-details.html","<div flex=\"100\" flex-xs=\"100\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\">\n<md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">פרטי הארגון - יופיעו בפרופיל ההורה ועל הקבלות שיופקו\n</span></div><md-content class=\"content md-padding\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!vm.systemSettings\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><form \nname=\"upgradeGradeForm\" class=\"md-inline-form\" ng-show=\"vm.systemSettings\" validate><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>\nשם הארגון</label><input ng-model=\"vm.systemSettings.BrandName\" ng-disabled=\"!vm.systemSettings || vm.isClicked\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" \nclass=\"name\"></md-icon><label>מספר הארגון</label><input ng-model=\"vm.systemSettings.BrandNumber\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>כתובת הארגון</label><md-icon md-svg-icon=\"map-marker\" \nclass=\"name\"></md-icon><input ng-model=\"vm.systemSettings.BrandAddress\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-phone\" class=\"name\"></md-icon><label>מספר טלפון</label><input \nng-model=\"vm.systemSettings.BrandPhoneNumber\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר פקס\n</label><md-icon md-svg-icon=\"fax\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.BrandFaxNumber\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon><label>מייל</label><input \nng-model=\"vm.systemSettings.BrandEmail\" ng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div>\n</div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>אתר אינטרנט</label>\n<md-icon md-font-icon=\"icon-web\" class=\"name\"></md-icon><input ng-model=\"vm.systemSettings.BrandWebsite\" \nng-disabled=\"!vm.systemSettings || vm.isClicked\"></md-input-container></div></div><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן  {{$root.User.Grade}}\" \nng-click=\"vm.updateSystemSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/general-settings/tabs/personalized.html","<div flex=\"100\" flex-xs=\"100\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\">\n<md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nהתאמה אישית - הפרטים שתעדכנו יופיעו בפרופיל ההורה ובתוכנת הניהול</span></div><md-content class=\"content md-padding\">\n<form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div class=\"fw-medium fcred hfs13 mb10\">\nשים לב: יש להשתמש בקבצים שגודלם עד 1MB</div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nng-repeat=\"image in vm.adminImages\" flex-gt-md=\"100\"><md-icon ng-if=\"!image.Value\" md-svg-icon=\"upload\" class=\"name\">\n</md-icon><md-icon ng-disabled=\"vm.isClicked\" ng-if=\"image.Value\" md-svg-icon=\"eye\" href=\"{{image.Value}}\" \nng-click=\"vm.viewFile(image.Value)\" style=\"cursor: pointer\" title=\"צפייה בקובץ\" class=\"name\"></md-icon><label>\n{{image.DisplayName}}</label><input ng-disabled=\"vm.isClicked\" ngf-select=\"vm.uploadFile($file,image)\" \nplaceholder=\"{{image.FileName}}\" ng-model=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" style=\"cursor: pointer\" \nreadonly=\"readonly\"></md-input-container></div></div><md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" \nng-click=\"vm.updateAdminImageSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content>\n</div>");
$templateCache.put("app/main/pages/settings-menue/views/external-registrations-settings/tabs/links.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getExternalSettings()\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">לינקים להצגה באתר ההרשמות החיצוני</span></div><md-content class=\"content md-padding\"><form \nname=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><label>קישור פורטל תשלומים</label><md-icon md-svg-icon=\"link-variant\"></md-icon><input \nng-model=\"vm.externalEvent.Portal\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>קישור אתר ראשי</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Website\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>קישור יצירת קשר</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Contact\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>קישור אתר תרומות</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.Donate\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>כותרת ראשית אתר</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.MainTitle\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>כותרת משנית אתר</label><md-icon \nmd-svg-icon=\"link-variant\"></md-icon><input ng-model=\"vm.externalEvent.SubTitle\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><md-button ng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן פרטים\" \nng-click=\"vm.updateExternalSettings()\">עדכן</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/external-registrations-settings/tabs/terms.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getExternalSettings()\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">תנאי השימוש יופיע במערכת הרישום החיצוני</span></div><md-content class=\"content md-padding\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.externalEvent\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><form name=\"upgradeGradeForm\" class=\"md-inline-form\" \nng-show=\"vm.externalEvent\" validate><div class=\"row quill-editor\" layout=\"row\"><ng-quill-editor format=\"text\" \nng-model=\"vm.externalEvent.Terms\" on-editor-created=\"$root.editorCreated(editor,\'Terms\')\"></ng-quill-editor></div>\n<md-button type=\"submit\" ng-disabled=\"!vm.externalEvent.Terms || vm.isClicked\" class=\"md-raised md-accent\" \nng-click=\"vm.updateExternalSettings()\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/event-management.html","<div id=\"event-management\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><a \nng-click=\"updateImage()\" class=\"cp smmb20\"><img style=\"background: gainsboro\" class=\"profile-image avatar huge smml0\" \nng-src=\"{{event.Image ? event.Image : \'\'}}\"></a><div><div class=\"hsf13 small-name smm0a\">{{activeModule.singleTitle}}\n</div><div class=\"name smmt20\">{{event.Name}} <span ng-if=\"event.EventType == 1\">(אירוע הרשמה חיצוני)</span></div>\n</div></div><div class=\"actions smmt20\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"generateFastLink()\" class=\"md-raised md-primary\"><md-icon md-font-icon=\"icon-link\"></md-icon>העתק קישור\n</md-button></div></div><div class=\"content\" flex><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!event\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-tabs md-dynamic-height \nid=\"event-management-tab\" ng-if=\"event\"><md-tab ng-disabled=\"$root.isEdit && selectedTab!=0\" md-on-select=\"setTab(0)\">\n<md-tab-label><span>כללי</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/general/general.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab \nng-disabled=\"($root.isEdit && selectedTab!=1) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(1)\"><md-tab-label><span>תשלום</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/payments/payments.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1\" \nng-disabled=\"($root.isEdit && selectedTab!=2) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(2)\"><md-tab-label><span>שיוכים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/association/association.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1\" \nng-disabled=\"($root.isEdit && selectedTab!=3) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(3)\"><md-tab-label><span>קבצים</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==3\" ng-include=\"\'app/main/pages/events/views/events/event-management/tabs/files/files.html\'\">\n</md-content></md-tab-body></md-tab><md-tab \nng-disabled=\"($root.isEdit && selectedTab!=4) || $root.AdminLevel==1 || (! $root.User.EditQuestions && $root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(4)\"><md-tab-label><span>שאלות</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==4\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/questions/questions.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"!event.IsProduct\" \nng-disabled=\"($root.isEdit && selectedTab!=5 ) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(5)\"><md-tab-label><span>הסעות</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==5\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/transportation/transportation.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"event.LocationID && !event.IsProduct\" \nng-disabled=\"($root.isEdit && selectedTab!=6 ) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(6)\"><md-tab-label><span>אולם</span></md-tab-label><md-tab-body><md-content ng-if=\"selectedTab==6\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/location/location.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1 && !event.IsProduct\" \nng-disabled=\"($root.isEdit && selectedTab!=7) || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-on-select=\"setTab(7)\"><md-tab-label><span>הנחות</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==7\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/discounts.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=8\" md-on-select=\"setTab(8)\"><md-tab-label>\n<span>נרשמים</span></md-tab-label><md-tab-body><md-content ng-if=\"selectedTab==8\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/subscribers/subscribers.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"($root.isEdit && selectedTab!=9 ) || $root.AdminLevel!= 3\" \nmd-on-select=\"setTab(9)\"><md-tab-label><span>סטטיסטיקה</span></md-tab-label><md-tab-body><md-content \nng-if=\"selectedTab==9\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/statistics/statistics.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1 && !event.IsProduct\" \nng-disabled=\"($root.isEdit && selectedTab!=10 ) || $root.AdminLevel!= 3\" md-on-select=\"setTab(10)\"><md-tab-label><span>\nהצעות רכישה</span></md-tab-label><md-tab-body><md-content ng-if=\"selectedTab==10\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/suggestions/suggestions.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"event.EventType != 1 && !event.IsProduct && event.RepeatType > 0\" \nng-disabled=\"$root.isEdit && selectedTab!=11\" md-on-select=\"setTab(11)\"><md-tab-label><span>שעות פעילות</span>\n</md-tab-label><md-tab-body><md-content style=\"min-height: 460px\" ng-if=\"selectedTab==11\" \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/meeting-days/meeting-days.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/events/views/events/new-event-dialog/new-event-dialog.html","<md-dialog class=\"new-Event-dialog\" aria-label=\"New Task\" style=\"overflow: visible !important\" ng-init=\"init();\"><form \nname=\"newEventForm\" ng-if=\"activeModule\" data-ng-model=\"newEventForm\" class=\"md-inline-form\" validate \nstyle=\"overflow: visible !important\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת {{activeModule.singleTitle}} חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"overflow: visible !important\"><md-input-container class=\"md-icon-float md-block\" ng-if=\"activeModule.external\">\n<md-icon md-font-icon=\"icon-filter\"></md-icon><label></label><md-select ng-model=\"newEvent.EventType\" \nplaceholder=\"מקום הצגה\" ng-disabled=\"isClicked\"><md-option ng-value=\"0\" ng-if=\"!externalOnly\">פורטל הורים</md-option>\n<md-option ng-value=\"1\">אתר הרשמה ציבורי</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-weather-sunny\"></md-icon><label>\nיצירת {{activeModule.singleTitle}}</label><md-select ng-model=\"newEvent.DuplicateEventSelect\" placeholder=\"סוג אירוע\" \nng-disabled=\"isClicked\"><md-option ng-value=\"1\">{{activeModule.singleTitle}} חדש</md-option><md-option ng-value=\"2\">\nשכפול {{activeModule.singleTitle}} קיים</md-option><md-option ng-value=\"3\" ng-show=\"activeModule.name != \'Products\'\">\nמוצר חדש</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" \nng-show=\"newEvent.DuplicateEventSelect==2\"><label>אירוע לשכפול</label><md-icon md-svg-icon=\"weather-sunny\"></md-icon>\n<md-select md-on-close=\"clearSearchTerm()\" ng-model=\"newEvent.DuplicateEvent\" ng-change=\"setName()\" \nng-disabled=\"!events || isClicked\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" \ntype=\"text\" ng-disabled=\"!events || isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש אירוע..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!events ||isClicked\"><md-option ng-value=\"event\" ng-repeat=\"event in events |filter:searchTerm\">\n{{event.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-weather-sunny\"></md-icon><label>שם</label>\n<input ng-model=\"newEvent.Name\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\" ng-if=\"newEvent.DuplicateEventSelect==1\"><label>\nשיוך לקטגוריה</label><md-icon md-svg-icon=\"apps\"></md-icon><md-select ng-model=\"newEvent.CategoryID\" \nplaceholder=\"שיוך לקטגוריה\" ng-required=\"newEvent.DuplicateEventSelect==1\" ng-disabled=\"isClicked || !categories\">\n<md-option ng-repeat=\"category in categories\" ng-value=\"category.ID\">{{category.Path.join(\' › \')}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\" \nng-if=\"newEvent.DuplicateEventSelect==1 && activeModule.name != \'Products\'\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><label>תאריך התחלה</label><div locale=\"he\" format=\"DD/MM/YYYY HH:mm\" \nmoment-picker=\"newEvent.StartDate\" change=\"validateDates()\"><input autocomplete=\"off\" ng-model=\"newEvent.StartDate\" \nng-required=\"activeModule.generalEventType != \'Products\'\" ng-disabled=\"isClicked\"></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\" \nng-if=\"newEvent.DuplicateEventSelect==1 && activeModule.name != \'Products\'\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" format=\"DD/MM/YYYY HH:mm\" \nmoment-picker=\"newEvent.EndDate\" change=\"validateDates()\"><label>תאריך סיום</label><input autocomplete=\"off\" \nng-model=\"newEvent.EndDate\" ng-disabled=\"isClicked\" ng-required=\"activeModule.generalEventType != \'Products\'\"></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\" \nng-show=\"newEvent.DuplicateEventSelect==1 && activeModule.name != \'Products\'\"><md-icon md-font-icon=\"icon-bank\">\n</md-icon><label></label><md-select ng-model=\"newEvent.LocationID\" placeholder=\"בחירת אולם\" ng-disabled=\"isClicked\">\n<md-option ng-repeat=\"location in locations\" ng-value=\"location.ID\">{{location.Name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\" ng-show=\"title==\'אירוע\'\"><md-icon \nmd-font-icon=\"icon-city\" class=\"name\"></md-icon><label>סוג אירוע</label><md-select ng-model=\"newEvent.EventTypeName\" \nplaceholder=\"סוג אירוע\"><md-option ng-value=\"1\">תנועה</md-option><md-option ng-value=\"2\">חברתי</md-option><md-option \nng-value=\"0\">אחר</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" ng-show=\"title==\'אירוע\'\"><md-icon md-font-icon=\"icon-city\" class=\"name\">\n</md-icon><md-select ng-model=\"newEvent.ExposeToExternalOrganization\"><md-option ng-value=\"0\">אירוע פנימי</md-option>\n<md-option ng-value=\"1\">אירוע חשוף</md-option></md-select></md-input-container><md-input-container \nng-if=\"newEvent.ExposeToExternalOrganization === 1\" class=\"md-icon-float md-block md-icon-left\"><label>תנועת נוער\n</label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-contact-chips ng-model=\"newEvent.exposedOrganizations\" \nmd-contacts=\"organizationsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר תנועות נוער\"></md-contact-chips></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"newEvent.DuplicateEventSelect==2 && activeModule.name != \'Products\'\"><md-checkbox\n md-no-ink ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"newEvent.duplicateAllFields\" class=\"md-primary\">\nשכפול כל השדות</md-checkbox></md-input-container><md-input-container class=\"md-icon-float md-block\" \nng-if=\"!newEvent.duplicateAllFields && newEvent.DuplicateEventSelect==2 && activeModule.name != \'Products\'\"><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><md-select aria-label=\"שדות לשכפול\" ng-model=\"newEvent.fieldsToDuplicate\" \nmultiple=\"multiple\" placeholder=\"שדות לשכפול\"><md-optgroup ng-repeat=\"group in fieldsToDuplicate\" \nlabel=\"{{group.groupLabel}}\"><md-option ng-repeat=\"field in group.fields\" ng-value=\"field.fieldName\">\n{{field.displayName}}</md-option></md-optgroup></md-select></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newEventForm.$invalid || isClicked || !validateDates(true)\" type=\"submit\" ng-click=\"saveNewEvent()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/new-multiple-registrations-dialog/new-multiple-registrations-dialog.html","<md-dialog class=\"new-multiple-registration-dialog\" aria-label=\"New Task\" \nstyle=\"width: 600px; max-width: 95vw; height: fit-content\" ng-init=\"init();\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">עגלת קניות</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>פרטי המאורעות\n</span></md-tab-label><md-tab-body><md-content class=\"about-tab\"><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"start center\"><table id=\"events-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">כמות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"event in eventNamesAndQuantities\"><td>{{event.Name}}</td><td>{{event.Quantity}}</td></tr></tbody></table>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"moveToNextStep()\" class=\"send-button md-accent md-raised\" \naria-label=\"Add Task\">המשך</md-button></div></md-dialog-actions></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>פרטי משתתף</span></md-tab-label><md-tab-body><md-content class=\"about-tab\"><form \nname=\"newRegistrationPart1Form\" data-ng-model=\"newRegistrationForm\" class=\"md-inline-form\" validate><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>\nשם פרטי</label><input ng-model=\"newRegistration.FirstName\" required ng-blur=\"userValidation()\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה\n</label><input ng-model=\"newRegistration.LastName\" required ng-blur=\"userValidation()\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon><label>אימייל</label>\n<input ng-model=\"newRegistration.UserEmail\" required type=\"email\" ng-blur=\"userValidation()\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cellphone\" class=\"name\"></md-icon><label>טלפון</label>\n<input ng-model=\"newRegistration.UserPhoneNumber\" required ng-blur=\"userValidation()\"></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"!userValidation()\" ng-click=\"getPrice()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">המשך</md-button></div></md-dialog-actions></form>\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"!newRegistration.UserPhoneNumber\"><md-tab-label><span>תשלום\n</span></md-tab-label><md-tab-body><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!items\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"total-price\" \nng-class=\"{\'fcred\':!getTotalAmountsValidity()}\">סכום כללי לחיוב:{{newRegistration.NewPrice}}</div><md-content \nclass=\"payments-tab\" style=\"height: 500px\" ng-show=\"items\"><form class=\"md-inline-form\" validate \nname=\"newRegistrationPart2Form\"><div class=\"separate-block\" ng-class=\"{\'paid\':payment.ReceiptID != \'\'}\" \nng-repeat=\"payment in payments\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon>\n<label>שם לקבלה</label><input ng-model=\"payment.Name\" disabled=\"disabled\" required></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><label>מייל לשליחת קבלה</label><input ng-model=\"payment.Email\" \ntype=\"email\" disabled=\"disabled\" required></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\" \nng-if=\"payment.Type != 11 || (payment.Type == 11 && event.ExtraPrice > 0)\"><md-input-container \nclass=\"md-block md-icon-left\"><md-icon md-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום לחיוב</label>\n<input ng-model=\"payment.Amount\" type=\"number\" ng-change=\"payment.Type == 1 && checkIfNoCharge($index)\" \nng-disabled=\"isClicked || payment.Name == \'\' || payment.Email == \'\' || payment.ReceiptID != \'\' || ($root.AdminLevel<3 && !$root.User.Payments)\" \nng-model-options=\"{debounce: 750}\" min=\"1\" max=\"{{event.NewPrice? event.NewPrice : event.Price}}\" required>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container \nclass=\"md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>אמצעי תשלום</label><md-select \nng-required=\"true\" ng-model=\"payment.Type\" \nng-disabled=\"isClicked || !items || event.NewPrice==0 || event.Price==0 || payment.Name == \'\' || payment.Email == \'\' || payment.ReceiptID != \'\'\" \nng-change=\"checkIfNoCharge($index)\" placeholder=\"אמצעי תשלום\"><md-option \nng-if=\"event.NewPrice == 0 || event.Price == 0\" ng-value=\"0\" ng-disabled=\"$root.User.EventsPay\" \nng-selected=\"event.NewPrice==0 || event.Price==0\">ללא חיוב</md-option><md-option ng-value=\"1\" \nng-if=\"!(activeModule.monthlyPayment && event.MonthlyPayment)\">אשראי</md-option><md-option \nng-if=\"payments.length == 1 && event.MonthlyPayment && event.ExtraPrice\" ng-value=\"11\">הוראת קבע + חיוב מיידי\n</md-option><md-option ng-value=\"11\" \nng-if=\"payments.length == 1 && activeModule.monthlyPayment && event.MonthlyPayment && !event.ExtraPrice\">\nהוראת קבע אשראי</md-option><md-option ng-value=\"2\">מזומן</md-option><md-option ng-value=\"3\">העברה בנקאית</md-option>\n<md-option ng-value=\"4\" ng-if=\"$root.AdminLevel>=3 || $root.User.ChecksPer\">המחאה</md-option></md-select>\n</md-input-container></div></div><div ng-show=\"payment.Type==3\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל החשבון</label><input ng-model=\"payment.AccountName\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==3\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר בנק</label>\n<input ng-model=\"payment.BankNumber\" type=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==3\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר סניף</label><input ng-model=\"payment.BranchNumber\" \ntype=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==3\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר חשבון</label><input ng-model=\"payment.AccountNumber\" type=\"number\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==3\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"upload\" class=\"name\" \nng-class=\"{\'green600\':payment.FileReceipt,\'red600\':!payment.FileReceipt}\"></md-icon><input placeholder=\"העלאת אסמכתא\" \nng-value=\"payment.FileName\" name=\"file\" ngf-select=\"uploadFile($file,payment)\" ngf-pattern=\"\'image/*\'\" class=\"cp\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"md-block\"><md-icon class=\"name\"></md-icon><label>\nבנק</label><md-icon md-svg-icon=\"bank\" class=\"name\"></md-icon><md-select ng-model=\"payment.BrandAccountNumber\" \nng-disabled=\"!banks || isClicked || payment.ReceiptID != \'\'\"><md-option ng-repeat=\"bank in banks\" \nng-value=\"bank.Number\">{{bank.Name}}</md-option></md-select></md-input-container></div><div ng-show=\"payment.Type==4\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל הצ\'ק/ים\n</label><input ng-model=\"payment.CheckOwner\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר צ\'קים</label><input ng-model=\"payment.NumberOfCheck\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" type=\"number\" min=\"1\" ng-required=\"newRegistration.Type==4\" \nng-change=\"generateChecks($index)\"></md-input-container><div ng-repeat=\"check in payment.checks\" \nng-if=\"payment.checks.length\" layout=\"row\" layout-wrap flex=\"100\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>בנק\n</label><input ng-model=\"check.CheckBank\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר סניף</label><input ng-model=\"check.CheckBranch\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר חשבון</label><input ng-model=\"check.CheckAccountNumber\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר המחאה</label><input ng-model=\"check.CheckNumber\" type=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block md-icon-left\"><md-icon md-svg-icon=\"calendar\" class=\"name\">\n</md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"check.CheckMaturityDate\"><label>\nמועד פרעון</label><input ng-required=\"newRegistration.Type==4\" autocomplete=\"off\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-model=\"check.CheckMaturityDate\"></div></md-input-container></div>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום המחאה</label><input ng-model=\"check.CheckAmount\" \ntype=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==4\">\n</md-input-container></div></div></div><div><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cards-outline\" \nclass=\"name\"></md-icon><label>סטטוס תשלום</label><md-select ng-model=\"payment.PaymentStatus\" \nng-disabled=\"isClicked || ($root.AdminLevel<3 && !$root.User.Payments) || payment.paymentStatusDisabled\"><md-option \nng-value=\"1\">שולם</md-option><md-option ng-value=\"2\">שולם ל{{$root.User.Coordinator}}</md-option><md-option \nng-value=\"3\">טרם אושר</md-option><md-option ng-value=\"5\" ng-if=\"$root.advancedCashierOptions\">הופקד לקופה</md-option>\n<md-option ng-value=\"6\" ng-if=\"$root.advancedCashierOptions\">יצא להפקדה</md-option><md-option ng-value=\"7\" \nng-if=\"$root.advancedCashierOptions\">הופקד</md-option><md-option ng-value=\"0\">לא שולם</md-option></md-select>\n</md-input-container></div><div ng-if=\"payment.Type == 11 && event.ExtraPrice > 0\" class=\"fcred hfs13\">\nחיוב בפועל על המחיר הנוסף ({{event.ExtraPrice}}₪) יתבצע מיד בסיום ההרשמה</div><div class=\"iframe_container\" \nng-if=\"(payment.Type==1 || payment.Type == 11) && payment.iframe != \'\'\"><iframe src=\"{{trustSrc(payment.iframe)}}\" \nframeborder=\"0\"></iframe></div><div layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"payment.Type != undefined && checkChecksValidity(payment) &&\r\n                                                    ([1,11].indexOf(payment.Type) == -1 && payment.ReceiptID == \'\')\" \ndata-ng-disabled=\"newRegistrationPart2Form.$invalid\" ng-click=\"savePayment($index)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירת תשלום</md-button><md-button \nng-if=\"payment.Type != 11 && $index == payments.length - 1 && ($root.AdminLevel == 3 || $root.User.Payments)\" \nng-disabled=\"payment.ReceiptID == \'\' || getTotalAmountsValidity()\" ng-click=\"addPaymentMissingPrice()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">פצל תשלום</md-button><md-button \nng-if=\"payments.length != 1 && ($root.AdminLevel == 3 || $root.User.Payments)\" \nng-disabled=\"payment.ReceiptID != \'\' || payment.RegistrationID != \'\'\" ng-click=\"removePayment($index)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">מחק תשלום</md-button></div></div><div class=\"mt50\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"power\" class=\"name\"></md-icon><label>סטטוס הרשמה</label>\n<md-select ng-model=\"newRegistration.Status\" ng-disabled=\"isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\" \nng-init=\"newRegistration.Status=1\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" \nng-show=\" newRegistration.Type!=1\"><md-button \ndata-ng-disabled=\"newRegistrationPart2Form.$invalid || isClicked || !paymentsValidity() || payments.length == 0\" \ntype=\"submit\" ng-click=\"saveNewRegistration()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button></div></form></md-content></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/field-panel/field-panel.html","<md-content ms-scroll><form name=\"fieldForm\" id=\"fieldForm\" data-ng-model=\"fieldForm\" class=\"md-inline-form\" validate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת שדה</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-question-mark-circle\">\n</md-icon><label>תיאור שדה</label><textarea ng-model=\"field.Title\" type=\"text\"></textarea></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-format-align-right\"></md-icon><label>סוג שדה</label>\n<md-select ng-model=\"field.Type\" placeholder=\"סוג שדה\"><md-option \nng-selected=\"field.AnswerType==1 || field.AnswerType==\'1\'\" ng-value=\"1\">שאלה פתוחה</md-option><md-option \nng-selected=\"field.AnswerType==2 || field.AnswerType==\'2\'\" ng-value=\"2\">אפשרויות</md-option><md-option \nng-selected=\"field.AnswerType==3 || field.AnswerType==\'3\'\" ng-value=\"3\">תאריך</md-option><md-option \nng-selected=\"field.AnswerType==4 || field.AnswerType==\'4\'\" ng-value=\"4\">קובץ</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>\nהאם להציג בפרופיל</label><md-select ng-model=\"field.ShowInProfile\" placeholder=\"האם להציג בפרופיל\" ng-required=\"true\" \nng-disabled=\"isClicked\"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"field.Type==2\"><md-icon md-font-icon=\"\"></md-icon>\n<label>אפשרויות</label><md-chips ng-model=\"field.Values\" readonly=\"false\" md-removable=\"true\"></md-chips>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-model=\"field.Required\" \nng-disabled=\"isClicked\" ng-true-value=\"1\" ng-false-value=\"0\">שדה חובה</md-checkbox></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select \nng-model=\"field.Status\" placeholder=\"סטטוס\"><md-option ng-selected=\"field.Status==0 || field.Status==\'0\'\" ng-value=\"0\">\nלא פעיל</md-option><md-option ng-selected=\"field.Status==1 || field.Status==\'1\'\" ng-value=\"1\">פעיל</md-option>\n</md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/events/views/events/new-single-registration-info-dialog/new-single-registration-info-dialog.html","<md-dialog class=\"newSingeRegistration-dialog\" aria-label=\"New Task\" ng-init=\"init();\" \nstyle=\"width: 600px; max-width: 95vw; height: fit-content\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הזמנה מהירה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog(false)\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"dataFetched < 3\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"content\" flex><div layout=\"row\" layout-wrap ng-show=\"dataFetched == 3\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"50\"><md-icon \nmd-font-icon=\"icon-numeric\" class=\"name\"></md-icon><label>כמות</label><input ng-model=\"quantity\" \nng-disabled=\"isClicked\" required type=\"number\" min=\"1\"></md-input-container></div><md-button type=\"submit\" \nng-if=\"dataFetched  == 3 && questions.length == 0 && transportation.length == 0 && !(location && location.Layout.length > 0)\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"moveToNextStep(2)\">המשך</md-button><md-tabs md-dynamic-height \nmd-selected=\"selectedTab\" ng-if=\"dataFetched == 3\"><md-tab ng-if=\"questions.length>0\"><md-tab-label><span>שאלות</span>\n</md-tab-label><md-tab-body><form name=\"quetionsForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap \nng-repeat=\"question in questions\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" ng-if=\"question.AnswerType!=3\"><md-icon style=\"cursor: pointer\" md-svg-icon=\"help-circle\" class=\"name\">\n</md-icon><label ng-if=\"question.AnswerType != 5\">{{question.Description}}</label><input \nng-if=\"question.AnswerType==1\" ng-model=\"question.Answer\" ng-disabled=\"isClicked\" \nng-blur=\"autocompleteQuestions(question)\" ng-required=\"question.Required\"><md-select ng-if=\"question.AnswerType==2\" \nng-model=\"question.Answer\" ng-disabled=\"isClicked\" ng-required=\"question.Required\"><md-option \nng-repeat=\"questionOption in question.Options\" ng-value=\"questionOption\">{{questionOption}}</md-option></md-select><div\n ng-if=\"question.AnswerType==4\" start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"question.Answer\"><input\n autocomplete=\"off\" ng-model=\"question.Answer\" ng-disabled=\"isClicked\" ng-required=\"question.Required\"></div>\n<md-checkbox ng-if=\"question.AnswerType == 5\" ng-required=\"question.Required\" ng-true-value=\"true\" \nng-false-value=\"false\" ng-model=\"question.Answer\">{{question.Description}}</md-checkbox></md-input-container></div>\n<md-button type=\"submit\" ng-disabled=\"quetionsForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"moveToNextStep(0)\">המשך</md-button></form></md-tab-body></md-tab><md-tab ng-if=\"transportation.length>0\">\n<md-tab-label><span>הסעות</span></md-tab-label><md-tab-body><form name=\"TransportationForm\" class=\"md-inline-form\" \nvalidate><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\">\n</md-icon><label>הסעה הלוך</label><md-select ng-model=\"selectedTransportation.SelectedTransportationTo\"><md-option \nng-repeat=\"transportationItem in transportation\" ng-value=\"transportationItem\" ng-if=\"transportationItem.Way==1\">\n{{transportationItem.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>תחנה הלוך</label><md-select \nng-model=\"selectedTransportation.SelectedTransportationStopTo\" \nng-disabled=\"!selectedTransportation.SelectedTransportationTo\"><md-option \nng-repeat=\"stop in selectedTransportation.SelectedTransportationTo.Stops\" ng-value=\"stop\">{{stop.Name}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>הסעה חזור</label><md-select \nng-disabled=\"isClicked\" ng-model=\"selectedTransportation.SelectedTransportationFrom\"><md-option \nng-repeat=\"transportationItem in transportation\" ng-if=\"transportationItem.Way==2\" ng-value=\"transportationItem\">\n{{transportationItem.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>תחנה חזור</label><md-select \nng-model=\"selectedTransportation.SelectedTransportationStopFrom\" \nng-disabled=\"!selectedTransportation.SelectedTransportationFrom\"><md-option \nng-repeat=\"stop in selectedTransportation.SelectedTransportationFrom.Stops\" ng-value=\"stop\">{{stop.Name}}</md-option>\n</md-select></md-input-container></div><md-button type=\"submit\" ng-disabled=\"TransportationForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"moveToNextStep(1)()\">המשך</md-button></form></md-tab-body>\n</md-tab><md-tab ng-if=\"location && location.Layout.length > 0\"><md-tab-label><span>בחירת מקום</span></md-tab-label>\n<md-tab-body><div class=\"md-inline-form\"><div layout=\"row\" layout-wrap><div id=\"row-seats-layout\" class=\"sflex fdc\">\n<div id=\"section-seats-layout\" class=\"sflex fdc jcc mt10\" ng-repeat=\"section in location.layout track by $index\"><div \nclass=\"center hfs18 fw-bold\">איזור {{section.Name}}</div><div ng-repeat=\"row in section.Rows track by $index\" \nclass=\"fcc\"><div>שורה {{row.Name}}</div><div ng-repeat=\"seat in row.Seats track by $index\" class=\"seat center fcc cp\" \nng-class=\"{\'free\': !seat.taken, \'taken\': seat.taken,\'reserved\': seat.reserved, \'notAvailable\': seat.notAvailable}\" \nng-click=\"!seat.taken && !seat.notAvailable && saveSeat(section.ID,row.ID,seat.ID); seat.reserved = true\"><span>\n{{seat.Name}}</span></div></div></div></div></div><md-button type=\"submit\" ng-disabled=\"locationForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"moveToNextStep(2)\">המשך</md-button></div></md-tab-body></md-tab>\n</md-tabs></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/settings-menue/views/categories/category-panel/category-panel.html","<md-content ms-scroll ng-init=\"getTerminals()\"><form name=\"categoryForm\" id=\"categoryForm\" \ndata-ng-model=\"categoryForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת קטגוריה</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-input-container class=\"md-icon-float md-block\">\n<md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><label>שם הקטגוריה</label><input ng-model=\"category.Name\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-format-align-right\"></md-icon><label>תיאור</label><textarea ng-model=\"category.Description\" \ntype=\"text\"></textarea></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-format-color\"></md-icon><label>שם לתצוגה בפרופיל הורה</label><textarea \nng-model=\"category.ProfileDisplayName\" type=\"text\"></textarea></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-format-color\"></md-icon><label>\nשם לתצוגה באתר הרשמות חיצוניות</label><textarea ng-model=\"category.ExternalDisplayName\" type=\"text\"></textarea>\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon><label>מיילים לקבלת בקשות ביטול</label><md-chips ng-model=\"category.CancelEmails\" \nreadonly=\"false\" md-removable=\"true\"></md-chips></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" ng-if=\"category.topLevel == null && terminalManagement\"><md-icon \nmd-font-icon=\"icon-power\"></md-icon><label>מסוף סליקה</label><md-select ng-model=\"category.TerminalID\" \nplaceholder=\"מסוף סליקה\" ng-disabled=\"$root.AdminLevel<3\"><md-option ng-value=\"null\">בחירת מסוף</md-option><md-option \nng-repeat=\"terminal in terminals\" ng-value=\"terminal.ID\">{{terminal.Name}}</md-option></md-select></md-input-container>\n</form></md-content>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/birthday.html","<div flex=\"100\" flex-xs=\"100\" class=\"fields-settings birthday-settings\" ng-init=\"vm.getSystemBirthdaySettings()\">\n<md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\">\n</md-icon><span class=\"title\">ניתן להגדיר שליחת ברכת יום הולדת בצורה אוטמטית לחניכים</span></div><md-content \nclass=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><label>סטטוס</label><md-select ng-model=\"vm.birthdaySettings.Status\" \nng-required=\"true\" ng-disabled=\"!vm.birthdaySettings || vm.isClicked \"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><label>כותרת להצגה בתבנית</label><textarea \nng-disabled=\"!vm.updateSystemBirthdaySettings || vm.isClicked \" ng-model=\"vm.birthdaySettings.Title\"></textarea>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>תוכן להצגה בתבנית\n</label><textarea ng-disabled=\"!vm.updateSystemBirthdaySettings || vm.isClicked \" ng-model=\"vm.birthdaySettings.Body\">\n</textarea></md-input-container></div><md-button ng-disabled=\"vm.isClicked || upgradeGradeForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"עדכן שכבה\" ng-click=\"vm.updateSystemBirthdaySettings()\" \nstyle=\"margin-right: 0px\">עדכן</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/fields-dy.html","<div flex=\"100\" flex-xs=\"100\" class=\"fields-settings\" ng-init=\"vm.fetchAllExtraStudentFields();\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">ניתן להגדיר שדות נוספים ברישום חניכים למערכת</span></div><md-content class=\"content md-padding\">\n<form name=\"emailsForm\" class=\"md-inline-form\" validate><div class=\"row form\" layout=\"row\"><div class=\"content table\">\n<div ng-if=\"vm.extraStudentFields\" class=\"events-table-c\"><table id=\"fields-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nשאלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג שאלה</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" ng-repeat=\"field in vm.extraStudentFields  \"><td>{{field.Title}}</td><td>\n{{vm.extraFieldType(field.Type)}}</td><td>{{field.Status==1 || field.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>\n<md-button class=\"preview-user\" ng-click=\"vm.editField(field)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div><md-button ng-disabled=\"vm.isClicked\" \nclass=\"md-raised md-accent\" ng-click=\"vm.openNewFieldDialog()\">שדה חדש</md-button></form></md-content></md-content>\n</div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/fields.html","<div flex=\"100\" flex-xs=\"100\" class=\"fields-settings\" ng-init=\"vm.fetchAllStudentFields()\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">ניתן להגדיר את שדות החובה ברישום משתמש למערכת ולהוסיף שדות נוספים בצורה דינמית</span></div>\n<md-content class=\"content md-padding\"><form name=\"emailsForm\" class=\"md-inline-form\" validate><label \nclass=\"header-title\">שדות חובה</label><div class=\"row form\" layout=\"row\"><div class=\"content\"><div layout-wrap=\"\" \nlayout-gt-md=\"row\"><div class=\"fdc sflex bottom-border\" flex-gt-md=\"30\" ng-repeat=\"field in vm.studentfields\"><label \nclass=\"fw-medium hfs18\">{{field.he_title}}</label><div class=\"sflex aic jcfs\"><md-input-container style=\"width: 100%\">\n<md-checkbox ng-model=\"field.required\" data-ng-disabled=\"vm.mandatoryStudentFields.includes(field.name)\" \naria-label=\"{{field.he_title}}\">חניך</md-checkbox></md-input-container><md-input-container style=\"width: 100%\">\n<md-checkbox ng-model=\"field.requiredForParent\" data-ng-disabled=\"vm.mandatoryStudentFields.includes(field.name)\" \naria-label=\"{{field.he_title}}\">הורה</md-checkbox></md-input-container></div></div></div></div></div><md-button \nng-disabled=\"vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateStudentFields()\" style=\"margin-right: 0px\">\nעדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/forms.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getEmails();vm.getProfileSettings();\" class=\"forms-settings\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">ניתן להגדיר כתובת מייל שקיבלו עדכון על כל פניה מכל טופס בפרופיל הורה בנוסך, הפניות יופיעו גם בתוכנה\n</span></div><md-content class=\"content md-padding\"><form name=\"emailsForm\" class=\"md-inline-form\" validate><label \nclass=\"header-title\">כתובת מיילים</label><div layout=\"row\" layout-wrap ng-repeat=\"setting in vm.settings\" \nng-if=\"setting.DisplayName!=\'סוגי פניות מהפרופיל\' && vm.settingsReady && setting.Property != \'ContactText\'\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\"><label>\n{{setting.DisplayName}}</label><md-chips ng-model=\"setting.Value\" readonly=\"false\" md-removable=\"true\"></md-chips>\n</md-input-container></div><label class=\"header-title\">סוגי פניות</label><div layout=\"row\" layout-wrap \nng-repeat=\"setting in vm.settings\" ng-if=\"setting.DisplayName==\'סוגי פניות מהפרופיל\' && vm.settingsReady\">\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\"><label>\n{{setting.DisplayName}}</label><md-chips ng-model=\"setting.Value\" readonly=\"false\" md-removable=\"true\"></md-chips>\n</md-input-container></div><label class=\"header-title\">טפסים</label><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\"><label>טקסט בקשה לביטול הרשמה\n</label><textarea ng-model=\"vm.profile.CancelFormText.Value\" ng-disabled=\"vm.isClicked\"></textarea>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\"><label>בקשות לביטול</label><md-select \nng-model=\"vm.profile.CancelEvents.Value\" ng-disabled=\"vm.isClicked\"><md-option ng-value=\"1\">פעיל</md-option><md-option \nng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap \ndata-ng-if=\"false\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-gt-sm=\"50\"><label>טופס סיבסוד</label><md-select ng-model=\"vm.profile.SubsidyForm.Value\" \nng-disabled=\"vm.isClicked\"><md-option ng-value=\"0\">ללא</md-option><md-option ng-value=\"1\">תבנית 1</md-option><md-option\n ng-value=\"2\">תבנית 2</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\"><label>\nטקסט בצור קשר</label><textarea ng-model=\"vm.profile.ContactText.Value\" ng-disabled=\"vm.isClicked\"></textarea>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\"><md-icon ng-if=\"!vm.profile.DefaultHealthDeclaration.Value\" \nng-click=\"vm.updateHealthDeclaration(vm.profile.DefaultHealthDeclaration)\" md-svg-icon=\"upload\" class=\"name\"></md-icon>\n<md-icon ng-disabled=\"vm.isClicked\" ng-if=\"vm.profile.DefaultHealthDeclaration.Value\" md-svg-icon=\"eye\" \nclass=\"cp name\" ng-click=\"vm.viewFile(vm.profile.DefaultHealthDeclaration.Value)\" title=\"צפייה בקובץ\"></md-icon><label>\nטופס הצהרת בריאות</label><input class=\"cp\" ng-disabled=\"vm.isClicked\" \nng-model=\"vm.profile.DefaultHealthDeclaration.Value\" disabled=\"disabled\" readonly=\"readonly\"></md-input-container>\n</div><md-button ng-disabled=\"vm.isClicked || emailsForm.$invalid\" class=\"md-raised md-accent\" \nng-click=\"vm.updateSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/profile-popup-alert.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getProfilePopUpAlert()\"><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">הודעת פרופיל אשר תוצג לכלל ההורים פעם אחת</span></div><md-content class=\"content md-padding\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.profilePopUpAlert\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><form name=\"upgradeGradeForm\" class=\"md-inline-form\" \nng-show=\"vm.profilePopUpAlert\" validate><div class=\"row quill-editor amit\" layout=\"row\" id=\"onetTimePopup\">\n<ng-quill-editor format=\"text\" ng-model=\"vm.profilePopUpAlert.Name\" \non-editor-created=\"$root.editorCreated(editor,\'popupAlert\')\"></ng-quill-editor></div><md-button type=\"submit\" \nng-disabled=\"!vm.profilePopUpAlert.Name || vm.isClicked\" class=\"md-raised md-accent\" \nng-click=\"vm.updateProfilePopUpAlert()\">עדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/profile-settings/tabs/terms.html","<div flex=\"100\" flex-xs=\"100\" ng-init=\"vm.getTerms()\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div \nclass=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon><span class=\"title\">\nתנאי השימוש יופיע בפרופיל ההורה ויוצגו גם בסוף תהליך הרישום</span></div><md-content class=\"content md-padding\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.terms\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><form name=\"upgradeGradeForm\" class=\"md-inline-form\" \nng-show=\"vm.terms\" validate><div class=\"row quill-editor\" layout=\"row\"><ng-quill-editor format=\"text\" \nng-model=\"vm.terms.Name\" on-editor-created=\"$root.editorCreated(editor,\'terms\')\"></ng-quill-editor></div><md-button \ntype=\"submit\" ng-disabled=\"!vm.terms.Name || vm.isClicked\" class=\"md-raised md-accent\" ng-click=\"vm.updateTerms()\">\nעדכון</md-button></form></md-content></md-content></div>");
$templateCache.put("app/main/pages/settings-menue/views/categories/new-category-dialog/new-category-dialog.html","<md-dialog class=\"newCategory-dialog\" aria-label=\"New Task\"><form name=\"newCategoryForm\" \ndata-ng-model=\"newQuestionForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nיצירת קטגוריה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-weather-sunny\"></md-icon><label>שם הקטגוריה</label><input \nng-model=\"newCategory.Name\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" ng-if=\"newCategory.ParentCategoryName\"><md-icon \nmd-font-icon=\"icon-weather-sunny\"></md-icon><label>שיוך לקטגוריה</label><input \nng-model=\"newCategory.ParentCategoryName\" type=\"text\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><label>תיאור הקטגוריה\n</label><textarea ng-model=\"newCategory.Description\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newCategoryForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNewCategory()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/settings-menue/views/locations/location-management/location-management.html","<div id=\"location-management\" class=\"page-layout simple tabbed\" ng-controller=\"LocationManagementController as vm\" \nng-init=\"vm.init()\"><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between end\"><div class=\"user-info\" layout=\"column\" layout-align=\"center center\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div><div class=\"hsf13 small-name\">אולם</div><div class=\"name\">\n{{vm.location.Name}}</div></div></div></div><div class=\"content\" flex><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!vm.location\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><md-tabs md-dynamic-height id=\"location-management-tab\" ng-if=\"vm.location\"><md-tab \nng-disabled=\"$root.isEdit && selectedTab!=0\" md-on-select=\"setTab(0)\"><md-tab-label><span>כללי</span></md-tab-label>\n<md-tab-body><md-content \nng-include=\"\'app/main/pages/settings-menue/views/locations/location-management/tabs/general/general.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"vm.location.IsRoom == 0\" \nng-disabled=\"$root.isEdit && selectedTab!=1\" md-on-select=\"setTab(1)\"><md-tab-label><span>איזורים</span></md-tab-label>\n<md-tab-body><md-content \nng-include=\"\'app/main/pages/settings-menue/views/locations/location-management/tabs/sections/sections.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=2\" md-on-select=\"setTab(2)\">\n<md-tab-label><span>יומן</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/settings-menue/views/locations/location-management/tabs/daybook/book.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=3\" md-on-select=\"setTab(3)\"><md-tab-label>\n<span>שעות פתיחה</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/settings-menue/views/locations/location-management/tabs/workingHours/working-hours.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/locations/new-location-dialog/new-location-dialog.html","<md-dialog class=\"newLocation-dialog\" aria-label=\"New Task\" ng-init=\"getSettlements()\"><form name=\"newLocationForm\" \ndata-ng-model=\"newLocationForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nיצירת אולם חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-weather-sunny\"></md-icon><label>שם האולם</label><input \nng-model=\"newLocation.Name\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><label>\nתיאור האולם</label><textarea ng-model=\"newLocation.Description\" type=\"text\" ng-disabled=\"isClicked\"></textarea>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><label>מיקום האולם</label><textarea ng-model=\"newLocation.Location\" \ntype=\"text\" ng-disabled=\"isClicked\"></textarea></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"row\" flex=\"100\"><label>{{$root.orgTypeBranchName.single}}</label><md-icon md-font-icon=\"icon-domain\"></md-icon>\n<md-select ng-model=\"newLocation.SettlementID\" id=\"SettlementID\" ng-disabled=\"!settlements || isClicked\" \nrequired=\"true\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.orgTypeBranchName.plural}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"settlement in settlements | filter: searchTerm\" ng-value=\"settlement.ID\">{{settlement.Name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-weather-sunny\"></md-icon><label>חדר ללא הושבה</label><md-select ng-model=\"newLocation.IsRoom\" \nplaceholder=\"חדר ללא הושבה\" ng-disabled=\"isClicked\"><md-option value=\"0\">לא</md-option><md-option value=\"1\">כן\n</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newLocationForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewLocation()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/users/views/students/change-group-grade-dialog/change-group-grade-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\" ng-init=\"getSettlements();getGrades()\"><form \nname=\"updateGroupForm\" data-ng-model=\"updateGroupForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">שינוי {{$root.User.Grade}}\\{{$root.User.Group}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" ng-disabled=\"isClicked\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>מספר חניכים שנבחרו</label><input ng-value=\"changeForm.Students.length\" type=\"number\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" \nclass=\"name\"></md-icon><label>סוג שינוי</label><md-select ng-required=\"true\" ng-model=\"changeForm.Type\" \nplaceholder=\"סוג שינוי\" ng-disabled=\"isClicked\"><md-option value=\"2\">\nהעברת {{$root.orgTypeBranchName.single}}\\{{$root.User.Group}}</md-option><md-option value=\"3\">\nהעברת {{$root.User.Grade}} + העברת {{$root.User.Group}}/{{$root.orgTypeBranchName.single}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"changeForm.Type>=3\"><md-icon \nmd-font-icon=\"icon-chair-school\" class=\"name\"></md-icon><label>בחירת {{$root.User.Grade}}</label><md-select \nng-required=\"changeForm.Type>=3\" ng-model=\"changeForm.GradeID\" placeholder=\"בחירת {{$root.User.Grade}}\" \nng-disabled=\"isClicked || !grades\"><md-option ng-value=\"9999\">{{$root.User.Grade}} חדשה</md-option><md-option \nng-repeat=\"grade in grades\" ng-value=\"grade.ID\">{{grade.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"changeForm.GradeID==9999\"><md-icon md-font-icon=\"icon-panorama-horizontal\" \nclass=\"name\"></md-icon><label>{{$root.User.Grade}} חדשה</label><input ng-model=\"changeForm.NewGradeName\" \nng-disabled=\"isClicked\" ng-required=\"changeForm.GradeID==9999\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"changeForm.GradeID==9999\"><label>שנתון</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"changeForm.GradeYear\" ng-disabled=\"isClicked\">\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"changeForm.GradeID==9999\"><md-icon md-font-icon=\"\">\n</md-icon><label>שכבת בוגרים</label><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><md-select \nng-model=\"changeForm.Graduates\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">\nלא</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"changeForm.Type>=2\"><md-icon\n md-font-icon=\"icon-domain\" class=\"name\"></md-icon><label>בחירת {{$root.orgTypeBranchName.single}}</label><md-select \nng-required=\"true\" ng-model=\"changeForm.SettlementID\" placeholder=\"בחירת {{$root.orgTypeBranchName.single}}\" \nng-disabled=\"isClicked || !settlements\" ng-change=\"getGroupsByBranch()\"><md-option \nng-repeat=\"settlement in settlements\" ng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"changeForm.Type>=2\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>בחירת {{$root.User.Group}}</label><md-select \nng-model=\"changeForm.GroupID\" placeholder=\"בחירת {{$root.User.Group}}\" \nng-disabled=\"isClicked || changeForm.GradeID==9999 || !groups\"><md-option ng-if=\"changeForm.Type==3\" ng-value=\"9999\" \nng-selected=\"changeForm.GradeID==9999\">{{$root.User.Group}} חדשה</md-option><md-option ng-repeat=\"group in groups\" \nng-value=\"group.ID\">{{group.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"changeForm.GroupID==9999\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>\n{{$root.User.Group}} חדשה</label><input ng-model=\"changeForm.NewGroupName\" ng-required=\"changeForm.GroupID==9999\" \nng-disabled=\"isClicked\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"updateGroupForm.$invalid || isClicked\" type=\"submit\" ng-click=\"updateGradeAndGroups()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">עדכון</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/parents-profile.html","<div id=\"parent-profile\" class=\"page-layout simple tabbed\" ng-init=\"saveOnEnter()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div \nclass=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\">\n<img class=\"profile-image avatar huge\" ng-src=\"{{parent.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\"><div>\n<div class=\"hsf13 small-name\">הורה</div><div class=\"name\">{{parent.FirstName}} {{parent.LastName}}</div></div></div>\n<div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button data-ng-if=\"CurrentTotalCash\" \nclass=\"md-raised sflex aic pen\"><md-icon md-font-icon=\"icon-cash\" class=\"ml10\"></md-icon>יתרת חשבון פנימי : <span \nclass=\"fw-bold\" ng-class=\"{\'fcgreen\':CurrentTotalCash > 0,\'fcred\':CurrentTotalCash < 0}\">₪{{CurrentTotalCash}}</span>\n</md-button><md-button data-ng-if=\"coordinator.Email!= \'\'\" href=\"mailto: {{coordinator.Email}}\" \nclass=\"md-raised md-primary\">שליחת הודעה</md-button><md-button ng-if=\"$root.AdminLevel=3\" ng-click=\"loginToProfile()\" \nclass=\"md-raised md-primary\">התחבר לפרופיל</md-button></div></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!parent\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n<div class=\"content\" flex ng-if=\"parent\"><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label>\n<span>כללי</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/about/about.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>משפחה</span></md-tab-label><md-tab-body><md-content class=\"family\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/family/family.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>קבלות</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/payments/payments.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>הרשמות</span></md-tab-label><md-tab-body><md-content \nclass=\"registrations-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/registrations/registrations.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>פניות צור קשר</span></md-tab-label><md-tab-body><md-content \nclass=\"contact-tab\" ng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/contact/contact.html\'\">\n</md-content></md-tab-body></md-tab><md-tab \nng-if=\"$root.AdminLevel == 3 || ($root.User.IsCoordinator && $root.User.SubsidyRequests == 1)\"><md-tab-label><span>\nבקשות לסבסוד</span></md-tab-label><md-tab-body><md-content class=\"subsidy-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>בקשות לביטול</span></md-tab-label><md-tab-body><md-content class=\"cancel-tab\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/cancellation/cancellation.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>הערות פנימיות</span></md-tab-label><md-tab-body><md-content \nclass=\"comments-tab\" ng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/comments/comments.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>חשבון פנימי</span></md-tab-label><md-tab-body>\n<md-content class=\"cash-tab\" ng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/cash/cash.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/users/views/students/new-students-dialog/new-students-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\" \nng-init=\"getBranches();getGrades();getOrganizations();getSettlements();\"><form name=\"newStudentsForm\" \ndata-ng-model=\"newStudentsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת חניך חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-accent md-raised cp\" ng-if=\"!tz\" ng-click=\"ChangeToPassport()\" \nng-disabled=\"isClicked\">החלף לדרכון / תעודה חריגה</md-button><md-button class=\"md-accent md-raised cp\" ng-if=\"tz\" \nng-click=\"ChangeToPassport()\" ng-disabled=\"isClicked\">החלף לתעודה מזהה</md-button></div><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label ng-if=\"!tz\">תעודת זהות</label>\n<label ng-if=\"tz\">דרכון / תעודה חריגה</label><input ng-model=\"newStudent.PrivateID\" type=\"text\" \ndata-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input ng-model=\"newStudent.FirstName\" \ntype=\"text\" data-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה</label><input \nng-model=\"newStudent.LastName\" type=\"text\" data-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-gender-male-female\" class=\"name\"></md-icon><label>מין\n</label><md-select ng-required=\"true\" ng-model=\"newStudent.Gender\" placeholder=\"מין\" ng-disabled=\"isClicked\"><md-option\n ng-value=\"\'Male\'\">בן</md-option><md-option ng-value=\"\'Female\'\">בת</md-option><md-option ng-value=\"\'Other\'\">אחר\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label>תעודת זהות הורה 1</label><input \nng-model=\"newStudent.Parent1\" type=\"text\" ng-pattern=\"/^[0-9]{9}$/\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label>\nתעודת זהות הורה 2</label><input ng-model=\"newStudent.Parent2\" ng-required=\"newStudent.Parent2\" type=\"text\" \nng-pattern=\"/^[0-9]{9}$/\" ng-disabled=\"isClicked\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"row\" layout-xs=\"row\" flex=\"100\"><md-icon md-font-icon=\"icon-cellphone-android\">\n</md-icon><label>מספר טלפון נייד</label><input ng-model=\"newStudent.MobileNumber\" type=\"tel\" aria-label=\"phone number\">\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon \nmd-font-icon=\"icon-calendar-select\" class=\"name\"></md-icon><label>תאריך לידה</label><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"newStudent.Birthday\"><input ng-required=\"$root.brandName != \'oz\'\" \nautocomplete=\"off\" ng-model=\"newStudent.Birthday\" ng-disabled=\"isClicked\"></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\"><md-icon md-font-icon=\"icon-account\">\n</md-icon><label>שם האב</label><input ng-model=\"newStudent.FatherName\" required type=\"text\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\"><label>{{$root.orgTypeBranchName.single}}\n</label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" \nng-model=\"newStudent.SettlementID\" id=\"SettlementID\" ng-disabled=\"!settlements || isClicked\" required=\"true\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.orgTypeBranchName.plural}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"settlement in settlements | filter: searchTerm\" ng-value=\"settlement.ID\">{{settlement.Name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"row\" \nflex=\"100\"><md-icon md-font-icon=\"icon-chair-school\"></md-icon><label>{{$root.User.Grade}}</label><md-select \nng-model=\"newStudent.GradeID\" ng-change=\"disableBranchChange()\" ng-disabled=\"!grades || isClicked\"><md-option \nng-repeat=\"grade in grades\" ng-value=\"grade.ID\">{{grade.Name}}</md-option></md-select></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newStudentsForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNesStudent()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה ומעבר לפרופיל\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/users/views/parents/parent-panel/parent-panel.html","<md-content ms-scroll><form name=\"parentForm\" id=\"parentForm\" data-ng-model=\"parentForm\" class=\"md-inline-form\" \nvalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת הורה</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><img ng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\" \nclass=\"md-avatar avatar systemUser-avatar huge\" alt=\"{{parent.FirstName}} {{parent.LastName}}\"><div \nclass=\"selectedUser-name\">{{ parent.FirstName }} {{ parent.LastName }}</div></div></div></md-toolbar>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon>\n<label>תעודת זהות</label><input ng-model=\"parent.PrivateID\" ng-disabled=\"true\"></md-input-container><md-input-container\n class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label>\n<input ng-model=\"parent.FirstName\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה</label><input ng-model=\"parent.LastName\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"name\"></md-icon>\n<label>דואר אלקטרוני</label><input ng-model=\"parent.Email\" dir=\"ltr\" type=\"email\" \nng-pattern=\"/[0-9a-zA-Z_-]+?(\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|)@[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z]{2,15}(|\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15})/\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cellphone-android\" class=\"name\">\n</md-icon><label>טלפון נייד</label><input ng-model=\"parent.MobileNumber\" dir=\"ltr\" type=\"tel\" \ndata-ng-patter=\"/([.+-]\\d{0,3})?([.0-9+-]{6,12})/\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>קשר משפחתי לחניכים</label><md-select \nng-model=\"parent.Relation\"><md-option ng-repeat=\"relation in relations\" ng-value=\"relation\">{{relation}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\" class=\"name\">\n</md-icon><label>סטטוס</label><md-select ng-model=\"parent.Status\" placeholder=\"סטטוס\" ng-disabled=\"$root.AdminLevel<3\">\n<md-option ng-selected=\"parent.Status==1 || parent.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"parent.Status==0 || parent.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cash\" class=\"name\"></md-icon><label>דרגת הנחה</label>\n<md-select ng-model=\"parent.DiscountLevel\" placeholder=\"דרגת הנחה\" ng-disabled=\"$root.AdminLevel<3\"><md-option \nng-value=\"0\">בחר רמה</md-option><md-option ng-selected=\"parent.DiscountLevel==1 || parent.DiscountLevel==\'1\'\" \nng-value=\"1\">1</md-option><md-option ng-selected=\"parent.DiscountLevel==2 || parent.DiscountLevel==\'2\'\" ng-value=\"2\">2\n</md-option><md-option ng-selected=\"parent.DiscountLevel==3 || parent.DiscountLevel==\'3\'\" ng-value=\"3\">3</md-option>\n<md-option ng-selected=\"parent.DiscountLevel==4 || parent.DiscountLevel==\'4\'\" ng-value=\"4\">4</md-option><md-option \nng-selected=\"parent.DiscountLevel==5 || parent.DiscountLevel==\'5\'\" ng-value=\"5\">5</md-option><md-option \nng-selected=\"parent.DiscountLevel==6 || parent.DiscountLevel==\'6\'\" ng-value=\"6\">6</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"parent.DiscountLevelStartDate\"><label>\nתאריך התחלה של מתן הדרגה</label><input autocomplete=\"off\" ng-model=\"parent.DiscountLevelStartDate\" \nng-disabled=\"$root.AdminLevel<3\"></div></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"parent.DiscountLevelEndDate\"><label>תאריך סיום של מתן הדרגה</label><input autocomplete=\"off\" \nng-model=\"parent.DiscountLevelEndDate\" ng-disabled=\"$root.AdminLevel<3\"></div></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/users/views/students/new-educator/new-educator.html","<div id=\"forgot-password\" class=\"sflex aic fdc\" ng-init=\"validRequest()\"><div id=\"forgot-form\" \nng-class=\"{hideme: success}\"><h2 class=\"hfs65 center\">{{appConfig.appName}} - רישום מחנך חדש</h2><form><div><label \nclass=\"formlabel dblock fw-medium\">סיסמא חדשה</label><div class=\"inputform\"><input ng-change=\"matchPass()\" \nng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" type=\"{{ inputType }}\" ng-model=\"form.password\" \nplaceholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button ng-click=\"showHidePassword()\" class=\"sflex aic btn\">\n{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5 class=\"hfs13 sflex jcfe\"><span \nng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span ng-class=\"{errors: shortPass}\">\nסיסמא קצרה מדיי</span></h5></div></div><div class=\"mt40\"><label class=\"formlabel dblock fw-medium\">אימות סיסמא</label>\n<div class=\"inputform\"><input ng-class=\"{error: shortPass || (!matchPassword && !matchFlags)}\" ng-change=\"matchPass()\" \ntype=\"{{ inputType }}\" ng-model=\"passwordVerify\" placeholder=\"6 תווים (ספרות ואותיות בלועזית)\"> <button \nng-click=\"showHidePassword()\" class=\"sflex aic btn\">{{ showHideText }} <img src=\"{{ showHideImg }}\" alt=\"\"></button><h5\n class=\"hfs13 sflex jcfe\"><span ng-class=\"{errors: !matchPasswords && !matchFlags}\">סיסמאות אינן תואמות</span> <span \nng-class=\"{errors: shortPass}\">סיסמא קצרה מדיי</span></h5></div></div><div class=\"center mt40\"><div class=\"loading\" \nng-if=\"loading\" ng-class=\"{active: loading}\"><span></span></div><input type=\"submit\" \nng-disabled=\"!matchPasswords || loading\" ng-click=\"submit()\" value=\"עדכן סיסמא\"></div><div class=\"w100 center mt40\"><h4\n class=\"hfs15\">לחצו חזרה <a href=\"/\">לעמוד הכניסה</a></h4></div></form></div><div id=\"done-reset\" class=\"center\" \nng-class=\"{show: success}\"><img class=\"mb40\" src=\"/assets/icons/Done.svg\" alt=\"\"><h2 class=\"hfs65 mb30\">\nאיפוס סיסמא בוצע בהצלחה!</h2><h5 class=\"hfs27 fw-light\">מתבצע חיבור כעת</h5></div><div id=\"CopyR\" class=\"center hfs15\">\n<span>Crafted By <a href=\"https://www.marvilix.com\" target=\"_blank\">Marvilix </a>© All Rights Reserved</span></div><div\n class=\"errorBox inrowf\" ng-class=\"{show: fail}\"><div class=\"w100 center\"><span class=\"hfs15\">{{ errorInfo }}</span> \n<img src=\"/assets/icons/Close.svg\" alt=\"\" ng-click=\"fail = false\"></div></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/student-profile.html","<div id=\"student-profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" ng-src=\"{{student.ProfileImage || \'assets/images/avatars/profile.jpg\' }}\"><div><div \nclass=\"hsf13 small-name\">חניך</div><div class=\"name\">{{student.FirstName}} {{student.LastName}}</div></div></div><div \nclass=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button data-ng-if=\"student.Email!= \'\'\" \nhref=\"mailto: {{student.Email}}\" class=\"md-raised md-primary\">שליחת הודעה</md-button></div></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!student\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"content\" flex ng-if=\"student\"><md-tabs md-dynamic-height \nmd-selected=\"selectedTab\" style=\"overflow: visible\"><md-tab ng-disabled=\"$root.isEdit && selectedTab!=0\"><md-tab-label>\n<span>כללי</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" style=\"overflow: visible\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/about/about.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=1\"><md-tab-label><span>מדריך</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" style=\"overflow: visible\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/educator-groups/educator-groups.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=2\"><md-tab-label><span>משפחה\n</span></md-tab-label><md-tab-body><md-content class=\"family-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/family/family.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"$root.AdminLevel>1\" ng-disabled=\"$root.isEdit && selectedTab!=3\"><md-tab-label><span>\nהרשמות ל{{$root.User.Events}}</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/registrations/registrations.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"$root.AdminLevel>1\" ng-disabled=\"$root.isEdit && selectedTab!=4\"><md-tab-label>\n<span>פניות צור קשר</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/contact/contact.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"$root.AdminLevel>1\" ng-disabled=\"$root.isEdit && selectedTab!=5\"><md-tab-label>\n<span>בקשות לביטול</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/cancellation/cancellation.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"$root.AdminLevel>1\" ng-disabled=\"$root.isEdit && selectedTab!=6\"><md-tab-label>\n<span>הערות פנימיות</span></md-tab-label><md-tab-body><md-content class=\"payments-tab\" \nng-include=\"\'app/main/pages/users/views/students/student-profile/tabs/comments/comments.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-panel/student-panel.html","<md-content ms-scroll ng-init=\"getStudent();getSettlements();\"><form name=\"studentForm\" id=\"studentForm\" \ndata-ng-model=\"studentForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת חניך</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\" class=\"md-avatar avatar systemUser-avatar huge\" \nalt=\"{{student.FirstName}} {{student.LastName}}\"><div class=\"selectedUser-name\">\n{{ student.FirstName }} {{ student.LastName }}</div></div></div></md-toolbar><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><label>תעודת זהות</label><input \nng-disabled=\"true\" ng-model=\"student.PrivateID\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>שם פרטי</label><input \nng-model=\"student.FirstName\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><label>שם משפחה</label><input ng-model=\"student.LastName\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select \nng-model=\"student.Status\" placeholder=\"סטטוס\"><md-option ng-selected=\"student.Status==1 || student.Status==\'1\'\" \nng-value=\"1\">פעיל</md-option><md-option ng-selected=\"student.Status==0 || student.Status==\'0\'\" ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"student.Birthday\"><label>תאריך לידה</label><input autocomplete=\"off\" ng-model=\"student.Birthday\"></div>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\"></md-icon><label>\nדואר אלקטרוני</label><input ng-model=\"student.Email\" dir=\"ltr\" type=\"email\" \nng-pattern=\"/[0-9a-zA-Z_-]+?(\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z_-]+?|)@[0-9a-zA-Z_-]+?\\.[0-9a-zA-Z]{2,15}(|\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}|\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15}\\.[0-9a-zA-Z]{2,15})/\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cellphone-android\"></md-icon>\n<label>טלפון נייד</label><input ng-model=\"student.MobileNumber\" dir=\"ltr\" type=\"tel\" \ndata-ng-patter=\"/([.+-]\\d{0,3})?([.0-9+-]{6,12})/\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><label>שם האב</label><input ng-model=\"student.FatherName\" required type=\"text\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-gender-male-female\"></md-icon>\n<label>{{$root.User.Grade}}</label><md-select ng-model=\"student.GradeID\" required placeholder=\"{{$root.User.Grade}}\">\n<md-option ng-repeat=\"grade in grades\" ng-value=\"grade.ID\">{{grade.Name}}</md-option></md-select></md-input-container>\n<div ng-show=\"!allFields\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"changeAllFields()\">הצג את כל השדות</md-button></div><div ng-show=\"allFields\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><label>טלפון</label><input \nng-model=\"student.PhoneNumber\"></md-input-container><div class=\"md-block md-icon-left fix-label\" \nstyle=\"display: -webkit-box\"><md-icon md-font-icon=\"icon-city\" class=\"name\" \nstyle=\"padding-top: 38px;padding-right: 7px\"></md-icon><md-autocomplete \nstyle=\"min-width: 327px;padding-right: -16px;margin-right: -22px\" md-selected-item-change=\"setSettlement(item)\" \nng-disabled=\"isClicked\" md-input-name=\"autocompleteField\" md-no-cache=\"noCache\" md-selected-item=\"selectedItem\" \nmd-search-text=\"searchText\" md-items=\"item in querySearch(searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" \nmd-floating-label=\"שם {{$root.orgTypeBranchName.single}}\"><md-item-template><span md-highlight-text=\"searchText\" \nmd-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\n{{$root.orgTypeBranchName.single}} לא נמצא</md-not-found></md-autocomplete></div><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-panorama-horizontal\"></md-icon><label>רחוב</label><input \nng-model=\"student.Address\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><label>מיקוד</label><input ng-model=\"student.ZipCode\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>סוג חניך</label><md-select \nng-model=\"student.Type\" placeholder=\"סוג חניך\"><md-option ng-selected=\"student.Type==2 || student.Type==\'2\'\" \nng-value=\"2\">בוגר</md-option><md-option ng-selected=\"student.Type==1 || student.Type==\'1\'\" ng-value=\"1\">רגיל\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><label>מין</label><md-select ng-model=\"student.Gender\" \nplaceholder=\"מין\"><md-option ng-selected=\"student.Gender==\'Male\'\" ng-value=\"\'Male\'\">בן</md-option><md-option \nng-selected=\"student.Gender==\'Female\'\" ng-value=\"\'Female\'\">בת</md-option><md-option \nng-selected=\"student.Gender==\'Other\'\" ng-value=\"\'Other\'\">אחר</md-option></md-select></md-input-container><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"changeAllFields()\">הסתר שדות\n</md-button></div></div></form></md-content>");
$templateCache.put("app/main/pages/utils/views/activities/activities-panel/activities-panel.html","<md-content ms-scroll><form class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת {{$root.User.Activity}}</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\" \naria-label=\"Close Dialog\" translate translate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-input-container class=\"md-icon-float md-block\">\n<label>שם {{$root.User.Activity}}</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"activities.Name\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>סטטוס</label>\n<md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><md-select ng-model=\"activities.Status\" placeholder=\"סטטוס\">\n<md-option ng-selected=\"activities.Status==1 || activities.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"activities.Status==0 || activities.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container></form></md-content>");
$templateCache.put("app/main/pages/utils/views/activities/activities-profile/activities-profile.html","<div id=\"activities-profile\" class=\"page-layout simple tabbed\" ng-init=\"init()\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div \nclass=\"user-info\"><div class=\"hsf13 small-name\">{{$root.User.Activity}}</div><div class=\"name\">{{activities.Name}}\n</div></div></div><div class=\"content\" flex><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label>\n<span>כללי</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/utils/views/activities/activities-profile/tabs/about/about.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>מפגשים</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/utils/views/activities/activities-profile/tabs/meetings/meetings.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/utils/views/activities/new-activities-dialog/new-activities-dialog.html","<md-dialog class=\"new-activities-dialog\" aria-label=\"New Task\" ng-init=\"getSettlements()\"><form \nname=\"newActivitiesForm\" data-ng-model=\"newActivitiesForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספת {{$root.User.Activity}} חדשה</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"overflow: visible !important\"><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-leaf\" class=\"name\"></md-icon><label>שם {{$root.User.Activity}}</label>\n<input ng-model=\"newActivities.Name\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\" ng-show=\"$root.AdminLevel>1\"><md-icon md-font-icon=\"icon-domain\" class=\"name\">\n</md-icon><label>בחר {{$root.orgTypeBranchName.single}}</label><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"newActivities.settlements\" multiple=\"multiple\" ng-disabled=\"!settlements || isClicked\" \nng-change=\"getGroups()\" required><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-disabled=\"isClicked\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר {{$root.orgTypeBranchName.plural}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\">\n<md-option ng-value=\"settlement.ID\" ng-repeat=\"settlement in settlements |filter:searchTerm\">{{settlement.Name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>בחר {{$root.User.Groups}}</label><md-select \nmd-on-close=\"clearSearchTerm()\" ng-model=\"newActivities.Groups\" multiple=\"multiple\" ng-disabled=\"!groups || isClicked\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר {{$root.orgTypeBranchName.plural}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\">\n<md-option ng-value=\"group.ID\" ng-repeat=\"group in groups |filter:searchTerm\">{{group.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newActivitiesForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewActivities()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button><md-button \ndata-ng-disabled=\"newActivitiesForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewActivities(true)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה ומעבר לעריכה מלאה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/utils/views/contacts/contact-panel/contact-panel.html","<md-content ms-scroll><form id=\"contact-panel\" class=\"md-inline-form\" validate data-ng-model=\"contactForm\"><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">עריכת איש קשר</span><md-button class=\"md-icon-button\" \nng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block\"><label>שם</label><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><input ng-model=\"contact.Name\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-phone\" class=\"name\"></md-icon><label>טלפון</label><input \nng-model=\"contact.Phone\" type=\"text\" data-ng-required=\"true\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><label>מייל</label><input ng-model=\"contact.Email\" \ntype=\"email\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-briefcase\" \nclass=\"name\"></md-icon><label>תפקיד</label><input ng-model=\"contact.Role\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-comment\" class=\"name\"></md-icon><label>הערות</label>\n<textarea ng-model=\"contact.Comments\"></textarea></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-alert-circle\"></md-icon><label>הצג בפרופיל הורה</label><md-select ng-model=\"contact.ShowInProfile\" \nplaceholder=\"הצג בפרופיל הורה\"><md-option ng-selected=\"contact.ShowInProfile==1 || contact.ShowInProfile==\'1\'\" \nng-value=\"1\">מוצג</md-option><md-option ng-selected=\"contact.ShowInProfile==0 || contact.ShowInProfile==\'0\'\" \nng-value=\"0\">לא מוצג</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>סטטוס\n</label><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><md-select ng-model=\"contact.Status\" \nplaceholder=\"סטטוס\"><md-option ng-selected=\"contact.Status==1 || contact.Status==\'1\'\" ng-value=\"1\">פעיל</md-option>\n<md-option ng-selected=\"contact.Status==0 || contact.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"branches.length\" class=\"md-block\" \ntitle=\"התחל לרשום שם {{$root.User.Branch}}\"><label>שיוך {{$root.User.Branches}}</label><md-contact-chips \nng-disabled=\"isClicked || !branches\" ng-model=\"selectedBranches\" md-contacts=\"branchesQuerySearch($query)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" \nplaceholder=\"בחר {{$root.User.Branches}}\"></md-contact-chips></md-input-container><md-input-container \nng-if=\"groups.length\" class=\"md-block\" title=\"התחל לרשום שם קבוצה\"><label>שיוך קבוצות</label><md-contact-chips \nng-disabled=\"isClicked || !groups\" ng-model=\"selectedGroups\" md-contacts=\"groupsQuerySearch($query)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" placeholder=\"בחר קבוצות\">\n</md-contact-chips></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/utils/views/contacts/new-contact-dialog/new-contact-dialog.html","<md-dialog class=\"newStudents-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form name=\"newContactForm\" \ndata-ng-model=\"newStudentsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת איש קשר חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-phone\" class=\"name\"></md-icon><label>טלפון</label><input \nng-change=\"checkForPhone()\" ng-model-options=\"{ debounce: 500 }\" ng-model=\"newContact.Phone\" type=\"text\" \ndata-ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם</label><input ng-model=\"newContact.Name\" type=\"text\" \ndata-ng-required=\"true\" ng-disabled=\"isClicked || !phoneChecked\"></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><label>מייל</label><input \nng-model=\"newContact.Email\" type=\"email\" ng-disabled=\"isClicked || !phoneChecked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-briefcase\" class=\"name\"></md-icon><label>תפקיד</label>\n<input ng-model=\"newContact.Role\" type=\"text\" ng-disabled=\"isClicked || !phoneChecked\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-comment\" class=\"name\"></md-icon><label>הערות</label>\n<textarea ng-model=\"newContact.Comments\" ng-disabled=\"isClicked || !phoneChecked\"></textarea></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-alert-circle\"></md-icon><label>הצג בפרופיל הורה\n</label><md-select ng-model=\"newContact.ShowInProfile\" placeholder=\"הצג בפרופיל הורה\" \nng-disabled=\"isClicked || !phoneChecked\"><md-option \nng-selected=\"contact.ShowInProfile==1 || contact.ShowInProfile==\'1\'\" ng-value=\"1\">מוצג</md-option><md-option \nng-selected=\"contact.ShowInProfile==0 || contact.ShowInProfile==\'0\'\" ng-value=\"0\">לא מוצג</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"groups\" class=\"md-block\" title=\"התחל לרשום שם קבוצה\"><label>שיוך קבוצות\n</label><md-contact-chips ng-disabled=\"isClicked || !groups || !phoneChecked\" ng-model=\"selectedGroups\" \nmd-contacts=\"groupsQuerySearch($query)\" md-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"true\" placeholder=\"בחר קבוצות\"></md-contact-chips></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-ng-disabled=\"newContactForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewContact()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/utils/views/reports/new-report-dialog/new-report-dialog.html","<md-dialog id=\"newReport-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת דוח חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" ng-disabled=\"isClicked\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"overflow:auto !important;min-height: 450px !important\"><form name=\"newReportForm\" data-ng-model=\"newReportForm\" \nvalidate style=\"overflow: visible !important;max-height: 80% !important\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"clipboard-text\"></md-icon><label>שם דוח</label><input type=\"text\" ng-model=\"report.Name\" \nplaceholder=\"הכנס/י שם כדי לשמור\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"file-excel\"></md-icon><label>בחר סוג דוח</label><md-select ng-model=\"report.Type\" ng-required=\"true\" \nng-change=\"getFields()\" ng-disabled=\"isClicked\"><md-option ng-value=\"1\">חניכים</md-option><md-option ng-value=\"2\" \nng-if=\"$root.AdminLevel>=2\">מחנכים</md-option><md-option ng-value=\"11\">הורים</md-option><md-option ng-value=\"3\" \nng-if=\"$root.AdminLevel>2\">{{$root.User.Coordinators}}</md-option><md-option ng-value=\"4\" ng-if=\"$root.AdminLevel>2\">\nמנהלים</md-option><md-option ng-value=\"5\" ng-if=\"$root.AdminLevel>2\">{{$root.orgTypeBranchName.plural}}</md-option>\n<md-option ng-value=\"19\" ng-if=\"$root.AdminLevel>2\">תשלומים ל{{$root.orgTypeBranchName.plural}}</md-option><md-option \nng-value=\"6\" ng-if=\"$root.AdminLevel>2\">{{$root.User.Groups}}</md-option><md-option ng-value=\"7\" \nng-if=\"$root.AdminLevel>2\">תשלומים</md-option><md-option ng-value=\"8\" ng-if=\"$root.AdminLevel>2\">מאורעות</md-option>\n<md-option ng-value=\"9\">מאורעות - נרשמים</md-option><md-option ng-value=\"14\">מאורעות - נוכחות</md-option><md-option \nng-value=\"15\">דוח נתוני הרשמות</md-option><md-option ng-value=\"10\" ng-if=\"$root.AdminLevel>2\">\nנרשמים לפי {{$root.orgTypeBranchName.single}}</md-option><md-option ng-value=\"12\" ng-if=\"$root.AdminLevel>2\">\nהכנסות חודשיות</md-option><md-option ng-value=\"16\">דוח {{$root.User.Activities}}</md-option><md-option ng-value=\"17\" \nng-if=\"$root.AdminLevel>2\">דוח סיכום הנחות</md-option><md-option ng-value=\"18\" ng-if=\"false && $root.AdminLevel>2\">\nדוח סיבסודים</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"[1,2,3,5,6,9,10,11,14,15,16,18,19].indexOf(report.Type) != -1\"><md-icon md-svg-icon=\"city\"></md-icon><label>\nבחר {{$root.orgTypeBranchName.plural}}</label><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"report.Settlements\" \nng-disabled=\"!settlements || isClicked || !settlements\" ng-required=\"$root.AdminLevel==1\" multiple=\"true\" \nng-change=\"getGroups()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" \nng-disabled=\"!settlements || isClicked\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חפש {{$root.orgTypeBranchName.plural}}..\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup ng-disabled=\"!settlements || isClicked\"><md-option ng-value=\"settlement\" \nng-repeat=\"settlement in settlements |filter:searchTerm\">{{settlement.Name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"[1,2,9,14,16].indexOf(report.Type) != -1\" \nng-required=\"$root.AdminLevel==1\" placeholder=\"השאר ריק לבחירת כל הקבוצות\"><md-icon md-svg-icon=\"account-multiple\">\n</md-icon><label>בחר {{$root.User.Groups}}</label><md-select ng-model=\"report.Groups\" multiple=\"true\" \nng-change=\"getActivities()\" ng-disabled=\"!report.Settlements || isClicked || !groups\"><md-option \nng-repeat=\"group in groups\" ng-value=\"group\">{{group.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"report.Type ==16\" ng-required=\"true\"><md-icon \nmd-svg-icon=\"account-multiple\"></md-icon><label>בחר {{$root.User.Activities}}</label><md-select \nng-model=\"report.Activities\" multiple=\"true\" ng-disabled=\"!activities\"><md-option ng-repeat=\"activity in activities\" \nng-value=\"activity\">{{activity.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"(report.Type>=1 && report.Type<=2) || (report.Type>8 && report.Type<10) || report.Type==14\" \nplaceholder=\"השאר ריק לבחירת כל {{$root.User.Grades}}\"><md-icon md-svg-icon=\"chair-school\"></md-icon><label>\nבחר {{$root.User.Grades}}</label><md-select ng-model=\"report.Grades\" multiple=\"true\" \nng-disabled=\"!grades || isClicked || !grades\"><md-option ng-repeat=\"grade in grades\" ng-value=\"grade\">{{grade.Name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"[8,9,10,12,13,14,15,17].indexOf(report.Type) != -1\"><md-icon md-font-icon=\"icon-apps\"></md-icon><label>\nבחר קטגוריה</label><md-select ng-model=\"report.Categories\" multiple=\"true\" ng-disabled=\"!categories || isClicked\" \nng-required=\"[8,9,10,13,14,15,17].indexOf(report.Type) != -1 && (!report.EventsSearch || report.EventsSearch.length == 0)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"categorySearchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" ng-keyup=\"eventKeyPress($event)\" placeholder=\"חפש קטגוריה..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-value=\"category.ID\" ng-repeat=\"category in categories |filter:categorySearchTerm\">{{category.Path.join(\' › \')}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"[8,9,10,13,14,15,17].indexOf(report.Type) != -1\"><label>בחר מאורע</label><md-icon md-svg-icon=\"weather-sunny\">\n</md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"report.EventsSearch\" ng-disabled=\"isClicked\" \nng-required=\"[8,9,10,13,14,15,17].indexOf(report.Type) != -1 && (!report.Categories || report.Categories.length == 0)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" ng-keyup=\"eventKeyPress($event)\" placeholder=\"חפש מאורע..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!events || isClicked\"><md-option ng-value=\"event\" ng-click=\"addToReportEvents(event)\" \nng-repeat=\"event in events |filter:searchTerm\">{{event.Name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"md-block\" \nng-if=\"[8,9,10,13,14,15,17,19,20].indexOf(report.Type) != -1\"><md-list><md-list-item \nng-repeat=\"event in report.Events\" class=\"p0\"><div class=\"w100 sflex jcsb aic\"><span>{{event.Name}}</span><md-button \nng-click=\"removeFromReportEvents(event)\" class=\"send-button md-accent md-raised m0\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></div></md-list-item></md-list></md-input-container><md-input-container class=\"md-block\" \nng-if=\"[18].indexOf(report.Type) != -1\"><md-icon md-svg-icon=\"clipboard-text\"></md-icon><label>מאורע (מלל חופשי)\n</label><input type=\"text\" ng-model=\"report.EventsFreeSearch\" placeholder=\"הכנס/י שם מאורע\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\" \nng-if=\"[7,9,12,16,18,19,20].indexOf(report.Type) != -1\"><md-icon md-font-icon=\"icon-calendar-select\" class=\"name\">\n</md-icon><label>תאריך התחלה</label><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"report.startDate\"><input ng-required=\"[7,12].indexOf(report.Type) != -1\" autocomplete=\"off\" \nng-model=\"report.startDate\" ng-disabled=\"isClicked\"></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" ng-if=\"[7,9,12,16,18,19,20].indexOf(report.Type) != -1\"><md-icon \nmd-font-icon=\"icon-calendar-select\" class=\"name\"></md-icon><label>תאריך סיום</label><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"report.endDate\"><input ng-required=\"[7,12].indexOf(report.Type) != -1\" \nautocomplete=\"off\" ng-model=\"report.endDate\" ng-disabled=\"isClicked\"></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" ng-if=\"[1].indexOf(report.Type) != -1\"><md-icon \nmd-font-icon=\"icon-calendar-select\" class=\"name\"></md-icon><label>תאריך התחלה (הרשמה)</label><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"report.CreatedTimeStart\"><input autocomplete=\"off\" \nng-model=\"report.CreatedTimeStart\" ng-disabled=\"isClicked\"></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" ng-if=\"[1].indexOf(report.Type) != -1\"><md-icon \nmd-font-icon=\"icon-calendar-select\" class=\"name\"></md-icon><label>תאריך סיום (הרשמה)</label><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"report.CreatedTimeEnd\"><input autocomplete=\"off\" \nng-model=\"report.CreatedTimeEnd\" ng-disabled=\"isClicked\"></div></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"report.Type && (report.Type<7 || report.Type==9)\"><label>סטטוס</label><md-icon \nmd-svg-icon=\"power\"></md-icon><md-select ng-model=\"report.Status\" ng-disabled=\"isClicked\"><md-option ng-value=\"null\">\nהכל</md-option><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" \nng-if=\"(report.Type>=1 && report.Type<=2) || (report.Type>8 && report.Type<10)\"><label>מין</label><md-icon \nmd-svg-icon=\"gender-male-female\"></md-icon><md-select ng-model=\"report.Gender\" ng-disabled=\"isClicked\"><md-option \nng-value=\"null\">הכל</md-option><md-option ng-value=\"1\">זכר</md-option><md-option ng-value=\"2\">נקבה</md-option>\n</md-select></md-input-container><md-input-container ng-show=\"false\" class=\"md-block\" \nng-if=\"report.Type && [10,18,19,20].indexOf(report.Type) == -1\"><md-icon md-svg-icon=\"notification-clear-all\">\n</md-icon><label>בחר שדות להצגה</label><md-select ng-model=\"report.Fields\" multiple=\"true\" \nng-disabled=\"!fields || fields.length==0 || isClicked\" placeholder=\"שדות להצגה\"><md-option \nng-repeat=\"(fieldKey,fieldValue) in fields\" ng-value=\"fieldKey\">{{fieldValue}}</md-option></md-select>\n</md-input-container><md-input-container ng-show=\"false\" class=\"md-block\" ng-if=\"report.Type && report.Type==1\">\n<md-checkbox ng-model=\"report.extraFields\" ng-disabled=\"isClicked\" ng-true-value=\"1\" ng-false-value=\"0\">\nהצג שדות נוספים בדו\"ח</md-checkbox></md-input-container><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newReportForm.$invalid || isClicked || !report.Name || !settlements\" type=\"submit\" \nng-click=\"saveNewReport()\" class=\"send-button md-accent md-raised\">שמירה</md-button><md-button \ndata-ng-disabled=\"newReportForm.$invalid || isClicked || !report.Name || !settlements\" type=\"submit\" \nng-click=\"saveNewReport(true)\" class=\"send-button md-accent md-raised\">שמירה ויצוא</md-button><md-button \ndata-ng-disabled=\"newReportForm.$invalid || isClicked || !settlements\" type=\"submit\" \nng-click=\"saveNewReport(false,true)\" class=\"send-button md-accent md-raised\">יצוא</md-button></div></md-dialog-actions>\n</form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/admin/coordinators/coordinators-profile/tabs/about/about.html","<div><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><div class=\"general\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">כללי\n</div></header><div class=\"content\"><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input ng-model=\"coordinator.FirstName\" \ntype=\"text\" md-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>שם משפחה</label><input ng-model=\"coordinator.LastName\" type=\"text\" md-autofocus>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><label>דואר אלקטרוני</label><input ng-model=\"coordinator.Email\" \ntype=\"email\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cellphone-android\" class=\"name\">\n</md-icon><input ng-model=\"coordinator.PhoneNumber\" type=\"tel\" md-autofocus></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><label>סטטוס\n</label><md-select ng-model=\"coordinator.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"coordinator.Status==1 || coordinator.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"coordinator.Status==0 || coordinator.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-tie\"></md-icon><label>תפקיד</label><md-select\n ng-model=\"coordinator.Role\" placeholder=\"תפקיד\"><md-option ng-repeat=\"role in roles\" ng-value=\"role.Name\">\n{{role.Name}}</md-option></md-select></md-input-container></div></div></div></div><div class=\"about-sidebar\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"25\" ng-if=\"coordinator.CreateTime || coordinator.LastLogin\"><div\n class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nסטטיסטיקה</div></header><div class=\"content\" ng-if=\"coordinator.CreateTime\"><div class=\"info-line\"><div class=\"title\">\nתאריך יצירה</div><div class=\"info\"><span>{{coordinator.CreateTime | cmdate:\'HH:mm:ss בתאריך- dd/MM/yyyy בשעה\'}}</span>\n</div></div><div class=\"info-line\" ng-if=\"coordinator.LastLogin\"><div class=\"title\">תאריך התחברות אחרון</div><div \nclass=\"info\"><span>{{coordinator.LastLogin | cmdate:\'HH:mm:ss בתאריך- dd/MM/yyyy בשעה\'}}</span></div></div><div \nclass=\"info-line\" ng-if=\"coordinator.Password==0 || coordinator.Password==\'0\'\"><md-button class=\"md-raised md-accent\" \nng-click=\"openNewCoordinatorDialog()\">שליחת הזמנה חוזרת למערכת</md-button></div></div></div></div></div></form></div>");
$templateCache.put("app/main/pages/admin/coordinators/coordinators-profile/tabs/categories/categories.html","<div><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><div class=\"general\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nפרטי שיוך קטגוריות</div></header><div class=\"content\"><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\"><md-icon md-font-icon=\"icon-apps\" \nclass=\"name\"></md-icon><label>קטגוריות</label><md-select ng-model=\"selectedCategories.categories\" \nplaceholder=\"קטגוריות\" multiple=\"multiple\"><md-option ng-repeat=\"category in categories\" ng-value=\"category.ID\">\n{{category.Path.join(\' › \')}}</md-option></md-select></md-input-container></div><div class=\"row\" layout=\"rot\">\n<md-button ng-disabled=\"isClicked || !categories\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"updateCategories()\">עדכן</md-button></div></div></div></div></div></form></div>");
$templateCache.put("app/main/pages/admin/coordinators/coordinators-profile/tabs/events/events.html","<div><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><div class=\"general\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex aic jcsb\"><div \nclass=\"title\">שיוך מאורעות</div><div><md-button class=\"md-icon-button\" title=\"הוספת שיוך\" \nng-click=\"createNewCoordinatorEvent()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></header><div \nclass=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!coordinatorEvents\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\" ng-if=\"coordinatorEvents\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מאורע</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" ng-repeat=\"event in coordinatorEvents | filter:{Status : filterGroup}\"><td>\n{{event.Name}}</td><td><md-button aria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" ng-disabled=\"isClicked\"><md-icon \nmd-font-icon=\"icon-trash\" ng-click=\"deleteCoordinatorEvents(event.ID)\"></md-icon></md-button></td></tr></tbody></table>\n</div></div></div></div></form></div>");
$templateCache.put("app/main/pages/admin/coordinators/coordinators-profile/tabs/permissions/permissions.html","<div><form name=\"UserForm\" class=\"md-inline-form\" validate ng-init=\"getGlobalMaxNumOfPayments()\"><div layout=\"row\" \nlayout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">כללי\n</div></header><div class=\"content\"><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>הרשאות לאישור תשלום</label><md-select \nng-model=\"coordinator.Payments\" placeholder=\"הרשאות לאישור תשלום\"><md-option ng-value=\"1\">פעיל</md-option><md-option \nng-value=\"0\">לא פעיל</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-weather-sunny\" class=\"name\"></md-icon><label>הרשאות ל{{$root.User.Events}}</label><md-select \nng-model=\"coordinator.EventsPer\" placeholder=\"הרשאות ל{{$root.User.Events}}\"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"cash-100\" class=\"name\"></md-icon><label>הרשאות להרשמת חניכים\n</label><md-select ng-model=\"coordinator.EventsPay\" placeholder=\"הרשאות להרשמת חניכים\"><md-option ng-value=\"1\">פעיל\n</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-svg-icon=\"cash-100\" class=\"name\"></md-icon><label>הרשאות לנוכחות {{$root.User.Event}}\n</label><md-select ng-model=\"coordinator.Attendance\" placeholder=\"הרשאות לנוכחות {{$root.User.Event}}\"><md-option \nng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"cart\" class=\"name\"></md-icon><label>\nהרשאות לשיווק {{$root.User.Events}}</label><md-select ng-model=\"coordinator.Marketing\" \nplaceholder=\"הרשאות לשיווק {{$root.User.Events}}\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">\nלא פעיל</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"account\" class=\"name\">\n</md-icon><label>חסימת הרשאה לרישום ל{{$root.User.Event}} לאחר סיום הרשמה</label><md-select \nng-model=\"coordinator.RegistrationClose\" placeholder=\"חסימת הרשאה לרישום ל{{$root.User.Event}} לאחר סיום הרשמה\">\n<md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\">\n</md-icon><label>הרשאות לעריכת שאלות {{$root.User.Events}}</label><md-select ng-model=\"coordinator.EditQuestions\" \nplaceholder=\"הרשאות לעריכת שאלות {{$root.User.Events}}\"><md-option ng-value=\"1\">פעיל</md-option><md-option \nng-value=\"0\">לא פעיל</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"name\"></md-icon><label>הרשאות לשיווק {{$root.User.Events}}</label><md-select \nng-model=\"coordinator.SubsidyRequests\" placeholder=\"הרשאות בקשות סבסוד\"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\"></md-icon><label>\nהרשאות לשליחת SMS</label><md-select ng-model=\"coordinator.SmsPer\" placeholder=\"הרשאות לשליחת SMS\"><md-option \nng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\"></md-icon><label>\nהרשאות לשליחת אימייל</label><md-select ng-model=\"coordinator.EmailPer\" placeholder=\"הרשאות לשליחת אימייל\"><md-option \nng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-help-circle\" class=\"name\"></md-icon><label>\nהרשאות להרשמה מעבר לכמות מוגבלת</label><md-select ng-model=\"coordinator.OverRegsPer\" \nplaceholder=\"הרשאות להרשמה לעבר לכמות מוגבלת\"><md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"numeric\" class=\"name\">\n</md-icon><label>מקסימום כמות תשלומים מותרת לקביעה</label><input type=\"number\" max=\"{{globalMaxNumOfPayments}}\" \nng-model=\"coordinator.MaxNumOfPayments\" type=\"number\" placeholder=\"מקסימום כמות תשלומים מותרת לקביעה\">\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"name\"></md-icon><label>הרשאות להרשמה באמצעות המחאות</label><md-select \nng-model=\"coordinator.ChecksPer\" placeholder=\"הרשאות להרשמה לעבר לכמות מוגבלת\"><md-option ng-value=\"1\">פעיל</md-option>\n<md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></div></div></div></div></form></div>");
$templateCache.put("app/main/pages/admin/coordinators/coordinators-profile/tabs/settlements/settlements.html","<div><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><div class=\"general\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nפרטי ניהול {{$root.orgTypeBranchName.plural}}</div></header><div class=\"content\"><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\"><md-contact-chips \nng-model=\"selectedSettlements\" ng-disabled=\"!settlements\" md-contacts=\"settlementsQuerySearch($query)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" \nplaceholder=\"בחר {{$root.orgTypeBranchName.plural}}\"></md-contact-chips></md-input-container></div><div class=\"row\" \nlayout=\"rot\"><md-button ng-disabled=\"isClicked || !settlements\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"updateSettlements()\">עדכן</md-button></div></div></div></div></div></form></div>");
$templateCache.put("app/main/pages/settings-menue/views/admin-settings/tabs/new-tag-dialog/new-tag-dialog.html","<md-dialog class=\"newTag-dialog\" aria-label=\"New Task\"><form name=\"newTagForm\" data-ng-model=\"newTagForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת תגית תושב</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת תגית תושב\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div><md-input-container class=\"md-block\" ng-if=\"!withFile\"><label>שם תגית</label><input type=\"text\" \nng-model=\"newTag.Name\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-ng-disabled=\"newTagForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewTag()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/settings-menue/views/accountancy-settings/tabs/accountsPopup/accountsPopup.html","<md-dialog class=\"new-Event-dialog\" aria-label=\"New Task\" style=\"overflow: visible !important\" ng-init=\"init();\">\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הנהלת חשבונות</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"content\" \nflex><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab><md-tab-label><span>תיקי הכנסות</span></md-tab-label>\n<md-tab-body><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon \nmd-svg-icon=\"information\"></md-icon><span class=\"title\">תיקי הכנסות יעודכנו בדו\"ח ייצוא הנהלת חשבונות מהמערכת</span>\n</div><md-content class=\"content md-padding\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!accountancy\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><form \nname=\"upgradeGradeForm\" class=\"md-inline-form\" validate ng-show=\"accountancy\"><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע המחאות מזומן</label><input \nng-model=\"accountancy.CashCheck\" ng-disabled=\"!accountancy || isClicked\"></md-input-container></div><div class=\"half\">\n<md-input-container class=\"md-block\"><label>מספר קבוע המחאות דחויות</label><input ng-model=\"accountancy.FutureCheck\" \nng-disabled=\"!accountancy || isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע ויזה</label><input ng-model=\"accountancy.Visa\" \nng-disabled=\"!accountancy || isClicked\"></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-block\"><label>מספר קבוע ישראקרד</label><input ng-model=\"accountancy.IsraCard\" \nng-disabled=\"!accountancy || isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע אמריקן אקספרס</label><input \nng-model=\"accountancy.AmericanExpress\" ng-disabled=\"!accountancy || isClicked\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע מאסטקארד</label><input \nng-model=\"accountancy.MasterCard\" ng-disabled=\"!accountancy || isClicked\"></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע דיינרס</label><input \nng-model=\"accountancy.Diners\" ng-disabled=\"!accountancy || isClicked\"></md-input-container></div><div class=\"half\">\n<md-input-container class=\"md-block\"><label>מספר קבוע מזומן</label><input ng-model=\"accountancy.Cash\" \nng-disabled=\"!accountancy || isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע לאומיקארד</label><input \nng-model=\"accountancy.LeumiCard\" ng-disabled=\"!accountancy || isClicked\"></md-input-container></div><div class=\"half\">\n<md-input-container class=\"md-block\"><label>מספר קבוע העברה בנקאית</label><input ng-model=\"accountancy.BankTransfer\" \nng-disabled=\"!accountancy || isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר קבוע חשבון פנימי</label><input \nng-model=\"accountancy.InnerTrans\" ng-disabled=\"!accountancy || isClicked\"></md-input-container></div><div class=\"half\">\n<md-input-container class=\"md-block\"><label>מספר תשלומים מקסימלי</label><input type=\"number\" \nng-model=\"accountancy.GlobalMaxNumOfPayments\" ng-disabled=\"!accountancy || isClicked\"></md-input-container></div></div>\n<md-button ng-disabled=\"isClicked\" class=\"md-raised md-accent\" ng-click=\"updateAccountancy()\" \nstyle=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>חשבון בנק</span></md-tab-label><md-tab-body><md-content \nclass=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon md-svg-icon=\"information\"></md-icon>\n<span class=\"title\">\nחשבונות בנק שמקושרים לתנועה. בהוספת הרשמות חדשות באמצעות העברה בנקאית ניתן לבחור את החשבון שאליו הופקד התשלום.</span>\n</div><md-content class=\"content md-padding\"><form name=\"upgradeGradeForm\" class=\"md-inline-form\" validate><div><div \nclass=\"half\" lass=\"row\" layout=\"row\"><table class=\"dataTable row-border hover\"><thead><tr><th data-priority=\"1\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם בנק</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר תיק הכנסות</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in accountancy.Banks\"><td><md-input-container class=\"md-block\"><label>שם בנק</label>\n<input ng-model=\"item.Name\" ng-disabled=\"isClicked\"></md-input-container></td><td><md-input-container class=\"md-block\">\n<label>מספר קבוע בנק</label><input ng-model=\"item.Number\" ng-disabled=\"isClicked\"></md-input-container></td></tr>\n</tbody></table></div></div><md-button ng-disabled=\"isClicked\" class=\"md-raised md-accent\" ng-click=\"addBank()\" \nstyle=\"margin-right: 0px\" ng-if=\"!accountancy.Banks || !accountancy.Banks.length\">הוספת בנק</md-button><md-button \nng-disabled=\"isClicked\" class=\"md-raised md-accent\" ng-click=\"updateAccountancy()\" style=\"margin-right: 0px\">עדכון\n</md-button></form></md-content></md-content></md-tab-body></md-tab><md-tab \nng-init=\"getSystemSettings();getAdminImages()\"><md-tab-label><span>פרטי הארגון</span></md-tab-label><md-tab-body><div \nflex=\"100\" flex-xs=\"100\"><md-content class=\"profile-box info-box md-whiteframe-1dp\"><div class=\"info-header\"><md-icon \nmd-svg-icon=\"information\"></md-icon><span class=\"title\">פרטי הארגון - יופיעו בפרופיל ההורה ועל הקבלות שיופקו</span>\n</div><md-content class=\"content md-padding\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!systemSettings\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><form \nname=\"upgradeGradeForm\" class=\"md-inline-form\" ng-show=\"systemSettings\" validate><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>\nשם הארגון</label><input ng-model=\"systemSettings.BrandName\" ng-disabled=\"!systemSettings || isClicked\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" \nclass=\"name\"></md-icon><label>מספר הארגון</label><input ng-model=\"systemSettings.BrandNumber\" \nng-disabled=\"!systemSettings || isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>כתובת הארגון</label><md-icon md-svg-icon=\"map-marker\" \nclass=\"name\"></md-icon><input ng-model=\"systemSettings.BrandAddress\" ng-disabled=\"!systemSettings || isClicked\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\" \nclass=\"name\"></md-icon><label>מספר טלפון</label><input ng-model=\"systemSettings.BrandPhoneNumber\" \nng-disabled=\"!systemSettings || isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>מספר פקס</label><md-icon md-svg-icon=\"fax\" class=\"name\">\n</md-icon><input ng-model=\"systemSettings.BrandFaxNumber\" ng-disabled=\"!systemSettings || isClicked\">\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" \nclass=\"name\"></md-icon><label>מייל</label><input ng-model=\"systemSettings.BrandEmail\" \nng-disabled=\"!systemSettings || isClicked\"></md-input-container></div></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-block\"><label>אתר אינטרנט</label><md-icon md-font-icon=\"icon-web\" \nclass=\"name\"></md-icon><input ng-model=\"systemSettings.BrandWebsite\" ng-disabled=\"!systemSettings || isClicked\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon ng-if=\"!systemSettings.BrandLogo\" md-svg-icon=\"upload\" class=\"name\"></md-icon><md-icon \nng-disabled=\"isClicked\" ng-if=\"systemSettings.BrandLogo\" md-svg-icon=\"eye\" href=\"{{systemSettings.BrandLogo}}\" \nng-click=\"viewFile(systemSettings.BrandLogo)\" style=\"cursor: pointer\" title=\"צפייה בקובץ\" class=\"name\"></md-icon>\n<label>לוגו</label><input ng-disabled=\"isClicked\" ngf-select=\"uploadFile($file)\" placeholder=\"{{filename}}\" \nng-model=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" style=\"cursor: pointer\" readonly=\"readonly\"></md-input-container>\n</div></div><md-button ng-disabled=\"isClicked\" class=\"md-raised md-accent\" aria-label=\"עדכן  {{$root.User.Grade}}\" \nng-click=\"updateSystemSettings()\" style=\"margin-right: 0px\">עדכון</md-button></form></md-content></md-content></div>\n</md-tab-body></md-tab></md-tabs></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/users/views/students/student-profile/new-educator-dialog/new-educator-dialog.html","<md-dialog class=\"newEducator-dialog\" aria-label=\"New Task\"><form name=\"newEducatorForm\" \ndata-ng-model=\"newEducatorForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nשליחת הזמנה למחנך</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" \nclass=\"name\"></md-icon><label>דואר אלקטרוני</label><input ng-model=\"newEducator.Email\" type=\"text\" ng-disabled=\"true\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newEducatorForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"sendInvitationToNewEducator()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nשליחה</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/users/views/students/student-profile/new-parent-dialog/new-parent-dialog.html","<md-dialog class=\"newParent-dialog\" aria-label=\"New Task\"><form name=\"newParentForm\" data-ng-model=\"newParentForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הורה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div><md-input-container class=\"md-block\"><md-button \nclass=\"md-accent md-raised cp\" ng-if=\"!tz\" ng-click=\"ChangeToPassport()\">החלף לדרכון / תעודה חריגה</md-button>\n<md-button class=\"md-accent md-raised cp\" ng-if=\"tz\" ng-click=\"ChangeToPassport()\">החלף לתעודה מזהה</md-button>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\">\n</md-icon><label ng-if=\"!tz\">תעודת זהות</label><label ng-if=\"tz\">דרכון</label><input ng-model=\"newParent.PrivateID\" \ntitle=\"במידה וההורה קיים יש להכניס ת.ז בלבד\" data-ng-required=\"true\" data-ng-pattern=\"pattern\" ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newParentForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewParent()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/utils/views/activities/activities-profile/send-activity-health-declaration-dialog/send-activity-health-declaration-dialog.html","<md-dialog class=\"new-activities-dialog\" aria-label=\"New Task\" ng-init=\"getStudents()\"><form \nname=\"newActivityMeetingForm\" data-ng-model=\"newActivityMeetingForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">שליחת הצהרת בריאות</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" flex=\"100\"><md-icon \nmd-font-icon=\"icon-message-text-outline\" class=\"name\"></md-icon><label>נמענים</label><md-select \nng-model=\"newHealthDeclarationMessage.Addressee\" placeholder=\"נמענים\" required class=\"hfs16\" multiple=\"multiple\">\n<md-option ng-value=\"\'Students\'\">חניכים</md-option><md-option ng-value=\"\'Parents\'\">הורים</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\"><md-icon md-font-icon=\"icon-apps\" class=\"name\"></md-icon><label>שליחה באמצעות</label><md-select \nng-model=\"newHealthDeclarationMessage.Interface\" placeholder=\"שליחה באמצעות\" required class=\"hfs16\" \nmultiple=\"multiple\"><md-option ng-value=\"1\">SMS</md-option><md-option ng-value=\"2\">אימייל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label>למי לשלוח</label><md-select \nng-model=\"newHealthDeclarationMessage.SendToAll\" placeholder=\"למי לשלוח\" required class=\"hfs16\"><md-option \nng-value=\"1\">כולם</md-option><md-option ng-value=\"0\">חניכים ספציפיים</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"newHealthDeclarationMessage.SendToAll == 0\" class=\"md-icon-float md-block md-icon-left\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>\nחניכים</label><md-select ng-model=\"newHealthDeclarationMessage.Students\" placeholder=\"חניכים\" class=\"hfs16\" \nmultiple=\"multiple\"><md-option ng-value=\"student.ID\" ng-repeat=\"student in students\" \nng-disabled=\"student.SignedHealthDaclerationFile.length\">{{student.StudentName}}</md-option></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newActivityMeetingForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"sendMessages()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שליחה</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/branches/views/groups/group-management/tabs/contacts/contacts.html","<div class=\"hours-container\"><div class=\"action-buttons\"><md-button ng-show=\"$root.AdminLevel>2\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newBranchHour-button\" ng-click=\"addNewContact()\" \naria-label=\"add new Branch hour\" title=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form \nname=\"contactsForm\" class=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס איש קשר</label><md-select \nng-model=\"contactsSearch.Status\" placeholder=\"סינון לפי סטטוס איש קשר\" ng-disabled=\"!groupContacts\"><md-option \nng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"contactsSearch.freeSearchFromDB\" type=\"search\" ng-disabled=\"!groupContacts\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!groupContacts\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getContacts()\">סינון</md-button>\n<md-button ng-disabled=\"!groupContacts\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getContacts(true)\">\nבטל סינון</md-button></div></form></div></div><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!groupContacts\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"groupContacts\"><table id=\"branches-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">טלפון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מייל</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תפקיד</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תצוגה בפרופיל הורה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"entry-code-item\" ng-repeat=\"contact in groupContacts\"><td>{{contact.Name}}</td><td>{{contact.Phone}}\n</td><td>{{contact.Email}}</td><td>{{contact.Role}}</td><td>{{contact.ShowInProfile? \'מוצג\' : \'לא מוצג\'}}</td><td>\n{{contact.Status==1 || contact.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button \nclass=\"preview-user md-icon-button\" ng-click=\"editContact(contact)\" title=\"עריכה\"><md-icon md-svg-icon=\"pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events-extras/views/attendance/meeting-management/tabs/general/general.html","<div><div layout=\"row\" layout-wrap class=\"h50\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" \nflex-gt-md=\"70\" flex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">כללי</div></header><div class=\"content\"><form name=\"MeetingForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"50\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-block md-icon-left\"><label>מאורע</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"meeting.Name\" md-autofocus disabled=\"disabled\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" format=\"DD/MM/YYYY HH:mm\" moment-picker=\"meeting.Date\">\n<label>שעת מפגש</label><input autocomplete=\"off\" ng-model=\"meeting.Date\"></div></md-input-container></div></div><div \nclass=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"50\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-md=\"100\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-format-align-right\"></md-icon><label>הערות</label><textarea ng-model=\"meeting.Comments\" type=\"text\">\n</textarea></md-input-container></div></div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/branches/views/groups/group-management/tabs/general/general.html","<div><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">כללי</div></header><div class=\"content\"><form name=\"GroupForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\">\n<label>שם</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"group.Name\" md-autofocus \nng-disabled=\"$root.AdminLevel==1\"></md-input-container><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><label>\n{{$root.orgTypeBranchName.single}}</label><md-select ng-model=\"group.SettlementID\" ng-required=\"true\" \nng-disabled=\"!settlements.length\"><md-option ng-repeat=\"settlement in settlements\" ng-value=\"settlement.ID\">\n{{settlement.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container\n class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-chair-school\" \nclass=\"name\"></md-icon><label>{{$root.User.Grades}}</label><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"group.Grades\" ng-required=\"true\" multiple=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-disabled=\"!grades || isClicked\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חפש שכבה..\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!grades || isClicked\"><md-option ng-value=\"grade.ID\" ng-repeat=\"grade in grades |filter:searchTerm\">\n{{grade.Name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-power\" class=\"name\">\n</md-icon><label>סטטוס</label><md-select ng-model=\"group.Status\" placeholder=\"סטטוס\" ng-disabled=\"$root.AdminLevel<2\">\n<md-option ng-selected=\"group.Status==1 || group.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"group.Status==0 || group.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/events-extras/views/attendance/meeting-management/tabs/attendance/attendance.html","<div id=\"attendance\" class=\"page-layout simple tabbed\"><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!attendance\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-if=\"attendance\"><table id=\"attendance-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תעודת זהות</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">נייד</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס נוכחות</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">הערות</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"member in attendance\"><td class=\"sflex w100 aic jcfs height-100\"><md-button class=\"md-icon-button cp\" \nng-click=\"markMember(member)\" aria-label=\"Close Dialog\" ng-disabled=\"member.Attendance\"><md-icon \nmd-font-icon=\"icon-check\" ng-class=\"{\'disabled\': member.Attendance}\"></md-icon></md-button></td><td>\n{{member.StudentName && member.StudentName.length? member.StudentName : (member.ParentName && member.ParentName.length? member.ParentName : member.UserName)}}\n</td><td>{{member.PrivateID}}</td><td>\n{{member.MemberPhoneNumber && member.MemberPhoneNumber.length? member.MemberPhoneNumber : member.UserPhone}}</td><td>\n<div class=\"sflex fdc\"><label>סטטוס</label><select ng-model=\"member.Attendance\" ng-change=\"updateAttendance(member)\">\n<option ng-repeat=\"status in statusArray\" ng-value=\"status\">{{status}}</option></select></div></td><td>\n<md-input-container><label>הערות</label><input ng-model=\"member.Comments\" ng-blur=\"updateAttendance(member)\">\n</md-input-container></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/admin/coordinators/coordinators-profile/tabs/events/new-coordinator-event-dialog/new-coordinator-event-dialog.html","<md-dialog class=\"newCoordinatorEvent-dialog\" aria-label=\"New Task\"><form name=\"newCoordinatorEventForm\" \ndata-ng-model=\"newCoordinatorEventForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">הוספת {{$root.User.Coordinator}} חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label>מאורע</label><md-icon md-svg-icon=\"weather-sunny\"></md-icon>\n<md-select md-on-close=\"clearSearchTerm()\" ng-model=\"newEvent.eventID\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nng-keyup=\"eventKeyPress($event)\" placeholder=\"חפש מאורע..\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup ng-disabled=\"events\"><md-option ng-value=\"event.ID\" \nng-repeat=\"event in events |filter:searchTerm\">{{event.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newCoordinatorEventForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNewCoordinatorEvent()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/branches/views/groups/group-management/tabs/students/students.html","<div class=\"members-container\"><div><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">חניכים\n</div></header><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"!groupStudents\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"groupStudents\"><table id=\"students-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תעודות זהות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מין</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">דואר אלקטרוני</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th></tr></thead><tbody><tr \nclass=\"md-ink-ripple\" ng-repeat=\"student in groupStudents\"><td>{{student.PrivateID}}</td><td><a class=\"cp\" \nhref=\"/student-profile?ID={{student.ID}}\">{{student.FirstName}} {{student.LastName}}</a></td><td><span \nng-if=\"student.Gender==\'Male\'\">בן</span> <span ng-if=\"student.Gender==\'Female\'\">בת</span> <span \nng-if=\"student.Gender==\'Other\'\">אחר</span> <span ng-if=\"student.Gender==null || student.Gender.length == 0\"></span>\n</td><td><a href=\"mailto: {{student.Email}}\">{{student.Email}}</a></td><td>{{student.GradeName}}</td></tr></tbody>\n</table></div></div></div><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">הורים</div></header><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!groupParents\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-if=\"groupParents\"><table id=\"parents-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תעודות זהות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מין</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">דואר אלקטרוני</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th></tr></thead><tbody><tr \nclass=\"md-ink-ripple\" ng-repeat=\"parent in groupParents\"><td>{{parent.PrivateID}}</td><td><a class=\"cp\" \nhref=\"/parent-profile?ID={{parent.ID}}\">{{parent.FirstName}} {{parent.LastName}}</a></td><td><span \nng-if=\"parent.Gender==\'Male\'\">בן</span> <span ng-if=\"parent.Gender==\'Female\'\">בת</span> <span \nng-if=\"parent.Gender==\'Other\'\">אחר</span> <span ng-if=\"parent.Gender==null || parent.Gender.length == 0\"></span></td>\n<td><a href=\"mailto: {{parent.Email}}\">{{parent.Email}}</a></td><td>{{parent.GradeName}}</td></tr></tbody></table>\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/association/association.html","<div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!association\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"association\"><div layout=\"row\" layout-wrap \nlayout-align=\"space-between\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"70\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">שיוכים נוספים</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate>\n<div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>מין</label>\n<md-icon md-svg-icon=\"gender-male-female\"></md-icon><md-select ng-model=\"event.Gender\" placeholder=\"מין\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"0\" ng-selected=\"event.Gender==\'0\'\">הכל</md-option><md-option ng-selected=\"event.Gender==\'1\'\" ng-value=\"\'1\'\">\nזכר</md-option><md-option ng-selected=\"event.Gender==\'2\'\" ng-value=\"\'2\'\">נקבה</md-option></md-select>\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>\n{{$root.User.Event}} עבור מדריכים בלבד</label><md-icon md-svg-icon=\"tie\"></md-icon><md-select \nng-model=\"event.EducatorsOnly\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div></div><div \nclass=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>קהל יעד</label>\n<md-icon md-font-icon=\"icon-account-switch\"></md-icon><md-select ng-model=\"event.OpenRegistrationTo\" \nplaceholder=\"קהל יעד\" ng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\">\n<md-option ng-value=\"1\">חניכים</md-option><md-option ng-value=\"2\">הורים</md-option><md-option ng-value=\"3\">\nחניכים + הורים</md-option></md-select></md-input-container></div></div></form></div></div><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nשיוך {{$root.User.Grades}} ו{{$root.orgTypeBranchName.plural}}<md-icon md-font-icon=\"icon-information\" \ntitle=\"במידה ולא נבחרו שיוכים ה{{$root.User.Event}} פתוח לכל {{$root.User.Grades}}  וה{{$root.orgTypeBranchName.plural}} הפעילים\">\n</md-icon></div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" \nflex=\"100\"><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"100\" title=\"התחל לרשום שם {{$root.orgTypeBranchName.single}}\"><label>\n{{$root.orgTypeBranchName.single}}</label><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"association.Settlements\" multiple=\"multiple\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.orgTypeBranchName.single}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\">\n<md-option ng-value=\"settlement.ID\" ng-repeat=\"settlement in settlements |filter:searchTerm\">{{settlement.Name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"100\" \ntitle=\"התחל לרשום שם {{$root.User.Grade}}\"><label>{{$root.User.Grades}}</label><md-select \nmd-on-close=\"clearSearchTerm()\" ng-model=\"association.Grades\" multiple=\"multiple\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Grades}}\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\"><md-option ng-value=\"grade.ID\" \nng-repeat=\"grade in grades |filter:searchTerm\">{{grade.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" ng-disabled=\"isClick || $root.AdminLevel==1\" \nclass=\"md-accent md-raised md-button md-ink-ripple\" aria-label=\"שמור את השדות\" ng-click=\"updateEventAssociation()\">\n<span>עדכן</span></md-button></form></div></div></div><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" \nflex-gt-md=\"25\" flex-gt-lg=\"35\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg sflex jcsb aic\"><div class=\"title\">שיוך תושבים<md-icon md-font-icon=\"icon-information\" \ntitle=\"במידה וקיימים שיוכים אחרים - שיוכים לפי תושב לא יעבדו\"></md-icon></div><div class=\"inrowf aic\">\n<md-input-container class=\"md-icon-float md-block m0\"><md-select ng-model=\"filters\" ng-change=\"filterGeneral()\">\n<md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">\nלא פעילים</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" aria-label=\"הוסף שיוך\" \ntitle=\"הוספת שיוך\" ng-click=\"addNewStudentAssociation()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"הורדת קובץ טעינה ריק\" title=\"הורדת קובץ טעינה ריק\" \nng-click=\"downloadEmptyStudentsAssociationFile()\"><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"הוסף תושבים\" title=\"טעינת אקסל\" \nng-click=\"uploadExcelFile()\"><md-icon md-svg-icon=\"file-excel\"></md-icon></md-button></div></header><div \nclass=\"content\"><table class=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">סוג תושב</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם תושב</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ת.ז.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"member in association.Members | filter: {Status: filters}\"><td><span ng-if=\"member.StudentID\">חניך</span> \n<span ng-if=\"member.ParentID\">הורה</span></td><td><span ng-if=\"member.StudentID\">{{member.StudentName}}</span> <span \nng-if=\"member.ParentID\">{{member.ParentName}}</span></td><td><span ng-if=\"member.StudentID\">{{member.StudentPrivateID}}\n</span> <span ng-if=\"member.ParentID\">{{member.ParentPrivateID}}</span></td><td><md-input-container><label>סטטוס\n</label><md-select ng-model=\"member.Status\" ng-change=\"changeStudentStatus(member)\"><md-option ng-value=\"1\">פעיל\n</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></td></tr></tbody></table>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/donations/donations.html","<div id=\"donations\" class=\"page-layout simple tabbed\" ng-init=\"getDonations();\"><div class=\"content\"><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!donations\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"donations\"><table id=\"type-subscribers-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם חניך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מחיר ששולם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תרומה</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"donation in donations\"><td>{{donation.ID}}</td><td>{{donation.StudentName}}</td><td>{{donation.FinalPrice}}\n</td><td>{{donation.DonationAmount}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/discounts.html","<div ng-controller=\"EventDiscountsController\" id=\"event-discounts\" class=\"page-layout simple tabbed\"><div \nclass=\"content\" flex><md-tabs md-dynamic-height><md-tab ng-disabled=\"$root.isEdit && selectedTab!=0\" \nmd-on-select=\"setTab(0)\"><md-tab-label><span>דרגת הנחה למשפחה</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/discount-levels.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=1\" md-on-select=\"setTab(1)\">\n<md-tab-label><span>הנחת משפחה</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/brothers-discounts.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=1\" md-on-select=\"setTab(2)\">\n<md-tab-label><span>הנחות לפי כמות הרשמות</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/registration-discounts.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=2\" md-on-select=\"setTab(3)\">\n<md-tab-label><span>הנחות כלליות</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/general-discounts.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=3\" md-on-select=\"setTab(4)\">\n<md-tab-label><span>הנחות תושבים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/student-discounts.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"$root.isEdit && selectedTab!=4\" md-on-select=\"setTab(5)\">\n<md-tab-label><span>הנחות לפי תאריכים</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/events/views/events/event-management/tabs/discounts/tabs/date-discounts.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/files/files.html","<div ng-controller=\"EventManagementFilesController\"><div layout=\"row\" layout-wrap layout-align=\"space-between\"><div \nclass=\"event-files\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" flex-gt-lg=\"50\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div \nclass=\"md-toolbar-tools\"><div class=\"title\">תנאי השתתפות</div><div class=\"md-button\"><md-button class=\"md-icon-button\" \naria-label=\"הוספת קובץ\" ng-click=\"uploadNewFileToEvent()\" ng-disabled=\"$root.AdminLevel==1\" title=\"הוספת קובץ חדש\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar><div class=\"content\"><p \nclass=\"md-caption\" ng-show=\"!isClicked && eventFiles.length>0\">\nלבחירת כל ה{{$root.orgTypeBranchName.plural}} יש להשאיר את הבחירה ריקה</p><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!eventFiles || !eventFiles\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table ng-show=\"!isClicked && eventFiles.length>0\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך העלאה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.plural}}</span>\n</div></th><th class=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div>\n</th></tr></thead><tbody><tr class=\"main-table-new\" ng-repeat=\"file in eventFiles\"><td><md-icon \nmd-font-icon=\"{{file.Icon}}\"></md-icon></td><td>{{file.Name}}</td><td>{{file.UploadTime | cmdate:\'dd/MM/yyyy\'}}</td>\n<td><md-input-container class=\"md-block\"><label>סטטוס</label><md-select ng-model=\"file.Status\" placeholder=\"סטטוס\">\n<md-option ng-selected=\"file.Status==1 || file.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"file.Status==0 || file.Status==\'0\' \" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</td><td><md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\"><label>\n{{$root.orgTypeBranchName.plural}}</label><md-select ng-model=\"file.selectedSettlements\" multiple=\"multiple\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm2\" type=\"text\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.orgTypeBranchName.single}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"settlement in file.Settlements | orderBy:\'Name\' | filter:searchTerm2\" ng-value=\"settlement\">\n{{settlement.Name}}</md-option></md-optgroup></md-select></md-input-container></td><td><a href=\"{{file.Path}}\" \ntarget=\"_blank\"><md-button aria-label=\"הצגה\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n</md-button></a></td></tr></tbody></table></div></div></div><div class=\"event-files\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\" flex-gt-lg=\"45\" ng-if=\"true || activeModule.healthDeclaration\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div \nclass=\"md-toolbar-tools\"><div class=\"title\">הצהרת בריאות</div><div class=\"md-button\"><md-button \nng-if=\"event.HealthDeclaration.length\" class=\"md-icon-button\" title=\"צפייה בהצהרת בריאות\" \nng-click=\"viewFile(event.healthDeclaration)\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"uploadHealthDeclarationFile()\" title=\"שינויי הצהרת בריאות\"><md-icon \nng-click=\"uploadHealthDeclarationFile()\" md-svg-icon=\"upload\"></md-icon></md-button><md-button class=\"md-icon-button\" \naria-label=\"הוספת תזמון\" ng-click=\"addNewScheduler()\" title=\"הוספת תזמון חדש\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></div></md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!eventHealthDeclarationSchedulers\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-repeat=\"scheduler in eventHealthDeclarationSchedulers\"><div \nclass=\"sflex jcsb aic\" ng-class=\"{\'executed\':scheduler.Executed}\"><md-input-container class=\"md-block col5s10\"><label>\nסוג תזמון</label><md-select ng-model=\"scheduler.SendByMeetingTime\" ng-change=\"saveScheduler(scheduler)\" \nplaceholder=\"סוג תזמון\" required class=\"hfs16\"><md-option ng-value=\"0\">בחירת שעה</md-option><md-option ng-value=\"1\" \nng-disabled=\"event.RepeatType != 2\">לפני מפגש</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block col5s10\" ng-if=\"scheduler.SendByMeetingTime == 0\"><label>שעת הפעלה</label><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY HH:mm\" moment-picker=\"scheduler.Timestamp\" change=\"saveScheduler(scheduler)\"><input \nclass=\"md-input hfs16\" autocomplete=\"off\" ng-model=\"scheduler.Timestamp\" required></div></md-input-container>\n<md-input-container class=\"md-block col5s10\" ng-if=\"scheduler.SendByMeetingTime == 1\"><label>שעות לפני המפגש</label>\n<md-select ng-model=\"scheduler.Timestamp\" ng-change=\"saveScheduler(scheduler)\" placeholder=\"שעות לפני המפגש\" required \nclass=\"hfs16\"><md-option ng-repeat=\"hour in generate24Hours()\" ng-value=\"hour\">{{hour}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block col5s10\"><label>שליחה באמצעות</label><md-select \nng-model=\"scheduler.Interface\" ng-change=\"saveScheduler(scheduler)\" placeholder=\"שליחה באמצעות\" required class=\"hfs16\">\n<md-option ng-value=\"1\">SMS</md-option><md-option ng-value=\"2\">אימייל</md-option><md-option ng-value=\"3\">SMS + אימייל\n</md-option></md-select></md-input-container><md-input-container class=\"md-block col5s10\"><label>נמענים</label>\n<md-select ng-model=\"scheduler.Addressee\" ng-change=\"saveScheduler(scheduler)\" placeholder=\"נמענים\" required \nclass=\"hfs16\"><md-option ng-value=\"1\" ng-if=\"event.EventType == 1\">נרשמים</md-option><md-option ng-value=\"1\" \nng-if=\"event.EventType == 0\">חניכים</md-option><md-option ng-value=\"2\" ng-if=\"event.EventType == 0\">הורים</md-option>\n<md-option ng-value=\"3\" ng-if=\"event.EventType == 0\">הורים + חניכים</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block col5s10\"><label>סטטוס</label><md-select ng-model=\"scheduler.Status\" \nng-change=\"saveScheduler(scheduler)\" placeholder=\"סטטוס\" required class=\"hfs16\"><md-option ng-value=\"1\">פעיל\n</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/general/general.html","<div ng-init=\"getCoordinators()\"><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-accent-bg\"><div class=\"title\">כללי</div></header><div class=\"content\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><label>שם</label><md-icon md-svg-icon=\"weather-sunny\"></md-icon><input \nng-model=\"event.Name\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>מזהה יחודי</label><md-icon \nmd-svg-icon=\"weather-sunny\"></md-icon><input ng-model=\"event.UniqueID\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon\n md-svg-icon=\"clipboard-text\"></md-icon><label>תיאור</label><textarea ng-model=\"event.Description\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nstyle=\"max-height:100px;overflow: auto\"></textarea></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><label>הערות</label><md-icon md-svg-icon=\"comment-text-outline\"></md-icon><textarea \nng-model=\"event.Comments\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nstyle=\"max-height:100px\"></textarea></md-input-container></div></div><div><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-svg-icon=\"clipboard-text\"></md-icon><label>שעות פעילות</label><textarea \nng-model=\"event.TimeDescription\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nstyle=\"max-height:100px;overflow: auto\"></textarea></md-input-container></div><div class=\"row\" layout=\"row\"><div \nclass=\"half\" \nng-if=\"$root.memberYearLogicEnabled && event.EventType != 1 && !event.IsProduct && activeModule.memberEvents\">\n<md-input-container class=\"md-icon-float md-block\"><label>{{$root.User.Event}} דמי חבר</label><md-icon \nmd-svg-icon=\"account-card-details\"></md-icon><md-select ng-model=\"event.MemberEvent\" \nplaceholder=\"{{$root.User.Event}} דמי חבר\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nng-change=\"checkIfYearIsSet()\"><md-option ng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select>\n</md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-if=\"event.EventType != 1 && !event.IsProduct && activeModule.monthlyPayment\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><label>אירוע חוזר</label><md-icon md-font-icon=\"icon-repeat\"></md-icon><md-select \nng-model=\"event.RepeatType\" placeholder=\"אירוע חוזר\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"0\">חד פעמי</md-option><md-option ng-value=\"1\">תאריכים מסויימים</md-option><md-option ng-value=\"2\">שבועי\n</md-option></md-select></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\" \nng-if=\"event.EventType == 1\"><md-input-container class=\"md-icon-float md-block\"><label>הכנס כתובת</label><md-icon \nmd-svg-icon=\"earth\"></md-icon><input vs-google-autocomplete vs-autocomplete-validator ng-model=\"event.Address\" \ntype=\"text\" name=\"place\" id=\"place\" vs-latitude=\"event.Lat\" vs-longitude=\"event.Lng\"></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>{{$root.User.Coordinator}} אחראי</label><md-icon\n md-font-icon=\"icon-tie\"></md-icon><md-select ng-model=\"event.CoordinatorID\" \nng-disabled=\"$root.AdminLevel!=3 || ! coordinators\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"{{$root.User.Coordinator}} אחראי\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"coordinator in coordinators | filter:searchTerm\" ng-value=\"coordinator.ID\">\n{{coordinator.FirstName}} {{coordinator.LastName}}</md-option></md-optgroup></md-select></md-input-container></div>\n</div><div class=\"row\" layout=\"row\"><div class=\"half\" ng-if=\"event.EventType != 1\"><md-input-container \nclass=\"md-icon-float md-block\"><label>ביטול הנחת אחים - עסקה מפוצלת</label><md-icon md-svg-icon=\"account-off\">\n</md-icon><md-select ng-model=\"event.DisableBrotherDiscount\" placeholder=\"ביטול הנחת אחים - עסקה מפוצלת\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-selected=\"event.DisableBrotherDiscount==1 || event.DisableBrotherDiscount==\'1\'\" ng-value=\"1\">כן</md-option>\n<md-option ng-selected=\"event.DisableBrotherDiscount==0 || event.DisableBrotherDiscount==\'0\'\" ng-value=\"0\">לא\n</md-option></md-select></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><label>סטטוס</label><md-icon md-svg-icon=\"power\"></md-icon><md-select \nng-model=\"event.Status\" placeholder=\"סטטוס\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-selected=\"event.Status==1 || event.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"event.Status==0 || event.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</div></div><div class=\"row\" layout=\"row\"><div class=\"half\" ng-if=\"event.EventType != 1\"><md-input-container \nclass=\"md-icon-float md-block\"><label>{{$root.User.Event}} מאסטר</label><md-icon md-svg-icon=\"crown\"></md-icon>\n<md-select md-on-close=\"clearSearchTerm()\" ng-model=\"event.ParentEventID\" \nng-disabled=\"isClicked || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"!events || isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Event}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"isClicked || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option value=\"0\">ללא\n</md-option><md-option ng-value=\"parentEvent.ID\" ng-repeat=\"parentEvent in events |filter:searchTerm\">\n{{parentEvent.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"half\" \nng-if=\"event.EventType != 1\"><md-input-container class=\"md-icon-float md-block\"><label>רמה</label><md-icon \nmd-svg-icon=\"numeric\"></md-icon><md-select ng-model=\"event.Level\" placeholder=\"רמה\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"1\">מאסטר</md-option><md-option ng-value=\"0\">רגיל</md-option></md-select></md-input-container></div></div><div\n class=\"row\" layout=\"row\"><div class=\"half\" \nng-if=\"$root.memberYearLogicEnabled && event.EventType != 1 && activeModule.memberEvents\" \nng-show=\"event.MemberEvent!=1\"><md-input-container class=\"md-icon-float md-block\"><label>מחייב הרשמה לדמי חבר לשנת\n</label><md-icon md-svg-icon=\"account-plus\"></md-icon><md-select ng-model=\"event.MinMemberYear\" \nplaceholder=\"מינימום שנת דמי חבר\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"0\">ללא</md-option><md-option ng-value=\"2015\">תשע\"ה</md-option><md-option ng-value=\"2016\">תשע\"ו</md-option>\n<md-option ng-value=\"2017\">תשע\"ז</md-option><md-option ng-value=\"2018\">תשע\"ח</md-option><md-option ng-value=\"2019\">\nתשע\"ט</md-option><md-option ng-value=\"2020\">תש\"פ</md-option><md-option ng-value=\"2021\">תשפ\"א</md-option></md-select>\n</md-input-container></div><div class=\"half\" \nng-if=\"$root.memberYearLogicEnabled && event.EventType != 1 && !event.IsProduct && activeModule.memberEvents\" \nng-show=\"event.MemberEvent==1\"><md-input-container class=\"md-icon-float md-block\"><label>\nשנת {{$root.User.Event}} דמי חבר</label><md-icon md-svg-icon=\"calendar-range\"></md-icon><md-select \nng-model=\"event.MemberYear\" placeholder=\"שנת {{$root.User.Event}} דמי חבר\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID) || event.MemberEvent!=1\" \nng-required=\"event.MemberEvent==1\"><md-option ng-value=\"0\">ללא</md-option><md-option ng-value=\"2015\">תשע\"ה</md-option>\n<md-option ng-value=\"2016\">תשע\"ו</md-option><md-option ng-value=\"2017\">תשע\"ז</md-option><md-option ng-value=\"2018\">\nתשע\"ח</md-option><md-option ng-value=\"2019\">תשע\"ט</md-option><md-option ng-value=\"2020\">תש\"פ</md-option><md-option \nng-value=\"2021\">תשפ\"א</md-option></md-select></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><label>שיוך לקטגוריה</label><md-icon md-svg-icon=\"apps\"></md-icon><md-select \nng-model=\"event.CategoryID\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nplaceholder=\"שיוך לקטגוריה\"><md-option ng-repeat=\"category in categories\" ng-value=\"category.ID\">\n{{category.Path.join(\' › \')}}</md-option></md-select></md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-if=\"event.IsProduct\"><div class=\"half\" ng-if=\"event.IsProduct\"><md-input-container class=\"md-icon-float md-block\">\n<label>האם לנהל מלאי</label><md-icon md-svg-icon=\"shopping\"></md-icon><md-select ng-model=\"event.Inventory\" \nplaceholder=\"האם לנהל מלאי\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div><div \nclass=\"half\" ng-if=\"event.Inventory\"><md-input-container class=\"md-icon-float md-block\"><label>מלאי</label><md-icon \nmd-svg-icon=\"shopping\"></md-icon><input ng-model=\"event.InventoryAmount\" type=\"number\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div></div><div class=\"row\" layout=\"row\" layout-xs=\"column\" ng-if=\"event.EventType == 1\"><div class=\"half\">\n<md-input-container class=\"md-icon-float md-block\"><label>אפשר בחירת כמות כרטיסים</label><md-icon md-svg-icon=\"earth\">\n</md-icon><md-select ng-model=\"event.ShowQuantity\" placeholder=\"אפשר בחירת כמות כרטיסים\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"1\">כן</md-option><md-option ng-value=\"0\">לא</md-option></md-select></md-input-container></div><div \nclass=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>מלל לבחירת כמות כרטיסים</label><md-icon \nmd-svg-icon=\"face\"></md-icon><input ng-model=\"event.QuantityText\" type=\"text\" md-autofocus \nng-disabled=\"$root.AdminLevel==1\"></md-input-container></div></div><div class=\"row\" layout=\"row\" layout-xs=\"column\" \nng-if=\"!event.IsProduct\"><div class=\"half\" ng-if=\"event.EventType != 1\"><md-input-container \nclass=\"md-icon-float md-block\"><label>שיטת צבירת הנחות</label><md-icon md-svg-icon=\"sale\"></md-icon><md-select \nng-model=\"event.DiscountType\" placeholder=\"שיטת צבירת הנחות\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"0\">הנחה מהמחיר המקורי</md-option><md-option ng-value=\"1\">הנחה מהסכום הנצבר</md-option></md-select>\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>\nהגבלת כמות נרשמים</label><md-icon md-svg-icon=\"face\"></md-icon><input ng-model=\"event.MaxRegs\" type=\"number\" \nmd-autofocus ng-disabled=\"$root.AdminLevel==1\"></md-input-container></div></div><div class=\"row\" layout=\"row\" \nlayout-xs=\"column\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>מקור הרשמה</label>\n<md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><md-select ng-model=\"event.ExposeToRegistrations\" \nplaceholder=\"זמינות להרשמה\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"0\">אדמין בלבד</md-option><md-option ng-value=\"1\">זמין לכולם</md-option></md-select></md-input-container>\n</div><div class=\"half\" ng-if=\"event.ExposeToRegistrations == 1\"><md-input-container class=\"md-icon-float md-block\">\n<label>זמינות להרשמה</label><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><md-select \nng-model=\"event.RegAvailable\" placeholder=\"זמינות להרשמה\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"><md-option \nng-value=\"0\">לינק בלבד</md-option><md-option ng-value=\"1\">זמין לכולם</md-option></md-select></md-input-container></div>\n</div><div class=\"row\" layout=\"row\" layout-xs=\"column\" \nng-if=\"!event.IsProduct && event.Level != 1 && activeModule.eventDates\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" \nformat=\"DD/MM/YYYY HH:mm\" moment-picker=\"event.StartDate\"><label>תאריך התחלה</label><input autocomplete=\"off\" \nng-model=\"event.StartDate\" required \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></div>\n</md-input-container></div><div class=\"half\"><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" format=\"DD/MM/YYYY HH:mm\" moment-picker=\"event.EndDate\">\n<label>תאריך סיום</label><input autocomplete=\"off\" ng-model=\"event.EndDate\" required \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></div>\n</md-input-container></div></div><div class=\"row\" layout=\"row\" \nng-if=\"event.Level != 1 && activeModule.registrationDates\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" \nformat=\"DD/MM/YYYY HH:mm\" moment-picker=\"event.RegistrationStartDate\"><label>התחלת רישום</label><input \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" autocomplete=\"off\" \nng-model=\"event.RegistrationStartDate\" required></div></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" \nformat=\"DD/MM/YYYY HH:mm\" moment-picker=\"event.RegistrationEndDate\"><label>סיום רישום</label><input \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" autocomplete=\"off\" \nng-model=\"event.RegistrationEndDate\" required></div></md-input-container></div></div><div ng-if=\"!event.IsProduct\">\n<md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon md-svg-icon=\"account-box\" class=\"name\">\n</md-icon><label>קבוצות אירוע</label><md-chips ng-model=\"event.Groups\" placeholder=\"הוספת קבוצות\"></md-chips>\n</md-input-container></div><div ng-if=\"!event.IsProduct && activeModule.name == \'Events\'\" class=\"row\" layout=\"row\"><div\n class=\"half\"><md-input-container class=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-city\" \nclass=\"name\"></md-icon><label>סוג אירוע</label><md-select ng-model=\"newEvent.EventTypeName\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nplaceholder=\"סוג אירוע\"><md-option ng-value=\"1\">תנועה</md-option><md-option ng-value=\"2\">חברתי</md-option><md-option \nng-value=\"0\">אחר</md-option></md-select></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><md-select \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nng-model=\"event.ExposeToExternalOrganization\"><md-option ng-value=\"0\">אירוע פנימי</md-option><md-option ng-value=\"1\">\nאירוע חשוף</md-option></md-select></md-input-container></div></div><div \nng-if=\"!event.IsProduct && activeModule.name == \'Events\'\"><md-input-container \nng-if=\"event.ExposeToExternalOrganization === 1\" class=\"md-icon-float md-block md-icon-left\"><label>תנועת נוער</label>\n<md-icon md-font-icon=\"icon-domain\"></md-icon><md-contact-chips ng-model=\"event.ExposedOrganizations\" \nmd-contacts=\"organizationsQuerySearch($query)\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nmd-contact-name=\"Name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"true\" \nplaceholder=\"בחר תנועות נוער\"></md-contact-chips></md-input-container></div><div \nng-if=\"locations && activeModule.sittingPlaces\" class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-bank\" class=\"name\"></md-icon><label>אולם\n</label><md-select \nng-disabled=\"disableLocationSelect || $root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" \nng-model=\"event.LocationID\" placeholder=\"אולם\"><md-option>ללא</md-option><md-option ng-repeat=\"location in locations\" \nng-value=\"location.ID\">{{location.Name}}</md-option></md-select></md-input-container></div></div><div class=\"row\" \nlayout=\"row\" ng-if=\"event.LocationID && event.RepeatType == 0\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" \nformat=\"DD/MM/YYYY HH:mm\" moment-picker=\"event.LocationStartDate\"><label>התחלת שימוש באולם</label><input \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" autocomplete=\"off\" \nng-model=\"event.LocationStartDate\"></div></md-input-container></div><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block md-icon-left\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" \nformat=\"DD/MM/YYYY HH:mm\" moment-picker=\"event.LocationEndDate\"><label>סיום שימוש באולם</label><input \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\" autocomplete=\"off\" \nng-model=\"event.LocationEndDate\"></div></md-input-container></div></div><div class=\"row\" layout=\"row\" \nlayout-xs=\"column\" ng-if=\"event.EventType == 1\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\">\n<label>הגבלת כמות כרטיסים להרשמה</label><md-icon md-svg-icon=\"face\"></md-icon><input \nng-model=\"event.RegistrationLimit\" type=\"number\" md-autofocus ng-disabled=\"$root.AdminLevel==1\"></md-input-container>\n</div></div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/location/location.html","<div id=\"event-location\" class=\"page-layout simple tabbed\"><div class=\"content\"><div class=\"action-buttons\"><md-button \nclass=\"md-fab md-accent md-icon-button mb10 new\" ng-click=\"getEventLocationReport()\" aria-label=\"add\" \ntitle=\'דו\"ח הושבה\'><md-icon md-font-icon=\"icon-file-excel\"></md-icon></md-button></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!event.location\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"event.location\"><div id=\"row-seats-layout\" class=\"sflex fdc\"><div \nid=\"section-seats-layout\" class=\"sflex fdc jcc mt10\" ng-repeat=\"section in event.location.layout track by $index\"><div \nclass=\"center hfs18 fw-bold\">איזור {{section.Name}}</div><div ng-repeat=\"row in section.Rows track by $index\" \nclass=\"fcc\"><div>שורה {{row.Name}}</div><div ng-repeat=\"seat in row.Seats track by $index\" class=\"seat center fcc\" \nng-click=\"seat.notAvailable != 2 && !seat.taken && markSeatAsNotAvailable(section.ID,row.ID,seat.ID,seat)\" \nng-class=\"{\'free\': !seat.taken, \'taken\': seat.taken, \'notAvailable\': seat.notAvailable, \'cp\' : seat.notAvailable != 2 && !seat.taken}\">\n<span><md-tooltip ng-if=\"seat.student\" md-direction=\"left\">{{seat.student}}</md-tooltip>{{seat.Name}}</span></div>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/payments.html","<div class=\"allowOverflow\"><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-accent-bg\"><div class=\"title\">תשלום</div></header><div class=\"content\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"row\" layout=\"row\"><div class=\"half\" \nng-if=\"activeModule.monthlyPayment && event.EventType != 1\"><md-input-container class=\"md-icon-float md-block\"><md-icon\n md-font-icon=\"icon-calendar\" class=\"name\"></md-icon><label>סוג תשלום</label><md-select \nng-model=\"event.MonthlyPayment\" ng-change=\"resetMonthlyPayment()\" placeholder=\"סוג תשלום\"><md-option ng-value=\"0\">בודד\n</md-option><md-option ng-value=\"1\">הוראת קבע</md-option></md-select></md-input-container></div><div class=\"half\" \nng-if=\"event.MonthlyPayment == 1 && $root.AdminLevel == 3\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"name\"></md-icon><label>מחייב אישור מנהל</label><md-select \nng-model=\"event.RegNeedApproval\" placeholder=\"מחייב אישור מנהל\"><md-option ng-value=\"1\">אישור מנהל</md-option>\n<md-option ng-value=\"0\">ללא אישור מנהל</md-option></md-select></md-input-container></div></div><div class=\"row\" \nlayout=\"row\"><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><label>מחיר <span ng-if=\"event.MonthlyPayment\">חודשי</span></label><input \nng-model=\"event.Price\" md-autofocus ng-pattern=\"floadRegex\" placeholder=\"יש להכניס מספר שלם\"></md-input-container>\n</div><div class=\"half\" ng-if=\"event.MonthlyPayment == 1 && event.Level == 1\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>תוספת מחיר חד פעמית</label>\n<input ng-model=\"event.ExtraPrice\" md-autofocus ng-pattern=\"floadRegex\" placeholder=\"יש להכניס מספר שלם\">\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block price-text\"><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>\nמלל במקום מחיר (מלל אשר יוצג במקום המחיר להורה בדף הראשי)</label><textarea ng-model=\"event.PriceText\" type=\"text\" \nmd-autofocus></textarea></md-input-container></div><div class=\"half\" ng-if=\"event.MonthlyPayment != 1\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר תשלומים מקסימלי</label><input type=\"number\" min=\"0\" max=\"{{globalMaxNumOfPayments}}\" ng-model=\"event.MaxPayments\" \nmd-autofocus></md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><label>סעיף תקציבי</label><md-icon md-svg-icon=\"barcode\"></md-icon><input \nng-model=\"event.CostingCode\" \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></md-input-container>\n</div><div class=\"half\"><md-input-container class=\"md-icon-float md-block\"><label>תוכנת הנהלת חשבונות</label><md-icon \nmd-svg-icon=\"desktop-classic\"></md-icon><textarea ng-model=\"event.HashavshevetID\" md-autofocus \nng-disabled=\"$root.AdminLevel==1 || ($root.AdminLevel==2 && event.CoordinatorID!=$root.User.ID)\"></textarea>\n</md-input-container></div></div><div class=\"row\" layout=\"row\"><div class=\"half\"><md-input-container \nclass=\"md-icon-float md-block\"><label>הצגת פרטים נוספים בקבלה</label><md-icon md-font-icon=\"icon-clipboard-text\">\n</md-icon><md-select ng-model=\"event.ReceiptsExtraInfo\" placeholder=\"הצגת פרטים נוספים בקבלה\"><md-option ng-value=\"0\">\nלא</md-option><md-option ng-value=\"1\">כן</md-option></md-select></md-input-container></div><div class=\"half\" \nng-if=\"event.EventType == 0 && event.MonthlyPayment == 1\"><md-input-container class=\"md-icon-float md-block\"><label>\n50% הנחה בהרשמה אחרי ה 15 לחודש</label><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-select \nng-model=\"event.HalfMonthDiscount\" placeholder=\"50% הנחה בהרשמה אחרי ה 15 לחודש\"><md-option ng-value=\"0\">לא</md-option>\n<md-option ng-value=\"1\">כן</md-option></md-select></md-input-container></div></div></form></div></div></div></div><div \nlayout=\"row\" layout-wrap ng-init=\"getPriceBySettlements()\" ng-if=\"event.EventType != 1\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div \nclass=\"title\">מחיר לפי {{$root.orgTypeBranchName.single}} ו{{$root.User.Grades}}<md-icon \nmd-font-icon=\"icon-information\" \ntitle=\"בעת התנגשויות, המחיר יקבע על פי הדיוק הגדול ביותר (קבוצה > {{$root.orgTypeBranchName.single}} ושכבה > {{$root.orgTypeBranchName.single}} \">\n</md-icon></div><div class=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select \nng-model=\"filterSettlements\" placeholder=\"סינון לפי סטטוס\"><md-option ng-value=\"undefined\">הצג הכל</md-option>\n<md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select>\n</md-input-container><md-button class=\"md-icon-button\" title=\"הוספת הנחה\" ng-click=\"createNewPriceBySettlement()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar><div class=\"content\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!priceBySettlements || $root.discountsLoading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table ng-show=\"priceBySettlements\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.single}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grades}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" \nng-repeat=\"priceBySettlement in priceBySettlements | filter:{Status : filterSettlements}\"><td>\n{{priceBySettlement.Price}}</td><td>{{priceBySettlement.SettlementName}}</td><td><span \nng-repeat=\"grade in priceBySettlement.Grades\"><span>{{grade.GradeName}}</span><span ng-if=\"!$last\">,</span></span></td>\n<td><md-button aria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" ng-disabled=\"isClicked\"><md-icon \nmd-font-icon=\"icon-power\" ng-class=\"{\'green600\':priceBySettlement.Status==1, \'red600\':priceBySettlement.Status==0}\" \nng-click=\"changeSettlementPriceStatus(priceBySettlement)\"></md-icon></md-button></td></tr></tbody></table></div></div>\n</div><div layout=\"row\" layout-wrap ng-init=\"getPriceByGroups()\" ng-if=\"event.EventType != 1\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div \nclass=\"title\">מחיר לפי קבוצות<md-icon md-font-icon=\"icon-information\" \ntitle=\"בעת התנגשויות, המחיר יקבע על פי הדיוק הגדול ביותר (קבוצה > {{$root.orgTypeBranchName.single}} ושכבה > {{$root.orgTypeBranchName.single}})\">\n</md-icon></div><div class=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select \nng-model=\"filterGroup\" placeholder=\"סינון לפי סטטוס\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option \nng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container><md-button\n class=\"md-icon-button\" title=\"הוספת הנחה\" ng-click=\"createNewPriceByGroup()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></div></md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!priceByGroups || $root.discountsLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table ng-show=\"priceByGroups\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">קבוצה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"priceByGroup in priceByGroups | filter:{Status : filterGroup}\"><td>{{priceByGroup.Price}}</td><td>\n{{priceByGroup.GroupName}}</td><td><md-button aria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-power\" \nng-class=\"{\'green600\':priceByGroup.Status==1, \'red600\':priceByGroup.Status==0}\" \nng-click=\"changeGroupPriceStatus(priceByGroup)\"></md-icon></md-button></td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/questions/questions.html","<div ng-controller=\"EventManagementQuestionsController\" ng-init=\"getEventQuestions()\"><div layout=\"row\" layout-wrap>\n<div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex jcsb aic\"><div \nclass=\"title\">שאלות</div><div class=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block m0\"><md-select \nng-model=\"filters\" ng-change=\"filterQuestions()\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option \nng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container><md-button\n class=\"md-icon-button\" aria-label=\"הוסף שאלה\" ng-click=\"addQuestionsToEvent()\" ng-disabled=\"$root.AdminLevel==1\" \ntitle=\"הוספת שאלה קיימת\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"הוסף שאלה\" ng-click=\"createNewEventQuestion()\" ng-disabled=\"$root.AdminLevel==1\" \ntitle=\"הוספת שאלה חדשה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></header><div class=\"content\">\n<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!eventQuestions\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"!isClicked && eventQuestions\"><table \nid=\"event-questions-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך הוספה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שאלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סוג שאלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.orgTypeBranchName.single}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"question in questions\"><td>{{question.CreatedAt | cmdate:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>\n{{question.Description}}</td><td>{{setType(question.AnswerType)}}</td><td><span ng-if=\"question.SettlementName\">\n{{question.SettlementName}}</span> <span ng-if=\"!question.SettlementName\">כולם</span></td><td>\n{{question.Status==1 || question.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td><md-button class=\"preview-user\" \nng-click=\"openEventQuestionPanel(question)\" title=\"עריכת שאלה\"><md-icon md-svg-icon=\"pencil\"></md-icon></md-button>\n</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/meeting-days/meeting-days.html","<div class=\"meetings-container\" ng-init=\"getMeetingDays()\"><div class=\"action-buttons\"><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newLMeetingDay-button\" ng-click=\"createMeetingDay()\" \naria-label=\"add new meeting day\" title=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap class=\"pt10\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"80\" \nflex-gt-lg=\"80\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">שעות פעילות</div></header><div class=\"content\"><form name=\"meetingDaysForm\" class=\"md-inline-form\" \nvalidate><div layout=\"row\" layout-wrap ng-repeat=\"meetingDay in meetingDays\" class=\"aic\"><md-input-container \nclass=\"md-block md-icon-left\" ng-if=\"event.RepeatType == 2\" layout=\"column\" flex=\"15\" flex-xs=\"100\"><label>יום</label>\n<md-select ng-model=\"meetingDay.Day\" ng-disabled=\"disableMeetings\" ng-blur=\"updateMeetingDay(meetingDay)\"><md-option \nng-value=\"1\">ראשון</md-option><md-option ng-value=\"2\">שני</md-option><md-option ng-value=\"3\">שלישי</md-option>\n<md-option ng-value=\"4\">רביעי</md-option><md-option ng-value=\"5\">חמישי</md-option><md-option ng-value=\"6\">שישי\n</md-option><md-option ng-value=\"7\">שבת</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-icon-left\" ng-if=\"event.RepeatType == 1\" layout=\"column\" flex=\"20\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"meetingDay.Day\" change=\"updateMeetingDay(meetingDay)\"><label>תאריך</label><input autocomplete=\"off\" \nng-model=\"meetingDay.Day\" ng-disabled=\"disableMeetings\"></div></md-input-container><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"20\" flex-xs=\"100\"><label>משעה</label><input \nng-model=\"meetingDay.StartTime\" required type=\"time\" ng-disabled=\"disableMeetings\" \nng-blur=\"updateMeetingDay(meetingDay)\"></md-input-container><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"20\" flex-xs=\"100\"><label>עד שעה</label><input ng-model=\"meetingDay.EndTime\" required type=\"time\" \nng-disabled=\"disableMeetings\" ng-blur=\"updateMeetingDay(meetingDay)\"></md-input-container><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"20\" flex-xs=\"100\"><label>תיאור</label><input \nng-model=\"meetingDay.description\" type=\"text\" ng-disabled=\"disableMeetings\" ng-blur=\"updateMeetingDay(meetingDay)\">\n</md-input-container><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"20\" flex-xs=\"100\">\n<md-button class=\"md-raised md-accent\" ng-click=\"deleteMeetingDay(meetingDay)\" ng-disabled=\"disableMeetings\"><md-icon \nmd-svg-icon=\"delete\"></md-icon></md-button></md-input-container></div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/transportation/transportation.html","<div ng-controller=\"EventManagementTransportationController\" ng-init=\"getEventTransportation()\"><div layout=\"row\" \nlayout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex jcsb aic\"><div \nclass=\"title\">הסעות</div><div class=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block m0\"><md-select \nng-model=\"filters\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option>\n<md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" \naria-label=\"הוספת הסעה\" ng-click=\"addTransportationToEvent()\" ng-disabled=\"$root.AdminLevel==1\" \ntitle=\"הוספת הסעה קיימת\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"הוספת הסעה\" ng-click=\"addNewTransportationToEvent()\" \nng-disabled=\"$root.AdminLevel==1\" title=\"הוספת הסעה חדשה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div></header><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!eventTransportation\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table \nng-if=\"eventTransportation\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם הסעה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">כיוון</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שיוך</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"item in eventTransportation  | filter: {Status: filters}\"><td>{{item.Name}}</td><td>\n{{item.Way==1 ? \'הלוך\' : \'חזור\'}}</td><td><md-icon md-font-icon=\"icon-power\" class=\"cp\" \nng-class=\"{\'green600\':item.Status==1, \'red600\':item.Status==0}\" ng-click=\"changeTransportationStatus(item)\"></md-icon>\n</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/locations/location-management/tabs/daybook/book.html","<div id=\"location-daybook\" class=\"page-layout simple tabbed\"><div class=\"action-buttons\"><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"calendar-toggle\" ng-click=\"vm.calendarDisplay = !vm.calendarDisplay\" \naria-label=\"switch display\" title=\"שנה תצוגה\"><md-icon ng-if=\"!vm.calendarDisplay\" md-font-icon=\"icon-calendar-select\">\n</md-icon><md-icon ng-if=\"vm.calendarDisplay\" md-font-icon=\"icon-table-large\"></md-icon></md-button></div><div \nclass=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!vm.dayBook\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"vm.dayBook && !vm.calendarDisplay\" class=\"mt50\"><table id=\"location-daybook-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" \ndt-instance=\"vm.dtInstance\" dt-options=\" vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">שם אירוע</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך התחלה אירוע</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך סוף אירוע</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">זמן תחילת שימוש באולם</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">זמן סוף שימוש באולם</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"event in vm.dayBook\"><td><a class=\"cp\" ng-click=\"vm.goToEvent(event.eventID,event.module)\">\n{{event.eventName}}</a></td><td>{{event.startDate}}</td><td>{{event.endDate}}</td><td>{{event.locationStartDate}}</td>\n<td>{{event.locationEndDate}}</td></tr></tbody></table></div><div class=\"center relative\" ms-scroll \nstyle=\"height:100%\" ng-if=\"vm.dayBook && vm.calendarDisplay\"><div class=\"toolbar layout-align-start-center layout-row\" \nlayout=\"row\" layout-align=\"start center\"><button \nclass=\"md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" ng-click=\"vm.calendar.today()\" \ntitle=\"היום\"><md-icon md-font-icon=\"icon-calendar-today\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-calendar-today\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</button> <button class=\"md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.calendar.changeView(\'agendaDay\')\" title=\"תצוגה יומית\"><md-icon md-font-icon=\"icon-view-day\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-view-day\" role=\"img\" aria-hidden=\"true\"></md-icon><div \nclass=\"md-ripple-container\"></div></button> <button \nclass=\"md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" title=\"תצוגה שבועית\"><md-icon md-font-icon=\"icon-view-week\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-view-week\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</button> <button class=\"md-icon-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.calendar.changeView(\'month\')\" title=\"תצוגה חודשית\"><md-icon md-font-icon=\"icon-view-module\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-view-module\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</button></div><div class=\"header-bottom layout-align-center-center layout-row\" layout=\"row\" \nlayout-align=\"center center\"><button class=\"md-icon-button arrow md-button ng-scope md-default-theme md-ink-ripple\" \ntype=\"button\" ng-click=\"vm.calendar.prev()\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-chevron-left\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</button><div class=\"title ng-binding\">{{vm.calendar.view.title}}</div><button \nclass=\"md-icon-button arrow md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.calendar.next()\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-chevron-right\" role=\"img\" aria-hidden=\"true\"></md-icon>\n<div class=\"md-ripple-container\"></div></button></div><div id=\"calendarView\" ui-calendar=\"vm.uiConfig.calendar\" \nng-model=\"vm.dayBookCalendar\" calendar=\"main\"></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/registers/registers.html","<div id=\"registers\" class=\"page-layout simple tabbed\" ng-controller=\"EventManagementSubscribersController\"><div \nclass=\"content\"><div class=\"action-buttons\"><md-button \nng-if=\"$root.AdminLevel>2 || $root.User.Events==1 || $root.User.EventsPay\" \nclass=\"md-fab md-accent md-icon-button mb10\" ng-click=\"openNewRegistrationDialog()\" \nng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" aria-label=\"add\" title=\"הוספת הזמנה\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button ng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" \nclass=\"md-fab md-accent md-icon-button mb10\" ng-click=\"openSendEmail()\" \nng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" aria-label=\"add systemUser\" \ntitle=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\"></md-icon></md-button><md-button \nng-if=\"$root.smsEnabled && ($root.AdminLevel>2 || $root.User.SmsPer)\" class=\"md-fab md-accent md-icon-button mb10\" \nng-click=\"openSendSMS()\" title=\"שליחת הודעה\" ng-disabled=\"!subscribers || subscribers.length==0\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cellphone-android\"></md-icon></md-button><md-button \nng-if=\"$root.AdminLevel>2\" class=\"md-fab md-accent md-icon-button mb10\" ng-click=\"changePaymentsStatus()\" \ntitle=\"אישור סטטוס תשלום\" ng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cash-100\"></md-icon></md-button></div><div layout=\"row\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" \nclass=\"md-inline-form w100\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nid=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><label>חיפוש חופשי\n</label><input ng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!subscribers\"></md-input-container></div>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס הזמנה</label><md-select \nng-model=\"search.Status\" placeholder=\"סינון לפי סטטוס הזמנה\" ng-disabled=\"!subscribers\" ng-init=\"search.Status = 1\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">\nלא פעילים</md-option></md-select></md-input-container></div></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" ng-disabled=\"!subscribers\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"getSubscribers()\">סינון</md-button><md-button ng-disabled=\"!subscribers\" class=\"md-raised md-accent\" \naria-label=\"חפש\" ng-click=\"getSubscribers(true)\">בטל סינון</md-button></div></form></div></div></div><div \nclass=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!subscribers\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"subscribers\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><input ng-model=\"selectAll\" \ntype=\"checkbox\" ng-change=\"setAll(selectAll)\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">תאריך הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם החניך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מחיר {{$root.User.Event}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">אמצעי תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סה\"כ תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס הזמנה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">זיכוי</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">פעולות</span>\n</div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"(registrationKey,registrationValue) in subscribers\"><td><input type=\"checkbox\" \nng-model=\"registrationValue.Selected\"></td><td>{{registrationValue.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}\n</td><td><a ng-click=\"goToStudentProfile(registrationValue)\" style=\"cursor: pointer\">\n{{registrationValue.FirstName}} {{registrationValue.LastName}}</a></td><td>{{registrationValue.BranchName}}</td><td>\n<span>{{registrationValue.EventPrice}}</span></td><td>{{registrationValue.PaymentType}}</td><td \nng-init=\"getFinalPrice(registrationKey,registrationValue)\">{{registrationValue.FinalPrice}}</td><td>\n{{registrationValue.Status==\'1\' ? \'פעיל\' : \'לא פעיל\'}}</td><td>{{registrationValue.PaymentStatus | paymentStatus}}</td>\n<td><a href=\"#\" ng-click=\"downloadReceipt(registrationValue.ReceiptID)\">{{registrationValue.ReceiptID}}</a></td><td><a \nhref=\"#\" ng-click=\"downloadReceipt(registrationValue.RefundID)\">{{registrationValue.RefundID}}</a></td><td><md-button \nng-disabled=\"$root.AdminLevel!=3 || registrationValue.Canceled>0\" class=\"preview-user\" \nng-click=\"cancelRegistration(registrationValue)\" \ntitle=\"{{registrationValue.Canceled==\'0\' ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\"><md-icon \nng-class=\"{\'canceled\': registrationValue.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-disabled=\"($root.AdminLevel!=3 && $root.User.AccountancyPer != 1) || registrationValue.RefundDate\" \nclass=\"preview-user\" ng-click=\"refundRegistration(registrationValue)\" \ntitle=\"{{!registrationValue.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\"><md-icon \nng-class=\"{\'refunded\': registrationValue.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button>\n<md-button class=\"preview-user\" ng-click=\"showFullRegistration(registrationValue)\" title=\"צפייה בפרטי הזמנה\"><md-icon \nmd-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"50\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">כללי</div></header><div class=\"content\" style=\"padding: 50px\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div class=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"parent.LastLogin\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-clock\" class=\"name\"></md-icon><label>תאריך התחברות אחרון\n</label><input ng-if=\"parent.LastLogin\" ng-value=\"parent.LastLogin*1000 | date:\'HH:mm:ss dd/MM/yyyy\'\" \nng-disabled=\"true\"> <input ng-if=\"!parent.LastLogin\" ng-value=\"\'לא התבצע חיבור למערכת\'\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"parent.Birthday\"><label>תאריך לידה</label><input \nautocomplete=\"off\" ng-model=\"parent.Birthday\"></div></md-input-container></div><div class=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>תעודות זהות</label>\n<input ng-model=\"parent.PrivateID\" ng-disabled=\"true\" type=\"text\" md-autofocus></md-input-container><md-input-container\n class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-phone\" class=\"name\"></md-icon><label>טלפון בבית</label><input \nng-model=\"parent.PhoneNumber\" type=\"text\" md-autofocus></md-input-container></div><div class=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label>\n<input ng-model=\"parent.FirstName\" type=\"text\" md-autofocus></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה</label><input \nng-model=\"parent.LastName\" type=\"text\" md-autofocus></md-input-container></div><div class=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-gender-male-female\"></md-icon><label>מין</label><md-select \nng-model=\"parent.Gender\" placeholder=\"מין\"><md-option ng-selected=\"parent.Gender==\'Male\'\" ng-value=\"\'Male\'\">בן\n</md-option><md-option ng-selected=\"parent.Gender==\'Female\'\" ng-value=\"\'Female\'\">בת</md-option><md-option \nng-selected=\"parent.Gender==\'Other\'\" ng-value=\"\'Other\'\">אחר</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"hospital-building\"></md-icon><label>קופת חולים</label><md-select \nng-model=\"parent.HMO\" placeholder=\"קופת חולים\"><md-option ng-repeat=\"hnm in HMOS\" ng-value=\"hnm\">{{hnm}}</md-option>\n</md-select></md-input-container></div><div class=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><label>דואר אלקטרוני</label><input ng-model=\"parent.Email\" \ntype=\"email\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cellphone-android\" class=\"name\">\n</md-icon><label>טלפון נייד</label><input ng-model=\"parent.MobileNumber\" md-autofocus></md-input-container></div><div \nclass=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-power\" class=\"name\"></md-icon><label>סטטוס\n</label><md-select ng-model=\"parent.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"parent.Status==1 || parent.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"parent.Status==0 || parent.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-cash\" class=\"name\"></md-icon><label>דרגת הנחה</label>\n<md-select ng-model=\"parent.DiscountLevel\" placeholder=\"דרגת הנחה\"><md-option ng-value=\"0\">בחר רמה</md-option>\n<md-option ng-selected=\"parent.DiscountLevel==1 || parent.DiscountLevel==\'1\'\" ng-value=\"1\">1</md-option><md-option \nng-selected=\"parent.DiscountLevel==2 || parent.DiscountLevel==\'2\'\" ng-value=\"2\">2</md-option><md-option \nng-selected=\"parent.DiscountLevel==3 || parent.DiscountLevel==\'3\'\" ng-value=\"3\">3</md-option><md-option \nng-selected=\"parent.DiscountLevel==4 || parent.DiscountLevel==\'4\'\" ng-value=\"4\">4</md-option><md-option \nng-selected=\"parent.DiscountLevel==5 || parent.DiscountLevel==\'5\'\" ng-value=\"5\">5</md-option><md-option \nng-selected=\"parent.DiscountLevel==6 || parent.DiscountLevel==\'6\'\" ng-value=\"6\">6</md-option></md-select>\n</md-input-container></div><div class=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-city\" class=\"name\"></md-icon><label>{{$root.orgTypeBranchName.single}}</label><md-select \nng-model=\"parent.SettlementID\" ng-disabled=\"!settlements\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.orgTypeBranchName.single}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup><md-option ng-repeat=\"settlement in settlements | filter: searchTerm\" \nng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-domain\" class=\"name\"></md-icon><label>כתובת מלאה</label>\n<input ng-model=\"parent.Address\" type=\"text\" md-autofocus></md-input-container></div><div class=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><label>רגישות למזון</label><md-icon md-svg-icon=\"food-off\"></md-icon><md-select \nng-model=\"parent.FoodSensitivityQuestion\" placeholder=\"רגישות למזון\"><md-option \nng-selected=\"parent.FoodSensitivityQuestion==\'1\'\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"parent.FoodSensitivityQuestion==\'0\'\" ng-value=\"0\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"food-off\"></md-icon><label>פירוט רגישות למזון</label><textarea \nng-model=\"parent.FoodSensitivity\" type=\"text\"></textarea></md-input-container></div><div class=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><label>בעיות רפואוית/תרופות קבועות</label><md-icon md-font-icon=\"icon-hospital\">\n</md-icon><md-select ng-model=\"parent.MedicalProblemsQuestion\" placeholder=\"בעיות רפואוית/תרופות קבועות\"><md-option \nng-selected=\"parent.MedicalProblemsQuestion==\'1\'\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"parent.MedicalProblemsQuestion==\'0\'\" ng-value=\"0\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><label>פירוט בעיות רפואוית/תרופות\n</label><textarea ng-model=\"parent.MedicalProblems\"></textarea></md-input-container></div><div class=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"parent.DiscountLevelStartDate\"><label>\nתאריך התחלה של מתן הדרגה</label><input autocomplete=\"off\" ng-model=\"parent.DiscountLevelStartDate\"></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div \nstart-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"parent.DiscountLevelEndDate\"><label>\nתאריך סיום של מתן הדרגה</label><input autocomplete=\"off\" ng-model=\"parent.DiscountLevelEndDate\"></div>\n</md-input-container></div><div class=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><label>דירוג פידבק</label><input ng-model=\"parent.FeedBack\" \ntype=\"number\" disabled=\"disabled\"></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><label>הערות פידבק</label><textarea \nng-model=\"parent.FeedBackComment\" disabled=\"disabled\"></textarea></md-input-container></div><div class=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>\nקשר משפחתי לחניכים</label><md-select ng-model=\"parent.Relation\"><md-option ng-repeat=\"relation in relations\" \nng-value=\"relation\">{{relation}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" ng-if=\"parent.Relation == \'אחר\'\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon>\n<label>סוג קשר</label><input type=\"text\" ng-model=\"parent.Other\"></md-input-container></div></form></div></div></div>\n<div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"50\"><div \nng-show=\"$root.AdminLevel>1\" class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\" style=\"display: flex;align-items: center;justify-content: space-between\"><span>\nפרטי שיבוץ</span></div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" ng-if=\"grades\">\n<label>{{$root.User.Grade}}</label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select \nmd-on-close=\"vm.clearSearchTerm()\" ng-model=\"parent.GradeID\" ng-disabled=\"!grades\" \nng-change=\"getGroupsBySettlementAndGrade()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm3\" \ntype=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Grade}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option value>\nללא {{$root.User.Grade}}</md-option><md-option ng-repeat=\"grade in grades | filter: searchTerm2\" ng-value=\"grade.ID\">\n{{grade.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" ng-if=\"parentsGroups\"><label>\n{{$root.User.Group}}</label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select \nmd-on-close=\"vm.clearSearchTerm()\" ng-model=\"parent.GroupID\" ng-disabled=\"!parentsGroups\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm2\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.User.Group}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header>\n<md-optgroup><md-option value>ללא {{$root.User.Group}}</md-option><md-option \nng-repeat=\"group in parentsGroups | filter: searchTerm2\" ng-value=\"group.ID\">{{group.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-click=\"getGroupsBySettlementAndGrade(true)\">טען את כל הקבוצות</md-button></div></form></div></div><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex jcsb aic\"><div \nclass=\"title\">תגיות</div><div class=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block m0\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-select ng-model=\"tagsStatus\"><md-option \nng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים\n</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" aria-label=\"הוסף תגית\" \ntitle=\"הוספת תגית\" ng-click=\"openAddNewUserTagsDialog()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</header><div class=\"content\"><table class=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם תגית</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"main-table-new\" ng-repeat=\"tag in parentTags | filter: {Status: tagsStatus}\"><td>{{tag.Name}}</td>\n<td><md-icon md-font-icon=\"icon-power\" class=\"cp\" ng-click=\"updateTagStatus(tag)\" \nng-class=\"{\'green600\':tag.Status==1, \'red600\':tag.Status==0}\"></md-icon></td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/suggestions/suggestions.html","<div class=\"allowOverflow\" ng-init=\"getSuggestions()\"><div layout=\"row\" layout-wrap><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div \nclass=\"title\">הצעות {{$root.User.Events}}/מוצרים<md-icon md-font-icon=\"icon-information\" \ntitle=\"ניתן לבחור אירועים או מוצרים שיוצעו להורה לרכישה\"></md-icon></div><div class=\"inrowf aic\"><md-input-container \nclass=\"md-icon-float md-block\"><md-select ng-model=\"filterEventSuggestions\" placeholder=\"סינון לפי סטטוס\"><md-option \nng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים\n</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" title=\"הוספת הצעה\" \nng-click=\"createNewEventSuggestion()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar>\n<div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!loadingSuggestions\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table ng-show=\"loadingSuggestions\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם אירוע</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחייב רכישה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"suggestion in suggestions | filter:{Status : filterEventSuggestions}\"><td>{{suggestion.Name}}</td><td>\n<md-input-container class=\"md-block\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"suggestion.Required\">\n</md-checkbox></md-input-container></td><td><md-button aria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" \nng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-power\" \nng-class=\"{\'green600\':suggestion.Status==1, \'red600\':suggestion.Status==0}\" \nng-click=\"changeSuggestionStatus(suggestion)\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/statistics/statistics.html","<div ng-controller=\"EventManagementStatisticsController\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{statistics.Subscribers.Total}}</div><div class=\"h3 secondary-text font-weight-500\">כמות רשומים</div></div><div \nclass=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{statistics.Subscribers.LastDay}}\n</div><div class=\"h3 secondary-text font-weight-500\">כמות הרשמות ביום האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.Subscribers.LastWeek}}</div><div \nclass=\"h3 secondary-text font-weight-500\">כמות הרשמות בשבוע האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{statistics.Subscribers.LastMounts}}</div><div \nclass=\"h3 secondary-text font-weight-500\">כמות הרשמות בחודש האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div>\n<div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">₪{{statistics.Revenues.Total}}</div><div \nclass=\"h3 secondary-text font-weight-500\">הכנסות</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\">\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">₪{{statistics.Revenues.LastDay}}</div><div \nclass=\"h3 secondary-text font-weight-500\">הכנסות ביום האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">₪{{statistics.Revenues.LastWeek}}</div><div \nclass=\"h3 secondary-text font-weight-500\">הכנסות בשבוע האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">₪{{statistics.Revenues.LastMounts}}</div><div \nclass=\"h3 secondary-text font-weight-500\">הכנסות בחודש האחרון</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"h3 p-16\">רישום לפי {{$root.orgTypeBranchName.plural}}</div><md-divider></md-divider><canvas \nstyle=\"transform: translateX(50%);right: 50%;position: relative\" class=\"chart chart-pie vm10\" \nchart-data=\"statistics.Settlements.Data\" chart-colors=\"statistics.colors\" chart-labels=\"statistics.Settlements.Labels\" \nchart-options=\"statistics.options\"></canvas></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">רישום לפי {{$root.User.Grades}}</div>\n<md-divider></md-divider><canvas style=\"transform: translateX(50%);right: 50%;position: relative\" \nclass=\"chart chart-pie vm10\" chart-data=\"statistics.Grades.Data\" chart-colors=\"statistics.colors\" \nchart-labels=\"statistics.Grades.Labels\" chart-options=\"statistics.options\"></canvas></ms-widget-front></ms-widget>\n</div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/subscribers.html","<div id=\"subscribers\" class=\"page-layout simple tabbed\" ng-init=\"getRegistrationsAmount();getCoordinators();\" \nng-controller=\"EventManagementSubscribersController\"><div class=\"content\"><div class=\"action-buttons\"><md-button \nng-if=\"$root.AdminLevel>2 || $root.User.Events==1 || $root.User.EventsPay\" \nng-class=\"{\'over-registered\':event.MaxRegs > 0 && registrationAmount >= event.MaxRegs}\" \nclass=\"md-fab md-accent md-icon-button mb10 new\" ng-click=\"openNewRegistrationDialog()\" \nng-disabled=\"!subscribers || disableForUser || ($root.AdminLevel == 2 && !$root.User.EventsPay) || ($root.AdminLevel == 2 && !$root.User.OverRegsPer && event.MaxRegs > 0 && registrationAmount >= event.MaxRegs)\" \naria-label=\"add\" title=\"הוספת הזמנה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div class=\"button-group\">\n<md-button ng-if=\"$root.AdminLevel>2 || $root.User.EmailPer || $root.User.SmsPer\" \nclass=\"md-fab md-accent md-icon-button mb10 email main-button\" \nng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" aria-label=\"add systemUser\" \ntitle=\"שליחת הודעות\"><md-icon md-font-icon=\"icon-message-text\"></md-icon></md-button><md-button \nng-if=\"$root.AdminLevel>2 || $root.User.EmailPer\" class=\"md-fab md-accent md-icon-button mb10 email second-button\" \nng-click=\"openSendEmail()\" ng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" \naria-label=\"add systemUser\" title=\"שליחת אימיל\"><md-icon md-font-icon=\"icon-at\"></md-icon></md-button><md-button \nng-if=\"$root.smsEnabled && ($root.AdminLevel>2 || $root.User.SmsPer)\" \nclass=\"md-fab md-accent md-icon-button mb10 sms second-button\" ng-click=\"openSendSMS()\" title=\"שליחת הודעה\" \nng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></md-button></div><div class=\"button-group\"><md-button \nng-if=\"$root.AdminLevel>2\" class=\"md-fab md-accent md-icon-button mb10 cash main-button\" title=\"פיננסי\" \nng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-credit-card-multiple\"></md-icon></md-button><md-button ng-if=\"$root.AdminLevel>2\" \nclass=\"md-fab md-accent md-icon-button mb10 cash second-button\" ng-click=\"changePaymentsStatus()\" \ntitle=\"אישור סטטוס תשלום רכזים\" ng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-cash-100\"></md-icon></md-button><md-button \nng-if=\"$root.AdminLevel>2 && event.EventType!= 1\" class=\"md-fab md-accent md-icon-button mb10 cash second-button\" \nng-click=\"addMonthlyPayment()\" title=\"הוספת חיוב בהוראת קבע\" \nng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount || !testForMonthlyPayments()\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon></md-button><md-button \nng-if=\"$root.AdminLevel>2\" class=\"md-fab md-accent md-icon-button mb10 cash second-button\" ng-click=\"groupRefund()\" \ntitle=\"זיכוי קבוצתי\" ng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-credit-card-multiple\"></md-icon></md-button><md-button \nng-if=\"$root.AdminLevel>2 && event.RegNeedApproval == 1\" \nclass=\"md-fab md-accent md-icon-button mb10 cash second-button\" ng-click=\"approveRegistrations()\" \ntitle=\"אישוריי הרשמות\" ng-disabled=\"!subscribers || subscribers.length==0 || !selectedStudentsCount\" \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></md-button></div><div \nclass=\"button-group\"><md-button class=\"md-fab md-accent md-icon-button mb10 main-button\" title=\'דו\"חות\' \naria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon></md-button><md-button \nclass=\"md-fab md-accent md-icon-button mb10 second-button\" ng-click=\"getRegistrationsReport()\" \ntitle=\'הורד דו\"ח נרשמים\' aria-label=\"add systemUser\"><md-icon md-font-icon=\"icon-people\"></md-icon></md-button>\n<md-button ng-if=\"$root.AdminLevel>2 && event.EventType != 1\" \nclass=\"md-fab md-accent md-icon-button mb10 second-button\" ng-click=\"getMergedRegFiles()\" \ntitle=\"הפקת טופס הרשמה מאוחד\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon></md-button><md-button \nng-if=\"$root.AdminLevel>2 && event.EventType != 1\" class=\"md-fab md-accent md-icon-button mb10 second-button\" \nng-click=\"showMonthforReport()\" title=\"הפקת דוח - תשלום חודשי טרם בוצע\" aria-label=\"add systemUser\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon></md-button></div></div><div layout=\"row\" layout-wrap>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"80\" flex-gt-lg=\"90\"><form name=\"UserForm\" \nclass=\"md-inline-form\" validate><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"70\" ng-if=\"event.EventType != 1\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" ng-show=\"$root.AdminLevel>1\" \ntitle=\"התחל לרשום שם {{$root.orgTypeBranchName.single}}\"><label>בחר {{$root.orgTypeBranchName.single}}</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.Settlements\" \nmultiple=\"multiple\" ng-disabled=\"!subscribers\" ng-change=\"getGroups()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"בחר {{$root.orgTypeBranchName.single}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup ng-disabled=\"isClicked\"><md-option ng-value=\"settlement.ID\" \nng-repeat=\"settlement in settlements |filter:searchTerm\">{{settlement.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\" ng-show=\"$root.AdminLevel>1\" \ntitle=\"התחל לרשום שם {{$root.User.Grades}}\"><label>בחר {{$root.User.Grades}}</label><md-icon \nmd-font-icon=\"icon-chair-school\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.grades\" \nmultiple=\"multiple\" ng-disabled=\"!subscribers\" ng-change=\"getGroups()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"בחר {{$root.User.Grades}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header>\n<md-optgroup ng-disabled=\"isClicked\"><md-option ng-value=\"grade.ID\" ng-repeat=\"grade in grades |filter:searchTerm\">\n{{grade.Name}}</md-option></md-optgroup></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"70\" ng-if=\"event.EventType != 1\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nng-show=\"groups\" title=\"התחל לרשום שם {{$root.User.Group}}\"><label>בחר {{$root.User.Groups}}</label><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" ng-model=\"search.groups\" \nmultiple=\"multiple\" ng-disabled=\"!subscribers\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"בחר {{$root.User.Groups}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header>\n<md-optgroup ng-disabled=\"isClicked\"><md-option ng-value=\"group.ID\" ng-repeat=\"group in groups |filter:searchTerm\">\n{{group.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\" \nng-show=\"$root.AdminLevel>2\" title=\"התחל לרשום שם {{$root.User.Coordinator}}\"><label>בחר {{$root.User.Coordinator}}\n</label><md-icon md-font-icon=\"icon-tie\"></md-icon><md-select md-on-close=\"clearSearchTerm()\" \nng-model=\"search.coordinators\" multiple=\"multiple\" ng-disabled=\"!subscribers\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"בחר {{$root.User.Coordinator}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\">\n<md-option ng-value=\"coordinator.ID\" ng-repeat=\"coordinator in coordinators |filter:searchTerm\">{{coordinator.Name}}\n</md-option></md-optgroup></md-select></md-input-container></div></div><div class=\"filters\" layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-xs=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-power\">\n</md-icon><label>סטטוס הזמנה</label><md-select ng-model=\"search.Status\" placeholder=\"סינון לפי סטטוס הזמנה\" \nng-disabled=\"!subscribers\" ng-init=\"search.Status = 1\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option \nng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option><md-option ng-value=\"-1\">קפואים</md-option>\n</md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"credit-card\"></md-icon><label>סטטוס תשלום\n</label><md-select ng-model=\"search.PaymentStatus\" placeholder=\"סינון לפי סטטוס תשלום\" ng-disabled=\"!subscribers\">\n<md-option ng-value=\"null\">הצג הכל</md-option><md-option ng-value=\"1\">שולם</md-option><md-option ng-value=\"2\">\nשולם ל{{$root.User.Coordinator}}</md-option><md-option ng-value=\"3\">טרם אושר</md-option><md-option ng-value=\"5\" \nng-if=\"$root.advancedCashierOptions\">הופקד לקופה</md-option><md-option ng-value=\"6\" \nng-if=\"$root.advancedCashierOptions\">יצא להפקדה</md-option><md-option ng-value=\"7\" \nng-if=\"$root.advancedCashierOptions\">הופקד</md-option><md-option ng-value=\"0\">לא שולם</md-option></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"event.EventType != 1\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-svg-icon=\"account-box\" \nclass=\"name\"></md-icon><label>קבוצת אירוע</label><md-select ng-model=\"search.EventGroup\" \nplaceholder=\"סינון לפי קבוצת אירוע\" ng-disabled=\"!subscribers\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option\n ng-repeat=\"group in event.Groups\" ng-value=\"group\">{{group}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-svg-icon=\"credit-card\"></md-icon><label>הזמנות מזוכות</label><md-select \nng-model=\"search.Refund\" placeholder=\"סינון לפי הזמנות מזוכות\" ng-disabled=\"!subscribers\"><md-option ng-value=\"null\">\nהצג הכל</md-option><md-option ng-value=\"1\">מזוכות</md-option><md-option ng-value=\"0\">לא מזוכות</md-option></md-select>\n</md-input-container></div></div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-gt-md=\"70\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>אמצעי תשלום</label><md-select \nng-model=\"search.PaymentType\" ng-disabled=\"!subscribers\"><md-option ng-value=\"null\">הצג הכל</md-option><md-option \nng-value=\"0\">ללא חיוב</md-option><md-option ng-value=\"1\">אשראי</md-option><md-option ng-value=\"2\">מזומן</md-option>\n<md-option ng-value=\"3\">העברה בנקאית</md-option><md-option ng-value=\"4\">המחאה</md-option><md-option ng-value=\"7\">\nחשבון פנימי</md-option><md-option ng-value=\"11\">הוראת קבע אשראי</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" ng-if=\"event.EventType != 1\"><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-calendar\" class=\"name\"></md-icon><label>חוסר קבלה לחודש\n</label><md-select ng-model=\"search.MissingReceipts\" ng-disabled=\"!subscribers\" multiple=\"\"><md-option \nng-repeat=\"month in months\" ng-value=\"month.val\">{{month.month}}</md-option></md-select></md-input-container></div>\n</div><div class=\"filters\" layout=\"row\" layout-xs=\"column\" flex=\"100\" flex-sm=\"100\" flex-gt-md=\"70\"><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\" \nng-if=\"$root.AdminLevel == 3 && event.RegNeedApproval == 1\"><md-input-container class=\"md-icon-float md-block\"><md-icon\n md-font-icon=\"icon-check-circle\" class=\"name\"></md-icon><label>ממתינים לאישור</label><md-select \nng-model=\"search.RegApproved\" ng-disabled=\"!subscribers\" ng-init=\"search.RegApproved = 2\"><md-option ng-value=\"null\">\nהכל</md-option><md-option ng-value=\"1\">ממתינים לאישור</md-option><md-option ng-value=\"2\">קיבלו אישור</md-option>\n</md-select></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-md=\"33\" flex-xs=\"100\">\n<md-input-container id=\"free-search\" class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<label>חיפוש חופשי</label><input ng-model=\"search.freeSearchFromDB\" type=\"search\" ng-disabled=\"!subscribers\">\n</md-input-container></div></div><div class=\"search-actions row\" layout=\"row\"><md-button type=\"submit\" \nng-disabled=\"!subscribers\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getSubscribers()\">סינון</md-button>\n<md-button ng-disabled=\"!subscribers\" class=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"getSubscribers(true)\">\nבטל סינון</md-button></div></form></div></div></div><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"!subscribers\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-if=\"subscribers\"><table id=\"type-subscribers-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\" style=\"width: 100%\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><input ng-model=\"selectAll\" type=\"checkbox\" ng-change=\"setAll(selectAll)\"></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך הרשמה</span></div></th><th \nclass=\"secondary-text\" ng-if=\"event.EventType != 1\"><div class=\"table-header\"><span class=\"column-title\">שם משתתף\n</span></div></th><th class=\"secondary-text\" ng-if=\"event.EventType != 1\"><div class=\"table-header\"><span \nclass=\"column-title\">ת.ז</span></div></th><th class=\"secondary-text\" ng-if=\"event.EventType == 1\"><div \nclass=\"table-header\"><span class=\"column-title\">שם פרטי</span></div></th><th class=\"secondary-text\" \nng-if=\"event.EventType == 1\"><div class=\"table-header\"><span class=\"column-title\">שם משפחה</span></div></th><th \nclass=\"secondary-text\" ng-if=\"event.EventType == 1\"><div class=\"table-header\"><span class=\"column-title\">אימייל</span>\n</div></th><th class=\"secondary-text\" ng-if=\"event.EventType != 1\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.orgTypeBranchName.single}}</span></div></th><th class=\"secondary-text\" \nng-if=\"event.EventType != 1\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">אמצעי תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">עלות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס הזמנה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">קבלה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">זיכוי</span></div></th><th \nclass=\"secondary-text\" ng-if=\"event.RegNeedApproval == 1\"><div class=\"table-header\"><span class=\"column-title\">\nגורם מאשר</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr>\n</thead><tbody><tr class=\"md-ink-ripple\" \nng-class=\"{\'divorcedProblem\' : registrationValue.DivorcedParents && registrationValue.DivorcedParentsApprovals < 2}\" \nng-repeat=\"(registrationKey,registrationValue) in subscribers\"><td><input type=\"checkbox\" \nng-model=\"registrationValue.Selected\" ng-click=\"studentToggled(registrationValue)\"></td><td>\n{{registrationValue.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td ng-if=\"event.EventType != 1\"><a \nclass=\"cp\" ng-if=\"registrationValue.StudentID || registrationValue.ParentID\" \nng-click=\"moveToMemberPrifile(registrationValue)\">{{registrationValue.MemberName}} </a><span \nng-if=\"registrationValue.UserID\">{{registrationValue.MemberName}}</span></td><td ng-if=\"event.EventType != 1\">\n{{registrationValue.PrivateID}}</td><td ng-if=\"event.EventType == 1\">{{registrationValue.FirstName}}</td><td \nng-if=\"event.EventType == 1\">{{registrationValue.LastName}}</td><td ng-if=\"event.EventType == 1\">\n{{registrationValue.Email}}</td><td ng-if=\"event.EventType != 1\">{{registrationValue.SettlementName}}</td><td \nng-if=\"event.EventType != 1\">{{registrationValue.GradeName}}</td><td>{{registrationValue.PaymentType}}</td><td \nng-init=\"getFinalPrice(registrationKey,registrationValue)\">{{registrationValue.FinalPrice}} ₪</td><td>\n{{registrationValue.Status | registrationStatus}}</td><td>{{registrationValue.PaymentStatus | paymentStatus}} <span \nng-if=\"registrationValue.PaymentStatus == 2 && registrationValue.CoordinatorName.length\">\n({{registrationValue.CoordinatorName}})</span></td><td><div class=\"sflex fdc hfs12\" \nng-if=\"registrationValue.ReceiptID.length\"><a ng-repeat=\"receiptID in registrationValue.ReceiptID\" href=\"#\" \nng-click=\"downloadReceipt(receiptID,1)\">{{receiptID}}</a></div></td><td><div class=\"sflex fdc hfs12\"><a \nng-repeat=\"refundReceiptID in registrationValue.RefundReceiptID\" ng-if=\"refundReceiptID > 0\" href=\"#\" \nng-click=\"downloadReceipt(refundReceiptID,2)\">{{refundReceiptID}}</a></div></td><td ng-if=\"event.RegNeedApproval == 1\">\n<span class=\"dpn\">{{registrationValue.ApproveDate}}</span>{{registrationValue.ApprovalInformation}}</td><td><md-button \nng-disabled=\"$root.AdminLevel!=3 || registrationValue.Canceled>0\" class=\"preview-user cancel\" \nng-click=\"cancelRegistration(registrationValue)\" \ntitle=\"{{registrationValue.Canceled==\'0\' ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\"><md-icon \nng-class=\"{\'canceled\': registrationValue.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-disabled=\"($root.AdminLevel!=3 && $root.User.AccountancyPer != 1) || registrationValue.RefundDate || registrationValue.ParentsCashTransID\" \nclass=\"preview-user refund\" ng-click=\"refundRegistration(registrationValue)\" \ntitle=\"{{!registrationValue.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\"><md-icon \nng-class=\"{\'refunded\': registrationValue.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button>\n<md-button class=\"preview-user view\" ng-click=\"showFullRegistration(registrationValue)\" title=\"צפייה בפרטי הזמנה\">\n<md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/settings-menue/views/locations/location-management/tabs/general/general.html","<div><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">כללי</div></header><div class=\"content\"><form name=\"LocationForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\">\n<label>שם</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.location.Name\" \nmd-autofocus></md-input-container><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" \nflex-xs=\"100\"><label>חדר ללא הושבה</label><md-icon md-font-icon=\"icon-weather-sunny\"></md-icon><md-select \nng-model=\"vm.location.IsRoom\" placeholder=\"חדר ללא הושבה\"><md-option value=\"0\">לא</md-option><md-option value=\"1\">כן\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"100\" flex-xs=\"100\"><label>תיאור</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><textarea ng-model=\"vm.location.Description\" type=\"text\" \nng-disabled=\"isClicked\"></textarea></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"100\" flex-xs=\"100\"><label>מיקום</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><textarea ng-model=\"vm.location.Location\" type=\"text\" \nng-disabled=\"isClicked\"></textarea></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><label>{{$root.orgTypeBranchName.single}}</label>\n<md-icon md-font-icon=\"icon-domain\"></md-icon><md-select ng-model=\"vm.location.SettlementID\" id=\"SettlementID\" \nng-disabled=\"!vm.settlements || isClicked\" required=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.orgTypeBranchName.plural}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup><md-option ng-repeat=\"settlement in vm.settlements | filter: searchTerm\" \nng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"100\"><md-icon \nmd-font-icon=\"icon-power\" class=\"name\"></md-icon><label>סטטוס</label><md-select ng-model=\"vm.location.Status\" \nplaceholder=\"סטטוס\"><md-option ng-selected=\"vm.location.Status==1 || vm.location.Status==\'1\'\" ng-value=\"1\">פעיל\n</md-option><md-option ng-selected=\"vm.location.Status==0 || vm.location.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option>\n</md-select></md-input-container></div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/cancellation/cancellation.html","<div id=\"family\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><span>בקשות לביטול</span></div><div class=\"product-count secondary-text\">\n</div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!cancellation\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"cancellation\"><table \nid=\"parent-cancellation-table\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם חניכ\\ה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם ה{{$root.User.Event}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">סיבת ביטול</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nclass=\"entry-code-item\" ng-repeat=\"cancel in  cancellation | orderBy:ID\"><td>\n{{cancel.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a href=\"/student-profile?ID={{cancel.StudentID}}\" \nstyle=\"cursor: pointer\">{{cancel.StudentName}}</a></td><td>{{cancel.EventName}}</td><td>\n{{cancel.Reason==\'Other\' ? \'אחר\' : \'מחלה\'}}</td><td>{{cancel.Status}}</td><td><md-button class=\"preview-user\" \nng-click=\"openCancellationDialog(cancel)\" title=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr>\n</tbody></table></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/cash/cash.html","<div id=\"cashTrans\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-svg-icon=\"cash\">\n</md-icon><span>תנועות בחשבון פנימי</span></div><div class=\"product-count secondary-text\"></div></div></div><table \nng-show=\"cashTrans\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-options=\"cashDtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ילד</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר הזמנה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">יתרה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr class=\"cash-item\" ng-class=\"cash.Amount > 0? \'plus\' : \'minus\'\" ng-repeat=\"cash in cashTrans \"><td><md-icon \nclass=\"indicator\" ng-if=\"cash.Amount > 0\" md-svg-icon=\"plus-circle\"></md-icon><md-icon class=\"indicator\" \nng-if=\"cash.Amount < 0\" md-svg-icon=\"minus-circle\"></md-icon></td><td>\n{{cash.CreationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a href=\"/student-profile?ID={{cash.StudentID}}\" \ntarget=\"_blank\">{{cash.StudentFirstName}} {{cash.StudentLastName}}</a></td><td>{{cash.RegistrationID}}</td><td>\n{{cash.Amount}}</td><td>{{cash.Total}}</td><td><md-button class=\"preview-user\" \nng-click=\"showFullRegistration({StudentID: cash.StudentID, ID: cash.RegistrationID})\" title=\"צפייה בפרטי הזמנה\">\n<md-icon md-svg-icon=\"eye\"></md-icon></md-button><md-button ng-if=\"cash.Amount > 0\" class=\"preview-user\" \nng-click=\"deleteCashTransaction(cash)\" title=\"מחיקת זיכויי (יחזיר את ההרשמה לפעילה)\"><md-icon md-svg-icon=\"delete\">\n</md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/settings-menue/views/locations/location-management/tabs/sections/sections.html","<div><div layout=\"row\" layout-wrap layout-align=\"space-between\"><div class=\"general\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"70\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-accent-bg\"><div class=\"title\">ניהול איזורים</div></header><div class=\"content\"><form \nname=\"SectionsForm\" class=\"md-inline-form\" validate><div layout=\"row\"><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"75\" flex-xs=\"75\"><label>איזור</label><md-icon \nmd-font-icon=\"icon-border-inside\" class=\"name\"></md-icon><md-select ng-model=\"vm.currentSectionID\" \nng-change=\"vm.setCurrentSection()\"><md-option ng-repeat=\"section in vm.location.Layout\" ng-value=\"section.ID\">\n{{section.Name}}</md-option></md-select></md-input-container><md-button ng-click=\"vm.addNewSection()\" \nclass=\"preview-user\" title=\"איזור חדש\"><md-icon md-svg-icon=\"plus\"></md-icon></md-button></div><div layout=\"row\" \nlayout-wrap ng-if=\"vm.currentSection\"><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"100\" \nflex-xs=\"100\"><label>שם איזור</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"vm.currentSection.Name\"></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentSection\">\n<md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"75\" flex-xs=\"75\"><label>שורות</label><md-icon \nmd-font-icon=\"icon-format-align-justify\" class=\"name\"></md-icon><md-select ng-model=\"vm.currentRowID\" \nng-change=\"vm.setCurrentRow()\"><md-option ng-repeat=\"row in vm.currentSection.Rows\" ng-value=\"row.ID\">{{row.Name}}\n</md-option></md-select></md-input-container><md-button ng-click=\"vm.addNewRow()\" class=\"preview-user\" \ntitle=\"שורה חדש\"><md-icon md-svg-icon=\"plus\"></md-icon></md-button></div><div class=\"search-actions row\" layout=\"row\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"שמירה\" ng-click=\"vm.updateLayout()\">שמירה</md-button>\n<md-button ng-if=\"currentSection\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"שמירה\" \nng-click=\"vm.deleteCurrentSection()\">מחיקת איזור</md-button></div></form></div></div></div><div class=\"general\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\" flex-gt-lg=\"35\" ng-if=\"vm.currentRow\"><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\" ng-if=\"vm.currentRow\"><header class=\"md-accent-bg\"><div \nclass=\"title\">ניהול שורה</div></header><div class=\"content\"><form name=\"SectionsForm\" class=\"md-inline-form\" validate>\n<div layout=\"row\" layout-wrap><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"50\">\n<label>שם שורה</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.currentRow.Name\">\n</md-input-container><md-input-container class=\"md-block md-icon-left\" layout=\"column\" flex=\"50\" flex-xs=\"50\"><label>\nמספר מושבים:</label><md-icon md-font-icon=\"icon-view-week\" class=\"name\"></md-icon><input \nng-value=\"vm.currentRow.Seats.length\" disabled=\"disabled\"></md-input-container></div><div class=\"search-actions row\" \nlayout=\"row\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"שמירה\" ng-click=\"vm.updateLayout()\">שמירה\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"מחיקה\" ng-click=\"vm.deleteCurrentRow()\">\nמחיקת שורה</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"סגירה\" \nng-click=\"vm.unsetCurrentRow()\">סגירה</md-button></div></form></div></div></div></div><div layout=\"row\" layout-wrap \nng-if=\"vm.currentRow || vm.currentSection\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\" flex-gt-lg=\"100\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg sflex jcsb aic\"><div class=\"title\" ng-if=\"currentRow\">שורה {{vm.currentRow.Name}}</div><div \nclass=\"title\" ng-if=\"!currentRow\">איזור {{vm.currentSection.Name}}</div><md-button class=\"md-raised\" \nng-class=\"{\'md-primary\': !vm.seatsSelection}\" aria-label=\"נטרול כסאות\" ng-click=\"vm.toggleSeatsSelection()\">נטרול כסאות\n</md-button></header><div class=\"content\" ng-if=\"vm.currentRow\"><div id=\"row-seats-layout\" class=\"fcc\"><div \nng-repeat=\"seat in vm.currentRow.Seats\" class=\"seat center fcc\"><div \nng-class=\"{\'notAvailable\': seat.notAvailable == 2}\" \nng-click=\"vm.seatsSelection && vm.setSeatAsNotAvailable(vm.currentSection.ID,vm.currentRow.ID,seat.ID,seat)\"><input \nng-model=\"seat.Name\" class=\"center\" ng-class=\"{\'cp\': vm.seatsSelection}\" ng-disabled=\"vm.seatsSelection\"></div></div>\n</div></div><div class=\"content\" ng-if=\"!vm.currentRow\" id=\"section-seats-layout-wrapper\"><div \nid=\"section-seats-layout\" class=\"sflex fdc jcc\"><div ng-repeat=\"row in vm.currentSection.Rows\" class=\"fcc\"><div \nclass=\"cp\" ng-click=\"vm.currentRowID=row.ID;vm.currentRow=row\">שורה {{row.Name}}</div><div \nng-repeat=\"seat in row.Seats\" ng-class=\"{\'notAvailable\': seat.notAvailable == 2}\" \nng-click=\"vm.seatsSelection && vm.setSeatAsNotAvailable(vm.currentSection.ID,row.ID,seat.ID,seat)\" \nclass=\"seat center fcc\"><input ng-model=\"seat.Name\" class=\"center\" ng-class=\"{\'cp\': vm.seatsSelection}\" \nng-disabled=\"vm.seatsSelection\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/registrations/registrations.html","<div id=\"payments\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table id=\"parents-reg-table\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-column-defs=\"dtColumnDefs\" \ndt-options=\"regDtOptions\" ng-show=\"registrations\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\">מספר הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך הרשמה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם משתתף</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{$root.User.Event}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מחיר לתשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס הזמנה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר זיכוי</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nng-class=\"{\'divorcedProblem\' : registration.DivorcedParents && registration.DivorcedParentsApprovals < 2}\" \nng-repeat=\"registration in registrations\"><td>{{registration.ID}}</td><td><span class=\"dpn\">\n{{registration.RegistrationTime}}</span>{{registration.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td>\n{{registration.MemberName}}</td><td><a href=\"/event-management?ID={{registration.EventID}}\">{{registration.EventName}}\n</a></td><td>{{registration.EventPrice}}</td><td>{{registration.Price}}</td><td>\n{{registration.Status | registrationStatus}}</td><td>{{registration.PaymentStatus | paymentStatus}}</td><td><div \nclass=\"sflex fdc hfs12\" ng-if=\"registration.ReceiptID.length\"><a ng-repeat=\"receiptID in registration.ReceiptID\" \nhref=\"#\" ng-click=\"downloadReceipt(receiptID,1)\">{{receiptID}}</a></div><div class=\"sflex fdc hfs12\" \nng-if=\"registration.PaymentType == 7\">שולם מיתרת הורה</div></td><td><div class=\"sflex fdc hfs12\"><a \nng-repeat=\"refundReceiptID in registration.RefundReceiptID\" ng-if=\"refundReceiptID > 0\" href=\"#\" \nng-click=\"downloadReceipt(refundReceiptID,2)\">{{refundReceiptID}}</a></div></td><td><md-button \nng-disabled=\"$root.AdminLevel!=3 || registration.Canceled>0\" class=\"preview-user delete\" \nng-click=\"cancelRegistration(registration)\" title=\"{{!registration.Canceled>0 ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\">\n<md-icon ng-class=\"{\'canceled\': registration.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-disabled=\"($root.AdminLevel!=3 && $root.User.AccountancyPer != 1) || !registration.PaymentStatus\" \nclass=\"preview-user refund\" ng-click=\"refundRegistration(registration)\" \ntitle=\"{{!registration.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\"><md-icon \nng-class=\"{\'refunded\': registration.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button><md-button\n class=\"preview-user info\" ng-click=\"showFullRegistration(registration)\" title=\"צפייה בפרטי הזמנה\"><md-icon \nmd-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/settings-menue/views/locations/location-management/tabs/workingHours/working-hours.html","<div class=\"hours-container\"><div class=\"action-buttons\"><md-button ng-show=\"$root.AdminLevel>=2\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-newLocationhHour-button\" ng-click=\"vm.addNewHour()\" \naria-label=\"add new Location hour\" title=\"הוספה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap class=\"pt10\"><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">שעות פתיחה</div></header><div class=\"content\"><form name=\"hoursForm\" class=\"md-inline-form\" validate><div\n layout=\"row\" layout-wrap ng-repeat=\"hour in vm.hours\" class=\"aic\"><md-input-container class=\"md-block md-icon-left\" \nlayout=\"column\" flex=\"25\" flex-xs=\"100\"><label>יום</label><md-icon md-font-icon=\"icon-view-day\" class=\"name\"></md-icon>\n<md-select ng-model=\"hour.Day\" ng-disabled=\"$root.AdminLevel<2\" ng-change=\"hour.dirty = true\"><md-option ng-value=\"1\">\nראשון</md-option><md-option ng-value=\"2\">שני</md-option><md-option ng-value=\"3\">שלישי</md-option><md-option \nng-value=\"4\">רביעי</md-option><md-option ng-value=\"5\">חמישי</md-option><md-option ng-value=\"6\">שישי</md-option>\n<md-option ng-value=\"7\">שבת</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"25\" flex-xs=\"100\"><label>משעה</label><md-icon \nmd-font-icon=\"icon-clock\" class=\"name\"></md-icon><input ng-model=\"hour.FromHour\" required \nng-disabled=\"$root.AdminLevel<2\" type=\"time\" ng-change=\"hour.dirty = true\"></md-input-container><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"25\" flex-xs=\"100\"><label>עד שעה</label><md-icon \nmd-font-icon=\"icon-clock\" class=\"name\"></md-icon><input ng-model=\"hour.ToHour\" required \nng-disabled=\"$root.AdminLevel<2\" type=\"time\" ng-change=\"hour.dirty = true\"></md-input-container><md-input-container \nclass=\"md-block md-icon-left\" layout=\"column\" flex=\"25\" flex-xs=\"100\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.deleteHour(hour)\" ng-disabled=\"$root.AdminLevel<2\"><md-icon md-svg-icon=\"delete\"></md-icon></md-button>\n</md-input-container></div><div layout=\"row\"><md-input-container ng-if=\"vm.displayHoursSave()\" \nclass=\"md-block md-icon-right\" layout=\"column\" flex=\"25\" flex-xs=\"100\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.saveHours()\" ng-disabled=\"$root.AdminLevel<2\">שמירה</md-button></md-input-container></div></form></div>\n</div></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/comments/comments.html","<div id=\"comments\" class=\"page-layout simple tabbed\"><div class=\"profile-box info-box md-whiteframe-1dp commentDiv\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">הערות</div></header><div class=\"content\"><form \nname=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-block\" \nstyle=\"width: 100%\"><textarea rows=\"4\" cols=\"50\" style=\"border:solid 1px rgb(224,224,224)\" \nng-model=\"$root.commentText\"></textarea></md-input-container></div><div><md-button class=\"md-accent md-raised\" \nng-click=\"addComment()\" ng-disabled=\"!$root.commentText\">הוספת הערה</md-button></div></form></div></div><div \nclass=\"content commentsLine\"><timeline><timeline-event ng-repeat=\"comment in Comments\" side=\"right\"><timeline-badge \nclass=\"{{comment.badgeClass}}\"><md-icon md-svg-icon=\"checkbox-marked-circle-outline\"></md-icon></timeline-badge>\n<timeline-panel class=\"{{comment.badgeClass}}\"><p style=\"font-weight: bold; font-size: 18px\">{{comment.user}}</p>\n<timeline-heading><h4 style=\"font-size: 16px\" ng-bind-html=\"comment.content\"></h4></timeline-heading><p \nstyle=\"font-size:12px\">{{comment.date | date: \'medium\'}}</p></timeline-panel></timeline-event></timeline></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/reset-password/reset-password.html","<div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"60\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nעדכון סיסמא</div></header><div class=\"content\" style=\"padding: 50px\"><ul><li>מינימום 8 תווים</li></ul><form \nname=\"PasswordForm\" class=\"md-inline-form\" ng-submit=\"updatePassword()\" validate><div class=\"row\" layout=\"row\"><div \nclass=\"half\"><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-lock\" class=\"account\">\n</md-icon><label>סיסמא חדשה</label><input ng-model=\"newPassword\" type=\"password\" ng-required=\"true\" \nng-pattern=\"/[0-9a-zA-Z]{8,}/\"></md-input-container></div></div><md-button ng-disabled=\"isClicked || !newPassword\" \nclass=\"md-raised md-accent\" ng-click=\"updateParentPassword(newPassword)\" style=\"margin-right: 0px\">שמור</md-button>\n</form></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/contact/contact.html","<div id=\"family\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\">\n</md-icon><span>פניות צור קשר</span></div><div class=\"product-count secondary-text\"></div></div></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!contactss\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table id=\"contact-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" \ndt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם חניכ\\ה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"contactForm in  contactss | orderBy:ID\"><td>{{contactForm.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td>\n<td><a href=\"/student-profile?ID={{contactForm.StudentID}}\" style=\"cursor: pointer\">{{contactForm.StudentName}}</a>\n</td><td>{{contactForm.Status}}</td><td><md-button class=\"preview-user\" ng-click=\"openContactDialog(contactForm)\" \ntitle=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/family/family.html","<div id=\"family\" class=\"page-layout simple tabbed\"><div class=\"content\"><div class=\"action-buttons\"><md-button \nclass=\"md-fab md-accent md-icon-button mb10 new\" ng-click=\"openNewParentDialog()\" ng-disabled=\"!family\" \naria-label=\"add\" title=\"הוספת בן משפחה\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div \nclass=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"!family\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\" ng-if=\"family\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג קרבה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תעודת זהות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">דואר אלקטרני</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.single}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר טלפון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"familyMember in family\"><td><span ng-if=\"familyMember.ParentID > 0\">בן/בת זוג</span> <span \nng-if=\"!familyMember.ParentID\">ילד</span></td><td>{{familyMember.FirstName}} {{familyMember.LastName}}</td><td>\n{{familyMember.PrivateID}}</td><td>{{familyMember.Email}}</td><td>{{familyMember.SettlementName}}</td><td>\n{{familyMember.GroupName}}</td><td>{{familyMember.GradeName}}</td><td>{{familyMember.PhoneNumber}}</td><td>\n{{familyMember.Status ? \'פעיל\' : \'לא פעיל\'}}</td><td><span ng-if=\"familyMember.ParentID > 0\"><md-button \nclass=\"preview-user\" href=\"/parent-profile?ID={{familyMember.ID}}\" title=\"מעבר לפרופיל\"><md-icon md-svg-icon=\"account\">\n</md-icon></md-button></span><span ng-if=\"!familyMember.ParentID\"><md-button class=\"preview-user\" \nhref=\"/student-profile?ID={{familyMember.ID}}\" title=\"מעבר לפרופיל\"><md-icon md-svg-icon=\"account\"></md-icon>\n</md-button></span><span><md-button class=\"preview-user\" ng-click=\"editFamily(familyMember)\" title=\"ערוך\"><md-icon \nmd-svg-icon=\"pencil\"></md-icon></md-button></span><span><md-button class=\"preview-user\" \nng-click=\"deleteFamily(familyMember)\" title=\"מחק\"><md-icon md-svg-icon=\"delete\"></md-icon></md-button></span><span \nng-if=\"familyMember.ParentID > 0\"><md-button class=\"preview-user\" ng-click=\"loginToProfile(familyMember)\" \ntitle=\"מעבר לפרופיל הורה\"><md-icon md-svg-icon=\"login\"></md-icon></md-button></span></td></tr></tbody></table></div>\n</div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/payments/payments.html","<div id=\"entry-codes\"><table ng-show=\"receipts\" class=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" \ndt-instance=\"dtInstance\" dt-options=\"dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">vסוג מסמך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מספר קבלה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סכום לתשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">אמצעי תשלום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"receipt in receipts \"><td><span class=\"dpn\">{{receipt.Date}}</span>\n{{receipt.Date | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td>{{receipt.Type==1 ? \'קבלה\' : \'זיכוי\'}}</td><td><a href=\"#\" \nng-click=\"downloadReceipt(receipt.ID, receipt.Type)\">{{receipt.ID}}</a></td><td>{{receipt.Amount}}</td><td>\n{{receipt.PaymentType}}</td><td><md-button class=\"preview-user\" title=\"שליחת קבלה חוזרת\"><md-icon md-svg-icon=\"email\" \nng-click=\"reSendReceipt(receipt)\"></md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">כללי</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label>\nתעודה מזהה\\דרכון</label><input ng-disabled=\"$root.User.GodMode != 1\" ng-model=\"student.PrivateID\" type=\"text\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>\nשם פרטי</label><input ng-model=\"student.FirstName\" type=\"text\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><label>\nשם משפחה</label><input ng-model=\"student.LastName\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><label>דואר אלקטרוני</label><input \nng-model=\"student.Email\" type=\"email\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon><div start-view=\"day\" locale=\"he\" \nformat=\"DD/MM/YYYY\" moment-picker=\"student.Birthday\"><label>תאריך לידה</label><input autocomplete=\"off\" \nng-model=\"student.Birthday\"></div></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-svg-icon=\"hospital-building\"></md-icon><label>קופת חולים</label><md-select ng-model=\"student.HMO\" \nplaceholder=\"קופת חולים\"><md-option ng-repeat=\"hnm in HMOS\" ng-value=\"hnm\">{{hnm}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><label>מין</label><md-select ng-model=\"student.Gender\" \nplaceholder=\"מין\"><md-option ng-selected=\"student.Gender==\'Male\'\" ng-value=\"\'Male\'\">בן</md-option><md-option \nng-selected=\"student.Gender==\'Female\'\" ng-value=\"\'Female\'\">בת</md-option><md-option \nng-selected=\"student.Gender==\'Other\'\" ng-value=\"\'Other\'\">אחר</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-tie\"></md-icon><label>הורים גרושים</label><md-select \nng-model=\"student.DivorcedParents\" placeholder=\"הורים גרושים\"><md-option value=\"0\">לא</md-option><md-option value=\"1\">\nכן</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><label>{{$root.orgTypeBranchName.single}}</label><md-icon md-font-icon=\"icon-domain\"></md-icon>\n<md-select md-on-close=\"vm.clearSearchTerm()\" ng-model=\"student.SettlementID\" \nng-change=\"getGroupsBySettlementAndGrade()\" id=\"SettlementID\" ng-disabled=\"!settlements\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.orgTypeBranchName.single}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup><md-option ng-repeat=\"settlement in settlements | filter: searchTerm\" \nng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-map-marker-radius\"></md-icon><label>כתובת</label><input \nng-model=\"student.Address\" type=\"text\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-phone\"></md-icon><label>מספר טלפון</label><input \nng-model=\"student.PhoneNumber\" type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon><label>מספר טלפון נייד</label><input ng-model=\"student.MobileNumber\" \ntype=\"tel\" aria-label=\"phone number\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select ng-model=\"student.Status\" \nplaceholder=\"סטטוס\"><md-option ng-selected=\"student.Status==1 || student.Status==\'1\'\" ng-value=\"1\">פעיל</md-option>\n<md-option ng-selected=\"student.Status==0 || student.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\" ng-if=\"!student.Status\"><md-icon md-font-icon=\"icon-power\"></md-icon>\n<label>סיבת סטטוס לא פעיל</label><textarea ng-model=\"student.StatusReason\"></textarea></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"row\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>בעיות רפואוית/תרופות קבועות</label><md-icon \nmd-font-icon=\"icon-hospital\"></md-icon><md-select ng-model=\"student.MedicalProblemsQuestion\" \nplaceholder=\"בעיות רפואוית/תרופות קבועות\"><md-option ng-selected=\"student.MedicalProblemsQuestion==\'1\'\" ng-value=\"1\">כן\n</md-option><md-option ng-selected=\"student.MedicalProblemsQuestion==\'0\'\" ng-value=\"0\">לא</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><label>\nבעיות רפואוית/תרופות קבועות</label><textarea ng-model=\"student.MedicalProblems\"></textarea></md-input-container></div>\n<div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>רגישות למזון</label><md-icon md-svg-icon=\"food-off\">\n</md-icon><md-select ng-model=\"student.FoodSensitivityQuestion\" placeholder=\"רגישות למזון\"><md-option \nng-selected=\"student.FoodSensitivityQuestion==\'1\'\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"student.FoodSensitivityQuestion==\'0\'\" ng-value=\"0\">לא</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"food-off\"></md-icon><label>רגישות למזון</label><textarea \nng-model=\"student.FoodSensitivity\" type=\"text\"></textarea></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-svg-icon=\"account-box\"></md-icon><label>שם האב</label><textarea \nng-model=\"student.FatherName\" type=\"text\"></textarea></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account\"></md-icon><label>סוג חניך</label><md-select \nng-model=\"student.Type\" placeholder=\"סוג חניך\"><md-option ng-selected=\"student.Type==2 || student.Type==\'2\'\" \nng-value=\"2\">בוגר</md-option><md-option ng-selected=\"student.Type==1 || student.Type==\'1\'\" ng-value=\"1\">רגיל\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label>מיקוד</label><input ng-model=\"student.ZipCode\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\" ng-if=\"student.EducatorID\"><md-icon md-font-icon=\"icon-tie\">\n</md-icon><label>תפקיד מדריך</label><md-select ng-model=\"student.Role\" placeholder=\"תפקיד\"><md-option \nng-repeat=\"role in roles\" ng-value=\"role.Name\">{{role.Name}}</md-option></md-select></md-input-container></div></form>\n</div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"50\"><div ng-show=\"$root.AdminLevel>1\" class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-accent-bg\"><div class=\"title\" \nstyle=\"display: flex;align-items: center;justify-content: space-between\"><span>פרטי שיבוץ</span></div></header><div \nclass=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container\n class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" ng-if=\"grades\"><label>{{$root.User.Grade}}</label><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" ng-model=\"student.GradeID\" \nng-disabled=\"!grades\" ng-change=\"getGroupsBySettlementAndGrade()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm3\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש {{$root.User.Grade}}\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option value>\nללא {{$root.User.Grade}}</md-option><md-option ng-repeat=\"grade in grades | filter: searchTerm2\" ng-value=\"grade.ID\">\n{{grade.Name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" ng-if=\"studentsGroups\"><label>\n{{$root.User.Group}}</label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select \nmd-on-close=\"vm.clearSearchTerm()\" ng-model=\"student.GroupID\" ng-disabled=\"!studentsGroups\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm2\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.User.Group}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header>\n<md-optgroup><md-option value>ללא {{$root.User.Group}}</md-option><md-option \nng-repeat=\"group in studentsGroups | filter: searchTerm2\" ng-value=\"group.ID\">{{group.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-click=\"getGroupsBySettlementAndGrade(true)\">טען את כל הקבוצות</md-button></div></form></div></div><div \nclass=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg sflex jcsb aic\"><div \nclass=\"title\">תגיות</div><div class=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block m0\"><md-select \nng-model=\"tagsStatus\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option>\n<md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" \naria-label=\"הוסף תגית\" title=\"הוספת תגית\" ng-click=\"openAddNewUserTagsDialog()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></header><div class=\"content\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם תגית</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"tag in Tags | filter: {Status: tagsStatus}\"><td>{{tag.Name}}</td><td><md-icon md-font-icon=\"icon-power\" \nclass=\"cp\" ng-click=\"updateTagStatus(tag)\" ng-class=\"{\'green600\':tag.Status==1, \'red600\':tag.Status==0}\"></md-icon>\n</td></tr></tbody></table></div></div><div ng-if=\"student.extraFields\" \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title sflex aic jcsb\"><span>שדות נוספים</span></div></header><div class=\"content\"><form name=\"ExtraFieldsForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container \nng-repeat=\"field in student.extraFields\" class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon><label \nng-if=\"field.question.Type == 1 || field.question.Type == 2\">{{field.question.Title}}</label><input \nng-if=\"field.question.Type == 1\" ng-model=\"field.Value\" type=\"text\"><md-select ng-if=\"field.question.Type == 2\" \nng-model=\"field.Value\"><md-option ng-repeat=\"option in field.question.Values\" ng-value=\"option\">{{option}}</md-option>\n</md-select><div ng-if=\"field.question.Type == 3\" start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" \nmoment-picker=\"field.Value\"><label>{{field.question.Title}}</label><input autocomplete=\"off\" ng-model=\"field.Value\">\n</div></md-input-container></div></form></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy.html","<div id=\"family\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><span>בקשות לסבסוד</span></div><div class=\"product-count secondary-text\">\n</div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!subsidyes\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" ng-show=\"subsidyes\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תאריך פניה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"subsidy in subsidyes\"><td>{{subsidy.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td>\n<md-button ng-click=\"openSubsidyDialog(subsidy)\" class=\"preview-user\" title=\"צפיה בבקשה\"><md-icon md-svg-icon=\"eye\">\n</md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/educator-groups/educator-groups.html","<div layout=\"row\" layout-wrap ng-controller=\"EducatorGroupsController as vm\"><div class=\"general\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" flex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" \nlayout=\"column\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools sflex aic jcsb\"><div \nclass=\"title\">מדריך</div><div><md-button class=\"preview-user\" ng-if=\"vm.showResend && $root.AdminLevel>1\" \nng-click=\"vm.openNewEducatorDialog()\">שליחת הזמנה למערכת</md-button><md-button ng-if=\"$root.AdminLevel>1\" \nclass=\"md-icon-button\" title=\"הוספת {{$root.User.Group}}\" ng-click=\"vm.addNewGroup()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar><div class=\"content\"><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!vm.educatorGroups\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.educatorGroups\"><table id=\"educatorGroupsTable\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.single}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grade}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody>\n<tr class=\"main-table-new\" ng-repeat=\"group in vm.educatorGroups\"><td>{{group.SettlementName}}</td><td>\n{{group.GroupName}}</td><td>{{group.GradeName}}</td><td><md-input-container><label>סטטוס</label><md-select \nng-model=\"group.Status\" ng-change=\"vm.updateStatus(group)\"><md-option value=\"1\" ng-selected=\"group.Status==1\">פעיל\n</md-option><md-option value=\"0\" ng-selected=\"group.Status==0\">לא פעיל</md-option></md-select></md-input-container>\n</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/registrations/registrations.html","<div id=\"registrations\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!registrations\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"registrations-table-c\"><table \nid=\"registrations-table\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"dtInstance\" \ndt-column-defs=\"dtColumnDefs\" dt-options=\"dtOptions\" ng-show=\"registrations\"><thead><tr><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\">מספר הרשמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תאריך הרשמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם {{$root.User.Event}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר לתשלום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס הזמנה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס תשלום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר קבלה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר זיכוי</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">אופן תשלום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr \nng-class=\"{\'divorcedProblem\' : student.DivorcedParents && registration.DivorcedParentsApprovals < 2}\" \nng-repeat=\"registration in registrations | orderBy : \'registration.ID\' \"><td>{{registration.ID}}</td><td>\n{{registration.RegistrationTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a \nhref=\"/event-management?ID={{registration.EventID}}\">{{registration.Name}}</a></td><td>{{registration.Price}}</td><td>\n{{registration.FinalPrice}}</td><td>{{registration.Status | registrationStatus}}</td><td>\n{{registration.PaymentStatus | paymentStatus}}</td><td><div class=\"sflex fdc hfs12\" \nng-if=\"registration.ReceiptID.length\"><a ng-repeat=\"receiptID in registration.ReceiptID\" href=\"#\" \nng-click=\"downloadReceipt(receiptID,1)\">{{receiptID}}</a></div><div class=\"sflex fdc hfs12\" \nng-if=\"registration.PaymentType == 7\">שולם מיתרת הורה</div></td><td><div class=\"sflex fdc hfs12\"><a \nng-repeat=\"refundReceiptID in registration.RefundReceiptID\" ng-if=\"refundReceiptID > 0\" href=\"#\" \nng-click=\"downloadReceipt(refundReceiptID,2)\">{{refundReceiptID}}</a></div></td><td>{{getPaymentType(registration)}}\n</td><td><md-button ng-disabled=\"$root.AdminLevel!=3 || registration.Canceled>0\" class=\"preview-user cancel\" \nng-click=\"cancelRegistration(registration)\" title=\"{{!registration.Canceled>0 ? \'ביטול הרשמה\' : \'הרשמה מבוטלת\'}}\">\n<md-icon ng-class=\"{\'canceled\': registration.Canceled>0}\" md-svg-icon=\"delete\"></md-icon></md-button><md-button \nng-disabled=\"($root.AdminLevel!=3 && $root.User.AccountancyPer != 1) || !registration.PaymentStatus\" \nclass=\"preview-user refund\" ng-click=\"refundRegistration(registration)\" \ntitle=\"{{!registration.RefundReceiptID.length ? \'זיכוי הרשמה\' : \'קיים זיכויי להרשמה\'}}\"><md-icon \nng-class=\"{\'refunded\': registration.RefundReceiptID.length}\" md-svg-icon=\"credit-card\"></md-icon></md-button><md-button\n class=\"preview-user view\" ng-click=\"showFullRegistration(registration)\" title=\"צפייה בפרטי הזמנה\"><md-icon \nmd-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/cancellation/cancellation.html","<div id=\"family\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!cancellation\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table id=\"cancellation-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" \ndt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם ה{{$root.User.Event}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">סיבת ביטול</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"cancel in  cancellation | orderBy:ID\"><td>{{cancel.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td><td><a \nhref=\"/parent-profile?ID={{cancel.ParentID}}\" style=\"cursor: pointer\">{{cancel.ParentName}}</a></td><td><a \nhref=\"mailto:{{cancel.ParentEmail}}\">{{cancel.ParentEmail}}</a></td><td>{{cancel.ParentPhone}}</td><td>\n{{cancel.EventName}}</td><td>{{cancel.Reason==\'Other\' ? \'אחר\' : \'מחלה\'}}</td><td>{{cancel.Status}}</td><td><md-button \nclass=\"preview-user\" ng-click=\"openCancellationDialog(cancel)\" title=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon>\n</md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/comments/comments.html","<div id=\"comments-page\" class=\"page-layout simple tabbed\"><div \nclass=\"profile-box info-box md-whiteframe-1dp commentDiv\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">הערות</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block\" style=\"width: 100%\"><textarea rows=\"4\" cols=\"50\" \nstyle=\"border:solid 1px rgb(224,224,224)\" ng-model=\"$root.commentText\"></textarea></md-input-container></div><div>\n<md-button class=\"md-accent md-raised\" ng-click=\"addComment()\" ng-disabled=\"!$root.commentText\">הוספת הערה</md-button>\n</div></form></div></div><div class=\"content commentsLine\"><timeline><timeline-event ng-repeat=\"comment in Comments\" \nside=\"right\"><timeline-badge class=\"{{comment.badgeClass}}\"><md-icon md-svg-icon=\"checkbox-marked-circle-outline\">\n</md-icon></timeline-badge><timeline-panel class=\"{{comment.badgeClass}}\"><p \nstyle=\"font-weight: bold; font-size: 18px\">{{comment.user}}</p><timeline-heading><h4 style=\"font-size: 16px\" \nng-bind-html=\"comment.content\"></h4></timeline-heading><p style=\"font-size:12px\">{{comment.date | date: \'medium\'}}</p>\n</timeline-panel></timeline-event></timeline></div></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/contact/contact.html","<div id=\"family\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!contactss\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table id=\"contact-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" \ndt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">תאריך</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">שם הורה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">מייל הורה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">טלפון נייד הורה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סטטוס פניה</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"entry-code-item\" \nng-repeat=\"contactForm in  contactss | orderBy:ID\"><td>{{contactForm.CreateTime | cmdate:\'HH:mm:ss dd/MM/yyyy \'}}</td>\n<td><a href=\"/parent-profile?ID={{contactForm.ParentID}}\" style=\"cursor: pointer\">{{contactForm.ParentName}}</a></td>\n<td><a href=\"mailto:{{contactForm.ParentEmail}}\">{{contactForm.ParentEmail}}</a></td><td>{{contactForm.ParentPhone}}\n</td><td>{{contactForm.Status}}</td><td><md-button class=\"preview-user\" ng-click=\"openContactDialog(contactForm)\" \ntitle=\"פרטי בקשה\"><md-icon md-svg-icon=\"eye\"></md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/family/family.html","<div id=\"family\"><div class=\"action-buttons\"><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-newFamilyMember-button\" ng-click=\"openNewParentDialog()\" ng-show=\"$root.AdminLevel>1\" \naria-label=\"add systemUser\" ng-disabled=\"!family\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!family\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"pt65 table-wrapper\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" ng-show=\"family\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג קרבה</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">תעודת זהות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">דואר אלקטרני</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר טלפון</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th><th \nclass=\"secondary-text\" ng-if=\"$root.AdminLevel>1\"><div class=\"table-header\"><span class=\"column-title\">פעולות</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"familyMember in family\"><td><span \nng-if=\"!familyMember.IsParent && familyMember.Gender==\'Female\'\">אחות</span> <span \nng-if=\"!familyMember.IsParent && familyMember.Gender==\'Male\'\">אח</span> <span \nng-if=\"!familyMember.IsParent && familyMember.Gender==\'Other\'\">אח</span> <span \nng-if=\"!familyMember.IsParent && familyMember.Gender==\'\'\">אח/אחות</span> <span ng-if=\"familyMember.IsParent\">הורה\n</span></td><td>{{familyMember.FirstName}} {{familyMember.LastName}}</td><td>{{familyMember.PrivateID}}</td><td>\n{{familyMember.Email}}</td><td>{{familyMember.PhoneNumber ? familyMember.PhoneNumber : familyMember.MobileNumber}}</td>\n<td>{{familyMember.Status ? \'פעיל\' : \'לא פעיל\'}}</td><td ng-if=\"$root.AdminLevel>1\"><span \nng-if=\"!familyMember.IsParent\"><md-button ng-disabled=\"$root.AdminLevel<2\" class=\"preview-user-student\" \nhref=\"/student-profile?ID={{familyMember.ID}}\" title=\"מעבר לפרופיל\"><md-icon md-svg-icon=\"account\"></md-icon>\n</md-button></span><span ng-if=\"familyMember.IsParent\"><md-button ng-disabled=\"$root.AdminLevel<2\" \nclass=\"preview-user-parent\" href=\"/parent-profile?ID={{familyMember.ID}}\" title=\"מעבר לפרופיל\"><md-icon \nmd-svg-icon=\"account\"></md-icon></md-button></span><span ng-if=\"!familyMember.IsParent\"><md-button \nng-disabled=\"$root.AdminLevel<3\" class=\"edit-user-student\" ng-click=\"editStudent(familyMember)\" title=\"ערוך\"><md-icon \nmd-svg-icon=\"account-edit\"></md-icon></md-button></span><span ng-if=\"familyMember.IsParent\"><md-button \nclass=\"edit-user-parent\" ng-click=\"editParent(familyMember)\" title=\"ערוך\"><md-icon md-svg-icon=\"account-edit\">\n</md-icon></md-button></span><span ng-if=\"familyMember.IsParent\"><md-button ng-disabled=\"$root.AdminLevel<3\" \nclass=\"delete-parent\" ng-click=\"deleteParentDialog(familyMember)\" title=\"מחק שיוך\"><md-icon md-svg-icon=\"delete\">\n</md-icon></md-button></span><span ng-if=\"familyMember.IsParent\"><md-button class=\"login-parent\" \nng-click=\"loginToProfile(familyMember)\" title=\"מעבר לפרופיל הורה\"><md-icon md-svg-icon=\"login\"></md-icon></md-button>\n</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/utils/views/activities/activities-profile/tabs/about/about.html","<div><div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" \nflex-gt-lg=\"50\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">כללי</div></header><div class=\"content\"><form name=\"UserForm\" class=\"md-inline-form\" validate><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\">\n<md-icon md-font-icon=\"icon-leaf\" class=\"name\"></md-icon><label>שם {{$root.User.Activity}}</label><input \nng-model=\"activities.Name\" type=\"text\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>{{$root.User.Groups}}\n</label><input ng-value=\"activities.GroupName\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס</label><md-select \nng-model=\"activities.Status\" placeholder=\"סטטוס\"><md-option \nng-selected=\"activities.Status==1 || activities.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"activities.Status==0 || activities.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\"><md-icon ng-if=\"activities.HealthDeclarationFilePath\" \nmd-font-icon=\"icon-eye cp\" class=\"name\" ng-click=\"viewFile(activities.HealthDeclarationFilePath)\"></md-icon><md-icon \nng-if=\"!activities.HealthDeclarationFilePath\" md-font-icon=\"icon-cloud-upload\" class=\"name\"></md-icon><label>\nהצהרת בריאות</label><input ng-model=\"activities.HealthDeclarationFileName\" type=\"text\" readonly=\"readonly\" class=\"cp\" \nng-click=\"uploadHealthDeclarationFile()\"></md-input-container></div></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/utils/views/activities/activities-profile/tabs/meetings/meetings.html","<div id=\"activity-meetings\" class=\"page-layout simple tabbed\"><div class=\"content\"><div class=\"action-buttons\">\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-new-meeting-button\" ng-click=\"openNewMeetingtDialog()\" \naria-label=\"add systemUser\" title=\"יצירת מפגש חדש\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-wrap><div class=\"general\" ng-repeat=\"meeting in meetings\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"80\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg sflex jcsb w100\"><div class=\"title\">{{meeting.Date}}</div><div class=\"sflex aic\"><md-switch \nng-model=\"meeting.Status\" ng-change=\"updateMeetingStatus(meeting)\" ng-true-value=\"1\" ng-false-value=\"0\" \nclass=\"md-green m0\">סטטוס</md-switch><md-icon ng-if=\"activities.HealthDeclarationFilePath\" \nng-click=\"openMeetingHealthDeclarationMessageDialog(meeting)\" md-font-icon=\"icon-email\" class=\"white600 mr10 cp\">\n</md-icon><span ng-click=\"meeting.expanded = !meeting.expanded\" class=\"cp mr10\"><md-icon ng-if=\"!meeting.expanded\" \nmd-font-icon=\"icon-arrow-expand\" class=\"white600\"></md-icon><md-icon ng-if=\"meeting.expanded\" \nmd-font-icon=\"icon-arrow-collapse\" class=\"white600\"></md-icon></span></div></header><div class=\"content\" \nng-class=\"{\'expanded\': meeting.expanded, \'collapsed\': !meeting.expanded}\"><table \nclass=\"dataTable row-border hover stripe md-ink-ripple\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם משתתף</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">נוכחות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">הצהרת בריאות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">הערות</span></div></th></tr></thead><tbody>\n<tr class=\"md-ink-ripple\" ng-repeat=\"student in meeting.Attendance\"><td>{{student.FirstName}} {{student.LastName}}</td>\n<td><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-checkbox ng-checked=\"student.Attendance==1\" \nng-click=\"updateStudentAttendance(student)\"></md-checkbox></md-input-container></td><td><span \nng-if=\"student.SignedHealthDaclerationFile\"><a href=\"{{student.SignedHealthDaclerationFile}}\" target=\"_blank\">\n{{student.SignedHealthDeclarationTimestamp * 1000 | date:\'HH:mm:ss dd/MM/yyyy\'}}</a></span></td><td><md-input-container\n layout=\"column\" layout-xs=\"row\" flex=\"100\"><input ng-model=\"student.Comments\" type=\"text\" \nng-blur=\"updateStudentAttendance(student,true)\"></md-input-container></td></tr></tbody></table></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/association/new-student-association-dialog/new-student-association-dialog.html","<md-dialog class=\"newStudentAssociation-dialog\" aria-label=\"New Task\"><form name=\"newStudentAssociationForm\" \ndata-ng-model=\"newStudentAssociationForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">הוספת שיוך לתושב</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div><label class=\"db\">סוג תושב:</label><md-radio-group \nng-model=\"newStudentAssociation.UserType\" required ng-init=\"newStudentAssociation.UserType = 1\"><md-radio-button \nvalue=\"1\" aria-label=\"חניך\">חניך</md-radio-button><md-radio-button value=\"0\" aria-label=\"הורה\">הורה</md-radio-button>\n</md-radio-group></div><div><md-input-container class=\"md-block\" ng-if=\"!withFile\"><label>ת.ז תושב</label><input \ntype=\"text\" ng-model=\"newStudentAssociation.PrivateID\" required ng-disabled=\"isClicked\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newStudentAssociationForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNewStudentAssociation()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nשמירה</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/new-group-price-dialog/new-group-price-dialog.html","<md-dialog class=\"newGroupPrice-dialog\" aria-label=\"New Task\" ng-init=\"getGroups();\"><form name=\"newGroupsPriceForm\" \ndata-ng-model=\"newGroupPriceForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת מחיר לפי קבוצה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div><md-input-container class=\"md-block\"><label>קבוצה</label><md-icon md-font-icon=\"icon-domain\"></md-icon>\n<md-select md-on-close=\"vm.clearSearchTerm()\" ng-model=\"newGroupPrice.GroupID\" id=\"GroupID\" \nng-disabled=\"!groups || isClicked\" required=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"חיפוש קבוצה\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option \nng-repeat=\"group in groups | filter: searchTerm\" ng-value=\"group.ID\">{{group.Name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>מחיר</label><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><input type=\"text\" ng-model=\"newGroupPrice.Price\" ng-required=\"true\" ng-disabled=\"isClicked\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newGroupsPriceForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNewGroupPrice()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/new-event-fee-dialog/new-event-fee-dialog.html","<md-dialog class=\"newEventFee-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form name=\"newEventFeeForm\" \ndata-ng-model=\"newEventFeeForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת עמלה לפי כמות תשלומים</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת עמלה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div><md-input-container class=\"md-block\"><label>מספר תשלומים</label><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><md-select ng-model=\"newEventFee.NumOfPayments\" ng-required=\"true\"><md-option \nng-repeat=\"payment in payments\" ng-value=\"payment\">{{payment}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>עמלה</label><md-icon md-svg-icon=\"percent\" class=\"name\"></md-icon><input \ntype=\"text\" ng-model=\"newEventFee.Fee\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newEventFeeForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewEventFee()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/payments/new-settlement-price-dialog/new-settlement-price-dialog.html","<md-dialog class=\"newBranchPrice-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form name=\"newBranchPriceForm\" \ndata-ng-model=\"newBranchPriceForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת מחיר לפי {{$root.orgTypeBranchName.single}} ושכבות</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div><md-input-container class=\"md-block\"><label>\n{{$root.orgTypeBranchName.single}}</label><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select \nmd-on-close=\"vm.clearSearchTerm()\" multiple=\"true\" ng-model=\"newBranchPrice.SettlementID\" id=\"SettlementID\" \nng-disabled=\"!settlements || isClicked\" required=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" type=\"text\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"חיפוש {{$root.orgTypeBranchName.single}}\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup><md-button layout-fill value=\"all\" ng-click=\"selectAllTest()\">בחר הכל</md-button>\n<md-option ng-repeat=\"settlement in settlements | filter: searchTerm\" ng-value=\"settlement.ID\">{{settlement.Name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-chair-school\"></md-icon><label>{{$root.User.Grade}}</label><md-select \nng-model=\"newBranchPrice.GradesID\" multiple=\"true\"><md-option ng-repeat=\"grade in grades\" ng-value=\"grade.ID\">\n{{grade.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>מחיר</label>\n<md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><input type=\"text\" ng-model=\"newBranchPrice.Price\" \nng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newBranchPriceForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewBranchPrice()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/questions/add-questions-to-event-dialog/add-questions-to-event-dialog.html","<md-dialog class=\"newQuestion-dialog\" aria-label=\"New Task\" ng-init=\"init()\" style=\"max-width: 50vw\"><form \nname=\"newQuestionForm\" data-ng-model=\"eventQuestions\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"row\"><div class=\"md-toolbar-tools md-toolbar-tools-top sflex jcsb aic\" layout=\"row\"><span class=\"title\">\nהוספה מרשימת שאלות</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!newQuestions\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-show=\"newQuestions.length==0\">לא נמצאו שאלות</div><div \nng-if=\"newQuestions.length>0\" ng-repeat=\"newQuestion in newQuestions | orderBy: \'AnswerType\'\" class=\"sflex aic jcsb\">\n<p>{{ newQuestion.Description }}</p><div class=\"sflex aic mr20\"><md-icon style=\"margin-left: 15px\" \nclass=\"md-secondary\" md-font-icon=\"{{newQuestion.AnswerType!=1 ? \'icon-pencil\' : \'icon-format-list-bulleted\'}}\">\n</md-icon><md-checkbox class=\"md-secondary\" ng-model=\"newQuestion.Add\" ng-disabled=\"isClicked\"></md-checkbox></div>\n</div><div><md-input-container class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\"><md-select \nng-model=\"newQuestions.SettlementID\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm2\" \ntype=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"שיוך ל{{$root.orgTypeBranchName.single}} ספציפי\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-value=\"null\">\nכולם</md-option><md-option ng-repeat=\"settlement in settlements | orderBy:\'Name\' | filter:searchTerm2\" \nng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-optgroup></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions ng-if=\"newQuestions.length>0\" layout=\"row\" layout-align=\"space-between center\">\n<md-button data-ng-disabled=\"newQuestionForm.$invalid || isClicked\" type=\"submit\" ng-click=\"addQuestionsToEvent()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">הוספה ושמירה</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/brothers-discounts.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools\"><div class=\"title\">הנחת משפחה</div><md-button \nclass=\"md-icon-button\" title=\"הוספת הנחת משפחה\" ng-click=\"addNewBrotherDiscount()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!BrotherDiscount || $root.discountsLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table \nng-if=\"BrotherDiscount.length>0 && !$root.discountsLoading\" class=\"dataTable row-border hover stripe md-ink-ripple\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מספר בן משפחה</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום/אחוזים</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">רמת הנחה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody>\n<tr class=\"main-table-new\" ng-repeat=\"brother in BrotherDiscount | orderBy: \'BrotherNumber\'  track by $index\"><td>\n{{brother.BrotherNumber + 1}}</td><td><md-input-container><label>הכנס/י מספר</label><input type=\"text\" \nng-model=\"brother.Discount\" ng-pattern=\"/^\\d+$/\"></md-input-container></td><td><md-input-container><label>רמה</label>\n<md-select ng-model=\"brother.Level\"><md-option value=\"1\" ng-selected=\"brother.Level==1\">בודדת</md-option><md-option \nvalue=\"2\" ng-selected=\"brother.Level==2\">מרובה</md-option></md-select></md-input-container></td><td>\n<md-input-container><label>סוג</label><md-select ng-model=\"brother.Type\"><md-option value=\"1\" \nng-selected=\"brother.Type==1\">ש\"ח</md-option><md-option value=\"2\" ng-selected=\"brother.Type==2\">אחוזים</md-option>\n</md-select></md-input-container></td><td><md-input-container><label>סטטוס</label><md-select ng-model=\"brother.Status\">\n<md-option value=\"1\" ng-selected=\"brother.Status==1\">פעיל</md-option><md-option value=\"0\" \nng-selected=\"brother.Status==0\">לא פעיל</md-option></md-select></md-input-container></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/date-discounts.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div class=\"title\">הנחות לפי תאריכים<md-icon \nmd-font-icon=\"icon-information\" title=\"במקרה של התנגשות, תופעל ההנחה הגדולה יותר\"></md-icon></div><div \nclass=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"filters\" \nng-change=\"filterGeneral()\" placeholder=\"סינון לפי סטטוס\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option\n ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container>\n<md-button class=\"md-icon-button\" aria-label=\"הוסף הנחה\" title=\"הוספת הנחת לפי תאריך\" \nng-click=\"createNewDateDiscount()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar>\n</div><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!DatesDiscounts || $root.discountsLoading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table ng-if=\"DatesDiscounts.length>0 && !$root.discountsLoading\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מתאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">עד תאריך</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">רמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">הערות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"discount in DatesDiscounts | filter: {Status: filters}\"><td><md-input-container><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"discount.FromDate\"><input class=\"md-input\" autocomplete=\"off\" \nng-model=\"discount.FromDate\" required ng-disabled=\"isClicked\"></div></md-input-container></td><td><md-input-container>\n<div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"discount.ToDate\"><input class=\"md-input\" \nautocomplete=\"off\" ng-model=\"discount.ToDate\" required ng-disabled=\"isClicked\"></div></md-input-container></td><td>\n<md-input-container><label>הכנס/י מספר</label><input type=\"text\" ng-model=\"discount.Discount\" ng-pattern=\"/^\\d+$/\" \nplaceholder=\"יש להכניס מספר שלם\"></md-input-container></td><td><md-input-container><label>רמה</label><md-select \nng-model=\"discount.Level\"><md-option value=\"1\" ng-selected=\"discount.Level==1\">בודדת</md-option><md-option value=\"2\" \nng-selected=\"discount.Level==2\">מרובה</md-option></md-select></md-input-container></td><td><md-input-container><label>\nסוג</label><md-select ng-model=\"discount.Type\"><md-option value=\"1\" ng-selected=\"discount.Type==1\">ש\"ח</md-option>\n<md-option value=\"2\" ng-selected=\"discount.Type==2\">אחוזים</md-option></md-select></md-input-container></td><td>\n<md-input-container><label>הערות</label><input ng-model=\"discount.Comments\"></md-input-container></td><td>\n<md-input-container><label>סטטוס</label><md-select ng-model=\"discount.Status\"><md-option value=\"1\" \nng-selected=\"discount.Status==1\">פעיל</md-option><md-option value=\"0\" ng-selected=\"discount.Status==0\">לא פעיל\n</md-option></md-select></md-input-container></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/discount-levels.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools\"><div class=\"title\">דרגות הנחה</div></div>\n</md-toolbar><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!FamilyLevelDiscount || $root.discountsLoading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table ng-show=\"FamilyLevelDiscount && !$root.discountsLoading\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">דרגה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סכום/אחוזים</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">רמת הנחה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"level in FamilyLevelDiscount | orderBy: DiscountLevel  track by $index\"><td>{{level.DiscountLevel}}</td><td>\n<md-input-container><label>הכנס/י מספר</label><input type=\"text\" ng-model=\"level.Discount\" ng-pattern=\"/^\\d+$/\" \nplaceholder=\"יש להכניס מספר שלם\"></md-input-container></td><td><md-input-container><label>רמה</label><md-select \nng-model=\"level.Level\"><md-option value=\"1\" ng-selected=\"level.Level==1\">בודדת</md-option><md-option value=\"2\" \nng-selected=\"level.Level==2\">מרובה</md-option></md-select></md-input-container></td><td><md-input-container><label>סוג\n</label><md-select ng-model=\"level.Type\"><md-option value=\"1\" ng-selected=\"level.Type==1\">ש\"ח</md-option><md-option \nvalue=\"2\" ng-selected=\"level.Type==2\">אחוזים</md-option></md-select></md-input-container></td><td><md-input-container>\n<label>סטטוס</label><md-select ng-model=\"level.Status\"><md-option value=\"1\" ng-selected=\"level.Status==1\">פעיל\n</md-option><md-option value=\"0\" ng-selected=\"level.Status==0\">לא פעיל</md-option></md-select></md-input-container>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/general-discounts.html","<div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar class=\"md-accent-bg md-menu-toolbar\">\n<div class=\"md-toolbar-tools inrowf\"><div class=\"title\">הנחות כלליות</div><div class=\"inrowf aic\"><md-input-container \nclass=\"md-icon-float md-block\"><md-select ng-model=\"filterg\" ng-change=\"filterGeneral()\" placeholder=\"סינון לפי סטטוס\">\n<md-option ng-value=\"undefined\">הצג הכל</md-option><md-option ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">\nלא פעילים</md-option></md-select></md-input-container><md-button class=\"md-icon-button\" title=\"הוספת הנחה\" \nng-click=\"createNewGeneralDiscount()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></md-toolbar>\n<div class=\"content\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"!GeneralDiscount || $root.discountsLoading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><table ng-show=\"GeneralDiscount && !$root.discountsLoading\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">רמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.orgTypeBranchName.plural}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Event}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{$root.User.Grades}}</span></div></th><th \nclass=\"secondary-text\" ng-if=\"$root.memberYearLogicEnabled\"><div class=\"table-header\"><span class=\"column-title\">\nהרשמה ראשונית לדמי חבר</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סכום</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">סוג</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">פעולות</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"(discountKey,discountValue) in GeneralDiscount | filter:{Status : filterg}\"><td>\n{{discountValue.Level==1 || discountValue.Level==\'1\' ? \'בודדת\' : \'מרובה\'}}</td><td><span \nng-repeat=\"settlement in discountValue.Settlements | filter: {\'Active\':\'1\'}\">{{settlement.Name}}{{$last ? \'\' : \', \'}}\n</span></td><td><span ng-repeat=\"event in discountValue.Events | filter: {\'Active\':\'1\'}\">\n{{event.Name}}{{$last ? \'\' : \', \'}}</span></td><td><span \nng-repeat=\"grade in discountValue.Grades | filter: {\'Active\':\'1\'}\">{{grade.Name}}{{$last ? \'\' : \', \'}}</span></td><td \nng-if=\"$root.memberYearLogicEnabled\">{{discountValue.NewMemberPay == 1? \'כן\' : \'לא\'}}</td><td>\n{{discountValue.Discount}}</td><td>{{discountValue.Type==2|| discountValue.Type==\'2\' ? \'אחוזים\' : \'ש\"ח\'}}</td><td>\n<md-button class=\"preview-user\" ng-click=\"editGeneralDiscount(discountValue)\">צפיה</md-button><md-button \naria-label=\"Use Android\" title=\"הפוך לפעיל\\לא פעיל\" ng-disabled=\"isClicked\"><md-icon md-font-icon=\"icon-power\" \nng-class=\"{\'green600\':discountValue.Status==1, \'red600\':discountValue.Status==0}\" \nng-click=\"changeStatus(discountValue,discountKey)\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/registration-discounts.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools\"><div class=\"title\">הנחת לפי כמות הרשמות</div>\n<md-button class=\"md-icon-button\" title=\"הוספת הנחה לפי הרשמה\" ng-click=\"addNewRegistrationDiscount()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></md-toolbar><div class=\"content\"><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-show=\"!RegistrationDiscount || $root.discountsLoading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table \nng-if=\"RegistrationDiscount.length>0 && !$root.discountsLoading\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר הרשמה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סכום/אחוזים</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">רמת הנחה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"main-table-new\" \nng-repeat=\"reg in RegistrationDiscount | orderBy: \'RegistrationNumber\'  track by $index\"><td>{{reg.RegistrationNumber}}\n</td><td><md-input-container><label>הכנס/י מספר</label><input type=\"text\" ng-model=\"reg.Discount\" ng-pattern=\"/^\\d+$/\">\n</md-input-container></td><td><md-input-container><label>רמה</label><md-select ng-model=\"reg.Level\"><md-option \nvalue=\"1\" ng-selected=\"reg.Level==1\">בודדת</md-option><md-option value=\"2\" ng-selected=\"reg.Level==2\">מרובה</md-option>\n</md-select></md-input-container></td><td><md-input-container><label>סוג</label><md-select ng-model=\"reg.Type\">\n<md-option value=\"1\" ng-selected=\"reg.Type==1\">ש\"ח</md-option><md-option value=\"2\" ng-selected=\"reg.Type==2\">אחוזים\n</md-option></md-select></md-input-container></td><td><md-input-container><label>סטטוס</label><md-select \nng-model=\"reg.Status\"><md-option value=\"1\" ng-selected=\"reg.Status==1\">פעיל</md-option><md-option value=\"0\" \nng-selected=\"reg.Status==0\">לא פעיל</md-option></md-select></md-input-container></td></tr></tbody></table></div></div>\n</div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/student-discounts.html","<div layout=\"row\" layout-wrap><div class=\"general\" layout=\"column\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"70\" \nflex-gt-lg=\"60\"><div class=\"profile-box info-box md-whiteframe-1dp\" layout=\"column\"><md-toolbar \nclass=\"md-accent-bg md-menu-toolbar\"><div class=\"md-toolbar-tools inrowf\"><div class=\"title\">הנחות תושבים</div><div \nclass=\"inrowf aic\"><md-input-container class=\"md-icon-float md-block\"><md-select ng-model=\"filters\" \nng-change=\"filterGeneral()\" placeholder=\"סינון לפי סטטוס\"><md-option ng-value=\"undefined\">הצג הכל</md-option><md-option\n ng-value=\"1\">פעילים</md-option><md-option ng-value=\"0\">לא פעילים</md-option></md-select></md-input-container>\n<md-button class=\"md-icon-button\" aria-label=\"הוסף הנחה\" title=\"הוספת הנחת תושב\" ng-click=\"createNewStudentDiscount()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-icon-button\" \naria-label=\"הורדת קובץ טעינה ריק\" title=\"הורדת קובץ טעינה ריק\" ng-click=\"downloadEventsDiscountsTemplateFile()\">\n<md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button><md-button class=\"md-icon-button\" \naria-label=\"הוסף הנחה\" title=\"טעינת אקסל הנחות תושב\" ng-click=\"uploadExcelFile()\"><md-icon md-svg-icon=\"file-excel\">\n</md-icon></md-button></div></div></md-toolbar></div><div class=\"content\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!StudentDiscount || $root.discountsLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table \nng-if=\"StudentDiscount.length>0 && !$root.discountsLoading\" class=\"dataTable row-border hover stripe md-ink-ripple\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג תושב</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם תושב</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ת.ז.</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">רמה</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">הערות</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody>\n<tr class=\"main-table-new\" ng-repeat=\"discount in StudentDiscount | filter: {Status: filters}\" \nng-class=\"{green: discount.Used}\"><td ng-if=\"discount.ParentName\">הורה</td><td ng-if=\"discount.StudentName\">חניך</td>\n<td ng-if=\"discount.ParentName\">{{discount.ParentName}}</td><td ng-if=\"discount.StudentName\">{{discount.StudentName}}\n</td><td ng-if=\"discount.ParentPrivateID\">{{discount.ParentPrivateID}}</td><td ng-if=\"discount.StudentPrivateID\">\n{{discount.StudentPrivateID}}</td><td><md-input-container><label>הכנס/י מספר</label><input type=\"text\" \nng-model=\"discount.Discount\" ng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\"></md-input-container></td><td>\n<md-input-container><label>רמה</label><md-select ng-model=\"discount.Level\"><md-option value=\"1\" \nng-selected=\"discount.Level==1\">בודדת</md-option><md-option value=\"2\" ng-selected=\"discount.Level==2\">מרובה</md-option>\n</md-select></md-input-container></td><td><md-input-container><label>סוג</label><md-select ng-model=\"discount.Type\">\n<md-option value=\"1\" ng-selected=\"discount.Type==1\">ש\"ח</md-option><md-option value=\"2\" ng-selected=\"discount.Type==2\">\nאחוזים</md-option></md-select></md-input-container></td><td><md-input-container><label>הערות</label><input \nng-model=\"discount.Comments\"></md-input-container></td><td><md-input-container><label>סטטוס</label><md-select \nng-model=\"discount.Status\"><md-option value=\"1\" ng-selected=\"discount.Status==1\">פעיל</md-option><md-option value=\"0\" \nng-selected=\"discount.Status==0\">לא פעיל</md-option></md-select></md-input-container></td></tr></tbody></table></div>\n</div></div>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/questions/edit-event-question-panel/edit-event-question-panel.html","<md-content ms-scroll ng-init=\"vm.init()\"><form name=\"branchsForm\" id=\"branchForm\" data-ng-model=\"branchForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nעריכת שאלה</span><md-button class=\"md-icon-button\" ng-click=\"$root.closePanel()\" aria-label=\"Close Dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\"></md-icon><label>מספר שאלה להצגה</label><input ng-model=\"vm.question.Number\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-power\"></md-icon><label>סטטוס\n</label><md-select ng-model=\"vm.question.Status\"><md-option \nng-selected=\"vm.question.Status==1 || vm.question.Status==\'1\'\" ng-value=\"1\">פעיל</md-option><md-option \nng-selected=\"vm.question.Status==0 || vm.question.Status==\'0\'\" ng-value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"alert-decagram\"></md-icon><label>\nשאלת חובה</label><md-select ng-model=\"vm.question.Required\"><md-option \nng-selected=\"vm.question.Required==1 || vm.question.Required==\'1\'\" ng-value=\"1\">כן</md-option><md-option \nng-selected=\"vm.question.Required==0 || vm.question.Required==\'0\'\" ng-value=\"0\">לא</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\"></md-icon><md-select \nng-model=\"vm.question.SettlementID\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm2\" \ntype=\"text\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"שיוך ל{{$root.orgTypeBranchName.single}} ספציפי\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup><md-option ng-value=\"null\">\nכולם</md-option><md-option ng-repeat=\"settlement in vm.settlements | orderBy:\'Name\' | filter:searchTerm2\" \nng-value=\"settlement.ID\">{{settlement.Name}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.question.AnswerType==1 || vm.question.AnswerType==\'1\'\"><md-icon \nmd-svg-icon=\"format-list-bulleted-type\"></md-icon><label>סוג שאלה</label><md-select \nng-model=\"vm.question.QuestionType\"><md-option ng-value=\"\'text\'\">טקסט</md-option><md-option ng-value=\"\'email\'\">\nדואר אלקטרוני</md-option><md-option ng-value=\"\'number\'\">מספרים</md-option><md-option ng-value=\"\'phonenumber\'\">\nמספר טלפון</md-option></md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/transportation/add-transportation-to-event-dialog/add-transportation-to-event-dialog.html","<md-dialog class=\"newTransportation-dialog\" aria-label=\"New Task\" ng-init=\"getAllTransportation()\"><form \nname=\"newTransportationForm\" data-ng-model=\"evenTtransportations\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">שיוך הסעה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label>בחר הסעה</label><md-select \nng-model=\"newTransportation.TransportationID\" placeholder=\"בחר הסעה\" ng-required=\"true\" ng-disabled=\"isClicked\" \nmultiple=\"multiple\"><md-option ng-repeat=\"item in transportation\" ng-value=\"item.ID\">{{item.Name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>כיוון הסעה</label><md-select \nng-model=\"newTransportation.Way\" placeholder=\"כיוון הסעה\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option \nng-selected=\"transportation.Way==1\" ng-value=\"1\">הלוך</md-option><md-option ng-selected=\"transportation.Way==2\" \nng-value=\"2\">חזור</md-option><md-option ng-selected=\"transportation.Way==\'both\'\" ng-value=\"\'both\'\">הלוך + חזור\n</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newTransportationForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewTransportation()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/transportation/add-new-transportation-to-event-dialog/add-new-transportation-to-event-dialog.html","<md-dialog class=\"newTransportation-dialog\" aria-label=\"New Task\"><form name=\"newTransportationForm\" \ndata-ng-model=\"evenTtransportations\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div\n class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הסעה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-bus\"></md-icon><label>שם הסעה</label><input type=\"text\" ng-model=\"newTransportation.Name\" \nplaceholder=\"שם הסעה\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container \nclass=\"md-block\"><label>כיוון הסעה</label><md-icon md-font-icon=\"icon-road\"></md-icon><md-select \nng-model=\"newTransportation.Way\" placeholder=\"כיוון הסעה\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option \nng-selected=\"transportation.Way==1\" ng-value=\"1\">הלוך</md-option><md-option ng-selected=\"transportation.Way==2\" \nng-value=\"2\">חזור</md-option><md-option ng-selected=\"transportation.Way==\'both\'\" ng-value=\"\'both\'\">הלוך + חזור\n</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newTransportationForm.$invalid || isClicked\" type=\"submit\" ng-click=\"addNewTransportation()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/suggestions/new-suggestion-dialog/new-suggestion-dialog.html","<md-dialog class=\"newEventSuggestion-dialog\" aria-label=\"New Task\" ng-init=\"init()\"><form \nname=\"newEventSuggestionForm\" data-ng-model=\"newEventSuggestionForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספת הצעה ל{{$root.User.Event}}/מוצר</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" title=\"סגירת חלון\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label>בחר {{$root.User.Event}}\\מוצר</label><md-icon md-svg-icon=\"weather-sunny\"></md-icon><md-select \nng-model=\"suggestedEvent.SuggestedEventID\" ng-disabled=\"!events\" ng-required=\"true\" ng-change=\"log()\"><md-select-header\n class=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"!events || isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש מאורע\" class=\"demo-header-searchbox md-text\" autocomplete=\"off\">\n</md-select-header><md-optgroup ng-disabled=\"!events || isClicked\"><md-option ng-value=\"event.ID\" \nng-repeat=\"event in events |filter:searchTerm\">{{event.Name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-true-value=\"1\" ng-disabled=\"!events\" \nng-false-value=\"0\" ng-model=\"suggestedEvent.Required\">חובת רכישה</md-checkbox></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-ng-disabled=\"newEventSuggestionForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewEventSuggestion()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/missing-month-receipt-dialog/missing-month-receipt-dialog.html","<md-dialog class=\"swapEventForm-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nבחירת חודש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog(false)\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"content\" flex>\n<md-content class=\"about-tab\"><form name=\"swapEventForm\" data-ng-model=\"swapEventForm\" class=\"md-inline-form\" validate>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-calendar\" class=\"name\"></md-icon><label>\nחוסר קבלה לחודש</label><md-select ng-model=\"search.month\" required multiple=\"multiple\"><md-option \nng-repeat=\"month in months\" ng-value=\"month.val\">{{month.month}}</md-option></md-select></md-input-container></form>\n</md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"swapEventForm.$invalid\" \nng-click=\"getMonthUnpaidReport()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">אישור</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/new-monthly-payment-dialog/new-monthly-payment-dialog.html","<md-dialog class=\"addMonthlyPayment-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת חיוב חדש בהוראת קבע</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"content\" \nflex><md-content class=\"about-tab\"><div class=\"fw-bold fcred\" ng-if=\"showPercentageWarning\">\nשים לב: אחוז לחיוב אינו נלקח בחשבון בעת חיוב עם בחירת כרטיס אשראי ספציפי</div><form name=\"newMonthlyPaymentForm\" \ndata-ng-model=\"newMonthlyPaymentForm\" class=\"md-inline-form\" validate><md-dialog-content ms-scroll><div layout=\"row\" \nflex=\"100\"><div layout=\"column\" flex=\"100\"><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-power\"></md-icon><label>סוג חיוב</label><md-select ng-model=\"chargeType\" placeholder=\"סוג חיוב\" \nrequired><md-option ng-value=\"1\">מחיר מחושב</md-option><md-option ng-value=\"2\">מחיר מחושב + הנחה</md-option><md-option \nng-value=\"3\">מחיר חדש</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div \nlayout=\"column\" flex=\"100\" ng-show=\"chargeType == 2\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-percent\" class=\"name\"></md-icon><label>הנחה באחוזים</label><input ng-model=\"percentDiscount\" \nplaceholder=\"הנחה באחוזים\" type=\"number\" min=\"0\" max=\"100\" ng-change=\"validateNumberInput()\" ng-disabled=\"isClicked\" \nng-required=\"chargeType == 2\"></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" \nflex=\"100\" ng-show=\"chargeType == 3\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-cash\" \nclass=\"name\"></md-icon><label>מחיר חדש</label><input ng-model=\"newPrice\" placeholder=\"מחיר חדש\" type=\"number\" min=\"0\" \nng-disabled=\"isClicked\" ng-required=\"chargeType == 3\"></md-input-container></div></div><div layout=\"row\" flex=\"100\">\n<div layout=\"column\" flex=\"100\"><md-input-container style=\"padding: 0\" class=\"md-icon-float md-block\"><label \nfor=\"MonthYear\">עבור חודש</label><div start-view=\"day\" locale=\"he\" format=\"MM/YYYY\" moment-picker=\"MonthYear\"><input \nautocomplete=\"off\" ng-model=\"MonthYear\" name=\"MonthYear\" required></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"newMonthlyPaymentForm.$invalid || isClicked\" \nng-click=\"addMonthlyPayment(true)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\" ng-if=\"chargeType\">\n<md-icon md-svg-icon=\"eye\" class=\"ml5\"></md-icon>הצג לפני חיוב</md-button></div></md-dialog-actions></form>\n</md-content></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/swap-event-dialog/swap-event-dialog.html","<md-dialog class=\"swapEventForm-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nבחירת חוג חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog(false)\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"content\" flex>\n<md-content class=\"about-tab\"><form name=\"swapEventForm\" data-ng-model=\"swapEventForm\" class=\"md-inline-form\" validate>\n<md-input-container class=\"md-icon-float md-block\"><label>מאורע</label><md-icon md-svg-icon=\"weather-sunny\"></md-icon>\n<md-select md-on-close=\"clearSearchTerm()\" ng-model=\"newEventID\" required=\"\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-model-options=\"{debounce: 750}\" \nng-keydown=\"$event.stopPropagation()\" ng-change=\"searchTerm.length >2 && getEvents()\" placeholder=\"חפש מאורע..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"events\">\n<md-option ng-value=\"event.ID\" ng-repeat=\"event in events\">{{event.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></form></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"swapEventForm.$invalid\" ng-click=\"swapRegistration()\" class=\"send-button md-accent md-raised\" \naria-label=\"Add Task\">אישור</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/new-registration-dialog/new-registration-dialog.html","<md-dialog class=\"newRegistration-dialog\" aria-label=\"New Task\" ng-init=\"init();\" \nstyle=\"width: 600px; max-width: 95vw; height: fit-content\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הזמנה חדשה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \nng-if=\"!restrictDialogClose\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"content\" flex><md-tabs md-dynamic-height md-selected=\"selectedTab\"><md-tab \nng-disabled=\"payments.length\"><md-tab-label><span ng-if=\"eventType == 0\">בחירת תושב</span> <span \nng-if=\"eventType == 1\">פרטי תושב</span></md-tab-label><md-tab-body><md-content class=\"about-tab\"><form \nname=\"newRegistrationPart1Form\" data-ng-model=\"newRegistrationForm\" class=\"md-inline-form\" validate><md-dialog-content \nms-scroll ng-if=\"eventType == 0\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised cp\" \nng-if=\"!tz\" ng-click=\"ChangeToPassport()\">החלף לדרכון / תעודה חריגה</md-button><md-button \nclass=\"md-accent md-raised cp\" ng-if=\"tz\" ng-click=\"ChangeToPassport()\">החלף לתעודה מזהה</md-button>\n</md-input-container><md-input-container class=\"md-block\"><label class=\"DC\">סוג תושב:</label><md-radio-group \nng-model=\"newRegistration.userType\" ng-required=\"true\" ng-init=\"newRegistration.userType = 1\"><md-radio-button \nvalue=\"1\" aria-label=\"חניך\">חניך</md-radio-button><md-radio-button value=\"0\" aria-label=\"הורה\">הורה</md-radio-button>\n</md-radio-group></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-box\" \nclass=\"name\"></md-icon><label ng-if=\"!tz\">תעודת זהות</label><label ng-if=\"tz\">דרכון/תעודה חריגה</label><input \nng-model=\"newRegistration.PrivateID\" ng-disabled=\"!newRegistration.userType\" data-ng-required=\"true\" \ndata-ng-pattern=\"/^[0-9]{9,30}$/\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input ng-model=\"newRegistration.FirstName\" \nng-disabled=\"!new\" ng-required=\"true\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה</label><input ng-model=\"newRegistration.LastName\" \nng-disabled=\"!new\" ng-required=\"true\"></md-input-container><div ng-if=\"notExist && !hide\"><div layout=\"row\" \nlayout-align=\"start center\"><span>החניך לא קיים במערכת. להוספת חניך חדש <a style=\"cursor: pointer\" \nng-click=\"newStudent()\">לחץ כאן</a></span></div></div><div ng-if=\"hide\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label>תעודת זהות הורה</label><input \nng-model=\"newRegistration.Parent1\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-gender-male-female\" class=\"name\"></md-icon><label>מין</label><md-select ng-required=\"true\" \nng-model=\"newRegistration.Gender\" placeholder=\"מין\"><md-option ng-value=\"\'Male\'\">בן</md-option><md-option \nng-value=\"\'Female\'\">בת</md-option><md-option ng-value=\"\'Other\'\">אחר</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label>{{$root.User.Grade}}</label>\n<md-select ng-model=\"newRegistration.GradeID\" ng-disabled=\"!grades\" ng-required=\"true\"><md-option \nng-repeat=\"grade in grades\" ng-value=\"grade.ID\">{{grade.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\" class=\"name\"></md-icon><label>\nבחירת {{$root.orgTypeBranchName.single}}</label><md-select ng-required=\"true\" ng-model=\"newRegistration.SettlementID\" \nplaceholder=\"בחירת {{$root.orgTypeBranchName.single}}\" ng-disabled=\"!settlements || !newRegistration.GradeID\" \nng-change=\"getGroupsBySettlements()\"><md-option ng-repeat=\"settlement in settlements\" ng-value=\"settlement.ID\">\n{{settlement.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>בחר {{$root.User.Group}}</label><md-select \nng-model=\"newRegistration.GroupID\" ng-disabled=\"!groups || !newRegistration.SettlementID\"><md-option \nng-repeat=\"group in groups\" ng-value=\"group.ID\">{{group.Name}}</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-content ms-scroll ng-if=\"eventType == 1\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם פרטי</label><input ng-model=\"newRegistration.FirstName\" \nng-required=\"true\" ng-blur=\"userValidation()\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><label>שם משפחה</label><input ng-model=\"newRegistration.LastName\" \nng-required=\"true\" ng-blur=\"userValidation()\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"name\"></md-icon><label>אימייל</label><input ng-model=\"newRegistration.UserEmail\" \nng-required=\"true\" type=\"email\" ng-blur=\"userValidation()\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-cellphone\" class=\"name\"></md-icon><label>טלפון</label><input \nng-model=\"newRegistration.UserPhoneNumber\" ng-required=\"true\" ng-blur=\"userValidation()\"></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"newRegistrationPart1Form.$invalid || (dataFetched < 5 && !new)\" \nng-click=\"moveToPayments()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">המשך</md-button></div>\n</md-dialog-actions></form></md-content></md-tab-body></md-tab><md-tab \nng-disabled=\"(!newRegistration.LastName && !newRegistration.UserPhoneNumber)  || payments.length\" \nng-if=\"quesitons.length>0\"><md-tab-label><span>שאלות</span></md-tab-label><md-tab-body><form name=\"quetionsForm\" \nclass=\"md-inline-form\" validate><div layout=\"row\" layout-wrap ng-repeat=\"question in quesitons\"><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" ng-if=\"question.AnswerType!=3\"><md-icon \nstyle=\"cursor: pointer\" md-svg-icon=\"help-circle\" class=\"name\"></md-icon><label ng-if=\"question.AnswerType != 5\">\n{{question.Description}}</label><input ng-if=\"question.AnswerType==1\" ng-model=\"question.Answer\" \nng-disabled=\"isClicked\" ng-required=\"question.Required\"><md-select ng-if=\"question.AnswerType==2\" \nng-model=\"question.Answer\" ng-disabled=\"isClicked\" ng-required=\"question.Required\"><md-option \nng-repeat=\"questionOption in question.Options\" ng-value=\"questionOption\">{{questionOption}}</md-option></md-select><div\n ng-if=\"question.AnswerType==4\" start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"question.Answer\"><input\n autocomplete=\"off\" ng-model=\"question.Answer\" ng-disabled=\"isClicked\" ng-required=\"question.Required\"></div>\n<md-checkbox ng-if=\"question.AnswerType == 5\" ng-required=\"question.Required\" ng-true-value=\"true\" \nng-false-value=\"false\" ng-model=\"question.Answer\">{{question.Description}}</md-checkbox></md-input-container></div>\n<md-button type=\"submit\" ng-disabled=\"quetionsForm.$invalid\" class=\"md-raised md-accent\" aria-label=\"חפש\" \nng-click=\"updateQuestions(registrations.Questions)\">המשך</md-button></form></md-tab-body></md-tab><md-tab \nng-disabled=\"(!newRegistration.LastName && !newRegistration.UserPhoneNumber) || new || payments.length || questionsDisable\" \nng-if=\"transportation.length>0\"><md-tab-label><span>הסעות</span></md-tab-label><md-tab-body><form \nname=\"TransportationForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>הסעה הלוך</label><md-select \nng-model=\"selectedTransportation.SelectedTransportationTo\"><md-option ng-repeat=\"transportationItem in transportation\" \nng-value=\"transportationItem\" ng-if=\"transportationItem.Way==1\">{{transportationItem.Name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" \nclass=\"name\"></md-icon><label>תחנה הלוך</label><md-select \nng-model=\"selectedTransportation.SelectedTransportationStopTo\" \nng-disabled=\"!selectedTransportation.SelectedTransportationTo\"><md-option \nng-repeat=\"stop in selectedTransportation.SelectedTransportationTo.Stops\" ng-value=\"stop\">{{stop.Name}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>הסעה חזור</label><md-select \nng-disabled=\"isClicked\" ng-model=\"selectedTransportation.SelectedTransportationFrom\"><md-option \nng-repeat=\"transportationItem in transportation\" ng-if=\"transportationItem.Way==2\" ng-value=\"transportationItem\">\n{{transportationItem.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\"><md-icon md-svg-icon=\"bus\" class=\"name\"></md-icon><label>תחנה חזור</label><md-select \nng-model=\"selectedTransportation.SelectedTransportationStopFrom\" \nng-disabled=\"!selectedTransportation.SelectedTransportationFrom\"><md-option \nng-repeat=\"stop in selectedTransportation.SelectedTransportationFrom.Stops\" ng-value=\"stop\">{{stop.Name}}</md-option>\n</md-select></md-input-container></div><md-button type=\"submit\" ng-disabled=\"TransportationForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"updateTransportations()\">המשך</md-button></form></md-tab-body>\n</md-tab><md-tab \nng-disabled=\"payments.length  || (!newRegistration.LastName && !newRegistration.UserPhoneNumber) || new || questionsDisable || transportationDisable\" \nng-if=\"location && location.Layout.length > 0\"><md-tab-label><span>בחירת מקום</span></md-tab-label><md-tab-body><div \nclass=\"md-inline-form\"><div layout=\"row\" layout-wrap><div id=\"row-seats-layout\" class=\"sflex fdc\"><div \nid=\"section-seats-layout\" class=\"sflex fdc jcc mt10\" ng-repeat=\"section in location.layout track by $index\"><div \nclass=\"center hfs18 fw-bold\">איזור {{section.Name}}</div><div ng-repeat=\"row in section.Rows track by $index\" \nclass=\"fcc\"><div>שורה {{row.Name}}</div><div ng-repeat=\"seat in row.Seats track by $index\" class=\"seat center fcc cp\" \nng-class=\"{\'free\': !seat.taken, \'taken\': seat.taken,\'reserved\': seat.reserved, \'notAvailable\': seat.notAvailable}\" \nng-click=\"!seat.taken && !seat.notAvailable && saveSeat(section.ID,row.ID,seat.ID); seat.reserved = true\"><span>\n{{seat.Name}}</span></div></div></div></div></div><md-button type=\"submit\" ng-disabled=\"locationForm.$invalid\" \nclass=\"md-raised md-accent\" aria-label=\"חפש\" ng-click=\"goToPayments()\">המשך</md-button></div></md-tab-body></md-tab>\n<md-tab \nng-disabled=\"((!newRegistration.LastName && !newRegistration.UserPhoneNumber) || new) || questionsDisable || transportationDisable || locationDisabled\">\n<md-tab-label><span>תשלום</span></md-tab-label><md-tab-body><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"!items\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div class=\"total-price\" ng-class=\"{\'fcred\':!getTotalAmountsValidity()}\"><span ng-if=\"!event.MonthlyPayment\">\nסכום כללי לחיוב:{{event.NewPrice}}</span></div><md-content class=\"payments-tab\" style=\"height: 500px\" ng-show=\"items\">\n<form class=\"md-inline-form\" validate name=\"newRegistrationPart2Form\"><div class=\"separate-block\" \nng-class=\"{\'paid\':payment.ReceiptID != \'\'}\" ng-repeat=\"payment in payments\"><div layout=\"row\" flex=\"100\" \nng-if=\"event.EventType != 1 && newRegistration.userType == 1\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" class=\"name\"></md-icon><label>\nשם ומייל לקבלה</label><md-select required=\"true\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-model=\"payment.parent\" ng-change=\"setParent($index)\" placeholder=\"בחר הורה\"><md-option \nng-repeat=\"parent in parents\" ng-value=\"parent\">{{parent.Name}} - {{parent.Email}}</md-option><md-option \nng-value=\"\'other\'\">אחר</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nng-if=\" newRegistration.userType == 0 || payment.parent === \'other\' || event.EventType == 1\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><label>שם לקבלה</label><input ng-model=\"payment.Name\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\' || event.EventType == 1\" required></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><label>מייל לשליחת קבלה</label><input ng-model=\"payment.Email\" \ntype=\"email\" ng-disabled=\"isClicked || payment.ReceiptID != \'\' || event.EventType == 1\" required></md-input-container>\n</div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\" \nng-if=\"event.MonthlyPayment != 1\"><md-input-container class=\"md-block md-icon-left\"><md-icon \nmd-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום לחיוב</label><input ng-model=\"payment.Amount\" \ntype=\"number\" ng-change=\"payment.Type == 1 && checkIfNoCharge($index)\" \nng-disabled=\"isClicked || payment.Name == \'\' || payment.Email == \'\' || payment.ReceiptID != \'\' || ($root.AdminLevel<3 && !$root.User.Payments)\" \nng-model-options=\"{debounce: 750}\" min=\"{{event.NewPrice == 0? 0 : 1}}\" \nmax=\"{{event.NewPrice? event.NewPrice : event.Price}}\" required></md-input-container></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"cash\" \nclass=\"name\"></md-icon><label>אמצעי תשלום</label><md-select ng-required=\"true\" ng-model=\"payment.Type\" \nng-disabled=\"!payment.Amount || isClicked || !items || event.NewPrice==0 || event.Price==0 || payment.Name == \'\' || payment.Email == \'\' || payment.ReceiptID != \'\'\" \nng-change=\"checkIfNoCharge($index)\" placeholder=\"אמצעי תשלום\"><md-option \nng-if=\"event.NewPrice == 0 || event.Price == 0\" ng-value=\"0\" ng-disabled=\"$root.User.EventsPay\" \nng-selected=\"event.NewPrice==0 || event.Price==0\">ללא חיוב</md-option><md-option ng-value=\"1\" \nng-if=\"!(activeModule.monthlyPayment && event.MonthlyPayment)\">אשראי</md-option><md-option \nng-if=\"payments.length == 1 && event.MonthlyPayment && event.ExtraPrice\" ng-value=\"11\">הוראת קבע + חיוב מיידי\n</md-option><md-option ng-value=\"11\" \nng-if=\"payments.length == 1 && activeModule.monthlyPayment && event.MonthlyPayment && !event.ExtraPrice\">\nהוראת קבע אשראי</md-option><md-option ng-value=\"2\">מזומן</md-option><md-option ng-value=\"3\">העברה בנקאית</md-option>\n<md-option ng-value=\"4\" ng-if=\"$root.AdminLevel>=3 || $root.User.ChecksPer\">המחאה</md-option></md-select>\n</md-input-container></div></div><div ng-show=\"payment.Type==3\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל החשבון</label><input ng-model=\"payment.AccountName\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==3\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר בנק</label>\n<input ng-model=\"payment.BankNumber\" type=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==3\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר סניף</label><input ng-model=\"payment.BranchNumber\" \ntype=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==3\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר חשבון</label><input ng-model=\"payment.AccountNumber\" type=\"number\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==3\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"upload\" class=\"name\" \nng-class=\"{\'green600\':payment.FileReceipt,\'red600\':!payment.FileReceipt}\"></md-icon><input placeholder=\"העלאת אסמכתא\" \nng-value=\"payment.FileName\" name=\"file\" ngf-select=\"uploadFile($file,payment)\" ngf-pattern=\"\'image/*\'\" class=\"cp\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"md-block\"><md-icon class=\"name\"></md-icon><label>\nבנק</label><md-icon md-svg-icon=\"bank\" class=\"name\"></md-icon><md-select ng-model=\"payment.BrandAccountNumber\" \nng-disabled=\"!banks || isClicked || payment.ReceiptID != \'\'\"><md-option ng-repeat=\"bank in banks\" \nng-value=\"bank.Number\">{{bank.Name}}</md-option></md-select></md-input-container></div><div ng-show=\"payment.Type==4\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"account\" class=\"name\"></md-icon><label>שם בעל הצ\'ק/ים\n</label><input ng-model=\"payment.CheckOwner\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"numeric\" class=\"name\"></md-icon><label>מספר צ\'קים</label><input ng-model=\"payment.NumberOfCheck\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" type=\"number\" min=\"1\" ng-required=\"newRegistration.Type==4\" \nng-change=\"generateChecks($index)\"></md-input-container><div ng-repeat=\"check in payment.checks\" \nng-if=\"payment.checks.length\" layout=\"row\" layout-wrap flex=\"100\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>בנק\n</label><input ng-model=\"check.CheckBank\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר סניף</label><input ng-model=\"check.CheckBranch\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר חשבון</label><input ng-model=\"check.CheckAccountNumber\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon md-svg-icon=\"numeric\" class=\"name\"></md-icon><label>\nמספר המחאה</label><input ng-model=\"check.CheckNumber\" type=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" \nng-required=\"newRegistration.Type==4\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block md-icon-left relative\"><md-icon md-svg-icon=\"calendar\" \nclass=\"name\"></md-icon><div start-view=\"day\" locale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"check.CheckMaturityDate\">\n<label>מועד פרעון</label><input ng-required=\"newRegistration.Type==4\" autocomplete=\"off\" \nng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-model=\"check.CheckMaturityDate\"></div></md-input-container></div>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><md-icon \nmd-svg-icon=\"cash-multiple\" class=\"name\"></md-icon><label>סכום המחאה</label><input ng-model=\"check.CheckAmount\" \ntype=\"number\" ng-disabled=\"isClicked || payment.ReceiptID != \'\'\" ng-required=\"newRegistration.Type==4\">\n</md-input-container></div></div></div><div ng-if=\"event.MonthlyPayment != 1\"><md-input-container class=\"md-block\">\n<md-icon md-svg-icon=\"cards-outline\" class=\"name\"></md-icon><label>סטטוס תשלום</label><md-select \nng-model=\"payment.PaymentStatus\" \nng-disabled=\"isClicked || ($root.AdminLevel<3 && !$root.User.Payments) || payment.paymentStatusDisabled\"><md-option \nng-value=\"1\">שולם</md-option><md-option ng-value=\"2\">שולם ל{{$root.User.Coordinator}}</md-option><md-option \nng-value=\"3\">טרם אושר</md-option><md-option ng-value=\"5\" ng-if=\"$root.advancedCashierOptions\">הופקד לקופה</md-option>\n<md-option ng-value=\"6\" ng-if=\"$root.advancedCashierOptions\">יצא להפקדה</md-option><md-option ng-value=\"7\" \nng-if=\"$root.advancedCashierOptions\">הופקד</md-option><md-option ng-value=\"0\">לא שולם</md-option></md-select>\n</md-input-container></div><div ng-if=\"payment.Type == 11 && event.ExtraPrice > 0\" class=\"fcred hfs13\">\nחיוב בפועל על המחיר הנוסף ({{event.ExtraPrice}}₪) יתבצע מיד בסיום ההרשמה</div><div class=\"iframe_container\" \nng-if=\"(payment.Type==1 || payment.Type == 11) && payment.iframe != \'\'\"><iframe src=\"{{trustSrc(payment.iframe)}}\" \nframeborder=\"0\"></iframe></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"event.MonthlyPayment != 1\">\n<md-button \nng-if=\"payment.Type != undefined && checkChecksValidity(payment) &&\r\n                                                    ([1,11].indexOf(payment.Type) == -1 && payment.ReceiptID == \'\')\" \ndata-ng-disabled=\"newRegistrationPart2Form.$invalid\" ng-click=\"savePayment($index)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירת תשלום</md-button><md-button \nng-if=\"event.MonthlyPayment != 1 && payment.Type != 11 && $index == payments.length - 1 && ($root.AdminLevel == 3 || $root.User.Payments)\" \nng-disabled=\"payment.ReceiptID == \'\' || getTotalAmountsValidity()\" ng-click=\"addPaymentMissingPrice()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">פצל תשלום</md-button><md-button \nng-if=\"payments.length != 1 && ($root.AdminLevel == 3 || $root.User.Payments)\" \nng-disabled=\"payment.ReceiptID != \'\' || payment.RegistrationID != \'\'\" ng-click=\"removePayment($index)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">מחק תשלום</md-button></div></div><div class=\"mt50\">\n<md-input-container class=\"md-block\"><md-icon md-svg-icon=\"power\" class=\"name\"></md-icon><label>סטטוס הרשמה</label>\n<md-select ng-model=\"newRegistration.Status\" ng-disabled=\"isClicked || ($root.AdminLevel<3 && !$root.User.Payments)\" \nng-init=\"newRegistration.Status=1\"><md-option ng-value=\"-1\" ng-if=\"event.MonthlyPayment == 1\">קפוא</md-option>\n<md-option ng-value=\"1\">פעיל</md-option><md-option ng-value=\"0\">לא פעיל</md-option></md-select></md-input-container>\n</div><div layout=\"row\" layout-align=\"start center\" ng-show=\" newRegistration.Type!=1\"><md-button \ndata-ng-disabled=\"newRegistrationPart2Form.$invalid || isClicked || (event.MonthlyPayment != 1 && !paymentsValidity() && !checkForMonthlyPayment()) || (payments.length == 0 && (!parents || parents.length == 0))\" \ntype=\"submit\" ng-click=\"saveNewRegistration()\" id=\"saveNewRegBtn\" class=\"send-button md-accent md-raised\" \naria-label=\"Add Task\">שמירה</md-button><md-button \ndata-ng-disabled=\"newRegistrationPart2Form.$invalid || isClicked || (event.MonthlyPayment != 1 && !paymentsValidity() && !checkForMonthlyPayment()) || (payments.length == 0 && (!parents || parents.length == 0))\" \ntype=\"submit\" ng-click=\"saveNewRegistration(true)\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">\nשמירה והוספת הרשמה חדשה</md-button></div><div class=\"w100 sflex mt25 aic jcc errMsg\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"showErr\">{{errMsg}}</div></form></md-content></md-tab-body></md-tab></md-tabs>\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/settings-menue/views/locations/location-management/tabs/sections/new-row-dialog/new-row-dialog.html","<md-dialog class=\"newRow-dialog\" aria-label=\"New Task\" ng-init=\"getSettlements()\"><form name=\"newRowForm\" \ndata-ng-model=\"newRowForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nיצירת שורה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-weather-sunny\"></md-icon><label>שם שורה</label><input \nng-model=\"newRow.Name\" type=\"text\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-weather-sunny\"></md-icon><label>כמות כסאות</label><input \nng-model=\"newRow.amountOfSeats\" type=\"number\" min=\"1\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-weather-sunny\"></md-icon><label>\nמספר כסא ראשון</label><input ng-model=\"newRow.FirstSeatNumber\" type=\"number\" min=\"1\" ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newRowForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewRow()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/family/new-family-member-dialog/new-family-member-dialog.html","<md-dialog class=\"newFamilyMember-dialog\" aria-label=\"New Task\"><form name=\"newFamilyMemberForm\" \ndata-ng-model=\"newFamilyMemberForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת בן משפחה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>\nבחר סוג</label><md-select ng-model=\"newFamilyMember.Type\" required=\"\"><md-option ng-value=\"1\">בן/בת זוג</md-option>\n<md-option ng-value=\"2\">ילד</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"newFamilyMember.Type\"><md-button class=\"md-accent md-raised cp\" ng-if=\"!tz\" ng-click=\"ChangeToPassport()\">\nהחלף לדרכון / תעודה חריגה</md-button><md-button class=\"md-accent md-raised cp\" ng-if=\"tz\" \nng-click=\"ChangeToPassport()\">החלף לתעודה מזהה</md-button></md-input-container><md-input-container class=\"md-block\" \nng-if=\"newFamilyMember.Type\"><md-icon md-font-icon=\"icon-account-box\" class=\"name\"></md-icon><label ng-if=\"!tz\">\nתעודת זהות</label><label ng-if=\"tz\">דרכון</label><input ng-model=\"newFamilyMember.PrivateID\" \ntitle=\"במידה וההורה קיים יש להכניס ת.ז בלבד\" data-ng-required=\"true\" data-ng-pattern=\"pattern\" ng-required=\"true\" \nng-disabled=\"isClicked\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newFamilyMemberForm.$invalid || isClicked\" type=\"submit\" ng-click=\"savenewFamilyMember()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/subsidy-dialog.html","<md-dialog class=\"subsidy-dialog\" aria-label=\"New Task\" style=\"min-width: 1000px\"><form name=\"newCoordinatorsForm\" \ndata-ng-model=\"newCoordinatorsForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nבקשת סבסוד</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-tabs md-dynamic-height md-selected=\"selectedTab\" ng-if=\"!subsidy.typeForm\"><md-tab><md-tab-label>\n<span>פרטי ילדים</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/kids.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>מצב כלכלי</span></md-tab-label><md-tab-body><md-content\n class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/economic.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>פרטי עיסוק</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/occupation.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>הכנסות נוספות</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/revenue.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>סיבות לבקשה וקבצים</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/details.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>שימוש פנימי</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/internal.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs><md-tabs md-dynamic-height md-selected=\"selectedTab\" \nng-if=\"subsidy.typeForm\"><md-tab><md-tab-label><span>פרטי הטופס</span></md-tab-label><md-tab-body><md-content \nclass=\"general-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/form2/formtype2.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>שימוש פנימי</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" style=\"padding: 50px\" \nng-include=\"\'app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/internal.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></form></md-dialog>");
$templateCache.put("app/main/pages/users/views/students/student-profile/tabs/educator-groups/new-educator-group-dialog/new-educator-group-dialog.html","<md-dialog class=\"newParent-dialog\" aria-label=\"New Task\" ng-init=\"vm.getSettlements()\"><form name=\"newParentForm\" \ndata-ng-model=\"newParentForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nשיוך {{$root.User.Group}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div><md-input-container class=\"md-block\"><label>בחר {{$root.orgTypeBranchName.single}}\n</label><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.getGroupsBySettlement()\" ng-model=\"vm.newGroup.SettlementID\" \nng-disabled=\"!vm.settlements || vm.isClicked\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"text\" ng-disabled=\"!vm.settlements || vm.isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.orgTypeBranchName.single}}..\" \nclass=\"demo-header-searchbox md-text\" autocomplete=\"off\"></md-select-header><md-optgroup \nng-disabled=\"!vm.settlements || isClicked\"><md-option ng-value=\"settlement.ID\" \nng-repeat=\"settlement in vm.settlements |filter:vm.searchTerm\">{{settlement.Name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>בחר {{$root.User.Group}}</label><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><md-select md-on-close=\"vm.clearSearchTerm2()\" \nng-model=\"vm.newGroup.GroupID\" ng-disabled=\"!vm.groups || vm.isClicked\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm2\" type=\"text\" ng-disabled=\"!vm.groups || vm.isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Group}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"!groups || isClicked\"><md-option ng-value=\"group.ID\" \nng-repeat=\"group in vm.groups |filter:vm.searchTerm2\">{{group.Name}}</md-option></md-optgroup></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"newParentForm.$invalid || vm.isClicked\" \ntype=\"submit\" ng-click=\"vm.addGroup()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/utils/views/activities/activities-profile/tabs/meetings/new-activity-meeting-dialog/new-activity-meeting-dialog.html","<md-dialog class=\"new-activities-dialog\" aria-label=\"New Task\" style=\"overflow: visible\"><form \nname=\"newActivityMeetingForm\" data-ng-model=\"newActivityMeetingForm\" class=\"md-inline-form\" validate \nstyle=\"overflow: visible\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת מפגש חדש</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate>\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"overflow: visible !important\"><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" flex=\"100\"><md-icon \nmd-font-icon=\"icon-leaf\" class=\"name\"></md-icon><label>שם {{$root.User.Activity}}</label><input \nng-model=\"newMeeting.Name\" type=\"text\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container><md-input-container\n class=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" flex=\"100\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"name\"></md-icon><label>{{$root.User.Groups}}</label><input \nng-value=\"newMeeting.GroupName\" type=\"text\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left\" layout=\"column\" layout-xs=\"row\" flex=\"100\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><div locale=\"he\" format=\"DD/MM/YYYY HH:mm\" position=\"bottom right\" \nmoment-picker=\"newMeeting.Date\"><label>תאריך</label><input autocomplete=\"off\" ng-model=\"newMeeting.Date\" \nng-required=\"true\" ng-disabled=\"isClicked\"></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newActivityMeetingForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewMeeting()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/general-discount-panel/general-discount-panel.html","<md-content ms-scroll><form name=\"generalDiscountForm\" id=\"generalDiscountForm\" data-ng-model=\"generalDiscountForm\" \nclass=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהנחה כללית</span><md-button class=\"md-icon-button\" ng-click=\"closePanel()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"PROFILE_PANEL.CLOSE_PANEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-input-container class=\"md-icon-float md-block md-icon-left\"><label>רמה</label><md-select \nng-model=\"editedGeneralDiscount.Level\" ng-disabled=\"true\"><md-option ng-value=\"1\" \nng-selected=\"generalDiscount.Level==1\">בודדת</md-option><md-option ng-value=\"2\" ng-selected=\"generalDiscount.Level==2\">\nמרובה</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\">\n<label>{{$root.orgTypeBranchName.plural}}</label><md-select ng-model=\"editedGeneralDiscount.Settlements\" \nmultiple=\"multiple\" ng-disabled=\"true\"><md-option ng-repeat=\"settlement in generalDiscount.Settlements\" \nng-selected=\"settlement.Active\" ng-value=\"settlement\">{{settlement.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\"><label>{{$root.User.Event}}</label><md-select \nng-model=\"editedGeneralDiscount.ParentEvent\" ng-disabled=\"true\"><md-option>ללא</md-option><md-option \nng-repeat=\"event in generalDiscount.Events\" ng-selected=\"event.Active\" ng-value=\"event\">{{event.Name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\"><label>אזור</label>\n<md-select ng-model=\"editedGeneralDiscount.Areas\" multiple=\"multiple\" ng-disabled=\"true\"><md-option \nng-repeat=\"area in generalDiscount.Areas\" ng-selected=\"area.Active\" ng-value=\"area\">{{area.Name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\"><label>\n{{$root.User.Groups}}</label><md-select ng-model=\"editedGeneralDiscount.Grades\" multiple=\"multiple\" ng-disabled=\"true\">\n<md-option ng-repeat=\"grade in generalDiscount.Grades\" ng-selected=\"grade.Active\" ng-value=\"grade\">{{grade.Name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block md-icon-float md-block md-icon-left\">\n<label>סכום הנחה</label><input type=\"text\" ng-model=\"editedGeneralDiscount.Discount\" \nng-value=\"generalDiscount.Discount\" ng-disabled=\"true\" ng-required=\"true\" ng-pattern=\"/^\\d+$/\" \nplaceholder=\"יש להכניס מספר שלם\"></md-input-container><md-input-container \nclass=\"md-block md-icon-float md-block md-icon-left\" ng-if=\"$root.memberYearLogicEnabled && activeModule.memberEvents\">\n<label>הנחה עבור הרשמה ראשונית לדמי חבר</label><input type=\"text\" ng-model=\"editedGeneralDiscount.NewMemberPay\" \nng-value=\"generalDiscount.NewMemberPay==1 ? \'כן\' : \'לא\'\" ng-disabled=\"true\" ng-required=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block md-icon-left\"><label>סוג</label><md-select \nng-model=\"editedGeneralDiscount.Type\" ng-disabled=\"true\" ng-required=\"true\"><md-option ng-value=\"1\" \nng-selected=\"generalDiscount.Type==1\">ש\"ח</md-option><md-option ng-value=\"2\" ng-selected=\"generalDiscount.Type==2\">\nאחוזים</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block md-icon-left\">\n<label>סטטוס</label><md-select ng-model=\"editedGeneralDiscount.Status\" ng-disabled=\"true\" ng-required=\"true\"><md-option\n ng-value=\"1\" ng-selected=\"generalDiscount.Status==1\">פעיל</md-option><md-option ng-value=\"0\" \nng-selected=\"generalDiscount.Status==0\">לא פעיל</md-option></md-select></md-input-container></form></md-content>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-brother-discount-dialog/new-brother-discount-dialog.html","<md-dialog class=\"newBrotherDiscount-dialog\" aria-label=\"New Task\" ng-init=\"getAllInformation()\"><form \nname=\"newBrotherDiscountForm\" data-ng-model=\"newBrotherDiscountForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספת הנחת משפחה חדשה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div><md-input-container class=\"md-block\"><label>רמה\n</label><md-select ng-model=\"newBrotherDiscount.Level\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">\nבודדת</md-option><md-option value=\"2\">מרובה</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>הכנס/י סכום/אחוזים</label><input type=\"text\" ng-model=\"newBrotherDiscount.Discount\" \nng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><label>סוג</label><md-select ng-model=\"newBrotherDiscount.Type\" \nng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">ש\"ח</md-option><md-option value=\"2\">אחוזים</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>סטטוס</label><md-select \nng-model=\"newBrotherDiscount.Status\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">פעיל</md-option>\n<md-option value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-ng-disabled=\"newBrotherDiscountForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveNewBrotherDiscount()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-general-discount-dialog/new-general-discount-dialog.html","<md-dialog class=\"newGeneralDiscount-dialog\" aria-label=\"New Task\" ng-init=\"getAllInformation()\"><form \nname=\"newGeneralDiscountForm\" data-ng-model=\"newGeneralDiscountForm\" class=\"md-inline-form\" validate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">הוספת הנחה כללית חדשה</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"endpointsReady<3\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-show=\"endpointsReady>=3\"><md-input-container class=\"md-block\"><label>רמה</label>\n<md-select ng-model=\"newGeneralDiscount.Level\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">בודדת\n</md-option><md-option value=\"2\">מרובה</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>{{$root.orgTypeBranchName.plural}}</label><md-select ng-model=\"newGeneralDiscount.Settlements\" \nmultiple=\"multiple\" ng-disabled=\"isClicked\"><md-option ng-value=\"settlement\" \nng-repeat=\"settlement in endpointData.Settlements\">{{settlement.Name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>רשום ל{{$root.User.Event}}</label><md-select \nmd-on-close=\"clearSearchTerm()\" ng-model=\"newGeneralDiscount.ParentEventID\" ng-disabled=\"isClicked\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" type=\"text\" ng-disabled=\"isClicked\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"חפש {{$root.User.Event}}..\" class=\"demo-header-searchbox md-text\" \nautocomplete=\"off\"></md-select-header><md-optgroup ng-disabled=\"isClicked\" ng-disabled=\"isClicked\"><md-option>ללא\n</md-option><md-option ng-value=\"event\" ng-repeat=\"event in endpointData.Events |filter:searchTerm\">{{event.Name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\"><label>\n{{$root.User.Grades}}</label><md-select ng-model=\"newGeneralDiscount.Grades\" multiple=\"multiple\" \nng-disabled=\"!endpointData.Grades || isClicked\"><md-option ng-value=\"grade\" ng-repeat=\"grade in endpointData.Grades\">\n{{grade.Name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nהכנס/י סכום/אחוזים</label><input type=\"text\" ng-model=\"newGeneralDiscount.Discount\" ng-pattern=\"/^\\d+$/\" \nplaceholder=\"יש להכניס מספר שלם\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container \nclass=\"md-block\"><label>סוג</label><md-select ng-model=\"newGeneralDiscount.Type\" ng-required=\"true\" \nng-disabled=\"isClicked\"><md-option value=\"1\">ש\"ח</md-option><md-option value=\"2\">אחוזים</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" \nng-if=\"$root.memberYearLogicEnabled && activeModule.memberEvents\"><label>הנחה עבור הרשמה ראשונית לדמי חבר</label>\n<md-select ng-model=\"newGeneralDiscount.NewMemberPay\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">\nכן</md-option><md-option value=\"0\">לא</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<label>סטטוס</label><md-select ng-model=\"newGeneralDiscount.Status\" ng-required=\"true\" ng-disabled=\"isClicked\">\n<md-option value=\"1\">פעיל</md-option><md-option value=\"0\">לא פעיל</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-ng-disabled=\"newGeneralDiscountForm.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewGeneralDiscount()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-registration-discount-dialog/new-registration-discount-dialog.html","<md-dialog class=\"newRegistrationDiscount-dialog\" aria-label=\"New Task\"><form name=\"newRegistrationDiscountForm\" \ndata-ng-model=\"newRegistrationDiscountForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">הוספת הנחה חדשה לפי כמות הרשמות</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div><md-input-container class=\"md-block\"><label>רמה</label><md-select \nng-model=\"newRegistrationDiscount.Level\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">בודדת\n</md-option><md-option value=\"2\">מרובה</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>הכנס/י סכום/אחוזים</label><input type=\"text\" ng-model=\"newRegistrationDiscount.Discount\" \nng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><label>סוג</label><md-select ng-model=\"newRegistrationDiscount.Type\" \nng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">ש\"ח</md-option><md-option value=\"2\">אחוזים</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>סטטוס</label><md-select \nng-model=\"newRegistrationDiscount.Status\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">פעיל\n</md-option><md-option value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-ng-disabled=\"newRegistrationDiscount.$invalid || isClicked\" type=\"submit\" \nng-click=\"saveNewRegistrationDiscount()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-date-discount-dialog/new-date-discount-dialog.html","<md-dialog class=\"newSDateDiscount-dialog\" aria-label=\"New Task\"><form name=\"newDateDiscountForm\" \ndata-ng-model=\"newDateDiscountForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הנחה לפי תאריך</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntitle=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"mt30\"><md-input-container class=\"md-block\"><label>תאריך התחלת הנחה</label><div \nmoment-picker=\"newDateDiscount.FromDate\" format=\"DD/MM/YYYY\" start-view=\"day\" locale=\"he\" append-to-body=\"true\"><input \nclass=\"md-input\" ng-model=\"newDateDiscount.FromDate\" required ng-disabled=\"isClicked\" autocomplete=\"off\"></div>\n</md-input-container><md-input-container class=\"md-block\"><label>תאריך סיום הנחה</label><div start-view=\"day\" \nlocale=\"he\" format=\"DD/MM/YYYY\" moment-picker=\"newDateDiscount.ToDate\"><input autocomplete=\"off\" \nng-model=\"newDateDiscount.ToDate\" required ng-disabled=\"isClicked\"></div></md-input-container><md-input-container \nclass=\"md-block\"><label>רמה</label><md-select ng-model=\"newDateDiscount.Level\" ng-required=\"true\" \nng-disabled=\"isClicked\"><md-option value=\"1\">בודדת</md-option><md-option value=\"2\">מרובה</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>סוג</label><md-select ng-model=\"newDateDiscount.Type\" \nng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">ש\"ח</md-option><md-option value=\"2\">אחוזים</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>הכנס/י סכום/אחוזים</label><input \ntype=\"text\" ng-model=\"newDateDiscount.Discount\" ng-pattern=\"/^\\d+$/\" placeholder=\"יש להכניס מספר שלם\" \nng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container class=\"md-block\"><label>סטטוס\n</label><md-select ng-model=\"newDateDiscount.Status\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">\nפעיל</md-option><md-option value=\"0\">לא פעיל</md-option></md-select></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-ng-disabled=\"newDateDiscountForm.$invalid || isClicked\" type=\"submit\" ng-click=\"saveDateDiscount()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/discounts/tabs/new-student-discount-dialog/new-student-discount-dialog.html","<md-dialog class=\"newStudentDiscount-dialog\" aria-label=\"New Task\"><form name=\"newStudentDiscountForm\" \ndata-ng-model=\"newStudentDiscountForm\" class=\"md-inline-form\" validate><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">הוספת הנחת תושב</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" title=\"הוספת הנחה\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div><div><label class=\"db\">סוג תושב:</label><md-radio-group \nng-model=\"newStudentDiscount.userType\" ng-required=\"true\"><md-radio-button value=\"0\" aria-label=\"הורה\">הורה\n</md-radio-button><md-radio-button value=\"1\" aria-label=\"חניך\">חניך</md-radio-button></md-radio-group></div>\n<md-input-container class=\"md-block\" ng-if=\"!withFile\"><label>ת.ז</label><input type=\"text\" \nng-model=\"newStudentDiscount.UserPrivateID\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container>\n<md-input-container class=\"md-block\"><label>רמה</label><md-select ng-model=\"newStudentDiscount.Level\" \nng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">בודדת</md-option><md-option value=\"2\">מרובה</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>סוג</label><md-select \nng-model=\"newStudentDiscount.Type\" ng-required=\"true\" ng-disabled=\"isClicked\"><md-option value=\"1\">ש\"ח</md-option>\n<md-option value=\"2\">אחוזים</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nהכנס/י סכום/אחוזים</label><input type=\"text\" ng-model=\"newStudentDiscount.Discount\" ng-pattern=\"/^\\d+$/\" \nplaceholder=\"יש להכניס מספר שלם\" ng-required=\"true\" ng-disabled=\"isClicked\"></md-input-container><md-input-container \nclass=\"md-block\"><label>סטטוס</label><md-select ng-model=\"newStudentDiscount.Status\" ng-required=\"true\" \nng-disabled=\"isClicked\"><md-option value=\"1\">פעיל</md-option><md-option value=\"0\">לא פעיל</md-option></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button data-ng-disabled=\"newStudentDiscountForm.$invalid || isClicked\" \ntype=\"submit\" ng-click=\"saveNewStudentDiscount()\" class=\"send-button md-accent md-raised\" aria-label=\"Add Task\">שמירה\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/events/views/events/event-management/tabs/subscribers/new-monthly-payment-dialog/monthly-payment-preview-dialog/monthly-payment-preview-dialog.html","<md-dialog class=\"multiPayment-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nחיוב חדש בהוראת קבע - תצוגה מקדימה</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MANAGE_USERS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"content\" flex>\n<md-content class=\"about-tab\" style=\"padding: 20px; max-height: 70vh\"><div><table id=\"type-subscribers-table\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מספר הזמנה</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם מלא</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ת.ז</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">אשראי</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תוקף אשראי</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סכום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס חיוב</span></div></th></tr></thead><tbody><tr \nclass=\"md-ink-ripple\" \nng-class=\"{\'proccesing\':data.process == 0,\'success\': data.process == 1, \'failed\': data.process == -1}\" \nng-repeat=\"data in registrations track by $index\"><td>{{data.ID}}</td><td>{{data.MemberName}}</td><td>\n{{data.PrivateID}}</td><td ng-if=\"data.Finished\">{{data.CreditCardNumber}}</td><td ng-if=\"data.Finished\">\n{{data.CreditCardExpDate}}</td><td ng-if=\"data.Finished\">{{data.Price}} &#8362;</td><td ng-if=\"data.Finished\"><span \nng-if=\"data.ChargeResult\">{{data.ChargeResult}}</span><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"!data.ChargeResult && startedCharging\"></md-progress-linear></td><td ng-if=\"!data.Finished\" colspan=\"4\">\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"!data.Finished\"></md-progress-linear></td></tr></tbody></table>\n</div></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"finishedCount != registrations.length || startedCharging\" ng-click=\"addMonthlyPayment()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">חיוב עבור {{registrations.length}} נרשמים</md-button>\n<md-button ng-disabled=\"finishedCount != registrations.length\" ng-click=\"closeDialog()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Task\">סגור</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/form2/formtype2.html","<div id=\"tofes2\"><h2>שם ה{{$root.User.Event}}: {{subsidy.Event }}</h2><h3 class=\"hfs20 fw-light\">\nתאריך בקשה {{subsidy.CreateTime*1000 | date}}</h3><table ng-if=\"subsidy.Students\" \nclass=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תעודות זהות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"student in subsidy.Students\"><td>{{student.PrivateID}}</td><td>{{student.FirstName}} {{student.LastName}}\n</td><td>{{student.GroupName}}</td><td>{{student.BranchName}}</td><td>{{student.Status ? \'פעיל\' : \'לא פעיל\'}}<md-button\n class=\"preview-user\" ng-disabled=\"true\"></md-button></td></tr><tr class=\"md-ink-ripple\" ng-repeat=\"kid in moreKids\">\n<td>{{kid.PrivateID}}</td><td>{{kid.FirstName + \" \" + kid.LastName}}</td><td>{{kid.GroupName}}</td><td>\n{{kid.BranchName}}</td><td>{{kid.student.Stats ? \'לא פעיל\' : \'פעיל\'}}<md-button class=\"preview-user\" \nng-disabled=\"true\"></md-button></td></tr></tbody></table><div class=\"w100 inrowf mt20\"><md-input-container \nng-if=\"subsidy.ParentFName\" class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>2 שם פרטי הורה</label><input ng-value=\"subsidy.ParentFName\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"subsidy.ParentFName\" \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>שם משפחה הורה 2</label><input ng-value=\"subsidy.ParentLName\" type=\"text\" \nng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"subsidy.ParentFName\" class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>\n2 פלאפון הורה</label><input ng-value=\"subsidy.ParentMNumber\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container ng-if=\"subsidy.ParentFName\" class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" \nflex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>אימייל הורה 2</label><input \nng-value=\"subsidy.ParentEmail\" type=\"text\" ng-disabled=\"true\"></md-input-container><div class=\"col4s20\">\nצילום ת.ז הורה 1 <a href=\"{{subsidy.Parent1PrivateIDFile.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon>\n</a></div><div class=\"col4s20\">צילום משכורת ראשונה הורה 1 <a href=\"{{subsidy.Parent1Paycheck1File.Path}}\" \ntarget=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div class=\"col4s20\">צילום משכורת שנייה הורה 1 <a \nhref=\"{{subsidy.Parent1Paycheck2File.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div \nclass=\"col4s20\">צילום משכורת שלישית הורה 1 <a href=\"{{subsidy.Parent1Paycheck3File.Path}}\" target=\"_blank\"><md-icon \nmd-svg-icon=\"eye\"></md-icon></a></div><div class=\"col4s20\" ng-if=\"subsidy.Parent2PrivateIDFile.Path\">צילום ת.ז הורה 2 \n<a href=\"{{subsidy.Parent2PrivateIDFile.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div \nclass=\"col4s20\" ng-if=\"subsidy.Parent2Paycheck1File.Path\">צילום משכורת ראשונה הורה 2 <a \nhref=\"{{subsidy.Parent2Paycheck1File.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div \nclass=\"col4s20\" ng-if=\"subsidy.Parent2Paycheck2File.Path\">צילום משכורת שנייה הורה 2 <a \nhref=\"{{subsidy.Parent2Paycheck2File.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div \nclass=\"col4s20\" ng-if=\"subsidy.Parent2Paycheck3File.Path\">צילום משכורת שלישית הורה 2 <a \nhref=\"{{subsidy.Parent2Paycheck3File.Path}}\" target=\"_blank\"><md-icon md-svg-icon=\"eye\"></md-icon></a></div><div \nclass=\"w100\"><ul><li ng-repeat=\"item in subsidy.OtherFiles\"><a href=\"{{item.Path}}\" target=\"_blank\">{{item.Name}}</a>\n</li></ul></div><div class=\"w100\" ng-if=\"subsidy.Comment\"><h3 class=\"hfs25 fw-medium\">הערות נוספות</h3><p>\n{{subsidy.Comment}}</p></div></div></div>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/details.html","<form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>סיבות לבקשה</label>\n<textarea ng-value=\"subsidy.Reason\" ng-disabled=\"true\"></textarea></md-input-container></div><span \nng-if=\"subsidy.Files\" ng-repeat=\"file in subsidy.Files\"><a style=\"font-size: 25px\" href=\"{{file.Path}}\" target=\"_self\" \ndownload=\"{{file.Name}}\" title=\"{{file.Name}}\" class=\"icon-file-document\"></a></span></form>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/economic.html","<form name=\"UserForm\" class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>בית פרטי</label><input ng-value=\"subsidy.House==1 ? \'כן\' : \'לא\'\" type=\"text\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>דירת מגורים</label>\n<input ng-value=\"subsidy.Apartment==1 ? \'כן\' : \'לא\'\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>בבעלות</label><input \nng-value=\"subsidy.Ownership==\'Private\' ? \'שכירות\' : \'פרטית\'\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>אחר</label><input ng-value=\"subsidy.OtherHouse\" type=\"text\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>בעל רכב</label><input ng-value=\"subsidy.Vehicle==1 ? \'כן\' : \'לא\'\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סוג רכב</label>\n<input ng-value=\"subsidy.VehicleType\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>רכב חברה</label><input \nng-value=\"subsidy.CompanyVehicle==1 ? \'כן\' : \'לא\'\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>שנת הרכב</label><input ng-value=\"subsidy.VehicleYear\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>רכב נוסף</label><input ng-value=\"subsidy.SecondVehicle==1 ? \'כן\' : \'לא\'\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סוג רכב</label>\n<input ng-value=\"subsidy.SecondVehicleType\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>רכב חברה</label><input \nng-value=\"subsidy.SecondCompanyVehicle==1 ? \'כן\' : \'לא\'\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>שנת הרכב</label><input ng-value=\"subsidy.SecondVehicleYear\" \ntype=\"text\" ng-disabled=\"true\"></md-input-container></div></form>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/internal.html","<form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>\nתשלום מאושר</label><md-select ng-model=\"subsidy.Confirmed\"><md-option ng-value=\"0\" \nng-selected=\"subsidy.Confirmed==0 || subsidy.Confirmed==\'0\'\">לא</md-option><md-option ng-value=\"1\" \nng-selected=\"subsidy.Confirmed==1 || subsidy.Confirmed==\'1\'\">כן</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סכום התשלום שאושר</label><input \nng-model=\"subsidy.NumberOfPayments\" type=\"number\"></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>שם המאשר</label><input ng-model=\"subsidy.ApprovedName\" \ntype=\"text\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>מאיזה תקציב</label><input ng-model=\"subsidy.FromBudget\" type=\"text\">\n</md-input-container></div><md-button type=\"submit\" ng-click=\"updateSubsidy()\" ng-disabled=\"isClicked\" \nclass=\"md-raised md-accent\" aria-label=\"שמור את השדות\" style=\"margin-right: 0px\">שמירה</md-button></form>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/kids.html","<table class=\"dataTable row-border hover stripe md-ink-ripple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">תעודות זהות</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Group}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{$root.User.Branch}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סטטוס</span></div></th></tr></thead><tbody><tr class=\"md-ink-ripple\" \nng-repeat=\"student in subsidy.Students\"><td>{{student.PrivateID}}</td><td>{{student.FirstName}} {{student.LastName}}\n</td><td>{{student.GroupName}}</td><td>{{student.BranchName}}</td><td>{{student.Status ? \'פעיל\' : \'לא פעיל\'}}<md-button\n class=\"preview-user\" ng-disabled=\"true\"></md-button></td></tr><tr class=\"md-ink-ripple\" \nng-repeat=\"kid in subsidy.Kids\"><td>{{kid.TZ}}</td><td>{{kid.Name}}</td><td>לא חבר</td><td>לא חבר</td><td>לא חבר\n<md-button class=\"preview-user\" ng-disabled=\"true\"></md-button></td></tr></tbody></table>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/occupation.html","<form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>\nמקצוע הורה 1</label><input ng-value=\"subsidy.FatherProfession\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>מקום עבודה הורה 1</label><input \nng-value=\"subsidy.FatherWorkplace\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סכום הכנסות הורה 1 ברוטו</label><input \nng-value=\"subsidy.FatherSalary\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>הערות הורה 1</label><input ng-value=\"subsidy.FatherNotes\" type=\"text\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>מקצוע הורה 2</label><input ng-value=\"subsidy.MotherProfession\" type=\"text\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>מקום עבודה הורה 2\n</label><input ng-value=\"subsidy.MotherWorkplace\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סכום הכנסות הורה 2 ברוטו</label><input \nng-value=\"subsidy.MotherSalary\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>הערות הורה 2</label><input ng-value=\"subsidy.MotherNotes\" type=\"text\" \nng-disabled=\"true\"></md-input-container></div></form>");
$templateCache.put("app/main/pages/users/views/parents/parents-profile/tabs/subsidy/subsidy-dialog/tabs/revenue.html","<form class=\"md-inline-form\" validate><div layout=\"row\" layout-wrap><md-input-container class=\"md-icon-float md-block\" \nlayout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>\nמקצוע הורה 1</label><input ng-value=\"subsidy.FatherProfession\" type=\"text\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>מקום עבודה הורה 1</label><input \nng-value=\"subsidy.FatherWorkplace\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>סכום הכנסות הורה 1 ברוטו</label><input \nng-value=\"subsidy.FatherSalary\" type=\"text\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>הערות הורה 1</label><input ng-value=\"subsidy.FatherNotes\" type=\"text\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><md-icon></md-icon><label>ביטוח לאומי</label><input ng-value=\"subsidy.NationalSecurity\" type=\"text\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-icon-float md-block\" layout=\"column\" \nlayout-xs=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>עסק\\רכש</label>\n<input ng-value=\"subsidy.Business\" type=\"text\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-icon-float md-block\" layout=\"column\" layout-xs=\"row\" flex=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><md-icon></md-icon><label>אחר</label><input \nng-value=\"subsidy.ExtraIncome\" type=\"text\" ng-disabled=\"true\"></md-input-container></div></form>");}]);